(function(){"use strict";try{if(typeof document!="undefined"){var a=document.createElement("style");a.appendChild(document.createTextNode(".availability-day[data-v-d596f077]{padding:0 10px;position:absolute}.availability-slots[data-v-d596f077]{display:flex;white-space:nowrap}.availability-slot[data-v-d596f077]{display:flex;flex-direction:row;align-items:center}.availability-slot-group[data-v-d596f077]{display:flex;flex-direction:column}[data-v-d596f077] .mx-input-wrapper{width:85px}[data-v-d596f077] .mx-datepicker{width:97px}[data-v-d596f077] .multiselect{border:1px solid var(--color-border-dark);width:120px}.time-zone[data-v-d596f077]{padding:32px 12px 12px 0}.grid-table[data-v-d596f077]{display:grid;margin-bottom:32px;grid-column-gap:24px;grid-row-gap:6px;grid-template-columns:min-content min-content min-content}.button[data-v-d596f077]{align-self:flex-end}.label-weekday[data-v-d596f077]{position:relative;display:inline-flex;padding-top:4px}.delete-slot[data-v-d596f077]{background-color:transparent;border:none;padding-bottom:12px;opacity:.5}.delete-slot[data-v-d596f077]:hover{opacity:1}.add-another[data-v-d596f077]{background-color:transparent;border:none;opacity:.5;display:inline-flex;padding:0;margin:0 0 3px}.add-another[data-v-d596f077]:hover{opacity:1}.to-text[data-v-d596f077]{padding-right:12px}.time-zone-text[data-v-d596f077]{padding-left:22px}.empty-content[data-v-d596f077]{color:var(--color-text-lighter);margin-top:4px}")),document.head.appendChild(a)}}catch(t){console.error("vite-plugin-css-injected-by-js",t)}})();
import Jp from "vue";
var nr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function gE(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
function Vr(r) {
  if (r.__esModule)
    return r;
  var e = r.default;
  if (typeof e == "function") {
    var t = function n() {
      if (this instanceof n) {
        var i = [null];
        i.push.apply(i, arguments);
        var s = Function.bind.apply(e, i);
        return new s();
      }
      return e.apply(this, arguments);
    };
    t.prototype = e.prototype;
  } else
    t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(r).forEach(function(n) {
    var i = Object.getOwnPropertyDescriptor(r, n);
    Object.defineProperty(t, n, i.get ? i : {
      enumerable: !0,
      get: function() {
        return r[n];
      }
    });
  }), t;
}
var wl = {}, RE = {
  get exports() {
    return wl;
  },
  set exports(r) {
    wl = r;
  }
}, Ei = {};
const vE = {}, NE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vE
}, Symbol.toStringTag, { value: "Module" })), xl = /* @__PURE__ */ Vr(NE);
var Ln = {}, FE = {
  get exports() {
    return Ln;
  },
  set exports(r) {
    Ln = r;
  }
}, eo = {}, to = {}, ro = {}, hc;
function ar() {
  return hc || (hc = 1, function(r) {
    const e = ":A-Za-z_\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", t = e + "\\-.\\d\\u00B7\\u0300-\\u036F\\u203F-\\u2040", n = "[" + e + "][" + t + "]*", i = new RegExp("^" + n + "$"), s = function(l, a) {
      const c = [];
      let T = a.exec(l);
      for (; T; ) {
        const u = [];
        u.startIndex = a.lastIndex - T[0].length;
        const d = T.length;
        for (let A = 0; A < d; A++)
          u.push(T[A]);
        c.push(u), T = a.exec(l);
      }
      return c;
    }, o = function(l) {
      const a = i.exec(l);
      return !(a === null || typeof a > "u");
    };
    r.isExist = function(l) {
      return typeof l < "u";
    }, r.isEmptyObject = function(l) {
      return Object.keys(l).length === 0;
    }, r.merge = function(l, a, c) {
      if (a) {
        const T = Object.keys(a), u = T.length;
        for (let d = 0; d < u; d++)
          c === "strict" ? l[T[d]] = [a[T[d]]] : l[T[d]] = a[T[d]];
      }
    }, r.getValue = function(l) {
      return r.isExist(l) ? l : "";
    }, r.buildOptions = function(l, a, c) {
      let T = {};
      if (!l)
        return a;
      for (let u = 0; u < c.length; u++)
        l[c[u]] !== void 0 ? T[c[u]] = l[c[u]] : T[c[u]] = a[c[u]];
      return T;
    }, r.isTagNameInArrayMode = function(l, a, c) {
      return a === !1 ? !1 : a instanceof RegExp ? a.test(l) : typeof a == "function" ? !!a(l, c) : a === "strict";
    }, r.isName = o, r.getAllMatches = s, r.nameRegexp = n;
  }(ro)), ro;
}
var mc;
function OE() {
  if (mc)
    return to;
  mc = 1;
  const r = ar(), e = function(t, n, i) {
    const s = {};
    if (!n.alwaysCreateTextNode && (!t.child || r.isEmptyObject(t.child)) && (!t.attrsMap || r.isEmptyObject(t.attrsMap)))
      return r.isExist(t.val) ? t.val : "";
    if (r.isExist(t.val) && !(typeof t.val == "string" && (t.val === "" || t.val === n.cdataPositionChar))) {
      const l = r.isTagNameInArrayMode(t.tagname, n.arrayMode, i);
      s[n.textNodeName] = l ? [t.val] : t.val;
    }
    r.merge(s, t.attrsMap, n.arrayMode);
    const o = Object.keys(t.child);
    for (let l = 0; l < o.length; l++) {
      const a = o[l];
      if (t.child[a] && t.child[a].length > 1) {
        s[a] = [];
        for (let c in t.child[a])
          t.child[a].hasOwnProperty(c) && s[a].push(e(t.child[a][c], n, a));
      } else {
        const c = e(t.child[a][0], n, a), T = n.arrayMode === !0 && typeof c == "object" || r.isTagNameInArrayMode(a, n.arrayMode, i);
        s[a] = T ? [c] : c;
      }
    }
    return s;
  };
  return to.convertToJson = e, to;
}
var Mn = {}, no, Ec;
function yE() {
  return Ec || (Ec = 1, no = function(r, e, t) {
    this.tagname = r, this.parent = e, this.child = {}, this.attrsMap = {}, this.val = t, this.addChild = function(n) {
      Array.isArray(this.child[n.tagname]) ? this.child[n.tagname].push(n) : this.child[n.tagname] = [n];
    };
  }), no;
}
var io, Sc;
function bE() {
  if (Sc)
    return io;
  Sc = 1;
  const r = /^[-+]?0x[a-fA-F0-9]+$/, e = /^([\-\+])?(0*)(\.[0-9]+([eE]\-?[0-9]+)?|[0-9]+(\.[0-9]+([eE]\-?[0-9]+)?)?)$/;
  !Number.parseInt && window.parseInt && (Number.parseInt = window.parseInt), !Number.parseFloat && window.parseFloat && (Number.parseFloat = window.parseFloat);
  const t = {
    hex: !0,
    leadingZeros: !0,
    decimalPoint: ".",
    eNotation: !0
    //skipLike: /regex/
  };
  function n(s, o = {}) {
    if (o = Object.assign({}, t, o), !s || typeof s != "string")
      return s;
    let l = s.trim();
    if (o.skipLike !== void 0 && o.skipLike.test(l))
      return s;
    if (o.hex && r.test(l))
      return Number.parseInt(l, 16);
    {
      const a = e.exec(l);
      if (a) {
        const c = a[1], T = a[2];
        let u = i(a[3]);
        const d = a[4] || a[6];
        if (!o.leadingZeros && T.length > 0 && c && l[2] !== ".")
          return s;
        if (!o.leadingZeros && T.length > 0 && !c && l[1] !== ".")
          return s;
        {
          const A = Number(l), f = "" + A;
          return f.search(/[eE]/) !== -1 || d ? o.eNotation ? A : s : l.indexOf(".") !== -1 ? f === "0" && u === "" || f === u || c && f === "-" + u ? A : s : T ? u === f || c + u === f ? A : s : l === f || l === c + f ? A : s;
        }
      } else
        return s;
    }
  }
  function i(s) {
    return s && s.indexOf(".") !== -1 && (s = s.replace(/0+$/, ""), s === "." ? s = "0" : s[0] === "." ? s = "0" + s : s[s.length - 1] === "." && (s = s.substr(0, s.length - 1))), s;
  }
  return io = n, io;
}
var Dc;
function Pi() {
  if (Dc)
    return Mn;
  Dc = 1;
  const r = ar(), e = ar().buildOptions, t = yE(), n = bE();
  "<((!\\[CDATA\\[([\\s\\S]*?)(]]>))|((NAME:)?(NAME))([^>]*)>|((\\/)(NAME)\\s*>))([^<]*)".replace(/NAME/g, r.nameRegexp), !Number.parseInt && window.parseInt && (Number.parseInt = window.parseInt), !Number.parseFloat && window.parseFloat && (Number.parseFloat = window.parseFloat);
  const i = {
    attributeNamePrefix: "@_",
    attrNodeName: !1,
    textNodeName: "#text",
    ignoreAttributes: !0,
    ignoreNameSpace: !1,
    allowBooleanAttributes: !1,
    //a tag can have attributes without any value
    //ignoreRootElement : false,
    parseNodeValue: !0,
    parseAttributeValue: !1,
    arrayMode: !1,
    trimValues: !0,
    //Trim string values of tag and attributes
    cdataTagName: !1,
    cdataPositionChar: "\\c",
    numParseOptions: {
      hex: !0,
      leadingZeros: !0
    },
    tagValueProcessor: function(f, h) {
      return f;
    },
    attrValueProcessor: function(f, h) {
      return f;
    },
    stopNodes: [],
    alwaysCreateTextNode: !1
    //decodeStrict: false,
  };
  Mn.defaultOptions = i;
  const s = [
    "attributeNamePrefix",
    "attrNodeName",
    "textNodeName",
    "ignoreAttributes",
    "ignoreNameSpace",
    "allowBooleanAttributes",
    "parseNodeValue",
    "parseAttributeValue",
    "arrayMode",
    "trimValues",
    "cdataTagName",
    "cdataPositionChar",
    "tagValueProcessor",
    "attrValueProcessor",
    "parseTrueNumberOnly",
    "numParseOptions",
    "stopNodes",
    "alwaysCreateTextNode"
  ];
  Mn.props = s;
  function o(f, h, S) {
    return h && (S.trimValues && (h = h.trim()), h = S.tagValueProcessor(h, f), h = a(h, S.parseNodeValue, S.numParseOptions)), h;
  }
  function l(f, h) {
    if (h.ignoreNameSpace) {
      const S = f.split(":"), p = f.charAt(0) === "/" ? "/" : "";
      if (S[0] === "xmlns")
        return "";
      S.length === 2 && (f = p + S[1]);
    }
    return f;
  }
  function a(f, h, S) {
    if (h && typeof f == "string") {
      const p = f.trim();
      return p === "true" ? !0 : p === "false" ? !1 : n(f, S);
    } else
      return r.isExist(f) ? f : "";
  }
  const c = new RegExp(`([^\\s=]+)\\s*(=\\s*(['"])(.*?)\\3)?`, "g");
  function T(f, h) {
    if (!h.ignoreAttributes && typeof f == "string") {
      f = f.replace(/\r?\n/g, " ");
      const S = r.getAllMatches(f, c), p = S.length, m = {};
      for (let g = 0; g < p; g++) {
        const N = l(S[g][1], h);
        N.length && (S[g][4] !== void 0 ? (h.trimValues && (S[g][4] = S[g][4].trim()), S[g][4] = h.attrValueProcessor(S[g][4], N), m[h.attributeNamePrefix + N] = a(
          S[g][4],
          h.parseAttributeValue,
          h.numParseOptions
        )) : h.allowBooleanAttributes && (m[h.attributeNamePrefix + N] = !0));
      }
      if (!Object.keys(m).length)
        return;
      if (h.attrNodeName) {
        const g = {};
        return g[h.attrNodeName] = m, g;
      }
      return m;
    }
  }
  const u = function(f, h) {
    f = f.replace(/\r\n?/g, `
`), h = e(h, i, s);
    const S = new t("!xml");
    let p = S, m = "";
    for (let g = 0; g < f.length; g++)
      if (f[g] === "<")
        if (f[g + 1] === "/") {
          const R = A(f, ">", g, "Closing Tag is not closed.");
          let D = f.substring(g + 2, R).trim();
          if (h.ignoreNameSpace) {
            const v = D.indexOf(":");
            v !== -1 && (D = D.substr(v + 1));
          }
          p && (p.val ? p.val = r.getValue(p.val) + "" + o(D, m, h) : p.val = o(D, m, h)), h.stopNodes.length && h.stopNodes.includes(p.tagname) && (p.child = [], p.attrsMap == null && (p.attrsMap = {}), p.val = f.substr(p.startIndex + 1, g - p.startIndex - 1)), p = p.parent, m = "", g = R;
        } else if (f[g + 1] === "?")
          g = A(f, "?>", g, "Pi Tag is not closed.");
        else if (f.substr(g + 1, 3) === "!--")
          g = A(f, "-->", g, "Comment is not closed.");
        else if (f.substr(g + 1, 2) === "!D") {
          const R = A(f, ">", g, "DOCTYPE is not closed.");
          f.substring(g, R).indexOf("[") >= 0 ? g = f.indexOf("]>", g) + 1 : g = R;
        } else if (f.substr(g + 1, 2) === "![") {
          const R = A(f, "]]>", g, "CDATA is not closed.") - 2, D = f.substring(g + 9, R);
          if (m && (p.val = r.getValue(p.val) + "" + o(p.tagname, m, h), m = ""), h.cdataTagName) {
            const v = new t(h.cdataTagName, p, D);
            p.addChild(v), p.val = r.getValue(p.val) + h.cdataPositionChar, D && (v.val = D);
          } else
            p.val = (p.val || "") + (D || "");
          g = R + 2;
        } else {
          const R = d(f, g + 1);
          let D = R.data;
          const v = R.index, O = D.indexOf(" ");
          let y = D, Z = !0;
          if (O !== -1 && (y = D.substr(0, O).replace(/\s\s*$/, ""), D = D.substr(O + 1)), h.ignoreNameSpace) {
            const F = y.indexOf(":");
            F !== -1 && (y = y.substr(F + 1), Z = y !== R.data.substr(F + 1));
          }
          if (p && m && p.tagname !== "!xml" && (p.val = r.getValue(p.val) + "" + o(p.tagname, m, h)), D.length > 0 && D.lastIndexOf("/") === D.length - 1) {
            y[y.length - 1] === "/" ? (y = y.substr(0, y.length - 1), D = y) : D = D.substr(0, D.length - 1);
            const F = new t(y, p, "");
            y !== D && (F.attrsMap = T(D, h)), p.addChild(F);
          } else {
            const F = new t(y, p);
            h.stopNodes.length && h.stopNodes.includes(F.tagname) && (F.startIndex = v), y !== D && Z && (F.attrsMap = T(D, h)), p.addChild(F), p = F;
          }
          m = "", g = v;
        }
      else
        m += f[g];
    return S;
  };
  function d(f, h) {
    let S, p = "";
    for (let m = h; m < f.length; m++) {
      let g = f[m];
      if (S)
        g === S && (S = "");
      else if (g === '"' || g === "'")
        S = g;
      else {
        if (g === ">")
          return {
            data: p,
            index: m
          };
        g === "	" && (g = " ");
      }
      p += g;
    }
  }
  function A(f, h, S, p) {
    const m = f.indexOf(h, S);
    if (m === -1)
      throw new Error(p);
    return m + h.length - 1;
  }
  return Mn.getTraversalObj = u, Mn;
}
var ao = {}, gc;
function CE() {
  if (gc)
    return ao;
  gc = 1;
  const r = ar(), e = {
    allowBooleanAttributes: !1
    //A tag can have attributes without any value
  }, t = ["allowBooleanAttributes"];
  ao.validate = function(p, m) {
    m = r.buildOptions(m, e, t);
    const g = [];
    let N = !1, R = !1;
    p[0] === "\uFEFF" && (p = p.substr(1));
    for (let D = 0; D < p.length; D++)
      if (p[D] === "<" && p[D + 1] === "?") {
        if (D += 2, D = n(p, D), D.err)
          return D;
      } else if (p[D] === "<") {
        let v = D;
        if (D++, p[D] === "!") {
          D = i(p, D);
          continue;
        } else {
          let O = !1;
          p[D] === "/" && (O = !0, D++);
          let y = "";
          for (; D < p.length && p[D] !== ">" && p[D] !== " " && p[D] !== "	" && p[D] !== `
` && p[D] !== "\r"; D++)
            y += p[D];
          if (y = y.trim(), y[y.length - 1] === "/" && (y = y.substring(0, y.length - 1), D--), !f(y)) {
            let b;
            return y.trim().length === 0 ? b = "Invalid space after '<'." : b = "Tag '" + y + "' is an invalid name.", d("InvalidTag", b, h(p, D));
          }
          const Z = l(p, D);
          if (Z === !1)
            return d("InvalidAttr", "Attributes for '" + y + "' have open quote.", h(p, D));
          let F = Z.value;
          if (D = Z.index, F[F.length - 1] === "/") {
            const b = D - F.length;
            F = F.substring(0, F.length - 1);
            const Y = c(F, m);
            if (Y === !0)
              N = !0;
            else
              return d(Y.err.code, Y.err.msg, h(p, b + Y.err.line));
          } else if (O)
            if (Z.tagClosed) {
              if (F.trim().length > 0)
                return d("InvalidTag", "Closing tag '" + y + "' can't have attributes or invalid starting.", h(p, v));
              {
                const b = g.pop();
                if (y !== b.tagName) {
                  let Y = h(p, b.tagStartPos);
                  return d(
                    "InvalidTag",
                    "Expected closing tag '" + b.tagName + "' (opened in line " + Y.line + ", col " + Y.col + ") instead of closing tag '" + y + "'.",
                    h(p, v)
                  );
                }
                g.length == 0 && (R = !0);
              }
            } else
              return d("InvalidTag", "Closing tag '" + y + "' doesn't have proper closing.", h(p, D));
          else {
            const b = c(F, m);
            if (b !== !0)
              return d(b.err.code, b.err.msg, h(p, D - F.length + b.err.line));
            if (R === !0)
              return d("InvalidXml", "Multiple possible root nodes found.", h(p, D));
            g.push({ tagName: y, tagStartPos: v }), N = !0;
          }
          for (D++; D < p.length; D++)
            if (p[D] === "<")
              if (p[D + 1] === "!") {
                D++, D = i(p, D);
                continue;
              } else if (p[D + 1] === "?") {
                if (D = n(p, ++D), D.err)
                  return D;
              } else
                break;
            else if (p[D] === "&") {
              const b = u(p, D);
              if (b == -1)
                return d("InvalidChar", "char '&' is not expected.", h(p, D));
              D = b;
            }
          p[D] === "<" && D--;
        }
      } else {
        if (p[D] === " " || p[D] === "	" || p[D] === `
` || p[D] === "\r")
          continue;
        return d("InvalidChar", "char '" + p[D] + "' is not expected.", h(p, D));
      }
    if (N) {
      if (g.length == 1)
        return d("InvalidTag", "Unclosed tag '" + g[0].tagName + "'.", h(p, g[0].tagStartPos));
      if (g.length > 0)
        return d("InvalidXml", "Invalid '" + JSON.stringify(g.map((D) => D.tagName), null, 4).replace(/\r?\n/g, "") + "' found.", { line: 1, col: 1 });
    } else
      return d("InvalidXml", "Start tag expected.", 1);
    return !0;
  };
  function n(p, m) {
    const g = m;
    for (; m < p.length; m++)
      if (p[m] == "?" || p[m] == " ") {
        const N = p.substr(g, m - g);
        if (m > 5 && N === "xml")
          return d("InvalidXml", "XML declaration allowed only at the start of the document.", h(p, m));
        if (p[m] == "?" && p[m + 1] == ">") {
          m++;
          break;
        } else
          continue;
      }
    return m;
  }
  function i(p, m) {
    if (p.length > m + 5 && p[m + 1] === "-" && p[m + 2] === "-") {
      for (m += 3; m < p.length; m++)
        if (p[m] === "-" && p[m + 1] === "-" && p[m + 2] === ">") {
          m += 2;
          break;
        }
    } else if (p.length > m + 8 && p[m + 1] === "D" && p[m + 2] === "O" && p[m + 3] === "C" && p[m + 4] === "T" && p[m + 5] === "Y" && p[m + 6] === "P" && p[m + 7] === "E") {
      let g = 1;
      for (m += 8; m < p.length; m++)
        if (p[m] === "<")
          g++;
        else if (p[m] === ">" && (g--, g === 0))
          break;
    } else if (p.length > m + 9 && p[m + 1] === "[" && p[m + 2] === "C" && p[m + 3] === "D" && p[m + 4] === "A" && p[m + 5] === "T" && p[m + 6] === "A" && p[m + 7] === "[") {
      for (m += 8; m < p.length; m++)
        if (p[m] === "]" && p[m + 1] === "]" && p[m + 2] === ">") {
          m += 2;
          break;
        }
    }
    return m;
  }
  const s = '"', o = "'";
  function l(p, m) {
    let g = "", N = "", R = !1;
    for (; m < p.length; m++) {
      if (p[m] === s || p[m] === o)
        N === "" ? N = p[m] : N !== p[m] || (N = "");
      else if (p[m] === ">" && N === "") {
        R = !0;
        break;
      }
      g += p[m];
    }
    return N !== "" ? !1 : {
      value: g,
      index: m,
      tagClosed: R
    };
  }
  const a = new RegExp(`(\\s*)([^\\s=]+)(\\s*=)?(\\s*(['"])(([\\s\\S])*?)\\5)?`, "g");
  function c(p, m) {
    const g = r.getAllMatches(p, a), N = {};
    for (let R = 0; R < g.length; R++) {
      if (g[R][1].length === 0)
        return d("InvalidAttr", "Attribute '" + g[R][2] + "' has no space in starting.", S(g[R]));
      if (g[R][3] === void 0 && !m.allowBooleanAttributes)
        return d("InvalidAttr", "boolean attribute '" + g[R][2] + "' is not allowed.", S(g[R]));
      const D = g[R][2];
      if (!A(D))
        return d("InvalidAttr", "Attribute '" + D + "' is an invalid name.", S(g[R]));
      if (!N.hasOwnProperty(D))
        N[D] = 1;
      else
        return d("InvalidAttr", "Attribute '" + D + "' is repeated.", S(g[R]));
    }
    return !0;
  }
  function T(p, m) {
    let g = /\d/;
    for (p[m] === "x" && (m++, g = /[\da-fA-F]/); m < p.length; m++) {
      if (p[m] === ";")
        return m;
      if (!p[m].match(g))
        break;
    }
    return -1;
  }
  function u(p, m) {
    if (m++, p[m] === ";")
      return -1;
    if (p[m] === "#")
      return m++, T(p, m);
    let g = 0;
    for (; m < p.length; m++, g++)
      if (!(p[m].match(/\w/) && g < 20)) {
        if (p[m] === ";")
          break;
        return -1;
      }
    return m;
  }
  function d(p, m, g) {
    return {
      err: {
        code: p,
        msg: m,
        line: g.line || g,
        col: g.col
      }
    };
  }
  function A(p) {
    return r.isName(p);
  }
  function f(p) {
    return r.isName(p);
  }
  function h(p, m) {
    const g = p.substring(0, m).split(/\r?\n/);
    return {
      line: g.length,
      // column number is last line's length + 1, because column numbering starts at 1:
      col: g[g.length - 1].length + 1
    };
  }
  function S(p) {
    return p.startIndex + p[1].length;
  }
  return ao;
}
var oo = {}, Rc;
function _E() {
  if (Rc)
    return oo;
  Rc = 1;
  const r = function(u) {
    return String.fromCharCode(u);
  }, e = {
    nilChar: r(176),
    missingChar: r(201),
    nilPremitive: r(175),
    missingPremitive: r(200),
    emptyChar: r(178),
    emptyValue: r(177),
    //empty Premitive
    boundryChar: r(179),
    objStart: r(198),
    arrStart: r(204),
    arrayEnd: r(185)
  }, t = [
    e.nilChar,
    e.nilPremitive,
    e.missingChar,
    e.missingPremitive,
    e.boundryChar,
    e.emptyChar,
    e.emptyValue,
    e.arrayEnd,
    e.objStart,
    e.arrStart
  ], n = function(u, d, A) {
    if (typeof d == "string")
      return u && u[0] && u[0].val !== void 0 ? i(u[0].val) : i(u);
    {
      const f = l(u);
      if (f === !0) {
        let h = "";
        if (Array.isArray(d)) {
          h += e.arrStart;
          const S = d[0], p = u.length;
          if (typeof S == "string")
            for (let m = 0; m < p; m++) {
              const g = i(u[m].val);
              h = s(h, g);
            }
          else
            for (let m = 0; m < p; m++) {
              const g = n(u[m], S, A);
              h = s(h, g);
            }
          h += e.arrayEnd;
        } else {
          h += e.objStart;
          const S = Object.keys(d);
          Array.isArray(u) && (u = u[0]);
          for (let p in S) {
            const m = S[p];
            let g;
            !A.ignoreAttributes && u.attrsMap && u.attrsMap[m] ? g = n(u.attrsMap[m], d[m], A) : m === A.textNodeName ? g = n(u.val, d[m], A) : g = n(u.child[m], d[m], A), h = s(h, g);
          }
        }
        return h;
      } else
        return f;
    }
  }, i = function(u) {
    switch (u) {
      case void 0:
        return e.missingPremitive;
      case null:
        return e.nilPremitive;
      case "":
        return e.emptyValue;
      default:
        return u;
    }
  }, s = function(u, d) {
    return !o(d[0]) && !o(u[u.length - 1]) && (u += e.boundryChar), u + d;
  }, o = function(u) {
    return t.indexOf(u) !== -1;
  };
  function l(u) {
    return u === void 0 ? e.missingChar : u === null ? e.nilChar : u.child && Object.keys(u.child).length === 0 && (!u.attrsMap || Object.keys(u.attrsMap).length === 0) ? e.emptyChar : !0;
  }
  const a = Pi(), c = ar().buildOptions, T = function(u, d, A) {
    return A = c(A, a.defaultOptions, a.props), n(u, d, A);
  };
  return oo.convert2nimn = T, oo;
}
var so = {}, vc;
function ME() {
  if (vc)
    return so;
  vc = 1;
  const r = ar(), e = ar().buildOptions, t = Pi(), n = function(o, l) {
    return l = e(l, t.defaultOptions, t.props), l.indentBy = l.indentBy || "", i(o, l);
  }, i = function(o, l, a) {
    let c = "{";
    const T = Object.keys(o.child);
    for (let u = 0; u < T.length; u++) {
      const d = T[u];
      if (o.child[d] && o.child[d].length > 1) {
        c += '"' + d + '" : [ ';
        for (let A in o.child[d])
          c += i(o.child[d][A], l) + " , ";
        c = c.substr(0, c.length - 1) + " ] ";
      } else
        c += '"' + d + '" : ' + i(o.child[d][0], l) + " ,";
    }
    return r.merge(c, o.attrsMap), r.isEmptyObject(c) ? r.isExist(o.val) ? o.val : "" : (r.isExist(o.val) && (typeof o.val == "string" && (o.val === "" || o.val === l.cdataPositionChar) || (c += '"' + l.textNodeName + '" : ' + s(o.val))), c[c.length - 1] === "," && (c = c.substr(0, c.length - 2)), c + "}");
  };
  function s(o) {
    return o === !0 || o === !1 || !isNaN(o) ? o : '"' + o + '"';
  }
  return so.convertToJsonString = n, so;
}
var lo, Nc;
function YE() {
  if (Nc)
    return lo;
  Nc = 1;
  const r = ar().buildOptions, e = {
    attributeNamePrefix: "@_",
    attrNodeName: !1,
    textNodeName: "#text",
    ignoreAttributes: !0,
    cdataTagName: !1,
    cdataPositionChar: "\\c",
    format: !1,
    indentBy: "  ",
    supressEmptyNode: !1,
    tagValueProcessor: function(f) {
      return f;
    },
    attrValueProcessor: function(f) {
      return f;
    }
  }, t = [
    "attributeNamePrefix",
    "attrNodeName",
    "textNodeName",
    "ignoreAttributes",
    "cdataTagName",
    "cdataPositionChar",
    "format",
    "indentBy",
    "supressEmptyNode",
    "tagValueProcessor",
    "attrValueProcessor",
    "rootNodeName"
    //when array as root
  ];
  function n(f) {
    this.options = r(f, e, t), this.options.ignoreAttributes || this.options.attrNodeName ? this.isAttribute = function() {
      return !1;
    } : (this.attrPrefixLen = this.options.attributeNamePrefix.length, this.isAttribute = d), this.options.cdataTagName ? this.isCDATA = A : this.isCDATA = function() {
      return !1;
    }, this.replaceCDATAstr = s, this.replaceCDATAarr = o, this.processTextOrObjNode = i, this.options.format ? (this.indentate = u, this.tagEndChar = `>
`, this.newLine = `
`) : (this.indentate = function() {
      return "";
    }, this.tagEndChar = ">", this.newLine = ""), this.options.supressEmptyNode ? (this.buildTextNode = T, this.buildObjNode = a) : (this.buildTextNode = c, this.buildObjNode = l), this.buildTextValNode = c, this.buildObjectNode = l;
  }
  n.prototype.parse = function(f) {
    return Array.isArray(f) && this.options.rootNodeName && this.options.rootNodeName.length > 1 && (f = {
      [this.options.rootNodeName]: f
    }), this.j2x(f, 0).val;
  }, n.prototype.j2x = function(f, h) {
    let S = "", p = "";
    for (let m in f)
      if (!(typeof f[m] > "u"))
        if (f[m] === null)
          p += this.indentate(h) + "<" + m + "/" + this.tagEndChar;
        else if (f[m] instanceof Date)
          p += this.buildTextNode(f[m], m, "", h);
        else if (typeof f[m] != "object") {
          const g = this.isAttribute(m);
          g ? S += " " + g + '="' + this.options.attrValueProcessor("" + f[m]) + '"' : this.isCDATA(m) ? f[this.options.textNodeName] ? p += this.replaceCDATAstr(f[this.options.textNodeName], f[m]) : p += this.replaceCDATAstr("", f[m]) : m === this.options.textNodeName ? f[this.options.cdataTagName] || (p += this.options.tagValueProcessor("" + f[m])) : p += this.buildTextNode(f[m], m, "", h);
        } else if (Array.isArray(f[m]))
          if (this.isCDATA(m))
            p += this.indentate(h), f[this.options.textNodeName] ? p += this.replaceCDATAarr(f[this.options.textNodeName], f[m]) : p += this.replaceCDATAarr("", f[m]);
          else {
            const g = f[m].length;
            for (let N = 0; N < g; N++) {
              const R = f[m][N];
              typeof R > "u" || (R === null ? p += this.indentate(h) + "<" + m + "/" + this.tagEndChar : typeof R == "object" ? p += this.processTextOrObjNode(R, m, h) : p += this.buildTextNode(R, m, "", h));
            }
          }
        else if (this.options.attrNodeName && m === this.options.attrNodeName) {
          const g = Object.keys(f[m]), N = g.length;
          for (let R = 0; R < N; R++)
            S += " " + g[R] + '="' + this.options.attrValueProcessor("" + f[m][g[R]]) + '"';
        } else
          p += this.processTextOrObjNode(f[m], m, h);
    return { attrStr: S, val: p };
  };
  function i(f, h, S) {
    const p = this.j2x(f, S + 1);
    return f[this.options.textNodeName] !== void 0 && Object.keys(f).length === 1 ? this.buildTextNode(p.val, h, p.attrStr, S) : this.buildObjNode(p.val, h, p.attrStr, S);
  }
  function s(f, h) {
    return f = this.options.tagValueProcessor("" + f), this.options.cdataPositionChar === "" || f === "" ? f + "<![CDATA[" + h + "]]" + this.tagEndChar : f.replace(this.options.cdataPositionChar, "<![CDATA[" + h + "]]" + this.tagEndChar);
  }
  function o(f, h) {
    if (f = this.options.tagValueProcessor("" + f), this.options.cdataPositionChar === "" || f === "")
      return f + "<![CDATA[" + h.join("]]><![CDATA[") + "]]" + this.tagEndChar;
    for (let S in h)
      f = f.replace(this.options.cdataPositionChar, "<![CDATA[" + h[S] + "]]>");
    return f + this.newLine;
  }
  function l(f, h, S, p) {
    return S && f.indexOf("<") === -1 ? this.indentate(p) + "<" + h + S + ">" + f + //+ this.newLine
    // + this.indentate(level)
    "</" + h + this.tagEndChar : this.indentate(p) + "<" + h + S + this.tagEndChar + f + //+ this.newLine
    this.indentate(p) + "</" + h + this.tagEndChar;
  }
  function a(f, h, S, p) {
    return f !== "" ? this.buildObjectNode(f, h, S, p) : this.indentate(p) + "<" + h + S + "/" + this.tagEndChar;
  }
  function c(f, h, S, p) {
    return this.indentate(p) + "<" + h + S + ">" + this.options.tagValueProcessor(f) + "</" + h + this.tagEndChar;
  }
  function T(f, h, S, p) {
    return f !== "" ? this.buildTextValNode(f, h, S, p) : this.indentate(p) + "<" + h + S + "/" + this.tagEndChar;
  }
  function u(f) {
    return this.options.indentBy.repeat(f);
  }
  function d(f) {
    return f.startsWith(this.options.attributeNamePrefix) ? f.substr(this.attrPrefixLen) : !1;
  }
  function A(f) {
    return f === this.options.cdataTagName;
  }
  return lo = n, lo;
}
var Fc;
function IE() {
  return Fc || (Fc = 1, function(r) {
    const e = OE(), t = Pi(), n = Pi(), i = ar().buildOptions, s = CE();
    r.parse = function(o, l = {}, a) {
      if (a) {
        a === !0 && (a = {});
        const u = s.validate(o, a);
        if (u !== !0)
          throw Error(u.err.msg);
      }
      l.parseTrueNumberOnly && l.parseNodeValue !== !1 && !l.numParseOptions && (l.numParseOptions = {
        leadingZeros: !1
      });
      let c = i(l, n.defaultOptions, n.props);
      const T = t.getTraversalObj(o, c);
      return e.convertToJson(T, c);
    }, r.convertTonimn = _E().convert2nimn, r.getTraversalObj = t.getTraversalObj, r.convertToJson = e.convertToJson, r.convertToJsonString = ME().convertToJsonString, r.validate = s.validate, r.j2xParser = YE(), r.parseToNimn = function(o, l, a) {
      return r.convertTonimn(r.getTraversalObj(o, a), l, a);
    };
  }(eo)), eo;
}
var Oc;
function BE() {
  if (Oc)
    return Ln;
  Oc = 1;
  const r = IE(), e = (t) => {
    if (t == null || (t = t.toString().trim().replace(/\n/g, " "), t.length === 0) || r.validate(t) !== !0)
      return !1;
    let n;
    try {
      n = r.parse(t);
    } catch {
      return !1;
    }
    return !(!n || !("svg" in n));
  };
  return FE.exports = e, Ln.default = e, Ln;
}
var yc;
function ZE() {
  if (yc)
    return Ei;
  yc = 1, Object.defineProperty(Ei, "__esModule", { value: !0 });
  var r = xl, e = BE();
  function t(c) {
    return c && typeof c == "object" && "default" in c ? c : { default: c };
  }
  var n = /* @__PURE__ */ t(e);
  function i(c, T, u, d) {
    function A(f) {
      return f instanceof u ? f : new u(function(h) {
        h(f);
      });
    }
    return new (u || (u = Promise))(function(f, h) {
      function S(g) {
        try {
          m(d.next(g));
        } catch (N) {
          h(N);
        }
      }
      function p(g) {
        try {
          m(d.throw(g));
        } catch (N) {
          h(N);
        }
      }
      function m(g) {
        g.done ? f(g.value) : A(g.value).then(S, p);
      }
      m((d = d.apply(c, T || [])).next());
    });
  }
  function s(c, T) {
    var u = { label: 0, sent: function() {
      if (f[0] & 1)
        throw f[1];
      return f[1];
    }, trys: [], ops: [] }, d, A, f, h;
    return h = { next: S(0), throw: S(1), return: S(2) }, typeof Symbol == "function" && (h[Symbol.iterator] = function() {
      return this;
    }), h;
    function S(m) {
      return function(g) {
        return p([m, g]);
      };
    }
    function p(m) {
      if (d)
        throw new TypeError("Generator is already executing.");
      for (; u; )
        try {
          if (d = 1, A && (f = m[0] & 2 ? A.return : m[0] ? A.throw || ((f = A.return) && f.call(A), 0) : A.next) && !(f = f.call(A, m[1])).done)
            return f;
          switch (A = 0, f && (m = [m[0] & 2, f.value]), m[0]) {
            case 0:
            case 1:
              f = m;
              break;
            case 4:
              return u.label++, { value: m[1], done: !1 };
            case 5:
              u.label++, A = m[1], m = [0];
              continue;
            case 7:
              m = u.ops.pop(), u.trys.pop();
              continue;
            default:
              if (f = u.trys, !(f = f.length > 0 && f[f.length - 1]) && (m[0] === 6 || m[0] === 2)) {
                u = 0;
                continue;
              }
              if (m[0] === 3 && (!f || m[1] > f[0] && m[1] < f[3])) {
                u.label = m[1];
                break;
              }
              if (m[0] === 6 && u.label < f[1]) {
                u.label = f[1], f = m;
                break;
              }
              if (f && u.label < f[2]) {
                u.label = f[2], u.ops.push(m);
                break;
              }
              f[2] && u.ops.pop(), u.trys.pop();
              continue;
          }
          m = T.call(c, u);
        } catch (g) {
          m = [6, g], A = 0;
        } finally {
          d = f = 0;
        }
      if (m[0] & 5)
        throw m[1];
      return { value: m[0] ? m[1] : void 0, done: !0 };
    }
  }
  var o = function(c) {
    return new Promise(function(T) {
      if (!l(c))
        T(c.toString("utf-8"));
      else {
        var u = new FileReader();
        u.onload = function() {
          T(u.result);
        }, u.readAsText(c);
      }
    });
  }, l = function(c) {
    return c.size !== void 0;
  }, a = function(c) {
    return i(void 0, void 0, void 0, function() {
      var T, u, d, A, f, h;
      return s(this, function(S) {
        switch (S.label) {
          case 0:
            if (!c)
              throw new Error("Not an svg");
            return T = "", r.Buffer.isBuffer(c) || c instanceof File ? [4, o(c)] : [3, 2];
          case 1:
            return T = S.sent(), [3, 3];
          case 2:
            T = c, S.label = 3;
          case 3:
            if (!n.default(T))
              throw new Error("Not an svg");
            return u = document.createElement("div"), u.innerHTML = T, d = u.firstElementChild, A = Array.from(d.attributes).map(function(p) {
              var m = p.name;
              return m;
            }), f = !!A.find(function(p) {
              return p.startsWith("on");
            }), h = d.getElementsByTagName("script"), [2, h.length === 0 && !f ? c : null];
        }
      });
    });
  };
  return Ei.sanitizeSVG = a, Ei;
}
var Gi = {}, wE = {
  get exports() {
    return Gi;
  },
  set exports(r) {
    Gi = r;
  }
}, bc;
function xE() {
  return bc || (bc = 1, function(r, e) {
    (function(t, n) {
      r.exports = n();
    })(nr, function() {
      return function(t) {
        function n(s) {
          if (i[s])
            return i[s].exports;
          var o = i[s] = { i: s, l: !1, exports: {} };
          return t[s].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
        }
        var i = {};
        return n.m = t, n.c = i, n.i = function(s) {
          return s;
        }, n.d = function(s, o, l) {
          n.o(s, o) || Object.defineProperty(s, o, { configurable: !1, enumerable: !0, get: l });
        }, n.n = function(s) {
          var o = s && s.__esModule ? function() {
            return s.default;
          } : function() {
            return s;
          };
          return n.d(o, "a", o), o;
        }, n.o = function(s, o) {
          return Object.prototype.hasOwnProperty.call(s, o);
        }, n.p = "/", n(n.s = 60);
      }([function(t, n) {
        var i = t.exports = typeof window < "u" && window.Math == Math ? window : typeof self < "u" && self.Math == Math ? self : Function("return this")();
        typeof __g == "number" && (__g = i);
      }, function(t, n, i) {
        var s = i(49)("wks"), o = i(30), l = i(0).Symbol, a = typeof l == "function";
        (t.exports = function(c) {
          return s[c] || (s[c] = a && l[c] || (a ? l : o)("Symbol." + c));
        }).store = s;
      }, function(t, n, i) {
        var s = i(5);
        t.exports = function(o) {
          if (!s(o))
            throw TypeError(o + " is not an object!");
          return o;
        };
      }, function(t, n, i) {
        var s = i(0), o = i(10), l = i(8), a = i(6), c = i(11), T = function(u, d, A) {
          var f, h, S, p, m = u & T.F, g = u & T.G, N = u & T.S, R = u & T.P, D = u & T.B, v = g ? s : N ? s[d] || (s[d] = {}) : (s[d] || {}).prototype, O = g ? o : o[d] || (o[d] = {}), y = O.prototype || (O.prototype = {});
          g && (A = d);
          for (f in A)
            h = !m && v && v[f] !== void 0, S = (h ? v : A)[f], p = D && h ? c(S, s) : R && typeof S == "function" ? c(Function.call, S) : S, v && a(v, f, S, u & T.U), O[f] != S && l(O, f, p), R && y[f] != S && (y[f] = S);
        };
        s.core = o, T.F = 1, T.G = 2, T.S = 4, T.P = 8, T.B = 16, T.W = 32, T.U = 64, T.R = 128, t.exports = T;
      }, function(t, n, i) {
        t.exports = !i(7)(function() {
          return Object.defineProperty({}, "a", { get: function() {
            return 7;
          } }).a != 7;
        });
      }, function(t, n) {
        t.exports = function(i) {
          return typeof i == "object" ? i !== null : typeof i == "function";
        };
      }, function(t, n, i) {
        var s = i(0), o = i(8), l = i(12), a = i(30)("src"), c = Function.toString, T = ("" + c).split("toString");
        i(10).inspectSource = function(u) {
          return c.call(u);
        }, (t.exports = function(u, d, A, f) {
          var h = typeof A == "function";
          h && (l(A, "name") || o(A, "name", d)), u[d] !== A && (h && (l(A, a) || o(A, a, u[d] ? "" + u[d] : T.join(String(d)))), u === s ? u[d] = A : f ? u[d] ? u[d] = A : o(u, d, A) : (delete u[d], o(u, d, A)));
        })(Function.prototype, "toString", function() {
          return typeof this == "function" && this[a] || c.call(this);
        });
      }, function(t, n) {
        t.exports = function(i) {
          try {
            return !!i();
          } catch {
            return !0;
          }
        };
      }, function(t, n, i) {
        var s = i(13), o = i(25);
        t.exports = i(4) ? function(l, a, c) {
          return s.f(l, a, o(1, c));
        } : function(l, a, c) {
          return l[a] = c, l;
        };
      }, function(t, n) {
        var i = {}.toString;
        t.exports = function(s) {
          return i.call(s).slice(8, -1);
        };
      }, function(t, n) {
        var i = t.exports = { version: "2.5.7" };
        typeof __e == "number" && (__e = i);
      }, function(t, n, i) {
        var s = i(14);
        t.exports = function(o, l, a) {
          if (s(o), l === void 0)
            return o;
          switch (a) {
            case 1:
              return function(c) {
                return o.call(l, c);
              };
            case 2:
              return function(c, T) {
                return o.call(l, c, T);
              };
            case 3:
              return function(c, T, u) {
                return o.call(l, c, T, u);
              };
          }
          return function() {
            return o.apply(l, arguments);
          };
        };
      }, function(t, n) {
        var i = {}.hasOwnProperty;
        t.exports = function(s, o) {
          return i.call(s, o);
        };
      }, function(t, n, i) {
        var s = i(2), o = i(41), l = i(29), a = Object.defineProperty;
        n.f = i(4) ? Object.defineProperty : function(c, T, u) {
          if (s(c), T = l(T, !0), s(u), o)
            try {
              return a(c, T, u);
            } catch {
            }
          if ("get" in u || "set" in u)
            throw TypeError("Accessors not supported!");
          return "value" in u && (c[T] = u.value), c;
        };
      }, function(t, n) {
        t.exports = function(i) {
          if (typeof i != "function")
            throw TypeError(i + " is not a function!");
          return i;
        };
      }, function(t, n) {
        t.exports = {};
      }, function(t, n) {
        t.exports = function(i) {
          if (i == null)
            throw TypeError("Can't call method on  " + i);
          return i;
        };
      }, function(t, n, i) {
        var s = i(7);
        t.exports = function(o, l) {
          return !!o && s(function() {
            l ? o.call(null, function() {
            }, 1) : o.call(null);
          });
        };
      }, function(t, n, i) {
        var s = i(23), o = i(16);
        t.exports = function(l) {
          return s(o(l));
        };
      }, function(t, n, i) {
        var s = i(53), o = Math.min;
        t.exports = function(l) {
          return l > 0 ? o(s(l), 9007199254740991) : 0;
        };
      }, function(t, n, i) {
        var s = i(11), o = i(23), l = i(28), a = i(19), c = i(64);
        t.exports = function(T, u) {
          var d = T == 1, A = T == 2, f = T == 3, h = T == 4, S = T == 6, p = T == 5 || S, m = u || c;
          return function(g, N, R) {
            for (var D, v, O = l(g), y = o(O), Z = s(N, R, 3), F = a(y.length), b = 0, Y = d ? m(g, F) : A ? m(g, 0) : void 0; F > b; b++)
              if ((p || b in y) && (D = y[b], v = Z(D, b, O), T)) {
                if (d)
                  Y[b] = v;
                else if (v)
                  switch (T) {
                    case 3:
                      return !0;
                    case 5:
                      return D;
                    case 6:
                      return b;
                    case 2:
                      Y.push(D);
                  }
                else if (h)
                  return !1;
              }
            return S ? -1 : f || h ? h : Y;
          };
        };
      }, function(t, n, i) {
        var s = i(5), o = i(0).document, l = s(o) && s(o.createElement);
        t.exports = function(a) {
          return l ? o.createElement(a) : {};
        };
      }, function(t, n) {
        t.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
      }, function(t, n, i) {
        var s = i(9);
        t.exports = Object("z").propertyIsEnumerable(0) ? Object : function(o) {
          return s(o) == "String" ? o.split("") : Object(o);
        };
      }, function(t, n) {
        t.exports = !1;
      }, function(t, n) {
        t.exports = function(i, s) {
          return { enumerable: !(1 & i), configurable: !(2 & i), writable: !(4 & i), value: s };
        };
      }, function(t, n, i) {
        var s = i(13).f, o = i(12), l = i(1)("toStringTag");
        t.exports = function(a, c, T) {
          a && !o(a = T ? a : a.prototype, l) && s(a, l, { configurable: !0, value: c });
        };
      }, function(t, n, i) {
        var s = i(49)("keys"), o = i(30);
        t.exports = function(l) {
          return s[l] || (s[l] = o(l));
        };
      }, function(t, n, i) {
        var s = i(16);
        t.exports = function(o) {
          return Object(s(o));
        };
      }, function(t, n, i) {
        var s = i(5);
        t.exports = function(o, l) {
          if (!s(o))
            return o;
          var a, c;
          if (l && typeof (a = o.toString) == "function" && !s(c = a.call(o)) || typeof (a = o.valueOf) == "function" && !s(c = a.call(o)) || !l && typeof (a = o.toString) == "function" && !s(c = a.call(o)))
            return c;
          throw TypeError("Can't convert object to primitive value");
        };
      }, function(t, n) {
        var i = 0, s = Math.random();
        t.exports = function(o) {
          return "Symbol(".concat(o === void 0 ? "" : o, ")_", (++i + s).toString(36));
        };
      }, function(t, n, i) {
        var s = i(0), o = i(12), l = i(9), a = i(67), c = i(29), T = i(7), u = i(77).f, d = i(45).f, A = i(13).f, f = i(51).trim, h = s.Number, S = h, p = h.prototype, m = l(i(44)(p)) == "Number", g = "trim" in String.prototype, N = function(O) {
          var y = c(O, !1);
          if (typeof y == "string" && y.length > 2) {
            y = g ? y.trim() : f(y, 3);
            var Z, F, b, Y = y.charCodeAt(0);
            if (Y === 43 || Y === 45) {
              if ((Z = y.charCodeAt(2)) === 88 || Z === 120)
                return NaN;
            } else if (Y === 48) {
              switch (y.charCodeAt(1)) {
                case 66:
                case 98:
                  F = 2, b = 49;
                  break;
                case 79:
                case 111:
                  F = 8, b = 55;
                  break;
                default:
                  return +y;
              }
              for (var I, q = y.slice(2), _ = 0, z = q.length; _ < z; _++)
                if ((I = q.charCodeAt(_)) < 48 || I > b)
                  return NaN;
              return parseInt(q, F);
            }
          }
          return +y;
        };
        if (!h(" 0o1") || !h("0b1") || h("+0x1")) {
          h = function(O) {
            var y = arguments.length < 1 ? 0 : O, Z = this;
            return Z instanceof h && (m ? T(function() {
              p.valueOf.call(Z);
            }) : l(Z) != "Number") ? a(new S(N(y)), Z, h) : N(y);
          };
          for (var R, D = i(4) ? u(S) : "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","), v = 0; D.length > v; v++)
            o(S, R = D[v]) && !o(h, R) && A(h, R, d(S, R));
          h.prototype = p, p.constructor = h, i(6)(s, "Number", h);
        }
      }, function(t, n, i) {
        function s(F) {
          return F !== 0 && (!(!Array.isArray(F) || F.length !== 0) || !F);
        }
        function o(F) {
          return function() {
            return !F.apply(void 0, arguments);
          };
        }
        function l(F, b) {
          return F === void 0 && (F = "undefined"), F === null && (F = "null"), F === !1 && (F = "false"), F.toString().toLowerCase().indexOf(b.trim()) !== -1;
        }
        function a(F, b, Y, I) {
          return F.filter(function(q) {
            return l(I(q, Y), b);
          });
        }
        function c(F) {
          return F.filter(function(b) {
            return !b.$isLabel;
          });
        }
        function T(F, b) {
          return function(Y) {
            return Y.reduce(function(I, q) {
              return q[F] && q[F].length ? (I.push({ $groupLabel: q[b], $isLabel: !0 }), I.concat(q[F])) : I;
            }, []);
          };
        }
        function u(F, b, Y, I, q) {
          return function(_) {
            return _.map(function(z) {
              var E;
              if (!z[Y])
                return console.warn("Options passed to vue-multiselect do not contain groups, despite the config."), [];
              var C = a(z[Y], F, b, q);
              return C.length ? (E = {}, i.i(S.a)(E, I, z[I]), i.i(S.a)(E, Y, C), E) : [];
            });
          };
        }
        var d = i(59), A = i(54), f = (i.n(A), i(95)), h = (i.n(f), i(31)), S = (i.n(h), i(58)), p = i(91), m = (i.n(p), i(98)), g = (i.n(m), i(92)), N = (i.n(g), i(88)), R = (i.n(N), i(97)), D = (i.n(R), i(89)), v = (i.n(D), i(96)), O = (i.n(v), i(93)), y = (i.n(O), i(90)), Z = (i.n(y), function() {
          for (var F = arguments.length, b = new Array(F), Y = 0; Y < F; Y++)
            b[Y] = arguments[Y];
          return function(I) {
            return b.reduce(function(q, _) {
              return _(q);
            }, I);
          };
        });
        n.a = { data: function() {
          return { search: "", isOpen: !1, preferredOpenDirection: "below", optimizedHeight: this.maxHeight };
        }, props: { internalSearch: { type: Boolean, default: !0 }, options: { type: Array, required: !0 }, multiple: { type: Boolean, default: !1 }, value: { type: null, default: function() {
          return [];
        } }, trackBy: { type: String }, label: { type: String }, searchable: { type: Boolean, default: !0 }, clearOnSelect: { type: Boolean, default: !0 }, hideSelected: { type: Boolean, default: !1 }, placeholder: { type: String, default: "Select option" }, allowEmpty: { type: Boolean, default: !0 }, resetAfter: { type: Boolean, default: !1 }, closeOnSelect: { type: Boolean, default: !0 }, customLabel: { type: Function, default: function(F, b) {
          return s(F) ? "" : b ? F[b] : F;
        } }, taggable: { type: Boolean, default: !1 }, tagPlaceholder: { type: String, default: "Press enter to create a tag" }, tagPosition: { type: String, default: "top" }, max: { type: [Number, Boolean], default: !1 }, id: { default: null }, optionsLimit: { type: Number, default: 1e3 }, groupValues: { type: String }, groupLabel: { type: String }, groupSelect: { type: Boolean, default: !1 }, blockKeys: { type: Array, default: function() {
          return [];
        } }, preserveSearch: { type: Boolean, default: !1 }, preselectFirst: { type: Boolean, default: !1 } }, mounted: function() {
          !this.multiple && this.max && console.warn("[Vue-Multiselect warn]: Max prop should not be used when prop Multiple equals false."), this.preselectFirst && !this.internalValue.length && this.options.length && this.select(this.filteredOptions[0]);
        }, computed: { internalValue: function() {
          return this.value || this.value === 0 ? Array.isArray(this.value) ? this.value : [this.value] : [];
        }, filteredOptions: function() {
          var F = this.search || "", b = F.toLowerCase().trim(), Y = this.options.concat();
          return Y = this.internalSearch ? this.groupValues ? this.filterAndFlat(Y, b, this.label) : a(Y, b, this.label, this.customLabel) : this.groupValues ? T(this.groupValues, this.groupLabel)(Y) : Y, Y = this.hideSelected ? Y.filter(o(this.isSelected)) : Y, this.taggable && b.length && !this.isExistingOption(b) && (this.tagPosition === "bottom" ? Y.push({ isTag: !0, label: F }) : Y.unshift({ isTag: !0, label: F })), Y.slice(0, this.optionsLimit);
        }, valueKeys: function() {
          var F = this;
          return this.trackBy ? this.internalValue.map(function(b) {
            return b[F.trackBy];
          }) : this.internalValue;
        }, optionKeys: function() {
          var F = this;
          return (this.groupValues ? this.flatAndStrip(this.options) : this.options).map(function(b) {
            return F.customLabel(b, F.label).toString().toLowerCase();
          });
        }, currentOptionLabel: function() {
          return this.multiple ? this.searchable ? "" : this.placeholder : this.internalValue.length ? this.getOptionLabel(this.internalValue[0]) : this.searchable ? "" : this.placeholder;
        } }, watch: { internalValue: function() {
          this.resetAfter && this.internalValue.length && (this.search = "", this.$emit("input", this.multiple ? [] : null));
        }, search: function() {
          this.$emit("search-change", this.search, this.id);
        } }, methods: { getValue: function() {
          return this.multiple ? this.internalValue : this.internalValue.length === 0 ? null : this.internalValue[0];
        }, filterAndFlat: function(F, b, Y) {
          return Z(u(b, Y, this.groupValues, this.groupLabel, this.customLabel), T(this.groupValues, this.groupLabel))(F);
        }, flatAndStrip: function(F) {
          return Z(T(this.groupValues, this.groupLabel), c)(F);
        }, updateSearch: function(F) {
          this.search = F;
        }, isExistingOption: function(F) {
          return !!this.options && this.optionKeys.indexOf(F) > -1;
        }, isSelected: function(F) {
          var b = this.trackBy ? F[this.trackBy] : F;
          return this.valueKeys.indexOf(b) > -1;
        }, isOptionDisabled: function(F) {
          return !!F.$isDisabled;
        }, getOptionLabel: function(F) {
          if (s(F))
            return "";
          if (F.isTag)
            return F.label;
          if (F.$isLabel)
            return F.$groupLabel;
          var b = this.customLabel(F, this.label);
          return s(b) ? "" : b;
        }, select: function(F, b) {
          if (F.$isLabel && this.groupSelect)
            return void this.selectGroup(F);
          if (!(this.blockKeys.indexOf(b) !== -1 || this.disabled || F.$isDisabled || F.$isLabel) && (!this.max || !this.multiple || this.internalValue.length !== this.max) && (b !== "Tab" || this.pointerDirty)) {
            if (F.isTag)
              this.$emit("tag", F.label, this.id), this.search = "", this.closeOnSelect && !this.multiple && this.deactivate();
            else {
              if (this.isSelected(F))
                return void (b !== "Tab" && this.removeElement(F));
              this.$emit("select", F, this.id), this.multiple ? this.$emit("input", this.internalValue.concat([F]), this.id) : this.$emit("input", F, this.id), this.clearOnSelect && (this.search = "");
            }
            this.closeOnSelect && this.deactivate();
          }
        }, selectGroup: function(F) {
          var b = this, Y = this.options.find(function(_) {
            return _[b.groupLabel] === F.$groupLabel;
          });
          if (Y)
            if (this.wholeGroupSelected(Y)) {
              this.$emit("remove", Y[this.groupValues], this.id);
              var I = this.internalValue.filter(function(_) {
                return Y[b.groupValues].indexOf(_) === -1;
              });
              this.$emit("input", I, this.id);
            } else {
              var q = Y[this.groupValues].filter(function(_) {
                return !(b.isOptionDisabled(_) || b.isSelected(_));
              });
              this.$emit("select", q, this.id), this.$emit("input", this.internalValue.concat(q), this.id);
            }
        }, wholeGroupSelected: function(F) {
          var b = this;
          return F[this.groupValues].every(function(Y) {
            return b.isSelected(Y) || b.isOptionDisabled(Y);
          });
        }, wholeGroupDisabled: function(F) {
          return F[this.groupValues].every(this.isOptionDisabled);
        }, removeElement: function(F) {
          var b = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1];
          if (!this.disabled && !F.$isDisabled) {
            if (!this.allowEmpty && this.internalValue.length <= 1)
              return void this.deactivate();
            var Y = i.i(d.a)(F) === "object" ? this.valueKeys.indexOf(F[this.trackBy]) : this.valueKeys.indexOf(F);
            if (this.$emit("remove", F, this.id), this.multiple) {
              var I = this.internalValue.slice(0, Y).concat(this.internalValue.slice(Y + 1));
              this.$emit("input", I, this.id);
            } else
              this.$emit("input", null, this.id);
            this.closeOnSelect && b && this.deactivate();
          }
        }, removeLastElement: function() {
          this.blockKeys.indexOf("Delete") === -1 && this.search.length === 0 && Array.isArray(this.internalValue) && this.internalValue.length && this.removeElement(this.internalValue[this.internalValue.length - 1], !1);
        }, activate: function() {
          var F = this;
          this.isOpen || this.disabled || (this.adjustPosition(), this.groupValues && this.pointer === 0 && this.filteredOptions.length && (this.pointer = 1), this.isOpen = !0, this.searchable ? (this.preserveSearch || (this.search = ""), this.$nextTick(function() {
            return F.$refs.search.focus();
          })) : this.$el.focus(), this.$emit("open", this.id));
        }, deactivate: function() {
          this.isOpen && (this.isOpen = !1, this.searchable ? this.$refs.search.blur() : this.$el.blur(), this.preserveSearch || (this.search = ""), this.$emit("close", this.getValue(), this.id));
        }, toggle: function() {
          this.isOpen ? this.deactivate() : this.activate();
        }, adjustPosition: function() {
          if (typeof window < "u") {
            var F = this.$el.getBoundingClientRect().top, b = window.innerHeight - this.$el.getBoundingClientRect().bottom;
            b > this.maxHeight || b > F || this.openDirection === "below" || this.openDirection === "bottom" ? (this.preferredOpenDirection = "below", this.optimizedHeight = Math.min(b - 40, this.maxHeight)) : (this.preferredOpenDirection = "above", this.optimizedHeight = Math.min(F - 40, this.maxHeight));
          }
        } } };
      }, function(t, n, i) {
        var s = i(54), o = (i.n(s), i(31));
        i.n(o), n.a = { data: function() {
          return { pointer: 0, pointerDirty: !1 };
        }, props: { showPointer: { type: Boolean, default: !0 }, optionHeight: { type: Number, default: 40 } }, computed: { pointerPosition: function() {
          return this.pointer * this.optionHeight;
        }, visibleElements: function() {
          return this.optimizedHeight / this.optionHeight;
        } }, watch: { filteredOptions: function() {
          this.pointerAdjust();
        }, isOpen: function() {
          this.pointerDirty = !1;
        } }, methods: { optionHighlight: function(l, a) {
          return { "multiselect__option--highlight": l === this.pointer && this.showPointer, "multiselect__option--selected": this.isSelected(a) };
        }, groupHighlight: function(l, a) {
          var c = this;
          if (!this.groupSelect)
            return ["multiselect__option--group", "multiselect__option--disabled"];
          var T = this.options.find(function(u) {
            return u[c.groupLabel] === a.$groupLabel;
          });
          return T && !this.wholeGroupDisabled(T) ? ["multiselect__option--group", { "multiselect__option--highlight": l === this.pointer && this.showPointer }, { "multiselect__option--group-selected": this.wholeGroupSelected(T) }] : "multiselect__option--disabled";
        }, addPointerElement: function() {
          var l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Enter", a = l.key;
          this.filteredOptions.length > 0 && this.select(this.filteredOptions[this.pointer], a), this.pointerReset();
        }, pointerForward: function() {
          this.pointer < this.filteredOptions.length - 1 && (this.pointer++, this.$refs.list.scrollTop <= this.pointerPosition - (this.visibleElements - 1) * this.optionHeight && (this.$refs.list.scrollTop = this.pointerPosition - (this.visibleElements - 1) * this.optionHeight), this.filteredOptions[this.pointer] && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect && this.pointerForward()), this.pointerDirty = !0;
        }, pointerBackward: function() {
          this.pointer > 0 ? (this.pointer--, this.$refs.list.scrollTop >= this.pointerPosition && (this.$refs.list.scrollTop = this.pointerPosition), this.filteredOptions[this.pointer] && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect && this.pointerBackward()) : this.filteredOptions[this.pointer] && this.filteredOptions[0].$isLabel && !this.groupSelect && this.pointerForward(), this.pointerDirty = !0;
        }, pointerReset: function() {
          this.closeOnSelect && (this.pointer = 0, this.$refs.list && (this.$refs.list.scrollTop = 0));
        }, pointerAdjust: function() {
          this.pointer >= this.filteredOptions.length - 1 && (this.pointer = this.filteredOptions.length ? this.filteredOptions.length - 1 : 0), this.filteredOptions.length > 0 && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect && this.pointerForward();
        }, pointerSet: function(l) {
          this.pointer = l, this.pointerDirty = !0;
        } } };
      }, function(t, n, i) {
        var s = i(36), o = i(74), l = i(15), a = i(18);
        t.exports = i(72)(Array, "Array", function(c, T) {
          this._t = a(c), this._i = 0, this._k = T;
        }, function() {
          var c = this._t, T = this._k, u = this._i++;
          return !c || u >= c.length ? (this._t = void 0, o(1)) : T == "keys" ? o(0, u) : T == "values" ? o(0, c[u]) : o(0, [u, c[u]]);
        }, "values"), l.Arguments = l.Array, s("keys"), s("values"), s("entries");
      }, function(t, n, i) {
        var s = i(31), o = (i.n(s), i(32)), l = i(33);
        n.a = { name: "vue-multiselect", mixins: [o.a, l.a], props: { name: { type: String, default: "" }, selectLabel: { type: String, default: "Press enter to select" }, selectGroupLabel: { type: String, default: "Press enter to select group" }, selectedLabel: { type: String, default: "Selected" }, deselectLabel: { type: String, default: "Press enter to remove" }, deselectGroupLabel: { type: String, default: "Press enter to deselect group" }, showLabels: { type: Boolean, default: !0 }, limit: { type: Number, default: 99999 }, maxHeight: { type: Number, default: 300 }, limitText: { type: Function, default: function(a) {
          return "and ".concat(a, " more");
        } }, loading: { type: Boolean, default: !1 }, disabled: { type: Boolean, default: !1 }, openDirection: { type: String, default: "" }, showNoOptions: { type: Boolean, default: !0 }, showNoResults: { type: Boolean, default: !0 }, tabindex: { type: Number, default: 0 } }, computed: { isSingleLabelVisible: function() {
          return (this.singleValue || this.singleValue === 0) && (!this.isOpen || !this.searchable) && !this.visibleValues.length;
        }, isPlaceholderVisible: function() {
          return !(this.internalValue.length || this.searchable && this.isOpen);
        }, visibleValues: function() {
          return this.multiple ? this.internalValue.slice(0, this.limit) : [];
        }, singleValue: function() {
          return this.internalValue[0];
        }, deselectLabelText: function() {
          return this.showLabels ? this.deselectLabel : "";
        }, deselectGroupLabelText: function() {
          return this.showLabels ? this.deselectGroupLabel : "";
        }, selectLabelText: function() {
          return this.showLabels ? this.selectLabel : "";
        }, selectGroupLabelText: function() {
          return this.showLabels ? this.selectGroupLabel : "";
        }, selectedLabelText: function() {
          return this.showLabels ? this.selectedLabel : "";
        }, inputStyle: function() {
          if (this.searchable || this.multiple && this.value && this.value.length)
            return this.isOpen ? { width: "100%" } : { width: "0", position: "absolute", padding: "0" };
        }, contentStyle: function() {
          return this.options.length ? { display: "inline-block" } : { display: "block" };
        }, isAbove: function() {
          return this.openDirection === "above" || this.openDirection === "top" || this.openDirection !== "below" && this.openDirection !== "bottom" && this.preferredOpenDirection === "above";
        }, showSearchInput: function() {
          return this.searchable && (!this.hasSingleSelectedSlot || !this.visibleSingleValue && this.visibleSingleValue !== 0 || this.isOpen);
        } } };
      }, function(t, n, i) {
        var s = i(1)("unscopables"), o = Array.prototype;
        o[s] == null && i(8)(o, s, {}), t.exports = function(l) {
          o[s][l] = !0;
        };
      }, function(t, n, i) {
        var s = i(18), o = i(19), l = i(85);
        t.exports = function(a) {
          return function(c, T, u) {
            var d, A = s(c), f = o(A.length), h = l(u, f);
            if (a && T != T) {
              for (; f > h; )
                if ((d = A[h++]) != d)
                  return !0;
            } else
              for (; f > h; h++)
                if ((a || h in A) && A[h] === T)
                  return a || h || 0;
            return !a && -1;
          };
        };
      }, function(t, n, i) {
        var s = i(9), o = i(1)("toStringTag"), l = s(function() {
          return arguments;
        }()) == "Arguments", a = function(c, T) {
          try {
            return c[T];
          } catch {
          }
        };
        t.exports = function(c) {
          var T, u, d;
          return c === void 0 ? "Undefined" : c === null ? "Null" : typeof (u = a(T = Object(c), o)) == "string" ? u : l ? s(T) : (d = s(T)) == "Object" && typeof T.callee == "function" ? "Arguments" : d;
        };
      }, function(t, n, i) {
        var s = i(2);
        t.exports = function() {
          var o = s(this), l = "";
          return o.global && (l += "g"), o.ignoreCase && (l += "i"), o.multiline && (l += "m"), o.unicode && (l += "u"), o.sticky && (l += "y"), l;
        };
      }, function(t, n, i) {
        var s = i(0).document;
        t.exports = s && s.documentElement;
      }, function(t, n, i) {
        t.exports = !i(4) && !i(7)(function() {
          return Object.defineProperty(i(21)("div"), "a", { get: function() {
            return 7;
          } }).a != 7;
        });
      }, function(t, n, i) {
        var s = i(9);
        t.exports = Array.isArray || function(o) {
          return s(o) == "Array";
        };
      }, function(t, n, i) {
        function s(l) {
          var a, c;
          this.promise = new l(function(T, u) {
            if (a !== void 0 || c !== void 0)
              throw TypeError("Bad Promise constructor");
            a = T, c = u;
          }), this.resolve = o(a), this.reject = o(c);
        }
        var o = i(14);
        t.exports.f = function(l) {
          return new s(l);
        };
      }, function(t, n, i) {
        var s = i(2), o = i(76), l = i(22), a = i(27)("IE_PROTO"), c = function() {
        }, T = function() {
          var u, d = i(21)("iframe"), A = l.length;
          for (d.style.display = "none", i(40).appendChild(d), d.src = "javascript:", u = d.contentWindow.document, u.open(), u.write("<script>document.F=Object<\/script>"), u.close(), T = u.F; A--; )
            delete T.prototype[l[A]];
          return T();
        };
        t.exports = Object.create || function(u, d) {
          var A;
          return u !== null ? (c.prototype = s(u), A = new c(), c.prototype = null, A[a] = u) : A = T(), d === void 0 ? A : o(A, d);
        };
      }, function(t, n, i) {
        var s = i(79), o = i(25), l = i(18), a = i(29), c = i(12), T = i(41), u = Object.getOwnPropertyDescriptor;
        n.f = i(4) ? u : function(d, A) {
          if (d = l(d), A = a(A, !0), T)
            try {
              return u(d, A);
            } catch {
            }
          if (c(d, A))
            return o(!s.f.call(d, A), d[A]);
        };
      }, function(t, n, i) {
        var s = i(12), o = i(18), l = i(37)(!1), a = i(27)("IE_PROTO");
        t.exports = function(c, T) {
          var u, d = o(c), A = 0, f = [];
          for (u in d)
            u != a && s(d, u) && f.push(u);
          for (; T.length > A; )
            s(d, u = T[A++]) && (~l(f, u) || f.push(u));
          return f;
        };
      }, function(t, n, i) {
        var s = i(46), o = i(22);
        t.exports = Object.keys || function(l) {
          return s(l, o);
        };
      }, function(t, n, i) {
        var s = i(2), o = i(5), l = i(43);
        t.exports = function(a, c) {
          if (s(a), o(c) && c.constructor === a)
            return c;
          var T = l.f(a);
          return (0, T.resolve)(c), T.promise;
        };
      }, function(t, n, i) {
        var s = i(10), o = i(0), l = o["__core-js_shared__"] || (o["__core-js_shared__"] = {});
        (t.exports = function(a, c) {
          return l[a] || (l[a] = c !== void 0 ? c : {});
        })("versions", []).push({ version: s.version, mode: i(24) ? "pure" : "global", copyright: "© 2018 Denis Pushkarev (zloirock.ru)" });
      }, function(t, n, i) {
        var s = i(2), o = i(14), l = i(1)("species");
        t.exports = function(a, c) {
          var T, u = s(a).constructor;
          return u === void 0 || (T = s(u)[l]) == null ? c : o(T);
        };
      }, function(t, n, i) {
        var s = i(3), o = i(16), l = i(7), a = i(84), c = "[" + a + "]", T = "​", u = RegExp("^" + c + c + "*"), d = RegExp(c + c + "*$"), A = function(h, S, p) {
          var m = {}, g = l(function() {
            return !!a[h]() || T[h]() != T;
          }), N = m[h] = g ? S(f) : a[h];
          p && (m[p] = N), s(s.P + s.F * g, "String", m);
        }, f = A.trim = function(h, S) {
          return h = String(o(h)), 1 & S && (h = h.replace(u, "")), 2 & S && (h = h.replace(d, "")), h;
        };
        t.exports = A;
      }, function(t, n, i) {
        var s, o, l, a = i(11), c = i(68), T = i(40), u = i(21), d = i(0), A = d.process, f = d.setImmediate, h = d.clearImmediate, S = d.MessageChannel, p = d.Dispatch, m = 0, g = {}, N = function() {
          var D = +this;
          if (g.hasOwnProperty(D)) {
            var v = g[D];
            delete g[D], v();
          }
        }, R = function(D) {
          N.call(D.data);
        };
        f && h || (f = function(D) {
          for (var v = [], O = 1; arguments.length > O; )
            v.push(arguments[O++]);
          return g[++m] = function() {
            c(typeof D == "function" ? D : Function(D), v);
          }, s(m), m;
        }, h = function(D) {
          delete g[D];
        }, i(9)(A) == "process" ? s = function(D) {
          A.nextTick(a(N, D, 1));
        } : p && p.now ? s = function(D) {
          p.now(a(N, D, 1));
        } : S ? (o = new S(), l = o.port2, o.port1.onmessage = R, s = a(l.postMessage, l, 1)) : d.addEventListener && typeof postMessage == "function" && !d.importScripts ? (s = function(D) {
          d.postMessage(D + "", "*");
        }, d.addEventListener("message", R, !1)) : s = "onreadystatechange" in u("script") ? function(D) {
          T.appendChild(u("script")).onreadystatechange = function() {
            T.removeChild(this), N.call(D);
          };
        } : function(D) {
          setTimeout(a(N, D, 1), 0);
        }), t.exports = { set: f, clear: h };
      }, function(t, n) {
        var i = Math.ceil, s = Math.floor;
        t.exports = function(o) {
          return isNaN(o = +o) ? 0 : (o > 0 ? s : i)(o);
        };
      }, function(t, n, i) {
        var s = i(3), o = i(20)(5), l = !0;
        "find" in [] && Array(1).find(function() {
          l = !1;
        }), s(s.P + s.F * l, "Array", { find: function(a) {
          return o(this, a, arguments.length > 1 ? arguments[1] : void 0);
        } }), i(36)("find");
      }, function(t, n, i) {
        var s, o, l, a, c = i(24), T = i(0), u = i(11), d = i(38), A = i(3), f = i(5), h = i(14), S = i(61), p = i(66), m = i(50), g = i(52).set, N = i(75)(), R = i(43), D = i(80), v = i(86), O = i(48), y = T.TypeError, Z = T.process, F = Z && Z.versions, b = F && F.v8 || "", Y = T.Promise, I = d(Z) == "process", q = function() {
        }, _ = o = R.f, z = !!function() {
          try {
            var U = Y.resolve(1), w = (U.constructor = {})[i(1)("species")] = function(W) {
              W(q, q);
            };
            return (I || typeof PromiseRejectionEvent == "function") && U.then(q) instanceof w && b.indexOf("6.6") !== 0 && v.indexOf("Chrome/66") === -1;
          } catch {
          }
        }(), E = function(U) {
          var w;
          return !(!f(U) || typeof (w = U.then) != "function") && w;
        }, C = function(U, w) {
          if (!U._n) {
            U._n = !0;
            var W = U._c;
            N(function() {
              for (var se = U._v, ie = U._s == 1, Fe = 0; W.length > Fe; )
                (function(V) {
                  var $, J, ae, X = ie ? V.ok : V.fail, pe = V.resolve, L = V.reject, ee = V.domain;
                  try {
                    X ? (ie || (U._h == 2 && Q(U), U._h = 1), X === !0 ? $ = se : (ee && ee.enter(), $ = X(se), ee && (ee.exit(), ae = !0)), $ === V.promise ? L(y("Promise-chain cycle")) : (J = E($)) ? J.call($, pe, L) : pe($)) : L(se);
                  } catch (Ae) {
                    ee && !ae && ee.exit(), L(Ae);
                  }
                })(W[Fe++]);
              U._c = [], U._n = !1, w && !U._h && P(U);
            });
          }
        }, P = function(U) {
          g.call(T, function() {
            var w, W, se, ie = U._v, Fe = M(U);
            if (Fe && (w = D(function() {
              I ? Z.emit("unhandledRejection", ie, U) : (W = T.onunhandledrejection) ? W({ promise: U, reason: ie }) : (se = T.console) && se.error && se.error("Unhandled promise rejection", ie);
            }), U._h = I || M(U) ? 2 : 1), U._a = void 0, Fe && w.e)
              throw w.v;
          });
        }, M = function(U) {
          return U._h !== 1 && (U._a || U._c).length === 0;
        }, Q = function(U) {
          g.call(T, function() {
            var w;
            I ? Z.emit("rejectionHandled", U) : (w = T.onrejectionhandled) && w({ promise: U, reason: U._v });
          });
        }, H = function(U) {
          var w = this;
          w._d || (w._d = !0, w = w._w || w, w._v = U, w._s = 2, w._a || (w._a = w._c.slice()), C(w, !0));
        }, re = function(U) {
          var w, W = this;
          if (!W._d) {
            W._d = !0, W = W._w || W;
            try {
              if (W === U)
                throw y("Promise can't be resolved itself");
              (w = E(U)) ? N(function() {
                var se = { _w: W, _d: !1 };
                try {
                  w.call(U, u(re, se, 1), u(H, se, 1));
                } catch (ie) {
                  H.call(se, ie);
                }
              }) : (W._v = U, W._s = 1, C(W, !1));
            } catch (se) {
              H.call({ _w: W, _d: !1 }, se);
            }
          }
        };
        z || (Y = function(U) {
          S(this, Y, "Promise", "_h"), h(U), s.call(this);
          try {
            U(u(re, this, 1), u(H, this, 1));
          } catch (w) {
            H.call(this, w);
          }
        }, s = function(U) {
          this._c = [], this._a = void 0, this._s = 0, this._d = !1, this._v = void 0, this._h = 0, this._n = !1;
        }, s.prototype = i(81)(Y.prototype, { then: function(U, w) {
          var W = _(m(this, Y));
          return W.ok = typeof U != "function" || U, W.fail = typeof w == "function" && w, W.domain = I ? Z.domain : void 0, this._c.push(W), this._a && this._a.push(W), this._s && C(this, !1), W.promise;
        }, catch: function(U) {
          return this.then(void 0, U);
        } }), l = function() {
          var U = new s();
          this.promise = U, this.resolve = u(re, U, 1), this.reject = u(H, U, 1);
        }, R.f = _ = function(U) {
          return U === Y || U === a ? new l(U) : o(U);
        }), A(A.G + A.W + A.F * !z, { Promise: Y }), i(26)(Y, "Promise"), i(83)("Promise"), a = i(10).Promise, A(A.S + A.F * !z, "Promise", { reject: function(U) {
          var w = _(this);
          return (0, w.reject)(U), w.promise;
        } }), A(A.S + A.F * (c || !z), "Promise", { resolve: function(U) {
          return O(c && this === a ? Y : this, U);
        } }), A(A.S + A.F * !(z && i(73)(function(U) {
          Y.all(U).catch(q);
        })), "Promise", { all: function(U) {
          var w = this, W = _(w), se = W.resolve, ie = W.reject, Fe = D(function() {
            var V = [], $ = 0, J = 1;
            p(U, !1, function(ae) {
              var X = $++, pe = !1;
              V.push(void 0), J++, w.resolve(ae).then(function(L) {
                pe || (pe = !0, V[X] = L, --J || se(V));
              }, ie);
            }), --J || se(V);
          });
          return Fe.e && ie(Fe.v), W.promise;
        }, race: function(U) {
          var w = this, W = _(w), se = W.reject, ie = D(function() {
            p(U, !1, function(Fe) {
              w.resolve(Fe).then(W.resolve, se);
            });
          });
          return ie.e && se(ie.v), W.promise;
        } });
      }, function(t, n, i) {
        var s = i(3), o = i(10), l = i(0), a = i(50), c = i(48);
        s(s.P + s.R, "Promise", { finally: function(T) {
          var u = a(this, o.Promise || l.Promise), d = typeof T == "function";
          return this.then(d ? function(A) {
            return c(u, T()).then(function() {
              return A;
            });
          } : T, d ? function(A) {
            return c(u, T()).then(function() {
              throw A;
            });
          } : T);
        } });
      }, function(t, n, i) {
        function s(u) {
          i(99);
        }
        var o = i(35), l = i(101), a = i(100), c = s, T = a(o.a, l.a, !1, c, null, null);
        n.a = T.exports;
      }, function(t, n, i) {
        function s(o, l, a) {
          return l in o ? Object.defineProperty(o, l, { value: a, enumerable: !0, configurable: !0, writable: !0 }) : o[l] = a, o;
        }
        n.a = s;
      }, function(t, n, i) {
        function s(l) {
          return (s = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(a) {
            return typeof a;
          } : function(a) {
            return a && typeof Symbol == "function" && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
          })(l);
        }
        function o(l) {
          return (o = typeof Symbol == "function" && s(Symbol.iterator) === "symbol" ? function(a) {
            return s(a);
          } : function(a) {
            return a && typeof Symbol == "function" && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : s(a);
          })(l);
        }
        n.a = o;
      }, function(t, n, i) {
        Object.defineProperty(n, "__esModule", { value: !0 });
        var s = i(34), o = (i.n(s), i(55)), l = (i.n(o), i(56)), a = (i.n(l), i(57)), c = i(32), T = i(33);
        i.d(n, "Multiselect", function() {
          return a.a;
        }), i.d(n, "multiselectMixin", function() {
          return c.a;
        }), i.d(n, "pointerMixin", function() {
          return T.a;
        }), n.default = a.a;
      }, function(t, n) {
        t.exports = function(i, s, o, l) {
          if (!(i instanceof s) || l !== void 0 && l in i)
            throw TypeError(o + ": incorrect invocation!");
          return i;
        };
      }, function(t, n, i) {
        var s = i(14), o = i(28), l = i(23), a = i(19);
        t.exports = function(c, T, u, d, A) {
          s(T);
          var f = o(c), h = l(f), S = a(f.length), p = A ? S - 1 : 0, m = A ? -1 : 1;
          if (u < 2)
            for (; ; ) {
              if (p in h) {
                d = h[p], p += m;
                break;
              }
              if (p += m, A ? p < 0 : S <= p)
                throw TypeError("Reduce of empty array with no initial value");
            }
          for (; A ? p >= 0 : S > p; p += m)
            p in h && (d = T(d, h[p], p, f));
          return d;
        };
      }, function(t, n, i) {
        var s = i(5), o = i(42), l = i(1)("species");
        t.exports = function(a) {
          var c;
          return o(a) && (c = a.constructor, typeof c != "function" || c !== Array && !o(c.prototype) || (c = void 0), s(c) && (c = c[l]) === null && (c = void 0)), c === void 0 ? Array : c;
        };
      }, function(t, n, i) {
        var s = i(63);
        t.exports = function(o, l) {
          return new (s(o))(l);
        };
      }, function(t, n, i) {
        var s = i(8), o = i(6), l = i(7), a = i(16), c = i(1);
        t.exports = function(T, u, d) {
          var A = c(T), f = d(a, A, ""[T]), h = f[0], S = f[1];
          l(function() {
            var p = {};
            return p[A] = function() {
              return 7;
            }, ""[T](p) != 7;
          }) && (o(String.prototype, T, h), s(RegExp.prototype, A, u == 2 ? function(p, m) {
            return S.call(p, this, m);
          } : function(p) {
            return S.call(p, this);
          }));
        };
      }, function(t, A, i) {
        var s = i(11), o = i(70), l = i(69), a = i(2), c = i(19), T = i(87), u = {}, d = {}, A = t.exports = function(f, h, S, p, m) {
          var g, N, R, D, v = m ? function() {
            return f;
          } : T(f), O = s(S, p, h ? 2 : 1), y = 0;
          if (typeof v != "function")
            throw TypeError(f + " is not iterable!");
          if (l(v)) {
            for (g = c(f.length); g > y; y++)
              if ((D = h ? O(a(N = f[y])[0], N[1]) : O(f[y])) === u || D === d)
                return D;
          } else
            for (R = v.call(f); !(N = R.next()).done; )
              if ((D = o(R, O, N.value, h)) === u || D === d)
                return D;
        };
        A.BREAK = u, A.RETURN = d;
      }, function(t, n, i) {
        var s = i(5), o = i(82).set;
        t.exports = function(l, a, c) {
          var T, u = a.constructor;
          return u !== c && typeof u == "function" && (T = u.prototype) !== c.prototype && s(T) && o && o(l, T), l;
        };
      }, function(t, n) {
        t.exports = function(i, s, o) {
          var l = o === void 0;
          switch (s.length) {
            case 0:
              return l ? i() : i.call(o);
            case 1:
              return l ? i(s[0]) : i.call(o, s[0]);
            case 2:
              return l ? i(s[0], s[1]) : i.call(o, s[0], s[1]);
            case 3:
              return l ? i(s[0], s[1], s[2]) : i.call(o, s[0], s[1], s[2]);
            case 4:
              return l ? i(s[0], s[1], s[2], s[3]) : i.call(o, s[0], s[1], s[2], s[3]);
          }
          return i.apply(o, s);
        };
      }, function(t, n, i) {
        var s = i(15), o = i(1)("iterator"), l = Array.prototype;
        t.exports = function(a) {
          return a !== void 0 && (s.Array === a || l[o] === a);
        };
      }, function(t, n, i) {
        var s = i(2);
        t.exports = function(o, l, a, c) {
          try {
            return c ? l(s(a)[0], a[1]) : l(a);
          } catch (u) {
            var T = o.return;
            throw T !== void 0 && s(T.call(o)), u;
          }
        };
      }, function(t, n, i) {
        var s = i(44), o = i(25), l = i(26), a = {};
        i(8)(a, i(1)("iterator"), function() {
          return this;
        }), t.exports = function(c, T, u) {
          c.prototype = s(a, { next: o(1, u) }), l(c, T + " Iterator");
        };
      }, function(t, n, i) {
        var s = i(24), o = i(3), l = i(6), a = i(8), c = i(15), T = i(71), u = i(26), d = i(78), A = i(1)("iterator"), f = !([].keys && "next" in [].keys()), h = function() {
          return this;
        };
        t.exports = function(S, p, m, g, N, R, D) {
          T(m, p, g);
          var v, O, y, Z = function(C) {
            if (!f && C in I)
              return I[C];
            switch (C) {
              case "keys":
              case "values":
                return function() {
                  return new m(this, C);
                };
            }
            return function() {
              return new m(this, C);
            };
          }, F = p + " Iterator", b = N == "values", Y = !1, I = S.prototype, q = I[A] || I["@@iterator"] || N && I[N], _ = q || Z(N), z = N ? b ? Z("entries") : _ : void 0, E = p == "Array" && I.entries || q;
          if (E && (y = d(E.call(new S()))) !== Object.prototype && y.next && (u(y, F, !0), s || typeof y[A] == "function" || a(y, A, h)), b && q && q.name !== "values" && (Y = !0, _ = function() {
            return q.call(this);
          }), s && !D || !f && !Y && I[A] || a(I, A, _), c[p] = _, c[F] = h, N)
            if (v = { values: b ? _ : Z("values"), keys: R ? _ : Z("keys"), entries: z }, D)
              for (O in v)
                O in I || l(I, O, v[O]);
            else
              o(o.P + o.F * (f || Y), p, v);
          return v;
        };
      }, function(t, n, i) {
        var s = i(1)("iterator"), o = !1;
        try {
          var l = [7][s]();
          l.return = function() {
            o = !0;
          }, Array.from(l, function() {
            throw 2;
          });
        } catch {
        }
        t.exports = function(a, c) {
          if (!c && !o)
            return !1;
          var T = !1;
          try {
            var u = [7], d = u[s]();
            d.next = function() {
              return { done: T = !0 };
            }, u[s] = function() {
              return d;
            }, a(u);
          } catch {
          }
          return T;
        };
      }, function(t, n) {
        t.exports = function(i, s) {
          return { value: s, done: !!i };
        };
      }, function(t, n, i) {
        var s = i(0), o = i(52).set, l = s.MutationObserver || s.WebKitMutationObserver, a = s.process, c = s.Promise, T = i(9)(a) == "process";
        t.exports = function() {
          var u, d, A, f = function() {
            var m, g;
            for (T && (m = a.domain) && m.exit(); u; ) {
              g = u.fn, u = u.next;
              try {
                g();
              } catch (N) {
                throw u ? A() : d = void 0, N;
              }
            }
            d = void 0, m && m.enter();
          };
          if (T)
            A = function() {
              a.nextTick(f);
            };
          else if (!l || s.navigator && s.navigator.standalone)
            if (c && c.resolve) {
              var h = c.resolve(void 0);
              A = function() {
                h.then(f);
              };
            } else
              A = function() {
                o.call(s, f);
              };
          else {
            var S = !0, p = document.createTextNode("");
            new l(f).observe(p, { characterData: !0 }), A = function() {
              p.data = S = !S;
            };
          }
          return function(m) {
            var g = { fn: m, next: void 0 };
            d && (d.next = g), u || (u = g, A()), d = g;
          };
        };
      }, function(t, n, i) {
        var s = i(13), o = i(2), l = i(47);
        t.exports = i(4) ? Object.defineProperties : function(a, c) {
          o(a);
          for (var T, u = l(c), d = u.length, A = 0; d > A; )
            s.f(a, T = u[A++], c[T]);
          return a;
        };
      }, function(t, n, i) {
        var s = i(46), o = i(22).concat("length", "prototype");
        n.f = Object.getOwnPropertyNames || function(l) {
          return s(l, o);
        };
      }, function(t, n, i) {
        var s = i(12), o = i(28), l = i(27)("IE_PROTO"), a = Object.prototype;
        t.exports = Object.getPrototypeOf || function(c) {
          return c = o(c), s(c, l) ? c[l] : typeof c.constructor == "function" && c instanceof c.constructor ? c.constructor.prototype : c instanceof Object ? a : null;
        };
      }, function(t, n) {
        n.f = {}.propertyIsEnumerable;
      }, function(t, n) {
        t.exports = function(i) {
          try {
            return { e: !1, v: i() };
          } catch (s) {
            return { e: !0, v: s };
          }
        };
      }, function(t, n, i) {
        var s = i(6);
        t.exports = function(o, l, a) {
          for (var c in l)
            s(o, c, l[c], a);
          return o;
        };
      }, function(t, n, i) {
        var s = i(5), o = i(2), l = function(a, c) {
          if (o(a), !s(c) && c !== null)
            throw TypeError(c + ": can't set as prototype!");
        };
        t.exports = { set: Object.setPrototypeOf || ("__proto__" in {} ? function(a, c, T) {
          try {
            T = i(11)(Function.call, i(45).f(Object.prototype, "__proto__").set, 2), T(a, []), c = !(a instanceof Array);
          } catch {
            c = !0;
          }
          return function(u, d) {
            return l(u, d), c ? u.__proto__ = d : T(u, d), u;
          };
        }({}, !1) : void 0), check: l };
      }, function(t, n, i) {
        var s = i(0), o = i(13), l = i(4), a = i(1)("species");
        t.exports = function(c) {
          var T = s[c];
          l && T && !T[a] && o.f(T, a, { configurable: !0, get: function() {
            return this;
          } });
        };
      }, function(t, n) {
        t.exports = `	
\v\f\r   ᠎             　\u2028\u2029\uFEFF`;
      }, function(t, n, i) {
        var s = i(53), o = Math.max, l = Math.min;
        t.exports = function(a, c) {
          return a = s(a), a < 0 ? o(a + c, 0) : l(a, c);
        };
      }, function(t, n, i) {
        var s = i(0), o = s.navigator;
        t.exports = o && o.userAgent || "";
      }, function(t, n, i) {
        var s = i(38), o = i(1)("iterator"), l = i(15);
        t.exports = i(10).getIteratorMethod = function(a) {
          if (a != null)
            return a[o] || a["@@iterator"] || l[s(a)];
        };
      }, function(t, n, i) {
        var s = i(3), o = i(20)(2);
        s(s.P + s.F * !i(17)([].filter, !0), "Array", { filter: function(l) {
          return o(this, l, arguments[1]);
        } });
      }, function(t, n, i) {
        var s = i(3), o = i(37)(!1), l = [].indexOf, a = !!l && 1 / [1].indexOf(1, -0) < 0;
        s(s.P + s.F * (a || !i(17)(l)), "Array", { indexOf: function(c) {
          return a ? l.apply(this, arguments) || 0 : o(this, c, arguments[1]);
        } });
      }, function(t, n, i) {
        var s = i(3);
        s(s.S, "Array", { isArray: i(42) });
      }, function(t, n, i) {
        var s = i(3), o = i(20)(1);
        s(s.P + s.F * !i(17)([].map, !0), "Array", { map: function(l) {
          return o(this, l, arguments[1]);
        } });
      }, function(t, n, i) {
        var s = i(3), o = i(62);
        s(s.P + s.F * !i(17)([].reduce, !0), "Array", { reduce: function(l) {
          return o(this, l, arguments.length, arguments[1], !1);
        } });
      }, function(t, n, i) {
        var s = Date.prototype, o = s.toString, l = s.getTime;
        new Date(NaN) + "" != "Invalid Date" && i(6)(s, "toString", function() {
          var a = l.call(this);
          return a === a ? o.call(this) : "Invalid Date";
        });
      }, function(t, n, i) {
        i(4) && /./g.flags != "g" && i(13).f(RegExp.prototype, "flags", { configurable: !0, get: i(39) });
      }, function(t, n, i) {
        i(65)("search", 1, function(s, o, l) {
          return [function(a) {
            var c = s(this), T = a == null ? void 0 : a[o];
            return T !== void 0 ? T.call(a, c) : new RegExp(a)[o](String(c));
          }, l];
        });
      }, function(t, n, i) {
        i(94);
        var s = i(2), o = i(39), l = i(4), a = /./.toString, c = function(T) {
          i(6)(RegExp.prototype, "toString", T, !0);
        };
        i(7)(function() {
          return a.call({ source: "a", flags: "b" }) != "/a/b";
        }) ? c(function() {
          var T = s(this);
          return "/".concat(T.source, "/", "flags" in T ? T.flags : !l && T instanceof RegExp ? o.call(T) : void 0);
        }) : a.name != "toString" && c(function() {
          return a.call(this);
        });
      }, function(t, n, i) {
        i(51)("trim", function(s) {
          return function() {
            return s(this, 3);
          };
        });
      }, function(t, n, i) {
        for (var s = i(34), o = i(47), l = i(6), a = i(0), c = i(8), T = i(15), u = i(1), d = u("iterator"), A = u("toStringTag"), f = T.Array, h = { CSSRuleList: !0, CSSStyleDeclaration: !1, CSSValueList: !1, ClientRectList: !1, DOMRectList: !1, DOMStringList: !1, DOMTokenList: !0, DataTransferItemList: !1, FileList: !1, HTMLAllCollection: !1, HTMLCollection: !1, HTMLFormElement: !1, HTMLSelectElement: !1, MediaList: !0, MimeTypeArray: !1, NamedNodeMap: !1, NodeList: !0, PaintRequestList: !1, Plugin: !1, PluginArray: !1, SVGLengthList: !1, SVGNumberList: !1, SVGPathSegList: !1, SVGPointList: !1, SVGStringList: !1, SVGTransformList: !1, SourceBufferList: !1, StyleSheetList: !0, TextTrackCueList: !1, TextTrackList: !1, TouchList: !1 }, S = o(h), p = 0; p < S.length; p++) {
          var m, g = S[p], N = h[g], R = a[g], D = R && R.prototype;
          if (D && (D[d] || c(D, d, f), D[A] || c(D, A, g), T[g] = f, N))
            for (m in s)
              D[m] || l(D, m, s[m], !0);
        }
      }, function(t, n) {
      }, function(t, n) {
        t.exports = function(i, s, o, l, a, c) {
          var T, u = i = i || {}, d = typeof i.default;
          d !== "object" && d !== "function" || (T = i, u = i.default);
          var A = typeof u == "function" ? u.options : u;
          s && (A.render = s.render, A.staticRenderFns = s.staticRenderFns, A._compiled = !0), o && (A.functional = !0), a && (A._scopeId = a);
          var f;
          if (c ? (f = function(p) {
            p = p || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, p || typeof __VUE_SSR_CONTEXT__ > "u" || (p = __VUE_SSR_CONTEXT__), l && l.call(this, p), p && p._registeredComponents && p._registeredComponents.add(c);
          }, A._ssrRegister = f) : l && (f = l), f) {
            var h = A.functional, S = h ? A.render : A.beforeCreate;
            h ? (A._injectStyles = f, A.render = function(p, m) {
              return f.call(m), S(p, m);
            }) : A.beforeCreate = S ? [].concat(S, f) : [f];
          }
          return { esModule: T, exports: u, options: A };
        };
      }, function(t, n, i) {
        var s = function() {
          var a = this, c = a.$createElement, T = a._self._c || c;
          return T("div", { staticClass: "multiselect", class: { "multiselect--active": a.isOpen, "multiselect--disabled": a.disabled, "multiselect--above": a.isAbove }, attrs: { tabindex: a.searchable ? -1 : a.tabindex }, on: { focus: function(u) {
            a.activate();
          }, blur: function(u) {
            !a.searchable && a.deactivate();
          }, keydown: [function(u) {
            return "button" in u || !a._k(u.keyCode, "down", 40, u.key, ["Down", "ArrowDown"]) ? u.target !== u.currentTarget ? null : (u.preventDefault(), void a.pointerForward()) : null;
          }, function(u) {
            return "button" in u || !a._k(u.keyCode, "up", 38, u.key, ["Up", "ArrowUp"]) ? u.target !== u.currentTarget ? null : (u.preventDefault(), void a.pointerBackward()) : null;
          }], keypress: function(u) {
            return "button" in u || !a._k(u.keyCode, "enter", 13, u.key, "Enter") || !a._k(u.keyCode, "tab", 9, u.key, "Tab") ? (u.stopPropagation(), u.target !== u.currentTarget ? null : void a.addPointerElement(u)) : null;
          }, keyup: function(u) {
            if (!("button" in u) && a._k(u.keyCode, "esc", 27, u.key, "Escape"))
              return null;
            a.deactivate();
          } } }, [a._t("caret", [T("div", { staticClass: "multiselect__select", on: { mousedown: function(u) {
            u.preventDefault(), u.stopPropagation(), a.toggle();
          } } })], { toggle: a.toggle }), a._v(" "), a._t("clear", null, { search: a.search }), a._v(" "), T("div", { ref: "tags", staticClass: "multiselect__tags" }, [a._t("selection", [T("div", { directives: [{ name: "show", rawName: "v-show", value: a.visibleValues.length > 0, expression: "visibleValues.length > 0" }], staticClass: "multiselect__tags-wrap" }, [a._l(a.visibleValues, function(u, d) {
            return [a._t("tag", [T("span", { key: d, staticClass: "multiselect__tag" }, [T("span", { domProps: { textContent: a._s(a.getOptionLabel(u)) } }), a._v(" "), T("i", { staticClass: "multiselect__tag-icon", attrs: { "aria-hidden": "true", tabindex: "1" }, on: { keypress: function(A) {
              if (!("button" in A) && a._k(A.keyCode, "enter", 13, A.key, "Enter"))
                return null;
              A.preventDefault(), a.removeElement(u);
            }, mousedown: function(A) {
              A.preventDefault(), a.removeElement(u);
            } } })])], { option: u, search: a.search, remove: a.removeElement })];
          })], 2), a._v(" "), a.internalValue && a.internalValue.length > a.limit ? [a._t("limit", [T("strong", { staticClass: "multiselect__strong", domProps: { textContent: a._s(a.limitText(a.internalValue.length - a.limit)) } })])] : a._e()], { search: a.search, remove: a.removeElement, values: a.visibleValues, isOpen: a.isOpen }), a._v(" "), T("transition", { attrs: { name: "multiselect__loading" } }, [a._t("loading", [T("div", { directives: [{ name: "show", rawName: "v-show", value: a.loading, expression: "loading" }], staticClass: "multiselect__spinner" })])], 2), a._v(" "), a.searchable ? T("input", { ref: "search", staticClass: "multiselect__input", style: a.inputStyle, attrs: { name: a.name, id: a.id, type: "text", autocomplete: "nope", placeholder: a.placeholder, disabled: a.disabled, tabindex: a.tabindex }, domProps: { value: a.search }, on: { input: function(u) {
            a.updateSearch(u.target.value);
          }, focus: function(u) {
            u.preventDefault(), a.activate();
          }, blur: function(u) {
            u.preventDefault(), a.deactivate();
          }, keyup: function(u) {
            if (!("button" in u) && a._k(u.keyCode, "esc", 27, u.key, "Escape"))
              return null;
            a.deactivate();
          }, keydown: [function(u) {
            if (!("button" in u) && a._k(u.keyCode, "down", 40, u.key, ["Down", "ArrowDown"]))
              return null;
            u.preventDefault(), a.pointerForward();
          }, function(u) {
            if (!("button" in u) && a._k(u.keyCode, "up", 38, u.key, ["Up", "ArrowUp"]))
              return null;
            u.preventDefault(), a.pointerBackward();
          }, function(u) {
            if (!("button" in u) && a._k(u.keyCode, "delete", [8, 46], u.key, ["Backspace", "Delete"]))
              return null;
            u.stopPropagation(), a.removeLastElement();
          }], keypress: function(u) {
            return "button" in u || !a._k(u.keyCode, "enter", 13, u.key, "Enter") ? (u.preventDefault(), u.stopPropagation(), u.target !== u.currentTarget ? null : void a.addPointerElement(u)) : null;
          } } }) : a._e(), a._v(" "), a.isSingleLabelVisible ? T("span", { staticClass: "multiselect__single", on: { mousedown: function(u) {
            return u.preventDefault(), a.toggle(u);
          } } }, [a._t("singleLabel", [[a._v(a._s(a.currentOptionLabel))]], { option: a.singleValue })], 2) : a._e(), a._v(" "), a.isPlaceholderVisible ? T("span", { staticClass: "multiselect__placeholder", on: { mousedown: function(u) {
            return u.preventDefault(), a.toggle(u);
          } } }, [a._t("placeholder", [a._v(`
          ` + a._s(a.placeholder) + `
        `)])], 2) : a._e()], 2), a._v(" "), T("transition", { attrs: { name: "multiselect" } }, [T("div", { directives: [{ name: "show", rawName: "v-show", value: a.isOpen, expression: "isOpen" }], ref: "list", staticClass: "multiselect__content-wrapper", style: { maxHeight: a.optimizedHeight + "px" }, attrs: { tabindex: "-1" }, on: { focus: a.activate, mousedown: function(u) {
            u.preventDefault();
          } } }, [T("ul", { staticClass: "multiselect__content", style: a.contentStyle }, [a._t("beforeList"), a._v(" "), a.multiple && a.max === a.internalValue.length ? T("li", [T("span", { staticClass: "multiselect__option" }, [a._t("maxElements", [a._v("Maximum of " + a._s(a.max) + " options selected. First remove a selected option to select another.")])], 2)]) : a._e(), a._v(" "), !a.max || a.internalValue.length < a.max ? a._l(a.filteredOptions, function(u, d) {
            return T("li", { key: d, staticClass: "multiselect__element" }, [u && (u.$isLabel || u.$isDisabled) ? a._e() : T("span", { staticClass: "multiselect__option", class: a.optionHighlight(d, u), attrs: { "data-select": u && u.isTag ? a.tagPlaceholder : a.selectLabelText, "data-selected": a.selectedLabelText, "data-deselect": a.deselectLabelText }, on: { click: function(A) {
              A.stopPropagation(), a.select(u);
            }, mouseenter: function(A) {
              if (A.target !== A.currentTarget)
                return null;
              a.pointerSet(d);
            } } }, [a._t("option", [T("span", [a._v(a._s(a.getOptionLabel(u)))])], { option: u, search: a.search })], 2), a._v(" "), u && (u.$isLabel || u.$isDisabled) ? T("span", { staticClass: "multiselect__option", class: a.groupHighlight(d, u), attrs: { "data-select": a.groupSelect && a.selectGroupLabelText, "data-deselect": a.groupSelect && a.deselectGroupLabelText }, on: { mouseenter: function(A) {
              if (A.target !== A.currentTarget)
                return null;
              a.groupSelect && a.pointerSet(d);
            }, mousedown: function(A) {
              A.preventDefault(), a.selectGroup(u);
            } } }, [a._t("option", [T("span", [a._v(a._s(a.getOptionLabel(u)))])], { option: u, search: a.search })], 2) : a._e()]);
          }) : a._e(), a._v(" "), T("li", { directives: [{ name: "show", rawName: "v-show", value: a.showNoResults && a.filteredOptions.length === 0 && a.search && !a.loading, expression: "showNoResults && (filteredOptions.length === 0 && search && !loading)" }] }, [T("span", { staticClass: "multiselect__option" }, [a._t("noResult", [a._v("No elements found. Consider changing the search query.")], { search: a.search })], 2)]), a._v(" "), T("li", { directives: [{ name: "show", rawName: "v-show", value: a.showNoOptions && a.options.length === 0 && !a.search && !a.loading, expression: "showNoOptions && (options.length === 0 && !search && !loading)" }] }, [T("span", { staticClass: "multiselect__option" }, [a._t("noOptions", [a._v("List is empty.")])], 2)]), a._v(" "), a._t("afterList")], 2)])])], 2);
        }, o = [], l = { render: s, staticRenderFns: o };
        n.a = l;
      }]);
    });
  }(wE)), Gi;
}
var ge = {}, LE = {
  get exports() {
    return ge;
  },
  set exports(r) {
    ge = r;
  }
};
(function(r) {
  var e;
  (function() {
    e = r.exports;
  })(), e.foldLength = 75, e.newLineChar = `\r
`, e.helpers = {
    /**
     * Compiles a list of all referenced TZIDs in all subcomponents and
     * removes any extra VTIMEZONE subcomponents. In addition, if any TZIDs
     * are referenced by a component, but a VTIMEZONE does not exist,
     * an attempt will be made to generate a VTIMEZONE using ICAL.TimezoneService.
     *
     * @param {ICAL.Component} vcal     The top-level VCALENDAR component.
     * @return {ICAL.Component}         The ICAL.Component that was passed in.
     */
    updateTimezones: function(t) {
      var n, i, s, o, l, a;
      if (!t || t.name !== "vcalendar")
        return t;
      for (n = t.getAllSubcomponents(), i = [], s = {}, l = 0; l < n.length; l++)
        n[l].name === "vtimezone" ? (a = n[l].getFirstProperty("tzid").getFirstValue(), s[a] = n[l]) : i = i.concat(n[l].getAllProperties());
      for (o = {}, l = 0; l < i.length; l++)
        (a = i[l].getParameter("tzid")) && (o[a] = !0);
      for (l in s)
        s.hasOwnProperty(l) && !o[l] && t.removeSubcomponent(s[l]);
      for (l in o)
        o.hasOwnProperty(l) && !s[l] && e.TimezoneService.has(l) && t.addSubcomponent(e.TimezoneService.get(l).component);
      return t;
    },
    /**
     * Checks if the given type is of the number type and also NaN.
     *
     * @param {Number} number     The number to check
     * @return {Boolean}          True, if the number is strictly NaN
     */
    isStrictlyNaN: function(t) {
      return typeof t == "number" && isNaN(t);
    },
    /**
     * Parses a string value that is expected to be an integer, when the valid is
     * not an integer throws a decoration error.
     *
     * @param {String} string     Raw string input
     * @return {Number}           Parsed integer
     */
    strictParseInt: function(t) {
      var n = parseInt(t, 10);
      if (e.helpers.isStrictlyNaN(n))
        throw new Error(
          'Could not extract integer from "' + t + '"'
        );
      return n;
    },
    /**
     * Creates or returns a class instance of a given type with the initialization
     * data if the data is not already an instance of the given type.
     *
     * @example
     * var time = new ICAL.Time(...);
     * var result = ICAL.helpers.formatClassType(time, ICAL.Time);
     *
     * (result instanceof ICAL.Time)
     * // => true
     *
     * result = ICAL.helpers.formatClassType({}, ICAL.Time);
     * (result isntanceof ICAL.Time)
     * // => true
     *
     *
     * @param {Object} data       object initialization data
     * @param {Object} type       object type (like ICAL.Time)
     * @return {?}                An instance of the found type.
     */
    formatClassType: function(n, i) {
      if (!(typeof n > "u"))
        return n instanceof i ? n : new i(n);
    },
    /**
     * Identical to indexOf but will only match values when they are not preceded
     * by a backslash character.
     *
     * @param {String} buffer         String to search
     * @param {String} search         Value to look for
     * @param {Number} pos            Start position
     * @return {Number}               The position, or -1 if not found
     */
    unescapedIndexOf: function(t, n, i) {
      for (; (i = t.indexOf(n, i)) !== -1; )
        if (i > 0 && t[i - 1] === "\\")
          i += 1;
        else
          return i;
      return -1;
    },
    /**
     * Find the index for insertion using binary search.
     *
     * @param {Array} list            The list to search
     * @param {?} seekVal             The value to insert
     * @param {function(?,?)} cmpfunc The comparison func, that can
     *                                  compare two seekVals
     * @return {Number}               The insert position
     */
    binsearchInsert: function(t, n, i) {
      if (!t.length)
        return 0;
      for (var s = 0, o = t.length - 1, l, a; s <= o; )
        if (l = s + Math.floor((o - s) / 2), a = i(n, t[l]), a < 0)
          o = l - 1;
        else if (a > 0)
          s = l + 1;
        else
          break;
      return a < 0 ? l : a > 0 ? l + 1 : l;
    },
    /**
     * Convenience function for debug output
     * @private
     */
    dumpn: (
      /* istanbul ignore next */
      function() {
        e.debug && (typeof console < "u" && "log" in console ? e.helpers.dumpn = function(n) {
          console.log(n);
        } : e.helpers.dumpn = function(n) {
          dump(n + `
`);
        }, e.helpers.dumpn(arguments[0]));
      }
    ),
    /**
     * Clone the passed object or primitive. By default a shallow clone will be
     * executed.
     *
     * @param {*} aSrc            The thing to clone
     * @param {Boolean=} aDeep    If true, a deep clone will be performed
     * @return {*}                The copy of the thing
     */
    clone: function(t, n) {
      if (!t || typeof t != "object")
        return t;
      if (t instanceof Date)
        return new Date(t.getTime());
      if ("clone" in t)
        return t.clone();
      if (Array.isArray(t)) {
        for (var i = [], s = 0; s < t.length; s++)
          i.push(n ? e.helpers.clone(t[s], !0) : t[s]);
        return i;
      } else {
        var o = {};
        for (var l in t)
          Object.prototype.hasOwnProperty.call(t, l) && (n ? o[l] = e.helpers.clone(t[l], !0) : o[l] = t[l]);
        return o;
      }
    },
    /**
     * Performs iCalendar line folding. A line ending character is inserted and
     * the next line begins with a whitespace.
     *
     * @example
     * SUMMARY:This line will be fold
     *  ed right in the middle of a word.
     *
     * @param {String} aLine      The line to fold
     * @return {String}           The folded line
     */
    foldline: function(n) {
      for (var i = "", s = n || "", o = 0, l = 0; s.length; ) {
        var a = s.codePointAt(o);
        a < 128 ? ++l : a < 2048 ? l += 2 : a < 65536 ? l += 3 : l += 4, l < e.foldLength + 1 ? o += a > 65535 ? 2 : 1 : (i += e.newLineChar + " " + s.substring(0, o), s = s.substring(o), o = l = 0);
      }
      return i.substr(e.newLineChar.length + 1);
    },
    /**
     * Pads the given string or number with zeros so it will have at least two
     * characters.
     *
     * @param {String|Number} data    The string or number to pad
     * @return {String}               The number padded as a string
     */
    pad2: function(n) {
      typeof n != "string" && (typeof n == "number" && (n = parseInt(n)), n = String(n));
      var i = n.length;
      switch (i) {
        case 0:
          return "00";
        case 1:
          return "0" + n;
        default:
          return n;
      }
    },
    /**
     * Truncates the given number, correctly handling negative numbers.
     *
     * @param {Number} number     The number to truncate
     * @return {Number}           The truncated number
     */
    trunc: function(n) {
      return n < 0 ? Math.ceil(n) : Math.floor(n);
    },
    /**
     * Poor-man's cross-browser inheritance for JavaScript. Doesn't support all
     * the features, but enough for our usage.
     *
     * @param {Function} base     The base class constructor function.
     * @param {Function} child    The child class constructor function.
     * @param {Object} extra      Extends the prototype with extra properties
     *                              and methods
     */
    inherits: function(t, n, i) {
      function s() {
      }
      s.prototype = t.prototype, n.prototype = new s(), i && e.helpers.extend(i, n.prototype);
    },
    /**
     * Poor-man's cross-browser object extension. Doesn't support all the
     * features, but enough for our usage. Note that the target's properties are
     * not overwritten with the source properties.
     *
     * @example
     * var child = ICAL.helpers.extend(parent, {
     *   "bar": 123
     * });
     *
     * @param {Object} source     The object to extend
     * @param {Object} target     The object to extend with
     * @return {Object}           Returns the target.
     */
    extend: function(t, n) {
      for (var i in t) {
        var s = Object.getOwnPropertyDescriptor(t, i);
        s && !Object.getOwnPropertyDescriptor(n, i) && Object.defineProperty(n, i, s);
      }
      return n;
    }
  }, e.design = function() {
    var t = /\\\\|\\;|\\,|\\[Nn]/g, n = /\\|;|,|\n/g, i = /\\\\|\\,|\\[Nn]/g, s = /\\|,|\n/g;
    function o(E, C) {
      var P = {
        matches: /.*/,
        fromICAL: function(M, Q) {
          return m(M, E, Q);
        },
        toICAL: function(M, Q) {
          var H = C;
          return Q && (H = new RegExp(H.source + "|" + Q)), M.replace(H, function(re) {
            switch (re) {
              case "\\":
                return "\\\\";
              case ";":
                return "\\;";
              case ",":
                return "\\,";
              case `
`:
                return "\\n";
              default:
                return re;
            }
          });
        }
      };
      return P;
    }
    var l = { defaultType: "text" }, a = { defaultType: "text", multiValue: "," }, c = { defaultType: "text", structuredValue: ";" }, T = { defaultType: "integer" }, u = { defaultType: "date-time", allowedTypes: ["date-time", "date"] }, d = { defaultType: "date-time" }, A = { defaultType: "uri" }, f = { defaultType: "utc-offset" }, h = { defaultType: "recur" }, S = { defaultType: "date-and-or-time", allowedTypes: ["date-time", "date", "text"] };
    function p(E) {
      switch (E) {
        case "\\\\":
          return "\\";
        case "\\;":
          return ";";
        case "\\,":
          return ",";
        case "\\n":
        case "\\N":
          return `
`;
        default:
          return E;
      }
    }
    function m(E, C, P) {
      return E.indexOf("\\") === -1 ? E : (P && (C = new RegExp(C.source + "|\\\\" + P)), E.replace(C, p));
    }
    var g = {
      categories: a,
      url: A,
      version: l,
      uid: l
    }, N = {
      boolean: {
        values: ["TRUE", "FALSE"],
        fromICAL: function(E) {
          switch (E) {
            case "TRUE":
              return !0;
            case "FALSE":
              return !1;
            default:
              return !1;
          }
        },
        toICAL: function(E) {
          return E ? "TRUE" : "FALSE";
        }
      },
      float: {
        matches: /^[+-]?\d+\.\d+$/,
        fromICAL: function(E) {
          var C = parseFloat(E);
          return e.helpers.isStrictlyNaN(C) ? 0 : C;
        },
        toICAL: function(E) {
          return String(E);
        }
      },
      integer: {
        fromICAL: function(E) {
          var C = parseInt(E);
          return e.helpers.isStrictlyNaN(C) ? 0 : C;
        },
        toICAL: function(E) {
          return String(E);
        }
      },
      "utc-offset": {
        toICAL: function(E) {
          return E.length < 7 ? E.substr(0, 3) + E.substr(4, 2) : E.substr(0, 3) + E.substr(4, 2) + E.substr(7, 2);
        },
        fromICAL: function(E) {
          return E.length < 6 ? E.substr(0, 3) + ":" + E.substr(3, 2) : E.substr(0, 3) + ":" + E.substr(3, 2) + ":" + E.substr(5, 2);
        },
        decorate: function(E) {
          return e.UtcOffset.fromString(E);
        },
        undecorate: function(E) {
          return E.toString();
        }
      }
    }, R = {
      // Although the syntax is DQUOTE uri DQUOTE, I don't think we should
      // enfoce anything aside from it being a valid content line.
      //
      // At least some params require - if multi values are used - DQUOTEs
      // for each of its values - e.g. delegated-from="uri1","uri2"
      // To indicate this, I introduced the new k/v pair
      // multiValueSeparateDQuote: true
      //
      // "ALTREP": { ... },
      // CN just wants a param-value
      // "CN": { ... }
      cutype: {
        values: ["INDIVIDUAL", "GROUP", "RESOURCE", "ROOM", "UNKNOWN"],
        allowXName: !0,
        allowIanaToken: !0
      },
      "delegated-from": {
        valueType: "cal-address",
        multiValue: ",",
        multiValueSeparateDQuote: !0
      },
      "delegated-to": {
        valueType: "cal-address",
        multiValue: ",",
        multiValueSeparateDQuote: !0
      },
      // "DIR": { ... }, // See ALTREP
      encoding: {
        values: ["8BIT", "BASE64"]
      },
      // "FMTTYPE": { ... }, // See ALTREP
      fbtype: {
        values: ["FREE", "BUSY", "BUSY-UNAVAILABLE", "BUSY-TENTATIVE"],
        allowXName: !0,
        allowIanaToken: !0
      },
      // "LANGUAGE": { ... }, // See ALTREP
      member: {
        valueType: "cal-address",
        multiValue: ",",
        multiValueSeparateDQuote: !0
      },
      partstat: {
        // TODO These values are actually different per-component
        values: [
          "NEEDS-ACTION",
          "ACCEPTED",
          "DECLINED",
          "TENTATIVE",
          "DELEGATED",
          "COMPLETED",
          "IN-PROCESS"
        ],
        allowXName: !0,
        allowIanaToken: !0
      },
      range: {
        values: ["THISANDFUTURE"]
      },
      related: {
        values: ["START", "END"]
      },
      reltype: {
        values: ["PARENT", "CHILD", "SIBLING"],
        allowXName: !0,
        allowIanaToken: !0
      },
      role: {
        values: [
          "REQ-PARTICIPANT",
          "CHAIR",
          "OPT-PARTICIPANT",
          "NON-PARTICIPANT"
        ],
        allowXName: !0,
        allowIanaToken: !0
      },
      rsvp: {
        values: ["TRUE", "FALSE"]
      },
      "sent-by": {
        valueType: "cal-address"
      },
      tzid: {
        matches: /^\//
      },
      value: {
        // since the value here is a 'type' lowercase is used.
        values: [
          "binary",
          "boolean",
          "cal-address",
          "date",
          "date-time",
          "duration",
          "float",
          "integer",
          "period",
          "recur",
          "text",
          "time",
          "uri",
          "utc-offset"
        ],
        allowXName: !0,
        allowIanaToken: !0
      }
    }, D = e.helpers.extend(N, {
      text: o(t, n),
      uri: {
        // TODO
        /* ... */
      },
      binary: {
        decorate: function(E) {
          return e.Binary.fromString(E);
        },
        undecorate: function(E) {
          return E.toString();
        }
      },
      "cal-address": {
        // needs to be an uri
      },
      date: {
        decorate: function(E, C) {
          return z.strict ? e.Time.fromDateString(E, C) : e.Time.fromString(E, C);
        },
        /**
         * undecorates a time object.
         */
        undecorate: function(E) {
          return E.toString();
        },
        fromICAL: function(E) {
          return !z.strict && E.length >= 15 ? D["date-time"].fromICAL(E) : E.substr(0, 4) + "-" + E.substr(4, 2) + "-" + E.substr(6, 2);
        },
        toICAL: function(E) {
          var C = E.length;
          return C == 10 ? E.substr(0, 4) + E.substr(5, 2) + E.substr(8, 2) : C >= 19 ? D["date-time"].toICAL(E) : E;
        }
      },
      "date-time": {
        fromICAL: function(E) {
          if (!z.strict && E.length == 8)
            return D.date.fromICAL(E);
          var C = E.substr(0, 4) + "-" + E.substr(4, 2) + "-" + E.substr(6, 2) + "T" + E.substr(9, 2) + ":" + E.substr(11, 2) + ":" + E.substr(13, 2);
          return E[15] && E[15] === "Z" && (C += "Z"), C;
        },
        toICAL: function(E) {
          var C = E.length;
          if (C == 10 && !z.strict)
            return D.date.toICAL(E);
          if (C >= 19) {
            var P = E.substr(0, 4) + E.substr(5, 2) + // grab the (DDTHH) segment
            E.substr(8, 5) + // MM
            E.substr(14, 2) + // SS
            E.substr(17, 2);
            return E[19] && E[19] === "Z" && (P += "Z"), P;
          } else
            return E;
        },
        decorate: function(E, C) {
          return z.strict ? e.Time.fromDateTimeString(E, C) : e.Time.fromString(E, C);
        },
        undecorate: function(E) {
          return E.toString();
        }
      },
      duration: {
        decorate: function(E) {
          return e.Duration.fromString(E);
        },
        undecorate: function(E) {
          return E.toString();
        }
      },
      period: {
        fromICAL: function(E) {
          var C = E.split("/");
          return C[0] = D["date-time"].fromICAL(C[0]), e.Duration.isValueString(C[1]) || (C[1] = D["date-time"].fromICAL(C[1])), C;
        },
        toICAL: function(E) {
          return !z.strict && E[0].length == 10 ? E[0] = D.date.toICAL(E[0]) : E[0] = D["date-time"].toICAL(E[0]), e.Duration.isValueString(E[1]) || (!z.strict && E[1].length == 10 ? E[1] = D.date.toICAL(E[1]) : E[1] = D["date-time"].toICAL(E[1])), E.join("/");
        },
        decorate: function(E, C) {
          return e.Period.fromJSON(E, C, !z.strict);
        },
        undecorate: function(E) {
          return E.toJSON();
        }
      },
      recur: {
        fromICAL: function(E) {
          return e.Recur._stringToData(E, !0);
        },
        toICAL: function(E) {
          var C = "";
          for (var P in E)
            if (Object.prototype.hasOwnProperty.call(E, P)) {
              var M = E[P];
              P == "until" ? M.length > 10 ? M = D["date-time"].toICAL(M) : M = D.date.toICAL(M) : P == "wkst" ? typeof M == "number" && (M = e.Recur.numericDayToIcalDay(M)) : Array.isArray(M) && (M = M.join(",")), C += P.toUpperCase() + "=" + M + ";";
            }
          return C.substr(0, C.length - 1);
        },
        decorate: function(C) {
          return e.Recur.fromData(C);
        },
        undecorate: function(E) {
          return E.toJSON();
        }
      },
      time: {
        fromICAL: function(E) {
          if (E.length < 6)
            return E;
          var C = E.substr(0, 2) + ":" + E.substr(2, 2) + ":" + E.substr(4, 2);
          return E[6] === "Z" && (C += "Z"), C;
        },
        toICAL: function(E) {
          if (E.length < 8)
            return E;
          var C = E.substr(0, 2) + E.substr(3, 2) + E.substr(6, 2);
          return E[8] === "Z" && (C += "Z"), C;
        }
      }
    }), v = e.helpers.extend(g, {
      action: l,
      attach: { defaultType: "uri" },
      attendee: { defaultType: "cal-address" },
      calscale: l,
      class: l,
      comment: l,
      completed: d,
      contact: l,
      created: d,
      description: l,
      dtend: u,
      dtstamp: d,
      dtstart: u,
      due: u,
      duration: { defaultType: "duration" },
      exdate: {
        defaultType: "date-time",
        allowedTypes: ["date-time", "date"],
        multiValue: ","
      },
      exrule: h,
      freebusy: { defaultType: "period", multiValue: "," },
      geo: { defaultType: "float", structuredValue: ";" },
      "last-modified": d,
      location: l,
      method: l,
      organizer: { defaultType: "cal-address" },
      "percent-complete": T,
      priority: T,
      prodid: l,
      "related-to": l,
      repeat: T,
      rdate: {
        defaultType: "date-time",
        allowedTypes: ["date-time", "date", "period"],
        multiValue: ",",
        detectType: function(E) {
          return E.indexOf("/") !== -1 ? "period" : E.indexOf("T") === -1 ? "date" : "date-time";
        }
      },
      "recurrence-id": u,
      resources: a,
      "request-status": c,
      rrule: h,
      sequence: T,
      status: l,
      summary: l,
      transp: l,
      trigger: { defaultType: "duration", allowedTypes: ["duration", "date-time"] },
      tzoffsetfrom: f,
      tzoffsetto: f,
      tzurl: A,
      tzid: l,
      tzname: l
    }), O = e.helpers.extend(N, {
      text: o(i, s),
      uri: o(i, s),
      date: {
        decorate: function(E) {
          return e.VCardTime.fromDateAndOrTimeString(E, "date");
        },
        undecorate: function(E) {
          return E.toString();
        },
        fromICAL: function(E) {
          return E.length == 8 ? D.date.fromICAL(E) : E[0] == "-" && E.length == 6 ? E.substr(0, 4) + "-" + E.substr(4) : E;
        },
        toICAL: function(E) {
          return E.length == 10 ? D.date.toICAL(E) : E[0] == "-" && E.length == 7 ? E.substr(0, 4) + E.substr(5) : E;
        }
      },
      time: {
        decorate: function(E) {
          return e.VCardTime.fromDateAndOrTimeString("T" + E, "time");
        },
        undecorate: function(E) {
          return E.toString();
        },
        fromICAL: function(E) {
          var C = O.time._splitZone(E, !0), P = C[0], M = C[1];
          return M.length == 6 ? M = M.substr(0, 2) + ":" + M.substr(2, 2) + ":" + M.substr(4, 2) : M.length == 4 && M[0] != "-" ? M = M.substr(0, 2) + ":" + M.substr(2, 2) : M.length == 5 && (M = M.substr(0, 3) + ":" + M.substr(3, 2)), P.length == 5 && (P[0] == "-" || P[0] == "+") && (P = P.substr(0, 3) + ":" + P.substr(3)), M + P;
        },
        toICAL: function(E) {
          var C = O.time._splitZone(E), P = C[0], M = C[1];
          return M.length == 8 ? M = M.substr(0, 2) + M.substr(3, 2) + M.substr(6, 2) : M.length == 5 && M[0] != "-" ? M = M.substr(0, 2) + M.substr(3, 2) : M.length == 6 && (M = M.substr(0, 3) + M.substr(4, 2)), P.length == 6 && (P[0] == "-" || P[0] == "+") && (P = P.substr(0, 3) + P.substr(4)), M + P;
        },
        _splitZone: function(E, C) {
          var P = E.length - 1, M = E.length - (C ? 5 : 6), Q = E[M], H, re;
          return E[P] == "Z" ? (H = E[P], re = E.substr(0, P)) : E.length > 6 && (Q == "-" || Q == "+") ? (H = E.substr(M), re = E.substr(0, M)) : (H = "", re = E), [H, re];
        }
      },
      "date-time": {
        decorate: function(E) {
          return e.VCardTime.fromDateAndOrTimeString(E, "date-time");
        },
        undecorate: function(E) {
          return E.toString();
        },
        fromICAL: function(E) {
          return O["date-and-or-time"].fromICAL(E);
        },
        toICAL: function(E) {
          return O["date-and-or-time"].toICAL(E);
        }
      },
      "date-and-or-time": {
        decorate: function(E) {
          return e.VCardTime.fromDateAndOrTimeString(E, "date-and-or-time");
        },
        undecorate: function(E) {
          return E.toString();
        },
        fromICAL: function(E) {
          var C = E.split("T");
          return (C[0] ? O.date.fromICAL(C[0]) : "") + (C[1] ? "T" + O.time.fromICAL(C[1]) : "");
        },
        toICAL: function(E) {
          var C = E.split("T");
          return O.date.toICAL(C[0]) + (C[1] ? "T" + O.time.toICAL(C[1]) : "");
        }
      },
      timestamp: D["date-time"],
      "language-tag": {
        matches: /^[a-zA-Z0-9-]+$/
        // Could go with a more strict regex here
      }
    }), y = {
      type: {
        valueType: "text",
        multiValue: ","
      },
      value: {
        // since the value here is a 'type' lowercase is used.
        values: [
          "text",
          "uri",
          "date",
          "time",
          "date-time",
          "date-and-or-time",
          "timestamp",
          "boolean",
          "integer",
          "float",
          "utc-offset",
          "language-tag"
        ],
        allowXName: !0,
        allowIanaToken: !0
      }
    }, Z = e.helpers.extend(g, {
      adr: { defaultType: "text", structuredValue: ";", multiValue: "," },
      anniversary: S,
      bday: S,
      caladruri: A,
      caluri: A,
      clientpidmap: c,
      email: l,
      fburl: A,
      fn: l,
      gender: c,
      geo: A,
      impp: A,
      key: A,
      kind: l,
      lang: { defaultType: "language-tag" },
      logo: A,
      member: A,
      n: { defaultType: "text", structuredValue: ";", multiValue: "," },
      nickname: a,
      note: l,
      org: { defaultType: "text", structuredValue: ";" },
      photo: A,
      related: A,
      rev: { defaultType: "timestamp" },
      role: l,
      sound: A,
      source: A,
      tel: { defaultType: "uri", allowedTypes: ["uri", "text"] },
      title: l,
      tz: { defaultType: "text", allowedTypes: ["text", "utc-offset", "uri"] },
      xml: l
    }), F = e.helpers.extend(N, {
      binary: D.binary,
      date: O.date,
      "date-time": O["date-time"],
      "phone-number": {
        // TODO
        /* ... */
      },
      uri: D.uri,
      text: D.text,
      time: D.time,
      vcard: D.text,
      "utc-offset": {
        toICAL: function(E) {
          return E.substr(0, 7);
        },
        fromICAL: function(E) {
          return E.substr(0, 7);
        },
        decorate: function(E) {
          return e.UtcOffset.fromString(E);
        },
        undecorate: function(E) {
          return E.toString();
        }
      }
    }), b = {
      type: {
        valueType: "text",
        multiValue: ","
      },
      value: {
        // since the value here is a 'type' lowercase is used.
        values: [
          "text",
          "uri",
          "date",
          "date-time",
          "phone-number",
          "time",
          "boolean",
          "integer",
          "float",
          "utc-offset",
          "vcard",
          "binary"
        ],
        allowXName: !0,
        allowIanaToken: !0
      }
    }, Y = e.helpers.extend(g, {
      fn: l,
      n: { defaultType: "text", structuredValue: ";", multiValue: "," },
      nickname: a,
      photo: { defaultType: "binary", allowedTypes: ["binary", "uri"] },
      bday: {
        defaultType: "date-time",
        allowedTypes: ["date-time", "date"],
        detectType: function(E) {
          return E.indexOf("T") === -1 ? "date" : "date-time";
        }
      },
      adr: { defaultType: "text", structuredValue: ";", multiValue: "," },
      label: l,
      tel: { defaultType: "phone-number" },
      email: l,
      mailer: l,
      tz: { defaultType: "utc-offset", allowedTypes: ["utc-offset", "text"] },
      geo: { defaultType: "float", structuredValue: ";" },
      title: l,
      role: l,
      logo: { defaultType: "binary", allowedTypes: ["binary", "uri"] },
      agent: { defaultType: "vcard", allowedTypes: ["vcard", "text", "uri"] },
      org: c,
      note: a,
      prodid: l,
      rev: {
        defaultType: "date-time",
        allowedTypes: ["date-time", "date"],
        detectType: function(E) {
          return E.indexOf("T") === -1 ? "date" : "date-time";
        }
      },
      "sort-string": l,
      sound: { defaultType: "binary", allowedTypes: ["binary", "uri"] },
      class: l,
      key: { defaultType: "binary", allowedTypes: ["binary", "text"] }
    }), I = {
      value: D,
      param: R,
      property: v
    }, q = {
      value: O,
      param: y,
      property: Z
    }, _ = {
      value: F,
      param: b,
      property: Y
    }, z = {
      /**
       * A designSet describes value, parameter and property data. It is used by
       * ther parser and stringifier in components and properties to determine they
       * should be represented.
       *
       * @typedef {Object} designSet
       * @memberOf ICAL.design
       * @property {Object} value       Definitions for value types, keys are type names
       * @property {Object} param       Definitions for params, keys are param names
       * @property {Object} property    Defintions for properties, keys are property names
       */
      /**
       * Can be set to false to make the parser more lenient.
       */
      strict: !0,
      /**
       * The default set for new properties and components if none is specified.
       * @type {ICAL.design.designSet}
       */
      defaultSet: I,
      /**
       * The default type for unknown properties
       * @type {String}
       */
      defaultType: "unknown",
      /**
       * Holds the design set for known top-level components
       *
       * @type {Object}
       * @property {ICAL.design.designSet} vcard       vCard VCARD
       * @property {ICAL.design.designSet} vevent      iCalendar VEVENT
       * @property {ICAL.design.designSet} vtodo       iCalendar VTODO
       * @property {ICAL.design.designSet} vjournal    iCalendar VJOURNAL
       * @property {ICAL.design.designSet} valarm      iCalendar VALARM
       * @property {ICAL.design.designSet} vtimezone   iCalendar VTIMEZONE
       * @property {ICAL.design.designSet} daylight    iCalendar DAYLIGHT
       * @property {ICAL.design.designSet} standard    iCalendar STANDARD
       *
       * @example
       * var propertyName = 'fn';
       * var componentDesign = ICAL.design.components.vcard;
       * var propertyDetails = componentDesign.property[propertyName];
       * if (propertyDetails.defaultType == 'text') {
       *   // Yep, sure is...
       * }
       */
      components: {
        vcard: q,
        vcard3: _,
        vevent: I,
        vtodo: I,
        vjournal: I,
        valarm: I,
        vtimezone: I,
        daylight: I,
        standard: I
      },
      /**
       * The design set for iCalendar (rfc5545/rfc7265) components.
       * @type {ICAL.design.designSet}
       */
      icalendar: I,
      /**
       * The design set for vCard (rfc6350/rfc7095) components.
       * @type {ICAL.design.designSet}
       */
      vcard: q,
      /**
       * The design set for vCard (rfc2425/rfc2426/rfc7095) components.
       * @type {ICAL.design.designSet}
       */
      vcard3: _,
      /**
       * Gets the design set for the given component name.
       *
       * @param {String} componentName        The name of the component
       * @return {ICAL.design.designSet}      The design set for the component
       */
      getDesignSet: function(E) {
        var C = E && E in z.components;
        return C ? z.components[E] : z.defaultSet;
      }
    };
    return z;
  }(), e.stringify = function() {
    var t = `\r
`, n = "unknown", i = e.design, s = e.helpers;
    function o(a) {
      typeof a[0] == "string" && (a = [a]);
      for (var c = 0, T = a.length, u = ""; c < T; c++)
        u += o.component(a[c]) + t;
      return u;
    }
    o.component = function(a, c) {
      var T = a[0].toUpperCase(), u = "BEGIN:" + T + t, d = a[1], A = 0, f = d.length, h = a[0];
      for (h === "vcard" && a[1].length > 0 && !(a[1][0][0] === "version" && a[1][0][3] === "4.0") && (h = "vcard3"), c = c || i.getDesignSet(h); A < f; A++)
        u += o.property(d[A], c) + t;
      for (var S = a[2] || [], p = 0, m = S.length; p < m; p++)
        u += o.component(S[p], c) + t;
      return u += "END:" + T, u;
    }, o.property = function(a, c, T) {
      var u = a[0].toUpperCase(), d = a[0], A = a[1], f = u, h;
      for (h in A) {
        var S = A[h];
        if (A.hasOwnProperty(h)) {
          var g = h in c.param && c.param[h].multiValue;
          g && Array.isArray(S) ? (c.param[h].multiValueSeparateDQuote && (g = '"' + g + '"'), S = S.map(o._rfc6868Unescape), S = o.multiValue(S, g, "unknown", null, c)) : S = o._rfc6868Unescape(S), f += ";" + h.toUpperCase(), f += "=" + o.propertyValue(S);
        }
      }
      if (a.length === 3)
        return f + ":";
      var p = a[2];
      c || (c = i.defaultSet);
      var m, g = !1, N = !1, R = !1;
      return d in c.property ? (m = c.property[d], "multiValue" in m && (g = m.multiValue), "structuredValue" in m && Array.isArray(a[3]) && (N = m.structuredValue), "defaultType" in m ? p === m.defaultType && (R = !0) : p === n && (R = !0)) : p === n && (R = !0), R || (f += ";VALUE=" + p.toUpperCase()), f += ":", g && N ? f += o.multiValue(
        a[3],
        N,
        p,
        g,
        c,
        N
      ) : g ? f += o.multiValue(
        a.slice(3),
        g,
        p,
        null,
        c,
        !1
      ) : N ? f += o.multiValue(
        a[3],
        N,
        p,
        null,
        c,
        N
      ) : f += o.value(a[3], p, c, !1), T ? f : e.helpers.foldline(f);
    }, o.propertyValue = function(a) {
      return s.unescapedIndexOf(a, ",") === -1 && s.unescapedIndexOf(a, ":") === -1 && s.unescapedIndexOf(a, ";") === -1 ? a : '"' + a + '"';
    }, o.multiValue = function(a, c, T, u, d, A) {
      for (var f = "", h = a.length, S = 0; S < h; S++)
        u && Array.isArray(a[S]) ? f += o.multiValue(a[S], u, T, null, d, A) : f += o.value(a[S], T, d, A), S !== h - 1 && (f += c);
      return f;
    }, o.value = function(a, c, T, u) {
      return c in T.value && "toICAL" in T.value[c] ? T.value[c].toICAL(a, u) : a;
    }, o._rfc6868Unescape = function(a) {
      return a.replace(/[\n^"]/g, function(c) {
        return l[c];
      });
    };
    var l = { '"': "^'", "\n": "^n", "^": "^^" };
    return o;
  }(), e.parse = function() {
    var t = /[^ \t]/, n = ":", i = ";", s = "=", o = "unknown", l = "text", a = e.design, c = e.helpers;
    function T(A) {
      this.message = A, this.name = "ParserError";
      try {
        throw new Error();
      } catch (h) {
        if (h.stack) {
          var f = h.stack.split(`
`);
          f.shift(), this.stack = f.join(`
`);
        }
      }
    }
    T.prototype = Error.prototype;
    function u(A) {
      var f = {}, h = f.component = [];
      if (f.stack = [h], u._eachLine(A, function(S, p) {
        u._handleContentLine(p, f);
      }), f.stack.length > 1)
        throw new T(
          "invalid ical body. component began but did not end"
        );
      return f = null, h.length == 1 ? h[0] : h;
    }
    u.property = function(A, f) {
      var h = {
        component: [[], []],
        designSet: f || a.defaultSet
      };
      return u._handleContentLine(A, h), h.component[1][0];
    }, u.component = function(A) {
      return u(A);
    }, u.ParserError = T, u._handleContentLine = function(A, f) {
      var h = A.indexOf(n), S = A.indexOf(i), p, m, g, N, R = {};
      S !== -1 && h !== -1 && S > h && (S = -1);
      var D;
      if (S !== -1) {
        if (g = A.substring(0, S).toLowerCase(), D = u._parseParameters(A.substring(S), 0, f.designSet), D[2] == -1)
          throw new T("Invalid parameters in '" + A + "'");
        if (R = D[0], p = D[1].length + D[2] + S, (m = A.substring(p).indexOf(n)) !== -1)
          N = A.substring(p + m + 1);
        else
          throw new T("Missing parameter value in '" + A + "'");
      } else if (h !== -1) {
        if (g = A.substring(0, h).toLowerCase(), N = A.substring(h + 1), g === "begin") {
          var v = [N.toLowerCase(), [], []];
          f.stack.length === 1 ? f.component.push(v) : f.component[2].push(v), f.stack.push(f.component), f.component = v, f.designSet || (f.designSet = a.getDesignSet(f.component[0]));
          return;
        } else if (g === "end") {
          f.component = f.stack.pop();
          return;
        }
      } else
        throw new T(
          'invalid line (no token ";" or ":") "' + A + '"'
        );
      var O, y = !1, Z = !1, F;
      g in f.designSet.property && (F = f.designSet.property[g], "multiValue" in F && (y = F.multiValue), "structuredValue" in F && (Z = F.structuredValue), N && "detectType" in F && (O = F.detectType(N))), O || ("value" in R ? O = R.value.toLowerCase() : F ? O = F.defaultType : O = o), delete R.value;
      var b;
      y && Z ? (N = u._parseMultiValue(N, Z, O, [], y, f.designSet, Z), b = [g, R, O, N]) : y ? (b = [g, R, O], u._parseMultiValue(N, y, O, b, null, f.designSet, !1)) : Z ? (N = u._parseMultiValue(N, Z, O, [], null, f.designSet, Z), b = [g, R, O, N]) : (N = u._parseValue(N, O, f.designSet, !1), b = [g, R, O, N]), f.component[0] === "vcard" && f.component[1].length === 0 && !(g === "version" && N === "4.0") && (f.designSet = a.getDesignSet("vcard3")), f.component[1].push(b);
    }, u._parseValue = function(A, f, h, S) {
      return f in h.value && "fromICAL" in h.value[f] ? h.value[f].fromICAL(A, S) : A;
    }, u._parseParameters = function(A, f, h) {
      for (var S = f, p = 0, m = s, g = {}, N, R, D, v = -1, O, y, Z; p !== !1 && (p = c.unescapedIndexOf(A, m, p + 1)) !== -1; ) {
        if (N = A.substr(S + 1, p - S - 1), N.length == 0)
          throw new T("Empty parameter name in '" + A + "'");
        R = N.toLowerCase(), Z = !1, y = !1, R in h.param && h.param[R].valueType ? O = h.param[R].valueType : O = l, R in h.param && (y = h.param[R].multiValue, h.param[R].multiValueSeparateDQuote && (Z = u._rfc6868Escape('"' + y + '"')));
        var F = A[p + 1];
        if (F === '"') {
          if (v = p + 2, p = c.unescapedIndexOf(A, '"', v), y && p != -1)
            for (var b = !0; b; )
              A[p + 1] == y && A[p + 2] == '"' ? p = c.unescapedIndexOf(A, '"', p + 3) : b = !1;
          if (p === -1)
            throw new T(
              'invalid line (no matching double quote) "' + A + '"'
            );
          D = A.substr(v, p - v), S = c.unescapedIndexOf(A, i, p), S === -1 && (p = !1);
        } else {
          v = p + 1;
          var Y = c.unescapedIndexOf(A, i, v), I = c.unescapedIndexOf(A, n, v);
          I !== -1 && Y > I ? (Y = I, p = !1) : Y === -1 ? (I === -1 ? Y = A.length : Y = I, p = !1) : (S = Y, p = Y), D = A.substr(v, Y - v);
        }
        if (D = u._rfc6868Escape(D), y) {
          var q = Z || y;
          D = u._parseMultiValue(D, q, O, [], null, h);
        } else
          D = u._parseValue(D, O, h);
        y && R in g ? Array.isArray(g[R]) ? g[R].push(D) : g[R] = [
          g[R],
          D
        ] : g[R] = D;
      }
      return [g, D, v];
    }, u._rfc6868Escape = function(A) {
      return A.replace(/\^['n^]/g, function(f) {
        return d[f];
      });
    };
    var d = { "^'": '"', "^n": `
`, "^^": "^" };
    return u._parseMultiValue = function(A, f, h, S, p, m, g) {
      var N = 0, R = 0, D;
      if (f.length === 0)
        return A;
      for (; (N = c.unescapedIndexOf(A, f, R)) !== -1; )
        D = A.substr(R, N - R), p ? D = u._parseMultiValue(D, p, h, [], null, m, g) : D = u._parseValue(D, h, m, g), S.push(D), R = N + f.length;
      return D = A.substr(R), p ? D = u._parseMultiValue(D, p, h, [], null, m, g) : D = u._parseValue(D, h, m, g), S.push(D), S.length == 1 ? S[0] : S;
    }, u._eachLine = function(A, f) {
      var h = A.length, S = A.search(t), p = S, m, g, N;
      do
        p = A.indexOf(`
`, S) + 1, p > 1 && A[p - 2] === "\r" ? N = 2 : N = 1, p === 0 && (p = h, N = 0), g = A[S], g === " " || g === "	" ? m += A.substr(
          S + 1,
          p - S - (N + 1)
        ) : (m && f(null, m), m = A.substr(
          S,
          p - S - N
        )), S = p;
      while (p !== h);
      m = m.trim(), m.length && f(null, m);
    }, u;
  }(), e.Component = function() {
    var t = 1, n = 2, i = 0;
    function s(o, l) {
      typeof o == "string" && (o = [o, [], []]), this.jCal = o, this.parent = l || null;
    }
    return s.prototype = {
      /**
       * Hydrated properties are inserted into the _properties array at the same
       * position as in the jCal array, so it is possible that the array contains
       * undefined values for unhydrdated properties. To avoid iterating the
       * array when checking if all properties have been hydrated, we save the
       * count here.
       *
       * @type {Number}
       * @private
       */
      _hydratedPropertyCount: 0,
      /**
       * The same count as for _hydratedPropertyCount, but for subcomponents
       *
       * @type {Number}
       * @private
       */
      _hydratedComponentCount: 0,
      /**
       * The name of this component
       * @readonly
       */
      get name() {
        return this.jCal[i];
      },
      /**
       * The design set for this component, e.g. icalendar vs vcard
       *
       * @type {ICAL.design.designSet}
       * @private
       */
      get _designSet() {
        var o = this.parent && this.parent._designSet;
        return o || e.design.getDesignSet(this.name);
      },
      _hydrateComponent: function(o) {
        if (this._components || (this._components = [], this._hydratedComponentCount = 0), this._components[o])
          return this._components[o];
        var l = new s(
          this.jCal[n][o],
          this
        );
        return this._hydratedComponentCount++, this._components[o] = l;
      },
      _hydrateProperty: function(o) {
        if (this._properties || (this._properties = [], this._hydratedPropertyCount = 0), this._properties[o])
          return this._properties[o];
        var l = new e.Property(
          this.jCal[t][o],
          this
        );
        return this._hydratedPropertyCount++, this._properties[o] = l;
      },
      /**
       * Finds first sub component, optionally filtered by name.
       *
       * @param {String=} name        Optional name to filter by
       * @return {?ICAL.Component}     The found subcomponent
       */
      getFirstSubcomponent: function(o) {
        if (o) {
          for (var l = 0, a = this.jCal[n], c = a.length; l < c; l++)
            if (a[l][i] === o) {
              var T = this._hydrateComponent(l);
              return T;
            }
        } else if (this.jCal[n].length)
          return this._hydrateComponent(0);
        return null;
      },
      /**
       * Finds all sub components, optionally filtering by name.
       *
       * @param {String=} name            Optional name to filter by
       * @return {ICAL.Component[]}       The found sub components
       */
      getAllSubcomponents: function(o) {
        var l = this.jCal[n].length, a = 0;
        if (o) {
          for (var c = this.jCal[n], T = []; a < l; a++)
            o === c[a][i] && T.push(
              this._hydrateComponent(a)
            );
          return T;
        } else {
          if (!this._components || this._hydratedComponentCount !== l)
            for (; a < l; a++)
              this._hydrateComponent(a);
          return this._components || [];
        }
      },
      /**
       * Returns true when a named property exists.
       *
       * @param {String} name     The property name
       * @return {Boolean}        True, when property is found
       */
      hasProperty: function(o) {
        for (var l = this.jCal[t], a = l.length, c = 0; c < a; c++)
          if (l[c][i] === o)
            return !0;
        return !1;
      },
      /**
       * Finds the first property, optionally with the given name.
       *
       * @param {String=} name        Lowercase property name
       * @return {?ICAL.Property}     The found property
       */
      getFirstProperty: function(o) {
        if (o) {
          for (var l = 0, a = this.jCal[t], c = a.length; l < c; l++)
            if (a[l][i] === o) {
              var T = this._hydrateProperty(l);
              return T;
            }
        } else if (this.jCal[t].length)
          return this._hydrateProperty(0);
        return null;
      },
      /**
       * Returns first property's value, if available.
       *
       * @param {String=} name    Lowercase property name
       * @return {?String}        The found property value.
       */
      getFirstPropertyValue: function(o) {
        var l = this.getFirstProperty(o);
        return l ? l.getFirstValue() : null;
      },
      /**
       * Get all properties in the component, optionally filtered by name.
       *
       * @param {String=} name        Lowercase property name
       * @return {ICAL.Property[]}    List of properties
       */
      getAllProperties: function(o) {
        var l = this.jCal[t].length, a = 0;
        if (o) {
          for (var c = this.jCal[t], T = []; a < l; a++)
            o === c[a][i] && T.push(
              this._hydrateProperty(a)
            );
          return T;
        } else {
          if (!this._properties || this._hydratedPropertyCount !== l)
            for (; a < l; a++)
              this._hydrateProperty(a);
          return this._properties || [];
        }
      },
      _removeObjectByIndex: function(o, l, a) {
        if (l = l || [], l[a]) {
          var c = l[a];
          "parent" in c && (c.parent = null);
        }
        l.splice(a, 1), this.jCal[o].splice(a, 1);
      },
      _removeObject: function(o, l, a) {
        var c = 0, T = this.jCal[o], u = T.length, d = this[l];
        if (typeof a == "string") {
          for (; c < u; c++)
            if (T[c][i] === a)
              return this._removeObjectByIndex(o, d, c), !0;
        } else if (d) {
          for (; c < u; c++)
            if (d[c] && d[c] === a)
              return this._removeObjectByIndex(o, d, c), !0;
        }
        return !1;
      },
      _removeAllObjects: function(o, l, a) {
        for (var c = this[l], T = this.jCal[o], u = T.length - 1; u >= 0; u--)
          (!a || T[u][i] === a) && this._removeObjectByIndex(o, c, u);
      },
      /**
       * Adds a single sub component.
       *
       * @param {ICAL.Component} component        The component to add
       * @return {ICAL.Component}                 The passed in component
       */
      addSubcomponent: function(o) {
        this._components || (this._components = [], this._hydratedComponentCount = 0), o.parent && o.parent.removeSubcomponent(o);
        var l = this.jCal[n].push(o.jCal);
        return this._components[l - 1] = o, this._hydratedComponentCount++, o.parent = this, o;
      },
      /**
       * Removes a single component by name or the instance of a specific
       * component.
       *
       * @param {ICAL.Component|String} nameOrComp    Name of component, or component
       * @return {Boolean}                            True when comp is removed
       */
      removeSubcomponent: function(o) {
        var l = this._removeObject(n, "_components", o);
        return l && this._hydratedComponentCount--, l;
      },
      /**
       * Removes all components or (if given) all components by a particular
       * name.
       *
       * @param {String=} name            Lowercase component name
       */
      removeAllSubcomponents: function(o) {
        var l = this._removeAllObjects(n, "_components", o);
        return this._hydratedComponentCount = 0, l;
      },
      /**
       * Adds an {@link ICAL.Property} to the component.
       *
       * @param {ICAL.Property} property      The property to add
       * @return {ICAL.Property}              The passed in property
       */
      addProperty: function(o) {
        if (!(o instanceof e.Property))
          throw new TypeError("must instance of ICAL.Property");
        this._properties || (this._properties = [], this._hydratedPropertyCount = 0), o.parent && o.parent.removeProperty(o);
        var l = this.jCal[t].push(o.jCal);
        return this._properties[l - 1] = o, this._hydratedPropertyCount++, o.parent = this, o;
      },
      /**
       * Helper method to add a property with a value to the component.
       *
       * @param {String}               name         Property name to add
       * @param {String|Number|Object} value        Property value
       * @return {ICAL.Property}                    The created property
       */
      addPropertyWithValue: function(o, l) {
        var a = new e.Property(o);
        return a.setValue(l), this.addProperty(a), a;
      },
      /**
       * Helper method that will update or create a property of the given name
       * and sets its value. If multiple properties with the given name exist,
       * only the first is updated.
       *
       * @param {String}               name         Property name to update
       * @param {String|Number|Object} value        Property value
       * @return {ICAL.Property}                    The created property
       */
      updatePropertyWithValue: function(o, l) {
        var a = this.getFirstProperty(o);
        return a ? a.setValue(l) : a = this.addPropertyWithValue(o, l), a;
      },
      /**
       * Removes a single property by name or the instance of the specific
       * property.
       *
       * @param {String|ICAL.Property} nameOrProp     Property name or instance to remove
       * @return {Boolean}                            True, when deleted
       */
      removeProperty: function(o) {
        var l = this._removeObject(t, "_properties", o);
        return l && this._hydratedPropertyCount--, l;
      },
      /**
       * Removes all properties associated with this component, optionally
       * filtered by name.
       *
       * @param {String=} name        Lowercase property name
       * @return {Boolean}            True, when deleted
       */
      removeAllProperties: function(o) {
        var l = this._removeAllObjects(t, "_properties", o);
        return this._hydratedPropertyCount = 0, l;
      },
      /**
       * Returns the Object representation of this component. The returned object
       * is a live jCal object and should be cloned if modified.
       * @return {Object}
       */
      toJSON: function() {
        return this.jCal;
      },
      /**
       * The string representation of this component.
       * @return {String}
       */
      toString: function() {
        return e.stringify.component(
          this.jCal,
          this._designSet
        );
      }
    }, s.fromString = function(o) {
      return new s(e.parse.component(o));
    }, s;
  }(), e.Property = function() {
    var t = 0, n = 1, i = 2, s = 3, o = e.design;
    function l(a, c) {
      this._parent = c || null, typeof a == "string" ? (this.jCal = [a, {}, o.defaultType], this.jCal[i] = this.getDefaultType()) : this.jCal = a, this._updateType();
    }
    return l.prototype = {
      /**
       * The value type for this property
       * @readonly
       * @type {String}
       */
      get type() {
        return this.jCal[i];
      },
      /**
       * The name of this property, in lowercase.
       * @readonly
       * @type {String}
       */
      get name() {
        return this.jCal[t];
      },
      /**
       * The parent component for this property.
       * @type {ICAL.Component}
       */
      get parent() {
        return this._parent;
      },
      set parent(a) {
        var c = !this._parent || a && a._designSet != this._parent._designSet;
        return this._parent = a, this.type == o.defaultType && c && (this.jCal[i] = this.getDefaultType(), this._updateType()), a;
      },
      /**
       * The design set for this property, e.g. icalendar vs vcard
       *
       * @type {ICAL.design.designSet}
       * @private
       */
      get _designSet() {
        return this.parent ? this.parent._designSet : o.defaultSet;
      },
      /**
       * Updates the type metadata from the current jCal type and design set.
       *
       * @private
       */
      _updateType: function() {
        var a = this._designSet;
        this.type in a.value && (a.value[this.type], "decorate" in a.value[this.type] ? this.isDecorated = !0 : this.isDecorated = !1, this.name in a.property && (this.isMultiValue = "multiValue" in a.property[this.name], this.isStructuredValue = "structuredValue" in a.property[this.name]));
      },
      /**
       * Hydrate a single value. The act of hydrating means turning the raw jCal
       * value into a potentially wrapped object, for example {@link ICAL.Time}.
       *
       * @private
       * @param {Number} index        The index of the value to hydrate
       * @return {Object}             The decorated value.
       */
      _hydrateValue: function(a) {
        return this._values && this._values[a] ? this._values[a] : this.jCal.length <= s + a ? null : this.isDecorated ? (this._values || (this._values = []), this._values[a] = this._decorate(
          this.jCal[s + a]
        )) : this.jCal[s + a];
      },
      /**
       * Decorate a single value, returning its wrapped object. This is used by
       * the hydrate function to actually wrap the value.
       *
       * @private
       * @param {?} value         The value to decorate
       * @return {Object}         The decorated value
       */
      _decorate: function(a) {
        return this._designSet.value[this.type].decorate(a, this);
      },
      /**
       * Undecorate a single value, returning its raw jCal data.
       *
       * @private
       * @param {Object} value         The value to undecorate
       * @return {?}                   The undecorated value
       */
      _undecorate: function(a) {
        return this._designSet.value[this.type].undecorate(a, this);
      },
      /**
       * Sets the value at the given index while also hydrating it. The passed
       * value can either be a decorated or undecorated value.
       *
       * @private
       * @param {?} value             The value to set
       * @param {Number} index        The index to set it at
       */
      _setDecoratedValue: function(a, c) {
        this._values || (this._values = []), typeof a == "object" && "icaltype" in a ? (this.jCal[s + c] = this._undecorate(a), this._values[c] = a) : (this.jCal[s + c] = a, this._values[c] = this._decorate(a));
      },
      /**
       * Gets a parameter on the property.
       *
       * @param {String}        name   Parameter name (lowercase)
       * @return {Array|String}        Parameter value
       */
      getParameter: function(a) {
        if (a in this.jCal[n])
          return this.jCal[n][a];
      },
      /**
       * Gets first parameter on the property.
       *
       * @param {String}        name   Parameter name (lowercase)
       * @return {String}        Parameter value
       */
      getFirstParameter: function(a) {
        var c = this.getParameter(a);
        return Array.isArray(c) ? c[0] : c;
      },
      /**
       * Sets a parameter on the property.
       *
       * @param {String}       name     The parameter name
       * @param {Array|String} value    The parameter value
       */
      setParameter: function(a, c) {
        var T = a.toLowerCase();
        typeof c == "string" && T in this._designSet.param && "multiValue" in this._designSet.param[T] && (c = [c]), this.jCal[n][a] = c;
      },
      /**
       * Removes a parameter
       *
       * @param {String} name     The parameter name
       */
      removeParameter: function(a) {
        delete this.jCal[n][a];
      },
      /**
       * Get the default type based on this property's name.
       *
       * @return {String}     The default type for this property
       */
      getDefaultType: function() {
        var a = this.jCal[t], c = this._designSet;
        if (a in c.property) {
          var T = c.property[a];
          if ("defaultType" in T)
            return T.defaultType;
        }
        return o.defaultType;
      },
      /**
       * Sets type of property and clears out any existing values of the current
       * type.
       *
       * @param {String} type     New iCAL type (see design.*.values)
       */
      resetType: function(a) {
        this.removeAllValues(), this.jCal[i] = a, this._updateType();
      },
      /**
       * Finds the first property value.
       *
       * @return {String}         First property value
       */
      getFirstValue: function() {
        return this._hydrateValue(0);
      },
      /**
       * Gets all values on the property.
       *
       * NOTE: this creates an array during each call.
       *
       * @return {Array}          List of values
       */
      getValues: function() {
        var a = this.jCal.length - s;
        if (a < 1)
          return [];
        for (var c = 0, T = []; c < a; c++)
          T[c] = this._hydrateValue(c);
        return T;
      },
      /**
       * Removes all values from this property
       */
      removeAllValues: function() {
        this._values && (this._values.length = 0), this.jCal.length = 3;
      },
      /**
       * Sets the values of the property.  Will overwrite the existing values.
       * This can only be used for multi-value properties.
       *
       * @param {Array} values    An array of values
       */
      setValues: function(a) {
        if (!this.isMultiValue)
          throw new Error(
            this.name + `: does not not support mulitValue.
override isMultiValue`
          );
        var c = a.length, T = 0;
        if (this.removeAllValues(), c > 0 && typeof a[0] == "object" && "icaltype" in a[0] && this.resetType(a[0].icaltype), this.isDecorated)
          for (; T < c; T++)
            this._setDecoratedValue(a[T], T);
        else
          for (; T < c; T++)
            this.jCal[s + T] = a[T];
      },
      /**
       * Sets the current value of the property. If this is a multi-value
       * property, all other values will be removed.
       *
       * @param {String|Object} value     New property value.
       */
      setValue: function(a) {
        this.removeAllValues(), typeof a == "object" && "icaltype" in a && this.resetType(a.icaltype), this.isDecorated ? this._setDecoratedValue(a, 0) : this.jCal[s] = a;
      },
      /**
       * Returns the Object representation of this component. The returned object
       * is a live jCal object and should be cloned if modified.
       * @return {Object}
       */
      toJSON: function() {
        return this.jCal;
      },
      /**
       * The string representation of this component.
       * @return {String}
       */
      toICALString: function() {
        return e.stringify.property(
          this.jCal,
          this._designSet,
          !0
        );
      }
    }, l.fromString = function(a, c) {
      return new l(e.parse.property(a, c));
    }, l;
  }(), e.UtcOffset = function() {
    function t(n) {
      this.fromData(n);
    }
    return t.prototype = {
      /**
       * The hours in the utc-offset
       * @type {Number}
       */
      hours: 0,
      /**
       * The minutes in the utc-offset
       * @type {Number}
       */
      minutes: 0,
      /**
       * The sign of the utc offset, 1 for positive offset, -1 for negative
       * offsets.
       * @type {Number}
       */
      factor: 1,
      /**
       * The type name, to be used in the jCal object.
       * @constant
       * @type {String}
       * @default "utc-offset"
       */
      icaltype: "utc-offset",
      /**
       * Returns a clone of the utc offset object.
       *
       * @return {ICAL.UtcOffset}     The cloned object
       */
      clone: function() {
        return e.UtcOffset.fromSeconds(this.toSeconds());
      },
      /**
       * Sets up the current instance using members from the passed data object.
       *
       * @param {Object} aData          An object with members of the utc offset
       * @param {Number=} aData.hours   The hours for the utc offset
       * @param {Number=} aData.minutes The minutes in the utc offset
       * @param {Number=} aData.factor  The factor for the utc-offset, either -1 or 1
       */
      fromData: function(n) {
        if (n)
          for (var i in n)
            n.hasOwnProperty(i) && (this[i] = n[i]);
        this._normalize();
      },
      /**
       * Sets up the current instance from the given seconds value. The seconds
       * value is truncated to the minute. Offsets are wrapped when the world
       * ends, the hour after UTC+14:00 is UTC-12:00.
       *
       * @param {Number} aSeconds         The seconds to convert into an offset
       */
      fromSeconds: function(n) {
        var i = Math.abs(n);
        return this.factor = n < 0 ? -1 : 1, this.hours = e.helpers.trunc(i / 3600), i -= this.hours * 3600, this.minutes = e.helpers.trunc(i / 60), this;
      },
      /**
       * Convert the current offset to a value in seconds
       *
       * @return {Number}                 The offset in seconds
       */
      toSeconds: function() {
        return this.factor * (60 * this.minutes + 3600 * this.hours);
      },
      /**
       * Compare this utc offset with another one.
       *
       * @param {ICAL.UtcOffset} other        The other offset to compare with
       * @return {Number}                     -1, 0 or 1 for less/equal/greater
       */
      compare: function(i) {
        var s = this.toSeconds(), o = i.toSeconds();
        return (s > o) - (o > s);
      },
      _normalize: function() {
        for (var n = this.toSeconds(), i = this.factor; n < -43200; )
          n += 97200;
        for (; n > 50400; )
          n -= 97200;
        this.fromSeconds(n), n == 0 && (this.factor = i);
      },
      /**
       * The iCalendar string representation of this utc-offset.
       * @return {String}
       */
      toICALString: function() {
        return e.design.icalendar.value["utc-offset"].toICAL(this.toString());
      },
      /**
       * The string representation of this utc-offset.
       * @return {String}
       */
      toString: function() {
        return (this.factor == 1 ? "+" : "-") + e.helpers.pad2(this.hours) + ":" + e.helpers.pad2(this.minutes);
      }
    }, t.fromString = function(n) {
      var i = {};
      return i.factor = n[0] === "+" ? 1 : -1, i.hours = e.helpers.strictParseInt(n.substr(1, 2)), i.minutes = e.helpers.strictParseInt(n.substr(4, 2)), new e.UtcOffset(i);
    }, t.fromSeconds = function(n) {
      var i = new t();
      return i.fromSeconds(n), i;
    }, t;
  }(), e.Binary = function() {
    function t(n) {
      this.value = n;
    }
    return t.prototype = {
      /**
       * The type name, to be used in the jCal object.
       * @default "binary"
       * @constant
       */
      icaltype: "binary",
      /**
       * Base64 decode the current value
       *
       * @return {String}         The base64-decoded value
       */
      decodeValue: function() {
        return this._b64_decode(this.value);
      },
      /**
       * Encodes the passed parameter with base64 and sets the internal
       * value to the result.
       *
       * @param {String} aValue      The raw binary value to encode
       */
      setEncodedValue: function(i) {
        this.value = this._b64_encode(i);
      },
      _b64_encode: function(i) {
        var s = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", o, l, a, c, T, u, d, A, f = 0, h = 0, S = "", p = [];
        if (!i)
          return i;
        do
          o = i.charCodeAt(f++), l = i.charCodeAt(f++), a = i.charCodeAt(f++), A = o << 16 | l << 8 | a, c = A >> 18 & 63, T = A >> 12 & 63, u = A >> 6 & 63, d = A & 63, p[h++] = s.charAt(c) + s.charAt(T) + s.charAt(u) + s.charAt(d);
        while (f < i.length);
        S = p.join("");
        var m = i.length % 3;
        return (m ? S.slice(0, m - 3) : S) + "===".slice(m || 3);
      },
      _b64_decode: function(i) {
        var s = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", o, l, a, c, T, u, d, A, f = 0, h = 0, S = "", p = [];
        if (!i)
          return i;
        i += "";
        do
          c = s.indexOf(i.charAt(f++)), T = s.indexOf(i.charAt(f++)), u = s.indexOf(i.charAt(f++)), d = s.indexOf(i.charAt(f++)), A = c << 18 | T << 12 | u << 6 | d, o = A >> 16 & 255, l = A >> 8 & 255, a = A & 255, u == 64 ? p[h++] = String.fromCharCode(o) : d == 64 ? p[h++] = String.fromCharCode(o, l) : p[h++] = String.fromCharCode(o, l, a);
        while (f < i.length);
        return S = p.join(""), S;
      },
      /**
       * The string representation of this value
       * @return {String}
       */
      toString: function() {
        return this.value;
      }
    }, t.fromString = function(n) {
      return new t(n);
    }, t;
  }(), function() {
    e.Period = function(n) {
      if (this.wrappedJSObject = this, n && "start" in n) {
        if (n.start && !(n.start instanceof e.Time))
          throw new TypeError(".start must be an instance of ICAL.Time");
        this.start = n.start;
      }
      if (n && n.end && n.duration)
        throw new Error("cannot accept both end and duration");
      if (n && "end" in n) {
        if (n.end && !(n.end instanceof e.Time))
          throw new TypeError(".end must be an instance of ICAL.Time");
        this.end = n.end;
      }
      if (n && "duration" in n) {
        if (n.duration && !(n.duration instanceof e.Duration))
          throw new TypeError(".duration must be an instance of ICAL.Duration");
        this.duration = n.duration;
      }
    }, e.Period.prototype = {
      /**
       * The start of the period
       * @type {ICAL.Time}
       */
      start: null,
      /**
       * The end of the period
       * @type {ICAL.Time}
       */
      end: null,
      /**
       * The duration of the period
       * @type {ICAL.Duration}
       */
      duration: null,
      /**
       * The class identifier.
       * @constant
       * @type {String}
       * @default "icalperiod"
       */
      icalclass: "icalperiod",
      /**
       * The type name, to be used in the jCal object.
       * @constant
       * @type {String}
       * @default "period"
       */
      icaltype: "period",
      /**
       * Returns a clone of the duration object.
       *
       * @return {ICAL.Period}      The cloned object
       */
      clone: function() {
        return e.Period.fromData({
          start: this.start ? this.start.clone() : null,
          end: this.end ? this.end.clone() : null,
          duration: this.duration ? this.duration.clone() : null
        });
      },
      /**
       * Calculates the duration of the period, either directly or by subtracting
       * start from end date.
       *
       * @return {ICAL.Duration}      The calculated duration
       */
      getDuration: function() {
        return this.duration ? this.duration : this.end.subtractDate(this.start);
      },
      /**
       * Calculates the end date of the period, either directly or by adding
       * duration to start date.
       *
       * @return {ICAL.Time}          The calculated end date
       */
      getEnd: function() {
        if (this.end)
          return this.end;
        var t = this.start.clone();
        return t.addDuration(this.duration), t;
      },
      /**
       * The string representation of this period.
       * @return {String}
       */
      toString: function() {
        return this.start + "/" + (this.end || this.duration);
      },
      /**
       * The jCal representation of this period type.
       * @return {Object}
       */
      toJSON: function() {
        return [this.start.toString(), (this.end || this.duration).toString()];
      },
      /**
       * The iCalendar string representation of this period.
       * @return {String}
       */
      toICALString: function() {
        return this.start.toICALString() + "/" + (this.end || this.duration).toICALString();
      }
    }, e.Period.fromString = function(n, i) {
      var s = n.split("/");
      if (s.length !== 2)
        throw new Error(
          'Invalid string value: "' + n + '" must contain a "/" char.'
        );
      var o = {
        start: e.Time.fromDateTimeString(s[0], i)
      }, l = s[1];
      return e.Duration.isValueString(l) ? o.duration = e.Duration.fromString(l) : o.end = e.Time.fromDateTimeString(l, i), new e.Period(o);
    }, e.Period.fromData = function(n) {
      return new e.Period(n);
    }, e.Period.fromJSON = function(t, n, i) {
      function s(o, l) {
        return i ? e.Time.fromString(o, l) : e.Time.fromDateTimeString(o, l);
      }
      return e.Duration.isValueString(t[1]) ? e.Period.fromData({
        start: s(t[0], n),
        duration: e.Duration.fromString(t[1])
      }) : e.Period.fromData({
        start: s(t[0], n),
        end: s(t[1], n)
      });
    };
  }(), function() {
    var t = /([PDWHMTS]{1,1})/;
    e.Duration = function(s) {
      this.wrappedJSObject = this, this.fromData(s);
    }, e.Duration.prototype = {
      /**
       * The weeks in this duration
       * @type {Number}
       * @default 0
       */
      weeks: 0,
      /**
       * The days in this duration
       * @type {Number}
       * @default 0
       */
      days: 0,
      /**
       * The days in this duration
       * @type {Number}
       * @default 0
       */
      hours: 0,
      /**
       * The minutes in this duration
       * @type {Number}
       * @default 0
       */
      minutes: 0,
      /**
       * The seconds in this duration
       * @type {Number}
       * @default 0
       */
      seconds: 0,
      /**
       * The seconds in this duration
       * @type {Boolean}
       * @default false
       */
      isNegative: !1,
      /**
       * The class identifier.
       * @constant
       * @type {String}
       * @default "icalduration"
       */
      icalclass: "icalduration",
      /**
       * The type name, to be used in the jCal object.
       * @constant
       * @type {String}
       * @default "duration"
       */
      icaltype: "duration",
      /**
       * Returns a clone of the duration object.
       *
       * @return {ICAL.Duration}      The cloned object
       */
      clone: function() {
        return e.Duration.fromData(this);
      },
      /**
       * The duration value expressed as a number of seconds.
       *
       * @return {Number}             The duration value in seconds
       */
      toSeconds: function() {
        var s = this.seconds + 60 * this.minutes + 3600 * this.hours + 86400 * this.days + 604800 * this.weeks;
        return this.isNegative ? -s : s;
      },
      /**
       * Reads the passed seconds value into this duration object. Afterwards,
       * members like {@link ICAL.Duration#days days} and {@link ICAL.Duration#weeks weeks} will be set up
       * accordingly.
       *
       * @param {Number} aSeconds     The duration value in seconds
       * @return {ICAL.Duration}      Returns this instance
       */
      fromSeconds: function(s) {
        var o = Math.abs(s);
        return this.isNegative = s < 0, this.days = e.helpers.trunc(o / 86400), this.days % 7 == 0 ? (this.weeks = this.days / 7, this.days = 0) : this.weeks = 0, o -= (this.days + 7 * this.weeks) * 86400, this.hours = e.helpers.trunc(o / 3600), o -= this.hours * 3600, this.minutes = e.helpers.trunc(o / 60), o -= this.minutes * 60, this.seconds = o, this;
      },
      /**
       * Sets up the current instance using members from the passed data object.
       *
       * @param {Object} aData               An object with members of the duration
       * @param {Number} aData.weeks         Duration in weeks
       * @param {Number} aData.days          Duration in days
       * @param {Number} aData.hours         Duration in hours
       * @param {Number} aData.minutes       Duration in minutes
       * @param {Number} aData.seconds       Duration in seconds
       * @param {Boolean} aData.isNegative   If true, the duration is negative
       */
      fromData: function(s) {
        var o = [
          "weeks",
          "days",
          "hours",
          "minutes",
          "seconds",
          "isNegative"
        ];
        for (var l in o)
          if (o.hasOwnProperty(l)) {
            var a = o[l];
            s && a in s ? this[a] = s[a] : this[a] = 0;
          }
      },
      /**
       * Resets the duration instance to the default values, i.e. PT0S
       */
      reset: function() {
        this.isNegative = !1, this.weeks = 0, this.days = 0, this.hours = 0, this.minutes = 0, this.seconds = 0;
      },
      /**
       * Compares the duration instance with another one.
       *
       * @param {ICAL.Duration} aOther        The instance to compare with
       * @return {Number}                     -1, 0 or 1 for less/equal/greater
       */
      compare: function(s) {
        var o = this.toSeconds(), l = s.toSeconds();
        return (o > l) - (o < l);
      },
      /**
       * Normalizes the duration instance. For example, a duration with a value
       * of 61 seconds will be normalized to 1 minute and 1 second.
       */
      normalize: function() {
        this.fromSeconds(this.toSeconds());
      },
      /**
       * The string representation of this duration.
       * @return {String}
       */
      toString: function() {
        if (this.toSeconds() == 0)
          return "PT0S";
        var s = "";
        return this.isNegative && (s += "-"), s += "P", this.weeks && (s += this.weeks + "W"), this.days && (s += this.days + "D"), (this.hours || this.minutes || this.seconds) && (s += "T", this.hours && (s += this.hours + "H"), this.minutes && (s += this.minutes + "M"), this.seconds && (s += this.seconds + "S")), s;
      },
      /**
       * The iCalendar string representation of this duration.
       * @return {String}
       */
      toICALString: function() {
        return this.toString();
      }
    }, e.Duration.fromSeconds = function(s) {
      return new e.Duration().fromSeconds(s);
    };
    function n(i, s, o) {
      var l;
      switch (i) {
        case "P":
          s && s === "-" ? o.isNegative = !0 : o.isNegative = !1;
          break;
        case "D":
          l = "days";
          break;
        case "W":
          l = "weeks";
          break;
        case "H":
          l = "hours";
          break;
        case "M":
          l = "minutes";
          break;
        case "S":
          l = "seconds";
          break;
        default:
          return 0;
      }
      if (l) {
        if (!s && s !== 0)
          throw new Error(
            'invalid duration value: Missing number before "' + i + '"'
          );
        var a = parseInt(s, 10);
        if (e.helpers.isStrictlyNaN(a))
          throw new Error(
            'invalid duration value: Invalid number "' + s + '" before "' + i + '"'
          );
        o[l] = a;
      }
      return 1;
    }
    e.Duration.isValueString = function(i) {
      return i[0] === "P" || i[1] === "P";
    }, e.Duration.fromString = function(s) {
      for (var o = 0, l = /* @__PURE__ */ Object.create(null), a = 0; (o = s.search(t)) !== -1; ) {
        var c = s[o], T = s.substr(0, o);
        s = s.substr(o + 1), a += n(c, T, l);
      }
      if (a < 2)
        throw new Error(
          'invalid duration value: Not enough duration components in "' + s + '"'
        );
      return new e.Duration(l);
    }, e.Duration.fromData = function(s) {
      return new e.Duration(s);
    };
  }(), function() {
    var t = [
      "tzid",
      "location",
      "tznames",
      "latitude",
      "longitude"
    ];
    e.Timezone = function(i) {
      this.wrappedJSObject = this, this.fromData(i);
    }, e.Timezone.prototype = {
      /**
       * Timezone identifier
       * @type {String}
       */
      tzid: "",
      /**
       * Timezone location
       * @type {String}
       */
      location: "",
      /**
       * Alternative timezone name, for the string representation
       * @type {String}
       */
      tznames: "",
      /**
       * The primary latitude for the timezone.
       * @type {Number}
       */
      latitude: 0,
      /**
       * The primary longitude for the timezone.
       * @type {Number}
       */
      longitude: 0,
      /**
       * The vtimezone component for this timezone.
       * @type {ICAL.Component}
       */
      component: null,
      /**
       * The year this timezone has been expanded to. All timezone transition
       * dates until this year are known and can be used for calculation
       *
       * @private
       * @type {Number}
       */
      expandedUntilYear: 0,
      /**
       * The class identifier.
       * @constant
       * @type {String}
       * @default "icaltimezone"
       */
      icalclass: "icaltimezone",
      /**
       * Sets up the current instance using members from the passed data object.
       *
       * @param {ICAL.Component|Object} aData options for class
       * @param {String|ICAL.Component} aData.component
       *        If aData is a simple object, then this member can be set to either a
       *        string containing the component data, or an already parsed
       *        ICAL.Component
       * @param {String} aData.tzid      The timezone identifier
       * @param {String} aData.location  The timezone locationw
       * @param {String} aData.tznames   An alternative string representation of the
       *                                  timezone
       * @param {Number} aData.latitude  The latitude of the timezone
       * @param {Number} aData.longitude The longitude of the timezone
       */
      fromData: function(i) {
        if (this.expandedUntilYear = 0, this.changes = [], i instanceof e.Component)
          this.component = i;
        else {
          if (i && "component" in i)
            if (typeof i.component == "string") {
              var s = e.parse(i.component);
              this.component = new e.Component(s);
            } else
              i.component instanceof e.Component ? this.component = i.component : this.component = null;
          for (var o in t)
            if (t.hasOwnProperty(o)) {
              var l = t[o];
              i && l in i && (this[l] = i[l]);
            }
        }
        return this.component instanceof e.Component && !this.tzid && (this.tzid = this.component.getFirstPropertyValue("tzid")), this;
      },
      /**
       * Finds the utcOffset the given time would occur in this timezone.
       *
       * @param {ICAL.Time} tt        The time to check for
       * @return {Number} utc offset in seconds
       */
      utcOffset: function(i) {
        if (this == e.Timezone.utcTimezone || this == e.Timezone.localTimezone || (this._ensureCoverage(i.year), !this.changes.length))
          return 0;
        for (var s = {
          year: i.year,
          month: i.month,
          day: i.day,
          hour: i.hour,
          minute: i.minute,
          second: i.second
        }, o = this._findNearbyChange(s), l = -1, a = 1; ; ) {
          var c = e.helpers.clone(this.changes[o], !0);
          c.utcOffset < c.prevUtcOffset ? e.Timezone.adjust_change(c, 0, 0, 0, c.utcOffset) : e.Timezone.adjust_change(
            c,
            0,
            0,
            0,
            c.prevUtcOffset
          );
          var T = e.Timezone._compare_change_fn(s, c);
          if (T >= 0 ? l = o : a = -1, a == -1 && l != -1)
            break;
          if (o += a, o < 0)
            return 0;
          if (o >= this.changes.length)
            break;
        }
        var u = this.changes[l], d = u.utcOffset - u.prevUtcOffset;
        if (d < 0 && l > 0) {
          var A = e.helpers.clone(u, !0);
          if (e.Timezone.adjust_change(
            A,
            0,
            0,
            0,
            A.prevUtcOffset
          ), e.Timezone._compare_change_fn(s, A) < 0) {
            var f = this.changes[l - 1], h = !1;
            u.is_daylight != h && f.is_daylight == h && (u = f);
          }
        }
        return u.utcOffset;
      },
      _findNearbyChange: function(i) {
        var s = e.helpers.binsearchInsert(
          this.changes,
          i,
          e.Timezone._compare_change_fn
        );
        return s >= this.changes.length ? this.changes.length - 1 : s;
      },
      _ensureCoverage: function(n) {
        if (e.Timezone._minimumExpansionYear == -1) {
          var i = e.Time.now();
          e.Timezone._minimumExpansionYear = i.year;
        }
        var s = n;
        if (s < e.Timezone._minimumExpansionYear && (s = e.Timezone._minimumExpansionYear), s += e.Timezone.EXTRA_COVERAGE, s > e.Timezone.MAX_YEAR && (s = e.Timezone.MAX_YEAR), !this.changes.length || this.expandedUntilYear < n) {
          for (var o = this.component.getAllSubcomponents(), l = o.length, a = 0; a < l; a++)
            this._expandComponent(
              o[a],
              s,
              this.changes
            );
          this.changes.sort(e.Timezone._compare_change_fn), this.expandedUntilYear = s;
        }
      },
      _expandComponent: function(n, i, s) {
        if (!n.hasProperty("dtstart") || !n.hasProperty("tzoffsetto") || !n.hasProperty("tzoffsetfrom"))
          return null;
        var o = n.getFirstProperty("dtstart").getFirstValue(), l;
        function a(p) {
          return p.factor * (p.hours * 3600 + p.minutes * 60);
        }
        function c() {
          var p = {};
          return p.is_daylight = n.name == "daylight", p.utcOffset = a(
            n.getFirstProperty("tzoffsetto").getFirstValue()
          ), p.prevUtcOffset = a(
            n.getFirstProperty("tzoffsetfrom").getFirstValue()
          ), p;
        }
        if (!n.hasProperty("rrule") && !n.hasProperty("rdate"))
          l = c(), l.year = o.year, l.month = o.month, l.day = o.day, l.hour = o.hour, l.minute = o.minute, l.second = o.second, e.Timezone.adjust_change(
            l,
            0,
            0,
            0,
            -l.prevUtcOffset
          ), s.push(l);
        else {
          var T = n.getAllProperties("rdate");
          for (var u in T)
            if (T.hasOwnProperty(u)) {
              var d = T[u], A = d.getFirstValue();
              l = c(), l.year = A.year, l.month = A.month, l.day = A.day, A.isDate ? (l.hour = o.hour, l.minute = o.minute, l.second = o.second, o.zone != e.Timezone.utcTimezone && e.Timezone.adjust_change(
                l,
                0,
                0,
                0,
                -l.prevUtcOffset
              )) : (l.hour = A.hour, l.minute = A.minute, l.second = A.second, A.zone != e.Timezone.utcTimezone && e.Timezone.adjust_change(
                l,
                0,
                0,
                0,
                -l.prevUtcOffset
              )), s.push(l);
            }
          var f = n.getFirstProperty("rrule");
          if (f) {
            f = f.getFirstValue(), l = c(), f.until && f.until.zone == e.Timezone.utcTimezone && (f.until.adjust(0, 0, 0, l.prevUtcOffset), f.until.zone = e.Timezone.localTimezone);
            for (var h = f.iterator(o), S; (S = h.next()) && (l = c(), !(S.year > i || !S)); )
              l.year = S.year, l.month = S.month, l.day = S.day, l.hour = S.hour, l.minute = S.minute, l.second = S.second, l.isDate = S.isDate, e.Timezone.adjust_change(
                l,
                0,
                0,
                0,
                -l.prevUtcOffset
              ), s.push(l);
          }
        }
        return s;
      },
      /**
       * The string representation of this timezone.
       * @return {String}
       */
      toString: function() {
        return this.tznames ? this.tznames : this.tzid;
      }
    }, e.Timezone._compare_change_fn = function(i, s) {
      return i.year < s.year ? -1 : i.year > s.year ? 1 : i.month < s.month ? -1 : i.month > s.month ? 1 : i.day < s.day ? -1 : i.day > s.day ? 1 : i.hour < s.hour ? -1 : i.hour > s.hour ? 1 : i.minute < s.minute ? -1 : i.minute > s.minute ? 1 : i.second < s.second ? -1 : i.second > s.second ? 1 : 0;
    }, e.Timezone.convert_time = function(i, s, o) {
      if (i.isDate || s.tzid == o.tzid || s == e.Timezone.localTimezone || o == e.Timezone.localTimezone)
        return i.zone = o, i;
      var l = s.utcOffset(i);
      return i.adjust(0, 0, 0, -l), l = o.utcOffset(i), i.adjust(0, 0, 0, l), null;
    }, e.Timezone.fromData = function(i) {
      var s = new e.Timezone();
      return s.fromData(i);
    }, e.Timezone.utcTimezone = e.Timezone.fromData({
      tzid: "UTC"
    }), e.Timezone.localTimezone = e.Timezone.fromData({
      tzid: "floating"
    }), e.Timezone.adjust_change = function(i, s, o, l, a) {
      return e.Time.prototype.adjust.call(
        i,
        s,
        o,
        l,
        a,
        i
      );
    }, e.Timezone._minimumExpansionYear = -1, e.Timezone.MAX_YEAR = 2035, e.Timezone.EXTRA_COVERAGE = 5;
  }(), e.TimezoneService = function() {
    var t, n = {
      get count() {
        return Object.keys(t).length;
      },
      reset: function() {
        t = /* @__PURE__ */ Object.create(null);
        var i = e.Timezone.utcTimezone;
        t.Z = i, t.UTC = i, t.GMT = i;
      },
      /**
       * Checks if timezone id has been registered.
       *
       * @param {String} tzid     Timezone identifier (e.g. America/Los_Angeles)
       * @return {Boolean}        False, when not present
       */
      has: function(i) {
        return !!t[i];
      },
      /**
       * Returns a timezone by its tzid if present.
       *
       * @param {String} tzid     Timezone identifier (e.g. America/Los_Angeles)
       * @return {?ICAL.Timezone} The timezone, or null if not found
       */
      get: function(i) {
        return t[i];
      },
      /**
       * Registers a timezone object or component.
       *
       * @param {String=} name
       *        The name of the timezone. Defaults to the component's TZID if not
       *        passed.
       * @param {ICAL.Component|ICAL.Timezone} zone
       *        The initialized zone or vtimezone.
       */
      register: function(i, s) {
        if (i instanceof e.Component && i.name === "vtimezone" && (s = new e.Timezone(i), i = s.tzid), s instanceof e.Timezone)
          t[i] = s;
        else
          throw new TypeError("timezone must be ICAL.Timezone or ICAL.Component");
      },
      /**
       * Removes a timezone by its tzid from the list.
       *
       * @param {String} tzid     Timezone identifier (e.g. America/Los_Angeles)
       * @return {?ICAL.Timezone} The removed timezone, or null if not registered
       */
      remove: function(i) {
        return delete t[i];
      }
    };
    return n.reset(), n;
  }(), function() {
    e.Time = function(n, i) {
      this.wrappedJSObject = this;
      var s = this._time = /* @__PURE__ */ Object.create(null);
      s.year = 0, s.month = 1, s.day = 1, s.hour = 0, s.minute = 0, s.second = 0, s.isDate = !1, this.fromData(n, i);
    }, e.Time._dowCache = {}, e.Time._wnCache = {}, e.Time.prototype = {
      /**
       * The class identifier.
       * @constant
       * @type {String}
       * @default "icaltime"
       */
      icalclass: "icaltime",
      _cachedUnixTime: null,
      /**
       * The type name, to be used in the jCal object. This value may change and
       * is strictly defined by the {@link ICAL.Time#isDate isDate} member.
       * @readonly
       * @type {String}
       * @default "date-time"
       */
      get icaltype() {
        return this.isDate ? "date" : "date-time";
      },
      /**
       * The timezone for this time.
       * @type {ICAL.Timezone}
       */
      zone: null,
      /**
       * Internal uses to indicate that a change has been made and the next read
       * operation must attempt to normalize the value (for example changing the
       * day to 33).
       *
       * @type {Boolean}
       * @private
       */
      _pendingNormalization: !1,
      /**
       * Returns a clone of the time object.
       *
       * @return {ICAL.Time}              The cloned object
       */
      clone: function() {
        return new e.Time(this._time, this.zone);
      },
      /**
       * Reset the time instance to epoch time
       */
      reset: function() {
        this.fromData(e.Time.epochTime), this.zone = e.Timezone.utcTimezone;
      },
      /**
       * Reset the time instance to the given date/time values.
       *
       * @param {Number} year             The year to set
       * @param {Number} month            The month to set
       * @param {Number} day              The day to set
       * @param {Number} hour             The hour to set
       * @param {Number} minute           The minute to set
       * @param {Number} second           The second to set
       * @param {ICAL.Timezone} timezone  The timezone to set
       */
      resetTo: function(n, i, s, o, l, a, c) {
        this.fromData({
          year: n,
          month: i,
          day: s,
          hour: o,
          minute: l,
          second: a,
          zone: c
        });
      },
      /**
       * Set up the current instance from the Javascript date value.
       *
       * @param {?Date} aDate     The Javascript Date to read, or null to reset
       * @param {Boolean} useUTC  If true, the UTC values of the date will be used
       */
      fromJSDate: function(n, i) {
        return n ? i ? (this.zone = e.Timezone.utcTimezone, this.year = n.getUTCFullYear(), this.month = n.getUTCMonth() + 1, this.day = n.getUTCDate(), this.hour = n.getUTCHours(), this.minute = n.getUTCMinutes(), this.second = n.getUTCSeconds()) : (this.zone = e.Timezone.localTimezone, this.year = n.getFullYear(), this.month = n.getMonth() + 1, this.day = n.getDate(), this.hour = n.getHours(), this.minute = n.getMinutes(), this.second = n.getSeconds()) : this.reset(), this._cachedUnixTime = null, this;
      },
      /**
       * Sets up the current instance using members from the passed data object.
       *
       * @param {Object} aData            Time initialization
       * @param {Number=} aData.year      The year for this date
       * @param {Number=} aData.month     The month for this date
       * @param {Number=} aData.day       The day for this date
       * @param {Number=} aData.hour      The hour for this date
       * @param {Number=} aData.minute    The minute for this date
       * @param {Number=} aData.second    The second for this date
       * @param {Boolean=} aData.isDate   If true, the instance represents a date
       *                                    (as opposed to a date-time)
       * @param {ICAL.Timezone=} aZone    Timezone this position occurs in
       */
      fromData: function(n, i) {
        if (n) {
          for (var s in n)
            if (Object.prototype.hasOwnProperty.call(n, s)) {
              if (s === "icaltype")
                continue;
              this[s] = n[s];
            }
        }
        if (i && (this.zone = i), n && !("isDate" in n) ? this.isDate = !("hour" in n) : n && "isDate" in n && (this.isDate = n.isDate), n && "timezone" in n) {
          var o = e.TimezoneService.get(
            n.timezone
          );
          this.zone = o || e.Timezone.localTimezone;
        }
        return n && "zone" in n && (this.zone = n.zone), this.zone || (this.zone = e.Timezone.localTimezone), this._cachedUnixTime = null, this;
      },
      /**
       * Calculate the day of week.
       * @param {ICAL.Time.weekDay=} aWeekStart
       *        The week start weekday, defaults to SUNDAY
       * @return {ICAL.Time.weekDay}
       */
      dayOfWeek: function(n) {
        var i = n || e.Time.SUNDAY, s = (this.year << 12) + (this.month << 8) + (this.day << 3) + i;
        if (s in e.Time._dowCache)
          return e.Time._dowCache[s];
        var o = this.day, l = this.month + (this.month < 3 ? 12 : 0), a = this.year - (this.month < 3 ? 1 : 0), c = o + a + e.helpers.trunc((l + 1) * 26 / 10) + e.helpers.trunc(a / 4);
        return c += e.helpers.trunc(a / 100) * 6 + e.helpers.trunc(a / 400), c = (c + 7 - i) % 7 + 1, e.Time._dowCache[s] = c, c;
      },
      /**
       * Calculate the day of year.
       * @return {Number}
       */
      dayOfYear: function() {
        var n = e.Time.isLeapYear(this.year) ? 1 : 0, i = e.Time.daysInYearPassedMonth;
        return i[n][this.month - 1] + this.day;
      },
      /**
       * Returns a copy of the current date/time, rewound to the start of the
       * week. The resulting ICAL.Time instance is of icaltype date, even if this
       * is a date-time.
       *
       * @param {ICAL.Time.weekDay=} aWeekStart
       *        The week start weekday, defaults to SUNDAY
       * @return {ICAL.Time}      The start of the week (cloned)
       */
      startOfWeek: function(n) {
        var i = n || e.Time.SUNDAY, s = this.clone();
        return s.day -= (this.dayOfWeek() + 7 - i) % 7, s.isDate = !0, s.hour = 0, s.minute = 0, s.second = 0, s;
      },
      /**
       * Returns a copy of the current date/time, shifted to the end of the week.
       * The resulting ICAL.Time instance is of icaltype date, even if this is a
       * date-time.
       *
       * @param {ICAL.Time.weekDay=} aWeekStart
       *        The week start weekday, defaults to SUNDAY
       * @return {ICAL.Time}      The end of the week (cloned)
       */
      endOfWeek: function(n) {
        var i = n || e.Time.SUNDAY, s = this.clone();
        return s.day += (7 - this.dayOfWeek() + i - e.Time.SUNDAY) % 7, s.isDate = !0, s.hour = 0, s.minute = 0, s.second = 0, s;
      },
      /**
       * Returns a copy of the current date/time, rewound to the start of the
       * month. The resulting ICAL.Time instance is of icaltype date, even if
       * this is a date-time.
       *
       * @return {ICAL.Time}      The start of the month (cloned)
       */
      startOfMonth: function() {
        var n = this.clone();
        return n.day = 1, n.isDate = !0, n.hour = 0, n.minute = 0, n.second = 0, n;
      },
      /**
       * Returns a copy of the current date/time, shifted to the end of the
       * month.  The resulting ICAL.Time instance is of icaltype date, even if
       * this is a date-time.
       *
       * @return {ICAL.Time}      The end of the month (cloned)
       */
      endOfMonth: function() {
        var n = this.clone();
        return n.day = e.Time.daysInMonth(n.month, n.year), n.isDate = !0, n.hour = 0, n.minute = 0, n.second = 0, n;
      },
      /**
       * Returns a copy of the current date/time, rewound to the start of the
       * year. The resulting ICAL.Time instance is of icaltype date, even if
       * this is a date-time.
       *
       * @return {ICAL.Time}      The start of the year (cloned)
       */
      startOfYear: function() {
        var n = this.clone();
        return n.day = 1, n.month = 1, n.isDate = !0, n.hour = 0, n.minute = 0, n.second = 0, n;
      },
      /**
       * Returns a copy of the current date/time, shifted to the end of the
       * year.  The resulting ICAL.Time instance is of icaltype date, even if
       * this is a date-time.
       *
       * @return {ICAL.Time}      The end of the year (cloned)
       */
      endOfYear: function() {
        var n = this.clone();
        return n.day = 31, n.month = 12, n.isDate = !0, n.hour = 0, n.minute = 0, n.second = 0, n;
      },
      /**
       * First calculates the start of the week, then returns the day of year for
       * this date. If the day falls into the previous year, the day is zero or negative.
       *
       * @param {ICAL.Time.weekDay=} aFirstDayOfWeek
       *        The week start weekday, defaults to SUNDAY
       * @return {Number}     The calculated day of year
       */
      startDoyWeek: function(n) {
        var i = n || e.Time.SUNDAY, s = this.dayOfWeek() - i;
        return s < 0 && (s += 7), this.dayOfYear() - s;
      },
      /**
       * Get the dominical letter for the current year. Letters range from A - G
       * for common years, and AG to GF for leap years.
       *
       * @param {Number} yr           The year to retrieve the letter for
       * @return {String}             The dominical letter.
       */
      getDominicalLetter: function() {
        return e.Time.getDominicalLetter(this.year);
      },
      /**
       * Finds the nthWeekDay relative to the current month (not day).  The
       * returned value is a day relative the month that this month belongs to so
       * 1 would indicate the first of the month and 40 would indicate a day in
       * the following month.
       *
       * @param {Number} aDayOfWeek   Day of the week see the day name constants
       * @param {Number} aPos         Nth occurrence of a given week day values
       *        of 1 and 0 both indicate the first weekday of that type. aPos may
       *        be either positive or negative
       *
       * @return {Number} numeric value indicating a day relative
       *                   to the current month of this time object
       */
      nthWeekDay: function(n, i) {
        var s = e.Time.daysInMonth(this.month, this.year), o, l = i, a = 0, c = this.clone();
        if (l >= 0) {
          c.day = 1, l != 0 && l--, a = c.day;
          var T = c.dayOfWeek(), u = n - T;
          u < 0 && (u += 7), a += u, a -= n, o = n;
        } else {
          c.day = s;
          var d = c.dayOfWeek();
          l++, o = d - n, o < 0 && (o += 7), o = s - o;
        }
        return o += l * 7, a + o;
      },
      /**
       * Checks if current time is the nth weekday, relative to the current
       * month.  Will always return false when rule resolves outside of current
       * month.
       *
       * @param {ICAL.Time.weekDay} aDayOfWeek       Day of week to check
       * @param {Number} aPos                        Relative position
       * @return {Boolean}                           True, if it is the nth weekday
       */
      isNthWeekDay: function(t, n) {
        var i = this.dayOfWeek();
        if (n === 0 && i === t)
          return !0;
        var s = this.nthWeekDay(t, n);
        return s === this.day;
      },
      /**
       * Calculates the ISO 8601 week number. The first week of a year is the
       * week that contains the first Thursday. The year can have 53 weeks, if
       * January 1st is a Friday.
       *
       * Note there are regions where the first week of the year is the one that
       * starts on January 1st, which may offset the week number. Also, if a
       * different week start is specified, this will also affect the week
       * number.
       *
       * @see ICAL.Time.weekOneStarts
       * @param {ICAL.Time.weekDay} aWeekStart        The weekday the week starts with
       * @return {Number}                             The ISO week number
       */
      weekNumber: function(n) {
        var i = (this.year << 12) + (this.month << 8) + (this.day << 3) + n;
        if (i in e.Time._wnCache)
          return e.Time._wnCache[i];
        var s, o = this.clone();
        o.isDate = !0;
        var l = this.year;
        o.month == 12 && o.day > 25 ? (s = e.Time.weekOneStarts(l + 1, n), o.compare(s) < 0 ? s = e.Time.weekOneStarts(l, n) : l++) : (s = e.Time.weekOneStarts(l, n), o.compare(s) < 0 && (s = e.Time.weekOneStarts(--l, n)));
        var a = o.subtractDate(s).toSeconds() / 86400, c = e.helpers.trunc(a / 7) + 1;
        return e.Time._wnCache[i] = c, c;
      },
      /**
       * Adds the duration to the current time. The instance is modified in
       * place.
       *
       * @param {ICAL.Duration} aDuration         The duration to add
       */
      addDuration: function(n) {
        var i = n.isNegative ? -1 : 1, s = this.second, o = this.minute, l = this.hour, a = this.day;
        s += i * n.seconds, o += i * n.minutes, l += i * n.hours, a += i * n.days, a += i * 7 * n.weeks, this.second = s, this.minute = o, this.hour = l, this.day = a, this._cachedUnixTime = null;
      },
      /**
       * Subtract the date details (_excluding_ timezone).  Useful for finding
       * the relative difference between two time objects excluding their
       * timezone differences.
       *
       * @param {ICAL.Time} aDate     The date to substract
       * @return {ICAL.Duration}      The difference as a duration
       */
      subtractDate: function(n) {
        var i = this.toUnixTime() + this.utcOffset(), s = n.toUnixTime() + n.utcOffset();
        return e.Duration.fromSeconds(i - s);
      },
      /**
       * Subtract the date details, taking timezones into account.
       *
       * @param {ICAL.Time} aDate  The date to subtract
       * @return {ICAL.Duration}  The difference in duration
       */
      subtractDateTz: function(n) {
        var i = this.toUnixTime(), s = n.toUnixTime();
        return e.Duration.fromSeconds(i - s);
      },
      /**
       * Compares the ICAL.Time instance with another one.
       *
       * @param {ICAL.Duration} aOther        The instance to compare with
       * @return {Number}                     -1, 0 or 1 for less/equal/greater
       */
      compare: function(n) {
        var i = this.toUnixTime(), s = n.toUnixTime();
        return i > s ? 1 : s > i ? -1 : 0;
      },
      /**
       * Compares only the date part of this instance with another one.
       *
       * @param {ICAL.Duration} other         The instance to compare with
       * @param {ICAL.Timezone} tz            The timezone to compare in
       * @return {Number}                     -1, 0 or 1 for less/equal/greater
       */
      compareDateOnlyTz: function(n, i) {
        function s(c) {
          return e.Time._cmp_attr(o, l, c);
        }
        var o = this.convertToZone(i), l = n.convertToZone(i), a = 0;
        return (a = s("year")) != 0 || (a = s("month")) != 0 || (a = s("day")) != 0, a;
      },
      /**
       * Convert the instance into another timezone. The returned ICAL.Time
       * instance is always a copy.
       *
       * @param {ICAL.Timezone} zone      The zone to convert to
       * @return {ICAL.Time}              The copy, converted to the zone
       */
      convertToZone: function(n) {
        var i = this.clone(), s = this.zone.tzid == n.tzid;
        return !this.isDate && !s && e.Timezone.convert_time(i, this.zone, n), i.zone = n, i;
      },
      /**
       * Calculates the UTC offset of the current date/time in the timezone it is
       * in.
       *
       * @return {Number}     UTC offset in seconds
       */
      utcOffset: function() {
        return this.zone == e.Timezone.localTimezone || this.zone == e.Timezone.utcTimezone ? 0 : this.zone.utcOffset(this);
      },
      /**
       * Returns an RFC 5545 compliant ical representation of this object.
       *
       * @return {String} ical date/date-time
       */
      toICALString: function() {
        var t = this.toString();
        return t.length > 10 ? e.design.icalendar.value["date-time"].toICAL(t) : e.design.icalendar.value.date.toICAL(t);
      },
      /**
       * The string representation of this date/time, in jCal form
       * (including : and - separators).
       * @return {String}
       */
      toString: function() {
        var n = this.year + "-" + e.helpers.pad2(this.month) + "-" + e.helpers.pad2(this.day);
        return this.isDate || (n += "T" + e.helpers.pad2(this.hour) + ":" + e.helpers.pad2(this.minute) + ":" + e.helpers.pad2(this.second), this.zone === e.Timezone.utcTimezone && (n += "Z")), n;
      },
      /**
       * Converts the current instance to a Javascript date
       * @return {Date}
       */
      toJSDate: function() {
        return this.zone == e.Timezone.localTimezone ? this.isDate ? new Date(this.year, this.month - 1, this.day) : new Date(
          this.year,
          this.month - 1,
          this.day,
          this.hour,
          this.minute,
          this.second,
          0
        ) : new Date(this.toUnixTime() * 1e3);
      },
      _normalize: function() {
        return this._time.isDate, this._time.isDate && (this._time.hour = 0, this._time.minute = 0, this._time.second = 0), this.adjust(0, 0, 0, 0), this;
      },
      /**
       * Adjust the date/time by the given offset
       *
       * @param {Number} aExtraDays       The extra amount of days
       * @param {Number} aExtraHours      The extra amount of hours
       * @param {Number} aExtraMinutes    The extra amount of minutes
       * @param {Number} aExtraSeconds    The extra amount of seconds
       * @param {Number=} aTime           The time to adjust, defaults to the
       *                                    current instance.
       */
      adjust: function(n, i, s, o, l) {
        var a, c, T = 0, u = 0, d, A, f, h, S, p = l || this._time;
        if (p.isDate || (d = p.second + o, p.second = d % 60, a = e.helpers.trunc(d / 60), p.second < 0 && (p.second += 60, a--), A = p.minute + s + a, p.minute = A % 60, c = e.helpers.trunc(A / 60), p.minute < 0 && (p.minute += 60, c--), f = p.hour + i + c, p.hour = f % 24, T = e.helpers.trunc(f / 24), p.hour < 0 && (p.hour += 24, T--)), p.month > 12 ? u = e.helpers.trunc((p.month - 1) / 12) : p.month < 1 && (u = e.helpers.trunc(p.month / 12) - 1), p.year += u, p.month -= 12 * u, h = p.day + n + T, h > 0)
          for (; S = e.Time.daysInMonth(p.month, p.year), !(h <= S); )
            p.month++, p.month > 12 && (p.year++, p.month = 1), h -= S;
        else
          for (; h <= 0; )
            p.month == 1 ? (p.year--, p.month = 12) : p.month--, h += e.Time.daysInMonth(p.month, p.year);
        return p.day = h, this._cachedUnixTime = null, this;
      },
      /**
       * Sets up the current instance from unix time, the number of seconds since
       * January 1st, 1970.
       *
       * @param {Number} seconds      The seconds to set up with
       */
      fromUnixTime: function(n) {
        this.zone = e.Timezone.utcTimezone;
        var i = e.Time.epochTime.clone();
        i.adjust(0, 0, 0, n), this.year = i.year, this.month = i.month, this.day = i.day, this.hour = i.hour, this.minute = i.minute, this.second = Math.floor(i.second), this._cachedUnixTime = null;
      },
      /**
       * Converts the current instance to seconds since January 1st 1970.
       *
       * @return {Number}         Seconds since 1970
       */
      toUnixTime: function() {
        if (this._cachedUnixTime !== null)
          return this._cachedUnixTime;
        var n = this.utcOffset(), i = Date.UTC(
          this.year,
          this.month - 1,
          this.day,
          this.hour,
          this.minute,
          this.second - n
        );
        return this._cachedUnixTime = i / 1e3, this._cachedUnixTime;
      },
      /**
       * Converts time to into Object which can be serialized then re-created
       * using the constructor.
       *
       * @example
       * // toJSON will automatically be called
       * var json = JSON.stringify(mytime);
       *
       * var deserialized = JSON.parse(json);
       *
       * var time = new ICAL.Time(deserialized);
       *
       * @return {Object}
       */
      toJSON: function() {
        for (var t = [
          "year",
          "month",
          "day",
          "hour",
          "minute",
          "second",
          "isDate"
        ], n = /* @__PURE__ */ Object.create(null), i = 0, s = t.length, o; i < s; i++)
          o = t[i], n[o] = this[o];
        return this.zone && (n.timezone = this.zone.tzid), n;
      }
    }, function() {
      function n(i) {
        Object.defineProperty(e.Time.prototype, i, {
          get: function() {
            return this._pendingNormalization && (this._normalize(), this._pendingNormalization = !1), this._time[i];
          },
          set: function(o) {
            return i === "isDate" && o && !this._time.isDate && this.adjust(0, 0, 0, 0), this._cachedUnixTime = null, this._pendingNormalization = !0, this._time[i] = o, o;
          }
        });
      }
      "defineProperty" in Object && (n("year"), n("month"), n("day"), n("hour"), n("minute"), n("second"), n("isDate"));
    }(), e.Time.daysInMonth = function(n, i) {
      var s = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], o = 30;
      return n < 1 || n > 12 || (o = s[n], n == 2 && (o += e.Time.isLeapYear(i))), o;
    }, e.Time.isLeapYear = function(n) {
      return n <= 1752 ? n % 4 == 0 : n % 4 == 0 && n % 100 != 0 || n % 400 == 0;
    }, e.Time.fromDayOfYear = function(n, i) {
      var s = i, o = n, l = new e.Time();
      l.auto_normalize = !1;
      var a = e.Time.isLeapYear(s) ? 1 : 0;
      if (o < 1)
        return s--, a = e.Time.isLeapYear(s) ? 1 : 0, o += e.Time.daysInYearPassedMonth[a][12], e.Time.fromDayOfYear(o, s);
      if (o > e.Time.daysInYearPassedMonth[a][12])
        return a = e.Time.isLeapYear(s) ? 1 : 0, o -= e.Time.daysInYearPassedMonth[a][12], s++, e.Time.fromDayOfYear(o, s);
      l.year = s, l.isDate = !0;
      for (var c = 11; c >= 0; c--)
        if (o > e.Time.daysInYearPassedMonth[a][c]) {
          l.month = c + 1, l.day = o - e.Time.daysInYearPassedMonth[a][c];
          break;
        }
      return l.auto_normalize = !0, l;
    }, e.Time.fromStringv2 = function(n) {
      return new e.Time({
        year: parseInt(n.substr(0, 4), 10),
        month: parseInt(n.substr(5, 2), 10),
        day: parseInt(n.substr(8, 2), 10),
        isDate: !0
      });
    }, e.Time.fromDateString = function(t) {
      return new e.Time({
        year: e.helpers.strictParseInt(t.substr(0, 4)),
        month: e.helpers.strictParseInt(t.substr(5, 2)),
        day: e.helpers.strictParseInt(t.substr(8, 2)),
        isDate: !0
      });
    }, e.Time.fromDateTimeString = function(t, n) {
      if (t.length < 19)
        throw new Error(
          'invalid date-time value: "' + t + '"'
        );
      var i;
      t[19] && t[19] === "Z" ? i = "Z" : n && (i = n.getParameter("tzid"));
      var s = new e.Time({
        year: e.helpers.strictParseInt(t.substr(0, 4)),
        month: e.helpers.strictParseInt(t.substr(5, 2)),
        day: e.helpers.strictParseInt(t.substr(8, 2)),
        hour: e.helpers.strictParseInt(t.substr(11, 2)),
        minute: e.helpers.strictParseInt(t.substr(14, 2)),
        second: e.helpers.strictParseInt(t.substr(17, 2)),
        timezone: i
      });
      return s;
    }, e.Time.fromString = function(n, i) {
      return n.length > 10 ? e.Time.fromDateTimeString(n, i) : e.Time.fromDateString(n);
    }, e.Time.fromJSDate = function(n, i) {
      var s = new e.Time();
      return s.fromJSDate(n, i);
    }, e.Time.fromData = function(n, i) {
      var s = new e.Time();
      return s.fromData(n, i);
    }, e.Time.now = function() {
      return e.Time.fromJSDate(new Date(), !1);
    }, e.Time.weekOneStarts = function(n, i) {
      var s = e.Time.fromData({
        year: n,
        month: 1,
        day: 1,
        isDate: !0
      }), o = s.dayOfWeek(), l = i || e.Time.DEFAULT_WEEK_START;
      return o > e.Time.THURSDAY && (s.day += 7), l > e.Time.THURSDAY && (s.day -= 7), s.day -= o - l, s;
    }, e.Time.getDominicalLetter = function(t) {
      var n = "GFEDCBA", i = (t + (t / 4 | 0) + (t / 400 | 0) - (t / 100 | 0) - 1) % 7, s = e.Time.isLeapYear(t);
      return s ? n[(i + 6) % 7] + n[i] : n[i];
    }, e.Time.epochTime = e.Time.fromData({
      year: 1970,
      month: 1,
      day: 1,
      hour: 0,
      minute: 0,
      second: 0,
      isDate: !1,
      timezone: "Z"
    }), e.Time._cmp_attr = function(n, i, s) {
      return n[s] > i[s] ? 1 : n[s] < i[s] ? -1 : 0;
    }, e.Time.daysInYearPassedMonth = [
      [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334, 365],
      [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335, 366]
    ], e.Time.SUNDAY = 1, e.Time.MONDAY = 2, e.Time.TUESDAY = 3, e.Time.WEDNESDAY = 4, e.Time.THURSDAY = 5, e.Time.FRIDAY = 6, e.Time.SATURDAY = 7, e.Time.DEFAULT_WEEK_START = e.Time.MONDAY;
  }(), function() {
    e.VCardTime = function(t, n, i) {
      this.wrappedJSObject = this;
      var s = this._time = /* @__PURE__ */ Object.create(null);
      s.year = null, s.month = null, s.day = null, s.hour = null, s.minute = null, s.second = null, this.icaltype = i || "date-and-or-time", this.fromData(t, n);
    }, e.helpers.inherits(
      e.Time,
      e.VCardTime,
      /** @lends ICAL.VCardTime */
      {
        /**
         * The class identifier.
         * @constant
         * @type {String}
         * @default "vcardtime"
         */
        icalclass: "vcardtime",
        /**
         * The type name, to be used in the jCal object.
         * @type {String}
         * @default "date-and-or-time"
         */
        icaltype: "date-and-or-time",
        /**
         * The timezone. This can either be floating, UTC, or an instance of
         * ICAL.UtcOffset.
         * @type {ICAL.Timezone|ICAL.UtcOFfset}
         */
        zone: null,
        /**
         * Returns a clone of the vcard date/time object.
         *
         * @return {ICAL.VCardTime}     The cloned object
         */
        clone: function() {
          return new e.VCardTime(this._time, this.zone, this.icaltype);
        },
        _normalize: function() {
          return this;
        },
        /**
         * @inheritdoc
         */
        utcOffset: function() {
          return this.zone instanceof e.UtcOffset ? this.zone.toSeconds() : e.Time.prototype.utcOffset.apply(this, arguments);
        },
        /**
         * Returns an RFC 6350 compliant representation of this object.
         *
         * @return {String}         vcard date/time string
         */
        toICALString: function() {
          return e.design.vcard.value[this.icaltype].toICAL(this.toString());
        },
        /**
         * The string representation of this date/time, in jCard form
         * (including : and - separators).
         * @return {String}
         */
        toString: function() {
          var n = e.helpers.pad2, i = this.year, s = this.month, o = this.day, l = this.hour, a = this.minute, c = this.second, T = i !== null, u = s !== null, d = o !== null, A = l !== null, f = a !== null, h = c !== null, S = (T ? n(i) + (u || d ? "-" : "") : u || d ? "--" : "") + (u ? n(s) : "") + (d ? "-" + n(o) : ""), p = (A ? n(l) : "-") + (A && f ? ":" : "") + (f ? n(a) : "") + (!A && !f ? "-" : "") + (f && h ? ":" : "") + (h ? n(c) : ""), m;
          if (this.zone === e.Timezone.utcTimezone)
            m = "Z";
          else if (this.zone instanceof e.UtcOffset)
            m = this.zone.toString();
          else if (this.zone === e.Timezone.localTimezone)
            m = "";
          else if (this.zone instanceof e.Timezone) {
            var g = e.UtcOffset.fromSeconds(this.zone.utcOffset(this));
            m = g.toString();
          } else
            m = "";
          switch (this.icaltype) {
            case "time":
              return p + m;
            case "date-and-or-time":
            case "date-time":
              return S + (p == "--" ? "" : "T" + p + m);
            case "date":
              return S;
          }
          return null;
        }
      }
    ), e.VCardTime.fromDateAndOrTimeString = function(t, n) {
      function i(S, p, m) {
        return S ? e.helpers.strictParseInt(S.substr(p, m)) : null;
      }
      var s = t.split("T"), o = s[0], l = s[1], a = l ? e.design.vcard.value.time._splitZone(l) : [], c = a[0], T = a[1];
      e.helpers.strictParseInt;
      var u = o ? o.length : 0, d = T ? T.length : 0, A = o && o[0] == "-" && o[1] == "-", f = T && T[0] == "-", h = {
        year: A ? null : i(o, 0, 4),
        month: A && (u == 4 || u == 7) ? i(o, 2, 2) : u == 7 || u == 10 ? i(o, 5, 2) : null,
        day: u == 5 ? i(o, 3, 2) : u == 7 && A ? i(o, 5, 2) : u == 10 ? i(o, 8, 2) : null,
        hour: f ? null : i(T, 0, 2),
        minute: f && d == 3 ? i(T, 1, 2) : d > 4 ? f ? i(T, 1, 2) : i(T, 3, 2) : null,
        second: d == 4 ? i(T, 2, 2) : d == 6 ? i(T, 4, 2) : d == 8 ? i(T, 6, 2) : null
      };
      return c == "Z" ? c = e.Timezone.utcTimezone : c && c[3] == ":" ? c = e.UtcOffset.fromString(c) : c = null, new e.VCardTime(h, c, n);
    };
  }(), function() {
    var t = {
      SU: e.Time.SUNDAY,
      MO: e.Time.MONDAY,
      TU: e.Time.TUESDAY,
      WE: e.Time.WEDNESDAY,
      TH: e.Time.THURSDAY,
      FR: e.Time.FRIDAY,
      SA: e.Time.SATURDAY
    }, n = {};
    for (var i in t)
      t.hasOwnProperty(i) && (n[t[i]] = i);
    e.Recur = function(d) {
      this.wrappedJSObject = this, this.parts = {}, d && typeof d == "object" && this.fromData(d);
    }, e.Recur.prototype = {
      /**
       * An object holding the BY-parts of the recurrence rule
       * @type {Object}
       */
      parts: null,
      /**
       * The interval value for the recurrence rule.
       * @type {Number}
       */
      interval: 1,
      /**
       * The week start day
       *
       * @type {ICAL.Time.weekDay}
       * @default ICAL.Time.MONDAY
       */
      wkst: e.Time.MONDAY,
      /**
       * The end of the recurrence
       * @type {?ICAL.Time}
       */
      until: null,
      /**
       * The maximum number of occurrences
       * @type {?Number}
       */
      count: null,
      /**
       * The frequency value.
       * @type {ICAL.Recur.frequencyValues}
       */
      freq: null,
      /**
       * The class identifier.
       * @constant
       * @type {String}
       * @default "icalrecur"
       */
      icalclass: "icalrecur",
      /**
       * The type name, to be used in the jCal object.
       * @constant
       * @type {String}
       * @default "recur"
       */
      icaltype: "recur",
      /**
       * Create a new iterator for this recurrence rule. The passed start date
       * must be the start date of the event, not the start of the range to
       * search in.
       *
       * @example
       * var recur = comp.getFirstPropertyValue('rrule');
       * var dtstart = comp.getFirstPropertyValue('dtstart');
       * var iter = recur.iterator(dtstart);
       * for (var next = iter.next(); next; next = iter.next()) {
       *   if (next.compare(rangeStart) < 0) {
       *     continue;
       *   }
       *   console.log(next.toString());
       * }
       *
       * @param {ICAL.Time} aStart        The item's start date
       * @return {ICAL.RecurIterator}     The recurrence iterator
       */
      iterator: function(u) {
        return new e.RecurIterator({
          rule: this,
          dtstart: u
        });
      },
      /**
       * Returns a clone of the recurrence object.
       *
       * @return {ICAL.Recur}      The cloned object
       */
      clone: function() {
        return new e.Recur(this.toJSON());
      },
      /**
       * Checks if the current rule is finite, i.e. has a count or until part.
       *
       * @return {Boolean}        True, if the rule is finite
       */
      isFinite: function() {
        return !!(this.count || this.until);
      },
      /**
       * Checks if the current rule has a count part, and not limited by an until
       * part.
       *
       * @return {Boolean}        True, if the rule is by count
       */
      isByCount: function() {
        return !!(this.count && !this.until);
      },
      /**
       * Adds a component (part) to the recurrence rule. This is not a component
       * in the sense of {@link ICAL.Component}, but a part of the recurrence
       * rule, i.e. BYMONTH.
       *
       * @param {String} aType            The name of the component part
       * @param {Array|String} aValue     The component value
       */
      addComponent: function(d, A) {
        var f = d.toUpperCase();
        f in this.parts ? this.parts[f].push(A) : this.parts[f] = [A];
      },
      /**
       * Sets the component value for the given by-part.
       *
       * @param {String} aType        The component part name
       * @param {Array} aValues       The component values
       */
      setComponent: function(d, A) {
        this.parts[d.toUpperCase()] = A.slice();
      },
      /**
       * Gets (a copy) of the requested component value.
       *
       * @param {String} aType        The component part name
       * @return {Array}              The component part value
       */
      getComponent: function(d) {
        var A = d.toUpperCase();
        return A in this.parts ? this.parts[A].slice() : [];
      },
      /**
       * Retrieves the next occurrence after the given recurrence id. See the
       * guide on {@tutorial terminology} for more details.
       *
       * NOTE: Currently, this method iterates all occurrences from the start
       * date. It should not be called in a loop for performance reasons. If you
       * would like to get more than one occurrence, you can iterate the
       * occurrences manually, see the example on the
       * {@link ICAL.Recur#iterator iterator} method.
       *
       * @param {ICAL.Time} aStartTime        The start of the event series
       * @param {ICAL.Time} aRecurrenceId     The date of the last occurrence
       * @return {ICAL.Time}                  The next occurrence after
       */
      getNextOccurrence: function(d, A) {
        var f = this.iterator(d), h;
        do
          h = f.next();
        while (h && h.compare(A) <= 0);
        return h && A.zone && (h.zone = A.zone), h;
      },
      /**
       * Sets up the current instance using members from the passed data object.
       *
       * @param {Object} data                               An object with members of the recurrence
       * @param {ICAL.Recur.frequencyValues=} data.freq     The frequency value
       * @param {Number=} data.interval                     The INTERVAL value
       * @param {ICAL.Time.weekDay=} data.wkst              The week start value
       * @param {ICAL.Time=} data.until                     The end of the recurrence set
       * @param {Number=} data.count                        The number of occurrences
       * @param {Array.<Number>=} data.bysecond             The seconds for the BYSECOND part
       * @param {Array.<Number>=} data.byminute             The minutes for the BYMINUTE part
       * @param {Array.<Number>=} data.byhour               The hours for the BYHOUR part
       * @param {Array.<String>=} data.byday                The BYDAY values
       * @param {Array.<Number>=} data.bymonthday           The days for the BYMONTHDAY part
       * @param {Array.<Number>=} data.byyearday            The days for the BYYEARDAY part
       * @param {Array.<Number>=} data.byweekno             The weeks for the BYWEEKNO part
       * @param {Array.<Number>=} data.bymonth              The month for the BYMONTH part
       * @param {Array.<Number>=} data.bysetpos             The positionals for the BYSETPOS part
       */
      fromData: function(u) {
        for (var d in u) {
          var A = d.toUpperCase();
          A in T ? Array.isArray(u[d]) ? this.parts[A] = u[d] : this.parts[A] = [u[d]] : this[d] = u[d];
        }
        this.interval && typeof this.interval != "number" && c.INTERVAL(this.interval, this), this.wkst && typeof this.wkst != "number" && (this.wkst = e.Recur.icalDayToNumericDay(this.wkst)), this.until && !(this.until instanceof e.Time) && (this.until = e.Time.fromString(this.until));
      },
      /**
       * The jCal representation of this recurrence type.
       * @return {Object}
       */
      toJSON: function() {
        var u = /* @__PURE__ */ Object.create(null);
        u.freq = this.freq, this.count && (u.count = this.count), this.interval > 1 && (u.interval = this.interval);
        for (var d in this.parts)
          if (this.parts.hasOwnProperty(d)) {
            var A = this.parts[d];
            Array.isArray(A) && A.length == 1 ? u[d.toLowerCase()] = A[0] : u[d.toLowerCase()] = e.helpers.clone(this.parts[d]);
          }
        return this.until && (u.until = this.until.toString()), "wkst" in this && this.wkst !== e.Time.DEFAULT_WEEK_START && (u.wkst = e.Recur.numericDayToIcalDay(this.wkst)), u;
      },
      /**
       * The string representation of this recurrence rule.
       * @return {String}
       */
      toString: function() {
        var d = "FREQ=" + this.freq;
        this.count && (d += ";COUNT=" + this.count), this.interval > 1 && (d += ";INTERVAL=" + this.interval);
        for (var A in this.parts)
          this.parts.hasOwnProperty(A) && (d += ";" + A + "=" + this.parts[A]);
        return this.until && (d += ";UNTIL=" + this.until.toICALString()), "wkst" in this && this.wkst !== e.Time.DEFAULT_WEEK_START && (d += ";WKST=" + e.Recur.numericDayToIcalDay(this.wkst)), d;
      }
    };
    function s(u, d, A, f) {
      var h = f;
      if (f[0] === "+" && (h = f.substr(1)), h = e.helpers.strictParseInt(h), d !== void 0 && f < d)
        throw new Error(
          u + ': invalid value "' + f + '" must be > ' + d
        );
      if (A !== void 0 && f > A)
        throw new Error(
          u + ': invalid value "' + f + '" must be < ' + d
        );
      return h;
    }
    e.Recur.icalDayToNumericDay = function(d, A) {
      var f = A || e.Time.SUNDAY;
      return (t[d] - f + 7) % 7 + 1;
    }, e.Recur.numericDayToIcalDay = function(d, A) {
      var f = A || e.Time.SUNDAY, h = d + f - e.Time.SUNDAY;
      return h > 7 && (h -= 7), n[h];
    };
    var o = /^(SU|MO|TU|WE|TH|FR|SA)$/, l = /^([+-])?(5[0-3]|[1-4][0-9]|[1-9])?(SU|MO|TU|WE|TH|FR|SA)$/, a = [
      "SECONDLY",
      "MINUTELY",
      "HOURLY",
      "DAILY",
      "WEEKLY",
      "MONTHLY",
      "YEARLY"
    ], c = {
      FREQ: function(u, d, A) {
        if (a.indexOf(u) !== -1)
          d.freq = u;
        else
          throw new Error(
            'invalid frequency "' + u + '" expected: "' + a.join(", ") + '"'
          );
      },
      COUNT: function(u, d, A) {
        d.count = e.helpers.strictParseInt(u);
      },
      INTERVAL: function(u, d, A) {
        d.interval = e.helpers.strictParseInt(u), d.interval < 1 && (d.interval = 1);
      },
      UNTIL: function(u, d, A) {
        u.length > 10 ? d.until = e.design.icalendar.value["date-time"].fromICAL(u) : d.until = e.design.icalendar.value.date.fromICAL(u), A || (d.until = e.Time.fromString(d.until));
      },
      WKST: function(u, d, A) {
        if (o.test(u))
          d.wkst = e.Recur.icalDayToNumericDay(u);
        else
          throw new Error('invalid WKST value "' + u + '"');
      }
    }, T = {
      BYSECOND: s.bind(this, "BYSECOND", 0, 60),
      BYMINUTE: s.bind(this, "BYMINUTE", 0, 59),
      BYHOUR: s.bind(this, "BYHOUR", 0, 23),
      BYDAY: function(u) {
        if (l.test(u))
          return u;
        throw new Error('invalid BYDAY value "' + u + '"');
      },
      BYMONTHDAY: s.bind(this, "BYMONTHDAY", -31, 31),
      BYYEARDAY: s.bind(this, "BYYEARDAY", -366, 366),
      BYWEEKNO: s.bind(this, "BYWEEKNO", -53, 53),
      BYMONTH: s.bind(this, "BYMONTH", 1, 12),
      BYSETPOS: s.bind(this, "BYSETPOS", -366, 366)
    };
    e.Recur.fromString = function(u) {
      var d = e.Recur._stringToData(u, !1);
      return new e.Recur(d);
    }, e.Recur.fromData = function(u) {
      return new e.Recur(u);
    }, e.Recur._stringToData = function(u, d) {
      for (var A = /* @__PURE__ */ Object.create(null), f = u.split(";"), h = f.length, S = 0; S < h; S++) {
        var p = f[S].split("="), m = p[0].toUpperCase(), g = p[0].toLowerCase(), N = d ? g : m, R = p[1];
        if (m in T) {
          for (var D = R.split(","), v = 0, O = D.length; v < O; v++)
            D[v] = T[m](D[v]);
          A[N] = D.length == 1 ? D[0] : D;
        } else
          m in c ? c[m](R, A, d) : A[g] = R;
      }
      return A;
    };
  }(), e.RecurIterator = function() {
    function t(n) {
      this.fromData(n);
    }
    return t.prototype = {
      /**
       * True when iteration is finished.
       * @type {Boolean}
       */
      completed: !1,
      /**
       * The rule that is being iterated
       * @type {ICAL.Recur}
       */
      rule: null,
      /**
       * The start date of the event being iterated.
       * @type {ICAL.Time}
       */
      dtstart: null,
      /**
       * The last occurrence that was returned from the
       * {@link ICAL.RecurIterator#next} method.
       * @type {ICAL.Time}
       */
      last: null,
      /**
       * The sequence number from the occurrence
       * @type {Number}
       */
      occurrence_number: 0,
      /**
       * The indices used for the {@link ICAL.RecurIterator#by_data} object.
       * @type {Object}
       * @private
       */
      by_indices: null,
      /**
       * If true, the iterator has already been initialized
       * @type {Boolean}
       * @private
       */
      initialized: !1,
      /**
       * The initializd by-data.
       * @type {Object}
       * @private
       */
      by_data: null,
      /**
       * The expanded yeardays
       * @type {Array}
       * @private
       */
      days: null,
      /**
       * The index in the {@link ICAL.RecurIterator#days} array.
       * @type {Number}
       * @private
       */
      days_index: 0,
      /**
       * Initialize the recurrence iterator from the passed data object. This
       * method is usually not called directly, you can initialize the iterator
       * through the constructor.
       *
       * @param {Object} options                The iterator options
       * @param {ICAL.Recur} options.rule       The rule to iterate.
       * @param {ICAL.Time} options.dtstart     The start date of the event.
       * @param {Boolean=} options.initialized  When true, assume that options are
       *        from a previously constructed iterator. Initialization will not be
       *        repeated.
       */
      fromData: function(n) {
        if (this.rule = e.helpers.formatClassType(n.rule, e.Recur), !this.rule)
          throw new Error("iterator requires a (ICAL.Recur) rule");
        if (this.dtstart = e.helpers.formatClassType(n.dtstart, e.Time), !this.dtstart)
          throw new Error("iterator requires a (ICAL.Time) dtstart");
        n.by_data ? this.by_data = n.by_data : this.by_data = e.helpers.clone(this.rule.parts, !0), n.occurrence_number && (this.occurrence_number = n.occurrence_number), this.days = n.days || [], n.last && (this.last = e.helpers.formatClassType(n.last, e.Time)), this.by_indices = n.by_indices, this.by_indices || (this.by_indices = {
          BYSECOND: 0,
          BYMINUTE: 0,
          BYHOUR: 0,
          BYDAY: 0,
          BYMONTH: 0,
          BYWEEKNO: 0,
          BYMONTHDAY: 0
        }), this.initialized = n.initialized || !1, this.initialized || this.init();
      },
      /**
       * Intialize the iterator
       * @private
       */
      init: function() {
        this.initialized = !0, this.last = this.dtstart.clone();
        var i = this.by_data;
        if ("BYDAY" in i && this.sort_byday_rules(i.BYDAY), "BYYEARDAY" in i && ("BYMONTH" in i || "BYWEEKNO" in i || "BYMONTHDAY" in i || "BYDAY" in i))
          throw new Error("Invalid BYYEARDAY rule");
        if ("BYWEEKNO" in i && "BYMONTHDAY" in i)
          throw new Error("BYWEEKNO does not fit to BYMONTHDAY");
        if (this.rule.freq == "MONTHLY" && ("BYYEARDAY" in i || "BYWEEKNO" in i))
          throw new Error("For MONTHLY recurrences neither BYYEARDAY nor BYWEEKNO may appear");
        if (this.rule.freq == "WEEKLY" && ("BYYEARDAY" in i || "BYMONTHDAY" in i))
          throw new Error("For WEEKLY recurrences neither BYMONTHDAY nor BYYEARDAY may appear");
        if (this.rule.freq != "YEARLY" && "BYYEARDAY" in i)
          throw new Error("BYYEARDAY may only appear in YEARLY rules");
        if (this.last.second = this.setup_defaults("BYSECOND", "SECONDLY", this.dtstart.second), this.last.minute = this.setup_defaults("BYMINUTE", "MINUTELY", this.dtstart.minute), this.last.hour = this.setup_defaults("BYHOUR", "HOURLY", this.dtstart.hour), this.last.day = this.setup_defaults("BYMONTHDAY", "DAILY", this.dtstart.day), this.last.month = this.setup_defaults("BYMONTH", "MONTHLY", this.dtstart.month), this.rule.freq == "WEEKLY")
          if ("BYDAY" in i) {
            var s = this.ruleDayOfWeek(i.BYDAY[0], this.rule.wkst), o = s[0], l = s[1], a = l - this.last.dayOfWeek(this.rule.wkst);
            (this.last.dayOfWeek(this.rule.wkst) < l && a >= 0 || a < 0) && (this.last.day += a);
          } else {
            var c = e.Recur.numericDayToIcalDay(this.dtstart.dayOfWeek());
            i.BYDAY = [c];
          }
        if (this.rule.freq == "YEARLY") {
          for (; this.expand_year_days(this.last.year), !(this.days.length > 0); )
            this.increment_year(this.rule.interval);
          this._nextByYearDay();
        }
        if (this.rule.freq == "MONTHLY" && this.has_by_data("BYDAY")) {
          var T = null, u = this.last.clone(), d = e.Time.daysInMonth(this.last.month, this.last.year);
          for (var A in this.by_data.BYDAY)
            if (this.by_data.BYDAY.hasOwnProperty(A)) {
              this.last = u.clone();
              var s = this.ruleDayOfWeek(this.by_data.BYDAY[A]), o = s[0], l = s[1], f = this.last.nthWeekDay(l, o);
              if (o >= 6 || o <= -6)
                throw new Error("Malformed values in BYDAY part");
              if (f > d || f <= 0) {
                if (T && T.month == u.month)
                  continue;
                for (; f > d || f <= 0; )
                  this.increment_month(), d = e.Time.daysInMonth(this.last.month, this.last.year), f = this.last.nthWeekDay(l, o);
              }
              this.last.day = f, (!T || this.last.compare(T) < 0) && (T = this.last.clone());
            }
          if (this.last = T.clone(), this.has_by_data("BYMONTHDAY") && this._byDayAndMonthDay(!0), this.last.day > d || this.last.day == 0)
            throw new Error("Malformed values in BYDAY part");
        } else if (this.has_by_data("BYMONTHDAY") && this.last.day < 0) {
          var d = e.Time.daysInMonth(this.last.month, this.last.year);
          this.last.day = d + this.last.day + 1;
        }
      },
      /**
       * Retrieve the next occurrence from the iterator.
       * @return {ICAL.Time}
       */
      next: function() {
        var i = this.last ? this.last.clone() : null;
        if (this.rule.count && this.occurrence_number >= this.rule.count || this.rule.until && this.last.compare(this.rule.until) > 0)
          return this.completed = !0, null;
        if (this.occurrence_number == 0 && this.last.compare(this.dtstart) >= 0)
          return this.occurrence_number++, this.last;
        var s;
        do
          switch (s = 1, this.rule.freq) {
            case "SECONDLY":
              this.next_second();
              break;
            case "MINUTELY":
              this.next_minute();
              break;
            case "HOURLY":
              this.next_hour();
              break;
            case "DAILY":
              this.next_day();
              break;
            case "WEEKLY":
              this.next_week();
              break;
            case "MONTHLY":
              s = this.next_month();
              break;
            case "YEARLY":
              this.next_year();
              break;
            default:
              return null;
          }
        while (!this.check_contracting_rules() || this.last.compare(this.dtstart) < 0 || !s);
        if (this.last.compare(i) == 0)
          throw new Error("Same occurrence found twice, protecting you from death by recursion");
        return this.rule.until && this.last.compare(this.rule.until) > 0 ? (this.completed = !0, null) : (this.occurrence_number++, this.last);
      },
      next_second: function() {
        return this.next_generic("BYSECOND", "SECONDLY", "second", "minute");
      },
      increment_second: function(i) {
        return this.increment_generic(i, "second", 60, "minute");
      },
      next_minute: function() {
        return this.next_generic(
          "BYMINUTE",
          "MINUTELY",
          "minute",
          "hour",
          "next_second"
        );
      },
      increment_minute: function(i) {
        return this.increment_generic(i, "minute", 60, "hour");
      },
      next_hour: function() {
        return this.next_generic(
          "BYHOUR",
          "HOURLY",
          "hour",
          "monthday",
          "next_minute"
        );
      },
      increment_hour: function(i) {
        this.increment_generic(i, "hour", 24, "monthday");
      },
      next_day: function() {
        "BYDAY" in this.by_data;
        var i = this.rule.freq == "DAILY";
        return this.next_hour() == 0 || (i ? this.increment_monthday(this.rule.interval) : this.increment_monthday(1)), 0;
      },
      next_week: function() {
        var i = 0;
        if (this.next_weekday_by_week() == 0)
          return i;
        if (this.has_by_data("BYWEEKNO")) {
          ++this.by_indices.BYWEEKNO, this.by_indices.BYWEEKNO == this.by_data.BYWEEKNO.length && (this.by_indices.BYWEEKNO = 0, i = 1), this.last.month = 1, this.last.day = 1;
          var s = this.by_data.BYWEEKNO[this.by_indices.BYWEEKNO];
          this.last.day += 7 * s, i && this.increment_year(1);
        } else
          this.increment_monthday(7 * this.rule.interval);
        return i;
      },
      /**
       * Normalize each by day rule for a given year/month.
       * Takes into account ordering and negative rules
       *
       * @private
       * @param {Number} year         Current year.
       * @param {Number} month        Current month.
       * @param {Array}  rules        Array of rules.
       *
       * @return {Array} sorted and normalized rules.
       *                 Negative rules will be expanded to their
       *                 correct positive values for easier processing.
       */
      normalizeByMonthDayRules: function(n, i, s) {
        for (var o = e.Time.daysInMonth(i, n), l = [], a = 0, c = s.length, T; a < c; a++)
          if (T = s[a], !(Math.abs(T) > o)) {
            if (T < 0)
              T = o + (T + 1);
            else if (T === 0)
              continue;
            l.indexOf(T) === -1 && l.push(T);
          }
        return l.sort(function(u, d) {
          return u - d;
        });
      },
      /**
       * NOTES:
       * We are given a list of dates in the month (BYMONTHDAY) (23, etc..)
       * Also we are given a list of days (BYDAY) (MO, 2SU, etc..) when
       * both conditions match a given date (this.last.day) iteration stops.
       *
       * @private
       * @param {Boolean=} isInit     When given true will not increment the
       *                                current day (this.last).
       */
      _byDayAndMonthDay: function(n) {
        var i, s = this.by_data.BYDAY, o, l = 0, a, c = s.length, T = 0, u, d = this, A = this.last.day;
        function f() {
          for (u = e.Time.daysInMonth(
            d.last.month,
            d.last.year
          ), i = d.normalizeByMonthDayRules(
            d.last.year,
            d.last.month,
            d.by_data.BYMONTHDAY
          ), a = i.length; i[l] <= A && !(n && i[l] == A) && l < a - 1; )
            l++;
        }
        function h() {
          A = 0, d.increment_month(), l = 0, f();
        }
        f(), n && (A -= 1);
        for (var S = 48; !T && S; ) {
          if (S--, o = A + 1, o > u) {
            h();
            continue;
          }
          var p = i[l++];
          if (p >= o)
            A = p;
          else {
            h();
            continue;
          }
          for (var m = 0; m < c; m++) {
            var g = this.ruleDayOfWeek(s[m]), N = g[0], R = g[1];
            if (this.last.day = A, this.last.isNthWeekDay(R, N)) {
              T = 1;
              break;
            }
          }
          if (!T && l === a) {
            h();
            continue;
          }
        }
        if (S <= 0)
          throw new Error("Malformed values in BYDAY combined with BYMONTHDAY parts");
        return T;
      },
      next_month: function() {
        this.rule.freq == "MONTHLY";
        var i = 1;
        if (this.next_hour() == 0)
          return i;
        if (this.has_by_data("BYDAY") && this.has_by_data("BYMONTHDAY"))
          i = this._byDayAndMonthDay();
        else if (this.has_by_data("BYDAY")) {
          var s = e.Time.daysInMonth(this.last.month, this.last.year), o = 0, l = 0;
          if (this.has_by_data("BYSETPOS")) {
            for (var a = this.last.day, c = 1; c <= s; c++)
              this.last.day = c, this.is_day_in_byday(this.last) && (l++, c <= a && o++);
            this.last.day = a;
          }
          i = 0;
          for (var c = this.last.day + 1; c <= s; c++)
            if (this.last.day = c, this.is_day_in_byday(this.last) && (!this.has_by_data("BYSETPOS") || this.check_set_position(++o) || this.check_set_position(o - l - 1))) {
              i = 1;
              break;
            }
          c > s && (this.last.day = 1, this.increment_month(), this.is_day_in_byday(this.last) ? (!this.has_by_data("BYSETPOS") || this.check_set_position(1)) && (i = 1) : i = 0);
        } else if (this.has_by_data("BYMONTHDAY")) {
          this.by_indices.BYMONTHDAY++, this.by_indices.BYMONTHDAY >= this.by_data.BYMONTHDAY.length && (this.by_indices.BYMONTHDAY = 0, this.increment_month());
          var s = e.Time.daysInMonth(this.last.month, this.last.year), c = this.by_data.BYMONTHDAY[this.by_indices.BYMONTHDAY];
          c < 0 && (c = s + c + 1), c > s ? (this.last.day = 1, i = this.is_day_in_byday(this.last)) : this.last.day = c;
        } else {
          this.increment_month();
          var s = e.Time.daysInMonth(this.last.month, this.last.year);
          this.by_data.BYMONTHDAY[0] > s ? i = 0 : this.last.day = this.by_data.BYMONTHDAY[0];
        }
        return i;
      },
      next_weekday_by_week: function() {
        var i = 0;
        if (this.next_hour() == 0)
          return i;
        if (!this.has_by_data("BYDAY"))
          return 1;
        for (; ; ) {
          var s = new e.Time();
          this.by_indices.BYDAY++, this.by_indices.BYDAY == Object.keys(this.by_data.BYDAY).length && (this.by_indices.BYDAY = 0, i = 1);
          var o = this.by_data.BYDAY[this.by_indices.BYDAY], l = this.ruleDayOfWeek(o), a = l[1];
          a -= this.rule.wkst, a < 0 && (a += 7), s.year = this.last.year, s.month = this.last.month, s.day = this.last.day;
          var c = s.startDoyWeek(this.rule.wkst);
          if (!(a + c < 1 && !i)) {
            var T = e.Time.fromDayOfYear(
              c + a,
              this.last.year
            );
            return this.last.year = T.year, this.last.month = T.month, this.last.day = T.day, i;
          }
        }
      },
      next_year: function() {
        if (this.next_hour() == 0)
          return 0;
        if (++this.days_index == this.days.length) {
          this.days_index = 0;
          do
            this.increment_year(this.rule.interval), this.expand_year_days(this.last.year);
          while (this.days.length == 0);
        }
        return this._nextByYearDay(), 1;
      },
      _nextByYearDay: function() {
        var i = this.days[this.days_index], s = this.last.year;
        i < 1 && (i += 1, s += 1);
        var o = e.Time.fromDayOfYear(i, s);
        this.last.day = o.day, this.last.month = o.month;
      },
      /**
       * @param dow (eg: '1TU', '-1MO')
       * @param {ICAL.Time.weekDay=} aWeekStart The week start weekday
       * @return [pos, numericDow] (eg: [1, 3]) numericDow is relative to aWeekStart
       */
      ruleDayOfWeek: function(i, s) {
        var o = i.match(/([+-]?[0-9])?(MO|TU|WE|TH|FR|SA|SU)/);
        if (o) {
          var l = parseInt(o[1] || 0, 10);
          return i = e.Recur.icalDayToNumericDay(o[2], s), [l, i];
        } else
          return [0, 0];
      },
      next_generic: function(i, s, o, l, a) {
        var c = i in this.by_data, T = this.rule.freq == s, u = 0;
        if (a && this[a]() == 0)
          return u;
        if (c) {
          this.by_indices[i]++, this.by_indices[i];
          var d = this.by_data[i];
          this.by_indices[i] == d.length && (this.by_indices[i] = 0, u = 1), this.last[o] = d[this.by_indices[i]];
        } else
          T && this["increment_" + o](this.rule.interval);
        return c && u && T && this["increment_" + l](1), u;
      },
      increment_monthday: function(i) {
        for (var s = 0; s < i; s++) {
          var o = e.Time.daysInMonth(this.last.month, this.last.year);
          this.last.day++, this.last.day > o && (this.last.day -= o, this.increment_month());
        }
      },
      increment_month: function() {
        if (this.last.day = 1, this.has_by_data("BYMONTH"))
          this.by_indices.BYMONTH++, this.by_indices.BYMONTH == this.by_data.BYMONTH.length && (this.by_indices.BYMONTH = 0, this.increment_year(1)), this.last.month = this.by_data.BYMONTH[this.by_indices.BYMONTH];
        else {
          this.rule.freq == "MONTHLY" ? this.last.month += this.rule.interval : this.last.month++, this.last.month--;
          var i = e.helpers.trunc(this.last.month / 12);
          this.last.month %= 12, this.last.month++, i != 0 && this.increment_year(i);
        }
      },
      increment_year: function(i) {
        this.last.year += i;
      },
      increment_generic: function(i, s, o, l) {
        this.last[s] += i;
        var a = e.helpers.trunc(this.last[s] / o);
        this.last[s] %= o, a != 0 && this["increment_" + l](a);
      },
      has_by_data: function(i) {
        return i in this.rule.parts;
      },
      expand_year_days: function(i) {
        var s = new e.Time();
        this.days = [];
        var o = {}, l = ["BYDAY", "BYWEEKNO", "BYMONTHDAY", "BYMONTH", "BYYEARDAY"];
        for (var a in l)
          if (l.hasOwnProperty(a)) {
            var c = l[a];
            c in this.rule.parts && (o[c] = this.rule.parts[c]);
          }
        if ("BYMONTH" in o && "BYWEEKNO" in o) {
          var T = 1, u = {};
          s.year = i, s.isDate = !0;
          for (var d = 0; d < this.by_data.BYMONTH.length; d++) {
            var A = this.by_data.BYMONTH[d];
            s.month = A, s.day = 1;
            var f = s.weekNumber(this.rule.wkst);
            s.day = e.Time.daysInMonth(A, i);
            var h = s.weekNumber(this.rule.wkst);
            for (d = f; d < h; d++)
              u[d] = 1;
          }
          for (var S = 0; S < this.by_data.BYWEEKNO.length && T; S++) {
            var p = this.by_data.BYWEEKNO[S];
            p < 52 ? T &= u[S] : T = 0;
          }
          T ? delete o.BYMONTH : delete o.BYWEEKNO;
        }
        var m = Object.keys(o).length;
        if (m == 0) {
          var g = this.dtstart.clone();
          g.year = this.last.year, this.days.push(g.dayOfYear());
        } else if (m == 1 && "BYMONTH" in o) {
          for (var N in this.by_data.BYMONTH)
            if (this.by_data.BYMONTH.hasOwnProperty(N)) {
              var R = this.dtstart.clone();
              R.year = i, R.month = this.by_data.BYMONTH[N], R.isDate = !0, this.days.push(R.dayOfYear());
            }
        } else if (m == 1 && "BYMONTHDAY" in o) {
          for (var D in this.by_data.BYMONTHDAY)
            if (this.by_data.BYMONTHDAY.hasOwnProperty(D)) {
              var v = this.dtstart.clone(), O = this.by_data.BYMONTHDAY[D];
              if (O < 0) {
                var y = e.Time.daysInMonth(v.month, i);
                O = O + y + 1;
              }
              v.day = O, v.year = i, v.isDate = !0, this.days.push(v.dayOfYear());
            }
        } else if (m == 2 && "BYMONTHDAY" in o && "BYMONTH" in o) {
          for (var N in this.by_data.BYMONTH)
            if (this.by_data.BYMONTH.hasOwnProperty(N)) {
              var Z = this.by_data.BYMONTH[N], y = e.Time.daysInMonth(Z, i);
              for (var D in this.by_data.BYMONTHDAY)
                if (this.by_data.BYMONTHDAY.hasOwnProperty(D)) {
                  var O = this.by_data.BYMONTHDAY[D];
                  O < 0 && (O = O + y + 1), s.day = O, s.month = Z, s.year = i, s.isDate = !0, this.days.push(s.dayOfYear());
                }
            }
        } else if (!(m == 1 && "BYWEEKNO" in o)) {
          if (!(m == 2 && "BYWEEKNO" in o && "BYMONTHDAY" in o))
            if (m == 1 && "BYDAY" in o)
              this.days = this.days.concat(this.expand_by_day(i));
            else if (m == 2 && "BYDAY" in o && "BYMONTH" in o) {
              for (var N in this.by_data.BYMONTH)
                if (this.by_data.BYMONTH.hasOwnProperty(N)) {
                  var A = this.by_data.BYMONTH[N], y = e.Time.daysInMonth(A, i);
                  s.year = i, s.month = this.by_data.BYMONTH[N], s.day = 1, s.isDate = !0;
                  var F = s.dayOfWeek(), b = s.dayOfYear() - 1;
                  s.day = y;
                  var Y = s.dayOfWeek();
                  if (this.has_by_data("BYSETPOS")) {
                    for (var I = [], q = 1; q <= y; q++)
                      s.day = q, this.is_day_in_byday(s) && I.push(q);
                    for (var _ = 0; _ < I.length; _++)
                      (this.check_set_position(_ + 1) || this.check_set_position(_ - I.length)) && this.days.push(b + I[_]);
                  } else
                    for (var z in this.by_data.BYDAY)
                      if (this.by_data.BYDAY.hasOwnProperty(z)) {
                        var E = this.by_data.BYDAY[z], C = this.ruleDayOfWeek(E), P = C[0], M = C[1], Q, H = (M + 7 - F) % 7 + 1, re = y - (Y + 7 - M) % 7;
                        if (P == 0)
                          for (var q = H; q <= y; q += 7)
                            this.days.push(b + q);
                        else
                          P > 0 ? (Q = H + (P - 1) * 7, Q <= y && this.days.push(b + Q)) : (Q = re + (P + 1) * 7, Q > 0 && this.days.push(b + Q));
                      }
                }
              this.days.sort(function(se, ie) {
                return se - ie;
              });
            } else if (m == 2 && "BYDAY" in o && "BYMONTHDAY" in o) {
              var U = this.expand_by_day(i);
              for (var w in U)
                if (U.hasOwnProperty(w)) {
                  var q = U[w], W = e.Time.fromDayOfYear(q, i);
                  this.by_data.BYMONTHDAY.indexOf(W.day) >= 0 && this.days.push(q);
                }
            } else if (m == 3 && "BYDAY" in o && "BYMONTHDAY" in o && "BYMONTH" in o) {
              var U = this.expand_by_day(i);
              for (var w in U)
                if (U.hasOwnProperty(w)) {
                  var q = U[w], W = e.Time.fromDayOfYear(q, i);
                  this.by_data.BYMONTH.indexOf(W.month) >= 0 && this.by_data.BYMONTHDAY.indexOf(W.day) >= 0 && this.days.push(q);
                }
            } else if (m == 2 && "BYDAY" in o && "BYWEEKNO" in o) {
              var U = this.expand_by_day(i);
              for (var w in U)
                if (U.hasOwnProperty(w)) {
                  var q = U[w], W = e.Time.fromDayOfYear(q, i), p = W.weekNumber(this.rule.wkst);
                  this.by_data.BYWEEKNO.indexOf(p) && this.days.push(q);
                }
            } else
              m == 3 && "BYDAY" in o && "BYWEEKNO" in o && "BYMONTHDAY" in o || (m == 1 && "BYYEARDAY" in o ? this.days = this.days.concat(this.by_data.BYYEARDAY) : this.days = []);
        }
        return 0;
      },
      expand_by_day: function(i) {
        var s = [], o = this.last.clone();
        o.year = i, o.month = 1, o.day = 1, o.isDate = !0;
        var l = o.dayOfWeek();
        o.month = 12, o.day = 31, o.isDate = !0;
        var a = o.dayOfWeek(), c = o.dayOfYear();
        for (var T in this.by_data.BYDAY)
          if (this.by_data.BYDAY.hasOwnProperty(T)) {
            var u = this.by_data.BYDAY[T], d = this.ruleDayOfWeek(u), A = d[0], f = d[1];
            if (A == 0)
              for (var h = (f + 7 - l) % 7 + 1, S = h; S <= c; S += 7)
                s.push(S);
            else if (A > 0) {
              var p;
              f >= l ? p = f - l + 1 : p = f - l + 8, s.push(p + (A - 1) * 7);
            } else {
              var m;
              A = -A, f <= a ? m = c - a + f : m = c - a + f - 7, s.push(m - (A - 1) * 7);
            }
          }
        return s;
      },
      is_day_in_byday: function(i) {
        for (var s in this.by_data.BYDAY)
          if (this.by_data.BYDAY.hasOwnProperty(s)) {
            var o = this.by_data.BYDAY[s], l = this.ruleDayOfWeek(o), a = l[0], c = l[1], T = i.dayOfWeek();
            if (a == 0 && c == T || i.nthWeekDay(c, a) == i.day)
              return 1;
          }
        return 0;
      },
      /**
       * Checks if given value is in BYSETPOS.
       *
       * @private
       * @param {Numeric} aPos position to check for.
       * @return {Boolean} false unless BYSETPOS rules exist
       *                   and the given value is present in rules.
       */
      check_set_position: function(i) {
        if (this.has_by_data("BYSETPOS")) {
          var s = this.by_data.BYSETPOS.indexOf(i);
          return s !== -1;
        }
        return !1;
      },
      sort_byday_rules: function(i) {
        for (var s = 0; s < i.length; s++)
          for (var o = 0; o < s; o++) {
            var l = this.ruleDayOfWeek(i[o], this.rule.wkst)[1], a = this.ruleDayOfWeek(i[s], this.rule.wkst)[1];
            if (l > a) {
              var c = i[s];
              i[s] = i[o], i[o] = c;
            }
          }
      },
      check_contract_restriction: function(i, s) {
        var o = t._indexMap[i], l = t._expandMap[this.rule.freq][o], a = !1;
        if (i in this.by_data && l == t.CONTRACT) {
          var c = this.by_data[i];
          for (var T in c)
            if (c.hasOwnProperty(T) && c[T] == s) {
              a = !0;
              break;
            }
        } else
          a = !0;
        return a;
      },
      check_contracting_rules: function() {
        var i = this.last.dayOfWeek(), s = this.last.weekNumber(this.rule.wkst), o = this.last.dayOfYear();
        return this.check_contract_restriction("BYSECOND", this.last.second) && this.check_contract_restriction("BYMINUTE", this.last.minute) && this.check_contract_restriction("BYHOUR", this.last.hour) && this.check_contract_restriction("BYDAY", e.Recur.numericDayToIcalDay(i)) && this.check_contract_restriction("BYWEEKNO", s) && this.check_contract_restriction("BYMONTHDAY", this.last.day) && this.check_contract_restriction("BYMONTH", this.last.month) && this.check_contract_restriction("BYYEARDAY", o);
      },
      setup_defaults: function(i, s, o) {
        var l = t._indexMap[i], a = t._expandMap[this.rule.freq][l];
        return a != t.CONTRACT && (i in this.by_data || (this.by_data[i] = [o]), this.rule.freq != s) ? this.by_data[i][0] : o;
      },
      /**
       * Convert iterator into a serialize-able object.  Will preserve current
       * iteration sequence to ensure the seamless continuation of the recurrence
       * rule.
       * @return {Object}
       */
      toJSON: function() {
        var n = /* @__PURE__ */ Object.create(null);
        return n.initialized = this.initialized, n.rule = this.rule.toJSON(), n.dtstart = this.dtstart.toJSON(), n.by_data = this.by_data, n.days = this.days, n.last = this.last.toJSON(), n.by_indices = this.by_indices, n.occurrence_number = this.occurrence_number, n;
      }
    }, t._indexMap = {
      BYSECOND: 0,
      BYMINUTE: 1,
      BYHOUR: 2,
      BYDAY: 3,
      BYMONTHDAY: 4,
      BYYEARDAY: 5,
      BYWEEKNO: 6,
      BYMONTH: 7,
      BYSETPOS: 8
    }, t._expandMap = {
      SECONDLY: [1, 1, 1, 1, 1, 1, 1, 1],
      MINUTELY: [2, 1, 1, 1, 1, 1, 1, 1],
      HOURLY: [2, 2, 1, 1, 1, 1, 1, 1],
      DAILY: [2, 2, 2, 1, 1, 1, 1, 1],
      WEEKLY: [2, 2, 2, 2, 3, 3, 1, 1],
      MONTHLY: [2, 2, 2, 2, 2, 3, 3, 1],
      YEARLY: [2, 2, 2, 2, 2, 2, 2, 2]
    }, t.UNKNOWN = 0, t.CONTRACT = 1, t.EXPAND = 2, t.ILLEGAL = 3, t;
  }(), e.RecurExpansion = function() {
    function t(o) {
      return e.helpers.formatClassType(o, e.Time);
    }
    function n(o, l) {
      return o.compare(l);
    }
    function i(o) {
      return o.hasProperty("rdate") || o.hasProperty("rrule") || o.hasProperty("recurrence-id");
    }
    function s(o) {
      this.ruleDates = [], this.exDates = [], this.fromData(o);
    }
    return s.prototype = {
      /**
       * True when iteration is fully completed.
       * @type {Boolean}
       */
      complete: !1,
      /**
       * Array of rrule iterators.
       *
       * @type {ICAL.RecurIterator[]}
       * @private
       */
      ruleIterators: null,
      /**
       * Array of rdate instances.
       *
       * @type {ICAL.Time[]}
       * @private
       */
      ruleDates: null,
      /**
       * Array of exdate instances.
       *
       * @type {ICAL.Time[]}
       * @private
       */
      exDates: null,
      /**
       * Current position in ruleDates array.
       * @type {Number}
       * @private
       */
      ruleDateInc: 0,
      /**
       * Current position in exDates array
       * @type {Number}
       * @private
       */
      exDateInc: 0,
      /**
       * Current negative date.
       *
       * @type {ICAL.Time}
       * @private
       */
      exDate: null,
      /**
       * Current additional date.
       *
       * @type {ICAL.Time}
       * @private
       */
      ruleDate: null,
      /**
       * Start date of recurring rules.
       *
       * @type {ICAL.Time}
       */
      dtstart: null,
      /**
       * Last expanded time
       *
       * @type {ICAL.Time}
       */
      last: null,
      /**
       * Initialize the recurrence expansion from the data object. The options
       * object may also contain additional members, see the
       * {@link ICAL.RecurExpansion constructor} for more details.
       *
       * @param {Object} options
       *        Recurrence expansion options
       * @param {ICAL.Time} options.dtstart
       *        Start time of the event
       * @param {ICAL.Component=} options.component
       *        Component for expansion, required if not resuming.
       */
      fromData: function(o) {
        var l = e.helpers.formatClassType(o.dtstart, e.Time);
        if (l)
          this.dtstart = l;
        else
          throw new Error(".dtstart (ICAL.Time) must be given");
        if (o.component)
          this._init(o.component);
        else {
          if (this.last = t(o.last) || l.clone(), !o.ruleIterators)
            throw new Error(".ruleIterators or .component must be given");
          this.ruleIterators = o.ruleIterators.map(function(a) {
            return e.helpers.formatClassType(a, e.RecurIterator);
          }), this.ruleDateInc = o.ruleDateInc, this.exDateInc = o.exDateInc, o.ruleDates && (this.ruleDates = o.ruleDates.map(t), this.ruleDate = this.ruleDates[this.ruleDateInc]), o.exDates && (this.exDates = o.exDates.map(t), this.exDate = this.exDates[this.exDateInc]), typeof o.complete < "u" && (this.complete = o.complete);
        }
      },
      /**
       * Retrieve the next occurrence in the series.
       * @return {ICAL.Time}
       */
      next: function() {
        for (var o, l, a, c = 500, T = 0; ; ) {
          if (T++ > c)
            throw new Error(
              "max tries have occured, rule may be impossible to forfill."
            );
          if (l = this.ruleDate, o = this._nextRecurrenceIter(this.last), !l && !o) {
            this.complete = !0;
            break;
          }
          if ((!l || o && l.compare(o.last) > 0) && (l = o.last.clone(), o.next()), this.ruleDate === l && this._nextRuleDay(), this.last = l, this.exDate && (a = this.exDate.compare(this.last), a < 0 && this._nextExDay(), a === 0)) {
            this._nextExDay();
            continue;
          }
          return this.last;
        }
      },
      /**
       * Converts object into a serialize-able format. This format can be passed
       * back into the expansion to resume iteration.
       * @return {Object}
       */
      toJSON: function() {
        function o(a) {
          return a.toJSON();
        }
        var l = /* @__PURE__ */ Object.create(null);
        return l.ruleIterators = this.ruleIterators.map(o), this.ruleDates && (l.ruleDates = this.ruleDates.map(o)), this.exDates && (l.exDates = this.exDates.map(o)), l.ruleDateInc = this.ruleDateInc, l.exDateInc = this.exDateInc, l.last = this.last.toJSON(), l.dtstart = this.dtstart.toJSON(), l.complete = this.complete, l;
      },
      /**
       * Extract all dates from the properties in the given component. The
       * properties will be filtered by the property name.
       *
       * @private
       * @param {ICAL.Component} component        The component to search in
       * @param {String} propertyName             The property name to search for
       * @return {ICAL.Time[]}                    The extracted dates.
       */
      _extractDates: function(o, l) {
        function a(f) {
          A = e.helpers.binsearchInsert(
            c,
            f,
            n
          ), c.splice(A, 0, f);
        }
        for (var c = [], T = o.getAllProperties(l), u = T.length, d = 0, A; d < u; d++)
          T[d].getValues().forEach(a);
        return c;
      },
      /**
       * Initialize the recurrence expansion.
       *
       * @private
       * @param {ICAL.Component} component    The component to initialize from.
       */
      _init: function(o) {
        if (this.ruleIterators = [], this.last = this.dtstart.clone(), !i(o)) {
          this.ruleDate = this.last.clone(), this.complete = !0;
          return;
        }
        if (o.hasProperty("rdate") && (this.ruleDates = this._extractDates(o, "rdate"), this.ruleDates[0] && this.ruleDates[0].compare(this.dtstart) < 0 ? (this.ruleDateInc = 0, this.last = this.ruleDates[0].clone()) : this.ruleDateInc = e.helpers.binsearchInsert(
          this.ruleDates,
          this.last,
          n
        ), this.ruleDate = this.ruleDates[this.ruleDateInc]), o.hasProperty("rrule"))
          for (var l = o.getAllProperties("rrule"), a = 0, c = l.length, T, u; a < c; a++)
            T = l[a].getFirstValue(), u = T.iterator(this.dtstart), this.ruleIterators.push(u), u.next();
        o.hasProperty("exdate") && (this.exDates = this._extractDates(o, "exdate"), this.exDateInc = e.helpers.binsearchInsert(
          this.exDates,
          this.last,
          n
        ), this.exDate = this.exDates[this.exDateInc]);
      },
      /**
       * Advance to the next exdate
       * @private
       */
      _nextExDay: function() {
        this.exDate = this.exDates[++this.exDateInc];
      },
      /**
       * Advance to the next rule date
       * @private
       */
      _nextRuleDay: function() {
        this.ruleDate = this.ruleDates[++this.ruleDateInc];
      },
      /**
       * Find and return the recurrence rule with the most recent event and
       * return it.
       *
       * @private
       * @return {?ICAL.RecurIterator}    Found iterator.
       */
      _nextRecurrenceIter: function() {
        var o = this.ruleIterators;
        if (o.length === 0)
          return null;
        for (var l = o.length, a, c, T = 0, u; T < l; T++) {
          if (a = o[T], c = a.last, a.completed) {
            l--, T !== 0 && T--, o.splice(T, 1);
            continue;
          }
          (!u || u.last.compare(c) > 0) && (u = a);
        }
        return u;
      }
    }, s;
  }(), e.Event = function() {
    function t(i, s) {
      i instanceof e.Component || (s = i, i = null), i ? this.component = i : this.component = new e.Component("vevent"), this._rangeExceptionCache = /* @__PURE__ */ Object.create(null), this.exceptions = /* @__PURE__ */ Object.create(null), this.rangeExceptions = [], s && s.strictExceptions && (this.strictExceptions = s.strictExceptions), s && s.exceptions ? s.exceptions.forEach(this.relateException, this) : this.component.parent && !this.isRecurrenceException() && this.component.parent.getAllSubcomponents("vevent").forEach(function(o) {
        o.hasProperty("recurrence-id") && this.relateException(o);
      }, this);
    }
    t.prototype = {
      THISANDFUTURE: "THISANDFUTURE",
      /**
       * List of related event exceptions.
       *
       * @type {ICAL.Event[]}
       */
      exceptions: null,
      /**
       * When true, will verify exceptions are related by their UUID.
       *
       * @type {Boolean}
       */
      strictExceptions: !1,
      /**
       * Relates a given event exception to this object.  If the given component
       * does not share the UID of this event it cannot be related and will throw
       * an exception.
       *
       * If this component is an exception it cannot have other exceptions
       * related to it.
       *
       * @param {ICAL.Component|ICAL.Event} obj       Component or event
       */
      relateException: function(i) {
        if (this.isRecurrenceException())
          throw new Error("cannot relate exception to exceptions");
        if (i instanceof e.Component && (i = new e.Event(i)), this.strictExceptions && i.uid !== this.uid)
          throw new Error("attempted to relate unrelated exception");
        var s = i.recurrenceId.toString();
        if (this.exceptions[s] = i, i.modifiesFuture()) {
          var o = [
            i.recurrenceId.toUnixTime(),
            s
          ], l = e.helpers.binsearchInsert(
            this.rangeExceptions,
            o,
            n
          );
          this.rangeExceptions.splice(l, 0, o);
        }
      },
      /**
       * Checks if this record is an exception and has the RANGE=THISANDFUTURE
       * value.
       *
       * @return {Boolean}        True, when exception is within range
       */
      modifiesFuture: function() {
        if (!this.component.hasProperty("recurrence-id"))
          return !1;
        var i = this.component.getFirstProperty("recurrence-id").getParameter("range");
        return i === this.THISANDFUTURE;
      },
      /**
       * Finds the range exception nearest to the given date.
       *
       * @param {ICAL.Time} time usually an occurrence time of an event
       * @return {?ICAL.Event} the related event/exception or null
       */
      findRangeException: function(i) {
        if (!this.rangeExceptions.length)
          return null;
        var s = i.toUnixTime(), o = e.helpers.binsearchInsert(
          this.rangeExceptions,
          [s],
          n
        );
        if (o -= 1, o < 0)
          return null;
        var l = this.rangeExceptions[o];
        return s < l[0] ? null : l[1];
      },
      /**
       * This object is returned by {@link ICAL.Event#getOccurrenceDetails getOccurrenceDetails}
       *
       * @typedef {Object} occurrenceDetails
       * @memberof ICAL.Event
       * @property {ICAL.Time} recurrenceId       The passed in recurrence id
       * @property {ICAL.Event} item              The occurrence
       * @property {ICAL.Time} startDate          The start of the occurrence
       * @property {ICAL.Time} endDate            The end of the occurrence
       */
      /**
       * Returns the occurrence details based on its start time.  If the
       * occurrence has an exception will return the details for that exception.
       *
       * NOTE: this method is intend to be used in conjunction
       *       with the {@link ICAL.Event#iterator iterator} method.
       *
       * @param {ICAL.Time} occurrence time occurrence
       * @return {ICAL.Event.occurrenceDetails} Information about the occurrence
       */
      getOccurrenceDetails: function(i) {
        var s = i.toString(), o = i.convertToZone(e.Timezone.utcTimezone).toString(), l, a = {
          //XXX: Clone?
          recurrenceId: i
        };
        if (s in this.exceptions)
          l = a.item = this.exceptions[s], a.startDate = l.startDate, a.endDate = l.endDate, a.item = l;
        else if (o in this.exceptions)
          l = this.exceptions[o], a.startDate = l.startDate, a.endDate = l.endDate, a.item = l;
        else {
          var c = this.findRangeException(
            i
          ), T;
          if (c) {
            var u = this.exceptions[c];
            a.item = u;
            var d = this._rangeExceptionCache[c];
            if (!d) {
              var A = u.recurrenceId.clone(), f = u.startDate.clone();
              A.zone = f.zone, d = f.subtractDate(A), this._rangeExceptionCache[c] = d;
            }
            var h = i.clone();
            h.zone = u.startDate.zone, h.addDuration(d), T = h.clone(), T.addDuration(u.duration), a.startDate = h, a.endDate = T;
          } else
            T = i.clone(), T.addDuration(this.duration), a.endDate = T, a.startDate = i, a.item = this;
        }
        return a;
      },
      /**
       * Builds a recur expansion instance for a specific point in time (defaults
       * to startDate).
       *
       * @param {ICAL.Time} startTime     Starting point for expansion
       * @return {ICAL.RecurExpansion}    Expansion object
       */
      iterator: function(i) {
        return new e.RecurExpansion({
          component: this.component,
          dtstart: i || this.startDate
        });
      },
      /**
       * Checks if the event is recurring
       *
       * @return {Boolean}        True, if event is recurring
       */
      isRecurring: function() {
        var i = this.component;
        return i.hasProperty("rrule") || i.hasProperty("rdate");
      },
      /**
       * Checks if the event describes a recurrence exception. See
       * {@tutorial terminology} for details.
       *
       * @return {Boolean}    True, if the event describes a recurrence exception
       */
      isRecurrenceException: function() {
        return this.component.hasProperty("recurrence-id");
      },
      /**
       * Returns the types of recurrences this event may have.
       *
       * Returned as an object with the following possible keys:
       *
       *    - YEARLY
       *    - MONTHLY
       *    - WEEKLY
       *    - DAILY
       *    - MINUTELY
       *    - SECONDLY
       *
       * @return {Object.<ICAL.Recur.frequencyValues, Boolean>}
       *          Object of recurrence flags
       */
      getRecurrenceTypes: function() {
        for (var i = this.component.getAllProperties("rrule"), s = 0, o = i.length, l = /* @__PURE__ */ Object.create(null); s < o; s++) {
          var a = i[s].getFirstValue();
          l[a.freq] = !0;
        }
        return l;
      },
      /**
       * The uid of this event
       * @type {String}
       */
      get uid() {
        return this._firstProp("uid");
      },
      set uid(i) {
        this._setProp("uid", i);
      },
      /**
       * The start date
       * @type {ICAL.Time}
       */
      get startDate() {
        return this._firstProp("dtstart");
      },
      set startDate(i) {
        this._setTime("dtstart", i);
      },
      /**
       * The end date. This can be the result directly from the property, or the
       * end date calculated from start date and duration. Setting the property
       * will remove any duration properties.
       * @type {ICAL.Time}
       */
      get endDate() {
        var i = this._firstProp("dtend");
        if (!i) {
          var s = this._firstProp("duration");
          i = this.startDate.clone(), s ? i.addDuration(s) : i.isDate && (i.day += 1);
        }
        return i;
      },
      set endDate(i) {
        this.component.hasProperty("duration") && this.component.removeProperty("duration"), this._setTime("dtend", i);
      },
      /**
       * The duration. This can be the result directly from the property, or the
       * duration calculated from start date and end date. Setting the property
       * will remove any `dtend` properties.
       * @type {ICAL.Duration}
       */
      get duration() {
        var i = this._firstProp("duration");
        return i || this.endDate.subtractDateTz(this.startDate);
      },
      set duration(i) {
        this.component.hasProperty("dtend") && this.component.removeProperty("dtend"), this._setProp("duration", i);
      },
      /**
       * The location of the event.
       * @type {String}
       */
      get location() {
        return this._firstProp("location");
      },
      set location(i) {
        return this._setProp("location", i);
      },
      /**
       * The attendees in the event
       * @type {ICAL.Property[]}
       * @readonly
       */
      get attendees() {
        return this.component.getAllProperties("attendee");
      },
      /**
       * The event summary
       * @type {String}
       */
      get summary() {
        return this._firstProp("summary");
      },
      set summary(i) {
        this._setProp("summary", i);
      },
      /**
       * The event description.
       * @type {String}
       */
      get description() {
        return this._firstProp("description");
      },
      set description(i) {
        this._setProp("description", i);
      },
      /**
       * The event color from [rfc7986](https://datatracker.ietf.org/doc/html/rfc7986)
       * @type {String}
       */
      get color() {
        return this._firstProp("color");
      },
      set color(i) {
        this._setProp("color", i);
      },
      /**
       * The organizer value as an uri. In most cases this is a mailto: uri, but
       * it can also be something else, like urn:uuid:...
       * @type {String}
       */
      get organizer() {
        return this._firstProp("organizer");
      },
      set organizer(i) {
        this._setProp("organizer", i);
      },
      /**
       * The sequence value for this event. Used for scheduling
       * see {@tutorial terminology}.
       * @type {Number}
       */
      get sequence() {
        return this._firstProp("sequence");
      },
      set sequence(i) {
        this._setProp("sequence", i);
      },
      /**
       * The recurrence id for this event. See {@tutorial terminology} for details.
       * @type {ICAL.Time}
       */
      get recurrenceId() {
        return this._firstProp("recurrence-id");
      },
      set recurrenceId(i) {
        this._setTime("recurrence-id", i);
      },
      /**
       * Set/update a time property's value.
       * This will also update the TZID of the property.
       *
       * TODO: this method handles the case where we are switching
       * from a known timezone to an implied timezone (one without TZID).
       * This does _not_ handle the case of moving between a known
       *  (by TimezoneService) timezone to an unknown timezone...
       *
       * We will not add/remove/update the VTIMEZONE subcomponents
       *  leading to invalid ICAL data...
       * @private
       * @param {String} propName     The property name
       * @param {ICAL.Time} time      The time to set
       */
      _setTime: function(i, s) {
        var o = this.component.getFirstProperty(i);
        o || (o = new e.Property(i), this.component.addProperty(o)), s.zone === e.Timezone.localTimezone || s.zone === e.Timezone.utcTimezone ? o.removeParameter("tzid") : o.setParameter("tzid", s.zone.tzid), o.setValue(s);
      },
      _setProp: function(i, s) {
        this.component.updatePropertyWithValue(i, s);
      },
      _firstProp: function(i) {
        return this.component.getFirstPropertyValue(i);
      },
      /**
       * The string representation of this event.
       * @return {String}
       */
      toString: function() {
        return this.component.toString();
      }
    };
    function n(i, s) {
      return i[0] > s[0] ? 1 : s[0] > i[0] ? -1 : 0;
    }
    return t;
  }(), e.ComponentParser = function() {
    function t(n) {
      typeof n > "u" && (n = {});
      var i;
      for (i in n)
        n.hasOwnProperty(i) && (this[i] = n[i]);
    }
    return t.prototype = {
      /**
       * When true, parse events
       *
       * @type {Boolean}
       */
      parseEvent: !0,
      /**
       * When true, parse timezones
       *
       * @type {Boolean}
       */
      parseTimezone: !0,
      /* SAX like events here for reference */
      /**
       * Fired when parsing is complete
       * @callback
       */
      oncomplete: (
        /* istanbul ignore next */
        function() {
        }
      ),
      /**
       * Fired if an error occurs during parsing.
       *
       * @callback
       * @param {Error} err details of error
       */
      onerror: (
        /* istanbul ignore next */
        function(n) {
        }
      ),
      /**
       * Fired when a top level component (VTIMEZONE) is found
       *
       * @callback
       * @param {ICAL.Timezone} component     Timezone object
       */
      ontimezone: (
        /* istanbul ignore next */
        function(n) {
        }
      ),
      /**
       * Fired when a top level component (VEVENT) is found.
       *
       * @callback
       * @param {ICAL.Event} component    Top level component
       */
      onevent: (
        /* istanbul ignore next */
        function(n) {
        }
      ),
      /**
       * Process a string or parse ical object.  This function itself will return
       * nothing but will start the parsing process.
       *
       * Events must be registered prior to calling this method.
       *
       * @param {ICAL.Component|String|Object} ical      The component to process,
       *        either in its final form, as a jCal Object, or string representation
       */
      process: function(n) {
        typeof n == "string" && (n = e.parse(n)), n instanceof e.Component || (n = new e.Component(n));
        for (var i = n.getAllSubcomponents(), s = 0, o = i.length, l; s < o; s++)
          switch (l = i[s], l.name) {
            case "vtimezone":
              if (this.parseTimezone) {
                var a = l.getFirstPropertyValue("tzid");
                a && this.ontimezone(new e.Timezone({
                  tzid: a,
                  component: l
                }));
              }
              break;
            case "vevent":
              this.parseEvent && this.onevent(new e.Event(l));
              break;
            default:
              continue;
          }
        this.oncomplete();
      }
    }, t;
  }();
})(LE);
var Si, kE = new Uint8Array(16);
function PE() {
  if (!Si && (Si = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !Si))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return Si(kE);
}
const GE = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function UE(r) {
  return typeof r == "string" && GE.test(r);
}
var it = [];
for (var uo = 0; uo < 256; ++uo)
  it.push((uo + 256).toString(16).substr(1));
function HE(r) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, t = (it[r[e + 0]] + it[r[e + 1]] + it[r[e + 2]] + it[r[e + 3]] + "-" + it[r[e + 4]] + it[r[e + 5]] + "-" + it[r[e + 6]] + it[r[e + 7]] + "-" + it[r[e + 8]] + it[r[e + 9]] + "-" + it[r[e + 10]] + it[r[e + 11]] + it[r[e + 12]] + it[r[e + 13]] + it[r[e + 14]] + it[r[e + 15]]).toLowerCase();
  if (!UE(t))
    throw TypeError("Stringified UUID is invalid");
  return t;
}
function va(r, e, t) {
  r = r || {};
  var n = r.random || (r.rng || PE)();
  if (n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, e) {
    t = t || 0;
    for (var i = 0; i < 16; ++i)
      e[t + i] = n[i];
    return e;
  }
  return HE(n);
}
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class Na {
  /**
   * @constructor
   *
   * @param {Object=} options Object of options
   * @param {boolean=} options.extractGlobalProperties Whether or not to preserve properties from the VCALENDAR component (defaults to false)
   * @param {boolean=} options.removeRSVPForAttendees Whether or not to remove RSVP from attendees (defaults to false)
   * @param {boolean=} options.includeTimezones Whether or not to include timezones (defaults to false)
   * @param {boolean=} options.preserveMethod Whether or not to preserve the iCalendar method (defaults to false)
   * @param {boolean=} options.processFreeBusy Whether or not to process VFreeBusy components (defaults to false)
   */
  constructor(e = {}) {
    if (new.target === Na)
      throw new TypeError("Cannot instantiate abstract class AbstractParser");
    this._options = Object.assign({}, e), this._name = null, this._color = null, this._sourceURL = null, this._refreshInterval = null, this._calendarTimezone = null, this._errors = [];
  }
  /**
   * Gets the name extracted from the calendar-data
   *
   * @return {String|null}
   */
  getName() {
    return this._name;
  }
  /**
   * Gets the color extracted from the calendar-data
   *
   * @return {String|null}
   */
  getColor() {
    return this._color;
  }
  /**
   * Gets whether this import can be converted into a webcal subscription
   *
   * @return {boolean}
   */
  offersWebcalFeed() {
    return this._sourceURL !== null;
  }
  /**
   * Gets the url pointing to the webcal source
   *
   * @return {String|null}
   */
  getSourceURL() {
    return this._sourceURL;
  }
  /**
   * Gets the recommended refresh rate to update this subscription
   *
   * @return {String|null}
   */
  getRefreshInterval() {
    return this._refreshInterval;
  }
  /**
   * Gets the default timezone of this calendar
   *
   * @return {string}
   */
  getCalendarTimezone() {
    return this._calendarTimezone;
  }
  /**
   * {String|Object} data
   *
   * @param {any} data The data to parse
   * @throws TypeError
   */
  parse(e) {
    throw new TypeError("Abstract method not implemented by subclass");
  }
  /**
   * Returns one CalendarComponent at a time
   */
  *getItemIterator() {
    throw new TypeError("Abstract method not implemented by subclass");
  }
  /**
   * Get an array of all items
   *
   * @return {CalendarComponent[]}
   */
  getAllItems() {
    return Array.from(this.getItemIterator());
  }
  /**
   * Returns a boolean whether or not the parsed data contains vevents
   *
   * @return {boolean}
   */
  containsVEvents() {
    return !1;
  }
  /**
   * Returns a boolean whether or not the parsed data contains vjournals
   *
   * @return {boolean}
   */
  containsVJournals() {
    return !1;
  }
  /**
   * Returns a boolean whether or not the parsed data contains vtodos
   *
   * @return {boolean}
   */
  containsVTodos() {
    return !1;
  }
  /**
   * Returns a boolean whether or not the parsed data contains vfreebusys
   *
   * @return {boolean}
   */
  containsVFreeBusy() {
    return !1;
  }
  /**
   * Returns a boolean whether
   *
   * @return {boolean}
   */
  hasErrors() {
    return this._errors.length !== 0;
  }
  /**
   * Get a list of all errors that occurred
   *
   * @return {*[]}
   */
  getErrorList() {
    return this._errors.slice();
  }
  /**
   * Returns the number of calendar-objects in parser
   *
   * @return {number}
   */
  getItemCount() {
    return 0;
  }
  /**
   * Gets an option provided
   *
   * @param {string} name The name of the option to get
   * @param {*} defaultValue The default value to return if option not provided
   * @return {any}
   * @protected
   */
  _getOption(e, t) {
    return Object.prototype.hasOwnProperty.call(this._options, e) ? this._options[e] : t;
  }
  /**
   * Return list of supported mime types
   *
   * @static
   */
  static getMimeTypes() {
    throw new TypeError("Abstract method not implemented by subclass");
  }
}
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class Au extends Error {
}
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
function Fa(r) {
  return class extends r {
    /**
     * Constructor
     */
    constructor(...e) {
      super(...e), this._mutable = !0;
    }
    /**
     * Returns whether or not this object is locked
     *
     * @return {boolean}
     */
    isLocked() {
      return !this._mutable;
    }
    /**
     * Marks this object is immutable
     * locks it against further modification
     */
    lock() {
      this._mutable = !1;
    }
    /**
     * Marks this object as mutable
     * allowing further modification
     */
    unlock() {
      this._mutable = !0;
    }
    /**
     * Check if modifications are allowed
     *
     * @throws {ModificationNotAllowedError} if this object is locked for modification
     * @protected
     */
    _modify() {
      if (!this._mutable)
        throw new Au();
    }
    /**
     * Check if modification of content is allowed
     *
     * @throws {ModificationNotAllowedError} if this object is locked for modification
     * @protected
     */
    _modifyContent() {
      this._modify();
    }
  };
}
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class fu extends Error {
}
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
function Vt(r) {
  return r.toLowerCase();
}
function Le(r) {
  return r.toUpperCase();
}
function Tt(r) {
  return r.charAt(0).toUpperCase() + r.slice(1);
}
function co(r, e) {
  return r.startsWith(e) || (r = e + r), r;
}
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
const Xp = /* @__PURE__ */ new Map();
function jE(r, e) {
  Xp.set(r, e);
}
function Ll(r, e) {
  return Xp.get(r) || e;
}
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
function zE(r) {
  return new ge.Component(Vt(r));
}
function pu(r) {
  return new ge.Property(Vt(r));
}
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
function Oa(r) {
  return class extends r {
    /**
     * Constructor
     */
    constructor(...e) {
      super(...e), this._subscribers = [];
    }
    /**
     * Adds a new subscriber
     *
     * @param {Function} handler - Handler to be called when modification happens
     */
    subscribe(e) {
      this._subscribers.push(e);
    }
    /**
     * Removes a subscriber
     *
     * @param {Function} handler - Handler to be no longer called when modification happens
     */
    unsubscribe(e) {
      const t = this._subscribers.indexOf(e);
      t !== -1 && this._subscribers.splice(t, 1);
    }
    /**
     * Notify all subscribed handlers
     *
     * @protected
     */
    _notifySubscribers(...e) {
      for (const t of this._subscribers)
        t(...e);
    }
  };
}
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class nn extends Oa(Fa(class {
})) {
  /**
   * Constructor
   *
   * @param {string} name The name of the parameter
   * @param {string|Array|null} value The value of the parameter
   */
  constructor(e, t = null) {
    super(), this._name = Le(e), this._value = t;
  }
  /**
   * Get parameter name
   *
   * @readonly
   * @return {string}
   */
  get name() {
    return this._name;
  }
  /**
   * Get parameter value
   *
   * @return {String|Array}
   */
  get value() {
    return this._value;
  }
  /**
   * Set new parameter value
   *
   * @throws {ModificationNotAllowedError} if parameter is locked for modification
   * @param {String|Array} value The new value to set
   */
  set value(e) {
    this._modifyContent(), this._value = e;
  }
  /**
   * Gets the first value of this parameter
   *
   * @return {String|null}
   */
  getFirstValue() {
    if (this.isMultiValue()) {
      if (this.value.length > 0)
        return this.value[0];
    } else
      return this.value;
    return null;
  }
  /**
   * Gets an iterator for all values
   */
  *getValueIterator() {
    this.isMultiValue() ? yield* this.value.slice()[Symbol.iterator]() : yield this.value;
  }
  /**
   * Returns whether or not the value is a multivalue
   *
   * @return {boolean}
   */
  isMultiValue() {
    return Array.isArray(this._value);
  }
  /**
   * Creates a copy of this parameter
   *
   * @return {Parameter}
   */
  clone() {
    const e = new this.constructor(this._name);
    return this.isMultiValue() ? e.value = this._value.slice() : e.value = this._value, e;
  }
  /**
   * @inheritDoc
   */
  _modifyContent() {
    super._modifyContent(), this._notifySubscribers();
  }
}
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class Ot extends Oa(Fa(class {
})) {
  /**
   * Constructor
   *
   * @param {ICAL.Binary|ICAL.Duration|ICAL.Period|ICAL.Recur|ICAL.Time|ICAL.UtcOffset} icalValue The ICAL.JS object to wrap
   */
  constructor(e) {
    if (new.target === Ot)
      throw new TypeError("Cannot instantiate abstract class AbstractValue");
    super(), this._innerValue = e;
  }
  /**
   * Gets wrapped ICAL.JS object
   *
   * @return {*}
   */
  toICALJs() {
    return this._innerValue;
  }
  /**
   * @inheritDoc
   */
  _modifyContent() {
    super._modifyContent(), this._notifySubscribers();
  }
}
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class ft extends Ot {
  /**
   * Sets the raw b64 encoded value
   *
   * @return {string}
   */
  get rawValue() {
    return this._innerValue.value;
  }
  /**
   * Gets the raw b64 encoded value
   *
   * @throws {ModificationNotAllowedError} if value is locked for modification
   * @param {string} value - The new raw value
   */
  set rawValue(e) {
    this._modifyContent(), this._innerValue.value = e;
  }
  /**
   * Gets the decoded value
   *
   * @return {string}
   */
  get value() {
    return this._innerValue.decodeValue();
  }
  /**
   * Sets the decoded Value
   *
   * @throws {ModificationNotAllowedError} if value is locked for modification
   * @param  {string} decodedValue - The new encoded value
   */
  set value(e) {
    this._modifyContent(), this._innerValue.setEncodedValue(e);
  }
  /**
   * clones this value
   *
   * @return {BinaryValue}
   */
  clone() {
    return ft.fromRawValue(this._innerValue.value);
  }
  /**
   * Create a new BinaryValue object from an ICAL.Binary object
   *
   * @param {ICAL.Binary} icalValue - The ICAL.Binary object
   * @return {BinaryValue}
   */
  static fromICALJs(e) {
    return new ft(e);
  }
  /**
   * Create a new BinaryValue object from a raw b64 encoded value
   *
   * @param {string} rawValue - The raw value
   * @return {BinaryValue}
   */
  static fromRawValue(e) {
    const t = new ge.Binary(e);
    return ft.fromICALJs(t);
  }
  /**
   * Create a new BinaryValue object from decoded value
   *
   * @param {string} decodedValue - The encoded value
   * @return {BinaryValue}
   */
  static fromDecodedValue(e) {
    const t = new ge.Binary();
    return t.setEncodedValue(e), ft.fromICALJs(t);
  }
}
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class yt extends Ot {
  /**
   * Gets the weeks of the stored duration-value
   *
   * @return {Number}
   */
  get weeks() {
    return this._innerValue.weeks;
  }
  /**
   * Sets the weeks of the stored duration-value
   *
   * @throws {ModificationNotAllowedError} if value is locked for modification
   * @throws {TypeError} if value is negative
   * @param {Number} weeks Amount of weeks
   */
  set weeks(e) {
    if (this._modifyContent(), e < 0)
      throw new TypeError("Weeks cannot be negative, use isNegative instead");
    this._innerValue.weeks = e;
  }
  /**
   * Gets the days of the stored duration-value
   *
   * @return {Number}
   */
  get days() {
    return this._innerValue.days;
  }
  /**
   * Sets the days of the stored duration-value
   *
   * @throws {ModificationNotAllowedError} if value is locked for modification
   * @throws {TypeError} if value is negative
   * @param {Number} days Amount of days
   */
  set days(e) {
    if (this._modifyContent(), e < 0)
      throw new TypeError("Days cannot be negative, use isNegative instead");
    this._innerValue.days = e;
  }
  /**
   * Gets the hours of the stored duration-value
   *
   * @return {Number}
   */
  get hours() {
    return this._innerValue.hours;
  }
  /**
   * Sets the weeks of the stored duration-value
   *
   * @throws {ModificationNotAllowedError} if value is locked for modification
   * @throws {TypeError} if value is negative
   * @param {Number} hours Amount of hours
   */
  set hours(e) {
    if (this._modifyContent(), e < 0)
      throw new TypeError("Hours cannot be negative, use isNegative instead");
    this._innerValue.hours = e;
  }
  /**
   * Gets the minutes of the stored duration-value
   *
   * @return {Number}
   */
  get minutes() {
    return this._innerValue.minutes;
  }
  /**
   * Sets the minutes of the stored duration-value
   *
   * @throws {ModificationNotAllowedError} if value is locked for modification
   * @throws {TypeError} if value is negative
   * @param {Number} minutes Amount of minutes
   */
  set minutes(e) {
    if (this._modifyContent(), e < 0)
      throw new TypeError("Minutes cannot be negative, use isNegative instead");
    this._innerValue.minutes = e;
  }
  /**
   * Gets the seconds of the stored duration-value
   *
   * @return {Number}
   */
  get seconds() {
    return this._innerValue.seconds;
  }
  /**
   * Sets the seconds of the stored duration-value
   *
   * @throws {ModificationNotAllowedError} if value is locked for modification
   * @throws {TypeError} if value is negative
   * @param {Number} seconds Amount of seconds
   */
  set seconds(e) {
    if (this._modifyContent(), e < 0)
      throw new TypeError("Seconds cannot be negative, use isNegative instead");
    this._innerValue.seconds = e;
  }
  /**
   * Gets the negative-indicator of the stored duration-value
   *
   * @return {boolean}
   */
  get isNegative() {
    return this._innerValue.isNegative;
  }
  /**
   * Gets the negative-indicator of the stored duration-value
   *
   * @throws {ModificationNotAllowedError} if value is locked for modification
   * @param {boolean} isNegative Whether or not the duration is negative
   */
  set isNegative(e) {
    this._modifyContent(), this._innerValue.isNegative = !!e;
  }
  /**
   * Gets the amount of total seconds of the stored duration-value
   *
   * @return {*|Number}
   */
  get totalSeconds() {
    return this._innerValue.toSeconds();
  }
  /**
   * Sets the amount of total seconds of the stored duration-value
   *
   * @throws {ModificationNotAllowedError} if value is locked for modification
   * @param {Number} totalSeconds The total amounts of seconds to set
   */
  set totalSeconds(e) {
    this._modifyContent(), this._innerValue.fromSeconds(e);
  }
  /**
   * Compares this duration to another one
   *
   * @param {DurationValue} otherDuration The duration to compare to
   * @return {Number} -1, 0 or 1 for less/equal/greater
   */
  compare(e) {
    return this._innerValue.compare(e.toICALJs());
  }
  /**
   * Adds the value of another duration to this one
   *
   * @throws {ModificationNotAllowedError} if value is locked for modification
   * @param {DurationValue} otherDuration The duration to add
   */
  addDuration(e) {
    this._modifyContent(), this.totalSeconds += e.totalSeconds, this._innerValue.normalize();
  }
  /**
   * Subtract the value of another duration from this one
   *
   * @throws {ModificationNotAllowedError} if value is locked for modification
   * @param {DurationValue} otherDuration The duration to subtract
   */
  subtractDuration(e) {
    this._modifyContent(), this.totalSeconds -= e.totalSeconds, this._innerValue.normalize();
  }
  /**
   * clones this value
   *
   * @return {DurationValue}
   */
  clone() {
    return yt.fromICALJs(this._innerValue.clone());
  }
  /**
   * Create a new DurationValue object from an ICAL.Duration object
   *
   * @param {ICAL.Duration} icalValue The ical.js duration value
   * @return {DurationValue}
   */
  static fromICALJs(e) {
    return new yt(e);
  }
  /**
   * Create a new DurationValue object from a number of seconds
   *
   * @param {Number} seconds Total amount of seconds
   * @return {DurationValue}
   */
  static fromSeconds(e) {
    const t = ge.Duration.fromSeconds(e);
    return new yt(t);
  }
  /**
   * Create a new DurationValue object from data
   *
   * @param {Object} data The destructuring object
   * @param {Number=} data.weeks Number of weeks to set
   * @param {Number=} data.days Number of days to set
   * @param {Number=} data.hours Number of hours to set
   * @param {Number=} data.minutes Number of minutes to set
   * @param {Number=} data.seconds Number of seconds to set
   * @param {boolean=} data.isNegative Whether or not duration is negative
   * @return {DurationValue}
   */
  static fromData(e) {
    const t = ge.Duration.fromData(e);
    return new yt(t);
  }
}
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class Oe extends Ot {
  /**
   * Gets the year of the stored date-time-value
   *
   * @return {Number}
   */
  get year() {
    return this._innerValue.year;
  }
  /**
   * Sets the year of the stored date-time-value
   *
   * @throws {ModificationNotAllowedError} if value is locked for modification
   * @param {Number} year Number of years to set
   */
  set year(e) {
    this._modifyContent(), this._innerValue.year = e;
  }
  /**
   * Gets the month of the stored date-time-value
   *
   * @return {Number}
   */
  get month() {
    return this._innerValue.month;
  }
  /**
   * Sets the month of the stored date-time-value
   *
   * @throws {ModificationNotAllowedError} if value is locked for modification
   * @param {Number} month Number of months to set
   */
  set month(e) {
    if (this._modifyContent(), e < 1 || e > 12)
      throw new TypeError("Month out of range");
    this._innerValue.month = e;
  }
  /**
   * Gets the day of the stored date-time-value
   *
   * @return {Number}
   */
  get day() {
    return this._innerValue.day;
  }
  /**
   * Sets the day of the stored date-time-value
   *
   * @throws {ModificationNotAllowedError} if value is locked for modification
   * @throws {TypeError} if out of range
   * @param {Number} day Number of days to set
   */
  set day(e) {
    if (this._modifyContent(), e < 1 || e > 31)
      throw new TypeError("Day out of range");
    this._innerValue.day = e;
  }
  /**
   * Gets the hour of the stored date-time-value
   *
   * @return {Number}
   */
  get hour() {
    return this._innerValue.hour;
  }
  /**
   * Sets the hour of the stored date-time-value
   *
   * @throws {ModificationNotAllowedError} if value is locked for modification
   * @throws {TypeError} if out of range
   * @param {Number} hour Number of hours to set
   */
  set hour(e) {
    if (this._modifyContent(), e < 0 || e > 23)
      throw new TypeError("Hour out of range");
    this._innerValue.hour = e;
  }
  /**
   * Gets the minute of the stored date-time-value
   *
   * @return {Number}
   */
  get minute() {
    return this._innerValue.minute;
  }
  /**
   * Sets the minute of the stored date-time-value
   *
   * @throws {ModificationNotAllowedError} if value is locked for modification
   * @throws {TypeError} if out of range
   * @param {Number} minute Number of minutes to set
   */
  set minute(e) {
    if (this._modifyContent(), e < 0 || e > 59)
      throw new TypeError("Minute out of range");
    this._innerValue.minute = e;
  }
  /**
   * Gets the second of the stored date-time-value
   *
   * @return {Number}
   */
  get second() {
    return this._innerValue.second;
  }
  /**
   * Sets the second of the stored date-time-value
   *
   * @throws {ModificationNotAllowedError} if value is locked for modification
   * @throws {TypeError} if out of range
   * @param {Number} second Number of seconds to set
   */
  set second(e) {
    if (this._modifyContent(), e < 0 || e > 59)
      throw new TypeError("Second out of range");
    this._innerValue.second = e;
  }
  /**
   * Gets the timezone of this date-time-value
   *
   * @return {String|null}
   */
  get timezoneId() {
    return this._innerValue.zone.tzid && this._innerValue.zone.tzid !== "floating" && this._innerValue.zone.tzid === "UTC" ? this._innerValue.zone.tzid : this._innerValue.timezone ? this._innerValue.timezone : this._innerValue.zone.tzid || null;
  }
  /**
   * Gets whether this date-time-value is a date or date-time
   *
   * @return {boolean}
   */
  get isDate() {
    return this._innerValue.isDate;
  }
  /**
   * Sets whether this date-time-value is a date or date-time
   *
   * @throws {ModificationNotAllowedError} if value is locked for modification
   * @param {boolean} isDate Whether this is a date or date-time value
   */
  set isDate(e) {
    this._modifyContent(), this._innerValue.isDate = !!e, e && (this._innerValue.hour = 0, this._innerValue.minute = 0, this._innerValue.second = 0);
  }
  /**
   * Gets the unix-time
   *
   * @return {Number}
   */
  get unixTime() {
    return this._innerValue.toUnixTime();
  }
  /**
   * returns vanilla javascript date object
   *
   * @return {Date}
   */
  get jsDate() {
    return this._innerValue.toJSDate();
  }
  /**
   * Adds a duration to this date-time-value
   *
   * @param {DurationValue} duration The duration to ad
   */
  addDuration(e) {
    this._innerValue.addDuration(e.toICALJs());
  }
  /**
   * Subtract another date excluding timezones
   *
   * @param {DateTimeValue} other The date-time value to subtract
   * @return {DurationValue}
   */
  subtractDateWithoutTimezone(e) {
    const t = this._innerValue.subtractDate(e.toICALJs());
    return yt.fromICALJs(t);
  }
  /**
   * Subtract another date, taking timezones into account
   *
   * @param {DateTimeValue} other The date-time value to subtract
   * @return {DurationValue}
   */
  subtractDateWithTimezone(e) {
    const t = this._innerValue.subtractDateTz(e.toICALJs());
    return yt.fromICALJs(t);
  }
  /**
   * Compares this DateTimeValue object with another one
   *
   * @param {DateTimeValue} other The date-time to compare to
   * @return {Number} -1, 0 or 1 for less/equal/greater
   */
  compare(e) {
    return this._innerValue.compare(e.toICALJs());
  }
  /**
   * Compares only the date part in a given timezone
   *
   * @param {DateTimeValue} other The date-time to compare to
   * @param {Timezone} timezone The timezone to compare in
   * @return {Number} -1, 0 or 1 for less/equal/greater
   */
  compareDateOnlyInGivenTimezone(e, t) {
    return this._innerValue.compareDateOnlyTz(e.toICALJs(), t.toICALTimezone());
  }
  /**
   * Returns a clone of this object which was converted to a different timezone
   *
   * @param {Timezone} timezone TimezoneId to convert to
   * @return {DateTimeValue}
   */
  getInTimezone(e) {
    const t = this._innerValue.convertToZone(e.toICALTimezone());
    return Oe.fromICALJs(t);
  }
  /**
   * Get the inner ICAL.Timezone
   *
   * @return {ICAL.Timezone}
   * @package
   */
  getICALTimezone() {
    return this._innerValue.zone;
  }
  /**
   * Returns a clone of this object which was converted to a different timezone
   *
   * @param {ICAL.Timezone} timezone TimezoneId to convert to
   * @return {DateTimeValue}
   * @package
   */
  getInICALTimezone(e) {
    const t = this._innerValue.convertToZone(e);
    return Oe.fromICALJs(t);
  }
  /**
   * Returns a clone of this object which was converted to UTC
   *
   * @return {DateTimeValue}
   */
  getInUTC() {
    const e = this._innerValue.convertToZone(ge.Timezone.utcTimezone);
    return Oe.fromICALJs(e);
  }
  /**
   * This silently replaces the inner timezone without converting the actual time
   *
   * @param {ICAL.Timezone} timezone The timezone to replace with
   * @package
   */
  silentlyReplaceTimezone(e) {
    this._modify(), this._innerValue = new ge.Time({
      year: this.year,
      month: this.month,
      day: this.day,
      hour: this.hour,
      minute: this.minute,
      second: this.second,
      isDate: this.isDate,
      timezone: e
    });
  }
  /**
   * Replaces the inner timezone without converting the actual time
   *
   * @param {Timezone} timezone The timezone to replace with
   */
  replaceTimezone(e) {
    this._modifyContent(), this._innerValue = ge.Time.fromData({
      year: this.year,
      month: this.month,
      day: this.day,
      hour: this.hour,
      minute: this.minute,
      second: this.second,
      isDate: this.isDate
    }, e.toICALTimezone());
  }
  /**
   * Calculates the UTC offset of the date-time-value in its timezone
   *
   * @return {Number}
   */
  utcOffset() {
    return this._innerValue.utcOffset();
  }
  /**
   * Check if this is an event with floating time
   *
   * @return {boolean}
   */
  isFloatingTime() {
    return this._innerValue.zone.tzid === "floating";
  }
  /**
   * clones this value
   *
   * @return {DateTimeValue}
   */
  clone() {
    return Oe.fromICALJs(this._innerValue.clone());
  }
  /**
   * Create a new DateTimeValue object from an ICAL.Time object
   *
   * @param {ICAL.Time} icalValue The ical.js Date value to initialise from
   * @return {DateTimeValue}
   */
  static fromICALJs(e) {
    return new Oe(e);
  }
  /**
   * Creates a new DateTimeValue object based on a vanilla javascript object
   *
   * @param {Date} jsDate The JavaScript date to initialise from
   * @param {boolean=} useUTC Whether or not to treat it as UTC
   * @return {DateTimeValue}
   */
  static fromJSDate(e, t = !1) {
    const n = ge.Time.fromJSDate(e, t);
    return Oe.fromICALJs(n);
  }
  /**
   * Creates a new DateTimeValue object based on simple parameters
   *
   * @param {Object} data The destructuring object
   * @param {Number=} data.year Amount of years to set
   * @param {Number=} data.month Amount of month to set (1-based)
   * @param {Number=} data.day Amount of days to set
   * @param {Number=} data.hour Amount of hours to set
   * @param {Number=} data.minute Amount of minutes to set
   * @param {Number=} data.second Amount of seconds to set
   * @param {boolean=} data.isDate Whether this is a date or date-time
   * @param {Timezone=} timezone The timezone of the DateTimeValue
   * @return {DateTimeValue}
   */
  static fromData(e, t) {
    const n = ge.Time.fromData(e, t ? t.toICALTimezone() : void 0);
    return Oe.fromICALJs(n);
  }
}
Oe.SUNDAY = ge.Time.SUNDAY;
Oe.MONDAY = ge.Time.MONDAY;
Oe.TUESDAY = ge.Time.TUESDAY;
Oe.WEDNESDAY = ge.Time.WEDNESDAY;
Oe.THURSDAY = ge.Time.THURSDAY;
Oe.FRIDAY = ge.Time.FRIDAY;
Oe.SATURDAY = ge.Time.SATURDAY;
Oe.DEFAULT_WEEK_START = Oe.MONDAY;
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class pt extends Ot {
  /**
   * @inheritDoc
   */
  constructor(...e) {
    super(...e), this._start = Oe.fromICALJs(this._innerValue.start), this._end = null, this._duration = null;
  }
  /**
   * Gets the start of the period-value
   *
   * @return {DateTimeValue}
   */
  get start() {
    return this._start;
  }
  /**
   * Sets the start of the period-value
   *
   * @throws {ModificationNotAllowedError} if value is locked for modification
   * @param {DateTimeValue} start The start of the period
   */
  set start(e) {
    this._modifyContent(), this._start = e, this._innerValue.start = e.toICALJs();
  }
  /**
   * Gets the end of the period-value
   *
   * @return {DateTimeValue}
   */
  get end() {
    return this._end || (this._duration && (this._duration.lock(), this._duration = null), this._innerValue.end = this._innerValue.getEnd(), this._end = Oe.fromICALJs(this._innerValue.end), this._innerValue.duration = null, this.isLocked() && this._end.lock()), this._end;
  }
  /**
   * Sets the end of the period-value
   *
   * @throws {ModificationNotAllowedError} if value is locked for modification
   * @param {DateTimeValue} end The end of the period
   */
  set end(e) {
    this._modifyContent(), this._innerValue.duration = null, this._innerValue.end = e.toICALJs(), this._end = e;
  }
  /**
   * Gets the duration of the period-value
   * The value is automatically locked.
   * If you want to edit the value, clone it and it as new duration
   *
   * @return {DurationValue}
   */
  get duration() {
    return this._duration || (this._end && (this._end.lock(), this._end = null), this._innerValue.duration = this._innerValue.getDuration(), this._duration = yt.fromICALJs(this._innerValue.duration), this._innerValue.end = null, this.isLocked() && this._duration.lock()), this._duration;
  }
  /**
   * Sets the duration of the period-value
   *
   * @throws {ModificationNotAllowedError} if value is locked for modification
   * @param {DurationValue} duration The duration to set
   */
  set duration(e) {
    this._modifyContent(), this._innerValue.end = null, this._innerValue.duration = e.toICALJs(), this._duration = e;
  }
  /**
   * @inheritDoc
   */
  lock() {
    super.lock(), this.start.lock(), this._end && this._end.lock(), this._duration && this._duration.lock();
  }
  /**
   * @inheritDoc
   */
  unlock() {
    super.unlock(), this.start.unlock(), this._end && this._end.unlock(), this._duration && this._duration.unlock();
  }
  /**
   * clones this value
   *
   * @return {PeriodValue}
   */
  clone() {
    return pt.fromICALJs(this._innerValue.clone());
  }
  /**
   * Create a new PeriodValue object from a ICAL.Period object
   *
   * @param {ICAL.Period} icalValue The ical.js period value to initialise from
   * @return {PeriodValue}
   */
  static fromICALJs(e) {
    return new pt(e);
  }
  /**
   * Create a new PeriodValue object from start and end
   *
   * @param {Object} data The destructuring object
   * @param {DateTimeValue} data.start The start of the period
   * @param {DateTimeValue} data.end The end of the period
   * @return {PeriodValue}
   */
  static fromDataWithEnd(e) {
    const t = ge.Period.fromData({
      start: e.start.toICALJs(),
      end: e.end.toICALJs()
    });
    return pt.fromICALJs(t);
  }
  /**
   * Create a new PeriodValue object from start and duration
   *
   * @param {Object} data The destructuring object
   * @param {DateTimeValue} data.start The start of the period
   * @param {DurationValue} data.duration The duration of the period
   * @return {PeriodValue}
   */
  static fromDataWithDuration(e) {
    const t = ge.Period.fromData({
      start: e.start.toICALJs(),
      duration: e.duration.toICALJs()
    });
    return pt.fromICALJs(t);
  }
}
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
const $E = ["SECONDLY", "MINUTELY", "HOURLY", "DAILY", "WEEKLY", "MONTHLY", "YEARLY"];
class un extends Ot {
  /**
   * Constructor
   *
   * @param {ICAL.Recur} icalValue The ical.js rrule value
   * @param {DateTimeValue?} until The Until date
   */
  constructor(e, t) {
    super(e), this._until = t;
  }
  /**
   * Gets the stored interval of this recurrence rule
   *
   * @return {Number}
   */
  get interval() {
    return this._innerValue.interval;
  }
  /**
   * Sets the stored interval of this recurrence rule
   *
   * @throws {ModificationNotAllowedError} if value is locked for modification
   * @param {Number} interval New Interval to set
   */
  set interval(e) {
    this._modifyContent(), this._innerValue.interval = parseInt(e, 10);
  }
  /**
   * Gets the weekstart used to calculate the recurrence expansion
   *
   * @return {Number}
   */
  get weekStart() {
    return this._innerValue.wkst;
  }
  /**
   * Sets the weekstart used to calculate the recurrence expansion
   *
   * @throws {ModificationNotAllowedError} if value is locked for modification
   * @throws {TypeError} if weekstart out of range
   * @param {Number} weekStart New start of week to set
   */
  set weekStart(e) {
    if (this._modifyContent(), e < Oe.SUNDAY || e > Oe.SATURDAY)
      throw new TypeError("Weekstart out of range");
    this._innerValue.wkst = e;
  }
  /**
   * Gets the until value if set
   * The value is automatically locked.
   * If you want to edit the value, clone it and it as new until
   *
   * @return {null|DateTimeValue}
   */
  get until() {
    return !this._until && this._innerValue.until && (this._until = Oe.fromICALJs(this._innerValue.until)), this._until;
  }
  /**
   * Sets the until value, automatically removes count
   *
   * @throws {ModificationNotAllowedError} if value is locked for modification
   * @param {DateTimeValue} until New until date to set
   */
  set until(e) {
    this._modifyContent(), this._until && this._until.lock(), this._until = e, this._innerValue.count = null, this._innerValue.until = e.toICALJs();
  }
  /**
   * Gets the count value if set
   *
   * @return {null|Number}
   */
  get count() {
    return this._innerValue.count;
  }
  /**
   * Sets the count value, automatically removes until
   *
   * @throws {ModificationNotAllowedError} if value is locked for modification
   * @param {Number} count New occurrence limit to set
   */
  set count(e) {
    this._modifyContent(), this._until && (this._until.lock(), this._until = null), this._innerValue.until = null, this._innerValue.count = parseInt(e, 10);
  }
  /**
   * Gets the frequency of the recurrence rule
   *
   * @return {string} see
   */
  get frequency() {
    return this._innerValue.freq;
  }
  /**
   * Sets the frequency of the recurrence rule
   *
   * @throws {ModificationNotAllowedError} if value is locked for modification
   * @throws {TypeError} if frequency is unknown
   * @param {string} freq New frequency to set
   */
  set frequency(e) {
    if (this._modifyContent(), !$E.includes(e))
      throw new TypeError("Unknown frequency");
    this._innerValue.freq = e;
  }
  /**
   * Modifies this recurrence-value to unset count and until
   */
  setToInfinite() {
    this._modifyContent(), this._until && (this._until.lock(), this._until = null), this._innerValue.until = null, this._innerValue.count = null;
  }
  /**
   * Checks whether the stored rule is finite
   *
   * @return {boolean}
   */
  isFinite() {
    return this._innerValue.isFinite();
  }
  /**
   * Checks whether the recurrence rule is limited by count
   *
   * @return {boolean}
   */
  isByCount() {
    return this._innerValue.isByCount();
  }
  /**
   * Adds a part to a component to the recurrence-rule
   *
   * @throws {ModificationNotAllowedError} if value is locked for modification
   * @param {string} componentName The name of the recurrence-component to add
   * @param {String|Number} value The value to add
   */
  addComponent(e, t) {
    this._modifyContent(), this._innerValue.addComponent(e, t);
  }
  /**
   * Sets / overwrites a component to the recurrence-rule
   *
   * @throws {ModificationNotAllowedError} if value is locked for modification
   * @param {string} componentName The name of the component to set
   * @param {Number[]|String[]} value The value to set
   */
  setComponent(e, t) {
    this._modifyContent(), t.length === 0 ? delete this._innerValue.parts[e.toUpperCase()] : this._innerValue.setComponent(e, t);
  }
  /**
   * Removes all parts of a component
   *
   * @throws {ModificationNotAllowedError} if value is locked for modification
   * @param {string} componentName The name of the component to remove
   */
  removeComponent(e) {
    delete this._innerValue.parts[Le(e)];
  }
  /**
   * Gets all parts of a component
   *
   * @param {string} componentName The name of the component to get
   * @return {Array}
   */
  getComponent(e) {
    return this._innerValue.getComponent(e);
  }
  /**
   * Checks if this recurrence rule is valid according to RFC 5545
   *
   * @return {boolean}
   */
  isRuleValid() {
    return !0;
  }
  /**
   * @inheritDoc
   */
  lock() {
    super.lock(), this._until && this._until.lock();
  }
  /**
   * @inheritDoc
   */
  unlock() {
    super.unlock(), this._until && this._until.unlock();
  }
  /**
   * clones this value
   *
   * @return {RecurValue}
   */
  clone() {
    return un.fromICALJs(this._innerValue.clone());
  }
  /**
   * Create a new RecurValue object from a ICAL.Recur object
   *
   * @param {ICAL.Recur} icalValue The ICAL.JS Recur value
   * @param {DateTimeValue?} until The Until date
   * @return {RecurValue}
   */
  static fromICALJs(e, t = null) {
    return new un(e, t);
  }
  /**
   * Create a new RecurValue object from a data object
   *
   * @param {Object} data The destructuring object
   * @param {String=} data.freq FREQ part of RRULE
   * @param {Number=} data.interval INTERVAL part of RRULE
   * @param {Number=} data.wkst WEEKSTART part of RRULE
   * @param {DateTimeValue=} data.until UNTIL part of RRULE
   * @param {Number=} data.count COUNT part of RRULE
   * @param {Number[]=} data.bysecond BYSECOND part of RRULE
   * @param {Number[]=} data.byminute BYMINUTE part of RRULE
   * @param {Number[]=} data.byhour BYHOUR part of RRULE
   * @param {String[]=} data.byday BYDAY part of RRULE
   * @param {Number[]=} data.bymonthday BYMONTHDAY part of RRULE
   * @param {Number[]=} data.byyearday BYYEARDAY part of RRULE
   * @param {Number[]=} data.byweekno BYWEEKNO part of RRULE
   * @param {Number[]=} data.bymonth BYMONTH part of RRULE
   * @param {Number[]=} data.bysetpos BYSETPOS part of RRULE
   * @return {RecurValue}
   */
  static fromData(e) {
    let t = null;
    e.until && (t = e.until, e.until = e.until.toICALJs());
    const n = ge.Recur.fromData(e);
    return un.fromICALJs(n, t);
  }
}
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class kr extends Ot {
  /**
   * Gets the hour part of the offset-value
   *
   * @return {Number}
   */
  get hours() {
    return this._innerValue.hours;
  }
  /**
   * Sets the hour part of the offset-value
   *
   * @throws {ModificationNotAllowedError} if value is locked for modification
  	 * @param {Number} hours - New hours to set
   */
  set hours(e) {
    this._modifyContent(), this._innerValue.hours = e;
  }
  /**
   * Gets the minute part of the offset-value
   *
   * @return {Number}
   */
  get minutes() {
    return this._innerValue.minutes;
  }
  /**
   * Sets the minute part of the offset-value
   *
   * @throws {ModificationNotAllowedError} if value is locked for modification
   * @param {Number} minutes - New minutes to set
   */
  set minutes(e) {
    this._modifyContent(), this._innerValue.minutes = e;
  }
  /**
   * Gets the factor
   *
   * @return {Number}
   */
  get factor() {
    return this._innerValue.factor;
  }
  /**
   * Sets the factor
   *
   * @throws {ModificationNotAllowedError} if value is locked for modification
   * @throws {TypeError} if factor is neither 1 nor -1
   * @param {Number} factor - New factor to set, 1 for positive, -1 for negative
   */
  set factor(e) {
    if (this._modifyContent(), e !== 1 && e !== -1)
      throw new TypeError("Factor may only be set to 1 or -1");
    this._innerValue.factor = e;
  }
  /**
   * Gets the total amount of seconds
   *
   * @return {Number}
   */
  get totalSeconds() {
    return this._innerValue.toSeconds();
  }
  /**
   * Sets the total amount of seconds
   *
   * @throws {ModificationNotAllowedError} if value is locked for modification
   * @param {Number} totalSeconds - New number of total seconds to set
   */
  set totalSeconds(e) {
    this._modifyContent(), this._innerValue.fromSeconds(e);
  }
  /**
   * Compares this UTCOffset to another one
   *
   * @param {UTCOffsetValue} other - The other UTCOffsetValue to compare with
   * @return {Number} -1, 0 or 1 for less/equal/greater
   */
  compare(e) {
    return this._innerValue.compare(e.toICALJs());
  }
  /**
   * Clones this value
   *
   * @return {UTCOffsetValue}
   */
  clone() {
    return kr.fromICALJs(this._innerValue.clone());
  }
  /**
   * Create a new UTCOffsetValue object from a ICAL.UTCOffset object
   *
   * @param {ICAL.UtcOffset} icalValue - The ICAL.UtcOffset object to initialize this object from
   * @return {UTCOffsetValue}
   */
  static fromICALJs(e) {
    return new kr(e);
  }
  /**
   * Create a new UTCOffsetValue object from a data object
   *
   * @param {Object} data - Object with data to create UTCOffsetValue object from
   * @param {Number=} data.hours - The number of hours to set
   * @param {Number=} data.minutes - The number of minutes to set
   * @param {Number=} data.factor - The factor to use, 1 for positive, -1 for negative
   * @return {UTCOffsetValue}
   */
  static fromData(e) {
    const t = new ge.UtcOffset();
    return t.fromData(e), kr.fromICALJs(t);
  }
  /**
   * Create a new UTCOffsetValue object from an amount of seconds
   *w
   * @param {Number} seconds - The total number of seconds to create the UTCOffsetValue object from
   * @return {UTCOffsetValue}
   */
  static fromSeconds(e) {
    const t = ge.UtcOffset.fromSeconds(e);
    return kr.fromICALJs(t);
  }
}
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class eh extends Error {
}
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @author Richard Steinmetz <richard@steinmetz.cloud>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
function th(r) {
  switch (Vt(r)) {
    case "binary":
      return ft;
    case "date":
    case "date-time":
      return Oe;
    case "duration":
      return yt;
    case "period":
      return pt;
    case "recur":
      return un;
    case "utc-offset":
      return kr;
    default:
      throw new eh();
  }
}
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class mt extends Oa(Fa(class {
})) {
  /**
   * Constructor
   *
   * @param {string} name The name of the property
   * @param {String|Number|AbstractValue|String[]|Number[]|AbstractValue[]|null} value The value of the property
   * @param {Parameter[]|[String][]} parameters Array of parameters
   * @param {CalendarComponent|null} root The root of the calendar-document
   * @param {AbstractComponent|null} parent The parent-element of this property
   */
  constructor(e, t = null, n = [], i = null, s = null) {
    super(), this._name = Le(e), this._value = t, this._parameters = /* @__PURE__ */ new Map(), this._root = i, this._parent = s, this._setParametersFromConstructor(n), t instanceof Ot && t.subscribe(() => this._notifySubscribers());
  }
  /**
   * Get property name
   *
   * @readonly
   * @return {string}
   */
  get name() {
    return this._name;
  }
  /**
   * Get parameter value
   *
   * @return {String|Number|AbstractValue|String[]|Number[]|AbstractValue[]|null}
   */
  get value() {
    return this._value;
  }
  /**
   * Set new parameter value
   *
   * @param {String|Number|AbstractValue|String[]|Number[]|AbstractValue[]|null} value The value of the property
   * @throws {ModificationNotAllowedError} if property is locked for modification
   */
  set value(e) {
    this._modifyContent(), this._value = e, e instanceof Ot && e.subscribe(() => this._notifySubscribers());
  }
  /**
   * Gets the root of this property
   *
   * @return {CalendarComponent|null}
   */
  get root() {
    return this._root;
  }
  /**
   * Sets the root of this property
   *
   * @param {CalendarComponent|null} root The root of the calendar-document
   * @throws {ModificationNotAllowedError} if property is locked for modification
   */
  set root(e) {
    this._modify(), this._root = e;
  }
  /**
   * Gets the direct parent element of this property
   *
   * @return {AbstractComponent}
   */
  get parent() {
    return this._parent;
  }
  /**
   * Sets the direct parent element of this property
   *
   * @param {AbstractComponent|null} parent The parent element of this property
   * @throws {ModificationNotAllowedError} if property is locked for modification
   */
  set parent(e) {
    this._modify(), this._parent = e;
  }
  /**
   * Gets the first value of this property
   *
   * @return {null|String|Number|AbstractValue}
   */
  getFirstValue() {
    if (this.isMultiValue()) {
      if (this.value.length > 0)
        return this.value[0];
    } else
      return this.value;
    return null;
  }
  /**
   * Gets an iterator over all values
   */
  *getValueIterator() {
    this.isMultiValue() ? yield* this.value.slice()[Symbol.iterator]() : yield this.value;
  }
  /**
   * Adds a value to the multi-value property
   *
   * @param {String|AbstractValue} value Value to add
   */
  addValue(e) {
    if (!this.isMultiValue())
      throw new TypeError("This is not a multivalue property");
    this._modifyContent(), this.value.push(e);
  }
  /**
   * Checks if a value is inside this multi-value property
   *
   * @param {String|AbstractValue} value Value to check for
   * @return {boolean}
   */
  hasValue(e) {
    if (!this.isMultiValue())
      throw new TypeError("This is not a multivalue property");
    return this.value.includes(e);
  }
  /**
   * Removes a value from this multi-value property
   *
   * @param {String|AbstractValue} value Value to remove
   */
  removeValue(e) {
    if (!this.hasValue(e))
      return;
    this._modifyContent();
    const t = this.value.indexOf(e);
    this.value.splice(t, 1);
  }
  /**
   * Sets a parameter on this property
   *
   * @param {Parameter} parameter The parameter to set
   * @throws {ModificationNotAllowedError} if property is locked for modification
   */
  setParameter(e) {
    this._modify(), this._parameters.set(e.name, e), e.subscribe(() => this._notifySubscribers());
  }
  /**
   * Gets a parameter on this property by its name
   *
   * @param {string} parameterName Name of the parameter to get
   * @return {Parameter}
   */
  getParameter(e) {
    return this._parameters.get(Le(e));
  }
  /**
   * Gets an iterator over all available parameters
   */
  *getParametersIterator() {
    yield* this._parameters.values();
  }
  /**
   * Get first value of a parameter
   *
   * @param {string} parameterName Name of the parameter
   * @return {null|String}
   */
  getParameterFirstValue(e) {
    const t = this.getParameter(e);
    return t instanceof nn ? t.isMultiValue() ? t.value[0] : t.value : null;
  }
  /**
   * Returns whether a parameter exists on this property
   *
   * @param {string} parameterName Name of the parameter
   * @return {boolean}
   */
  hasParameter(e) {
    return this._parameters.has(Le(e));
  }
  /**
   * Deletes a parameter on this property
   *
   * @param {string} parameterName Name of the parameter
   * @throws {ModificationNotAllowedError} if property is locked for modification
   */
  deleteParameter(e) {
    this._modify(), this._parameters.delete(Le(e));
  }
  /**
   * update a parameter if it exists,
   * create a new one if it doesn't
   *
   * @param {string} parameterName Name of the parameter
   * @param {string|Array|null} value Value to set
   * @throws {ModificationNotAllowedError} if property is locked for modification
   */
  updateParameterIfExist(e, t) {
    if (this._modify(), this.hasParameter(e)) {
      const n = this.getParameter(e);
      n.value = t;
    } else {
      const n = new nn(Le(e), t);
      this.setParameter(n);
    }
  }
  /**
   * Returns whether or not the value is a multivalue
   *
   * @return {boolean}
   */
  isMultiValue() {
    return Array.isArray(this._value);
  }
  /**
   * Returns whether or not this valus is decorated
   *
   * @return {boolean}
   */
  isDecoratedValue() {
    return this.isMultiValue() ? this._value[0] instanceof Ot : this._value instanceof Ot;
  }
  /**
   * Marks this parameter is immutable
   * locks it against further modification
   */
  lock() {
    super.lock();
    for (const e of this.getParametersIterator())
      e.lock();
    if (this.isDecoratedValue())
      for (const e of this.getValueIterator())
        e.lock();
  }
  /**
   * Marks this parameter as mutable
   * allowing further modification
   */
  unlock() {
    super.unlock();
    for (const e of this.getParametersIterator())
      e.unlock();
    if (this.isDecoratedValue())
      for (const e of this.getValueIterator())
        e.unlock();
  }
  /**
   * Creates a copy of this parameter
   *
   * @return {Property}
   */
  clone() {
    const e = [];
    for (const t of this.getParametersIterator())
      e.push(t.clone());
    return new this.constructor(this.name, this._cloneValue(), e, this.root, this.parent);
  }
  /**
   * Copies the values of this property
   *
   * @return {String|Number|AbstractValue|String[]|Number[]|AbstractValue[]|null}
   * @protected
   */
  _cloneValue() {
    return this.isDecoratedValue() ? this.isMultiValue() ? this._value.map((e) => e.clone()) : this._value.clone() : this.isMultiValue() ? this._value.slice() : this._value;
  }
  /**
   * Sets parameters from the constructor
   *
   * @param {Parameter[]|[String][]} parameters Array of parameters to set
   * @private
   */
  _setParametersFromConstructor(e) {
    e.forEach((t) => {
      t instanceof nn || (t = new nn(t[0], t[1])), this.setParameter(t);
    });
  }
  /**
   * Creates a new Component based on an ical object
   *
   * @param {ICAL.Property} icalProperty The ical.js property to initialise from
   * @param {CalendarComponent=} root The root of the calendar-document
   * @param {AbstractComponent=} parent The parent element of this property
   * @return {Property}
   */
  static fromICALJs(e, t = null, n = null) {
    if (!(e instanceof ge.Property))
      throw new fu();
    let i;
    if (e.isDecorated) {
      const l = th(e.getFirstValue().icaltype);
      e.isMultiValue ? i = e.getValues().map((a) => l.fromICALJs(a)) : i = l.fromICALJs(e.getFirstValue());
    } else
      e.isMultiValue ? i = e.getValues() : i = e.getFirstValue();
    const s = [];
    return Object.keys(Object.assign({}, e.toJSON()[1])).forEach((l) => {
      Le(l) !== "TZID" && s.push([l, e.getParameter(l)]);
    }), new this(e.name, i, s, t, n);
  }
  /**
   * Returns an ICAL.js property based on this Property
   *
   * @return {ICAL.Property}
   */
  toICALJs() {
    const e = pu(Vt(this.name));
    this.isMultiValue() ? this.isDecoratedValue() ? e.setValues(this.value.map((n) => n.toICALJs())) : e.setValues(this.value) : this.isDecoratedValue() ? e.setValue(this.value.toICALJs()) : e.setValue(this.value);
    for (const n of this.getParametersIterator())
      e.setParameter(Vt(n.name), n.value);
    const t = this.getFirstValue();
    return t instanceof Oe && t.timezoneId !== "floating" && t.timezoneId !== "UTC" && !t.isDate && e.setParameter("tzid", t.timezoneId), e;
  }
  /**
   * @inheritDoc
   */
  _modifyContent() {
    super._modifyContent(), this._notifySubscribers();
  }
}
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class Fr extends mt {
  /**
   * Gets the format-type of this attachment
   *
   * @return {string}
   */
  get formatType() {
    return this.getParameterFirstValue("FMTTYPE");
  }
  /**
   * Sets the format-type of this attachment
   *
   * @param {string} fmtType Mime-type of attachment
   */
  set formatType(e) {
    this.updateParameterIfExist("FMTTYPE", e);
  }
  /**
   * Gets the uri of this attachment
   *
   * @return {String|null}
   */
  get uri() {
    return this._value instanceof ft ? null : this._value;
  }
  /**
   * Sets the uri of this attachment
   *
   * @param {string} uri Link to attachment if applicable
   */
  set uri(e) {
    this.value = e;
  }
  /**
   * Gets the encoding of this attachment
   *
   * @return {string|null}
   */
  get encoding() {
    return this._value instanceof ft ? "BASE64" : null;
  }
  /**
   * Gets the data stored in this attachment
   *
   * @return {String|null}
   */
  get data() {
    return this._value instanceof ft ? this._value.value : null;
  }
  /**
   * Sets the data stored in this attachment
   *
   * @param {string} data The data of the attachment
   */
  set data(e) {
    this.value instanceof ft ? this.value.value = e : this.value = ft.fromDecodedValue(e);
  }
  /**
   * @inheritDoc
   */
  toICALJs() {
    const e = super.toICALJs();
    return this._value instanceof ft && this.getParameterFirstValue("ENCODING") !== "BASE64" && e.setParameter("ENCODING", "BASE64"), e;
  }
  /**
   * Creates a new AttachmentProperty based on data
   *
   * @param {string} data The data of the attachment
   * @param {String=} formatType The mime-type of the data
   * @return {AttachmentProperty}
   */
  static fromData(e, t = null) {
    const n = ft.fromDecodedValue(e), i = new Fr("ATTACH", n);
    return t && (i.formatType = t), i;
  }
  /**
   * Creates a new AttachmentProperty based on a link
   *
   * @param {string} uri The URI for the attachment
   * @param {String=} formatType The mime-type of the uri
   * @return {AttachmentProperty}
   */
  static fromLink(e, t = null) {
    const n = new Fr("ATTACH", e);
    return t && (n.formatType = t), n;
  }
}
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class xt extends mt {
  /**
   * Returns the role of the attendee.
   *
   * @return {string}
   */
  get role() {
    const e = ["CHAIR", "REQ-PARTICIPANT", "OPT-PARTICIPANT", "NON-PARTICIPANT"], t = "REQ-PARTICIPANT";
    if (this.hasParameter("ROLE")) {
      const n = this.getParameterFirstValue("ROLE");
      if (e.includes(n))
        return n;
    }
    return t;
  }
  /**
   * Sets new role of the attendee
   *
   * @param {string} role The role of the attendee (e.g. CHAIR, REQ-PARTICIPANT)
   */
  set role(e) {
    this.updateParameterIfExist("ROLE", e);
  }
  /**
   * Returns the calendar-user-type of an attendee
   *
   * @return {string}
   */
  get userType() {
    const e = ["INDIVIDUAL", "GROUP", "RESOURCE", "ROOM", "UNKNOWN"];
    if (this.hasParameter("CUTYPE")) {
      const t = this.getParameterFirstValue("CUTYPE");
      return e.includes(t) ? t : "UNKNOWN";
    } else
      return "INDIVIDUAL";
  }
  /**
   * Sets new calendar-user-type of attendee
   *
   * @param {string} userType The type of user (e.g. INDIVIDUAL, GROUP)
   */
  set userType(e) {
    this.updateParameterIfExist("CUTYPE", e);
  }
  /**
   * Returns the "Répondez s'il vous plaît" value for attendee
   *
   * @return {boolean}
   */
  get rsvp() {
    if (this.hasParameter("RSVP")) {
      const e = this.getParameterFirstValue("RSVP");
      return Le(e) === "TRUE";
    } else
      return !1;
  }
  /**
   * Updates the "Répondez s'il vous plaît" value for attendee
   *
   * @param {boolean} rsvp Whether or not to send out an invitation
   */
  set rsvp(e) {
    this.updateParameterIfExist("RSVP", e ? "TRUE" : "FALSE");
  }
  /**
   * Returns the common-name of the attendee
   *
   * @return {string|null}
   */
  get commonName() {
    return this.getParameterFirstValue("CN");
  }
  /**
   * Sets a new common-name of the attendee
   *
   * @param {string} commonName The display name of the attendee
   */
  set commonName(e) {
    this.updateParameterIfExist("CN", e);
  }
  /**
   * Returns the participation-status of the attendee
   *
   * @return {string}
   */
  get participationStatus() {
    let e;
    this.parent ? e = this.parent.name : e = "VEVENT";
    const t = {
      VEVENT: ["NEEDS-ACTION", "ACCEPTED", "DECLINED", "TENTATIVE", "DELEGATED"],
      VJOURNAL: ["NEEDS-ACTION", "ACCEPTED", "DECLINED"],
      VTODO: ["NEEDS-ACTION", "ACCEPTED", "DECLINED", "TENTATIVE", "DELEGATED", "COMPLETED", "IN-PROCESS"]
    };
    if (this.hasParameter("PARTSTAT")) {
      const n = this.getParameterFirstValue("PARTSTAT");
      return t[e].includes(n) ? n : "NEEDS-ACTION";
    } else
      return "NEEDS-ACTION";
  }
  /**
   * Sets a new participation-status of the attendee
   *
   * @param {string} participationStatus The participation status (e.g. ACCEPTED, DECLINED)
   */
  set participationStatus(e) {
    this.updateParameterIfExist("PARTSTAT", e);
  }
  /**
   * Gets this attendee's language
   *
   * @return {string}
   */
  get language() {
    return this.getParameterFirstValue("LANGUAGE");
  }
  /**
   * Sets this attendee's language
   * This can be used to influence the language of the invitation email
   *
   * @param {string} language The preferred language of the attendee
   */
  set language(e) {
    this.updateParameterIfExist("LANGUAGE", e);
  }
  /**
   * Gets the email of the attendee
   *
   * @return {string}
   */
  get email() {
    return this.value;
  }
  /**
   * Sets the email address of the attendee
   *
   * @param {string} email The e-email address of the attendee
   */
  set email(e) {
    this.value = co(e, "mailto:");
  }
  /**
   * Is this attendee the organizer?
   *
   * @return {boolean}
   */
  isOrganizer() {
    return this._name === "ORGANIZER";
  }
  /**
   * Creates a new AttendeeProperty from name and email
   *
   * @param {string} name The display name
   * @param {string} email The email address
   * @param {boolean=} isOrganizer Whether this is the organizer or an attendee
   * @return {AttendeeProperty}
   */
  static fromNameAndEMail(e, t, n = !1) {
    const i = n ? "ORGANIZER" : "ATTENDEE";
    return t = co(t, "mailto:"), new xt(i, t, [["CN", e]]);
  }
  /**
   * Creates a new AttendeeProperty from name, email, role, userType and rsvp
   *
   * @param {string} name The display name
   * @param {string} email The email address
   * @param {string} role The role
   * @param {string} userType The type of user
   * @param {boolean} rsvp Whether to send out an invitation
   * @param {boolean=} isOrganizer Whether this is the organizer or an attendee
   * @return {AttendeeProperty}
   */
  static fromNameEMailRoleUserTypeAndRSVP(e, t, n, i, s, o = !1) {
    const l = o ? "ORGANIZER" : "ATTENDEE";
    return t = co(t, "mailto:"), new xt(l, t, [["CN", e], ["ROLE", n], ["CUTYPE", i], ["RSVP", s ? "TRUE" : "FALSE"]]);
  }
}
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
ge.design.icalendar.property.conference = {
  defaultType: "uri"
};
ge.design.icalendar.param.feature = {
  valueType: "cal-address",
  multiValue: ","
};
class Sn extends mt {
  /**
   * Iterator that iterates over all supported features
   * of the conference system
   */
  *getFeatureIterator() {
    if (!this.hasParameter("FEATURE"))
      return;
    yield* this.getParameter("FEATURE").getValueIterator();
  }
  /**
   * Lists all supported features of the conference system
   *
   * @return {String[]}
   */
  listAllFeatures() {
    return this.hasParameter("FEATURE") ? this.getParameter("FEATURE").value.slice() : [];
  }
  /**
   * Adds a supported feature to the conference system
   *
   * @param {string} featureToAdd Feature to add
   */
  addFeature(e) {
    if (this._modify(), !this.hasParameter("FEATURE"))
      this.updateParameterIfExist("FEATURE", [e]);
    else {
      if (this.hasFeature(e))
        return;
      this.getParameter("FEATURE").value.push(e);
    }
  }
  /**
   * Removes a supported feature
   *
   * @param {string} feature The feature to remove
   */
  removeFeature(e) {
    if (this._modify(), !this.hasFeature(e))
      return;
    const t = this.getParameter("FEATURE"), n = t.value.indexOf(e);
    t.value.splice(n, 1);
  }
  /**
   * Removes all supported features from this conference system
   */
  clearAllFeatures() {
    this.deleteParameter("FEATURE");
  }
  /**
   * Check if this conference system supports a feature
   *
   * @param {string} feature The feature to check
   * @return {boolean}
   */
  hasFeature(e) {
    if (!this.hasParameter("FEATURE"))
      return !1;
    const t = this.getParameter("FEATURE");
    return Array.isArray(t.value) ? t.value.includes(e) : !1;
  }
  /**
   * Gets label for the conference system
   *
   * @return {string}
   */
  get label() {
    return this.getParameterFirstValue("LABEL");
  }
  /**
   * Updates the label for the conference system
   *
   * @param {string} label The label to set
   */
  set label(e) {
    this.updateParameterIfExist("LABEL", e);
  }
  /**
   * Gets the uri for this conference system
   */
  get uri() {
    return this.value;
  }
  /**
   * Sets the uri for this conference system
   *
   * @param {string} uri The URI to set
   */
  set uri(e) {
    this.value = e;
  }
  /**
   * @inheritDoc
   */
  toICALJs() {
    const e = super.toICALJs();
    return e.setParameter("value", "URI"), e;
  }
  /**
   * Creates a new ConferenceProperty based on URI, label and features
   *
   * @param {string} uri URI of the Conference
   * @param {String=} label Label of the conference
   * @param {String[]=} features Features of the conference
   * @return {ConferenceProperty}
   */
  static fromURILabelAndFeatures(e, t = null, n = null) {
    const i = new Sn("CONFERENCE", e);
    return t && i.updateParameterIfExist("label", t), n && i.updateParameterIfExist("feature", n), i;
  }
}
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class ya extends mt {
  /**
   * Gets the type of this FreeBusyProperty
   *
   * @return {string}
   */
  get type() {
    const e = ["FREE", "BUSY", "BUSY-UNAVAILABLE", "BUSY-TENTATIVE"], t = "BUSY";
    if (this.hasParameter("FBTYPE")) {
      const n = this.getParameterFirstValue("FBTYPE");
      if (e.includes(n))
        return n;
    }
    return t;
  }
  /**
   * Sets the type of this FreeBusyProperty
   *
   * @param {string} type The type of information (e.g. FREE, BUSY, etc.)
   */
  set type(e) {
    this.updateParameterIfExist("FBTYPE", e);
  }
  /**
   * Creates a new FreeBusyProperty based on period and type
   *
   * @param {PeriodValue} period The period for FreeBusy Information
   * @param {string} type The type of the period
   * @return {FreeBusyProperty}
   */
  static fromPeriodAndType(e, t) {
    return new ya("FREEBUSY", e, [["fbtype", t]]);
  }
}
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class Dn extends mt {
  /**
   * @inheritDoc
   */
  constructor(e, t = [0, 0], n = [], i = null, s = null) {
    super(e, t, n, i, s);
  }
  /**
   * Gets the latitude stored in this property
   *
   * @return {Number}
   */
  get latitude() {
    return this._value[0];
  }
  /**
   * Sets the latitude stored in this property
   *
   * @param {String|Number} lat Latitude
   */
  set latitude(e) {
    this._modifyContent(), typeof e != "number" && (e = parseFloat(e)), this._value[0] = e;
  }
  /**
   * Gets the longitude stored in this property
   */
  get longitude() {
    return this._value[1];
  }
  /**
   * Sets the longitude stored in this property
   *
   * @param {String|Number} long Longitude
   */
  set longitude(e) {
    this._modifyContent(), typeof e != "number" && (e = parseFloat(e)), this._value[1] = e;
  }
  /**
   * @inheritDoc
   *
   * TODO: this is an ugly hack right now.
   * As soon as the value is an array, we assume it's multivalue
   * but GEO is a (the one and only besides request-status) structured value and is also
   * stored inside an array.
   *
   * Calling icalProperty.setValues will throw an error
   */
  toICALJs() {
    const e = pu(Vt(this.name));
    return e.setValue(this.value), this._parameters.forEach((t) => {
      e.setParameter(Vt(t.name), t.value);
    }), e;
  }
  /**
   * Creates a new GeoProperty based on a latitude and a longitude value
   *
   * @param {Number} lat Latitude
   * @param {Number} long Longitude
   * @return {GeoProperty}
   */
  static fromPosition(e, t) {
    return new Dn("GEO", [e, t]);
  }
}
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class jr extends Fr {
  /**
   * Gets the image-type
   */
  get display() {
    return this.getParameterFirstValue("DISPLAY") || "BADGE";
  }
  /**
   * Gets the image-type
   *
   * @param {string} display The display-type image is optimized for
   */
  set display(e) {
    this.updateParameterIfExist("DISPLAY", e);
  }
  /**
   * Creates a new ImageProperty based on data
   *
   * @param {string} data The data of the image
   * @param {String=} display The display-type it's optimized for
   * @param {String=} formatType The mime-type of the image
   * @return {ImageProperty}
   */
  static fromData(e, t = null, n = null) {
    const i = ft.fromDecodedValue(e), s = new jr("IMAGE", i);
    return t && (s.display = t), n && (s.formatType = n), s;
  }
  /**
   * Creates a new ImageProperty based on a link
   *
   * @param {string} uri The uri of the image
   * @param {String=} display The display-type it's optimized for
   * @param {String=} formatType The mime-type of the image
   * @return {ImageProperty}
   */
  static fromLink(e, t = null, n = null) {
    const i = new jr("IMAGE", e);
    return t && (i.display = t), n && (i.formatType = n), i;
  }
}
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class ai extends mt {
  /**
   * Get's the relation-type of this related-to property
   *
   * @return {string}
   */
  get relationType() {
    const e = ["PARENT", "CHILD", "SIBLING"], t = "PARENT";
    if (this.hasParameter("RELTYPE")) {
      const n = this.getParameterFirstValue("RELTYPE");
      return e.includes(n) ? n : t;
    } else
      return t;
  }
  /**
   * Sets a new relation type
   *
   * @param {string} relationType The type of relation (e.g. SIBLING, PARENT, etc.)
   */
  set relationType(e) {
    this.updateParameterIfExist("RELTYPE", e);
  }
  /**
   * Gets Id of related object
   *
   * @return {string}
   */
  get relatedId() {
    return this.value;
  }
  /**
   * Sets a new related id
   *
   * @param {string} relatedId The Id of the related document
   */
  set relatedId(e) {
    this.value = e;
  }
  /**
   * Creates a new RELATED-TO property based on a relation-type and id
   *
   * @param {string} relType The type of the relation (e.g. SIBLING, CHILD)
   * @param {string} relId The Id of the related document
   * @return {RelationProperty}
   */
  static fromRelTypeAndId(e, t) {
    return new ai("RELATED-TO", t, [["RELTYPE", e]]);
  }
}
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class Be extends mt {
  /**
   * @inheritDoc
   */
  constructor(e, t = ["1", "Pending"], n = [], i = null, s = null) {
    super(e, t, n, i, s);
  }
  /**
   * Gets the status code of the request status
   *
   * @return {Number}
   */
  get statusCode() {
    return parseFloat(this.value[0]);
  }
  /**
   * Sets the status code of the request status
   *
   * @param {Number} statusCode The statusCode of the request
   */
  set statusCode(e) {
    this._modifyContent(), this.value[0] = e.toString(), e === Math.floor(e) && (this.value[0] += ".0");
  }
  /**
   * Gets the status message of the request status
   *
   * @return {string}
   */
  get statusMessage() {
    return this.value[1];
  }
  /**
   * Sets the status message of the request status
   *
   * @param {string} statusMessage The message of the request
   */
  set statusMessage(e) {
    this._modifyContent(), this.value[1] = e;
  }
  /**
   * Gets the exception data of the request status if available
   *
   * @return {null|String}
   */
  get exceptionData() {
    return this.value[2] ? this.value[2] : null;
  }
  /**
   * Sets the exception dtat of the request status
   *
   * @param {string} exceptionData The additional exception-data
   */
  set exceptionData(e) {
    this._modifyContent(), this.value[2] = e;
  }
  /**
   * Check if request is pending
   *
   * @return {boolean}
   */
  isPending() {
    return this.statusCode >= 1 && this.statusCode < 2;
  }
  /**
   * Check if request was successful
   *
   * @return {boolean}
   */
  isSuccessful() {
    return this.statusCode >= 2 && this.statusCode < 3;
  }
  /**
   * Check if a client error occurred
   *
   * @return {boolean}
   */
  isClientError() {
    return this.statusCode >= 3 && this.statusCode < 4;
  }
  /**
   * Check if a scheduling error occurred
   *
   * @return {boolean}
   */
  isSchedulingError() {
    return this.statusCode >= 4 && this.statusCode < 5;
  }
  /**
   * @inheritDoc
   *
   * TODO: this is an ugly hack right now.
   * As soon as the value is an array, we assume it's multivalue
   * but REQUEST-STATUS is a (the one and only besides GEO) structured value and is also
   * stored inside an array.
   *
   * Calling icalProperty.setValues will throw an error
   */
  toICALJs() {
    const e = pu(Vt(this.name));
    return e.setValue(this.value), this._parameters.forEach((t) => {
      e.setParameter(Vt(t.name), t.value);
    }), e;
  }
  /**
   * Creates a new RequestStatusProperty from a code and a status message
   *
   * @param {Number} code The status-code of the request
   * @param {string} message The message of the request
   * @return {RequestStatusProperty}
   */
  static fromCodeAndMessage(e, t) {
    return new Be("REQUEST-STATUS", [e.toString(), t]);
  }
}
Be.SUCCESS = [2, "Success"];
Be.SUCCESS_FALLBACK = [2.1, "Success, but fallback taken on one or more property values."];
Be.SUCCESS_PROP_IGNORED = [2.2, "Success; invalid property ignored."];
Be.SUCCESS_PROPPARAM_IGNORED = [2.3, "Success; invalid property parameter ignored."];
Be.SUCCESS_NONSTANDARD_PROP_IGNORED = [2.4, "Success; unknown, non-standard property ignored."];
Be.SUCCESS_NONSTANDARD_PROPPARAM_IGNORED = [2.5, "Success; unknown, non-standard property value ignored."];
Be.SUCCESS_COMP_IGNORED = [2.6, "Success; invalid calendar component ignored."];
Be.SUCCESS_FORWARDED = [2.7, "Success; request forwarded to Calendar User."];
Be.SUCCESS_REPEATING_IGNORED = [2.8, "Success; repeating event ignored. Scheduled as a single component."];
Be.SUCCESS_TRUNCATED_END = [2.9, "Success; truncated end date time to date boundary."];
Be.SUCCESS_REPEATING_VTODO_IGNORED = [2.1, "Success; repeating VTODO ignored.  Scheduled as a single VTODO."];
Be.SUCCESS_UNBOUND_RRULE_CLIPPED = [2.11, "Success; unbounded RRULE clipped at some finite number of instances."];
Be.CLIENT_INVALID_PROPNAME = [3, "Invalid property name."];
Be.CLIENT_INVALID_PROPVALUE = [3.1, "Invalid property value."];
Be.CLIENT_INVALID_PROPPARAM = [3.2, "Invalid property parameter."];
Be.CLIENT_INVALID_PROPPARAMVALUE = [3.3, "Invalid property parameter value."];
Be.CLIENT_INVALUD_CALENDAR_COMP_SEQ = [3.4, "Invalid calendar component sequence."];
Be.CLIENT_INVALID_DATE_TIME = [3.5, "Invalid date or time."];
Be.CLIENT_INVALID_RRULE = [3.6, "Invalid rule."];
Be.CLIENT_INVALID_CU = [3.7, "Invalid Calendar User."];
Be.CLIENT_NO_AUTHORITY = [3.8, "No authority."];
Be.CLIENT_UNSUPPORTED_VERSION = [3.9, "Unsupported version."];
Be.CLIENT_TOO_LARGE = [3.1, "Request entity too large."];
Be.CLIENT_REQUIRED_COMP_OR_PROP_MISSING = [3.11, "Required component or property missing."];
Be.CLIENT_UNKNOWN_COMP_OR_PROP = [3.12, "Unknown component or property found."];
Be.CLIENT_UNSUPPORTED_COMP_OR_PROP = [3.13, "Unsupported component or property found."];
Be.CLIENT_UNSUPPORTED_CAPABILITY = [3.14, "Unsupported capability."];
Be.SCHEDULING_EVENT_CONFLICT = [4, "Event conflict.  Date/time is busy."];
Be.SERVER_REQUEST_NOT_SUPPORTED = [5, "Request not supported."];
Be.SERVER_SERVICE_UNAVAILABLE = [5.1, "Service unavailable."];
Be.SERVER_INVALID_CALENDAR_SERVICE = [5.2, "Invalid calendar service."];
Be.SERVER_NO_SCHEDULING_FOR_USER = [5.3, "No scheduling support for user."];
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class Xn extends mt {
  /**
   * Gets the alternate text
   *
   * @return {string}
   */
  get alternateText() {
    return this.getParameterFirstValue("ALTREP");
  }
  /**
   * Sets the alternate text
   *
   * @param {string} altRep The alternative text
   */
  set alternateText(e) {
    this.updateParameterIfExist("ALTREP", e);
  }
  /**
   * Gets language of this property
   *
   * @return {string}
   */
  get language() {
    return this.getParameterFirstValue("LANGUAGE");
  }
  /**
   * Sets language of this property
   *
   * @param {string} language The language of the text
   */
  set language(e) {
    this.updateParameterIfExist("LANGUAGE", e);
  }
}
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class or extends mt {
  /**
   * Gets the related parameter
   *
   * @return {string}
   */
  get related() {
    return this.hasParameter("RELATED") ? this.getParameterFirstValue("RELATED") : "START";
  }
  /**
   * Sets the related parameter
   *
   * @param {string} related Either START or END
   */
  set related(e) {
    this.updateParameterIfExist("RELATED", e);
  }
  /**
   * Gets the value of this trigger
   * (If you override the setter, you also have to override the getter or
   *  it will simply be undefined)
   *
   * @return {String|Number|AbstractValue|String[]|Number[]|AbstractValue[]}
   */
  get value() {
    return super.value;
  }
  /**
   * Set the value of this trigger
   *
   * @param {DurationValue|DateTimeValue} value The time of trigger
   */
  set value(e) {
    super.value = e, e instanceof Oe && (this.deleteParameter("RELATED"), super.value = e.getInUTC());
  }
  /**
   * Gets whether this alarm trigger is relative
   *
   * @return {boolean}
   */
  isRelative() {
    return this.getFirstValue() instanceof yt;
  }
  /**
   * Creates a new absolute trigger
   *
   * @param {DateTimeValue} alarmTime Time to create Trigger from
   * @return {TriggerProperty}
   */
  static fromAbsolute(e) {
    return new or("TRIGGER", e);
  }
  /**
   * Creates a new relative trigger
   *
   * @param {DurationValue} alarmOffset Duration to create Trigger from
   * @param {boolean=} relatedToStart Related to Start or end?
   * @return {TriggerProperty}
   */
  static fromRelativeAndRelated(e, t = !0) {
    return new or("TRIGGER", e, [["RELATED", t ? "START" : "END"]]);
  }
}
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @author Richard Steinmetz <richard@steinmetz.cloud>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
function Ii(r) {
  switch (Le(r)) {
    case "ATTACH":
      return Fr;
    case "ATTENDEE":
    case "ORGANIZER":
      return xt;
    case "CONFERENCE":
      return Sn;
    case "FREEBUSY":
      return ya;
    case "GEO":
      return Dn;
    case "IMAGE":
      return jr;
    case "RELATED-TO":
      return ai;
    case "REQUEST-STATUS":
      return Be;
    case "TRIGGER":
      return or;
    case "COMMENT":
    case "CONTACT":
    case "DESCRIPTION":
    case "LOCATION":
    case "SUMMARY":
      return Xn;
    default:
      return mt;
  }
}
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class qt extends Oa(Fa(class {
})) {
  /**
   * Constructor
   *
   * @param {string} name - Name of component
   * @param {Property[]} properties - Array of properties stored inside the component
   * @param {AbstractComponent[]} components - Array of subcomponents stored inside this component
   * @param {CalendarComponent|null} root - The root of this calendar document
   * @param {AbstractComponent|null} parent - The parent component of this element
   */
  constructor(e, t = [], n = [], i = null, s = null) {
    super(), this._name = Le(e), this._properties = /* @__PURE__ */ new Map(), this._components = /* @__PURE__ */ new Map(), this._root = i, this._parent = s, this._setPropertiesFromConstructor(t), this._setComponentsFromConstructor(n);
  }
  /**
   * Get the component's name
   *
   * @return {string}
   */
  get name() {
    return this._name;
  }
  /**
   * Gets the root of this calendar-document
   *
   * @return {CalendarComponent}
   */
  get root() {
    return this._root;
  }
  /**
   * Sets the root of this calendar-document
   *
   * @param {CalendarComponent} root The new root element
   */
  set root(e) {
    this._modify(), this._root = e;
    for (const t of this.getPropertyIterator())
      t.root = e;
    for (const t of this.getComponentIterator())
      t.root = e;
  }
  /**
   * Gets the parent component
   *
   * @return {AbstractComponent}
   */
  get parent() {
    return this._parent;
  }
  /**
   * Sets the parent component
   *
   * @param {AbstractComponent} parent The new parent element
   */
  set parent(e) {
    this._modify(), this._parent = e;
  }
  /**
   * Gets the first property that matches the given propertyName
   *
   * @param {string} propertyName Name of the property to get
   * @return {Property|null}
   */
  getFirstProperty(e) {
    return this._properties.has(Le(e)) ? this._properties.get(Le(e))[0] : null;
  }
  /**
   * Gets the first value of the first property matching that name
   *
   * @param {string} propertyName Name of the property to get first value of
   * @return {String|Number|AbstractValue|String[]|Number[]|AbstractValue[]|null}
   */
  getFirstPropertyFirstValue(e) {
    const t = this.getFirstProperty(e);
    return t ? t.getFirstValue() : null;
  }
  /**
   * update a property if it exists,
   * create a new one if it doesn't
   *
   * @param {string} propertyName Name of the property to update / create
   * @param {String|Number|AbstractValue|String[]|Number[]|AbstractValue[]|null} value The value to set
   */
  updatePropertyWithValue(e, t) {
    this._modify();
    const n = this.getFirstProperty(e);
    if (n)
      n.value = t;
    else {
      const i = Ii(e), s = new i(e, t, [], this, this.root);
      this.addProperty(s);
    }
  }
  /**
   * Returns iterator for all properties of a given propertyName
   * or if no propertyName was given over all available properties
   *
   * @param {String=} propertyName Name of the property to get an iterator for
   */
  *getPropertyIterator(e = null) {
    if (e) {
      if (!this.hasProperty(e))
        return;
      yield* this._properties.get(Le(e)).slice()[Symbol.iterator]();
    } else
      for (const t of this._properties.keys())
        yield* this.getPropertyIterator(t);
  }
  /**
   * Get all properties by name that match the given LANG parameter
   *
   * @param {string} propertyName The name of the property
   * @param {String|null} lang The lang to query
   * @private
   */
  *_getAllOfPropertyByLang(e, t) {
    for (const n of this.getPropertyIterator(e))
      n.getParameterFirstValue("LANGUAGE") === t && (yield n);
  }
  /**
   * Get the first property by name that matches the given LANG parameter
   *
   * @param {string} propertyName The name of the property
   * @param {String|null} lang The lang to query
   * @return {Property|null}
   * @private
   */
  _getFirstOfPropertyByLang(e, t) {
    return this._getAllOfPropertyByLang(e, t).next().value || null;
  }
  /**
   * Adds a property
   *
   * @param {Property} property The property to add
   * @return {boolean}
   */
  addProperty(e) {
    if (this._modify(), e.root = this.root, e.parent = this, this._properties.has(e.name)) {
      const t = this._properties.get(e.name);
      if (t.indexOf(e) !== -1)
        return !1;
      t.push(e);
    } else
      this._properties.set(e.name, [e]);
    return e.subscribe(() => this._notifySubscribers()), !0;
  }
  /**
   * Checks if this component has a property of the given name
   *
   * @param {string} propertyName The name of the property
   * @return {boolean}
   */
  hasProperty(e) {
    return this._properties.has(Le(e));
  }
  /**
   * Removes the given property from this component
   *
   * @param {Property} property The property to delete
   * @return {boolean}
   */
  deleteProperty(e) {
    if (this._modify(), !this._properties.has(e.name))
      return !1;
    const t = this._properties.get(e.name), n = t.indexOf(e);
    return n === -1 ? !1 : (n !== -1 && t.length === 1 ? this._properties.delete(e.name) : t.splice(n, 1), !0);
  }
  /**
   * Removes all properties of a given name
   *
   * @param {string} propertyName The name of the property
   * @return {boolean}
   */
  deleteAllProperties(e) {
    return this._modify(), this._properties.delete(Le(e));
  }
  /**
   * Gets the first component of a given name
   *
   * @param {string} componentName The name of the component
   * @return {AbstractComponent|null}
   */
  getFirstComponent(e) {
    return this.hasComponent(e) ? this._components.get(Le(e))[0] : null;
  }
  /**
   * Returns iterator for all components of a given componentName
   * or if no componentName was given over all available components
   *
   * @param {String=} componentName The name of the component
   */
  *getComponentIterator(e) {
    if (e) {
      if (!this.hasComponent(e))
        return;
      yield* this._components.get(Le(e)).slice()[Symbol.iterator]();
    } else
      for (const t of this._components.keys())
        yield* this.getComponentIterator(t);
  }
  /**
   * Adds a new component to this component
   *
   * @param {AbstractComponent} component The component to add
   * @return {boolean}
   */
  addComponent(e) {
    if (this._modify(), e.root = this.root, e.parent = this, this._components.has(e.name)) {
      const t = this._components.get(e.name);
      if (t.indexOf(e) !== -1)
        return !1;
      t.push(e);
    } else
      this._components.set(e.name, [e]);
    return e.subscribe(() => this._notifySubscribers()), !0;
  }
  /**
   * Checks if this component has a component of the given name
   *
   * @param {string} componentName The name of the component
   * @return {boolean}
   */
  hasComponent(e) {
    return this._components.has(Le(e));
  }
  /**
   * Removes the given component from this component
   *
   * @param {AbstractComponent} component The component to delete
   * @return {boolean}
   */
  deleteComponent(e) {
    if (this._modify(), !this._components.has(e.name))
      return !1;
    const t = this._components.get(e.name), n = t.indexOf(e);
    return n === -1 ? !1 : (n !== -1 && t.length === 1 ? this._components.delete(e.name) : t.splice(n, 1), !0);
  }
  /**
   * Removes all components of a given name
   *
   * @param {string} componentName The name of the component
   * @return {boolean}
   */
  deleteAllComponents(e) {
    return this._modify(), this._components.delete(Le(e));
  }
  /**
   * Marks this parameter is immutable
   * locks it against further modification
   */
  lock() {
    super.lock();
    for (const e of this.getPropertyIterator())
      e.lock();
    for (const e of this.getComponentIterator())
      e.lock();
  }
  /**
   * Marks this parameter as mutable
   * allowing further modification
   */
  unlock() {
    super.unlock();
    for (const e of this.getPropertyIterator())
      e.unlock();
    for (const e of this.getComponentIterator())
      e.unlock();
  }
  /**
   * Creates a copy of this parameter
   *
   * @return {AbstractComponent}
   */
  clone() {
    const e = [];
    for (const n of this.getPropertyIterator())
      e.push(n.clone());
    const t = [];
    for (const n of this.getComponentIterator())
      t.push(n.clone());
    return new this.constructor(this.name, e, t, this.root, this.parent);
  }
  /**
   * Adds properties from constructor to this._properties
   *
   * @param {Property[]} properties Array of properties
   * @private
   */
  _setPropertiesFromConstructor(e) {
    for (let t of e) {
      if (Array.isArray(t)) {
        const n = Ii(t[0]);
        t = new n(t[0], t[1]);
      }
      this.addProperty(t);
    }
  }
  /**
   * Adds components from constructor to this._components
   *
   * @param {AbstractComponent[]} components Array of components
   * @private
   */
  _setComponentsFromConstructor(e) {
    for (const t of e)
      this.addComponent(t);
  }
  /**
   * Creates a new Component based on an ical object
   *
   * @param {ICAL.Component} icalValue The ical.js component to initialise from
   * @param {CalendarComponent=} root The root of the Calendar Document
   * @param {AbstractComponent=} parent The parent element of this component
   * @return {AbstractComponent}
   */
  static fromICALJs(e, t = null, n = null) {
    if (!(e instanceof ge.Component))
      throw new fu();
    const i = e.name, s = new this(i, [], [], t, n);
    for (const o of e.getAllProperties()) {
      const a = Ii(o.name).fromICALJs(o, t, s);
      s.addProperty(a);
    }
    for (const o of e.getAllSubcomponents()) {
      const a = this._getConstructorForComponentName(o.name).fromICALJs(o, t, s);
      s.addComponent(a);
    }
    return s;
  }
  /**
   * Gets a constructor for a give component name
   *
   * @param {string} componentName The name of the component
   * @return {AbstractComponent}
   * @protected
   */
  static _getConstructorForComponentName(e) {
    return qt;
  }
  /**
   * turns this Component into an ICAL.js component
   *
   * @return {ICAL.Component}
   */
  toICALJs() {
    const e = zE(Vt(this.name));
    for (const t of this.getPropertyIterator())
      e.addProperty(t.toICALJs());
    for (const t of this.getComponentIterator())
      e.addSubcomponent(t.toICALJs());
    return e;
  }
}
function we(r, e, t = !0) {
  e = qE(e), Object.defineProperty(r, e.name, {
    get() {
      const n = this.getFirstPropertyFirstValue(e.iCalendarName);
      return n ? Array.isArray(e.allowedValues) && !e.allowedValues.includes(n) ? e.unknownValue : n : e.defaultValue;
    },
    set(n) {
      if (this._modify(), n === null) {
        this.deleteAllProperties(e.iCalendarName);
        return;
      }
      if (Array.isArray(e.allowedValues) && !e.allowedValues.includes(n))
        throw new TypeError("Illegal value");
      this.updatePropertyWithValue(e.iCalendarName, n);
    }
  });
}
function Yt(r, e) {
  e = rh(e), r["get" + Tt(e.name) + "Iterator"] = function* () {
    yield* this.getPropertyIterator(e.iCalendarName);
  }, r["get" + Tt(e.name) + "List"] = function() {
    return Array.from(this["get" + Tt(e.name) + "Iterator"]());
  }, r["remove" + Tt(e.name)] = function(t) {
    this.deleteProperty(t);
  }, r["clearAll" + Tt(e.pluralName)] = function() {
    this.deleteAllProperties(e.iCalendarName);
  };
}
function hu(r, e) {
  e = rh(e), r["get" + Tt(e.name) + "Iterator"] = function* (t = null) {
    for (const n of this._getAllOfPropertyByLang(e.iCalendarName, t))
      yield* n.getValueIterator();
  }, r["get" + Tt(e.name) + "List"] = function(t = null) {
    return Array.from(this["get" + Tt(e.name) + "Iterator"](t));
  }, r["add" + Tt(e.name)] = function(t, n = null) {
    const i = this._getFirstOfPropertyByLang(e.iCalendarName, n);
    if (i)
      i.addValue(t);
    else {
      const s = new mt(e.iCalendarName, [t]);
      if (n) {
        const o = new nn("LANGUAGE", n);
        s.setParameter(o);
      }
      this.addProperty(s);
    }
  }, r["remove" + Tt(e.name)] = function(t, n = null) {
    for (const i of this._getAllOfPropertyByLang(e.iCalendarName, n))
      if (i.isMultiValue() && i.hasValue(t))
        return i.value.length === 1 ? (this.deleteProperty(i), !0) : (i.removeValue(t), !0);
    return !1;
  }, r["clearAll" + Tt(e.pluralName)] = function(t = null) {
    for (const n of this._getAllOfPropertyByLang(e.iCalendarName, t))
      this.deleteProperty(n);
  };
}
function VE(r, e) {
  e = WE(e), r["get" + Tt(e.name) + "Iterator"] = function* () {
    yield* this.getComponentIterator(e.iCalendarName);
  }, r["get" + Tt(e.name) + "List"] = function() {
    return Array.from(this["get" + Tt(e.name) + "Iterator"]());
  }, r["remove" + Tt(e.name)] = function(t) {
    this.deleteComponent(t);
  }, r["clearAll" + Tt(e.pluralName)] = function() {
    this.deleteAllComponents(e.iCalendarName);
  };
}
function qE(r) {
  return typeof r == "string" && (r = {
    name: r
  }), Object.assign({}, {
    iCalendarName: Le(r.name),
    pluralName: r.name + "s",
    allowedValues: null,
    defaultValue: null,
    unknownValue: null
  }, r);
}
function rh(r) {
  return typeof r == "string" && (r = {
    name: r
  }), Object.assign({}, {
    iCalendarName: Le(r.name),
    pluralName: r.name + "s"
  }, r);
}
function WE(r) {
  return typeof r == "string" && (r = {
    name: r
  }), Object.assign({}, {
    iCalendarName: "V" + Le(r.name),
    pluralName: r.name + "s"
  }, r);
}
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
function _t() {
  return new Date();
}
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class nh extends Error {
}
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class ei {
  /**
   * Constructor
   *
   * @param {AbstractRecurringComponent} masterItem The master-item of the recurrence-set
   */
  constructor(e) {
    this._masterItem = e, this._recurrenceExceptionItems = /* @__PURE__ */ new Map(), this._rangeRecurrenceExceptionItemsIndex = [], this._rangeRecurrenceExceptionItemsDiffCache = /* @__PURE__ */ new Map(), this._rangeRecurrenceExceptionItems = /* @__PURE__ */ new Map();
  }
  /**
   *
   * @return {AbstractRecurringComponent}
   */
  get masterItem() {
    return this._masterItem;
  }
  /**
   *
   * @param {AbstractRecurringComponent} masterItem The master-item of the recurrence-set
   */
  set masterItem(e) {
    this._masterItem = e;
  }
  /**
   * Gets an iterator over all registered recurrence exceptions of this calendar-document
   */
  *getRecurrenceExceptionIterator() {
    yield* this._recurrenceExceptionItems.values();
  }
  /**
   * Gets a list of all registered recurrence-exceptions of this calendar-document
   *
   * @return {AbstractRecurringComponent[]}
   */
  getRecurrenceExceptionList() {
    return Array.from(this.getRecurrenceExceptionIterator());
  }
  /**
   * Checks if there is a recurrence Exception for a given recurrenceId
   *
   * @param {DateTimeValue|Number} recurrenceId The recurrenceId to check
   * @return {boolean}
   */
  hasRecurrenceExceptionForId(e) {
    return e instanceof Oe ? e = e.unixTime : e instanceof ge.Time && (e = e.toUnixTime()), this._recurrenceExceptionItems.has(e);
  }
  /**
   * Gets the recurrence exception for a given recurrence Id
   *
   * @param {DateTimeValue|Number} recurrenceId The recurrenceId to get
   * @return {AbstractRecurringComponent|null}
   */
  getRecurrenceException(e) {
    return e instanceof Oe ? e = e.unixTime : e instanceof ge.Time && (e = e.toUnixTime()), this._recurrenceExceptionItems.get(e) || null;
  }
  /**
   * Check if there is a recurrence-exception with a range for a given recurrence-id
   *
   * @param {DateTimeValue|Number} recurrenceId The recurrenceId to check
   * @return {boolean}
   */
  hasRangeRecurrenceExceptionForId(e) {
    return e instanceof Oe ? e = e.unixTime : e instanceof ge.Time && (e = e.toUnixTime()), this._rangeRecurrenceExceptionItemsIndex.length === 0 ? !1 : this._rangeRecurrenceExceptionItemsIndex[0] < e;
  }
  /**
   * Get recurrence-exception with range that's affecting the given recurrence-id
   *
   * @param {DateTimeValue|Number} recurrenceId The recurrenceId to get
   * @return {AbstractRecurringComponent|null}
   */
  getRangeRecurrenceExceptionForId(e) {
    e instanceof Oe ? e = e.unixTime : e instanceof ge.Time && (e = e.toUnixTime());
    const t = ge.helpers.binsearchInsert(this._rangeRecurrenceExceptionItemsIndex, e, (i, s) => i - s);
    if (t === 0)
      return null;
    const n = this._rangeRecurrenceExceptionItemsIndex[t - 1];
    return this._rangeRecurrenceExceptionItems.get(n);
  }
  /**
   * Gets the difference between recurrence-id and start
   * Mostly needed to handle recurrence-exceptions with range
   *
   * @param {DateTimeValue|Number} recurrenceId The recurrenceId to get
   * @return {DurationValue|null}
   */
  getRangeRecurrenceExceptionDiff(e) {
    if (e instanceof Oe ? e = e.unixTime : e instanceof ge.Time && (e = e.toUnixTime()), this._rangeRecurrenceExceptionItemsDiffCache.has(e))
      return this._rangeRecurrenceExceptionItemsDiffCache.get(e);
    const t = this.getRangeRecurrenceExceptionForId(e);
    if (!t)
      return null;
    const n = t.recurrenceId, s = t.startDate.subtractDateWithTimezone(n);
    return s.lock(), this._rangeRecurrenceExceptionItemsDiffCache.set(e, s), s;
  }
  /**
   * Adds a new recurrence-exception to this calendar-document
   *
   * @param {AbstractRecurringComponent} recurrenceExceptionItem The recurrence-exception-item to relate to recurrence-set
   */
  relateRecurrenceException(e) {
    this._modify();
    const t = this._getRecurrenceIdKey(e);
    if (this._recurrenceExceptionItems.set(t, e), e.modifiesFuture()) {
      this._rangeRecurrenceExceptionItems.set(t, e);
      const n = ge.helpers.binsearchInsert(this._rangeRecurrenceExceptionItemsIndex, t, (i, s) => i - s);
      this._rangeRecurrenceExceptionItemsIndex.splice(n, 0, t);
    }
    e.recurrenceManager = this;
  }
  /**
   * Removes a recurrence exception by the item itself
   *
   * @param {AbstractRecurringComponent} recurrenceExceptionItem The recurrence-exception remove
   */
  removeRecurrenceException(e) {
    const t = this._getRecurrenceIdKey(e);
    this.removeRecurrenceExceptionByRecurrenceId(t);
  }
  /**
   * Removes a recurrence exception by it's unix-time
   *
   * @param {Number} recurrenceId The recurrence-exception to remove
   */
  removeRecurrenceExceptionByRecurrenceId(e) {
    this._modify(), this._recurrenceExceptionItems.delete(e), this._rangeRecurrenceExceptionItems.delete(e), this._rangeRecurrenceExceptionItemsDiffCache.delete(e);
    const t = this._rangeRecurrenceExceptionItemsIndex.indexOf(e);
    t !== -1 && this._rangeRecurrenceExceptionItemsIndex.splice(t, 1);
  }
  /**
   *
   * @param {AbstractRecurringComponent} recurrenceExceptionItem Object to get key from
   * @return {Number}
   * @private
   */
  _getRecurrenceIdKey(e) {
    return e.recurrenceId.unixTime;
  }
  /**
   * Gets an iterator over all recurrence rules
   */
  *getRecurrenceRuleIterator() {
    for (const e of this._masterItem.getPropertyIterator("RRULE"))
      yield e.getFirstValue();
  }
  /**
   * Gets a list of all recurrence rules
   *
   * @return {RecurValue[]}
   */
  getRecurrenceRuleList() {
    return Array.from(this.getRecurrenceRuleIterator());
  }
  /**
   * Adds a new recurrence rule
   *
   * @param {RecurValue} recurrenceRule The RRULE to add
   */
  addRecurrenceRule(e) {
    this._modify(), this.resetCache();
    const t = new mt("RRULE", e);
    this._masterItem.addProperty(t);
  }
  /**
   * Removes a recurrence rule
   *
   * @param {RecurValue} recurrenceRule The RRULE to remove
   */
  removeRecurrenceRule(e) {
    this._modify(), this.resetCache();
    for (const t of this._masterItem.getPropertyIterator("RRULE"))
      t.getFirstValue() === e && this._masterItem.deleteProperty(t);
  }
  /**
   * Removes all recurrence rules
   */
  clearAllRecurrenceRules() {
    this._modify(), this.resetCache(), this._masterItem.deleteAllProperties("RRULE");
  }
  /**
   * Gets an iterator over all recurrence
   *
   * @param {boolean} isNegative Whether or not to get EXDATES
   * @param {string} valueType Limit type of EXDATES
   */
  *getRecurrenceDateIterator(e = !1, t = null) {
    for (const n of this._getPropertiesForRecurrenceDate(e, t))
      yield* n.getValueIterator();
  }
  /**
   *
   * @param {boolean} isNegative Whether or not to get EXDATES
   * @param {string} valueType Limit type of EXDATES
   * @return {(DateTimeValue|PeriodValue)[]}
   */
  listAllRecurrenceDates(e = !1, t = null) {
    return Array.from(this.getRecurrenceDateIterator(e, t));
  }
  /**
   * This adds a new recurrence-date value.
   * It automatically adds it to the first property of the same value-type
   * or creates a new one if necessary
   *
   * @param {boolean} isNegative Whether we are dealing with an EXDATE or RDATE
   * @param {DateTimeValue|PeriodValue} value EXDATE to add
   */
  addRecurrenceDate(e = !1, t) {
    this._modify(), this.resetCache();
    let n = null;
    t instanceof Oe && !t.isDate && (n = t.timezoneId);
    const i = this._getValueTypeByValue(t), o = this._getPropertiesForRecurrenceDate(e, i, n).next.value;
    if (o instanceof mt)
      o.value.push(t), this.masterItem.markPropertyAsDirty(e ? "EXDATE" : "RDATE");
    else {
      const l = this._getPropertyNameByIsNegative(e), a = new mt(l, t);
      this._masterItem.addProperty(a);
    }
  }
  /**
   * Checks if a recurrenceID is an RDATE or EXDATE
   *
   * @param {boolean} isNegative Whether we are dealing with an EXDATE or RDATE
   * @param {DateTimeValue} recurrenceId Recurrence-Id to check
   * @return {boolean}
   */
  hasRecurrenceDate(e = !1, t) {
    for (let n of this.getRecurrenceDateIterator(e))
      if (n instanceof pt && (n = n.start), n.compare(t) === 0)
        return !0;
    return !1;
  }
  /**
   *
   * @param {boolean} isNegative Whether we are dealing with an EXDATE or RDATE
   * @param {DateTimeValue} recurrenceId Recurrence-Id to get
   * @return {null|DateTimeValue|PeriodValue}
   */
  getRecurrenceDate(e = !1, t) {
    for (const n of this.getRecurrenceDateIterator(e)) {
      let i = n;
      if (i instanceof pt && (i = i.start), i.compare(t) === 0)
        return n;
    }
    return null;
  }
  /**
   * This deletes a recurrence-date value from this recurrence-set
   *
   * @param {boolean} isNegative Whether we are dealing with an EXDATE or RDATE
   * @param {DateTimeValue|PeriodValue} value The EXDATE/RDATE to remove
   */
  removeRecurrenceDate(e = !1, t) {
    this._modify(), this.resetCache();
    const n = this._getValueTypeByValue(t);
    for (const i of this._getPropertiesForRecurrenceDate(e, n))
      for (const s of i.getValueIterator())
        if (t === s) {
          const o = i.value;
          if (o.length === 1) {
            this.masterItem.deleteProperty(i);
            continue;
          }
          const l = o.indexOf(t);
          o.splice(l, 1), this.masterItem.markPropertyAsDirty(e ? "EXDATE" : "RDATE");
        }
  }
  /**
   * Clears all recurrence-date information
   *
   * @param {boolean} isNegative Whether we are dealing with an EXDATE or RDATE
   * @param {string} valueType The type of RDATEs/EXDATEs to remove
   */
  clearAllRecurrenceDates(e = !1, t = null) {
    this._modify(), this.resetCache();
    for (const n of this._getPropertiesForRecurrenceDate(e, t))
      this._masterItem.deleteProperty(n);
  }
  /**
   * Gets the property name for recurrence dates based on the isNegative boolean
   *
   * @param {boolean} isNegative Whether we are dealing with an EXDATE or RDATE
   * @return {string}
   * @private
   */
  _getPropertyNameByIsNegative(e) {
    return e ? "EXDATE" : "RDATE";
  }
  /**
   * Gets the value type based on the provided value
   *
   * @param {PeriodValue|DateTimeValue} value The value to get type of property from
   * @return {string}
   * @private
   */
  _getValueTypeByValue(e) {
    return e instanceof pt ? "PERIOD" : e.isDate ? "DATE" : "DATETIME";
  }
  /**
   *
   * @param {boolean} isNegative Whether we are dealing with an EXDATE or RDATE
   * @param {String|null} valueType The type of values to get
   * @param {ICAL.Timezone=} timezoneId Filter by timezone
   * @private
   */
  *_getPropertiesForRecurrenceDate(e, t, n = null) {
    const i = this._getPropertyNameByIsNegative(e);
    for (const s of this._masterItem.getPropertyIterator(i))
      t === null ? yield s : Le(t) === "PERIOD" && s.getFirstValue() instanceof pt ? yield s : Le(t) === "DATE" && s.getFirstValue().isDate ? yield s : Le(t) === "DATETIME" && !s.getFirstValue().isDate && (n === null || s.getFirstValue().timezoneId === n) && (yield s);
  }
  /**
   * Checks if the entire set of recurrence rules is finite
   *
   * @return {boolean}
   */
  isFinite() {
    return this.getRecurrenceRuleList().every((e) => e.isFinite());
  }
  /**
   * @return {boolean}
   */
  isEmptyRecurrenceSet() {
    return this._getRecurExpansionObject().next() === void 0;
  }
  /**
   * Gets the occurrence at the exact given recurrenceId
   *
   * @param {DateTimeValue} recurrenceId RecurrenceId to get
   * @return {AbstractRecurringComponent|null}
   */
  getOccurrenceAtExactly(e) {
    if (!this.masterItem.isRecurring())
      return this.masterItem.getReferenceRecurrenceId().compare(e) === 0 ? this.masterItem : null;
    const t = this._getRecurExpansionObject(), n = e.toICALJs();
    let i;
    for (; i = t.next(); ) {
      if (i.compare(n) === 0)
        return this._getOccurrenceAtRecurrenceId(Oe.fromICALJs(i));
      if (i.compare(n) === 1)
        return null;
    }
    return null;
  }
  /**
   * Gets the closest occurrence to the given recurrenceId.
   * That's either the closest in the future, or in case the
   * recurrence-set ends before recurrenceId, the last one
   *
   * This function works solely on the basis of recurrence-ids.
   * It ignores the actual date of recurrence-exceptions.
   * Ideally we should fix it and provide a similar implementation
   * like getAllOccurrencesBetweenIterator, but for now it's the
   * accepted behavior.
   *
   * @param {DateTimeValue} recurrenceId RecurrenceId to get
   * @return {AbstractRecurringComponent}
   */
  getClosestOccurrence(e) {
    if (!this.masterItem.isRecurring())
      return this.masterItem;
    const t = this._getRecurExpansionObject();
    e = e.toICALJs();
    let n = null, i;
    for (; i = t.next(); )
      if (i.compare(e) === -1)
        n = i;
      else {
        const o = Oe.fromICALJs(i);
        return this._getOccurrenceAtRecurrenceId(o);
      }
    const s = Oe.fromICALJs(n);
    return this._getOccurrenceAtRecurrenceId(s);
  }
  /**
   * Get all occurrences between start and end
   * Start and End are inclusive
   *
   * @param {DateTimeValue} queriedTimeRangeStart Start of time-range
   * @param {DateTimeValue} queriedTimeRangeEnd End of time-range
   */
  *getAllOccurrencesBetweenIterator(e, t) {
    if (!this.masterItem.isRecurring()) {
      typeof this.masterItem.isInTimeFrame != "function" && (yield this.masterItem), this.masterItem.isInTimeFrame(e, t) && (yield this.masterItem);
      return;
    }
    const n = this._getRecurExpansionObject(), i = e.toICALJs(), s = t.toICALJs(), o = Array.from(this._recurrenceExceptionItems.keys()), l = Math.max.apply(Math, o);
    let a;
    for (; a = n.next(); ) {
      const c = Oe.fromICALJs(a), T = this._getOccurrenceAtRecurrenceId(c);
      let u = null;
      switch (Le(T.name)) {
        case "VEVENT":
        case "VTODO":
          u = T.endDate.toICALJs();
          break;
        case "VJOURNAL":
        default:
          u = a;
          break;
      }
      if (u.compare(i) === -1)
        continue;
      const d = T.startDate.toICALJs();
      if ((!T.isRecurrenceException() || T.modifiesFuture()) && d.compare(s) === 1) {
        if (this._recurrenceExceptionItems.size === 0 || a.toUnixTime() > l)
          break;
        continue;
      }
      typeof T.isInTimeFrame != "function" && (yield T), T.isInTimeFrame(e, t) && (yield T);
    }
  }
  /**
   * Get all occurrences between start and end
   *
   * @param {DateTimeValue} start Start of time-range
   * @param {DateTimeValue} end End of time-range
   * @return {(*|null)[]}
   */
  getAllOccurrencesBetween(e, t) {
    return Array.from(this.getAllOccurrencesBetweenIterator(e, t));
  }
  /**
   * Update the UID of all components in the recurrence set
   *
   * @param {string} newUID The new UID of the calendar-document
   */
  updateUID(e) {
    this._masterItem.updatePropertyWithValue("UID", e);
    for (const t of this.getRecurrenceExceptionIterator())
      t.updatePropertyWithValue("UID", e);
  }
  /**
   * Updates the recurrence-information accordingly,
   * whenever the start-date of the master-item changes
   *
   * @param {DateTimeValue} newStartDate The new start-date
   * @param {DateTimeValue} oldStartDate The old start-date
   */
  updateStartDateOfMasterItem(e, t) {
    const n = e.subtractDateWithTimezone(t);
    for (const i of this.getRecurrenceDateIterator(!0))
      this.hasRecurrenceDate(!1, i) || i.addDuration(n);
    for (const i of this.getRecurrenceExceptionIterator())
      this.hasRecurrenceDate(!1, i.recurrenceId) || (this.removeRecurrenceException(i), i.recurrenceId.addDuration(n), this.relateRecurrenceException(i));
    for (const i of this.getRecurrenceRuleIterator())
      i.until && i.until.addDuration(n);
  }
  /**
   * Gets an object for the given recurrenceId
   * It does not verify that the given recurrenceId
   * is actually a valid recurrence of this calendar-document
   *
   * @param {DateTimeValue} recurrenceId Recurrence-Id to get
   * @return {AbstractRecurringComponent}
   * @private
   */
  _getOccurrenceAtRecurrenceId(e) {
    if (this.hasRecurrenceExceptionForId(e)) {
      const t = this.getRecurrenceException(e);
      return t.canCreateRecurrenceExceptions() ? t.forkItem(e) : t;
    } else if (this.hasRangeRecurrenceExceptionForId(e)) {
      const t = this.getRangeRecurrenceExceptionForId(e), n = this.getRangeRecurrenceExceptionDiff(e);
      return t.forkItem(e, n);
    } else
      return e.compare(this._masterItem.startDate) === 0 ? this._masterItem.canCreateRecurrenceExceptions() ? this._masterItem.forkItem(e) : this._masterItem : this._masterItem.forkItem(e);
  }
  /**
   * Resets the internal recur-expansion object.
   * This is necessary after each modification of the
   * recurrence-information
   */
  resetCache() {
  }
  /**
   * Gets a new ICAL.RecurExpansion object
   *
   * Inspired by how ICAL.JS RecurExpansion
   * serialises and unserialises its state
   *
   * @return {ICAL.RecurExpansion}
   * @private
   */
  _getRecurExpansionObject() {
    if (this._masterItem.startDate === null)
      throw new nh();
    const e = this._masterItem.startDate.toICALJs();
    let t = e.clone();
    const n = [];
    let i;
    const s = [];
    let o = null;
    const l = [], a = !1;
    for (const u of this.getRecurrenceRuleIterator())
      n.push(u.toICALJs().iterator(e)), n[n.length - 1].next();
    for (let u of this.getRecurrenceDateIterator()) {
      u instanceof pt && (u = u.start), u = u.toICALJs();
      const d = ge.helpers.binsearchInsert(s, u, (A, f) => A.compare(f));
      s.splice(d, 0, u);
    }
    s.length > 0 && s[0].compare(e) === -1 ? (i = 0, t = s[0].clone()) : (i = ge.helpers.binsearchInsert(s, e, (u, d) => u.compare(d)), o = l[i]);
    for (let u of this.getRecurrenceDateIterator(!0)) {
      u = u.toICALJs();
      const d = ge.helpers.binsearchInsert(l, u, (A, f) => A.compare(f));
      l.splice(d, 0, u);
    }
    const c = ge.helpers.binsearchInsert(l, e, (u, d) => u.compare(d)), T = l[c];
    return new ge.RecurExpansion({
      dtstart: e,
      last: t,
      ruleIterators: n,
      ruleDateInc: i,
      exDateInc: c,
      ruleDates: s,
      ruleDate: o,
      exDates: l,
      exDate: T,
      complete: a
    });
  }
  /**
   * @private
   */
  _modify() {
    if (this._masterItem.isLocked())
      throw new Au();
  }
}
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class ht {
  /**
   * Constructor
   *
   * @param {String|ICAL.Timezone|ICAL.Component} timezoneId Id of the timezone
   * @param {String?} ics The iCalendar timezone definition
   */
  constructor(e, t) {
    this._timezoneId = null, this._ics = null, this._innerValue = null, this._initialized = !1, e instanceof ge.Timezone ? (this._innerValue = e, this._initialized = !0) : e instanceof ge.Component ? (this._innerValue = new ge.Timezone(e), this._initialized = !0) : (this._timezoneId = e, this._ics = t);
  }
  /**
   * Gets the timezone id
   *
   * @return {string}
   */
  get timezoneId() {
    return this._initialized ? this._innerValue.tzid : this._timezoneId;
  }
  /**
   * Gets the UTC Offset for a given date in this timezone
   *
   * @param {Number} year Year of the date
   * @param {Number} month Month of the date (1-based)
   * @param {Number} day Day of the date
   * @param {Number} hour Hour of the date
   * @param {Number} minute Minute of the date
   * @param {Number} second Second of the date
   * @return {Number}
   */
  offsetForArray(e, t, n, i, s, o) {
    this._initialize();
    const l = new ge.Time({
      year: e,
      month: t,
      day: n,
      hour: i,
      minute: s,
      second: o,
      isDate: !1
    });
    return this._innerValue.utcOffset(l);
  }
  /**
   * Converts a timestamp to an array of year, month, day, hour, minute, second.
   *
   * @param {Number} ms Timestamp in milliseconds
   * @return {Number[]}
   */
  timestampToArray(e) {
    this._initialize();
    const t = ge.Time.fromData({
      year: 1970,
      month: 1,
      day: 1,
      hour: 0,
      minute: 0,
      second: 0
    });
    t.fromUnixTime(Math.floor(e / 1e3));
    const n = t.convertToZone(this._innerValue);
    return [
      n.year,
      n.month,
      // THIS is 1-based !
      n.day,
      n.hour,
      n.minute,
      n.second
    ];
  }
  /**
   * Returns
   *
   * @return {ICAL.Timezone}
   */
  toICALTimezone() {
    return this._initialize(), this._innerValue;
  }
  /**
   * Returns the corresponding ICAL.
   *
   * @return {ICAL.Component}
   */
  toICALJs() {
    return this._initialize(), this._innerValue.component;
  }
  /**
   * Initialises the inner ICAL.Timezone component
   *
   * @private
   */
  _initialize() {
    if (!this._initialized) {
      const e = ge.parse(this._ics), t = new ge.Component(e);
      this._innerValue = new ge.Timezone(t), this._initialized = !0;
    }
  }
}
ht.utc = new ht(ge.Timezone.utcTimezone);
ht.floating = new ht(ge.Timezone.localTimezone);
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class Lt extends qt {
  /**
   * Adds a new attendee based on their name and email-address
   *
   * @param {string} name - Name of the attendee
   * @param {string} email - E-Mail address of the attendee
   * @return {boolean}
   */
  addAttendeeFromNameAndEMail(e, t) {
    const n = xt.fromNameAndEMail(e, t);
    return this.addProperty(n);
  }
  /**
   * Gets the trigger property
   *
   * @url https://tools.ietf.org/html/rfc5545#section-3.8.6.3
   *
   * @return {TriggerProperty}
   */
  get trigger() {
    return this.getFirstProperty("TRIGGER");
  }
  /**
   * Sets an absolute alarm
   *
   * @param {DateTimeValue} alarmTime - Absolute time for the trigger
   */
  setTriggerFromAbsolute(e) {
    const t = or.fromAbsolute(e);
    this.deleteAllProperties("TRIGGER"), this.addProperty(t);
  }
  /**
   * Sets a relative trigger
   *
   * @param {DurationValue} alarmOffset - Relative time of the trigger, either related to start or end
   * @param {boolean=} relatedToStart - Related to Start or end?
   */
  setTriggerFromRelative(e, t = !0) {
    const n = or.fromRelativeAndRelated(e, t);
    this.deleteAllProperties("TRIGGER"), this.addProperty(n);
  }
}
we(Lt.prototype, "action");
we(Lt.prototype, "description");
we(Lt.prototype, "summary");
we(Lt.prototype, "duration");
we(Lt.prototype, "repeat");
we(Lt.prototype, {
  name: "attachment",
  iCalendarName: "ATTACH"
});
Yt(Lt.prototype, "attendee");
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
function QE(r) {
  switch (Le(r)) {
    case "VALARM":
      return Lt;
    default:
      return qt;
  }
}
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class qe extends qt {
  /**
   * @inheritDoc
   */
  constructor(...e) {
    super(...e), this._primaryItem = null, this._isExactForkOfPrimary = !1, this._originalRecurrenceId = null, this._recurrenceManager = null, this._dirty = !1, this._significantChange = !1, this._cachedId = null;
  }
  /**
   * Gets the primary-item of this recurring item
   *
   * @return {AbstractRecurringComponent}
   */
  get primaryItem() {
    return this._primaryItem;
  }
  /**
   * Sets the primary-item of this recurring item
   *
   * @param {AbstractRecurringComponent} primaryItem The new primary-item
   */
  set primaryItem(e) {
    this._modify(), this._primaryItem = e;
  }
  /**
   * Gets whether or not this is a fork of the primary item
   * for the same recurrence-id
   *
   * @return {boolean}
   */
  get isExactForkOfPrimary() {
    return this._isExactForkOfPrimary;
  }
  /**
   * Sets the isExactForkOfPrimary indicator, see getter for description
   *
   * @param {boolean} isExactForkOfPrimary Whether or not this is an exact fork
   */
  set isExactForkOfPrimary(e) {
    this._isExactForkOfPrimary = e;
  }
  /**
   * Gets the original recurrence-id
   *
   * @return {DateTimeValue}
   */
  get originalRecurrenceId() {
    return this._originalRecurrenceId;
  }
  /**
   * Sets the original recurrence-id
   *
   * @param {DateTimeValue} originalRecurrenceId The new original recurrence-id
   */
  set originalRecurrenceId(e) {
    this._originalRecurrenceId = e;
  }
  /**
   * Gets the recurrence-manager of this recurrence-set
   *
   * @return {RecurrenceManager}
   */
  get recurrenceManager() {
    return this._recurrenceManager;
  }
  /**
   * Sets the recurrence-manager of this recurrence-set
   *
   * @param {RecurrenceManager} recurrenceManager The new recurrence-manager
   */
  set recurrenceManager(e) {
    this._recurrenceManager = e;
  }
  /**
   * Gets the master-item of this recurring item
   *
   * @return {AbstractRecurringComponent}
   */
  get masterItem() {
    return this.recurrenceManager.masterItem;
  }
  /**
   * Returns whether this item is the master item
   *
   * @return {boolean}
   */
  isMasterItem() {
    return this.masterItem === this;
  }
  /**
   * Gets a unique ID for this occurrence of the event
   *
   * Please note that if the same event occurs in multiple calendars,
   * this id will not be unique. Software using this library will have to
   * manually mix in the calendar id into this id
   *
   * @return {string}
   */
  get id() {
    return this._cachedId ? this._cachedId : this.startDate === null ? (this._cachedId = encodeURIComponent(this.uid), this._cachedId) : (this._cachedId = [encodeURIComponent(this.uid), encodeURIComponent(this.getReferenceRecurrenceId().unixTime.toString())].join("###"), this._cachedId);
  }
  /**
   * Gets the UID property
   *
   * @return {String|null}
   */
  get uid() {
    return this.getFirstPropertyFirstValue("UID");
  }
  /**
   * Sets the UID property and the UID property of all related exceptions
   *
   * @param {string} uid The new UID
   */
  set uid(e) {
    this._recurrenceManager.updateUID(e);
  }
  /**
   * Gets the start date of the event
   *
   * @return {DateTimeValue}
   */
  get startDate() {
    return this.getFirstPropertyFirstValue("dtstart");
  }
  /**
   * Sets the start date of the event
   *
   * @param {DateTimeValue} start The new start-date to set
   */
  set startDate(e) {
    const t = this.startDate;
    this.updatePropertyWithValue("dtstart", e), this.isMasterItem() && this._recurrenceManager.updateStartDateOfMasterItem(e, t);
  }
  /**
   * Checks whether this item is part of a recurring set
   *
   * @return {boolean}
   */
  isPartOfRecurrenceSet() {
    return this.masterItem.isRecurring();
  }
  /**
   * Checks whether this component is recurring
   *
   * @return {boolean}
   */
  isRecurring() {
    return this.hasProperty("RRULE") || this.hasProperty("RDATE");
  }
  /**
   * Checks whether this component is a recurrence-exception
   *
   * @return {boolean}
   */
  isRecurrenceException() {
    return this.hasProperty("RECURRENCE-ID");
  }
  /**
   * Checks wether this component is a recurrence-exception
   * and whether it's modifying the future
   *
   * @return {boolean}
   */
  modifiesFuture() {
    return this.isRecurrenceException() ? this.getFirstProperty("RECURRENCE-ID").getParameterFirstValue("RANGE") === "THISANDFUTURE" : !1;
  }
  /**
   * Creates an occurrence at the given time
   *
   * This is an internal function for calendar-js, used by the recurrence-manager
   * Do not call from outside
   *
   * @param {DateTimeValue} recurrenceId The recurrence-Id of the forked item
   * @param {DurationValue=} startDiff to be used when The start-diff (used for RECURRENCE-ID;RANGE=THISANDFUTURE)
   * @return {AbstractRecurringComponent}
   */
  forkItem(e, t = null) {
    const n = this.clone();
    if (n.recurrenceManager = this.recurrenceManager, n.primaryItem = this, n.getReferenceRecurrenceId().compare(e) === 0 && (n.isExactForkOfPrimary = !0), !n.hasProperty("DTSTART"))
      throw new TypeError("Can't fork item without a DTSTART");
    if (n.getFirstPropertyFirstValue("DTSTART").timezoneId !== e.timezoneId) {
      const l = n.getFirstPropertyFirstValue("DTSTART").getICALTimezone();
      e = e.getInICALTimezone(l);
    }
    n.originalRecurrenceId = e.clone();
    const i = n.getFirstPropertyFirstValue("DTSTART");
    let s = null;
    if (this._recurrenceManager.hasRecurrenceDate(!1, e)) {
      const l = this._recurrenceManager.getRecurrenceDate(!1, e);
      l instanceof pt && (s = l);
    }
    let o;
    if (n.hasProperty("DTEND") ? o = n.getFirstPropertyFirstValue("DTEND").subtractDateWithTimezone(i) : n.hasProperty("DUE") && (o = n.getFirstPropertyFirstValue("DUE").subtractDateWithTimezone(i)), !(n.isRecurrenceException() && n.isExactForkOfPrimary)) {
      if (n.updatePropertyWithValue("DTSTART", e.clone()), t && n.startDate.addDuration(t), n.hasProperty("DTEND")) {
        const l = n.startDate.clone();
        l.addDuration(o), n.updatePropertyWithValue("DTEND", l);
      } else if (n.hasProperty("DUE")) {
        const l = n.startDate.clone();
        l.addDuration(o), n.updatePropertyWithValue("DUE", l);
      }
      s && (n.deleteAllProperties("DTEND"), n.deleteAllProperties("DURATION"), n.updatePropertyWithValue("DTEND", s.end.clone()));
    }
    return n.resetDirty(), n;
  }
  /**
   * Checks whether it's possible to create a recurrence exception for this event
   * It is possible
   *
   * @return {boolean}
   */
  canCreateRecurrenceExceptions() {
    let e = !1;
    return this.primaryItem && this.primaryItem.isRecurring() && (e = !0), this.isRecurring() || this.modifiesFuture() || !this.isRecurring() && e;
  }
  /**
   * creates a recurrence exception based on this event
   * If the parameter thisAndAllFuture is set to true,
   * it will apply changes to this and all future occurrences
   *
   * @param {boolean} thisAndAllFuture Whether to create an exception for this and all future
   * @return {AbstractRecurringComponent[]} the AbstractRecurringComponent of the future events.
   * In case you set `thisAndAllFuture` to true, this will be an
   * AbstractRecurringComponent inside a entirely new calendar component
   */
  createRecurrenceException(e = !1) {
    if (!this.canCreateRecurrenceExceptions())
      throw new Error("Can't create recurrence-exceptions for non-recurring items");
    const t = this.primaryItem;
    if (e) {
      if (this.isExactForkOfPrimary && this.primaryItem.isMasterItem())
        return this._overridePrimaryItem(), [this, this];
      this.removeThisOccurrence(!0), this.recurrenceManager = new ei(this), this._originalRecurrenceId = null, this.primaryItem = this, this.updatePropertyWithValue("UID", va()), this._cachedId = null, this.addRelation("SIBLING", t.uid), t.addRelation("SIBLING", this.uid), this.deleteAllProperties("RECURRENCE-ID"), this.deleteAllProperties("RDATE"), this.deleteAllProperties("EXDATE"), this.updatePropertyWithValue("CREATED", Oe.fromJSDate(_t(), !0)), this.updatePropertyWithValue("DTSTAMP", Oe.fromJSDate(_t(), !0)), this.updatePropertyWithValue("LAST-MODIFIED", Oe.fromJSDate(_t(), !0)), this.updatePropertyWithValue("SEQUENCE", 0), this._significantChange = !1, this._dirty = !1, this.root = this.root.constructor.fromEmpty(), this.root.addComponent(this), this.parent = this.root;
      for (const n of this.getAttendeeIterator())
        n.rsvp = !0;
    } else {
      if (this.deleteAllProperties("RECURRENCE-ID"), this.recurrenceId = this.getReferenceRecurrenceId().clone(), this.root.addComponent(this), this.recurrenceManager.relateRecurrenceException(this), this.primaryItem = this, this.deleteAllProperties("RDATE"), this.deleteAllProperties("RRULE"), this.deleteAllProperties("EXDATE"), this.updatePropertyWithValue("CREATED", Oe.fromJSDate(_t(), !0)), this.updatePropertyWithValue("DTSTAMP", Oe.fromJSDate(_t(), !0)), this.updatePropertyWithValue("LAST-MODIFIED", Oe.fromJSDate(_t(), !0)), this.updatePropertyWithValue("SEQUENCE", 0), this.recurrenceManager.hasRecurrenceDate(!1, this.getReferenceRecurrenceId())) {
        const n = this.recurrenceManager.getRecurrenceDate(!1, this.getReferenceRecurrenceId());
        if (n instanceof pt) {
          const i = n.start;
          this.recurrenceManager.removeRecurrenceDate(!1, n), this.recurrenceManager.addRecurrenceDate(!1, i);
        }
      }
      this.originalRecurrenceId = null;
    }
    return [t, this];
  }
  /**
   * Deletes this occurrence from the series of recurring events
   * If the parameter thisAndAllFuture is set to true,
   * it will remove this and all future occurrences
   *
   * @param {boolean} thisAndAllFuture Whether to create an exception for this and all future
   * @throws EmptyRecurrenceSetError Thrown, when deleting an occurrence results in no more events
   * @return {boolean} true if this deleted the last occurrence in set, false if there are occurrences left
   */
  removeThisOccurrence(e = !1) {
    if (!this.isPartOfRecurrenceSet())
      return !0;
    if (e) {
      const t = this.getReferenceRecurrenceId().clone(), n = t.getInTimezone(ht.utc);
      n.addDuration(yt.fromSeconds(-1));
      for (const i of this.recurrenceManager.getRecurrenceRuleIterator())
        i.until = n.clone();
      for (const i of this.recurrenceManager.getRecurrenceDateIterator()) {
        let s = i;
        i instanceof pt && (s = s.start), t.compare(s) <= 0 && this.recurrenceManager.removeRecurrenceDate(!1, i);
      }
      for (const i of this.recurrenceManager.getRecurrenceDateIterator(!0))
        t.compare(i) <= 0 && this.recurrenceManager.removeRecurrenceDate(!0, i);
      for (const i of this.recurrenceManager.getRecurrenceExceptionList())
        t.compare(i.recurrenceId) <= 0 && (this.root.deleteComponent(i), this.recurrenceManager.removeRecurrenceException(i));
    } else if (this.isRecurrenceException() && !this.modifiesFuture() && (this.root.deleteComponent(this), this.recurrenceManager.removeRecurrenceException(this)), this.recurrenceManager.hasRecurrenceDate(!1, this.getReferenceRecurrenceId())) {
      const t = this.recurrenceManager.getRecurrenceDate(!1, this.getReferenceRecurrenceId());
      this.recurrenceManager.removeRecurrenceDate(!1, t);
    } else
      this.recurrenceManager.addRecurrenceDate(!0, this.getReferenceRecurrenceId().clone());
    return this.recurrenceManager.isEmptyRecurrenceSet();
  }
  /**
   * @inheritDoc
   */
  clone() {
    const e = super.clone();
    return e.resetDirty(), e;
  }
  /**
   * Adds a new attendee
   *
   * @param {AttendeeProperty} attendee The attendee property to add
   * @private
   * @return {boolean}
   */
  _addAttendee(e) {
    for (const t of this.getAttendeeIterator())
      if (t.email === e.email)
        return !1;
    return this.addProperty(e), !0;
  }
  /**
   * Adds a new attendee based on their name and email-address
   *
   * @param {string} name The name of the attendee to add
   * @param {string} email The email-address of the attendee to add
   * @return {boolean}
   */
  addAttendeeFromNameAndEMail(e, t) {
    const n = xt.fromNameAndEMail(e, t);
    return this._addAttendee(n);
  }
  /**
   * Adds a new attendee based on their properties
   *
   * @param {string} name The name of the attendee to add
   * @param {string} email The email-address of the attendee to add
   * @param {string} role The role of the attendee to add
   * @param {string} userType The type of attendee to add
   * @param {boolean} rsvp Whether or not to request a response from the attendee
   * @return {boolean}
   */
  addAttendeeFromNameEMailRoleUserTypeAndRSVP(e, t, n, i, s) {
    const o = xt.fromNameEMailRoleUserTypeAndRSVP(e, t, n, i, s, !1);
    return this._addAttendee(o);
  }
  /**
   * Sets the organiser property from common-name and email address
   *
   * @param {string} name The name of the organizer
   * @param {string} email The email-address of the organizer
   */
  setOrganizerFromNameAndEMail(e, t) {
    this.deleteAllProperties("ORGANIZER"), this.addProperty(xt.fromNameAndEMail(e, t, !0));
  }
  /**
   * Adds a new attachment from raw data
   *
   * @param {string} data The data of the attachment
   * @param {string} formatType The mime-type of the attachment
   */
  addAttachmentFromData(e, t = null) {
    this.addProperty(Fr.fromData(e, t));
  }
  /**
   * Adds a new attachment from a link
   *
   * @param {string} uri The URI of the attachment
   * @param {string} formatType The mime-type of the attachment
   */
  addAttachmentFromLink(e, t = null) {
    this.addProperty(Fr.fromLink(e, t));
  }
  /**
   * Adds a new contact
   *
   * @url https://tools.ietf.org/html/rfc5545#section-3.8.4.2
   *
   * @param {string} contact The textual contact description to add
   */
  addContact(e) {
    this.addProperty(new Xn("CONTACT", e));
  }
  /**
   * Adds a new comment
   *
   * @url https://tools.ietf.org/html/rfc5545#section-3.8.1.4
   *
   * @param {string} comment The comment to add
   */
  addComment(e) {
    this.addProperty(new Xn("COMMENT", e));
  }
  /**
   * Adds a new image from raw data
   *
   * @param {string} data Data of the image to add
   * @param {String=} display What display-type the image is optimized for
   * @param {String=} formatType The mime-type of the image
   */
  addImageFromData(e, t = null, n = null) {
    this.addProperty(jr.fromData(e, t, n));
  }
  /**
   * Adds a new image from a link
   *
   * @param {string} uri The URI of the image to add
   * @param {String=} display What display-type the image is optimized for
   * @param {String=} formatType The mime-type of the image
   */
  addImageFromLink(e, t = null, n = null) {
    this.addProperty(jr.fromLink(e, t, n));
  }
  /**
   * Creates a new RELATED-TO property based on a relation-type and id
   * and adds it to this object
   *
   * @param {string} relType The type of relation to add
   * @param {string} relId The id of the related calendar-document
   */
  addRelation(e, t) {
    this.addProperty(ai.fromRelTypeAndId(e, t));
  }
  /**
   * Creates a new REQUEST-STATUS property based on code and message
   * and adds it to this object
   *
   * @param {Number} code The status-code of the request status
   * @param {string} message The message of the request status
   */
  addRequestStatus(e, t) {
    this.addProperty(Be.fromCodeAndMessage(e, t));
  }
  /**
   * Adds a new absolute alarm based on action and trigger time
   *
   * @param {string} action The type of alarm Action
   * @param {DateTimeValue} alarmTime The trigger time of the alarm
   * @return {AlarmComponent}
   */
  addAbsoluteAlarm(e, t) {
    const n = new Lt("VALARM", [["action", e], or.fromAbsolute(t)]);
    return this.addComponent(n), n;
  }
  /**
   * Adds a new relative alarm based on action, trigger time and relativeTo parameter
   *
   * @param {string} action The type of alarm Action
   * @param {DurationValue} alarmOffset The trigger time of the alarm
   * @param {boolean=} relatedToStart Whether or not the alarm is related to the event's start
   * @return {AlarmComponent}
   */
  addRelativeAlarm(e, t, n = !0) {
    const i = new Lt("VALARM", [["action", e], or.fromRelativeAndRelated(t, n)]);
    return this.addComponent(i), i;
  }
  /**
   * Marks a certain property as edited
   *
   * @param {string} propertyName The name of the property
   */
  markPropertyAsDirty(e) {
    this.markDirty(), ["DTSTART", "DTEND", "DURATION", "RRULE", "RDATE", "EXDATE", "STATUS", ...Ll("property-list-significant-change", [])].includes(Le(e)) && this.markChangesAsSignificant();
  }
  /**
   * Marks a certain component as edited
   *
   * @param {string} componentName The name of the component
   */
  markSubComponentAsDirty(e) {
    this.markDirty(), Ll("component-list-significant-change", []).includes(e) && this.markChangesAsSignificant();
  }
  /**
   * Returns whether or not this component is dirty
   *
   * @return {boolean}
   */
  isDirty() {
    return this._dirty || this._significantChange;
  }
  /**
   * Marks this object as dirty
   */
  markDirty() {
    this._dirty = !0;
  }
  /**
   * Marks changes as significant. Can be called by the program using this lib
   */
  markChangesAsSignificant() {
    this._significantChange = !0;
  }
  /**
   * Updates the event after modifications.
   *
   * @return {boolean} true if last-modified was updated
   */
  undirtify() {
    return this.isDirty() ? (this.hasProperty("SEQUENCE") || (this.sequence = 0), this.updatePropertyWithValue("DTSTAMP", Oe.fromJSDate(_t(), !0)), this.updatePropertyWithValue("LAST-MODIFIED", Oe.fromJSDate(_t(), !0)), this._significantChange && this.sequence++, this.resetDirty(), !0) : !1;
  }
  /**
   * Resets the dirty indicators without updating DTSTAMP or LAST-MODIFIED
   */
  resetDirty() {
    this._dirty = !1, this._significantChange = !1;
  }
  /**
   * @inheritDoc
   */
  updatePropertyWithValue(e, t) {
    super.updatePropertyWithValue(e, t), Le(e) === "UID" && (this._cachedId = null), this.markPropertyAsDirty(e);
  }
  /**
   * @inheritDoc
   */
  addProperty(e) {
    return this.markPropertyAsDirty(e.name), e.subscribe(() => this.markPropertyAsDirty(e.name)), super.addProperty(e);
  }
  /**
   * @inheritDoc
   */
  deleteProperty(e) {
    return this.markPropertyAsDirty(e.name), super.deleteProperty(e);
  }
  /**
   * @inheritDoc
   */
  deleteAllProperties(e) {
    return this.markPropertyAsDirty(e), super.deleteAllProperties(e);
  }
  /**
   * @inheritDoc
   */
  addComponent(e) {
    return this.markSubComponentAsDirty(e.name), e.subscribe(() => this.markSubComponentAsDirty(e.name)), super.addComponent(e);
  }
  /**
   * @inheritDoc
   */
  deleteComponent(e) {
    return this.markSubComponentAsDirty(e.name), super.deleteComponent(e);
  }
  /**
   * @inheritDoc
   */
  deleteAllComponents(e) {
    return this.markSubComponentAsDirty(e), super.deleteAllComponents(e);
  }
  /**
   * Gets a recurrence-id that has to be used to refer to this event.
   * This is used for recurrence-management
   *
   * @return {DateTimeValue}
   */
  getReferenceRecurrenceId() {
    return this.originalRecurrenceId ? this.originalRecurrenceId : this.recurrenceId ? this.recurrenceId : this.startDate;
  }
  /**
   * Overrides the master item with this one
   *
   * @private
   */
  _overridePrimaryItem() {
    const e = this.primaryItem.startDate;
    for (const t of this.primaryItem.getPropertyIterator())
      this.primaryItem.deleteProperty(t);
    for (const t of this.getPropertyIterator())
      this.primaryItem.addProperty(t);
    this.recurrenceManager.resetCache(), this.startDate.compare(e) !== 0 && this.recurrenceManager.updateStartDateOfMasterItem(this.startDate, e);
  }
  /**
   * @inheritDoc
   */
  static _getConstructorForComponentName(e) {
    return QE(e);
  }
  /**
   * @inheritDoc
   */
  static fromICALJs(...e) {
    const t = super.fromICALJs(...e);
    return t.resetDirty(), t;
  }
}
we(qe.prototype, {
  name: "stampTime",
  iCalendarName: "DTSTAMP"
});
we(qe.prototype, {
  name: "recurrenceId",
  iCalendarName: "RECURRENCE-ID"
});
we(qe.prototype, "color");
we(qe.prototype, {
  name: "creationTime",
  iCalendarName: "CREATED"
});
we(qe.prototype, {
  name: "modificationTime",
  iCalendarName: "LAST-MODIFIED"
});
we(qe.prototype, "organizer");
we(qe.prototype, "sequence");
we(qe.prototype, "status");
we(qe.prototype, "url");
we(qe.prototype, {
  name: "title",
  iCalendarName: "SUMMARY"
});
we(qe.prototype, {
  name: "accessClass",
  iCalendarName: "class",
  allowedValues: ["PUBLIC", "PRIVATE", "CONFIDENTIAL"],
  defaultValue: "PUBLIC",
  unknownValue: "PRIVATE"
});
hu(qe.prototype, {
  name: "category",
  pluralName: "categories",
  iCalendarName: "CATEGORIES"
});
Yt(qe.prototype, {
  name: "attendee"
});
Yt(qe.prototype, {
  name: "attachment",
  iCalendarName: "ATTACH"
});
Yt(qe.prototype, {
  name: "relation",
  iCalendarName: "RELATED-TO"
});
Yt(qe.prototype, "comment");
Yt(qe.prototype, "contact");
Yt(qe.prototype, "image");
Yt(qe.prototype, {
  name: "requestStatus",
  pluralName: "requestStatus",
  iCalendarName: "REQUEST-STATUS"
});
VE(qe.prototype, "alarm");
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
function ih(r) {
  return r.getFirstPropertyFirstValue("X-NEXTCLOUD-BC-FIELD-TYPE");
}
function KE(r) {
  switch (ih(r)) {
    case "BDAY":
      return "🎂";
    case "DEATHDATE":
      return "⚰️";
    case "ANNIVERSARY":
      return "💍";
    default:
      return null;
  }
}
function JE(r, e) {
  if (!r.hasProperty("X-NEXTCLOUD-BC-YEAR"))
    return null;
  const t = r.getFirstPropertyFirstValue("X-NEXTCLOUD-BC-YEAR");
  return parseInt(e, 10) - parseInt(t, 10);
}
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class Wt extends qe {
  /**
   * Returns whether this event is an all-day event
   *
   * @return {boolean}
   */
  isAllDay() {
    return this.startDate.isDate && this.endDate.isDate;
  }
  /**
   * Checks whether it's possible to switch from date-time to date or vise-versa
   *
   * @return {boolean}
   */
  canModifyAllDay() {
    return !this.recurrenceManager.masterItem.isRecurring();
  }
  /**
   * Gets the calculated end-date of the event
   *
   * Quote from RFC 5545 3.6.1:
   * The "DTSTART" property for a "VEVENT" specifies the inclusive
   * start of the event.  For recurring events, it also specifies the
   * very first instance in the recurrence set.  The "DTEND" property
   * for a "VEVENT" calendar component specifies the non-inclusive end
   * of the event.  For cases where a "VEVENT" calendar component
   * specifies a "DTSTART" property with a DATE value type but no
   * "DTEND" nor "DURATION" property, the event's duration is taken to
   * be one day.  For cases where a "VEVENT" calendar component
   * specifies a "DTSTART" property with a DATE-TIME value type but no
   * "DTEND" property, the event ends on the same calendar date and
   * time of day specified by the "DTSTART" property.
   *
   * @return {DateTimeValue}
   */
  get endDate() {
    if (this.hasProperty("dtend"))
      return this.getFirstPropertyFirstValue("dtend");
    const e = this.startDate.clone();
    return this.hasProperty("duration") ? e.addDuration(this.getFirstPropertyFirstValue("duration")) : this.startDate.isDate && e.addDuration(yt.fromSeconds(60 * 60 * 24)), e;
  }
  /**
   * Sets the end time of the event
   *
   * @param {DateTimeValue} end The end of the event
   */
  set endDate(e) {
    this.deleteAllProperties("duration"), this.updatePropertyWithValue("dtend", e);
  }
  /**
   * Gets the calculated duration of the event
   *
   * @return {DurationValue}
   */
  get duration() {
    return this.hasProperty("duration") ? this.getFirstPropertyFirstValue("duration") : this.startDate.subtractDateWithTimezone(this.endDate);
  }
  /**
   * Sets the calculated duration of the event
   *
   * @param {DurationValue} duration The duration of the event
   */
  set duration(e) {
    this.deleteAllProperties("dtend"), this.updatePropertyWithValue("duration", e);
  }
  /**
   * Sets the geographical position based on latitude and longitude
   *
   * @url https://tools.ietf.org/html/rfc5545#section-3.8.1.6
   *
   * @param {Number} lat - latitude
   * @param {Number} long - longitude
   */
  setGeographicalPositionFromLatitudeAndLongitude(e, t) {
    this.deleteAllProperties("GEO"), this.addProperty(Dn.fromPosition(e, t));
  }
  /**
   * Adds a new conference property based on URI, label and features
   *
   * @url https://tools.ietf.org/html/rfc7986#section-5.11
   *
   * @param {string} uri The URI of the conference system
   * @param {String=} label The label for the conference system
   * @param {String[]=} features The features of the conference system
   */
  addConference(e, t = null, n = null) {
    this._modify(), this.addProperty(Sn.fromURILabelAndFeatures(e, t, n));
  }
  /**
   * Adds a duration to the start of the event
   *
   * @param {DurationValue} duration The duration to add
   */
  addDurationToStart(e) {
    this.startDate.addDuration(e);
  }
  /**
   * Adds a duration to the end of the event
   *
   * @param {DurationValue} duration The duration to add
   */
  addDurationToEnd(e) {
    const t = this.endDate;
    t.addDuration(e), this.endDate = t;
  }
  /**
   * Shifts the entire event by the given duration
   *
   * @param {DurationValue} delta The duration to shift event by
   * @param {boolean} allDay Whether the updated event should be all-day or not
   * @param {Timezone} defaultTimezone The default timezone if moving from all-day to timed event
   * @param {DurationValue} defaultAllDayDuration The default all-day duration if moving from timed to all-day
   * @param {DurationValue} defaultTimedDuration The default timed duration if moving from all-day to timed
   */
  shiftByDuration(e, t, n, i, s) {
    const o = this.isAllDay();
    if (o !== t && !this.canModifyAllDay())
      throw new TypeError("Can't modify all-day of this event");
    if (this.startDate.isDate = t, this.startDate.addDuration(e), o && !t && (this.startDate.replaceTimezone(n), this.endDate = this.startDate.clone(), this.endDate.addDuration(s)), !o && t && (this.endDate = this.startDate.clone(), this.endDate.addDuration(i)), o === t) {
      const l = this.endDate;
      l.addDuration(e), this.endDate = l;
    }
  }
  /**
   * Checks if this is a birthday event
   *
   * @return {boolean}
   */
  isBirthdayEvent() {
    return ih(this) === "BDAY";
  }
  /**
   * Gets the icon to the birthday event
   *
   * @return {string}
   */
  getIconForBirthdayEvent() {
    return KE(this);
  }
  /**
   * Calculates the age of the birthday
   *
   * @return {number}
   */
  getAgeForBirthdayEvent() {
    return JE(this, this.startDate.year);
  }
  /**
   * Serializes the entire series to ICS
   *
   * @return {string}
   */
  toICSEntireSeries() {
    return this.root.toICS();
  }
  /**
   * Serializes exactly this recurrence to ICS
   * It removes all recurrence information
   *
   * @return {string}
   */
  toICSThisOccurrence() {
    const e = this.clone();
    return e.deleteAllProperties("RRULE"), e.deleteAllProperties("EXRULE"), e.deleteAllProperties("RDATE"), e.deleteAllProperties("EXDATE"), e.deleteAllProperties("RECURRENCE-ID"), e.root = e.root.constructor.fromEmpty(), e.parent = e.root, e.root.addComponent(e), e.root.toICS();
  }
  /**
   * Checks if this event is in a given time-frame
   *
   * @param {DateTimeValue} start Start of time-range to check
   * @param {DateTimeValue} end End of time-range to check
   * @return {boolean}
   */
  isInTimeFrame(e, t) {
    return e.compare(this.endDate) <= 0 && t.compare(this.startDate) >= 0;
  }
}
we(Wt.prototype, {
  name: "timeTransparency",
  iCalendarName: "TRANSP",
  allowedValues: ["OPAQUE", "TRANSPARENT"],
  defaultValue: "OPAQUE"
});
we(Wt.prototype, "description");
we(Wt.prototype, {
  name: "geographicalPosition",
  iCalendarName: "GEO"
});
we(Wt.prototype, "location");
we(Wt.prototype, {
  name: "priority",
  allowedValues: Array(9).keys(),
  defaultValue: 0,
  unknownValue: 0
});
hu(Wt.prototype, {
  name: "resource",
  iCalendarName: "RESOURCES"
});
Yt(Wt.prototype, "conference");
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class gn extends qt {
  /**
   * Gets the start-date of the FreeBusy component
   *
   * @return {DateTimeValue}
   */
  get startDate() {
    return this.getFirstPropertyFirstValue("DTSTART");
  }
  /**
   * Sets the start-date of the FreeBusy component
   *
   * @param {DateTimeValue} startDate The start of the queried time-range
   */
  set startDate(e) {
    this._modify(), this.updatePropertyWithValue("DTSTART", e.getInTimezone(ht.utc));
  }
  /**
   * Gets the end-date of the FreeBusy component
   *
   * @return {DateTimeValue}
   */
  get endDate() {
    return this.getFirstPropertyFirstValue("DTEND");
  }
  /**
   * Sets the start-date of the FreeBusy component
   *
   * @param {DateTimeValue} endDate The end of the queried time-range
   */
  set endDate(e) {
    this._modify(), this.updatePropertyWithValue("DTEND", e.getInTimezone(ht.utc));
  }
  /**
   * Gets an iterator over all FreeBusyProperties
   */
  *getFreeBusyIterator() {
    yield* this.getPropertyIterator("FREEBUSY");
  }
  /**
   * Adds a new attendee based on their name and email-address
   *
   * @url https://tools.ietf.org/html/rfc5545#section-3.8.4.1
   *
   * @param {string} name The name of the attendee to add
   * @param {string} email The email-address of the attendee to add
   */
  addAttendeeFromNameAndEMail(e, t) {
    this._modify(), this.addProperty(xt.fromNameAndEMail(e, t));
  }
  /**
   * Sets the organiser property from common-name and email address
   *
   * @url https://tools.ietf.org/html/rfc5545#section-3.8.4.3
   *
   * @param {string} name The name of the organizer
   * @param {string} email The email-address of the organizer
   */
  setOrganizerFromNameAndEMail(e, t) {
    this._modify(), this.deleteAllProperties("ORGANIZER"), this.addProperty(xt.fromNameAndEMail(e, t, !0));
  }
}
we(gn.prototype, "organizer");
we(gn.prototype, "uid");
Yt(gn.prototype, "attendee");
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class mu extends qe {
  /**
   * Adds a new description property
   *
   * @url https://tools.ietf.org/html/rfc5545#section-3.8.1.5
   *
   * @param {string} description The description text
   */
  addDescription(e) {
    this.addProperty(new Xn("DESCRIPTION", e));
  }
}
Yt(mu.prototype, "description");
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class ba extends qt {
  /**
   * Returns a calendar-js Timezone object
   *
   * @return {Timezone}
   */
  toTimezone() {
    return new ht(this.toICALJs());
  }
}
we(ba.prototype, {
  name: "timezoneId",
  iCalendarName: "tzid"
});
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class Pt extends qe {
  /**
   * Returns whether this event is an all-day event
   *
   * @return {boolean}
   */
  isAllDay() {
    const e = ["DTSTART", "DUE"];
    for (const t of e)
      if (this.hasProperty(t))
        return this.getFirstPropertyFirstValue(t).isDate;
    return !0;
  }
  /**
   * Checks whether it's possible to switch from date-time to date or vise-versa
   *
   * @return {boolean}
   */
  canModifyAllDay() {
    return !this.hasProperty("dtstart") && !this.hasProperty("due") ? !1 : !this.recurrenceManager.masterItem.isRecurring();
  }
  /**
   * Gets the calculated end-date of the task
   *
   * If there is a due-date, we will just return that.
   * If there is a start-date and a duration, we will
   * calculate the end-date based on that.
   *
   * If there is neither a due-date nor a combination
   * of start-date and duration, we just return null
   *
   * @return {DateTimeValue|null}
   */
  get endDate() {
    if (this.hasProperty("due"))
      return this.getFirstPropertyFirstValue("due");
    if (!this.hasProperty("dtstart") || !this.hasProperty("duration"))
      return null;
    const e = this.startDate.clone();
    return e.addDuration(this.getFirstPropertyFirstValue("duration")), e;
  }
  /**
   * Shifts the entire task by the given duration
   *
   * @param {DurationValue} delta The duration to shift event by
   * @param {boolean} allDay Whether the updated event should be all-day or not
   * @param {Timezone} defaultTimezone The default timezone if moving from all-day to timed event
   * @param {DurationValue} defaultAllDayDuration The default all-day duration if moving from timed to all-day
   * @param {DurationValue} defaultTimedDuration The default timed duration if moving from all-day to timed
   */
  shiftByDuration(e, t, n, i, s) {
    const o = this.isAllDay();
    if (!this.hasProperty("dtstart") && !this.hasProperty("due"))
      throw new TypeError("This task does not have a start-date nor due-date");
    if (o !== t && !this.canModifyAllDay())
      throw new TypeError("Can't modify all-day of this todo");
    this.hasProperty("dtstart") && (this.startDate.isDate = t, this.startDate.addDuration(e), o && !t && this.startDate.replaceTimezone(n)), this.hasProperty("due") && (this.dueTime.isDate = t, this.dueTime.addDuration(e), o && !t && this.dueTime.replaceTimezone(n));
  }
  /**
   * Checks if this event is in a given time-frame
   *
   * @param {DateTimeValue} start Start of time-range to check
   * @param {DateTimeValue} end End of time-range to check
   * @return {boolean}
   */
  isInTimeFrame(e, t) {
    return !this.hasProperty("dtstart") && !this.hasProperty("due") ? !0 : !this.hasProperty("dtstart") && this.hasProperty("due") ? e.compare(this.endDate) <= 0 : e.compare(this.endDate) <= 0 && t.compare(this.startDate) >= 0;
  }
  /**
   * Gets the geographical position property
   *
   * @return {GeoProperty}
   */
  get geographicalPosition() {
    return this.getFirstProperty("GEO");
  }
  /**
   * Sets the geographical position based on latitude and longitude
   *
   * @url https://tools.ietf.org/html/rfc5545#section-3.8.1.6
   *
   * @param {Number} lat - latitude
   * @param {Number} long - longitude
   */
  setGeographicalPositionFromLatitudeAndLongitude(e, t) {
    this.deleteAllProperties("GEO"), this.addProperty(Dn.fromPosition(e, t));
  }
  /**
   * Adds a new conference property based on URI, label and features
   *
   * @url https://tools.ietf.org/html/rfc7986#section-5.11
   *
   * @param {string} uri The URI of the conference
   * @param {String=} label The label of the conference
   * @param {String[]=} features Supported features of conference-system
   */
  addConference(e, t = null, n = null) {
    this.addProperty(Sn.fromURILabelAndFeatures(e, t, n));
  }
}
we(Pt.prototype, {
  name: "completedTime",
  iCalendarName: "COMPLETED"
});
we(Pt.prototype, {
  name: "dueTime",
  iCalendarName: "DUE"
});
we(Pt.prototype, {
  name: "duration"
});
we(Pt.prototype, {
  name: "percent",
  iCalendarName: "PERCENT-COMPLETE"
});
we(Pt.prototype, "description");
we(Pt.prototype, "location");
we(Pt.prototype, {
  name: "priority",
  allowedValues: Array.from(Array(10).keys()),
  defaultValue: 0,
  unknownValue: 0
});
hu(Pt.prototype, {
  name: "resource",
  iCalendarName: "RESOURCES"
});
Yt(Pt.prototype, "conference");
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
function ah(r) {
  switch (Le(r)) {
    case "VEVENT":
      return Wt;
    case "VFREEBUSY":
      return gn;
    case "VJOURNAL":
      return mu;
    case "VTIMEZONE":
      return ba;
    case "VTODO":
      return Pt;
    default:
      return qt;
  }
}
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class sr extends qt {
  /**
   * Constructor
   *
   * @inheritDoc
   */
  constructor(e = "VCALENDAR", t = [], n = []) {
    super(e, t, n), this.root = this, this.parent = null;
  }
  /**
   * Gets an iterator over all VTIMEZONE components
   */
  *getTimezoneIterator() {
    yield* this.getComponentIterator("vtimezone");
  }
  /**
   * Gets an iterator over all VObject components
   */
  *getVObjectIterator() {
    yield* this.getEventIterator(), yield* this.getJournalIterator(), yield* this.getTodoIterator();
  }
  /**
   * Gets an iterator over all VEVENT components
   */
  *getEventIterator() {
    yield* this.getComponentIterator("vevent");
  }
  /**
   * Gets an iterator over all VFREEBUSY components
   */
  *getFreebusyIterator() {
    yield* this.getComponentIterator("vfreebusy");
  }
  /**
   * Gets an iterator over all VJOURNAL components
   */
  *getJournalIterator() {
    yield* this.getComponentIterator("vjournal");
  }
  /**
   * Gets an iterator over all VTODO components
   */
  *getTodoIterator() {
    yield* this.getComponentIterator("vtodo");
  }
  /**
   * @inheritDoc
   */
  static _getConstructorForComponentName(e) {
    return ah(e);
  }
  /**
   * Converts this calendar component into text/calendar
   *
   * @param {boolean} cleanUpTimezones Whether or not to clean up timezone data
   * @return {string}
   */
  toICS(e = !0) {
    for (const n of this.getVObjectIterator())
      n.undirtify();
    const t = this.toICALJs();
    return e && ge.helpers.updateTimezones(t), t.toString();
  }
  /**
   * Creates a new empty calendar-component
   *
   * @param {[String][]=} additionalProps Additional props to add to empty calendar-document
   * @return {CalendarComponent}
   */
  static fromEmpty(e = []) {
    return new this("VCALENDAR", [["prodid", Ll("PRODID", "-//IDN georgehrke.com//calendar-js//EN")], ["calscale", "GREGORIAN"], ["version", "2.0"]].concat(e));
  }
  /**
   * Creates a new calendar-component with a method
   *
   * @param {string} method The method for the calendar-document
   * @return {CalendarComponent}
   */
  static fromMethod(e) {
    return this.fromEmpty([["method", e]]);
  }
  /**
   * @inheritDoc
   */
  static fromICALJs(e) {
    const t = super.fromICALJs(e);
    return t.root = t, t;
  }
}
we(sr.prototype, {
  name: "productId",
  iCalendarName: "PRODID"
});
we(sr.prototype, {
  name: "version"
});
we(sr.prototype, {
  name: "calendarScale",
  iCalendarName: "CALSCALE",
  defaultValue: "GREGORIAN"
});
we(sr.prototype, {
  name: "method"
});
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class Tr {
  /**
   * @constructor
   */
  constructor() {
    if (new.target === Tr)
      throw new TypeError("Cannot instantiate abstract class AbstractRepairStep");
  }
  /**
   * @param {string} input String representation of the data to repair
   */
  repair(e) {
    throw new TypeError("Abstract method not implemented by subclass");
  }
  /**
   * @return {number}
   */
  static priority() {
    return 0;
  }
}
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class XE extends Tr {
  /**
   * Please see the corresponding test file for an example of broken calendar-data
   *
   * @inheritDoc
   */
  repair(e) {
    return e.replace(/^BEGIN:(VEVENT|VTODO|VJOURNAL)$(((?!^END:(VEVENT|VTODO|VJOURNAL)$)(?!^UID.*$)(.|\n))*)^END:(VEVENT|VTODO|VJOURNAL)$\n/gm, (t, n, i) => "BEGIN:" + n + `\r
UID:` + va() + i + "END:" + n + `\r
`);
  }
}
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class e1 extends Tr {
  /**
   * Please see the corresponding test file for an example of broken calendar-data
   *
   * @inheritDoc
   */
  repair(e) {
    return e.replace(/^(DTSTART|DTEND)(.*):([0-9]{8})T(::)$/gm, (t, n, i, s) => n + ";VALUE=DATE:" + s);
  }
}
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class t1 extends Tr {
  /**
   * Please see the corresponding test file for an example of broken calendar-data
   *
   * @inheritDoc
   */
  repair(e) {
    return e.replace(/^(DTSTART|DTEND)(((?!VALUE=DATE).)*):([0-9]{8})$/gm, (t, n, i, s, o) => n + i + ";VALUE=DATE:" + o);
  }
}
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class r1 extends Tr {
  /**
   * Please see the corresponding test file for an example of broken calendar-data
   *
   * @inheritDoc
   */
  repair(e) {
    return e.replace(/^TRIGGER:P$/gm, "TRIGGER:P0D").replace(/^TRIGGER:-P$/gm, "TRIGGER:P0D");
  }
}
/**
 * @copyright Copyright (c) 2020 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class n1 extends Tr {
  /**
   * Please see the corresponding test file for an example of broken calendar-data
   *
   * @inheritDoc
   */
  repair(e) {
    return e.replace(/^CREATED:00001231T000000Z$/gm, "CREATED:19700101T000000Z");
  }
}
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class i1 extends Tr {
  /**
   * Please see the corresponding test file for an example of broken calendar-data
   *
   * @inheritDoc
   */
  repair(e) {
    let t = !1, n = !1, i = !1;
    const s = /* @__PURE__ */ new Set();
    return e.replace(/^END:VCALENDAR$(((?!^BEGIN:)(.|\n))*)^BEGIN:VCALENDAR$\n/gm, "").replace(/^PRODID:(.*)$\n/gm, (o) => t ? "" : (t = !0, o)).replace(/^VERSION:(.*)$\n/gm, (o) => n ? "" : (n = !0, o)).replace(/^CALSCALE:(.*)$\n/gm, (o) => i ? "" : (i = !0, o)).replace(/^BEGIN:VTIMEZONE$(((?!^END:VTIMEZONE$)(.|\n))*)^END:VTIMEZONE$\n/gm, (o) => {
      const l = o.match(/^TZID:(.*)$/gm);
      if (l === null)
        return "";
      const a = Le(l[0].slice(5));
      return s.has(a) ? "" : (s.add(a), o);
    });
  }
}
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class a1 extends Tr {
  /**
   * Please see the corresponding test file for an example of broken calendar-data
   *
   * @inheritDoc
   */
  repair(e) {
    return e.replace(/(^.*)(;X-NC-GROUP-ID=\d+)(:.*$)/gm, "$1$3");
  }
}
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
function* o1() {
  yield XE, yield e1, yield t1, yield r1, yield n1, yield i1, yield a1;
}
var s1 = "2.2019c", l1 = {
  "AUS Central Standard Time": {
    aliasTo: "Australia/Darwin"
  },
  "AUS Eastern Standard Time": {
    aliasTo: "Australia/Sydney"
  },
  "Afghanistan Standard Time": {
    aliasTo: "Asia/Kabul"
  },
  "Africa/Asmera": {
    aliasTo: "Africa/Asmara"
  },
  "Africa/Timbuktu": {
    aliasTo: "Africa/Bamako"
  },
  "Alaskan Standard Time": {
    aliasTo: "America/Anchorage"
  },
  "America/Argentina/ComodRivadavia": {
    aliasTo: "America/Argentina/Catamarca"
  },
  "America/Buenos_Aires": {
    aliasTo: "America/Argentina/Buenos_Aires"
  },
  "America/Louisville": {
    aliasTo: "America/Kentucky/Louisville"
  },
  "America/Montreal": {
    aliasTo: "America/Toronto"
  },
  "America/Santa_Isabel": {
    aliasTo: "America/Tijuana"
  },
  "Arab Standard Time": {
    aliasTo: "Asia/Riyadh"
  },
  "Arabian Standard Time": {
    aliasTo: "Asia/Dubai"
  },
  "Arabic Standard Time": {
    aliasTo: "Asia/Baghdad"
  },
  "Argentina Standard Time": {
    aliasTo: "America/Argentina/Buenos_Aires"
  },
  "Asia/Calcutta": {
    aliasTo: "Asia/Kolkata"
  },
  "Asia/Katmandu": {
    aliasTo: "Asia/Kathmandu"
  },
  "Asia/Rangoon": {
    aliasTo: "Asia/Yangon"
  },
  "Asia/Saigon": {
    aliasTo: "Asia/Ho_Chi_Minh"
  },
  "Atlantic Standard Time": {
    aliasTo: "America/Halifax"
  },
  "Atlantic/Faeroe": {
    aliasTo: "Atlantic/Faroe"
  },
  "Atlantic/Jan_Mayen": {
    aliasTo: "Europe/Oslo"
  },
  "Azerbaijan Standard Time": {
    aliasTo: "Asia/Baku"
  },
  "Azores Standard Time": {
    aliasTo: "Atlantic/Azores"
  },
  "Bahia Standard Time": {
    aliasTo: "America/Bahia"
  },
  "Bangladesh Standard Time": {
    aliasTo: "Asia/Dhaka"
  },
  "Belarus Standard Time": {
    aliasTo: "Europe/Minsk"
  },
  "Canada Central Standard Time": {
    aliasTo: "America/Regina"
  },
  "Cape Verde Standard Time": {
    aliasTo: "Atlantic/Cape_Verde"
  },
  "Caucasus Standard Time": {
    aliasTo: "Asia/Yerevan"
  },
  "Cen. Australia Standard Time": {
    aliasTo: "Australia/Adelaide"
  },
  "Central America Standard Time": {
    aliasTo: "America/Guatemala"
  },
  "Central Asia Standard Time": {
    aliasTo: "Asia/Almaty"
  },
  "Central Brazilian Standard Time": {
    aliasTo: "America/Cuiaba"
  },
  "Central Europe Standard Time": {
    aliasTo: "Europe/Budapest"
  },
  "Central European Standard Time": {
    aliasTo: "Europe/Warsaw"
  },
  "Central Pacific Standard Time": {
    aliasTo: "Pacific/Guadalcanal"
  },
  "Central Standard Time": {
    aliasTo: "America/Chicago"
  },
  "Central Standard Time (Mexico)": {
    aliasTo: "America/Mexico_City"
  },
  "China Standard Time": {
    aliasTo: "Asia/Shanghai"
  },
  "E. Africa Standard Time": {
    aliasTo: "Africa/Nairobi"
  },
  "E. Australia Standard Time": {
    aliasTo: "Australia/Brisbane"
  },
  "E. South America Standard Time": {
    aliasTo: "America/Sao_Paulo"
  },
  "Eastern Standard Time": {
    aliasTo: "America/New_York"
  },
  "Egypt Standard Time": {
    aliasTo: "Africa/Cairo"
  },
  "Ekaterinburg Standard Time": {
    aliasTo: "Asia/Yekaterinburg"
  },
  "Etc/GMT": {
    aliasTo: "UTC"
  },
  "Etc/GMT+0": {
    aliasTo: "UTC"
  },
  "Etc/UCT": {
    aliasTo: "UTC"
  },
  "Etc/UTC": {
    aliasTo: "UTC"
  },
  "Etc/Unversal": {
    aliasTo: "UTC"
  },
  "Etc/Zulu": {
    aliasTo: "UTC"
  },
  "Europe/Belfast": {
    aliasTo: "Europe/London"
  },
  "FLE Standard Time": {
    aliasTo: "Europe/Kiev"
  },
  "Fiji Standard Time": {
    aliasTo: "Pacific/Fiji"
  },
  GMT: {
    aliasTo: "UTC"
  },
  "GMT Standard Time": {
    aliasTo: "Europe/London"
  },
  "GMT+0": {
    aliasTo: "UTC"
  },
  GMT0: {
    aliasTo: "UTC"
  },
  "GTB Standard Time": {
    aliasTo: "Europe/Bucharest"
  },
  "Georgian Standard Time": {
    aliasTo: "Asia/Tbilisi"
  },
  "Greenland Standard Time": {
    aliasTo: "America/Godthab"
  },
  Greenwich: {
    aliasTo: "UTC"
  },
  "Greenwich Standard Time": {
    aliasTo: "Atlantic/Reykjavik"
  },
  "Hawaiian Standard Time": {
    aliasTo: "Pacific/Honolulu"
  },
  "India Standard Time": {
    aliasTo: "Asia/Calcutta"
  },
  "Iran Standard Time": {
    aliasTo: "Asia/Tehran"
  },
  "Israel Standard Time": {
    aliasTo: "Asia/Jerusalem"
  },
  "Jordan Standard Time": {
    aliasTo: "Asia/Amman"
  },
  "Kaliningrad Standard Time": {
    aliasTo: "Europe/Kaliningrad"
  },
  "Korea Standard Time": {
    aliasTo: "Asia/Seoul"
  },
  "Libya Standard Time": {
    aliasTo: "Africa/Tripoli"
  },
  "Line Islands Standard Time": {
    aliasTo: "Pacific/Kiritimati"
  },
  "Magadan Standard Time": {
    aliasTo: "Asia/Magadan"
  },
  "Mauritius Standard Time": {
    aliasTo: "Indian/Mauritius"
  },
  "Middle East Standard Time": {
    aliasTo: "Asia/Beirut"
  },
  "Montevideo Standard Time": {
    aliasTo: "America/Montevideo"
  },
  "Morocco Standard Time": {
    aliasTo: "Africa/Casablanca"
  },
  "Mountain Standard Time": {
    aliasTo: "America/Denver"
  },
  "Mountain Standard Time (Mexico)": {
    aliasTo: "America/Chihuahua"
  },
  "Myanmar Standard Time": {
    aliasTo: "Asia/Rangoon"
  },
  "N. Central Asia Standard Time": {
    aliasTo: "Asia/Novosibirsk"
  },
  "Namibia Standard Time": {
    aliasTo: "Africa/Windhoek"
  },
  "Nepal Standard Time": {
    aliasTo: "Asia/Katmandu"
  },
  "New Zealand Standard Time": {
    aliasTo: "Pacific/Auckland"
  },
  "Newfoundland Standard Time": {
    aliasTo: "America/St_Johns"
  },
  "North Asia East Standard Time": {
    aliasTo: "Asia/Irkutsk"
  },
  "North Asia Standard Time": {
    aliasTo: "Asia/Krasnoyarsk"
  },
  "Pacific SA Standard Time": {
    aliasTo: "America/Santiago"
  },
  "Pacific Standard Time": {
    aliasTo: "America/Los_Angeles"
  },
  "Pacific Standard Time (Mexico)": {
    aliasTo: "America/Santa_Isabel"
  },
  "Pacific/Johnston": {
    aliasTo: "Pacific/Honolulu"
  },
  "Pakistan Standard Time": {
    aliasTo: "Asia/Karachi"
  },
  "Paraguay Standard Time": {
    aliasTo: "America/Asuncion"
  },
  "Romance Standard Time": {
    aliasTo: "Europe/Paris"
  },
  "Russia Time Zone 10": {
    aliasTo: "Asia/Srednekolymsk"
  },
  "Russia Time Zone 11": {
    aliasTo: "Asia/Kamchatka"
  },
  "Russia Time Zone 3": {
    aliasTo: "Europe/Samara"
  },
  "Russian Standard Time": {
    aliasTo: "Europe/Moscow"
  },
  "SA Eastern Standard Time": {
    aliasTo: "America/Cayenne"
  },
  "SA Pacific Standard Time": {
    aliasTo: "America/Bogota"
  },
  "SA Western Standard Time": {
    aliasTo: "America/La_Paz"
  },
  "SE Asia Standard Time": {
    aliasTo: "Asia/Bangkok"
  },
  "Samoa Standard Time": {
    aliasTo: "Pacific/Apia"
  },
  "Singapore Standard Time": {
    aliasTo: "Asia/Singapore"
  },
  "South Africa Standard Time": {
    aliasTo: "Africa/Johannesburg"
  },
  "Sri Lanka Standard Time": {
    aliasTo: "Asia/Colombo"
  },
  "Syria Standard Time": {
    aliasTo: "Asia/Damascus"
  },
  "Taipei Standard Time": {
    aliasTo: "Asia/Taipei"
  },
  "Tasmania Standard Time": {
    aliasTo: "Australia/Hobart"
  },
  "Tokyo Standard Time": {
    aliasTo: "Asia/Tokyo"
  },
  "Tonga Standard Time": {
    aliasTo: "Pacific/Tongatapu"
  },
  "Turkey Standard Time": {
    aliasTo: "Europe/Istanbul"
  },
  UCT: {
    aliasTo: "UTC"
  },
  "US Eastern Standard Time": {
    aliasTo: "America/Indiana/Indianapolis"
  },
  "US Mountain Standard Time": {
    aliasTo: "America/Phoenix"
  },
  "US/Central": {
    aliasTo: "America/Chicago"
  },
  "US/Eastern": {
    aliasTo: "America/New_York"
  },
  "US/Mountain": {
    aliasTo: "America/Denver"
  },
  "US/Pacific": {
    aliasTo: "America/Los_Angeles"
  },
  "US/Pacific-New": {
    aliasTo: "America/Los_Angeles"
  },
  "Ulaanbaatar Standard Time": {
    aliasTo: "Asia/Ulaanbaatar"
  },
  Universal: {
    aliasTo: "UTC"
  },
  "Venezuela Standard Time": {
    aliasTo: "America/Caracas"
  },
  "Vladivostok Standard Time": {
    aliasTo: "Asia/Vladivostok"
  },
  "W. Australia Standard Time": {
    aliasTo: "Australia/Perth"
  },
  "W. Central Africa Standard Time": {
    aliasTo: "Africa/Lagos"
  },
  "W. Europe Standard Time": {
    aliasTo: "Europe/Berlin"
  },
  "West Asia Standard Time": {
    aliasTo: "Asia/Tashkent"
  },
  "West Pacific Standard Time": {
    aliasTo: "Pacific/Port_Moresby"
  },
  "Yakutsk Standard Time": {
    aliasTo: "Asia/Yakutsk"
  },
  Z: {
    aliasTo: "UTC"
  },
  Zulu: {
    aliasTo: "UTC"
  },
  utc: {
    aliasTo: "UTC"
  }
}, u1 = {
  "Africa/Abidjan": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0000\r
TZOFFSETTO:+0000\r
TZNAME:GMT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0051900",
    longitude: "-0040200"
  },
  "Africa/Accra": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0000\r
TZOFFSETTO:+0000\r
TZNAME:GMT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0053300",
    longitude: "+0001300"
  },
  "Africa/Addis_Ababa": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0300\r
TZOFFSETTO:+0300\r
TZNAME:EAT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0090200",
    longitude: "+0384200"
  },
  "Africa/Algiers": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0100\r
TZNAME:CET\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0364700",
    longitude: "+0030300"
  },
  "Africa/Asmara": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0300\r
TZOFFSETTO:+0300\r
TZNAME:EAT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0152000",
    longitude: "+0385300"
  },
  "Africa/Bamako": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0000\r
TZOFFSETTO:+0000\r
TZNAME:GMT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0123900",
    longitude: "-0080000"
  },
  "Africa/Bangui": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0100\r
TZNAME:WAT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0042200",
    longitude: "+0183500"
  },
  "Africa/Banjul": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0000\r
TZOFFSETTO:+0000\r
TZNAME:GMT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0132800",
    longitude: "-0163900"
  },
  "Africa/Bissau": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0000\r
TZOFFSETTO:+0000\r
TZNAME:GMT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0115100",
    longitude: "-0153500"
  },
  "Africa/Blantyre": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0200\r
TZNAME:CAT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0154700",
    longitude: "+0350000"
  },
  "Africa/Brazzaville": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0100\r
TZNAME:WAT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0041600",
    longitude: "+0151700"
  },
  "Africa/Bujumbura": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0200\r
TZNAME:CAT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0032300",
    longitude: "+0292200"
  },
  "Africa/Cairo": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0200\r
TZNAME:EET\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0300300",
    longitude: "+0311500"
  },
  "Africa/Casablanca": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0000\r
TZOFFSETTO:+0000\r
TZNAME:+00\r
DTSTART:19700101T000000\r
END:STANDARD`,
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0000\r
TZOFFSETTO:+0100\r
TZNAME:+01\r
DTSTART:20180325T020000\r
RDATE:20180325T020000\r
RDATE:20180617T020000\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0000\r
TZNAME:+00\r
DTSTART:20180513T030000\r
RDATE:20180513T030000\r
END:STANDARD`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0000\r
TZOFFSETTO:+0100\r
TZNAME:+01\r
DTSTART:20190609T020000\r
RDATE:20190609T020000\r
RDATE:20200524T020000\r
RDATE:20210516T020000\r
RDATE:20220508T020000\r
END:STANDARD`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0100\r
TZNAME:+01\r
DTSTART:20181028T030000\r
RDATE:20181028T030000\r
END:STANDARD`,
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0000\r
TZNAME:+00\r
DTSTART:20190505T030000\r
RDATE:20190505T030000\r
RDATE:20200419T030000\r
RDATE:20210411T030000\r
RDATE:20220327T030000\r
END:DAYLIGHT`
    ],
    latitude: "+0333900",
    longitude: "-0073500"
  },
  "Africa/Ceuta": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0200\r
TZNAME:CEST\r
DTSTART:19700329T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0100\r
TZNAME:CET\r
DTSTART:19701025T030000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0355300",
    longitude: "-0051900"
  },
  "Africa/Conakry": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0000\r
TZOFFSETTO:+0000\r
TZNAME:GMT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0093100",
    longitude: "-0134300"
  },
  "Africa/Dakar": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0000\r
TZOFFSETTO:+0000\r
TZNAME:GMT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0144000",
    longitude: "-0172600"
  },
  "Africa/Dar_es_Salaam": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0300\r
TZOFFSETTO:+0300\r
TZNAME:EAT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0064800",
    longitude: "+0391700"
  },
  "Africa/Djibouti": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0300\r
TZOFFSETTO:+0300\r
TZNAME:EAT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0113600",
    longitude: "+0430900"
  },
  "Africa/Douala": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0100\r
TZNAME:WAT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0040300",
    longitude: "+0094200"
  },
  "Africa/El_Aaiun": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0100\r
TZOFFSETTO:+0000\r
TZNAME:+00\r
DTSTART:19700101T000000\r
END:STANDARD`,
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0000\r
TZOFFSETTO:+0100\r
TZNAME:+01\r
DTSTART:20180325T020000\r
RDATE:20180325T020000\r
RDATE:20180617T020000\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0000\r
TZNAME:+00\r
DTSTART:20180513T030000\r
RDATE:20180513T030000\r
END:STANDARD`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0100\r
TZNAME:+01\r
DTSTART:20181028T030000\r
RDATE:20181028T030000\r
END:STANDARD`,
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0000\r
TZNAME:+00\r
DTSTART:20190505T030000\r
RDATE:20190505T030000\r
RDATE:20200419T030000\r
RDATE:20210411T030000\r
RDATE:20220327T030000\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0000\r
TZOFFSETTO:+0100\r
TZNAME:+01\r
DTSTART:20190609T020000\r
RDATE:20190609T020000\r
RDATE:20200524T020000\r
RDATE:20210516T020000\r
RDATE:20220508T020000\r
END:STANDARD`
    ],
    latitude: "+0270900",
    longitude: "-0131200"
  },
  "Africa/Freetown": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0000\r
TZOFFSETTO:+0000\r
TZNAME:GMT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0083000",
    longitude: "-0131500"
  },
  "Africa/Gaborone": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0200\r
TZNAME:CAT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0243900",
    longitude: "+0255500"
  },
  "Africa/Harare": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0200\r
TZNAME:CAT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0175000",
    longitude: "+0310300"
  },
  "Africa/Johannesburg": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0200\r
TZNAME:SAST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0261500",
    longitude: "+0280000"
  },
  "Africa/Juba": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0300\r
TZOFFSETTO:+0300\r
TZNAME:EAT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0045100",
    longitude: "+0313700"
  },
  "Africa/Kampala": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0300\r
TZOFFSETTO:+0300\r
TZNAME:EAT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0001900",
    longitude: "+0322500"
  },
  "Africa/Khartoum": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0200\r
TZNAME:CAT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0153600",
    longitude: "+0323200"
  },
  "Africa/Kigali": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0200\r
TZNAME:CAT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0015700",
    longitude: "+0300400"
  },
  "Africa/Kinshasa": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0100\r
TZNAME:WAT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0041800",
    longitude: "+0151800"
  },
  "Africa/Lagos": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0100\r
TZNAME:WAT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0062700",
    longitude: "+0032400"
  },
  "Africa/Libreville": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0100\r
TZNAME:WAT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0002300",
    longitude: "+0092700"
  },
  "Africa/Lome": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0000\r
TZOFFSETTO:+0000\r
TZNAME:GMT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0060800",
    longitude: "+0011300"
  },
  "Africa/Luanda": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0100\r
TZNAME:WAT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0084800",
    longitude: "+0131400"
  },
  "Africa/Lubumbashi": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0200\r
TZNAME:CAT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0114000",
    longitude: "+0272800"
  },
  "Africa/Lusaka": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0200\r
TZNAME:CAT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0152500",
    longitude: "+0281700"
  },
  "Africa/Malabo": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0100\r
TZNAME:WAT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0034500",
    longitude: "+0084700"
  },
  "Africa/Maputo": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0200\r
TZNAME:CAT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0255800",
    longitude: "+0323500"
  },
  "Africa/Maseru": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0200\r
TZNAME:SAST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0292800",
    longitude: "+0273000"
  },
  "Africa/Mbabane": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0200\r
TZNAME:SAST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0261800",
    longitude: "+0310600"
  },
  "Africa/Mogadishu": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0300\r
TZOFFSETTO:+0300\r
TZNAME:EAT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0020400",
    longitude: "+0452200"
  },
  "Africa/Monrovia": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0000\r
TZOFFSETTO:+0000\r
TZNAME:GMT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0061800",
    longitude: "-0104700"
  },
  "Africa/Nairobi": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0300\r
TZOFFSETTO:+0300\r
TZNAME:EAT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0011700",
    longitude: "+0364900"
  },
  "Africa/Ndjamena": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0100\r
TZNAME:WAT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0120700",
    longitude: "+0150300"
  },
  "Africa/Niamey": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0100\r
TZNAME:WAT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0133100",
    longitude: "+0020700"
  },
  "Africa/Nouakchott": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0000\r
TZOFFSETTO:+0000\r
TZNAME:GMT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0180600",
    longitude: "-0155700"
  },
  "Africa/Ouagadougou": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0000\r
TZOFFSETTO:+0000\r
TZNAME:GMT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0122200",
    longitude: "-0013100"
  },
  "Africa/Porto-Novo": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0100\r
TZNAME:WAT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0062900",
    longitude: "+0023700"
  },
  "Africa/Sao_Tome": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0000\r
TZOFFSETTO:+0100\r
TZNAME:WAT\r
DTSTART:20180101T010000\r
RDATE:20180101T010000\r
END:STANDARD`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0000\r
TZNAME:GMT\r
DTSTART:20190101T020000\r
RDATE:20190101T020000\r
END:STANDARD`
    ],
    latitude: "+0002000",
    longitude: "+0064400"
  },
  "Africa/Tripoli": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0200\r
TZNAME:EET\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0325400",
    longitude: "+0131100"
  },
  "Africa/Tunis": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0100\r
TZNAME:CET\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0364800",
    longitude: "+0101100"
  },
  "Africa/Windhoek": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0200\r
TZNAME:CAT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0223400",
    longitude: "+0170600"
  },
  "America/Adak": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-1000\r
TZOFFSETTO:-0900\r
TZNAME:HDT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0900\r
TZOFFSETTO:-1000\r
TZNAME:HST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0515248",
    longitude: "-1763929"
  },
  "America/Anchorage": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0900\r
TZOFFSETTO:-0800\r
TZNAME:AKDT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0800\r
TZOFFSETTO:-0900\r
TZNAME:AKST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0611305",
    longitude: "-1495401"
  },
  "America/Anguilla": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0400\r
TZNAME:AST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0181200",
    longitude: "-0630400"
  },
  "America/Antigua": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0400\r
TZNAME:AST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0170300",
    longitude: "-0614800"
  },
  "America/Araguaina": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0300\r
TZOFFSETTO:-0300\r
TZNAME:-03\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0071200",
    longitude: "-0481200"
  },
  "America/Argentina/Buenos_Aires": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0300\r
TZOFFSETTO:-0300\r
TZNAME:-03\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0343600",
    longitude: "-0582700"
  },
  "America/Argentina/Catamarca": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0300\r
TZOFFSETTO:-0300\r
TZNAME:-03\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0282800",
    longitude: "-0654700"
  },
  "America/Argentina/Cordoba": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0300\r
TZOFFSETTO:-0300\r
TZNAME:-03\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0312400",
    longitude: "-0641100"
  },
  "America/Argentina/Jujuy": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0300\r
TZOFFSETTO:-0300\r
TZNAME:-03\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0241100",
    longitude: "-0651800"
  },
  "America/Argentina/La_Rioja": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0300\r
TZOFFSETTO:-0300\r
TZNAME:-03\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0292600",
    longitude: "-0665100"
  },
  "America/Argentina/Mendoza": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0300\r
TZOFFSETTO:-0300\r
TZNAME:-03\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0325300",
    longitude: "-0684900"
  },
  "America/Argentina/Rio_Gallegos": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0300\r
TZOFFSETTO:-0300\r
TZNAME:-03\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0513800",
    longitude: "-0691300"
  },
  "America/Argentina/Salta": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0300\r
TZOFFSETTO:-0300\r
TZNAME:-03\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0244700",
    longitude: "-0652500"
  },
  "America/Argentina/San_Juan": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0300\r
TZOFFSETTO:-0300\r
TZNAME:-03\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0313200",
    longitude: "-0683100"
  },
  "America/Argentina/San_Luis": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0300\r
TZOFFSETTO:-0300\r
TZNAME:-03\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0331900",
    longitude: "-0662100"
  },
  "America/Argentina/Tucuman": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0300\r
TZOFFSETTO:-0300\r
TZNAME:-03\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0264900",
    longitude: "-0651300"
  },
  "America/Argentina/Ushuaia": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0300\r
TZOFFSETTO:-0300\r
TZNAME:-03\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0544800",
    longitude: "-0681800"
  },
  "America/Aruba": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0400\r
TZNAME:AST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0123000",
    longitude: "-0695800"
  },
  "America/Asuncion": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0300\r
TZNAME:-03\r
DTSTART:19701004T000000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0300\r
TZOFFSETTO:-0400\r
TZNAME:-04\r
DTSTART:19700322T000000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=4SU\r
END:STANDARD`
    ],
    latitude: "-0251600",
    longitude: "-0574000"
  },
  "America/Atikokan": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0500\r
TZOFFSETTO:-0500\r
TZNAME:EST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0484531",
    longitude: "-0913718"
  },
  "America/Bahia": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0300\r
TZOFFSETTO:-0300\r
TZNAME:-03\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0125900",
    longitude: "-0383100"
  },
  "America/Bahia_Banderas": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0500\r
TZOFFSETTO:-0600\r
TZNAME:CST\r
DTSTART:19701025T020000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`,
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0600\r
TZOFFSETTO:-0500\r
TZNAME:CDT\r
DTSTART:19700405T020000\r
RRULE:FREQ=YEARLY;BYMONTH=4;BYDAY=1SU\r
END:DAYLIGHT`
    ],
    latitude: "+0204800",
    longitude: "-1051500"
  },
  "America/Barbados": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0400\r
TZNAME:AST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0130600",
    longitude: "-0593700"
  },
  "America/Belem": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0300\r
TZOFFSETTO:-0300\r
TZNAME:-03\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0012700",
    longitude: "-0482900"
  },
  "America/Belize": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0600\r
TZOFFSETTO:-0600\r
TZNAME:CST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0173000",
    longitude: "-0881200"
  },
  "America/Blanc-Sablon": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0400\r
TZNAME:AST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0512500",
    longitude: "-0570700"
  },
  "America/Boa_Vista": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0400\r
TZNAME:-04\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0024900",
    longitude: "-0604000"
  },
  "America/Bogota": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0500\r
TZOFFSETTO:-0500\r
TZNAME:-05\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0043600",
    longitude: "-0740500"
  },
  "America/Boise": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0700\r
TZOFFSETTO:-0600\r
TZNAME:MDT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0600\r
TZOFFSETTO:-0700\r
TZNAME:MST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0433649",
    longitude: "-1161209"
  },
  "America/Cambridge_Bay": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0700\r
TZOFFSETTO:-0600\r
TZNAME:MDT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0600\r
TZOFFSETTO:-0700\r
TZNAME:MST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0690650",
    longitude: "-1050310"
  },
  "America/Campo_Grande": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0400\r
TZNAME:-04\r
DTSTART:19700101T000000\r
END:STANDARD`,
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0300\r
TZNAME:-03\r
DTSTART:20181104T000000\r
RDATE:20181104T000000\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0300\r
TZOFFSETTO:-0400\r
TZNAME:-04\r
DTSTART:20180218T000000\r
RDATE:20180218T000000\r
RDATE:20190217T000000\r
END:STANDARD`
    ],
    latitude: "-0202700",
    longitude: "-0543700"
  },
  "America/Cancun": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0500\r
TZOFFSETTO:-0500\r
TZNAME:EST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0210500",
    longitude: "-0864600"
  },
  "America/Caracas": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0400\r
TZNAME:-04\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0103000",
    longitude: "-0665600"
  },
  "America/Cayenne": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0300\r
TZOFFSETTO:-0300\r
TZNAME:-03\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0045600",
    longitude: "-0522000"
  },
  "America/Cayman": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0500\r
TZOFFSETTO:-0500\r
TZNAME:EST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0191800",
    longitude: "-0812300"
  },
  "America/Chicago": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0600\r
TZOFFSETTO:-0500\r
TZNAME:CDT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0500\r
TZOFFSETTO:-0600\r
TZNAME:CST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0415100",
    longitude: "-0873900"
  },
  "America/Chihuahua": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0700\r
TZOFFSETTO:-0600\r
TZNAME:MDT\r
DTSTART:19700405T020000\r
RRULE:FREQ=YEARLY;BYMONTH=4;BYDAY=1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0600\r
TZOFFSETTO:-0700\r
TZNAME:MST\r
DTSTART:19701025T020000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0283800",
    longitude: "-1060500"
  },
  "America/Costa_Rica": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0600\r
TZOFFSETTO:-0600\r
TZNAME:CST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0095600",
    longitude: "-0840500"
  },
  "America/Creston": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0700\r
TZOFFSETTO:-0700\r
TZNAME:MST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0490600",
    longitude: "-1163100"
  },
  "America/Cuiaba": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0300\r
TZNAME:-03\r
DTSTART:20181104T000000\r
RDATE:20181104T000000\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0300\r
TZOFFSETTO:-0400\r
TZNAME:-04\r
DTSTART:20180218T000000\r
RDATE:20180218T000000\r
RDATE:20190217T000000\r
END:STANDARD`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0400\r
TZNAME:-04\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0153500",
    longitude: "-0560500"
  },
  "America/Curacao": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0400\r
TZNAME:AST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0121100",
    longitude: "-0690000"
  },
  "America/Danmarkshavn": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0000\r
TZOFFSETTO:+0000\r
TZNAME:GMT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0764600",
    longitude: "-0184000"
  },
  "America/Dawson": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0800\r
TZOFFSETTO:-0700\r
TZNAME:PDT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0700\r
TZOFFSETTO:-0800\r
TZNAME:PST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0640400",
    longitude: "-1392500"
  },
  "America/Dawson_Creek": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0700\r
TZOFFSETTO:-0700\r
TZNAME:MST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0594600",
    longitude: "-1201400"
  },
  "America/Denver": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0700\r
TZOFFSETTO:-0600\r
TZNAME:MDT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0600\r
TZOFFSETTO:-0700\r
TZNAME:MST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0394421",
    longitude: "-1045903"
  },
  "America/Detroit": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0500\r
TZOFFSETTO:-0400\r
TZNAME:EDT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0500\r
TZNAME:EST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0421953",
    longitude: "-0830245"
  },
  "America/Dominica": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0400\r
TZNAME:AST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0151800",
    longitude: "-0612400"
  },
  "America/Edmonton": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0700\r
TZOFFSETTO:-0600\r
TZNAME:MDT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0600\r
TZOFFSETTO:-0700\r
TZNAME:MST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0533300",
    longitude: "-1132800"
  },
  "America/Eirunepe": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0500\r
TZOFFSETTO:-0500\r
TZNAME:-05\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0064000",
    longitude: "-0695200"
  },
  "America/El_Salvador": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0600\r
TZOFFSETTO:-0600\r
TZNAME:CST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0134200",
    longitude: "-0891200"
  },
  "America/Fort_Nelson": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0700\r
TZOFFSETTO:-0700\r
TZNAME:MST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0584800",
    longitude: "-1224200"
  },
  "America/Fortaleza": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0300\r
TZOFFSETTO:-0300\r
TZNAME:-03\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0034300",
    longitude: "-0383000"
  },
  "America/Glace_Bay": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0300\r
TZNAME:ADT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0300\r
TZOFFSETTO:-0400\r
TZNAME:AST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0461200",
    longitude: "-0595700"
  },
  "America/Godthab": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0300\r
TZOFFSETTO:-0200\r
TZNAME:-02\r
DTSTART:19700328T220000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYMONTHDAY=24,25,26,27,28,29,30;BYDAY=SA\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0200\r
TZOFFSETTO:-0300\r
TZNAME:-03\r
DTSTART:19701024T230000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYMONTHDAY=24,25,26,27,28,29,30;BYDAY=SA\r
END:STANDARD`
    ],
    latitude: "+0641100",
    longitude: "-0514400"
  },
  "America/Goose_Bay": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0300\r
TZOFFSETTO:-0400\r
TZNAME:AST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`,
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0300\r
TZNAME:ADT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`
    ],
    latitude: "+0532000",
    longitude: "-0602500"
  },
  "America/Grand_Turk": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0500\r
TZNAME:EST\r
DTSTART:20181104T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`,
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0500\r
TZOFFSETTO:-0400\r
TZNAME:EDT\r
DTSTART:20190310T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0400\r
TZNAME:AST\r
DTSTART:19700101T000000\r
END:STANDARD`,
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0400\r
TZNAME:EDT\r
DTSTART:20180311T020000\r
RDATE:20180311T020000\r
END:DAYLIGHT`
    ],
    latitude: "+0212800",
    longitude: "-0710800"
  },
  "America/Grenada": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0400\r
TZNAME:AST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0120300",
    longitude: "-0614500"
  },
  "America/Guadeloupe": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0400\r
TZNAME:AST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0161400",
    longitude: "-0613200"
  },
  "America/Guatemala": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0600\r
TZOFFSETTO:-0600\r
TZNAME:CST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0143800",
    longitude: "-0903100"
  },
  "America/Guayaquil": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0500\r
TZOFFSETTO:-0500\r
TZNAME:-05\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0021000",
    longitude: "-0795000"
  },
  "America/Guyana": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0400\r
TZNAME:-04\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0064800",
    longitude: "-0581000"
  },
  "America/Halifax": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0300\r
TZNAME:ADT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0300\r
TZOFFSETTO:-0400\r
TZNAME:AST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0443900",
    longitude: "-0633600"
  },
  "America/Havana": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0500\r
TZNAME:CST\r
DTSTART:19701101T010000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`,
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0500\r
TZOFFSETTO:-0400\r
TZNAME:CDT\r
DTSTART:19700308T000000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`
    ],
    latitude: "+0230800",
    longitude: "-0822200"
  },
  "America/Hermosillo": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0700\r
TZOFFSETTO:-0700\r
TZNAME:MST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0290400",
    longitude: "-1105800"
  },
  "America/Indiana/Indianapolis": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0500\r
TZOFFSETTO:-0400\r
TZNAME:EDT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0500\r
TZNAME:EST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0394606",
    longitude: "-0860929"
  },
  "America/Indiana/Knox": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0600\r
TZOFFSETTO:-0500\r
TZNAME:CDT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0500\r
TZOFFSETTO:-0600\r
TZNAME:CST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0411745",
    longitude: "-0863730"
  },
  "America/Indiana/Marengo": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0500\r
TZOFFSETTO:-0400\r
TZNAME:EDT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0500\r
TZNAME:EST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0382232",
    longitude: "-0862041"
  },
  "America/Indiana/Petersburg": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0500\r
TZOFFSETTO:-0400\r
TZNAME:EDT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0500\r
TZNAME:EST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0382931",
    longitude: "-0871643"
  },
  "America/Indiana/Tell_City": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0600\r
TZOFFSETTO:-0500\r
TZNAME:CDT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0500\r
TZOFFSETTO:-0600\r
TZNAME:CST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0375711",
    longitude: "-0864541"
  },
  "America/Indiana/Vevay": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0500\r
TZOFFSETTO:-0400\r
TZNAME:EDT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0500\r
TZNAME:EST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0384452",
    longitude: "-0850402"
  },
  "America/Indiana/Vincennes": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0500\r
TZOFFSETTO:-0400\r
TZNAME:EDT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0500\r
TZNAME:EST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0384038",
    longitude: "-0873143"
  },
  "America/Indiana/Winamac": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0500\r
TZNAME:EST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`,
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0500\r
TZOFFSETTO:-0400\r
TZNAME:EDT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`
    ],
    latitude: "+0410305",
    longitude: "-0863611"
  },
  "America/Inuvik": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0700\r
TZOFFSETTO:-0600\r
TZNAME:MDT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0600\r
TZOFFSETTO:-0700\r
TZNAME:MST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0682059",
    longitude: "-1334300"
  },
  "America/Iqaluit": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0500\r
TZOFFSETTO:-0400\r
TZNAME:EDT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0500\r
TZNAME:EST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0634400",
    longitude: "-0682800"
  },
  "America/Jamaica": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0500\r
TZOFFSETTO:-0500\r
TZNAME:EST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0175805",
    longitude: "-0764736"
  },
  "America/Juneau": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0900\r
TZOFFSETTO:-0800\r
TZNAME:AKDT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0800\r
TZOFFSETTO:-0900\r
TZNAME:AKST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0581807",
    longitude: "-1342511"
  },
  "America/Kentucky/Louisville": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0500\r
TZOFFSETTO:-0400\r
TZNAME:EDT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0500\r
TZNAME:EST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0381515",
    longitude: "-0854534"
  },
  "America/Kentucky/Monticello": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0500\r
TZOFFSETTO:-0400\r
TZNAME:EDT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0500\r
TZNAME:EST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0364947",
    longitude: "-0845057"
  },
  "America/Kralendijk": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0400\r
TZNAME:AST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0120903",
    longitude: "-0681636"
  },
  "America/La_Paz": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0400\r
TZNAME:-04\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0163000",
    longitude: "-0680900"
  },
  "America/Lima": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0500\r
TZOFFSETTO:-0500\r
TZNAME:-05\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0120300",
    longitude: "-0770300"
  },
  "America/Los_Angeles": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0800\r
TZOFFSETTO:-0700\r
TZNAME:PDT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0700\r
TZOFFSETTO:-0800\r
TZNAME:PST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0340308",
    longitude: "-1181434"
  },
  "America/Lower_Princes": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0400\r
TZNAME:AST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0180305",
    longitude: "-0630250"
  },
  "America/Maceio": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0300\r
TZOFFSETTO:-0300\r
TZNAME:-03\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0094000",
    longitude: "-0354300"
  },
  "America/Managua": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0600\r
TZOFFSETTO:-0600\r
TZNAME:CST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0120900",
    longitude: "-0861700"
  },
  "America/Manaus": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0400\r
TZNAME:-04\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0030800",
    longitude: "-0600100"
  },
  "America/Marigot": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0400\r
TZNAME:AST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0180400",
    longitude: "-0630500"
  },
  "America/Martinique": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0400\r
TZNAME:AST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0143600",
    longitude: "-0610500"
  },
  "America/Matamoros": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0600\r
TZOFFSETTO:-0500\r
TZNAME:CDT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0500\r
TZOFFSETTO:-0600\r
TZNAME:CST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0255000",
    longitude: "-0973000"
  },
  "America/Mazatlan": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0700\r
TZOFFSETTO:-0600\r
TZNAME:MDT\r
DTSTART:19700405T020000\r
RRULE:FREQ=YEARLY;BYMONTH=4;BYDAY=1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0600\r
TZOFFSETTO:-0700\r
TZNAME:MST\r
DTSTART:19701025T020000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0231300",
    longitude: "-1062500"
  },
  "America/Menominee": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0600\r
TZOFFSETTO:-0500\r
TZNAME:CDT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0500\r
TZOFFSETTO:-0600\r
TZNAME:CST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0450628",
    longitude: "-0873651"
  },
  "America/Merida": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0600\r
TZOFFSETTO:-0500\r
TZNAME:CDT\r
DTSTART:19700405T020000\r
RRULE:FREQ=YEARLY;BYMONTH=4;BYDAY=1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0500\r
TZOFFSETTO:-0600\r
TZNAME:CST\r
DTSTART:19701025T020000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0205800",
    longitude: "-0893700"
  },
  "America/Metlakatla": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0900\r
TZOFFSETTO:-0800\r
TZNAME:AKDT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0800\r
TZOFFSETTO:-0900\r
TZNAME:AKST\r
DTSTART:20191103T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0800\r
TZOFFSETTO:-0800\r
TZNAME:PST\r
DTSTART:20181104T020000\r
RDATE:20181104T020000\r
END:STANDARD`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0800\r
TZOFFSETTO:-0900\r
TZNAME:AKST\r
DTSTART:20190120T020000\r
RDATE:20190120T020000\r
END:STANDARD`
    ],
    latitude: "+0550737",
    longitude: "-1313435"
  },
  "America/Mexico_City": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0600\r
TZOFFSETTO:-0500\r
TZNAME:CDT\r
DTSTART:19700405T020000\r
RRULE:FREQ=YEARLY;BYMONTH=4;BYDAY=1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0500\r
TZOFFSETTO:-0600\r
TZNAME:CST\r
DTSTART:19701025T020000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0192400",
    longitude: "-0990900"
  },
  "America/Miquelon": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0300\r
TZOFFSETTO:-0200\r
TZNAME:-02\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0200\r
TZOFFSETTO:-0300\r
TZNAME:-03\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0470300",
    longitude: "-0562000"
  },
  "America/Moncton": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0300\r
TZNAME:ADT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0300\r
TZOFFSETTO:-0400\r
TZNAME:AST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0460600",
    longitude: "-0644700"
  },
  "America/Monterrey": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0600\r
TZOFFSETTO:-0500\r
TZNAME:CDT\r
DTSTART:19700405T020000\r
RRULE:FREQ=YEARLY;BYMONTH=4;BYDAY=1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0500\r
TZOFFSETTO:-0600\r
TZNAME:CST\r
DTSTART:19701025T020000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0254000",
    longitude: "-1001900"
  },
  "America/Montevideo": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0300\r
TZOFFSETTO:-0300\r
TZNAME:-03\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0345433",
    longitude: "-0561245"
  },
  "America/Montserrat": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0400\r
TZNAME:AST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0164300",
    longitude: "-0621300"
  },
  "America/Nassau": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0500\r
TZOFFSETTO:-0400\r
TZNAME:EDT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0500\r
TZNAME:EST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0250500",
    longitude: "-0772100"
  },
  "America/New_York": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0500\r
TZOFFSETTO:-0400\r
TZNAME:EDT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0500\r
TZNAME:EST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0404251",
    longitude: "-0740023"
  },
  "America/Nipigon": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0500\r
TZOFFSETTO:-0400\r
TZNAME:EDT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0500\r
TZNAME:EST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0490100",
    longitude: "-0881600"
  },
  "America/Nome": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0900\r
TZOFFSETTO:-0800\r
TZNAME:AKDT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0800\r
TZOFFSETTO:-0900\r
TZNAME:AKST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0643004",
    longitude: "-1652423"
  },
  "America/Noronha": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0200\r
TZOFFSETTO:-0200\r
TZNAME:-02\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0035100",
    longitude: "-0322500"
  },
  "America/North_Dakota/Beulah": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0600\r
TZOFFSETTO:-0500\r
TZNAME:CDT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0500\r
TZOFFSETTO:-0600\r
TZNAME:CST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0471551",
    longitude: "-1014640"
  },
  "America/North_Dakota/Center": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0600\r
TZOFFSETTO:-0500\r
TZNAME:CDT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0500\r
TZOFFSETTO:-0600\r
TZNAME:CST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0470659",
    longitude: "-1011757"
  },
  "America/North_Dakota/New_Salem": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0600\r
TZOFFSETTO:-0500\r
TZNAME:CDT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0500\r
TZOFFSETTO:-0600\r
TZNAME:CST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0465042",
    longitude: "-1012439"
  },
  "America/Ojinaga": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0700\r
TZOFFSETTO:-0600\r
TZNAME:MDT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0600\r
TZOFFSETTO:-0700\r
TZNAME:MST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0293400",
    longitude: "-1042500"
  },
  "America/Panama": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0500\r
TZOFFSETTO:-0500\r
TZNAME:EST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0085800",
    longitude: "-0793200"
  },
  "America/Pangnirtung": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0500\r
TZOFFSETTO:-0400\r
TZNAME:EDT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0500\r
TZNAME:EST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0660800",
    longitude: "-0654400"
  },
  "America/Paramaribo": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0300\r
TZOFFSETTO:-0300\r
TZNAME:-03\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0055000",
    longitude: "-0551000"
  },
  "America/Phoenix": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0700\r
TZOFFSETTO:-0700\r
TZNAME:MST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0332654",
    longitude: "-1120424"
  },
  "America/Port-au-Prince": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0500\r
TZOFFSETTO:-0400\r
TZNAME:EDT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0500\r
TZNAME:EST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0183200",
    longitude: "-0722000"
  },
  "America/Port_of_Spain": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0400\r
TZNAME:AST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0103900",
    longitude: "-0613100"
  },
  "America/Porto_Velho": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0400\r
TZNAME:-04\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0084600",
    longitude: "-0635400"
  },
  "America/Puerto_Rico": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0400\r
TZNAME:AST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0182806",
    longitude: "-0660622"
  },
  "America/Punta_Arenas": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0300\r
TZOFFSETTO:-0300\r
TZNAME:-03\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0530900",
    longitude: "-0705500"
  },
  "America/Rainy_River": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0600\r
TZOFFSETTO:-0500\r
TZNAME:CDT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0500\r
TZOFFSETTO:-0600\r
TZNAME:CST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0484300",
    longitude: "-0943400"
  },
  "America/Rankin_Inlet": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0600\r
TZOFFSETTO:-0500\r
TZNAME:CDT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0500\r
TZOFFSETTO:-0600\r
TZNAME:CST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0624900",
    longitude: "-0920459"
  },
  "America/Recife": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0300\r
TZOFFSETTO:-0300\r
TZNAME:-03\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0080300",
    longitude: "-0345400"
  },
  "America/Regina": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0600\r
TZOFFSETTO:-0600\r
TZNAME:CST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0502400",
    longitude: "-1043900"
  },
  "America/Resolute": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0500\r
TZOFFSETTO:-0600\r
TZNAME:CST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`,
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0600\r
TZOFFSETTO:-0500\r
TZNAME:CDT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`
    ],
    latitude: "+0744144",
    longitude: "-0944945"
  },
  "America/Rio_Branco": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0500\r
TZOFFSETTO:-0500\r
TZNAME:-05\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0095800",
    longitude: "-0674800"
  },
  "America/Santarem": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0300\r
TZOFFSETTO:-0300\r
TZNAME:-03\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0022600",
    longitude: "-0545200"
  },
  "America/Santiago": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0300\r
TZOFFSETTO:-0400\r
TZNAME:-04\r
DTSTART:20190407T000000\r
RRULE:FREQ=YEARLY;BYMONTH=4;BYMONTHDAY=2,3,4,5,6,7,8;BYDAY=SU\r
END:STANDARD`,
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0300\r
TZNAME:-03\r
DTSTART:20190908T000000\r
RRULE:FREQ=YEARLY;BYMONTH=9;BYMONTHDAY=2,3,4,5,6,7,8;BYDAY=SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0500\r
TZOFFSETTO:-0400\r
TZNAME:-04\r
DTSTART:19700101T000000\r
END:STANDARD`,
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0300\r
TZNAME:-03\r
DTSTART:20180812T000000\r
RDATE:20180812T000000\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0300\r
TZOFFSETTO:-0400\r
TZNAME:-04\r
DTSTART:20180513T000000\r
RDATE:20180513T000000\r
END:STANDARD`
    ],
    latitude: "-0332700",
    longitude: "-0704000"
  },
  "America/Santo_Domingo": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0400\r
TZNAME:AST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0182800",
    longitude: "-0695400"
  },
  "America/Sao_Paulo": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0300\r
TZOFFSETTO:-0200\r
TZNAME:-02\r
DTSTART:20181104T000000\r
RDATE:20181104T000000\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0200\r
TZOFFSETTO:-0300\r
TZNAME:-03\r
DTSTART:20180218T000000\r
RDATE:20180218T000000\r
RDATE:20190217T000000\r
END:STANDARD`,
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0200\r
TZOFFSETTO:-0200\r
TZNAME:-02\r
DTSTART:19700101T000000\r
END:DAYLIGHT`
    ],
    latitude: "-0233200",
    longitude: "-0463700"
  },
  "America/Scoresbysund": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0100\r
TZOFFSETTO:+0000\r
TZNAME:+00\r
DTSTART:19700329T000000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0000\r
TZOFFSETTO:-0100\r
TZNAME:-01\r
DTSTART:19701025T010000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0702900",
    longitude: "-0215800"
  },
  "America/Sitka": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0900\r
TZOFFSETTO:-0800\r
TZNAME:AKDT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0800\r
TZOFFSETTO:-0900\r
TZNAME:AKST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0571035",
    longitude: "-1351807"
  },
  "America/St_Barthelemy": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0400\r
TZNAME:AST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0175300",
    longitude: "-0625100"
  },
  "America/St_Johns": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0230\r
TZOFFSETTO:-0330\r
TZNAME:NST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`,
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0330\r
TZOFFSETTO:-0230\r
TZNAME:NDT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`
    ],
    latitude: "+0473400",
    longitude: "-0524300"
  },
  "America/St_Kitts": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0400\r
TZNAME:AST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0171800",
    longitude: "-0624300"
  },
  "America/St_Lucia": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0400\r
TZNAME:AST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0140100",
    longitude: "-0610000"
  },
  "America/St_Thomas": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0400\r
TZNAME:AST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0182100",
    longitude: "-0645600"
  },
  "America/St_Vincent": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0400\r
TZNAME:AST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0130900",
    longitude: "-0611400"
  },
  "America/Swift_Current": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0600\r
TZOFFSETTO:-0600\r
TZNAME:CST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0501700",
    longitude: "-1075000"
  },
  "America/Tegucigalpa": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0600\r
TZOFFSETTO:-0600\r
TZNAME:CST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0140600",
    longitude: "-0871300"
  },
  "America/Thule": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0300\r
TZNAME:ADT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0300\r
TZOFFSETTO:-0400\r
TZNAME:AST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0763400",
    longitude: "-0684700"
  },
  "America/Thunder_Bay": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0500\r
TZOFFSETTO:-0400\r
TZNAME:EDT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0500\r
TZNAME:EST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0482300",
    longitude: "-0891500"
  },
  "America/Tijuana": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0800\r
TZOFFSETTO:-0700\r
TZNAME:PDT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0700\r
TZOFFSETTO:-0800\r
TZNAME:PST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0323200",
    longitude: "-1170100"
  },
  "America/Toronto": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0500\r
TZOFFSETTO:-0400\r
TZNAME:EDT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0500\r
TZNAME:EST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0433900",
    longitude: "-0792300"
  },
  "America/Tortola": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0400\r
TZNAME:AST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0182700",
    longitude: "-0643700"
  },
  "America/Vancouver": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0800\r
TZOFFSETTO:-0700\r
TZNAME:PDT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0700\r
TZOFFSETTO:-0800\r
TZNAME:PST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0491600",
    longitude: "-1230700"
  },
  "America/Whitehorse": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0800\r
TZOFFSETTO:-0700\r
TZNAME:PDT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0700\r
TZOFFSETTO:-0800\r
TZNAME:PST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0604300",
    longitude: "-1350300"
  },
  "America/Winnipeg": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0600\r
TZOFFSETTO:-0500\r
TZNAME:CDT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0500\r
TZOFFSETTO:-0600\r
TZNAME:CST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0495300",
    longitude: "-0970900"
  },
  "America/Yakutat": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0900\r
TZOFFSETTO:-0800\r
TZNAME:AKDT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0800\r
TZOFFSETTO:-0900\r
TZNAME:AKST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0593249",
    longitude: "-1394338"
  },
  "America/Yellowknife": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0700\r
TZOFFSETTO:-0600\r
TZNAME:MDT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0600\r
TZOFFSETTO:-0700\r
TZNAME:MST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0622700",
    longitude: "-1142100"
  },
  "Antarctica/Casey": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0800\r
TZOFFSETTO:+1100\r
TZNAME:+11\r
DTSTART:19700101T000000\r
END:STANDARD`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+1100\r
TZOFFSETTO:+0800\r
TZNAME:+08\r
DTSTART:20180311T040000\r
RDATE:20180311T040000\r
END:STANDARD`
    ],
    latitude: "-0661700",
    longitude: "+1103100"
  },
  "Antarctica/Davis": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0700\r
TZOFFSETTO:+0700\r
TZNAME:+07\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0683500",
    longitude: "+0775800"
  },
  "Antarctica/DumontDUrville": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+1000\r
TZOFFSETTO:+1000\r
TZNAME:+10\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0664000",
    longitude: "+1400100"
  },
  "Antarctica/Macquarie": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+1100\r
TZOFFSETTO:+1100\r
TZNAME:+11\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0543000",
    longitude: "+1585700"
  },
  "Antarctica/Mawson": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0500\r
TZOFFSETTO:+0500\r
TZNAME:+05\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0673600",
    longitude: "+0625300"
  },
  "Antarctica/McMurdo": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+1200\r
TZOFFSETTO:+1300\r
TZNAME:NZDT\r
DTSTART:19700927T020000\r
RRULE:FREQ=YEARLY;BYMONTH=9;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+1300\r
TZOFFSETTO:+1200\r
TZNAME:NZST\r
DTSTART:19700405T030000\r
RRULE:FREQ=YEARLY;BYMONTH=4;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "-0775000",
    longitude: "+1663600"
  },
  "Antarctica/Palmer": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0300\r
TZOFFSETTO:-0300\r
TZNAME:-03\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0644800",
    longitude: "-0640600"
  },
  "Antarctica/Rothera": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0300\r
TZOFFSETTO:-0300\r
TZNAME:-03\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0673400",
    longitude: "-0680800"
  },
  "Antarctica/Syowa": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0300\r
TZOFFSETTO:+0300\r
TZNAME:+03\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0690022",
    longitude: "+0393524"
  },
  "Antarctica/Troll": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0000\r
TZOFFSETTO:+0200\r
TZNAME:+02\r
DTSTART:19700329T010000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0000\r
TZNAME:+00\r
DTSTART:19701025T030000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "-0720041",
    longitude: "+0023206"
  },
  "Antarctica/Vostok": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0600\r
TZOFFSETTO:+0600\r
TZNAME:+06\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0782400",
    longitude: "+1065400"
  },
  "Arctic/Longyearbyen": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0200\r
TZNAME:CEST\r
DTSTART:19700329T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0100\r
TZNAME:CET\r
DTSTART:19701025T030000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0780000",
    longitude: "+0160000"
  },
  "Asia/Aden": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0300\r
TZOFFSETTO:+0300\r
TZNAME:+03\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0124500",
    longitude: "+0451200"
  },
  "Asia/Almaty": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0600\r
TZOFFSETTO:+0600\r
TZNAME:+06\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0431500",
    longitude: "+0765700"
  },
  "Asia/Amman": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0300\r
TZNAME:EEST\r
DTSTART:19700326T235959\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1TH\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0300\r
TZOFFSETTO:+0200\r
TZNAME:EET\r
DTSTART:19701030T010000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1FR\r
END:STANDARD`
    ],
    latitude: "+0315700",
    longitude: "+0355600"
  },
  "Asia/Anadyr": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+1200\r
TZOFFSETTO:+1200\r
TZNAME:+12\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0644500",
    longitude: "+1772900"
  },
  "Asia/Aqtau": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0500\r
TZOFFSETTO:+0500\r
TZNAME:+05\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0443100",
    longitude: "+0501600"
  },
  "Asia/Aqtobe": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0500\r
TZOFFSETTO:+0500\r
TZNAME:+05\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0501700",
    longitude: "+0571000"
  },
  "Asia/Ashgabat": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0500\r
TZOFFSETTO:+0500\r
TZNAME:+05\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0375700",
    longitude: "+0582300"
  },
  "Asia/Atyrau": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0500\r
TZOFFSETTO:+0500\r
TZNAME:+05\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0470700",
    longitude: "+0515600"
  },
  "Asia/Baghdad": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0300\r
TZOFFSETTO:+0300\r
TZNAME:+03\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0332100",
    longitude: "+0442500"
  },
  "Asia/Bahrain": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0300\r
TZOFFSETTO:+0300\r
TZNAME:+03\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0262300",
    longitude: "+0503500"
  },
  "Asia/Baku": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0400\r
TZOFFSETTO:+0400\r
TZNAME:+04\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0402300",
    longitude: "+0495100"
  },
  "Asia/Bangkok": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0700\r
TZOFFSETTO:+0700\r
TZNAME:+07\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0134500",
    longitude: "+1003100"
  },
  "Asia/Barnaul": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0700\r
TZOFFSETTO:+0700\r
TZNAME:+07\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0532200",
    longitude: "+0834500"
  },
  "Asia/Beirut": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0300\r
TZNAME:EEST\r
DTSTART:19700329T000000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0300\r
TZOFFSETTO:+0200\r
TZNAME:EET\r
DTSTART:19701025T000000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0335300",
    longitude: "+0353000"
  },
  "Asia/Bishkek": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0600\r
TZOFFSETTO:+0600\r
TZNAME:+06\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0425400",
    longitude: "+0743600"
  },
  "Asia/Brunei": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0800\r
TZOFFSETTO:+0800\r
TZNAME:+08\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0045600",
    longitude: "+1145500"
  },
  "Asia/Chita": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0900\r
TZOFFSETTO:+0900\r
TZNAME:+09\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0520300",
    longitude: "+1132800"
  },
  "Asia/Choibalsan": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0800\r
TZOFFSETTO:+0800\r
TZNAME:+08\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0480400",
    longitude: "+1143000"
  },
  "Asia/Colombo": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0530\r
TZOFFSETTO:+0530\r
TZNAME:+0530\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0065600",
    longitude: "+0795100"
  },
  "Asia/Damascus": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0300\r
TZOFFSETTO:+0200\r
TZNAME:EET\r
DTSTART:19701030T000000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1FR\r
END:STANDARD`,
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0300\r
TZNAME:EEST\r
DTSTART:19700327T000000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1FR\r
END:DAYLIGHT`
    ],
    latitude: "+0333000",
    longitude: "+0361800"
  },
  "Asia/Dhaka": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0600\r
TZOFFSETTO:+0600\r
TZNAME:+06\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0234300",
    longitude: "+0902500"
  },
  "Asia/Dili": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0900\r
TZOFFSETTO:+0900\r
TZNAME:+09\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0083300",
    longitude: "+1253500"
  },
  "Asia/Dubai": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0400\r
TZOFFSETTO:+0400\r
TZNAME:+04\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0251800",
    longitude: "+0551800"
  },
  "Asia/Dushanbe": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0500\r
TZOFFSETTO:+0500\r
TZNAME:+05\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0383500",
    longitude: "+0684800"
  },
  "Asia/Famagusta": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0300\r
TZOFFSETTO:+0200\r
TZNAME:EET\r
DTSTART:19701025T040000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`,
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0300\r
TZNAME:EEST\r
DTSTART:20180325T030000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`
    ],
    latitude: "+0350700",
    longitude: "+0335700"
  },
  "Asia/Gaza": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0300\r
TZOFFSETTO:+0200\r
TZNAME:EET\r
DTSTART:19701031T010000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SA\r
END:STANDARD`,
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0300\r
TZNAME:EEST\r
DTSTART:20190329T000000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1FR\r
END:DAYLIGHT`,
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0300\r
TZNAME:EEST\r
DTSTART:20180324T010000\r
RDATE:20180324T010000\r
END:DAYLIGHT`
    ],
    latitude: "+0313000",
    longitude: "+0342800"
  },
  "Asia/Hebron": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0300\r
TZOFFSETTO:+0200\r
TZNAME:EET\r
DTSTART:19701031T010000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SA\r
END:STANDARD`,
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0300\r
TZNAME:EEST\r
DTSTART:20190329T000000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1FR\r
END:DAYLIGHT`,
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0300\r
TZNAME:EEST\r
DTSTART:20180324T010000\r
RDATE:20180324T010000\r
END:DAYLIGHT`
    ],
    latitude: "+0313200",
    longitude: "+0350542"
  },
  "Asia/Ho_Chi_Minh": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0700\r
TZOFFSETTO:+0700\r
TZNAME:+07\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0104500",
    longitude: "+1064000"
  },
  "Asia/Hong_Kong": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0800\r
TZOFFSETTO:+0800\r
TZNAME:HKT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0221700",
    longitude: "+1140900"
  },
  "Asia/Hovd": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0700\r
TZOFFSETTO:+0700\r
TZNAME:+07\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0480100",
    longitude: "+0913900"
  },
  "Asia/Irkutsk": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0800\r
TZOFFSETTO:+0800\r
TZNAME:+08\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0521600",
    longitude: "+1042000"
  },
  "Asia/Istanbul": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0300\r
TZOFFSETTO:+0300\r
TZNAME:+03\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0410100",
    longitude: "+0285800"
  },
  "Asia/Jakarta": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0700\r
TZOFFSETTO:+0700\r
TZNAME:WIB\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0061000",
    longitude: "+1064800"
  },
  "Asia/Jayapura": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0900\r
TZOFFSETTO:+0900\r
TZNAME:WIT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0023200",
    longitude: "+1404200"
  },
  "Asia/Jerusalem": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0300\r
TZNAME:IDT\r
DTSTART:19700327T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYMONTHDAY=23,24,25,26,27,28,29;BYDAY=FR\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0300\r
TZOFFSETTO:+0200\r
TZNAME:IST\r
DTSTART:19701025T020000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0314650",
    longitude: "+0351326"
  },
  "Asia/Kabul": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0430\r
TZOFFSETTO:+0430\r
TZNAME:+0430\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0343100",
    longitude: "+0691200"
  },
  "Asia/Kamchatka": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+1200\r
TZOFFSETTO:+1200\r
TZNAME:+12\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0530100",
    longitude: "+1583900"
  },
  "Asia/Karachi": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0500\r
TZOFFSETTO:+0500\r
TZNAME:PKT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0245200",
    longitude: "+0670300"
  },
  "Asia/Kathmandu": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0545\r
TZOFFSETTO:+0545\r
TZNAME:+0545\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0274300",
    longitude: "+0851900"
  },
  "Asia/Khandyga": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0900\r
TZOFFSETTO:+0900\r
TZNAME:+09\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0623923",
    longitude: "+1353314"
  },
  "Asia/Kolkata": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0530\r
TZOFFSETTO:+0530\r
TZNAME:IST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0223200",
    longitude: "+0882200"
  },
  "Asia/Krasnoyarsk": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0700\r
TZOFFSETTO:+0700\r
TZNAME:+07\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0560100",
    longitude: "+0925000"
  },
  "Asia/Kuala_Lumpur": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0800\r
TZOFFSETTO:+0800\r
TZNAME:+08\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0031000",
    longitude: "+1014200"
  },
  "Asia/Kuching": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0800\r
TZOFFSETTO:+0800\r
TZNAME:+08\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0013300",
    longitude: "+1102000"
  },
  "Asia/Kuwait": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0300\r
TZOFFSETTO:+0300\r
TZNAME:+03\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0292000",
    longitude: "+0475900"
  },
  "Asia/Macau": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0800\r
TZOFFSETTO:+0800\r
TZNAME:CST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0221150",
    longitude: "+1133230"
  },
  "Asia/Magadan": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+1100\r
TZOFFSETTO:+1100\r
TZNAME:+11\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0593400",
    longitude: "+1504800"
  },
  "Asia/Makassar": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0800\r
TZOFFSETTO:+0800\r
TZNAME:WITA\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0050700",
    longitude: "+1192400"
  },
  "Asia/Manila": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0800\r
TZOFFSETTO:+0800\r
TZNAME:PST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0143500",
    longitude: "+1210000"
  },
  "Asia/Muscat": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0400\r
TZOFFSETTO:+0400\r
TZNAME:+04\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0233600",
    longitude: "+0583500"
  },
  "Asia/Nicosia": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0300\r
TZOFFSETTO:+0200\r
TZNAME:EET\r
DTSTART:19701025T040000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`,
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0300\r
TZNAME:EEST\r
DTSTART:19700329T030000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`
    ],
    latitude: "+0351000",
    longitude: "+0332200"
  },
  "Asia/Novokuznetsk": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0700\r
TZOFFSETTO:+0700\r
TZNAME:+07\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0534500",
    longitude: "+0870700"
  },
  "Asia/Novosibirsk": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0700\r
TZOFFSETTO:+0700\r
TZNAME:+07\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0550200",
    longitude: "+0825500"
  },
  "Asia/Omsk": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0600\r
TZOFFSETTO:+0600\r
TZNAME:+06\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0550000",
    longitude: "+0732400"
  },
  "Asia/Oral": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0500\r
TZOFFSETTO:+0500\r
TZNAME:+05\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0511300",
    longitude: "+0512100"
  },
  "Asia/Phnom_Penh": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0700\r
TZOFFSETTO:+0700\r
TZNAME:+07\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0113300",
    longitude: "+1045500"
  },
  "Asia/Pontianak": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0700\r
TZOFFSETTO:+0700\r
TZNAME:WIB\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0000200",
    longitude: "+1092000"
  },
  "Asia/Pyongyang": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0900\r
TZOFFSETTO:+0830\r
TZNAME:KST\r
DTSTART:19700101T000000\r
END:STANDARD`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0830\r
TZOFFSETTO:+0900\r
TZNAME:KST\r
DTSTART:20180504T233000\r
RDATE:20180504T233000\r
END:STANDARD`
    ],
    latitude: "+0390100",
    longitude: "+1254500"
  },
  "Asia/Qatar": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0300\r
TZOFFSETTO:+0300\r
TZNAME:+03\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0251700",
    longitude: "+0513200"
  },
  "Asia/Qostanay": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0600\r
TZOFFSETTO:+0600\r
TZNAME:+06\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0531200",
    longitude: "+0633700"
  },
  "Asia/Qyzylorda": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0600\r
TZOFFSETTO:+0600\r
TZNAME:+06\r
DTSTART:19700101T000000\r
END:STANDARD`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0600\r
TZOFFSETTO:+0500\r
TZNAME:+05\r
DTSTART:20181221T000000\r
RDATE:20181221T000000\r
END:STANDARD`
    ],
    latitude: "+0444800",
    longitude: "+0652800"
  },
  "Asia/Riyadh": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0300\r
TZOFFSETTO:+0300\r
TZNAME:+03\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0243800",
    longitude: "+0464300"
  },
  "Asia/Sakhalin": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+1100\r
TZOFFSETTO:+1100\r
TZNAME:+11\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0465800",
    longitude: "+1424200"
  },
  "Asia/Samarkand": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0500\r
TZOFFSETTO:+0500\r
TZNAME:+05\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0394000",
    longitude: "+0664800"
  },
  "Asia/Seoul": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0900\r
TZOFFSETTO:+0900\r
TZNAME:KST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0373300",
    longitude: "+1265800"
  },
  "Asia/Shanghai": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0800\r
TZOFFSETTO:+0800\r
TZNAME:CST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0311400",
    longitude: "+1212800"
  },
  "Asia/Singapore": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0800\r
TZOFFSETTO:+0800\r
TZNAME:+08\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0011700",
    longitude: "+1035100"
  },
  "Asia/Srednekolymsk": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+1100\r
TZOFFSETTO:+1100\r
TZNAME:+11\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0672800",
    longitude: "+1534300"
  },
  "Asia/Taipei": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0800\r
TZOFFSETTO:+0800\r
TZNAME:CST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0250300",
    longitude: "+1213000"
  },
  "Asia/Tashkent": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0500\r
TZOFFSETTO:+0500\r
TZNAME:+05\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0412000",
    longitude: "+0691800"
  },
  "Asia/Tbilisi": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0400\r
TZOFFSETTO:+0400\r
TZNAME:+04\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0414300",
    longitude: "+0444900"
  },
  "Asia/Tehran": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0400\r
TZOFFSETTO:+0330\r
TZNAME:+0330\r
DTSTART:19700101T000000\r
END:STANDARD`,
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0330\r
TZOFFSETTO:+0430\r
TZNAME:+0430\r
DTSTART:20180321T235959\r
RDATE:20180321T235959\r
RDATE:20190321T235959\r
RDATE:20200320T235959\r
RDATE:20210321T235959\r
RDATE:20220321T235959\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0430\r
TZOFFSETTO:+0330\r
TZNAME:+0330\r
DTSTART:20180921T235959\r
RDATE:20180921T235959\r
RDATE:20190921T235959\r
RDATE:20200920T235959\r
RDATE:20210921T235959\r
RDATE:20220921T235959\r
END:STANDARD`
    ],
    latitude: "+0354000",
    longitude: "+0512600"
  },
  "Asia/Thimphu": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0600\r
TZOFFSETTO:+0600\r
TZNAME:+06\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0272800",
    longitude: "+0893900"
  },
  "Asia/Tokyo": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0900\r
TZOFFSETTO:+0900\r
TZNAME:JST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0353916",
    longitude: "+1394441"
  },
  "Asia/Tomsk": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0700\r
TZOFFSETTO:+0700\r
TZNAME:+07\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0563000",
    longitude: "+0845800"
  },
  "Asia/Ulaanbaatar": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0800\r
TZOFFSETTO:+0800\r
TZNAME:+08\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0475500",
    longitude: "+1065300"
  },
  "Asia/Urumqi": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0600\r
TZOFFSETTO:+0600\r
TZNAME:+06\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0434800",
    longitude: "+0873500"
  },
  "Asia/Ust-Nera": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+1000\r
TZOFFSETTO:+1000\r
TZNAME:+10\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0643337",
    longitude: "+1431336"
  },
  "Asia/Vientiane": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0700\r
TZOFFSETTO:+0700\r
TZNAME:+07\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0175800",
    longitude: "+1023600"
  },
  "Asia/Vladivostok": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+1000\r
TZOFFSETTO:+1000\r
TZNAME:+10\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0431000",
    longitude: "+1315600"
  },
  "Asia/Yakutsk": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0900\r
TZOFFSETTO:+0900\r
TZNAME:+09\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0620000",
    longitude: "+1294000"
  },
  "Asia/Yangon": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0630\r
TZOFFSETTO:+0630\r
TZNAME:+0630\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0164700",
    longitude: "+0961000"
  },
  "Asia/Yekaterinburg": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0500\r
TZOFFSETTO:+0500\r
TZNAME:+05\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0565100",
    longitude: "+0603600"
  },
  "Asia/Yerevan": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0400\r
TZOFFSETTO:+0400\r
TZNAME:+04\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0401100",
    longitude: "+0443000"
  },
  "Atlantic/Azores": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0100\r
TZOFFSETTO:+0000\r
TZNAME:+00\r
DTSTART:19700329T000000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0000\r
TZOFFSETTO:-0100\r
TZNAME:-01\r
DTSTART:19701025T010000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0374400",
    longitude: "-0254000"
  },
  "Atlantic/Bermuda": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0400\r
TZOFFSETTO:-0300\r
TZNAME:ADT\r
DTSTART:19700308T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0300\r
TZOFFSETTO:-0400\r
TZNAME:AST\r
DTSTART:19701101T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "+0321700",
    longitude: "-0644600"
  },
  "Atlantic/Canary": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0000\r
TZOFFSETTO:+0100\r
TZNAME:WEST\r
DTSTART:19700329T010000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0000\r
TZNAME:WET\r
DTSTART:19701025T020000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0280600",
    longitude: "-0152400"
  },
  "Atlantic/Cape_Verde": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0100\r
TZOFFSETTO:-0100\r
TZNAME:-01\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0145500",
    longitude: "-0233100"
  },
  "Atlantic/Faroe": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0000\r
TZOFFSETTO:+0100\r
TZNAME:WEST\r
DTSTART:19700329T010000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0000\r
TZNAME:WET\r
DTSTART:19701025T020000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0620100",
    longitude: "-0064600"
  },
  "Atlantic/Madeira": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0000\r
TZOFFSETTO:+0100\r
TZNAME:WEST\r
DTSTART:19700329T010000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0000\r
TZNAME:WET\r
DTSTART:19701025T020000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0323800",
    longitude: "-0165400"
  },
  "Atlantic/Reykjavik": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0000\r
TZOFFSETTO:+0000\r
TZNAME:GMT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0640900",
    longitude: "-0215100"
  },
  "Atlantic/South_Georgia": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0200\r
TZOFFSETTO:-0200\r
TZNAME:-02\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0541600",
    longitude: "-0363200"
  },
  "Atlantic/St_Helena": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0000\r
TZOFFSETTO:+0000\r
TZNAME:GMT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0155500",
    longitude: "-0054200"
  },
  "Atlantic/Stanley": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0300\r
TZOFFSETTO:-0300\r
TZNAME:-03\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0514200",
    longitude: "-0575100"
  },
  "Australia/Adelaide": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+1030\r
TZOFFSETTO:+0930\r
TZNAME:ACST\r
DTSTART:19700405T030000\r
RRULE:FREQ=YEARLY;BYMONTH=4;BYDAY=1SU\r
END:STANDARD`,
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0930\r
TZOFFSETTO:+1030\r
TZNAME:ACDT\r
DTSTART:19701004T020000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=1SU\r
END:DAYLIGHT`
    ],
    latitude: "-0345500",
    longitude: "+1383500"
  },
  "Australia/Brisbane": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+1000\r
TZOFFSETTO:+1000\r
TZNAME:AEST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0272800",
    longitude: "+1530200"
  },
  "Australia/Broken_Hill": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+1030\r
TZOFFSETTO:+0930\r
TZNAME:ACST\r
DTSTART:19700405T030000\r
RRULE:FREQ=YEARLY;BYMONTH=4;BYDAY=1SU\r
END:STANDARD`,
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0930\r
TZOFFSETTO:+1030\r
TZNAME:ACDT\r
DTSTART:19701004T020000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=1SU\r
END:DAYLIGHT`
    ],
    latitude: "-0315700",
    longitude: "+1412700"
  },
  "Australia/Currie": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+1000\r
TZOFFSETTO:+1100\r
TZNAME:AEDT\r
DTSTART:19701004T020000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+1100\r
TZOFFSETTO:+1000\r
TZNAME:AEST\r
DTSTART:19700405T030000\r
RRULE:FREQ=YEARLY;BYMONTH=4;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "-0395600",
    longitude: "+1435200"
  },
  "Australia/Darwin": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0930\r
TZOFFSETTO:+0930\r
TZNAME:ACST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0122800",
    longitude: "+1305000"
  },
  "Australia/Eucla": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0845\r
TZOFFSETTO:+0845\r
TZNAME:+0845\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0314300",
    longitude: "+1285200"
  },
  "Australia/Hobart": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+1000\r
TZOFFSETTO:+1100\r
TZNAME:AEDT\r
DTSTART:19701004T020000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+1100\r
TZOFFSETTO:+1000\r
TZNAME:AEST\r
DTSTART:19700405T030000\r
RRULE:FREQ=YEARLY;BYMONTH=4;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "-0425300",
    longitude: "+1471900"
  },
  "Australia/Lindeman": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+1000\r
TZOFFSETTO:+1000\r
TZNAME:AEST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0201600",
    longitude: "+1490000"
  },
  "Australia/Lord_Howe": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+1100\r
TZOFFSETTO:+1030\r
TZNAME:+1030\r
DTSTART:19700405T020000\r
RRULE:FREQ=YEARLY;BYMONTH=4;BYDAY=1SU\r
END:STANDARD`,
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+1030\r
TZOFFSETTO:+1100\r
TZNAME:+11\r
DTSTART:19701004T020000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=1SU\r
END:DAYLIGHT`
    ],
    latitude: "-0313300",
    longitude: "+1590500"
  },
  "Australia/Melbourne": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+1100\r
TZOFFSETTO:+1000\r
TZNAME:AEST\r
DTSTART:19700405T030000\r
RRULE:FREQ=YEARLY;BYMONTH=4;BYDAY=1SU\r
END:STANDARD`,
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+1000\r
TZOFFSETTO:+1100\r
TZNAME:AEDT\r
DTSTART:19701004T020000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=1SU\r
END:DAYLIGHT`
    ],
    latitude: "-0374900",
    longitude: "+1445800"
  },
  "Australia/Perth": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0800\r
TZOFFSETTO:+0800\r
TZNAME:AWST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0315700",
    longitude: "+1155100"
  },
  "Australia/Sydney": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+1100\r
TZOFFSETTO:+1000\r
TZNAME:AEST\r
DTSTART:19700405T030000\r
RRULE:FREQ=YEARLY;BYMONTH=4;BYDAY=1SU\r
END:STANDARD`,
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+1000\r
TZOFFSETTO:+1100\r
TZNAME:AEDT\r
DTSTART:19701004T020000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=1SU\r
END:DAYLIGHT`
    ],
    latitude: "-0335200",
    longitude: "+1511300"
  },
  "Europe/Amsterdam": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0200\r
TZNAME:CEST\r
DTSTART:19700329T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0100\r
TZNAME:CET\r
DTSTART:19701025T030000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0522200",
    longitude: "+0045400"
  },
  "Europe/Andorra": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0200\r
TZNAME:CEST\r
DTSTART:19700329T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0100\r
TZNAME:CET\r
DTSTART:19701025T030000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0423000",
    longitude: "+0013100"
  },
  "Europe/Astrakhan": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0400\r
TZOFFSETTO:+0400\r
TZNAME:+04\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0462100",
    longitude: "+0480300"
  },
  "Europe/Athens": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0300\r
TZNAME:EEST\r
DTSTART:19700329T030000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0300\r
TZOFFSETTO:+0200\r
TZNAME:EET\r
DTSTART:19701025T040000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0375800",
    longitude: "+0234300"
  },
  "Europe/Belgrade": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0200\r
TZNAME:CEST\r
DTSTART:19700329T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0100\r
TZNAME:CET\r
DTSTART:19701025T030000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0445000",
    longitude: "+0203000"
  },
  "Europe/Berlin": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0200\r
TZNAME:CEST\r
DTSTART:19700329T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0100\r
TZNAME:CET\r
DTSTART:19701025T030000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0523000",
    longitude: "+0132200"
  },
  "Europe/Bratislava": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0200\r
TZNAME:CEST\r
DTSTART:19700329T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0100\r
TZNAME:CET\r
DTSTART:19701025T030000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0480900",
    longitude: "+0170700"
  },
  "Europe/Brussels": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0200\r
TZNAME:CEST\r
DTSTART:19700329T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0100\r
TZNAME:CET\r
DTSTART:19701025T030000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0505000",
    longitude: "+0042000"
  },
  "Europe/Bucharest": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0300\r
TZNAME:EEST\r
DTSTART:19700329T030000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0300\r
TZOFFSETTO:+0200\r
TZNAME:EET\r
DTSTART:19701025T040000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0442600",
    longitude: "+0260600"
  },
  "Europe/Budapest": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0200\r
TZNAME:CEST\r
DTSTART:19700329T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0100\r
TZNAME:CET\r
DTSTART:19701025T030000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0473000",
    longitude: "+0190500"
  },
  "Europe/Busingen": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0200\r
TZNAME:CEST\r
DTSTART:19700329T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0100\r
TZNAME:CET\r
DTSTART:19701025T030000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0474200",
    longitude: "+0084100"
  },
  "Europe/Chisinau": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0300\r
TZNAME:EEST\r
DTSTART:19700329T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0300\r
TZOFFSETTO:+0200\r
TZNAME:EET\r
DTSTART:19701025T030000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0470000",
    longitude: "+0285000"
  },
  "Europe/Copenhagen": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0200\r
TZNAME:CEST\r
DTSTART:19700329T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0100\r
TZNAME:CET\r
DTSTART:19701025T030000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0554000",
    longitude: "+0123500"
  },
  "Europe/Dublin": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0000\r
TZOFFSETTO:+0100\r
TZNAME:IST\r
DTSTART:19700329T010000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:STANDARD`,
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0000\r
TZNAME:GMT\r
DTSTART:19701025T020000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:DAYLIGHT`
    ],
    latitude: "+0532000",
    longitude: "-0061500"
  },
  "Europe/Gibraltar": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0200\r
TZNAME:CEST\r
DTSTART:19700329T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0100\r
TZNAME:CET\r
DTSTART:19701025T030000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0360800",
    longitude: "-0052100"
  },
  "Europe/Guernsey": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0000\r
TZOFFSETTO:+0100\r
TZNAME:BST\r
DTSTART:19700329T010000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0000\r
TZNAME:GMT\r
DTSTART:19701025T020000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0492717",
    longitude: "-0023210"
  },
  "Europe/Helsinki": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0300\r
TZNAME:EEST\r
DTSTART:19700329T030000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0300\r
TZOFFSETTO:+0200\r
TZNAME:EET\r
DTSTART:19701025T040000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0601000",
    longitude: "+0245800"
  },
  "Europe/Isle_of_Man": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0000\r
TZOFFSETTO:+0100\r
TZNAME:BST\r
DTSTART:19700329T010000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0000\r
TZNAME:GMT\r
DTSTART:19701025T020000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0540900",
    longitude: "-0042800"
  },
  "Europe/Istanbul": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0300\r
TZOFFSETTO:+0300\r
TZNAME:+03\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0410100",
    longitude: "+0285800"
  },
  "Europe/Jersey": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0000\r
TZOFFSETTO:+0100\r
TZNAME:BST\r
DTSTART:19700329T010000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0000\r
TZNAME:GMT\r
DTSTART:19701025T020000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0491101",
    longitude: "-0020624"
  },
  "Europe/Kaliningrad": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0200\r
TZNAME:EET\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0544300",
    longitude: "+0203000"
  },
  "Europe/Kiev": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0300\r
TZNAME:EEST\r
DTSTART:19700329T030000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0300\r
TZOFFSETTO:+0200\r
TZNAME:EET\r
DTSTART:19701025T040000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0502600",
    longitude: "+0303100"
  },
  "Europe/Kirov": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0300\r
TZOFFSETTO:+0300\r
TZNAME:+03\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0583600",
    longitude: "+0493900"
  },
  "Europe/Lisbon": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0000\r
TZNAME:WET\r
DTSTART:19701025T020000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`,
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0000\r
TZOFFSETTO:+0100\r
TZNAME:WEST\r
DTSTART:19700329T010000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`
    ],
    latitude: "+0384300",
    longitude: "-0090800"
  },
  "Europe/Ljubljana": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0200\r
TZNAME:CEST\r
DTSTART:19700329T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0100\r
TZNAME:CET\r
DTSTART:19701025T030000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0460300",
    longitude: "+0143100"
  },
  "Europe/London": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0000\r
TZOFFSETTO:+0100\r
TZNAME:BST\r
DTSTART:19700329T010000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0000\r
TZNAME:GMT\r
DTSTART:19701025T020000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0513030",
    longitude: "+0000731"
  },
  "Europe/Luxembourg": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0200\r
TZNAME:CEST\r
DTSTART:19700329T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0100\r
TZNAME:CET\r
DTSTART:19701025T030000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0493600",
    longitude: "+0060900"
  },
  "Europe/Madrid": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0200\r
TZNAME:CEST\r
DTSTART:19700329T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0100\r
TZNAME:CET\r
DTSTART:19701025T030000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0402400",
    longitude: "-0034100"
  },
  "Europe/Malta": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0200\r
TZNAME:CEST\r
DTSTART:19700329T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0100\r
TZNAME:CET\r
DTSTART:19701025T030000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0355400",
    longitude: "+0143100"
  },
  "Europe/Mariehamn": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0300\r
TZNAME:EEST\r
DTSTART:19700329T030000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0300\r
TZOFFSETTO:+0200\r
TZNAME:EET\r
DTSTART:19701025T040000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0600600",
    longitude: "+0195700"
  },
  "Europe/Minsk": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0300\r
TZOFFSETTO:+0300\r
TZNAME:+03\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0535400",
    longitude: "+0273400"
  },
  "Europe/Monaco": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0200\r
TZNAME:CEST\r
DTSTART:19700329T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0100\r
TZNAME:CET\r
DTSTART:19701025T030000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0434200",
    longitude: "+0072300"
  },
  "Europe/Moscow": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0300\r
TZOFFSETTO:+0300\r
TZNAME:MSK\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0554521",
    longitude: "+0373704"
  },
  "Europe/Nicosia": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0300\r
TZOFFSETTO:+0200\r
TZNAME:EET\r
DTSTART:19701025T040000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`,
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0300\r
TZNAME:EEST\r
DTSTART:19700329T030000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`
    ],
    latitude: "+0351000",
    longitude: "+0332200"
  },
  "Europe/Oslo": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0200\r
TZNAME:CEST\r
DTSTART:19700329T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0100\r
TZNAME:CET\r
DTSTART:19701025T030000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0595500",
    longitude: "+0104500"
  },
  "Europe/Paris": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0200\r
TZNAME:CEST\r
DTSTART:19700329T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0100\r
TZNAME:CET\r
DTSTART:19701025T030000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0485200",
    longitude: "+0022000"
  },
  "Europe/Podgorica": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0200\r
TZNAME:CEST\r
DTSTART:19700329T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0100\r
TZNAME:CET\r
DTSTART:19701025T030000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0422600",
    longitude: "+0191600"
  },
  "Europe/Prague": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0200\r
TZNAME:CEST\r
DTSTART:19700329T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0100\r
TZNAME:CET\r
DTSTART:19701025T030000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0500500",
    longitude: "+0142600"
  },
  "Europe/Riga": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0300\r
TZNAME:EEST\r
DTSTART:19700329T030000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0300\r
TZOFFSETTO:+0200\r
TZNAME:EET\r
DTSTART:19701025T040000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0565700",
    longitude: "+0240600"
  },
  "Europe/Rome": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0200\r
TZNAME:CEST\r
DTSTART:19700329T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0100\r
TZNAME:CET\r
DTSTART:19701025T030000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0415400",
    longitude: "+0122900"
  },
  "Europe/Samara": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0400\r
TZOFFSETTO:+0400\r
TZNAME:+04\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0531200",
    longitude: "+0500900"
  },
  "Europe/San_Marino": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0200\r
TZNAME:CEST\r
DTSTART:19700329T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0100\r
TZNAME:CET\r
DTSTART:19701025T030000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0435500",
    longitude: "+0122800"
  },
  "Europe/Sarajevo": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0200\r
TZNAME:CEST\r
DTSTART:19700329T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0100\r
TZNAME:CET\r
DTSTART:19701025T030000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0435200",
    longitude: "+0182500"
  },
  "Europe/Saratov": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0400\r
TZOFFSETTO:+0400\r
TZNAME:+04\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0513400",
    longitude: "+0460200"
  },
  "Europe/Simferopol": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0300\r
TZOFFSETTO:+0300\r
TZNAME:MSK\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0445700",
    longitude: "+0340600"
  },
  "Europe/Skopje": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0200\r
TZNAME:CEST\r
DTSTART:19700329T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0100\r
TZNAME:CET\r
DTSTART:19701025T030000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0415900",
    longitude: "+0212600"
  },
  "Europe/Sofia": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0300\r
TZNAME:EEST\r
DTSTART:19700329T030000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0300\r
TZOFFSETTO:+0200\r
TZNAME:EET\r
DTSTART:19701025T040000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0424100",
    longitude: "+0231900"
  },
  "Europe/Stockholm": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0200\r
TZNAME:CEST\r
DTSTART:19700329T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0100\r
TZNAME:CET\r
DTSTART:19701025T030000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0592000",
    longitude: "+0180300"
  },
  "Europe/Tallinn": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0300\r
TZNAME:EEST\r
DTSTART:19700329T030000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0300\r
TZOFFSETTO:+0200\r
TZNAME:EET\r
DTSTART:19701025T040000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0592500",
    longitude: "+0244500"
  },
  "Europe/Tirane": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0200\r
TZNAME:CEST\r
DTSTART:19700329T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0100\r
TZNAME:CET\r
DTSTART:19701025T030000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0412000",
    longitude: "+0195000"
  },
  "Europe/Ulyanovsk": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0400\r
TZOFFSETTO:+0400\r
TZNAME:+04\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0542000",
    longitude: "+0482400"
  },
  "Europe/Uzhgorod": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0300\r
TZNAME:EEST\r
DTSTART:19700329T030000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0300\r
TZOFFSETTO:+0200\r
TZNAME:EET\r
DTSTART:19701025T040000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0483700",
    longitude: "+0221800"
  },
  "Europe/Vaduz": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0200\r
TZNAME:CEST\r
DTSTART:19700329T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0100\r
TZNAME:CET\r
DTSTART:19701025T030000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0470900",
    longitude: "+0093100"
  },
  "Europe/Vatican": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0200\r
TZNAME:CEST\r
DTSTART:19700329T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0100\r
TZNAME:CET\r
DTSTART:19701025T030000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0415408",
    longitude: "+0122711"
  },
  "Europe/Vienna": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0200\r
TZNAME:CEST\r
DTSTART:19700329T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0100\r
TZNAME:CET\r
DTSTART:19701025T030000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0481300",
    longitude: "+0162000"
  },
  "Europe/Vilnius": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0300\r
TZNAME:EEST\r
DTSTART:19700329T030000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0300\r
TZOFFSETTO:+0200\r
TZNAME:EET\r
DTSTART:19701025T040000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0544100",
    longitude: "+0251900"
  },
  "Europe/Volgograd": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0300\r
TZOFFSETTO:+0400\r
TZNAME:+04\r
DTSTART:20181028T020000\r
RDATE:20181028T020000\r
END:STANDARD`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0400\r
TZOFFSETTO:+0300\r
TZNAME:+03\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0484400",
    longitude: "+0442500"
  },
  "Europe/Warsaw": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0200\r
TZNAME:CEST\r
DTSTART:19700329T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0100\r
TZNAME:CET\r
DTSTART:19701025T030000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0521500",
    longitude: "+0210000"
  },
  "Europe/Zagreb": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0200\r
TZNAME:CEST\r
DTSTART:19700329T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0100\r
TZNAME:CET\r
DTSTART:19701025T030000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0454800",
    longitude: "+0155800"
  },
  "Europe/Zaporozhye": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0300\r
TZNAME:EEST\r
DTSTART:19700329T030000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0300\r
TZOFFSETTO:+0200\r
TZNAME:EET\r
DTSTART:19701025T040000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0475000",
    longitude: "+0351000"
  },
  "Europe/Zurich": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+0100\r
TZOFFSETTO:+0200\r
TZNAME:CEST\r
DTSTART:19700329T020000\r
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0200\r
TZOFFSETTO:+0100\r
TZNAME:CET\r
DTSTART:19701025T030000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\r
END:STANDARD`
    ],
    latitude: "+0472300",
    longitude: "+0083200"
  },
  "Indian/Antananarivo": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0300\r
TZOFFSETTO:+0300\r
TZNAME:EAT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0185500",
    longitude: "+0473100"
  },
  "Indian/Chagos": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0600\r
TZOFFSETTO:+0600\r
TZNAME:+06\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0072000",
    longitude: "+0722500"
  },
  "Indian/Christmas": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0700\r
TZOFFSETTO:+0700\r
TZNAME:+07\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0102500",
    longitude: "+1054300"
  },
  "Indian/Cocos": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0630\r
TZOFFSETTO:+0630\r
TZNAME:+0630\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0121000",
    longitude: "+0965500"
  },
  "Indian/Comoro": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0300\r
TZOFFSETTO:+0300\r
TZNAME:EAT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0114100",
    longitude: "+0431600"
  },
  "Indian/Kerguelen": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0500\r
TZOFFSETTO:+0500\r
TZNAME:+05\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0492110",
    longitude: "+0701303"
  },
  "Indian/Mahe": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0400\r
TZOFFSETTO:+0400\r
TZNAME:+04\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0044000",
    longitude: "+0552800"
  },
  "Indian/Maldives": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0500\r
TZOFFSETTO:+0500\r
TZNAME:+05\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0041000",
    longitude: "+0733000"
  },
  "Indian/Mauritius": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0400\r
TZOFFSETTO:+0400\r
TZNAME:+04\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0201000",
    longitude: "+0573000"
  },
  "Indian/Mayotte": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0300\r
TZOFFSETTO:+0300\r
TZNAME:EAT\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0124700",
    longitude: "+0451400"
  },
  "Indian/Reunion": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0400\r
TZOFFSETTO:+0400\r
TZNAME:+04\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0205200",
    longitude: "+0552800"
  },
  "Pacific/Apia": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+1400\r
TZOFFSETTO:+1300\r
TZNAME:+13\r
DTSTART:19700405T040000\r
RRULE:FREQ=YEARLY;BYMONTH=4;BYDAY=1SU\r
END:STANDARD`,
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+1300\r
TZOFFSETTO:+1400\r
TZNAME:+14\r
DTSTART:19700927T030000\r
RRULE:FREQ=YEARLY;BYMONTH=9;BYDAY=-1SU\r
END:DAYLIGHT`
    ],
    latitude: "-0135000",
    longitude: "-1714400"
  },
  "Pacific/Auckland": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+1200\r
TZOFFSETTO:+1300\r
TZNAME:NZDT\r
DTSTART:19700927T020000\r
RRULE:FREQ=YEARLY;BYMONTH=9;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+1300\r
TZOFFSETTO:+1200\r
TZNAME:NZST\r
DTSTART:19700405T030000\r
RRULE:FREQ=YEARLY;BYMONTH=4;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "-0365200",
    longitude: "+1744600"
  },
  "Pacific/Bougainville": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+1100\r
TZOFFSETTO:+1100\r
TZNAME:+11\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0061300",
    longitude: "+1553400"
  },
  "Pacific/Chatham": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+1245\r
TZOFFSETTO:+1345\r
TZNAME:+1345\r
DTSTART:19700927T024500\r
RRULE:FREQ=YEARLY;BYMONTH=9;BYDAY=-1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+1345\r
TZOFFSETTO:+1245\r
TZNAME:+1245\r
DTSTART:19700405T034500\r
RRULE:FREQ=YEARLY;BYMONTH=4;BYDAY=1SU\r
END:STANDARD`
    ],
    latitude: "-0435700",
    longitude: "-1763300"
  },
  "Pacific/Chuuk": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+1000\r
TZOFFSETTO:+1000\r
TZNAME:+10\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0072500",
    longitude: "+1514700"
  },
  "Pacific/Easter": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0500\r
TZOFFSETTO:-0600\r
TZNAME:-06\r
DTSTART:20190406T220000\r
RRULE:FREQ=YEARLY;BYMONTH=4;BYDAY=1SA\r
END:STANDARD`,
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0600\r
TZOFFSETTO:-0500\r
TZNAME:-05\r
DTSTART:20190907T220000\r
RRULE:FREQ=YEARLY;BYMONTH=9;BYDAY=1SA\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0600\r
TZOFFSETTO:-0600\r
TZNAME:-06\r
DTSTART:19700101T000000\r
END:STANDARD`,
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:-0600\r
TZOFFSETTO:-0500\r
TZNAME:-05\r
DTSTART:20180811T220000\r
RDATE:20180811T220000\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0500\r
TZOFFSETTO:-0600\r
TZNAME:-06\r
DTSTART:20180512T220000\r
RDATE:20180512T220000\r
END:STANDARD`
    ],
    latitude: "-0270900",
    longitude: "-1092600"
  },
  "Pacific/Efate": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+1100\r
TZOFFSETTO:+1100\r
TZNAME:+11\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0174000",
    longitude: "+1682500"
  },
  "Pacific/Enderbury": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+1300\r
TZOFFSETTO:+1300\r
TZNAME:+13\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0030800",
    longitude: "-1710500"
  },
  "Pacific/Fakaofo": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+1300\r
TZOFFSETTO:+1300\r
TZNAME:+13\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0092200",
    longitude: "-1711400"
  },
  "Pacific/Fiji": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+1300\r
TZOFFSETTO:+1200\r
TZNAME:+12\r
DTSTART:19700118T030000\r
RRULE:FREQ=YEARLY;BYMONTH=1;BYMONTHDAY=12,13,14,15,16,17,18;BYDAY=SU\r
END:STANDARD`,
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+1200\r
TZOFFSETTO:+1300\r
TZNAME:+13\r
DTSTART:20191110T020000\r
RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=2SU\r
END:DAYLIGHT`,
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+1200\r
TZOFFSETTO:+1300\r
TZNAME:+13\r
DTSTART:20181104T020000\r
RDATE:20181104T020000\r
END:DAYLIGHT`
    ],
    latitude: "-0180800",
    longitude: "+1782500"
  },
  "Pacific/Funafuti": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+1200\r
TZOFFSETTO:+1200\r
TZNAME:+12\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0083100",
    longitude: "+1791300"
  },
  "Pacific/Galapagos": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0600\r
TZOFFSETTO:-0600\r
TZNAME:-06\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0005400",
    longitude: "-0893600"
  },
  "Pacific/Gambier": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0900\r
TZOFFSETTO:-0900\r
TZNAME:-09\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0230800",
    longitude: "-1345700"
  },
  "Pacific/Guadalcanal": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+1100\r
TZOFFSETTO:+1100\r
TZNAME:+11\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0093200",
    longitude: "+1601200"
  },
  "Pacific/Guam": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+1000\r
TZOFFSETTO:+1000\r
TZNAME:ChST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0132800",
    longitude: "+1444500"
  },
  "Pacific/Honolulu": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-1000\r
TZOFFSETTO:-1000\r
TZNAME:HST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0211825",
    longitude: "-1575130"
  },
  "Pacific/Kiritimati": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+1400\r
TZOFFSETTO:+1400\r
TZNAME:+14\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0015200",
    longitude: "-1572000"
  },
  "Pacific/Kosrae": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+1100\r
TZOFFSETTO:+1100\r
TZNAME:+11\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0051900",
    longitude: "+1625900"
  },
  "Pacific/Kwajalein": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+1200\r
TZOFFSETTO:+1200\r
TZNAME:+12\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0090500",
    longitude: "+1672000"
  },
  "Pacific/Majuro": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+1200\r
TZOFFSETTO:+1200\r
TZNAME:+12\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0070900",
    longitude: "+1711200"
  },
  "Pacific/Marquesas": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0930\r
TZOFFSETTO:-0930\r
TZNAME:-0930\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0090000",
    longitude: "-1393000"
  },
  "Pacific/Midway": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-1100\r
TZOFFSETTO:-1100\r
TZNAME:SST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0281300",
    longitude: "-1772200"
  },
  "Pacific/Nauru": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+1200\r
TZOFFSETTO:+1200\r
TZNAME:+12\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0003100",
    longitude: "+1665500"
  },
  "Pacific/Niue": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-1100\r
TZOFFSETTO:-1100\r
TZNAME:-11\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0190100",
    longitude: "-1695500"
  },
  "Pacific/Norfolk": {
    ics: [
      `BEGIN:DAYLIGHT\r
TZOFFSETFROM:+1100\r
TZOFFSETTO:+1200\r
TZNAME:+12\r
DTSTART:20191006T020000\r
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=1SU\r
END:DAYLIGHT`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+1200\r
TZOFFSETTO:+1100\r
TZNAME:+11\r
DTSTART:20200405T030000\r
RRULE:FREQ=YEARLY;BYMONTH=4;BYDAY=1SU\r
END:STANDARD`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+1130\r
TZOFFSETTO:+1100\r
TZNAME:+11\r
DTSTART:19700101T000000\r
END:STANDARD`,
      `BEGIN:STANDARD\r
TZOFFSETFROM:+1100\r
TZOFFSETTO:+1100\r
TZNAME:+11\r
DTSTART:20190701T000000\r
RDATE:20190701T000000\r
END:STANDARD`
    ],
    latitude: "-0290300",
    longitude: "+1675800"
  },
  "Pacific/Noumea": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+1100\r
TZOFFSETTO:+1100\r
TZNAME:+11\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0221600",
    longitude: "+1662700"
  },
  "Pacific/Pago_Pago": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-1100\r
TZOFFSETTO:-1100\r
TZNAME:SST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0141600",
    longitude: "-1704200"
  },
  "Pacific/Palau": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+0900\r
TZOFFSETTO:+0900\r
TZNAME:+09\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0072000",
    longitude: "+1342900"
  },
  "Pacific/Pitcairn": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-0800\r
TZOFFSETTO:-0800\r
TZNAME:-08\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0250400",
    longitude: "-1300500"
  },
  "Pacific/Pohnpei": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+1100\r
TZOFFSETTO:+1100\r
TZNAME:+11\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0065800",
    longitude: "+1581300"
  },
  "Pacific/Port_Moresby": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+1000\r
TZOFFSETTO:+1000\r
TZNAME:+10\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0093000",
    longitude: "+1471000"
  },
  "Pacific/Rarotonga": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-1000\r
TZOFFSETTO:-1000\r
TZNAME:-10\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0211400",
    longitude: "-1594600"
  },
  "Pacific/Saipan": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+1000\r
TZOFFSETTO:+1000\r
TZNAME:ChST\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0151200",
    longitude: "+1454500"
  },
  "Pacific/Tahiti": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:-1000\r
TZOFFSETTO:-1000\r
TZNAME:-10\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0173200",
    longitude: "-1493400"
  },
  "Pacific/Tarawa": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+1200\r
TZOFFSETTO:+1200\r
TZNAME:+12\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0012500",
    longitude: "+1730000"
  },
  "Pacific/Tongatapu": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+1300\r
TZOFFSETTO:+1300\r
TZNAME:+13\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0211000",
    longitude: "-1751000"
  },
  "Pacific/Wake": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+1200\r
TZOFFSETTO:+1200\r
TZNAME:+12\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "+0191700",
    longitude: "+1663700"
  },
  "Pacific/Wallis": {
    ics: [
      `BEGIN:STANDARD\r
TZOFFSETFROM:+1200\r
TZOFFSETTO:+1200\r
TZNAME:+12\r
DTSTART:19700101T000000\r
END:STANDARD`
    ],
    latitude: "-0131800",
    longitude: "-1761000"
  }
}, Yr = {
  version: s1,
  aliases: l1,
  zones: u1
};
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class oh {
  /**
   * Constructor
   */
  constructor() {
    this._aliases = /* @__PURE__ */ new Map(), this._timezones = /* @__PURE__ */ new Map();
  }
  /**
   * Gets a timezone for the given id
   *
   * @param {string} timezoneId The id of the timezone
   * @return {Timezone|null}
   */
  getTimezoneForId(e) {
    return this._getTimezoneForIdRec(e, 0);
  }
  _getTimezoneForIdRec(e, t) {
    if (this._timezones.has(e))
      return this._timezones.get(e);
    if (t >= 20)
      return console.error("TimezoneManager.getTimezoneForIdRec() exceeds recursion limits"), null;
    if (this._aliases.has(e)) {
      const n = this._aliases.get(e);
      return this._getTimezoneForIdRec(n, t + 1);
    }
    return null;
  }
  /**
   * Checks if there is a timezone for the given id stored in this manager
   *
   * @param {string} timezoneId The id of the timezone
   * @return {boolean}
   */
  hasTimezoneForId(e) {
    return this._timezones.has(e) || this._aliases.has(e);
  }
  /**
   * Checks if the given timezone id is an alias
   *
   * @param {string} timezoneId The id of the timezone
   * @return {boolean}
   */
  isAlias(e) {
    return !this._timezones.has(e) && this._aliases.has(e);
  }
  /**
   * Lists all timezones
   *
   * @param {boolean=} includeAliases Whether or not to include aliases
   * @return {String[]}
   */
  listAllTimezones(e = !1) {
    const t = Array.from(this._timezones.keys());
    return e ? t.concat(Array.from(this._aliases.keys())) : t;
  }
  /**
   * Registers a timezone
   *
   * @param {Timezone} timezone The timezone-object to register
   */
  registerTimezone(e) {
    this._timezones.set(e.timezoneId, e);
  }
  registerDefaultTimezones() {
    console.debug(`@nextcloud/calendar-js app is using version ${Yr.version} of the timezone database`);
    for (const e in Yr.zones)
      if (Object.prototype.hasOwnProperty.call(Yr.zones, [e])) {
        const t = ["BEGIN:VTIMEZONE", "TZID:" + e, ...Yr.zones[e].ics, "END:VTIMEZONE"].join(`\r
`);
        this.registerTimezoneFromICS(e, t);
      }
    for (const e in Yr.aliases)
      Object.prototype.hasOwnProperty.call(Yr.aliases, [e]) && this.registerAlias(e, Yr.aliases[e].aliasTo);
  }
  /**
   * Registers a timezone based on ics data
   *
   * @param {string} timezoneId The id of the timezone
   * @param {string} ics The iCalendar timezone definition
   */
  registerTimezoneFromICS(e, t) {
    const n = new ht(e, t);
    this.registerTimezone(n);
  }
  /**
   * Registers a new timezone-alias
   *
   * @param {string} aliasName The timezone-id of the alias
   * @param {string} timezoneId The timezone-id to resolve the alias to
   */
  registerAlias(e, t) {
    this._aliases.set(e, t);
  }
  /**
   * Unregisters a timezone
   *
   * @param {string} timezoneId Unregisters a timezone by Id
   */
  unregisterTimezones(e) {
    this._timezones.delete(e);
  }
  /**
   * Unregisters a timezone-alias
   *
   * @param {string} aliasName The alias to unregister
   */
  unregisterAlias(e) {
    this._aliases.delete(e);
  }
  /**
   * Clear all timezones
  	 */
  clearAllTimezones() {
    this._aliases = /* @__PURE__ */ new Map(), this._timezones = /* @__PURE__ */ new Map(), an.registerTimezone(ht.utc), an.registerTimezone(ht.floating), an.registerAlias("GMT", ht.utc.timezoneId), an.registerAlias("Z", ht.utc.timezoneId);
  }
}
const an = new oh();
an.clearAllTimezones();
function Eu() {
  return an;
}
function c1(r) {
  const e = r.indexOf("/") !== -1, t = r.indexOf(" ") !== -1, n = r.startsWith("Etc"), i = r.startsWith("US/");
  return e && !t && !n && !i;
}
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class sh extends Na {
  /**
   * @inheritDoc
   */
  constructor(...e) {
    super(...e), this._rawData = null, this._calendarComponent = null, this._containsVEvents = !1, this._containsVJournals = !1, this._containsVTodos = !1, this._containsVFreeBusy = !1, this._items = /* @__PURE__ */ new Map(), this._masterItems = /* @__PURE__ */ new Map(), this._recurrenceExceptionItems = /* @__PURE__ */ new Map(), this._forgedMasterItems = /* @__PURE__ */ new Map(), this._timezones = /* @__PURE__ */ new Map(), this._requiredTimezones = /* @__PURE__ */ new Map(), this._defaultTimezoneManager = Eu();
  }
  /**
   * Parses the actual calendar-data
   *
   * @param {string} ics The icalendar data to parse
   */
  parse(e) {
    this._rawData = e, this._applyRepairSteps(), this._extractTimezones(), this._registerTimezones(), this._createCalendarComponent(), this._getOption("extractGlobalProperties", !1) && this._extractProperties(), this._processVObjects(), this._getOption("processFreeBusy", !1) && this._processVFreeBusy();
  }
  /**
   * @inheritDoc
   */
  *getItemIterator() {
    for (const e of this._items.values()) {
      const t = sr.fromEmpty();
      this._getOption("includeTimezones", !1) && this._addRequiredTimezonesToCalendarComp(t, e[0].uid), this._calendarComponent.hasProperty("PRODID") && (t.deleteAllProperties("PRODID"), t.addProperty(this._calendarComponent.getFirstProperty("PRODID").clone())), this._getOption("preserveMethod", !1) && this._calendarComponent.hasProperty("METHOD") && (t.deleteAllProperties("METHOD"), t.addProperty(this._calendarComponent.getFirstProperty("METHOD").clone()));
      for (const n of e)
        t.addComponent(n);
      yield t;
    }
  }
  /**
   * @inheritDoc
   */
  containsVEvents() {
    return this._containsVEvents;
  }
  /**
   * @inheritDoc
   */
  containsVJournals() {
    return this._containsVJournals;
  }
  /**
   * @inheritDoc
   */
  containsVTodos() {
    return this._containsVTodos;
  }
  /**
   * @inheritDoc
   */
  containsVFreeBusy() {
    return this._containsVFreeBusy;
  }
  /**
   * @inheritDoc
   */
  getItemCount() {
    return Array.from(this._items.keys()).length;
  }
  /**
   * Applies all registered repair steps
   *
   * @private
   */
  _applyRepairSteps() {
    for (const e of o1()) {
      const t = new e();
      this._rawData = t.repair(this._rawData);
    }
  }
  /**
   * Creates a calendar component based upon the repaired data
   *
   * @private
   */
  _createCalendarComponent() {
    const e = ge.parse(this._rawData), t = new ge.Component(e);
    this._calendarComponent = sr.fromICALJs(t);
  }
  /**
   * extracts properties
   *
   * @protected
   */
  _extractProperties() {
    this._extractPropertyAndPutResultIntoVariable(["name", "x-wr-calname"], "_name"), this._extractPropertyAndPutResultIntoVariable(["color", "x-apple-calendar-color"], "_color"), this._extractPropertyAndPutResultIntoVariable(["source"], "_sourceURL"), this._extractPropertyAndPutResultIntoVariable(["refresh-interval", "x-published-ttl"], "_refreshInterval"), this._extractPropertyAndPutResultIntoVariable(["x-wr-timezone"], "_calendarTimezone");
  }
  /**
   * Extract a property and writes it into a class property
   * names must be an array, it will use the value of the fist
   * propertyname it can find
   *
   * @param {String[]} names The names of the properties to check
   * @param {string} variableName The variable name to save it under
   * @private
   */
  _extractPropertyAndPutResultIntoVariable(e, t) {
    for (const n of e)
      if (this._calendarComponent.hasProperty(n)) {
        this[t] = this._calendarComponent.getFirstPropertyFirstValue(n);
        return;
      }
  }
  /**
   * Extracts timezones from the calendar component
   *
   * @protected
   */
  _extractTimezones() {
    const e = this._rawData.match(/^BEGIN:VTIMEZONE$(((?!^END:VTIMEZONE$)(.|\n))*)^END:VTIMEZONE$\n/gm);
    if (e)
      for (const t of e) {
        const n = t.match(/^TZID:(.*)$/gm);
        if (!n)
          continue;
        const i = n[0].slice(5), s = new ht(i, t);
        this._timezones.set(i, s);
      }
  }
  /**
   * Registers unknown timezones into our timezone-manager
   *
   * @protected
   */
  _registerTimezones() {
    for (const [e, t] of this._timezones)
      this._defaultTimezoneManager.hasTimezoneForId(e) || this._defaultTimezoneManager.registerTimezone(t);
  }
  /**
   * Processes the parsed vobjects
   *
   * @protected
   */
  _processVObjects() {
    for (const e of this._calendarComponent.getVObjectIterator()) {
      this._addItem(e), this._markCompTypeAsSeen(e.name), e.isRecurrenceException() ? this._addRecurrenceException(e) : (e.recurrenceManager = new ei(e), this._masterItems.set(e.uid, e));
      for (const t of e.getPropertyIterator())
        for (const n of t.getValueIterator())
          n instanceof Oe && n.timezoneId && this._addRequiredTimezone(e.uid, n.timezoneId);
      for (const t of e.getAlarmIterator())
        for (const n of t.getPropertyIterator())
          for (const i of n.getValueIterator())
            i instanceof Oe && i.timezoneId && this._addRequiredTimezone(e.uid, i.timezoneId);
      if (this._getOption("removeRSVPForAttendees", !1))
        for (const t of e.getAttendeeIterator())
          t.deleteParameter("RSVP");
    }
    for (const e of this._recurrenceExceptionItems.values())
      for (const t of e) {
        if (this._masterItems.has(t.uid)) {
          const i = this._masterItems.get(t.uid);
          i.isRecurring() || this._forgedMasterItems.set(i.uid, i);
        } else {
          const i = ah(t.name), s = new i(t.name, [["UID", t.uid], ["DTSTAMP", t.stampTime.clone()], ["DTSTART", t.recurrenceId.clone()]]);
          s.recurrenceManager = new ei(s), this._forgedMasterItems.set(t.uid, s), this._masterItems.set(t.uid, s), this._addItem(s);
        }
        this._forgedMasterItems.has(t.uid) && this._forgedMasterItems.get(t.uid).recurrenceManager.addRecurrenceDate(!1, t.recurrenceId.clone()), this._masterItems.get(t.uid).recurrenceManager.relateRecurrenceException(t);
      }
  }
  /**
   * Process FreeBusy components
   *
   * @private
   */
  _processVFreeBusy() {
    for (const e of this._calendarComponent.getFreebusyIterator()) {
      this._addItem(e), this._markCompTypeAsSeen(e.name);
      for (const t of e.getPropertyIterator())
        for (const n of t.getValueIterator())
          n instanceof Oe && n.timezoneId && this._addRequiredTimezone(e.uid, n.timezoneId);
    }
  }
  /**
   *
   * @param {AbstractRecurringComponent} item The recurrence-item to register
   * @private
   */
  _addRecurrenceException(e) {
    this._recurrenceExceptionItems.has(e.uid) ? this._recurrenceExceptionItems.get(e.uid).push(e) : this._recurrenceExceptionItems.set(e.uid, [e]);
  }
  /**
   *
   * @param {AbstractRecurringComponent} item The item to register
   * @private
   */
  _addItem(e) {
    this._items.has(e.uid) ? this._items.get(e.uid).push(e) : this._items.set(e.uid, [e]);
  }
  /**
   *
   * @param {string} uid The uid of the calendar-object
   * @param {string} timezoneId The timezoneId required by the object
   * @private
   */
  _addRequiredTimezone(e, t) {
    if (!(t === "UTC" || t === "floating" || t === "GMT" || t === "Z"))
      if (this._requiredTimezones.has(e))
        this._requiredTimezones.get(e).add(t);
      else {
        const n = /* @__PURE__ */ new Set([t]);
        this._requiredTimezones.set(e, n);
      }
  }
  /**
   *
   * @param {CalendarComponent} calendarComp The calendar-component to add timezones to
   * @param {string} uid The UID of the calendar-object
   * @private
   */
  _addRequiredTimezonesToCalendarComp(e, t) {
    if (this._requiredTimezones.has(t))
      for (const n of this._requiredTimezones.get(t)) {
        if (!this._defaultTimezoneManager.hasTimezoneForId(n))
          return;
        const i = this._defaultTimezoneManager.getTimezoneForId(n);
        i.timezoneId !== n && this._replaceTimezoneWithAnotherOne(e, n, i.timezoneId);
        const s = ba.fromICALJs(i.toICALJs());
        e.addComponent(s);
      }
  }
  /**
   * Replaces all occurrences of searchTimezone with replaceTimezone
   *
   * @param {CalendarComponent} calendarComponent The calendar-component to replace a timezone in
   * @param {string} searchTimezone The timezone to replace
   * @param {string} replaceTimezone The replacement timezone
   * @private
   */
  _replaceTimezoneWithAnotherOne(e, t, n) {
    for (const i of this._calendarComponent.getVObjectIterator()) {
      for (const s of i.getPropertyIterator())
        for (const o of s.getValueIterator())
          o instanceof Oe && o.timezoneId === t && o.silentlyReplaceTimezone(n);
      for (const s of i.getAlarmIterator())
        for (const o of s.getPropertyIterator())
          for (const l of o.getValueIterator())
            l instanceof Oe && l.timezoneId === t && l.silentlyReplaceTimezone(n);
    }
  }
  /**
   * Marks a certain component type as seen.
   * This is used for
   * containsVEvents()
   * containsVJournals()
   * containsVTodos()
   *
   * @param {string} compName The name of the visited component
   * @private
   */
  _markCompTypeAsSeen(e) {
    switch (Le(e)) {
      case "VEVENT":
        this._containsVEvents = !0;
        break;
      case "VJOURNAL":
        this._containsVJournals = !0;
        break;
      case "VTODO":
        this._containsVTodos = !0;
        break;
      case "VFREEBUSY":
        this._containsVFreeBusy = !0;
        break;
    }
  }
  /**
   * @inheritDoc
   */
  static getMimeTypes() {
    return ["text/calendar"];
  }
}
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class lh {
  /**
   * Constructor
   */
  constructor() {
    this._parsers = [];
  }
  /**
   * Get a list of all supported file-types
   *
   * @return {String[]}
   */
  getAllSupportedFileTypes() {
    return this._parsers.reduce((e, t) => e.concat(t.getMimeTypes()), []);
  }
  /**
   * Get an instance of a parser for one specific file-type
   *
   * @param {string} fileType The mime-type to get a parser for
   * @param {Object=} options Options destructuring object
   * @param {boolean=} options.extractGlobalProperties Whether or not to preserve properties from the VCALENDAR component (defaults to false)
   * @param {boolean=} options.removeRSVPForAttendees Whether or not to remove RSVP from attendees (defaults to false)
   * @param {boolean=} options.includeTimezones Whether or not to include timezones (defaults to false)
   * @param {boolean=} options.preserveMethod Whether or not to preserve the iCalendar method (defaults to false)
   * @param {boolean=} options.processFreeBusy Whether or not to process VFreeBusy components (defaults to false)
   *
   * @return {AbstractParser}
   */
  getParserForFileType(e, t) {
    const n = this._parsers.find((i) => i.getMimeTypes().includes(e));
    if (!n)
      throw new TypeError("Unknown file-type.");
    return new n(t);
  }
  /**
   * Registers a parser
   *
   * @param {Function} parser The parser to register
   */
  registerParser(e) {
    this._parsers.push(e);
  }
}
function uh() {
  const r = new lh();
  return r.registerParser(sh), r;
}
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class kl {
  /**
   * Constructor
   *
   * @param {TimezoneManager} timezoneManager The timezone-manager to wrap
   */
  constructor(e) {
    this._timezoneManager = e;
  }
  /**
   * @param {string} timezoneId The id of the timezone
   * @return {boolean}
   */
  has(e) {
    return this._timezoneManager.hasTimezoneForId(e);
  }
  /**
   * @param {string} timezoneId The id of the timezone
   * @return {ICAL.Timezone|undefined}
   */
  get(e) {
    const t = this._timezoneManager.getTimezoneForId(e);
    if (t)
      return t.toICALTimezone();
  }
  /**
   * @throws TypeError
   */
  register() {
    throw new TypeError("Not allowed to register new timezone");
  }
  /**
   * @throws TypeError
   */
  remove() {
    throw new TypeError("Not allowed to remove timezone");
  }
  /**
   * @throws TypeError
   */
  reset() {
    throw new TypeError("Not allowed to reset TimezoneService");
  }
}
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class T1 extends Error {
}
/**
 * @copyright Copyright (c) 2021 Christoph Wurst
 *
 * @author Christoph Wurst <christoph@winzerhof-wurst.at>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
function d1(r = [], e = [], t = "Global") {
  const n = {}, i = [];
  for (const s of r) {
    const o = s.split("/");
    let [l, a] = [o.shift(), o.join("/")];
    a || (a = l, l = t), n[l] = n[l] || {
      continent: l,
      regions: []
    }, n[l].regions.push({
      label: ch(a),
      cities: [],
      timezoneId: s
    });
  }
  for (const s of e) {
    const {
      continent: o,
      label: l,
      timezoneId: a
    } = s;
    n[o] = n[o] || {
      continent: o,
      regions: []
    }, n[o].regions.push({
      label: l,
      cities: [],
      timezoneId: a
    });
  }
  for (const s in n)
    Object.prototype.hasOwnProperty.call(n, s) && (n[s].regions.sort((o, l) => o.label < l.label ? -1 : 1), i.push(n[s]));
  return i.sort((s, o) => s.continent < o.continent ? -1 : 1), i;
}
function ch(r) {
  return r.split("_").join(" ").replace("St ", "St. ").split("/").join(" - ");
}
/**
 * @copyright Copyright (c) 2019 Georg Ehrke
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @author Richard Steinmetz <richard@steinmetz.cloud>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
ge.TimezoneService instanceof kl || (ge.TimezoneService = new kl(Eu()));
function* A1(r, e, t) {
  const i = uh().getParserForFileType("text/calendar");
  i.parse(r);
  const o = i.getItemIterator().next().value;
  if (o === void 0)
    return;
  const a = o.getVObjectIterator().next().value;
  a !== void 0 && (yield* a.recurrenceManager.getAllOccurrencesBetweenIterator(e, t));
}
function f1(r, e) {
  const t = sr.fromEmpty(), n = new Wt("VEVENT");
  return n.updatePropertyWithValue("CREATED", Oe.fromJSDate(_t(), !0)), n.updatePropertyWithValue("DTSTAMP", Oe.fromJSDate(_t(), !0)), n.updatePropertyWithValue("LAST-MODIFIED", Oe.fromJSDate(_t(), !0)), n.updatePropertyWithValue("SEQUENCE", 0), n.updatePropertyWithValue("UID", va()), n.updatePropertyWithValue("DTSTART", r), n.updatePropertyWithValue("DTEND", e), t.addComponent(n), n.recurrenceManager = new ei(n), t;
}
function p1(r, e, t, n) {
  const i = sr.fromMethod("REQUEST"), s = new gn("VFREEBUSY");
  s.updatePropertyWithValue("DTSTAMP", Oe.fromJSDate(_t(), !0)), s.updatePropertyWithValue("UID", va()), s.updatePropertyWithValue("DTSTART", r.clone().getInUTC()), s.updatePropertyWithValue("DTEND", e.clone().getInUTC()), s.addProperty(t.clone());
  for (const o of n) {
    const l = o.clone();
    l.deleteParameter("ROLE"), l.deleteParameter("CUTYPE"), l.deleteParameter("RSVP"), l.deleteParameter("PARTSTAT"), l.deleteParameter("REQUEST-STATUS"), l.deleteParameter("LANGUAGE"), s.addProperty(l);
  }
  return i.addComponent(s), i;
}
const h1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AbstractComponent: qt,
  AbstractParser: Na,
  AbstractRecurringComponent: qe,
  AbstractValue: Ot,
  AlarmComponent: Lt,
  AttachmentProperty: Fr,
  AttendeeProperty: xt,
  BinaryValue: ft,
  CalendarComponent: sr,
  ConferenceProperty: Sn,
  DateTimeValue: Oe,
  DurationValue: yt,
  EventComponent: Wt,
  ExpectedICalJSError: fu,
  FreeBusyComponent: gn,
  FreeBusyProperty: ya,
  GeoProperty: Dn,
  ICalendarParser: sh,
  IllegalValueError: T1,
  ImageProperty: jr,
  JournalComponent: mu,
  ModificationNotAllowedError: Au,
  Parameter: nn,
  ParserManager: lh,
  PeriodValue: pt,
  Property: mt,
  RecurValue: un,
  RecurrenceManager: ei,
  RecurringWithoutDtStartError: nh,
  RelationProperty: ai,
  RequestStatusProperty: Be,
  TextProperty: Xn,
  Timezone: ht,
  TimezoneAdapter: kl,
  TimezoneComponent: ba,
  TimezoneManager: oh,
  ToDoComponent: Pt,
  TriggerProperty: or,
  UTCOffsetValue: kr,
  UnknownICALTypeError: eh,
  createEvent: f1,
  createFreeBusyRequest: p1,
  getConstructorForICALType: th,
  getConstructorForPropertyName: Ii,
  getParserManager: uh,
  getReadableTimezoneName: ch,
  getSortedTimezoneList: d1,
  getTimezoneManager: Eu,
  isOlsonTimezone: c1,
  parseICSAndGetAllOccurrencesBetween: A1,
  setConfig: jE
}, Symbol.toStringTag, { value: "Module" })), m1 = /* @__PURE__ */ Vr(h1);
var Ui = {}, E1 = {
  get exports() {
    return Ui;
  },
  set exports(r) {
    Ui = r;
  }
}, Hi = {}, S1 = {
  get exports() {
    return Hi;
  },
  set exports(r) {
    Hi = r;
  }
}, Cc;
function D1() {
  return Cc || (Cc = 1, function() {
    var r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", e = {
      // Bit-wise rotation left
      rotl: function(t, n) {
        return t << n | t >>> 32 - n;
      },
      // Bit-wise rotation right
      rotr: function(t, n) {
        return t << 32 - n | t >>> n;
      },
      // Swap big-endian to little-endian and vice versa
      endian: function(t) {
        if (t.constructor == Number)
          return e.rotl(t, 8) & 16711935 | e.rotl(t, 24) & 4278255360;
        for (var n = 0; n < t.length; n++)
          t[n] = e.endian(t[n]);
        return t;
      },
      // Generate an array of any length of random bytes
      randomBytes: function(t) {
        for (var n = []; t > 0; t--)
          n.push(Math.floor(Math.random() * 256));
        return n;
      },
      // Convert a byte array to big-endian 32-bit words
      bytesToWords: function(t) {
        for (var n = [], i = 0, s = 0; i < t.length; i++, s += 8)
          n[s >>> 5] |= t[i] << 24 - s % 32;
        return n;
      },
      // Convert big-endian 32-bit words to a byte array
      wordsToBytes: function(t) {
        for (var n = [], i = 0; i < t.length * 32; i += 8)
          n.push(t[i >>> 5] >>> 24 - i % 32 & 255);
        return n;
      },
      // Convert a byte array to a hex string
      bytesToHex: function(t) {
        for (var n = [], i = 0; i < t.length; i++)
          n.push((t[i] >>> 4).toString(16)), n.push((t[i] & 15).toString(16));
        return n.join("");
      },
      // Convert a hex string to a byte array
      hexToBytes: function(t) {
        for (var n = [], i = 0; i < t.length; i += 2)
          n.push(parseInt(t.substr(i, 2), 16));
        return n;
      },
      // Convert a byte array to a base-64 string
      bytesToBase64: function(t) {
        for (var n = [], i = 0; i < t.length; i += 3)
          for (var s = t[i] << 16 | t[i + 1] << 8 | t[i + 2], o = 0; o < 4; o++)
            i * 8 + o * 6 <= t.length * 8 ? n.push(r.charAt(s >>> 6 * (3 - o) & 63)) : n.push("=");
        return n.join("");
      },
      // Convert a base-64 string to a byte array
      base64ToBytes: function(t) {
        t = t.replace(/[^A-Z0-9+\/]/ig, "");
        for (var n = [], i = 0, s = 0; i < t.length; s = ++i % 4)
          s != 0 && n.push((r.indexOf(t.charAt(i - 1)) & Math.pow(2, -2 * s + 8) - 1) << s * 2 | r.indexOf(t.charAt(i)) >>> 6 - s * 2);
        return n;
      }
    };
    S1.exports = e;
  }()), Hi;
}
var To, _c;
function Mc() {
  if (_c)
    return To;
  _c = 1;
  var r = {
    // UTF-8 encoding
    utf8: {
      // Convert a string to a byte array
      stringToBytes: function(e) {
        return r.bin.stringToBytes(unescape(encodeURIComponent(e)));
      },
      // Convert a byte array to a string
      bytesToString: function(e) {
        return decodeURIComponent(escape(r.bin.bytesToString(e)));
      }
    },
    // Binary encoding
    bin: {
      // Convert a string to a byte array
      stringToBytes: function(e) {
        for (var t = [], n = 0; n < e.length; n++)
          t.push(e.charCodeAt(n) & 255);
        return t;
      },
      // Convert a byte array to a string
      bytesToString: function(e) {
        for (var t = [], n = 0; n < e.length; n++)
          t.push(String.fromCharCode(e[n]));
        return t.join("");
      }
    }
  };
  return To = r, To;
}
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
var Ao, Yc;
function g1() {
  if (Yc)
    return Ao;
  Yc = 1, Ao = function(t) {
    return t != null && (r(t) || e(t) || !!t._isBuffer);
  };
  function r(t) {
    return !!t.constructor && typeof t.constructor.isBuffer == "function" && t.constructor.isBuffer(t);
  }
  function e(t) {
    return typeof t.readFloatLE == "function" && typeof t.slice == "function" && r(t.slice(0, 0));
  }
  return Ao;
}
var Ic;
function R1() {
  return Ic || (Ic = 1, function() {
    var r = D1(), e = Mc().utf8, t = g1(), n = Mc().bin, i = function(s, o) {
      s.constructor == String ? o && o.encoding === "binary" ? s = n.stringToBytes(s) : s = e.stringToBytes(s) : t(s) ? s = Array.prototype.slice.call(s, 0) : !Array.isArray(s) && s.constructor !== Uint8Array && (s = s.toString());
      for (var l = r.bytesToWords(s), a = s.length * 8, c = 1732584193, T = -271733879, u = -1732584194, d = 271733878, A = 0; A < l.length; A++)
        l[A] = (l[A] << 8 | l[A] >>> 24) & 16711935 | (l[A] << 24 | l[A] >>> 8) & 4278255360;
      l[a >>> 5] |= 128 << a % 32, l[(a + 64 >>> 9 << 4) + 14] = a;
      for (var f = i._ff, h = i._gg, S = i._hh, p = i._ii, A = 0; A < l.length; A += 16) {
        var m = c, g = T, N = u, R = d;
        c = f(c, T, u, d, l[A + 0], 7, -680876936), d = f(d, c, T, u, l[A + 1], 12, -389564586), u = f(u, d, c, T, l[A + 2], 17, 606105819), T = f(T, u, d, c, l[A + 3], 22, -1044525330), c = f(c, T, u, d, l[A + 4], 7, -176418897), d = f(d, c, T, u, l[A + 5], 12, 1200080426), u = f(u, d, c, T, l[A + 6], 17, -1473231341), T = f(T, u, d, c, l[A + 7], 22, -45705983), c = f(c, T, u, d, l[A + 8], 7, 1770035416), d = f(d, c, T, u, l[A + 9], 12, -1958414417), u = f(u, d, c, T, l[A + 10], 17, -42063), T = f(T, u, d, c, l[A + 11], 22, -1990404162), c = f(c, T, u, d, l[A + 12], 7, 1804603682), d = f(d, c, T, u, l[A + 13], 12, -40341101), u = f(u, d, c, T, l[A + 14], 17, -1502002290), T = f(T, u, d, c, l[A + 15], 22, 1236535329), c = h(c, T, u, d, l[A + 1], 5, -165796510), d = h(d, c, T, u, l[A + 6], 9, -1069501632), u = h(u, d, c, T, l[A + 11], 14, 643717713), T = h(T, u, d, c, l[A + 0], 20, -373897302), c = h(c, T, u, d, l[A + 5], 5, -701558691), d = h(d, c, T, u, l[A + 10], 9, 38016083), u = h(u, d, c, T, l[A + 15], 14, -660478335), T = h(T, u, d, c, l[A + 4], 20, -405537848), c = h(c, T, u, d, l[A + 9], 5, 568446438), d = h(d, c, T, u, l[A + 14], 9, -1019803690), u = h(u, d, c, T, l[A + 3], 14, -187363961), T = h(T, u, d, c, l[A + 8], 20, 1163531501), c = h(c, T, u, d, l[A + 13], 5, -1444681467), d = h(d, c, T, u, l[A + 2], 9, -51403784), u = h(u, d, c, T, l[A + 7], 14, 1735328473), T = h(T, u, d, c, l[A + 12], 20, -1926607734), c = S(c, T, u, d, l[A + 5], 4, -378558), d = S(d, c, T, u, l[A + 8], 11, -2022574463), u = S(u, d, c, T, l[A + 11], 16, 1839030562), T = S(T, u, d, c, l[A + 14], 23, -35309556), c = S(c, T, u, d, l[A + 1], 4, -1530992060), d = S(d, c, T, u, l[A + 4], 11, 1272893353), u = S(u, d, c, T, l[A + 7], 16, -155497632), T = S(T, u, d, c, l[A + 10], 23, -1094730640), c = S(c, T, u, d, l[A + 13], 4, 681279174), d = S(d, c, T, u, l[A + 0], 11, -358537222), u = S(u, d, c, T, l[A + 3], 16, -722521979), T = S(T, u, d, c, l[A + 6], 23, 76029189), c = S(c, T, u, d, l[A + 9], 4, -640364487), d = S(d, c, T, u, l[A + 12], 11, -421815835), u = S(u, d, c, T, l[A + 15], 16, 530742520), T = S(T, u, d, c, l[A + 2], 23, -995338651), c = p(c, T, u, d, l[A + 0], 6, -198630844), d = p(d, c, T, u, l[A + 7], 10, 1126891415), u = p(u, d, c, T, l[A + 14], 15, -1416354905), T = p(T, u, d, c, l[A + 5], 21, -57434055), c = p(c, T, u, d, l[A + 12], 6, 1700485571), d = p(d, c, T, u, l[A + 3], 10, -1894986606), u = p(u, d, c, T, l[A + 10], 15, -1051523), T = p(T, u, d, c, l[A + 1], 21, -2054922799), c = p(c, T, u, d, l[A + 8], 6, 1873313359), d = p(d, c, T, u, l[A + 15], 10, -30611744), u = p(u, d, c, T, l[A + 6], 15, -1560198380), T = p(T, u, d, c, l[A + 13], 21, 1309151649), c = p(c, T, u, d, l[A + 4], 6, -145523070), d = p(d, c, T, u, l[A + 11], 10, -1120210379), u = p(u, d, c, T, l[A + 2], 15, 718787259), T = p(T, u, d, c, l[A + 9], 21, -343485551), c = c + m >>> 0, T = T + g >>> 0, u = u + N >>> 0, d = d + R >>> 0;
      }
      return r.endian([c, T, u, d]);
    };
    i._ff = function(s, o, l, a, c, T, u) {
      var d = s + (o & l | ~o & a) + (c >>> 0) + u;
      return (d << T | d >>> 32 - T) + o;
    }, i._gg = function(s, o, l, a, c, T, u) {
      var d = s + (o & a | l & ~a) + (c >>> 0) + u;
      return (d << T | d >>> 32 - T) + o;
    }, i._hh = function(s, o, l, a, c, T, u) {
      var d = s + (o ^ l ^ a) + (c >>> 0) + u;
      return (d << T | d >>> 32 - T) + o;
    }, i._ii = function(s, o, l, a, c, T, u) {
      var d = s + (l ^ (o | ~a)) + (c >>> 0) + u;
      return (d << T | d >>> 32 - T) + o;
    }, i._blocksize = 16, i._digestsize = 16, E1.exports = function(s, o) {
      if (s == null)
        throw new Error("Illegal argument " + s);
      var l = r.wordsToBytes(i(s, o));
      return o && o.asBytes ? l : o && o.asString ? n.bytesToString(l) : r.bytesToHex(l);
    };
  }()), Ui;
}
var Di = {}, gi = {}, Bc = {}, fo, Zc;
function ot() {
  if (Zc)
    return fo;
  Zc = 1;
  var r = function(e) {
    return e && e.Math == Math && e;
  };
  return fo = // eslint-disable-next-line es/no-global-this -- safe
  r(typeof globalThis == "object" && globalThis) || r(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
  r(typeof self == "object" && self) || r(typeof nr == "object" && nr) || // eslint-disable-next-line no-new-func -- fallback
  function() {
    return this;
  }() || Function("return this")(), fo;
}
var po = {}, ho, wc;
function $e() {
  return wc || (wc = 1, ho = function(r) {
    try {
      return !!r();
    } catch {
      return !0;
    }
  }), ho;
}
var mo, xc;
function Rt() {
  if (xc)
    return mo;
  xc = 1;
  var r = $e();
  return mo = !r(function() {
    return Object.defineProperty({}, 1, { get: function() {
      return 7;
    } })[1] != 7;
  }), mo;
}
var Eo, Lc;
function Ca() {
  if (Lc)
    return Eo;
  Lc = 1;
  var r = $e();
  return Eo = !r(function() {
    var e = function() {
    }.bind();
    return typeof e != "function" || e.hasOwnProperty("prototype");
  }), Eo;
}
var So, kc;
function It() {
  if (kc)
    return So;
  kc = 1;
  var r = Ca(), e = Function.prototype.call;
  return So = r ? e.bind(e) : function() {
    return e.apply(e, arguments);
  }, So;
}
var Do = {}, Pc;
function Su() {
  if (Pc)
    return Do;
  Pc = 1;
  var r = {}.propertyIsEnumerable, e = Object.getOwnPropertyDescriptor, t = e && !r.call({ 1: 2 }, 1);
  return Do.f = t ? function(i) {
    var s = e(this, i);
    return !!s && s.enumerable;
  } : r, Do;
}
var go, Gc;
function oi() {
  return Gc || (Gc = 1, go = function(r, e) {
    return {
      enumerable: !(r & 1),
      configurable: !(r & 2),
      writable: !(r & 4),
      value: e
    };
  }), go;
}
var Ro, Uc;
function Th() {
  if (Uc)
    return Ro;
  Uc = 1;
  var r = Ca(), e = Function.prototype, t = e.call, n = r && e.bind.bind(t, t);
  return Ro = function(i) {
    return r ? n(i) : function() {
      return t.apply(i, arguments);
    };
  }, Ro;
}
var vo, Hc;
function qr() {
  if (Hc)
    return vo;
  Hc = 1;
  var r = Th(), e = r({}.toString), t = r("".slice);
  return vo = function(n) {
    return t(e(n), 8, -1);
  }, vo;
}
var No, jc;
function Ve() {
  if (jc)
    return No;
  jc = 1;
  var r = qr(), e = Th();
  return No = function(t) {
    if (r(t) === "Function")
      return e(t);
  }, No;
}
var Fo, zc;
function Du() {
  if (zc)
    return Fo;
  zc = 1;
  var r = Ve(), e = $e(), t = qr(), n = Object, i = r("".split);
  return Fo = e(function() {
    return !n("z").propertyIsEnumerable(0);
  }) ? function(s) {
    return t(s) == "String" ? i(s, "") : n(s);
  } : n, Fo;
}
var Oo, $c;
function gu() {
  return $c || ($c = 1, Oo = function(r) {
    return r == null;
  }), Oo;
}
var yo, Vc;
function Rn() {
  if (Vc)
    return yo;
  Vc = 1;
  var r = gu(), e = TypeError;
  return yo = function(t) {
    if (r(t))
      throw e("Can't call method on " + t);
    return t;
  }, yo;
}
var bo, qc;
function Wr() {
  if (qc)
    return bo;
  qc = 1;
  var r = Du(), e = Rn();
  return bo = function(t) {
    return r(e(t));
  }, bo;
}
var Co, Wc;
function dh() {
  if (Wc)
    return Co;
  Wc = 1;
  var r = typeof document == "object" && document.all, e = typeof r > "u" && r !== void 0;
  return Co = {
    all: r,
    IS_HTMLDDA: e
  }, Co;
}
var _o, Qc;
function Ke() {
  if (Qc)
    return _o;
  Qc = 1;
  var r = dh(), e = r.all;
  return _o = r.IS_HTMLDDA ? function(t) {
    return typeof t == "function" || t === e;
  } : function(t) {
    return typeof t == "function";
  }, _o;
}
var Mo, Kc;
function Gt() {
  if (Kc)
    return Mo;
  Kc = 1;
  var r = Ke(), e = dh(), t = e.all;
  return Mo = e.IS_HTMLDDA ? function(n) {
    return typeof n == "object" ? n !== null : r(n) || n === t;
  } : function(n) {
    return typeof n == "object" ? n !== null : r(n);
  }, Mo;
}
var Yo, Jc;
function Or() {
  if (Jc)
    return Yo;
  Jc = 1;
  var r = ot(), e = Ke(), t = function(n) {
    return e(n) ? n : void 0;
  };
  return Yo = function(n, i) {
    return arguments.length < 2 ? t(r[n]) : r[n] && r[n][i];
  }, Yo;
}
var Io, Xc;
function si() {
  if (Xc)
    return Io;
  Xc = 1;
  var r = Ve();
  return Io = r({}.isPrototypeOf), Io;
}
var Bo, eT;
function v1() {
  if (eT)
    return Bo;
  eT = 1;
  var r = Or();
  return Bo = r("navigator", "userAgent") || "", Bo;
}
var Zo, tT;
function Ru() {
  if (tT)
    return Zo;
  tT = 1;
  var r = ot(), e = v1(), t = r.process, n = r.Deno, i = t && t.versions || n && n.version, s = i && i.v8, o, l;
  return s && (o = s.split("."), l = o[0] > 0 && o[0] < 4 ? 1 : +(o[0] + o[1])), !l && e && (o = e.match(/Edge\/(\d+)/), (!o || o[1] >= 74) && (o = e.match(/Chrome\/(\d+)/), o && (l = +o[1]))), Zo = l, Zo;
}
var wo, rT;
function vn() {
  if (rT)
    return wo;
  rT = 1;
  var r = Ru(), e = $e();
  return wo = !!Object.getOwnPropertySymbols && !e(function() {
    var t = Symbol();
    return !String(t) || !(Object(t) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && r && r < 41;
  }), wo;
}
var xo, nT;
function Ah() {
  if (nT)
    return xo;
  nT = 1;
  var r = vn();
  return xo = r && !Symbol.sham && typeof Symbol.iterator == "symbol", xo;
}
var Lo, iT;
function li() {
  if (iT)
    return Lo;
  iT = 1;
  var r = Or(), e = Ke(), t = si(), n = Ah(), i = Object;
  return Lo = n ? function(s) {
    return typeof s == "symbol";
  } : function(s) {
    var o = r("Symbol");
    return e(o) && t(o.prototype, i(s));
  }, Lo;
}
var ko, aT;
function fh() {
  if (aT)
    return ko;
  aT = 1;
  var r = String;
  return ko = function(e) {
    try {
      return r(e);
    } catch {
      return "Object";
    }
  }, ko;
}
var Po, oT;
function ph() {
  if (oT)
    return Po;
  oT = 1;
  var r = Ke(), e = fh(), t = TypeError;
  return Po = function(n) {
    if (r(n))
      return n;
    throw t(e(n) + " is not a function");
  }, Po;
}
var Go, sT;
function hh() {
  if (sT)
    return Go;
  sT = 1;
  var r = ph(), e = gu();
  return Go = function(t, n) {
    var i = t[n];
    return e(i) ? void 0 : r(i);
  }, Go;
}
var Uo, lT;
function mh() {
  if (lT)
    return Uo;
  lT = 1;
  var r = It(), e = Ke(), t = Gt(), n = TypeError;
  return Uo = function(i, s) {
    var o, l;
    if (s === "string" && e(o = i.toString) && !t(l = r(o, i)) || e(o = i.valueOf) && !t(l = r(o, i)) || s !== "string" && e(o = i.toString) && !t(l = r(o, i)))
      return l;
    throw n("Can't convert object to primitive value");
  }, Uo;
}
var ji = {}, N1 = {
  get exports() {
    return ji;
  },
  set exports(r) {
    ji = r;
  }
}, Ho, uT;
function Nn() {
  return uT || (uT = 1, Ho = !1), Ho;
}
var jo, cT;
function vu() {
  if (cT)
    return jo;
  cT = 1;
  var r = ot(), e = Object.defineProperty;
  return jo = function(t, n) {
    try {
      e(r, t, { value: n, configurable: !0, writable: !0 });
    } catch {
      r[t] = n;
    }
    return n;
  }, jo;
}
var zo, TT;
function Nu() {
  if (TT)
    return zo;
  TT = 1;
  var r = ot(), e = vu(), t = "__core-js_shared__", n = r[t] || e(t, {});
  return zo = n, zo;
}
var dT;
function Fn() {
  if (dT)
    return ji;
  dT = 1;
  var r = Nn(), e = Nu();
  return (N1.exports = function(t, n) {
    return e[t] || (e[t] = n !== void 0 ? n : {});
  })("versions", []).push({
    version: "3.25.5",
    mode: r ? "pure" : "global",
    copyright: "© 2014-2022 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.25.5/LICENSE",
    source: "https://github.com/zloirock/core-js"
  }), ji;
}
var $o, AT;
function yr() {
  if (AT)
    return $o;
  AT = 1;
  var r = Rn(), e = Object;
  return $o = function(t) {
    return e(r(t));
  }, $o;
}
var Vo, fT;
function st() {
  if (fT)
    return Vo;
  fT = 1;
  var r = Ve(), e = yr(), t = r({}.hasOwnProperty);
  return Vo = Object.hasOwn || function(i, s) {
    return t(e(i), s);
  }, Vo;
}
var qo, pT;
function Fu() {
  if (pT)
    return qo;
  pT = 1;
  var r = Ve(), e = 0, t = Math.random(), n = r(1 .toString);
  return qo = function(i) {
    return "Symbol(" + (i === void 0 ? "" : i) + ")_" + n(++e + t, 36);
  }, qo;
}
var Wo, hT;
function Je() {
  if (hT)
    return Wo;
  hT = 1;
  var r = ot(), e = Fn(), t = st(), n = Fu(), i = vn(), s = Ah(), o = e("wks"), l = r.Symbol, a = l && l.for, c = s ? l : l && l.withoutSetter || n;
  return Wo = function(T) {
    if (!t(o, T) || !(i || typeof o[T] == "string")) {
      var u = "Symbol." + T;
      i && t(l, T) ? o[T] = l[T] : s && a ? o[T] = a(u) : o[T] = c(u);
    }
    return o[T];
  }, Wo;
}
var Qo, mT;
function Eh() {
  if (mT)
    return Qo;
  mT = 1;
  var r = It(), e = Gt(), t = li(), n = hh(), i = mh(), s = Je(), o = TypeError, l = s("toPrimitive");
  return Qo = function(a, c) {
    if (!e(a) || t(a))
      return a;
    var T = n(a, l), u;
    if (T) {
      if (c === void 0 && (c = "default"), u = r(T, a, c), !e(u) || t(u))
        return u;
      throw o("Can't convert object to primitive value");
    }
    return c === void 0 && (c = "number"), i(a, c);
  }, Qo;
}
var Ko, ET;
function _a() {
  if (ET)
    return Ko;
  ET = 1;
  var r = Eh(), e = li();
  return Ko = function(t) {
    var n = r(t, "string");
    return e(n) ? n : n + "";
  }, Ko;
}
var Jo, ST;
function Ou() {
  if (ST)
    return Jo;
  ST = 1;
  var r = ot(), e = Gt(), t = r.document, n = e(t) && e(t.createElement);
  return Jo = function(i) {
    return n ? t.createElement(i) : {};
  }, Jo;
}
var Xo, DT;
function Sh() {
  if (DT)
    return Xo;
  DT = 1;
  var r = Rt(), e = $e(), t = Ou();
  return Xo = !r && !e(function() {
    return Object.defineProperty(t("div"), "a", {
      get: function() {
        return 7;
      }
    }).a != 7;
  }), Xo;
}
var gT;
function ui() {
  if (gT)
    return po;
  gT = 1;
  var r = Rt(), e = It(), t = Su(), n = oi(), i = Wr(), s = _a(), o = st(), l = Sh(), a = Object.getOwnPropertyDescriptor;
  return po.f = r ? a : function(T, u) {
    if (T = i(T), u = s(u), l)
      try {
        return a(T, u);
      } catch {
      }
    if (o(T, u))
      return n(!e(t.f, T, u), T[u]);
  }, po;
}
var e0 = {}, t0, RT;
function Dh() {
  if (RT)
    return t0;
  RT = 1;
  var r = Rt(), e = $e();
  return t0 = r && e(function() {
    return Object.defineProperty(function() {
    }, "prototype", {
      value: 42,
      writable: !1
    }).prototype != 42;
  }), t0;
}
var r0, vT;
function Ut() {
  if (vT)
    return r0;
  vT = 1;
  var r = Gt(), e = String, t = TypeError;
  return r0 = function(n) {
    if (r(n))
      return n;
    throw t(e(n) + " is not an object");
  }, r0;
}
var NT;
function bt() {
  if (NT)
    return e0;
  NT = 1;
  var r = Rt(), e = Sh(), t = Dh(), n = Ut(), i = _a(), s = TypeError, o = Object.defineProperty, l = Object.getOwnPropertyDescriptor, a = "enumerable", c = "configurable", T = "writable";
  return e0.f = r ? t ? function(d, A, f) {
    if (n(d), A = i(A), n(f), typeof d == "function" && A === "prototype" && "value" in f && T in f && !f[T]) {
      var h = l(d, A);
      h && h[T] && (d[A] = f.value, f = {
        configurable: c in f ? f[c] : h[c],
        enumerable: a in f ? f[a] : h[a],
        writable: !1
      });
    }
    return o(d, A, f);
  } : o : function(d, A, f) {
    if (n(d), A = i(A), n(f), e)
      try {
        return o(d, A, f);
      } catch {
      }
    if ("get" in f || "set" in f)
      throw s("Accessors not supported");
    return "value" in f && (d[A] = f.value), d;
  }, e0;
}
var n0, FT;
function ci() {
  if (FT)
    return n0;
  FT = 1;
  var r = Rt(), e = bt(), t = oi();
  return n0 = r ? function(n, i, s) {
    return e.f(n, i, t(1, s));
  } : function(n, i, s) {
    return n[i] = s, n;
  }, n0;
}
var zi = {}, F1 = {
  get exports() {
    return zi;
  },
  set exports(r) {
    zi = r;
  }
}, i0, OT;
function yu() {
  if (OT)
    return i0;
  OT = 1;
  var r = Rt(), e = st(), t = Function.prototype, n = r && Object.getOwnPropertyDescriptor, i = e(t, "name"), s = i && function() {
  }.name === "something", o = i && (!r || r && n(t, "name").configurable);
  return i0 = {
    EXISTS: i,
    PROPER: s,
    CONFIGURABLE: o
  }, i0;
}
var a0, yT;
function gh() {
  if (yT)
    return a0;
  yT = 1;
  var r = Ve(), e = Ke(), t = Nu(), n = r(Function.toString);
  return e(t.inspectSource) || (t.inspectSource = function(i) {
    return n(i);
  }), a0 = t.inspectSource, a0;
}
var o0, bT;
function O1() {
  if (bT)
    return o0;
  bT = 1;
  var r = ot(), e = Ke(), t = r.WeakMap;
  return o0 = e(t) && /native code/.test(String(t)), o0;
}
var s0, CT;
function Ma() {
  if (CT)
    return s0;
  CT = 1;
  var r = Fn(), e = Fu(), t = r("keys");
  return s0 = function(n) {
    return t[n] || (t[n] = e(n));
  }, s0;
}
var l0, _T;
function Ya() {
  return _T || (_T = 1, l0 = {}), l0;
}
var u0, MT;
function Ti() {
  if (MT)
    return u0;
  MT = 1;
  var r = O1(), e = ot(), t = Gt(), n = ci(), i = st(), s = Nu(), o = Ma(), l = Ya(), a = "Object already initialized", c = e.TypeError, T = e.WeakMap, u, d, A, f = function(m) {
    return A(m) ? d(m) : u(m, {});
  }, h = function(m) {
    return function(g) {
      var N;
      if (!t(g) || (N = d(g)).type !== m)
        throw c("Incompatible receiver, " + m + " required");
      return N;
    };
  };
  if (r || s.state) {
    var S = s.state || (s.state = new T());
    S.get = S.get, S.has = S.has, S.set = S.set, u = function(m, g) {
      if (S.has(m))
        throw c(a);
      return g.facade = m, S.set(m, g), g;
    }, d = function(m) {
      return S.get(m) || {};
    }, A = function(m) {
      return S.has(m);
    };
  } else {
    var p = o("state");
    l[p] = !0, u = function(m, g) {
      if (i(m, p))
        throw c(a);
      return g.facade = m, n(m, p, g), g;
    }, d = function(m) {
      return i(m, p) ? m[p] : {};
    }, A = function(m) {
      return i(m, p);
    };
  }
  return u0 = {
    set: u,
    get: d,
    has: A,
    enforce: f,
    getterFor: h
  }, u0;
}
var YT;
function y1() {
  if (YT)
    return zi;
  YT = 1;
  var r = $e(), e = Ke(), t = st(), n = Rt(), i = yu().CONFIGURABLE, s = gh(), o = Ti(), l = o.enforce, a = o.get, c = Object.defineProperty, T = n && !r(function() {
    return c(function() {
    }, "length", { value: 8 }).length !== 8;
  }), u = String(String).split("String"), d = F1.exports = function(A, f, h) {
    String(f).slice(0, 7) === "Symbol(" && (f = "[" + String(f).replace(/^Symbol\(([^)]*)\)/, "$1") + "]"), h && h.getter && (f = "get " + f), h && h.setter && (f = "set " + f), (!t(A, "name") || i && A.name !== f) && (n ? c(A, "name", { value: f, configurable: !0 }) : A.name = f), T && h && t(h, "arity") && A.length !== h.arity && c(A, "length", { value: h.arity });
    try {
      h && t(h, "constructor") && h.constructor ? n && c(A, "prototype", { writable: !1 }) : A.prototype && (A.prototype = void 0);
    } catch {
    }
    var S = l(A);
    return t(S, "source") || (S.source = u.join(typeof f == "string" ? f : "")), A;
  };
  return Function.prototype.toString = d(function() {
    return e(this) && a(this).source || s(this);
  }, "toString"), zi;
}
var c0, IT;
function Qt() {
  if (IT)
    return c0;
  IT = 1;
  var r = Ke(), e = bt(), t = y1(), n = vu();
  return c0 = function(i, s, o, l) {
    l || (l = {});
    var a = l.enumerable, c = l.name !== void 0 ? l.name : s;
    if (r(o) && t(o, c, l), l.global)
      a ? i[s] = o : n(s, o);
    else {
      try {
        l.unsafe ? i[s] && (a = !0) : delete i[s];
      } catch {
      }
      a ? i[s] = o : e.f(i, s, {
        value: o,
        enumerable: !1,
        configurable: !l.nonConfigurable,
        writable: !l.nonWritable
      });
    }
    return i;
  }, c0;
}
var T0 = {}, d0, BT;
function b1() {
  if (BT)
    return d0;
  BT = 1;
  var r = Math.ceil, e = Math.floor;
  return d0 = Math.trunc || function(n) {
    var i = +n;
    return (i > 0 ? e : r)(i);
  }, d0;
}
var A0, ZT;
function Ia() {
  if (ZT)
    return A0;
  ZT = 1;
  var r = b1();
  return A0 = function(e) {
    var t = +e;
    return t !== t || t === 0 ? 0 : r(t);
  }, A0;
}
var f0, wT;
function Rh() {
  if (wT)
    return f0;
  wT = 1;
  var r = Ia(), e = Math.max, t = Math.min;
  return f0 = function(n, i) {
    var s = r(n);
    return s < 0 ? e(s + i, 0) : t(s, i);
  }, f0;
}
var p0, xT;
function bu() {
  if (xT)
    return p0;
  xT = 1;
  var r = Ia(), e = Math.min;
  return p0 = function(t) {
    return t > 0 ? e(r(t), 9007199254740991) : 0;
  }, p0;
}
var h0, LT;
function Ba() {
  if (LT)
    return h0;
  LT = 1;
  var r = bu();
  return h0 = function(e) {
    return r(e.length);
  }, h0;
}
var m0, kT;
function C1() {
  if (kT)
    return m0;
  kT = 1;
  var r = Wr(), e = Rh(), t = Ba(), n = function(i) {
    return function(s, o, l) {
      var a = r(s), c = t(a), T = e(l, c), u;
      if (i && o != o) {
        for (; c > T; )
          if (u = a[T++], u != u)
            return !0;
      } else
        for (; c > T; T++)
          if ((i || T in a) && a[T] === o)
            return i || T || 0;
      return !i && -1;
    };
  };
  return m0 = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: n(!0),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: n(!1)
  }, m0;
}
var E0, PT;
function vh() {
  if (PT)
    return E0;
  PT = 1;
  var r = Ve(), e = st(), t = Wr(), n = C1().indexOf, i = Ya(), s = r([].push);
  return E0 = function(o, l) {
    var a = t(o), c = 0, T = [], u;
    for (u in a)
      !e(i, u) && e(a, u) && s(T, u);
    for (; l.length > c; )
      e(a, u = l[c++]) && (~n(T, u) || s(T, u));
    return T;
  }, E0;
}
var S0, GT;
function Cu() {
  return GT || (GT = 1, S0 = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
  ]), S0;
}
var UT;
function Za() {
  if (UT)
    return T0;
  UT = 1;
  var r = vh(), e = Cu(), t = e.concat("length", "prototype");
  return T0.f = Object.getOwnPropertyNames || function(i) {
    return r(i, t);
  }, T0;
}
var D0 = {}, HT;
function wa() {
  return HT || (HT = 1, D0.f = Object.getOwnPropertySymbols), D0;
}
var g0, jT;
function _1() {
  if (jT)
    return g0;
  jT = 1;
  var r = Or(), e = Ve(), t = Za(), n = wa(), i = Ut(), s = e([].concat);
  return g0 = r("Reflect", "ownKeys") || function(l) {
    var a = t.f(i(l)), c = n.f;
    return c ? s(a, c(l)) : a;
  }, g0;
}
var R0, zT;
function Nh() {
  if (zT)
    return R0;
  zT = 1;
  var r = st(), e = _1(), t = ui(), n = bt();
  return R0 = function(i, s, o) {
    for (var l = e(s), a = n.f, c = t.f, T = 0; T < l.length; T++) {
      var u = l[T];
      !r(i, u) && !(o && r(o, u)) && a(i, u, c(s, u));
    }
  }, R0;
}
var v0, $T;
function Fh() {
  if ($T)
    return v0;
  $T = 1;
  var r = $e(), e = Ke(), t = /#|\.prototype\./, n = function(a, c) {
    var T = s[i(a)];
    return T == l ? !0 : T == o ? !1 : e(c) ? r(c) : !!c;
  }, i = n.normalize = function(a) {
    return String(a).replace(t, ".").toLowerCase();
  }, s = n.data = {}, o = n.NATIVE = "N", l = n.POLYFILL = "P";
  return v0 = n, v0;
}
var N0, VT;
function St() {
  if (VT)
    return N0;
  VT = 1;
  var r = ot(), e = ui().f, t = ci(), n = Qt(), i = vu(), s = Nh(), o = Fh();
  return N0 = function(l, a) {
    var c = l.target, T = l.global, u = l.stat, d, A, f, h, S, p;
    if (T ? A = r : u ? A = r[c] || i(c, {}) : A = (r[c] || {}).prototype, A)
      for (f in a) {
        if (S = a[f], l.dontCallGetSet ? (p = e(A, f), h = p && p.value) : h = A[f], d = o(T ? f : c + (u ? "." : "#") + f, l.forced), !d && h !== void 0) {
          if (typeof S == typeof h)
            continue;
          s(S, h);
        }
        (l.sham || h && h.sham) && t(S, "sham", !0), n(A, f, S, l);
      }
  }, N0;
}
var F0, qT;
function _u() {
  if (qT)
    return F0;
  qT = 1;
  var r = qr();
  return F0 = Array.isArray || function(t) {
    return r(t) == "Array";
  }, F0;
}
var O0, WT;
function M1() {
  if (WT)
    return O0;
  WT = 1;
  var r = TypeError, e = 9007199254740991;
  return O0 = function(t) {
    if (t > e)
      throw r("Maximum allowed index exceeded");
    return t;
  }, O0;
}
var y0, QT;
function Oh() {
  if (QT)
    return y0;
  QT = 1;
  var r = _a(), e = bt(), t = oi();
  return y0 = function(n, i, s) {
    var o = r(i);
    o in n ? e.f(n, o, t(0, s)) : n[o] = s;
  }, y0;
}
var b0, KT;
function Mu() {
  if (KT)
    return b0;
  KT = 1;
  var r = Je(), e = r("toStringTag"), t = {};
  return t[e] = "z", b0 = String(t) === "[object z]", b0;
}
var C0, JT;
function Yu() {
  if (JT)
    return C0;
  JT = 1;
  var r = Mu(), e = Ke(), t = qr(), n = Je(), i = n("toStringTag"), s = Object, o = t(function() {
    return arguments;
  }()) == "Arguments", l = function(a, c) {
    try {
      return a[c];
    } catch {
    }
  };
  return C0 = r ? t : function(a) {
    var c, T, u;
    return a === void 0 ? "Undefined" : a === null ? "Null" : typeof (T = l(c = s(a), i)) == "string" ? T : o ? t(c) : (u = t(c)) == "Object" && e(c.callee) ? "Arguments" : u;
  }, C0;
}
var _0, XT;
function Y1() {
  if (XT)
    return _0;
  XT = 1;
  var r = Ve(), e = $e(), t = Ke(), n = Yu(), i = Or(), s = gh(), o = function() {
  }, l = [], a = i("Reflect", "construct"), c = /^\s*(?:class|function)\b/, T = r(c.exec), u = !c.exec(o), d = function(h) {
    if (!t(h))
      return !1;
    try {
      return a(o, l, h), !0;
    } catch {
      return !1;
    }
  }, A = function(h) {
    if (!t(h))
      return !1;
    switch (n(h)) {
      case "AsyncFunction":
      case "GeneratorFunction":
      case "AsyncGeneratorFunction":
        return !1;
    }
    try {
      return u || !!T(c, s(h));
    } catch {
      return !0;
    }
  };
  return A.sham = !0, _0 = !a || e(function() {
    var f;
    return d(d.call) || !d(Object) || !d(function() {
      f = !0;
    }) || f;
  }) ? A : d, _0;
}
var M0, ed;
function I1() {
  if (ed)
    return M0;
  ed = 1;
  var r = _u(), e = Y1(), t = Gt(), n = Je(), i = n("species"), s = Array;
  return M0 = function(o) {
    var l;
    return r(o) && (l = o.constructor, e(l) && (l === s || r(l.prototype)) ? l = void 0 : t(l) && (l = l[i], l === null && (l = void 0))), l === void 0 ? s : l;
  }, M0;
}
var Y0, td;
function yh() {
  if (td)
    return Y0;
  td = 1;
  var r = I1();
  return Y0 = function(e, t) {
    return new (r(e))(t === 0 ? 0 : t);
  }, Y0;
}
var I0, rd;
function Iu() {
  if (rd)
    return I0;
  rd = 1;
  var r = $e(), e = Je(), t = Ru(), n = e("species");
  return I0 = function(i) {
    return t >= 51 || !r(function() {
      var s = [], o = s.constructor = {};
      return o[n] = function() {
        return { foo: 1 };
      }, s[i](Boolean).foo !== 1;
    });
  }, I0;
}
var nd;
function bh() {
  if (nd)
    return Bc;
  nd = 1;
  var r = St(), e = $e(), t = _u(), n = Gt(), i = yr(), s = Ba(), o = M1(), l = Oh(), a = yh(), c = Iu(), T = Je(), u = Ru(), d = T("isConcatSpreadable"), A = u >= 51 || !e(function() {
    var p = [];
    return p[d] = !1, p.concat()[0] !== p;
  }), f = c("concat"), h = function(p) {
    if (!n(p))
      return !1;
    var m = p[d];
    return m !== void 0 ? !!m : t(p);
  }, S = !A || !f;
  return r({ target: "Array", proto: !0, arity: 1, forced: S }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    concat: function(m) {
      var g = i(this), N = a(g, 0), R = 0, D, v, O, y, Z;
      for (D = -1, O = arguments.length; D < O; D++)
        if (Z = D === -1 ? g : arguments[D], h(Z))
          for (y = s(Z), o(R + y), v = 0; v < y; v++, R++)
            v in Z && l(N, R, Z[v]);
        else
          o(R + 1), l(N, R++, Z);
      return N.length = R, N;
    }
  }), Bc;
}
var id;
function B1() {
  if (id)
    return gi;
  id = 1, Object.defineProperty(gi, "__esModule", {
    value: !0
  }), gi.loadState = r, bh();
  function r(e, t, n) {
    var i = document.querySelector("#initial-state-".concat(e, "-").concat(t));
    if (i === null) {
      if (n !== void 0)
        return n;
      throw new Error("Could not find initial state ".concat(t, " of ").concat(e));
    }
    try {
      return JSON.parse(atob(i.value));
    } catch {
      throw new Error("Could not parse initial state ".concat(t, " of ").concat(e));
    }
  }
  return gi;
}
var ad;
function Z1() {
  if (ad)
    return Di;
  ad = 1, Object.defineProperty(Di, "__esModule", {
    value: !0
  }), Di.getCapabilities = e;
  var r = B1();
  function e() {
    try {
      return (0, r.loadState)("core", "capabilities");
    } catch {
      return console.debug("Could not find capabilities initial state fall back to _oc_capabilities"), "_oc_capabilities" in window ? window._oc_capabilities : {};
    }
  }
  return Di;
}
var $i = {}, w1 = {
  get exports() {
    return $i;
  },
  set exports(r) {
    $i = r;
  }
}, od;
function x1() {
  return od || (od = 1, function(r) {
    (function(e) {
      if (typeof t != "function") {
        var t = function(f) {
          return f;
        };
        t.nonNative = !0;
      }
      const n = t("plaintext"), i = t("html"), s = t("comment"), o = /<(\w*)>/g, l = /<\/?([^\s\/>]+)/;
      function a(f, h, S) {
        f = f || "", h = h || [], S = S || "";
        let p = T(h, S);
        return u(f, p);
      }
      function c(f, h) {
        f = f || [], h = h || "";
        let S = T(f, h);
        return function(m) {
          return u(m || "", S);
        };
      }
      a.init_streaming_mode = c;
      function T(f, h) {
        return f = d(f), {
          allowable_tags: f,
          tag_replacement: h,
          state: n,
          tag_buffer: "",
          depth: 0,
          in_quote_char: ""
        };
      }
      function u(f, h) {
        if (typeof f != "string")
          throw new TypeError("'html' parameter must be a string");
        let S = h.allowable_tags, p = h.tag_replacement, m = h.state, g = h.tag_buffer, N = h.depth, R = h.in_quote_char, D = "";
        for (let v = 0, O = f.length; v < O; v++) {
          let y = f[v];
          if (m === n)
            switch (y) {
              case "<":
                m = i, g += y;
                break;
              default:
                D += y;
                break;
            }
          else if (m === i)
            switch (y) {
              case "<":
                if (R)
                  break;
                N++;
                break;
              case ">":
                if (R)
                  break;
                if (N) {
                  N--;
                  break;
                }
                R = "", m = n, g += ">", S.has(A(g)) ? D += g : D += p, g = "";
                break;
              case '"':
              case "'":
                y === R ? R = "" : R = R || y, g += y;
                break;
              case "-":
                g === "<!-" && (m = s), g += y;
                break;
              case " ":
              case `
`:
                if (g === "<") {
                  m = n, D += "< ", g = "";
                  break;
                }
                g += y;
                break;
              default:
                g += y;
                break;
            }
          else if (m === s)
            switch (y) {
              case ">":
                g.slice(-2) == "--" && (m = n), g = "";
                break;
              default:
                g += y;
                break;
            }
        }
        return h.state = m, h.tag_buffer = g, h.depth = N, h.in_quote_char = R, D;
      }
      function d(f) {
        let h = /* @__PURE__ */ new Set();
        if (typeof f == "string") {
          let S;
          for (; S = o.exec(f); )
            h.add(S[1]);
        } else
          !t.nonNative && typeof f[t.iterator] == "function" ? h = new Set(f) : typeof f.forEach == "function" && f.forEach(h.add, h);
        return h;
      }
      function A(f) {
        let h = l.exec(f);
        return h ? h[1].toLowerCase() : null;
      }
      r.exports ? r.exports = a : e.striptags = a;
    })(nr);
  }(w1)), $i;
}
const L1 = "aaa1rp3barth4b_ott3vie4c1le2ogado5udhabi7c_ademy5centure6ountant_s9o1tor4d_s1ult4e_g1ro2tna4f_l1rica5g_akhan5ency5i_g1rbus3force5tel5kdn3l_faromeo7ibaba4pay4lfinanz6state5y2sace3tom5m_azon4ericanexpress7family11x2fam3ica3sterdam8nalytics7droid5quan4z2o_l2partments8p_le4q_uarelle8r_ab1mco4chi3my2pa2t_e3s_da2ia2sociates9t_hleta5torney7u_ction5di_ble3o3spost5thor3o_s4vianca6w_s2x_a2z_ure5ba_by2idu3namex3narepublic11d1k2r_celona5laycard4s5efoot5gains6seball5ketball8uhaus5yern5b_c1t1va3cg1n2d1e_ats2uty4er2ntley5rlin4st_buy5t2f1g1h_arti5i_ble3d1ke2ng_o3o1z2j1lack_friday9ockbuster8g1omberg7ue3m_s1w2n_pparibas9o_ats3ehringer8fa2m1nd2o_k_ing5sch2tik2on4t1utique6x2r_adesco6idgestone9oadway5ker3ther5ussels7s1t1uild_ers6siness6y1zz3v1w1y1z_h3ca_b1fe2l_l1vinklein9m_era3p2non3petown5ital_one8r_avan4ds2e_er_s4s2sa1e1h1ino4t_ering5holic7ba1n1re2s2c1d1enter4o1rn3f_a1d2g1h_anel2nel4rity4se2t2eap3intai5ristmas6ome4urch5i_priani6rcle4sco3tadel4i_c2y_eats7k1l_aims4eaning6ick2nic1que6othing5ud3ub_med6m1n1o_ach3des3ffee4llege4ogne5m_cast4mbank4unity6pany2re3uter5sec4ndos3struction8ulting7tact3ractors9oking_channel11l1p2rsica5untry4pon_s4rses6pa2r_edit_card4union9icket5own3s1uise_s6u_isinella9v1w1x1y_mru3ou3z2dabur3d1nce3ta1e1ing3sun4y2clk3ds2e_al_er2s3gree4livery5l1oitte5ta3mocrat6ntal2ist5si_gn4v2hl2iamonds6et2gital5rect_ory7scount3ver5h2y2j1k1m1np2o_cs1tor4g1mains5t1wnload7rive4tv2ubai3nlop4pont4rban5vag2r2z2earth3t2c_o2deka3u_cation8e1g1mail3erck5nergy4gineer_ing9terprises10pson4quipment8r_icsson6ni3s_q1tate5t_isalat7u_rovision8s2vents5xchange6pert3osed4ress5traspace10fage2il1rwinds6th3mily4n_s2rm_ers5shion4t3edex3edback6rrari3ero6i_at2delity5o2lm2nal1nce1ial7re_stone6mdale6sh_ing5t_ness6j1k1lickr3ghts4r2orist4wers5y2m1o_o_d_network8tball6rd1ex2sale4um3undation8x2r_ee1senius7l1ogans4ntdoor4ier7tr2ujitsu5n_d2rniture7tbol5yi3ga_l_lery3o1up4me_s3p1rden4y2b_iz3d_n2e_a1nt_ing5orge5f1g_ee3h1i_ft_s3ves2ing5l_ass3e1obal2o4m_ail3bh2o1x2n1odaddy5ld_point6f2o_dyear5g_le4p1t1v2p1q1r_ainger5phics5tis4een3ipe3ocery4up4s1t1u_ardian6cci3ge2ide2tars5ru3w1y2hair2mburg5ngout5us3bo2dfc_bank7ealth_care8lp1sinki6re1mes5gtv3iphop4samitsu7tachi5v2k_t2m1n1ockey4ldings5iday5medepot5goods5s_ense7nda3rse3spital5t_ing5t_eles2s3mail5use3w2r1sbc3t1u_ghes5yatt3undai7ibm2cbc2e1u2d1e_ee3fm2kano4l1m_amat4db2mo_bilien9n_c1dustries8finiti5o2g1k1stitute6urance4e4t_ernational10uit4vestments10o1piranga7q1r_ish4s_maili5t_anbul7t_au2v3jaguar4va3cb2e_ep2tzt3welry6io2ll2m_p2nj2o_bs1urg4t1y2p_morgan6rs3uegos4niper7kaufen5ddi3e_rryhotels6logistics9properties14fh2g1h1i_a1ds2m1nder2le4tchen5wi3m1n1oeln3matsu5sher5p_mg2n2r_d1ed3uokgroup8w1y_oto4z2la_caixa5mborghini8er3ncaster5ia3d_rover6xess5salle5t_ino3robe5w_yer5b1c1ds2ease3clerc5frak4gal2o2xus4gbt3i_dl2fe_insurance9style7ghting6ke2lly3mited4o2ncoln4de2k2psy3ve1ing5k1lc1p2oan_s3cker3us3l1ndon4tte1o3ve3pl_financial11r1s1t_d_a3u_ndbeck6xe1ury5v1y2ma_cys3drid4if1son4keup4n_agement7go3p1rket_ing3s4riott5shalls7serati6ttel5ba2c_kinsey7d1e_d_ia3et2lbourne7me1orial6n_u2rckmsd7g1h1iami3crosoft7l1ni1t2t_subishi9k1l_b1s2m_a2n1o_bi_le4da2e1i1m1nash3ey2ster5rmon3tgage6scow4to_rcycles9v_ie4p1q1r1s_d2t_n1r2u_seum3ic3tual5v1w1x1y1z2na_b1goya4me2tura4vy3ba2c1e_c1t_bank4flix4work5ustar5w_s2xt_direct7us4f_l2g_o2hk2i_co2ke1on3nja3ssan1y5l1o_kia3rthwesternmutual14on4w_ruz3tv4p1r_a1w2tt2u1yc2z2obi1server7ffice5kinawa6layan_group9dnavy5lo3m_ega4ne1g1l_ine5oo2pen3racle3nge4g_anic5igins6saka4tsuka4t2vh3pa_ge2nasonic7ris2s1tners4s1y3ssagens7y2ccw3e_t2f_izer5g1h_armacy6d1ilips5one2to_graphy6s4ysio5ics1tet2ures6d1n_g1k2oneer5zza4k1l_ace2y_station9umbing5s3m1n_c2ohl2ker3litie5rn2st3r_america6xi3ess3ime3o_d_uctions8f1gressive8mo2perties3y5tection8u_dential9s1t1ub2w_c2y2qa1pon3uebec3st5racing4dio4e_ad1lestate6tor2y4cipes5d_stone5umbrella9hab3ise_n3t2liance6n_t_als5pair3ort3ublican8st_aurant8view_s5xroth6ich_ardli6oh3l1o1p2o_cher3ks3deo3gers4om3s_vp3u_gby3hr2n2w_e2yukyu6sa_arland6fe_ty4kura4le1on3msclub4ung5ndvik_coromant12ofi4p1rl2s1ve2xo3b_i1s2c_a1b1haeffler7midt4olarships8ol3ule3warz5ience5ot3d1e_arch3t2cure1ity6ek2lect4ner3rvices6ven3w1x_y3fr2g1h_angrila6rp2w2ell3ia1ksha5oes2p_ping5uji3w_time7i_lk2na1gles5te3j1k_i_n2y_pe4l_ing4m_art3ile4n_cf3o_ccer3ial4ftbank4ware6hu2lar2utions7ng1y2y2pa_ce3ort2t3r_l2s1t_ada2ples4r1tebank4farm7c_group6ockholm6rage3e3ream4udio2y3yle4u_cks3pplies3y2ort5rf1gery5zuki5v1watch4iss4x1y_dney4stems6z2tab1ipei4lk2obao4rget4tamotors6r2too4x_i3c_i2d_k2eam2ch_nology8l1masek5nnis4va3f1g1h_d1eater2re6iaa2ckets5enda4ffany5ps2res2ol4j_maxx4x2k_maxx5l1m_all4n1o_day3kyo3ols3p1ray3shiba5tal3urs3wn2yota3s3r_ade1ing4ining5vel_channel7ers_insurance16ust3v2t1ube2i1nes3shu4v_s2w1z2ua1bank3s2g1k1nicom3versity8o2ol2ps2s1y1z2va_cations7na1guard7c1e_gas3ntures6risign5mögensberater2ung14sicherung10t2g1i_ajes4deo3g1king4llas4n1p1rgin4sa1ion4va1o3laanderen9n1odka3lkswagen7vo3te1ing3o2yage5u_elos6wales2mart4ter4ng_gou5tch_es6eather_channel12bcam3er2site5d_ding5ibo2r3f1hoswho6ien2ki2lliamhill9n_dows4e1ners6me2olterskluwer11odside6rk_s2ld3w2s1tc1f3xbox3erox4finity6ihuan4n2xx2yz3yachts4hoo3maxun5ndex5e1odobashi7ga2kohama6u_tube6t1un3za_ppos4ra3ero3ip2m1one3uerich6w2", k1 = "ελ1υ2бг1ел3дети4ею2католик6ом3мкд2он1сква6онлайн5рг3рус2ф2сайт3рб3укр3қаз3հայ3ישראל5קום3ابوظبي5تصالات6رامكو5لاردن4بحرين5جزائر5سعودية6عليان5مغرب5مارات5یران5بارت2زار4يتك3ھارت5تونس4سودان3رية5شبكة4عراق2ب2مان4فلسطين6قطر3كاثوليك6وم3مصر2ليسيا5وريتانيا7قع4همراه5پاکستان7ڀارت4कॉम3नेट3भारत_म्3ोत5संगठन5বাংলা5ভারত2ৰত4ਭਾਰਤ4ભારત4ଭାରତ4இந்தியா6லங்கை6சிங்கப்பூர்11భారత్5ಭಾರತ4ഭാരതം5ලංකා4คอม3ไทย3ລາວ3გე2みんな3アマゾン4クラウド4グーグル4コム2ストア3セール3ファッション6ポイント4世界2中信1国1國1文网3亚马逊3企业2佛山2信息2健康2八卦2公司1益2台湾1灣2商城1店1标2嘉里_大酒店5在线2大拿2天主教3娱乐2家電2广东2微博2慈善2我爱你3手机2招聘2政务1府2新加坡2闻2时尚2書籍2机构2淡马锡3游戏2澳門2点看2移动2组织机构4网址1店1站1络2联通2谷歌2购物2通販2集团2電訊盈科4飞利浦3食品2餐厅2香格里拉3港2닷넷1컴2삼성2한국2", Tn = (r, e) => {
  for (const t in e)
    r[t] = e[t];
  return r;
}, Pl = "numeric", Gl = "ascii", Ul = "alpha", Bi = "asciinumeric", Ri = "alphanumeric", Hl = "domain", Ch = "emoji", P1 = "scheme", G1 = "slashscheme", sd = "whitespace";
function U1(r, e) {
  return r in e || (e[r] = []), e[r];
}
function Pr(r, e, t) {
  e[Pl] && (e[Bi] = !0, e[Ri] = !0), e[Gl] && (e[Bi] = !0, e[Ul] = !0), e[Bi] && (e[Ri] = !0), e[Ul] && (e[Ri] = !0), e[Ri] && (e[Hl] = !0), e[Ch] && (e[Hl] = !0);
  for (const n in e) {
    const i = U1(n, t);
    i.indexOf(r) < 0 && i.push(r);
  }
}
function H1(r, e) {
  const t = {};
  for (const n in e)
    e[n].indexOf(r) >= 0 && (t[n] = !0);
  return t;
}
function Nt(r) {
  r === void 0 && (r = null), this.j = {}, this.jr = [], this.jd = null, this.t = r;
}
Nt.groups = {};
Nt.prototype = {
  accepts() {
    return !!this.t;
  },
  /**
   * Follow an existing transition from the given input to the next state.
   * Does not mutate.
   * @param {string} input character or token type to transition on
   * @returns {?State<T>} the next state, if any
   */
  go(r) {
    const e = this, t = e.j[r];
    if (t)
      return t;
    for (let n = 0; n < e.jr.length; n++) {
      const i = e.jr[n][0], s = e.jr[n][1];
      if (s && i.test(r))
        return s;
    }
    return e.jd;
  },
  /**
   * Whether the state has a transition for the given input. Set the second
   * argument to true to only look for an exact match (and not a default or
   * regular-expression-based transition)
   * @param {string} input
   * @param {boolean} exactOnly
   */
  has(r, e) {
    return e === void 0 && (e = !1), e ? r in this.j : !!this.go(r);
  },
  /**
   * Short for "transition all"; create a transition from the array of items
   * in the given list to the same final resulting state.
   * @param {string | string[]} inputs Group of inputs to transition on
   * @param {Transition<T> | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   */
  ta(r, e, t, n) {
    for (let i = 0; i < r.length; i++)
      this.tt(r[i], e, t, n);
  },
  /**
   * Short for "take regexp transition"; defines a transition for this state
   * when it encounters a token which matches the given regular expression
   * @param {RegExp} regexp Regular expression transition (populate first)
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  tr(r, e, t, n) {
    n = n || Nt.groups;
    let i;
    return e && e.j ? i = e : (i = new Nt(e), t && n && Pr(e, t, n)), this.jr.push([r, i]), i;
  },
  /**
   * Short for "take transitions", will take as many sequential transitions as
   * the length of the given input and returns the
   * resulting final state.
   * @param {string | string[]} input
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  ts(r, e, t, n) {
    let i = this;
    const s = r.length;
    if (!s)
      return i;
    for (let o = 0; o < s - 1; o++)
      i = i.tt(r[o]);
    return i.tt(r[s - 1], e, t, n);
  },
  /**
   * Short for "take transition", this is a method for building/working with
   * state machines.
   *
   * If a state already exists for the given input, returns it.
   *
   * If a token is specified, that state will emit that token when reached by
   * the linkify engine.
   *
   * If no state exists, it will be initialized with some default transitions
   * that resemble existing default transitions.
   *
   * If a state is given for the second argument, that state will be
   * transitioned to on the given input regardless of what that input
   * previously did.
   *
   * Specify a token group flags to define groups that this token belongs to.
   * The token will be added to corresponding entires in the given groups
   * object.
   *
   * @param {string} input character, token type to transition on
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of groups
   * @returns {State<T>} taken after the given input
   */
  tt(r, e, t, n) {
    n = n || Nt.groups;
    const i = this;
    if (e && e.j)
      return i.j[r] = e, e;
    const s = e;
    let o, l = i.go(r);
    if (l ? (o = new Nt(), Tn(o.j, l.j), o.jr.push.apply(o.jr, l.jr), o.jd = l.jd, o.t = l.t) : o = new Nt(), s) {
      if (n)
        if (o.t && typeof o.t == "string") {
          const a = Tn(H1(o.t, n), t);
          Pr(s, a, n);
        } else
          t && Pr(s, t, n);
      o.t = s;
    }
    return i.j[r] = o, o;
  }
};
const ve = (r, e, t, n, i) => r.ta(e, t, n, i), Ct = (r, e, t, n, i) => r.tr(e, t, n, i), ld = (r, e, t, n, i) => r.ts(e, t, n, i), fe = (r, e, t, n, i) => r.tt(e, t, n, i), tr = "WORD", jl = "UWORD", ti = "LOCALHOST", zl = "TLD", $l = "UTLD", Zi = "SCHEME", tn = "SLASH_SCHEME", Vi = "NUM", _h = "WS", Bu = "NL", on = "OPENBRACE", kn = "OPENBRACKET", Pn = "OPENANGLEBRACKET", Gn = "OPENPAREN", xr = "CLOSEBRACE", sn = "CLOSEBRACKET", ln = "CLOSEANGLEBRACKET", Lr = "CLOSEPAREN", qi = "AMPERSAND", Wi = "APOSTROPHE", Qi = "ASTERISK", Dr = "AT", Ki = "BACKSLASH", Ji = "BACKTICK", Xi = "CARET", gr = "COLON", Zu = "COMMA", ea = "DOLLAR", Ht = "DOT", ta = "EQUALS", wu = "EXCLAMATION", jt = "HYPHEN", ra = "PERCENT", na = "PIPE", ia = "PLUS", aa = "POUND", oa = "QUERY", xu = "QUOTE", Lu = "SEMI", rr = "SLASH", Un = "TILDE", sa = "UNDERSCORE", Mh = "EMOJI", la = "SYM";
var Yh = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  WORD: tr,
  UWORD: jl,
  LOCALHOST: ti,
  TLD: zl,
  UTLD: $l,
  SCHEME: Zi,
  SLASH_SCHEME: tn,
  NUM: Vi,
  WS: _h,
  NL: Bu,
  OPENBRACE: on,
  OPENBRACKET: kn,
  OPENANGLEBRACKET: Pn,
  OPENPAREN: Gn,
  CLOSEBRACE: xr,
  CLOSEBRACKET: sn,
  CLOSEANGLEBRACKET: ln,
  CLOSEPAREN: Lr,
  AMPERSAND: qi,
  APOSTROPHE: Wi,
  ASTERISK: Qi,
  AT: Dr,
  BACKSLASH: Ki,
  BACKTICK: Ji,
  CARET: Xi,
  COLON: gr,
  COMMA: Zu,
  DOLLAR: ea,
  DOT: Ht,
  EQUALS: ta,
  EXCLAMATION: wu,
  HYPHEN: jt,
  PERCENT: ra,
  PIPE: na,
  PLUS: ia,
  POUND: aa,
  QUERY: oa,
  QUOTE: xu,
  SEMI: Lu,
  SLASH: rr,
  TILDE: Un,
  UNDERSCORE: sa,
  EMOJI: Mh,
  SYM: la
});
const Qr = /[a-z]/, B0 = /\p{L}/u, Z0 = /\p{Emoji}/u, w0 = /\d/, ud = /\s/, cd = `
`, j1 = "️", z1 = "‍";
let vi = null, Ni = null;
function $1(r) {
  r === void 0 && (r = []);
  const e = {};
  Nt.groups = e;
  const t = new Nt();
  vi == null && (vi = Td(L1)), Ni == null && (Ni = Td(k1)), fe(t, "'", Wi), fe(t, "{", on), fe(t, "[", kn), fe(t, "<", Pn), fe(t, "(", Gn), fe(t, "}", xr), fe(t, "]", sn), fe(t, ">", ln), fe(t, ")", Lr), fe(t, "&", qi), fe(t, "*", Qi), fe(t, "@", Dr), fe(t, "`", Ji), fe(t, "^", Xi), fe(t, ":", gr), fe(t, ",", Zu), fe(t, "$", ea), fe(t, ".", Ht), fe(t, "=", ta), fe(t, "!", wu), fe(t, "-", jt), fe(t, "%", ra), fe(t, "|", na), fe(t, "+", ia), fe(t, "#", aa), fe(t, "?", oa), fe(t, '"', xu), fe(t, "/", rr), fe(t, ";", Lu), fe(t, "~", Un), fe(t, "_", sa), fe(t, "\\", Ki);
  const n = Ct(t, w0, Vi, {
    [Pl]: !0
  });
  Ct(n, w0, n);
  const i = Ct(t, Qr, tr, {
    [Gl]: !0
  });
  Ct(i, Qr, i);
  const s = Ct(t, B0, jl, {
    [Ul]: !0
  });
  Ct(s, Qr), Ct(s, B0, s);
  const o = Ct(t, ud, _h, {
    [sd]: !0
  });
  fe(t, cd, Bu, {
    [sd]: !0
  }), fe(o, cd), Ct(o, ud, o);
  const l = Ct(t, Z0, Mh, {
    [Ch]: !0
  });
  Ct(l, Z0, l), fe(l, j1, l);
  const a = fe(l, z1);
  Ct(a, Z0, l);
  const c = [[Qr, i]], T = [[Qr, null], [B0, s]];
  for (let u = 0; u < vi.length; u++)
    hr(t, vi[u], zl, tr, c);
  for (let u = 0; u < Ni.length; u++)
    hr(t, Ni[u], $l, jl, T);
  Pr(zl, {
    tld: !0,
    ascii: !0
  }, e), Pr($l, {
    utld: !0,
    alpha: !0
  }, e), hr(t, "file", Zi, tr, c), hr(t, "mailto", Zi, tr, c), hr(t, "http", tn, tr, c), hr(t, "https", tn, tr, c), hr(t, "ftp", tn, tr, c), hr(t, "ftps", tn, tr, c), Pr(Zi, {
    scheme: !0,
    ascii: !0
  }, e), Pr(tn, {
    slashscheme: !0,
    ascii: !0
  }, e), r = r.sort((u, d) => u[0] > d[0] ? 1 : -1);
  for (let u = 0; u < r.length; u++) {
    const d = r[u][0], f = r[u][1] ? {
      [P1]: !0
    } : {
      [G1]: !0
    };
    d.indexOf("-") >= 0 ? f[Hl] = !0 : Qr.test(d) ? w0.test(d) ? f[Bi] = !0 : f[Gl] = !0 : f[Pl] = !0, ld(t, d, d, f);
  }
  return ld(t, "localhost", ti, {
    ascii: !0
  }), t.jd = new Nt(la), {
    start: t,
    tokens: Tn({
      groups: e
    }, Yh)
  };
}
function V1(r, e) {
  const t = q1(e.replace(/[A-Z]/g, (l) => l.toLowerCase())), n = t.length, i = [];
  let s = 0, o = 0;
  for (; o < n; ) {
    let l = r, a = null, c = 0, T = null, u = -1, d = -1;
    for (; o < n && (a = l.go(t[o])); )
      l = a, l.accepts() ? (u = 0, d = 0, T = l) : u >= 0 && (u += t[o].length, d++), c += t[o].length, s += t[o].length, o++;
    s -= u, o -= d, c -= u, i.push({
      t: T.t,
      // token type/name
      v: e.slice(s - c, s),
      // string value
      s: s - c,
      // start index
      e: s
      // end index (excluding)
    });
  }
  return i;
}
function q1(r) {
  const e = [], t = r.length;
  let n = 0;
  for (; n < t; ) {
    let i = r.charCodeAt(n), s, o = i < 55296 || i > 56319 || n + 1 === t || (s = r.charCodeAt(n + 1)) < 56320 || s > 57343 ? r[n] : r.slice(n, n + 2);
    e.push(o), n += o.length;
  }
  return e;
}
function hr(r, e, t, n, i) {
  let s;
  const o = e.length;
  for (let l = 0; l < o - 1; l++) {
    const a = e[l];
    r.j[a] ? s = r.j[a] : (s = new Nt(n), s.jr = i.slice(), r.j[a] = s), r = s;
  }
  return s = new Nt(t), s.jr = i.slice(), r.j[e[o - 1]] = s, s;
}
function Td(r) {
  const e = [], t = [];
  let n = 0, i = "0123456789";
  for (; n < r.length; ) {
    let s = 0;
    for (; i.indexOf(r[n + s]) >= 0; )
      s++;
    if (s > 0) {
      e.push(t.join(""));
      let o = parseInt(r.substring(n, n + s), 10);
      for (; o > 0; o--)
        t.pop();
      n += s;
    } else
      r[n] === "_" ? (e.push(t.join("")), n++) : (t.push(r[n]), n++);
  }
  return e;
}
const ri = {
  defaultProtocol: "http",
  events: null,
  format: dd,
  formatHref: dd,
  nl2br: !1,
  tagName: "a",
  target: null,
  rel: null,
  validate: !0,
  truncate: 1 / 0,
  className: null,
  attributes: null,
  ignoreTags: [],
  render: null
};
function ku(r, e) {
  e === void 0 && (e = null);
  let t = Tn({}, ri);
  r && (t = Tn(t, r instanceof ku ? r.o : r));
  const n = t.ignoreTags, i = [];
  for (let s = 0; s < n.length; s++)
    i.push(n[s].toUpperCase());
  this.o = t, e && (this.defaultRender = e), this.ignoreTags = i;
}
ku.prototype = {
  o: ri,
  /**
   * @type string[]
   */
  ignoreTags: [],
  /**
   * @param {IntermediateRepresentation} ir
   * @returns {any}
   */
  defaultRender(r) {
    return r;
  },
  /**
   * Returns true or false based on whether a token should be displayed as a
   * link based on the user options.
   * @param {MultiToken} token
   * @returns {boolean}
   */
  check(r) {
    return this.get("validate", r.toString(), r);
  },
  // Private methods
  /**
   * Resolve an option's value based on the value of the option and the given
   * params. If operator and token are specified and the target option is
   * callable, automatically calls the function with the given argument.
   * @template {keyof Opts} K
   * @param {K} key Name of option to use
   * @param {string} [operator] will be passed to the target option if it's a
   * function. If not specified, RAW function value gets returned
   * @param {MultiToken} [token] The token from linkify.tokenize
   * @returns {Opts[K] | any}
   */
  get(r, e, t) {
    const n = e != null;
    let i = this.o[r];
    return i && (typeof i == "object" ? (i = t.t in i ? i[t.t] : ri[r], typeof i == "function" && n && (i = i(e, t))) : typeof i == "function" && n && (i = i(e, t.t, t)), i);
  },
  /**
   * @template {keyof Opts} L
   * @param {L} key Name of options object to use
   * @param {string} [operator]
   * @param {MultiToken} [token]
   * @returns {Opts[L] | any}
   */
  getObj(r, e, t) {
    let n = this.o[r];
    return typeof n == "function" && e != null && (n = n(e, t.t, t)), n;
  },
  /**
   * Convert the given token to a rendered element that may be added to the
   * calling-interface's DOM
   * @param {MultiToken} token Token to render to an HTML element
   * @returns {any} Render result; e.g., HTML string, DOM element, React
   *   Component, etc.
   */
  render(r) {
    const e = r.render(this);
    return (this.get("render", null, r) || this.defaultRender)(e, r.t, r);
  }
};
function dd(r) {
  return r;
}
function Ih(r, e) {
  this.t = "token", this.v = r, this.tk = e;
}
Ih.prototype = {
  isLink: !1,
  /**
   * Return the string this token represents.
   * @return {string}
   */
  toString() {
    return this.v;
  },
  /**
   * What should the value for this token be in the `href` HTML attribute?
   * Returns the `.toString` value by default.
   * @param {string} [scheme]
   * @return {string}
  */
  toHref(r) {
    return this.toString();
  },
  /**
   * @param {Options} options Formatting options
   * @returns {string}
   */
  toFormattedString(r) {
    const e = this.toString(), t = r.get("truncate", e, this), n = r.get("format", e, this);
    return t && n.length > t ? n.substring(0, t) + "…" : n;
  },
  /**
   *
   * @param {Options} options
   * @returns {string}
   */
  toFormattedHref(r) {
    return r.get("formatHref", this.toHref(r.get("defaultProtocol")), this);
  },
  /**
   * The start index of this token in the original input string
   * @returns {number}
   */
  startIndex() {
    return this.tk[0].s;
  },
  /**
   * The end index of this token in the original input string (up to this
   * index but not including it)
   * @returns {number}
   */
  endIndex() {
    return this.tk[this.tk.length - 1].e;
  },
  /**
  	Returns an object  of relevant values for this token, which includes keys
  	* type - Kind of token ('url', 'email', etc.)
  	* value - Original text
  	* href - The value that should be added to the anchor tag's href
  		attribute
  		@method toObject
  	@param {string} [protocol] `'http'` by default
  */
  toObject(r) {
    return r === void 0 && (r = ri.defaultProtocol), {
      type: this.t,
      value: this.toString(),
      isLink: this.isLink,
      href: this.toHref(r),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   *
   * @param {Options} options Formatting option
   */
  toFormattedObject(r) {
    return {
      type: this.t,
      value: this.toFormattedString(r),
      isLink: this.isLink,
      href: this.toFormattedHref(r),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   * Whether this token should be rendered as a link according to the given options
   * @param {Options} options
   * @returns {boolean}
   */
  validate(r) {
    return r.get("validate", this.toString(), this);
  },
  /**
   * Return an object that represents how this link should be rendered.
   * @param {Options} options Formattinng options
   */
  render(r) {
    const e = this, t = this.toFormattedHref(r), n = r.get("tagName", t, e), i = this.toFormattedString(r), s = {}, o = r.get("className", t, e), l = r.get("target", t, e), a = r.get("rel", t, e), c = r.getObj("attributes", t, e), T = r.getObj("events", t, e);
    return s.href = t, o && (s.class = o), l && (s.target = l), a && (s.rel = a), c && Tn(s, c), {
      tagName: n,
      attributes: s,
      content: i,
      eventListeners: T
    };
  }
};
function xa(r, e) {
  class t extends Ih {
    constructor(i, s) {
      super(i, s), this.t = r;
    }
  }
  for (const n in e)
    t.prototype[n] = e[n];
  return t.t = r, t;
}
const Ad = xa("email", {
  isLink: !0,
  toHref() {
    return "mailto:" + this.toString();
  }
}), fd = xa("text"), W1 = xa("nl"), Ir = xa("url", {
  isLink: !0,
  /**
  	Lowercases relevant parts of the domain and adds the protocol if
  	required. Note that this will not escape unsafe HTML characters in the
  	URL.
  		@param {string} [scheme] default scheme (e.g., 'https')
  	@return {string} the full href
  */
  toHref(r) {
    return r === void 0 && (r = ri.defaultProtocol), this.hasProtocol() ? this.v : `${r}://${this.v}`;
  },
  /**
   * Check whether this URL token has a protocol
   * @return {boolean}
   */
  hasProtocol() {
    const r = this.tk;
    return r.length >= 2 && r[0].t !== ti && r[1].t === gr;
  }
}), et = (r) => new Nt(r);
function Q1(r) {
  let {
    groups: e
  } = r;
  const t = e.domain.concat([qi, Qi, Dr, Ki, Ji, Xi, ea, ta, jt, Vi, ra, na, ia, aa, rr, la, Un, sa]), n = [Wi, ln, xr, sn, Lr, gr, Zu, Ht, wu, Pn, on, kn, Gn, oa, xu, Lu], i = [qi, Wi, Qi, Ki, Ji, Xi, xr, ea, ta, jt, Vi, on, ra, na, ia, aa, oa, rr, la, Un, sa], s = et(), o = fe(s, Un);
  ve(o, i, o), ve(o, e.domain, o);
  const l = et(), a = et(), c = et();
  ve(s, e.domain, l), ve(s, e.scheme, a), ve(s, e.slashscheme, c), ve(l, i, o), ve(l, e.domain, l);
  const T = fe(l, Dr);
  fe(o, Dr, T), fe(a, Dr, T), fe(c, Dr, T);
  const u = fe(o, Ht);
  ve(u, i, o), ve(u, e.domain, o);
  const d = et();
  ve(T, e.domain, d), ve(d, e.domain, d);
  const A = fe(d, Ht);
  ve(A, e.domain, d);
  const f = et(Ad);
  ve(A, e.tld, f), ve(A, e.utld, f), fe(T, ti, f);
  const h = fe(d, jt);
  ve(h, e.domain, d), ve(f, e.domain, d), fe(f, Ht, A), fe(f, jt, h);
  const S = fe(f, gr);
  ve(S, e.numeric, Ad);
  const p = fe(l, jt), m = fe(l, Ht);
  ve(p, e.domain, l), ve(m, i, o), ve(m, e.domain, l);
  const g = et(Ir);
  ve(m, e.tld, g), ve(m, e.utld, g), ve(g, e.domain, l), ve(g, i, o), fe(g, Ht, m), fe(g, jt, p), fe(g, Dr, T);
  const N = fe(g, gr), R = et(Ir);
  ve(N, e.numeric, R);
  const D = et(Ir), v = et();
  ve(D, t, D), ve(D, n, v), ve(v, t, D), ve(v, n, v), fe(g, rr, D), fe(R, rr, D);
  const O = fe(a, gr), y = fe(c, gr), Z = fe(y, rr);
  fe(Z, rr, O), ve(a, e.domain, l), fe(a, Ht, m), fe(a, jt, p), ve(c, e.domain, l), fe(c, Ht, m), fe(c, jt, p), ve(O, e.domain, D), fe(O, rr, D);
  const F = fe(D, on), b = fe(D, kn), Y = fe(D, Pn), I = fe(D, Gn);
  fe(v, on, F), fe(v, kn, b), fe(v, Pn, Y), fe(v, Gn, I), fe(F, xr, D), fe(b, sn, D), fe(Y, ln, D), fe(I, Lr, D), fe(F, xr, D);
  const q = et(Ir), _ = et(Ir), z = et(Ir), E = et(Ir);
  ve(F, t, q), ve(b, t, _), ve(Y, t, z), ve(I, t, E);
  const C = et(), P = et(), M = et(), Q = et();
  return ve(F, n), ve(b, n), ve(Y, n), ve(I, n), ve(q, t, q), ve(_, t, _), ve(z, t, z), ve(E, t, E), ve(q, n, q), ve(_, n, _), ve(z, n, z), ve(E, n, E), ve(C, t, C), ve(P, t, _), ve(M, t, z), ve(Q, t, E), ve(C, n, C), ve(P, n, P), ve(M, n, M), ve(Q, n, Q), fe(_, sn, D), fe(z, ln, D), fe(E, Lr, D), fe(q, xr, D), fe(P, sn, D), fe(M, ln, D), fe(Q, Lr, D), fe(C, Lr, D), fe(s, ti, g), fe(s, Bu, W1), {
    start: s,
    tokens: Yh
  };
}
function K1(r, e, t) {
  let n = t.length, i = 0, s = [], o = [];
  for (; i < n; ) {
    let l = r, a = null, c = null, T = 0, u = null, d = -1;
    for (; i < n && !(a = l.go(t[i].t)); )
      o.push(t[i++]);
    for (; i < n && (c = a || l.go(t[i].t)); )
      a = null, l = c, l.accepts() ? (d = 0, u = l) : d >= 0 && d++, i++, T++;
    if (d < 0)
      i -= T, i < n && (o.push(t[i]), i++);
    else {
      o.length > 0 && (s.push(x0(fd, e, o)), o = []), i -= d, T -= d;
      const A = u.t, f = t.slice(i - T, i);
      s.push(x0(A, e, f));
    }
  }
  return o.length > 0 && s.push(x0(fd, e, o)), s;
}
function x0(r, e, t) {
  const n = t[0].s, i = t[t.length - 1].e, s = e.slice(n, i);
  return new r(s, t);
}
const At = {
  scanner: null,
  parser: null,
  tokenQueue: [],
  pluginQueue: [],
  customSchemes: [],
  initialized: !1
};
function J1() {
  At.scanner = $1(At.customSchemes);
  for (let r = 0; r < At.tokenQueue.length; r++)
    At.tokenQueue[r][1]({
      scanner: At.scanner
    });
  At.parser = Q1(At.scanner.tokens);
  for (let r = 0; r < At.pluginQueue.length; r++)
    At.pluginQueue[r][1]({
      scanner: At.scanner,
      parser: At.parser
    });
  At.initialized = !0;
}
function X1(r) {
  return At.initialized || J1(), K1(At.parser.start, r, V1(At.scanner.start, r));
}
function Bh(r) {
  return r.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function eS(r) {
  return r.replace(/"/g, "&quot;");
}
function tS(r) {
  const e = [];
  for (const t in r) {
    let n = r[t] + "";
    e.push(`${t}="${eS(n)}"`);
  }
  return e.join(" ");
}
function rS(r) {
  let {
    tagName: e,
    attributes: t,
    content: n
  } = r;
  return `<${e} ${tS(t)}>${Bh(n)}</${e}>`;
}
function Zh(r, e) {
  e === void 0 && (e = {}), e = new ku(e, rS);
  const t = X1(r), n = [];
  for (let i = 0; i < t.length; i++) {
    const s = t[i];
    s.t === "nl" && e.get("nl2br") ? n.push(`<br>
`) : !s.isLink || !e.check(s) ? n.push(Bh(s.toString())) : n.push(e.render(s));
  }
  return n.join("");
}
String.prototype.linkify || Object.defineProperty(String.prototype, "linkify", {
  writable: !1,
  value: function(e) {
    return Zh(this, e);
  }
});
const nS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Zh
}, Symbol.toStringTag, { value: "Module" })), iS = /* @__PURE__ */ Vr(nS);
var L0 = {}, pd = {}, hd;
function dr() {
  if (hd)
    return pd;
  hd = 1;
  var r = St(), e = Rt(), t = bt().f;
  return r({ target: "Object", stat: !0, forced: Object.defineProperty !== t, sham: !e }, {
    defineProperty: t
  }), pd;
}
var Kr = {}, md = {}, k0, Ed;
function aS() {
  if (Ed)
    return k0;
  Ed = 1;
  var r = ot();
  return k0 = r, k0;
}
var P0 = {}, Sd;
function wh() {
  if (Sd)
    return P0;
  Sd = 1;
  var r = Je();
  return P0.f = r, P0;
}
var G0, Dd;
function Pu() {
  if (Dd)
    return G0;
  Dd = 1;
  var r = aS(), e = st(), t = wh(), n = bt().f;
  return G0 = function(i) {
    var s = r.Symbol || (r.Symbol = {});
    e(s, i) || n(s, i, {
      value: t.f(i)
    });
  }, G0;
}
var gd;
function xh() {
  if (gd)
    return md;
  gd = 1;
  var r = Pu();
  return r("iterator"), md;
}
var U0 = {}, H0, Rd;
function La() {
  if (Rd)
    return H0;
  Rd = 1;
  var r = vh(), e = Cu();
  return H0 = Object.keys || function(n) {
    return r(n, e);
  }, H0;
}
var vd;
function Lh() {
  if (vd)
    return U0;
  vd = 1;
  var r = Rt(), e = Dh(), t = bt(), n = Ut(), i = Wr(), s = La();
  return U0.f = r && !e ? Object.defineProperties : function(l, a) {
    n(l);
    for (var c = i(a), T = s(a), u = T.length, d = 0, A; u > d; )
      t.f(l, A = T[d++], c[A]);
    return l;
  }, U0;
}
var j0, Nd;
function oS() {
  if (Nd)
    return j0;
  Nd = 1;
  var r = Or();
  return j0 = r("document", "documentElement"), j0;
}
var z0, Fd;
function di() {
  if (Fd)
    return z0;
  Fd = 1;
  var r = Ut(), e = Lh(), t = Cu(), n = Ya(), i = oS(), s = Ou(), o = Ma(), l = ">", a = "<", c = "prototype", T = "script", u = o("IE_PROTO"), d = function() {
  }, A = function(m) {
    return a + T + l + m + a + "/" + T + l;
  }, f = function(m) {
    m.write(A("")), m.close();
    var g = m.parentWindow.Object;
    return m = null, g;
  }, h = function() {
    var m = s("iframe"), g = "java" + T + ":", N;
    return m.style.display = "none", i.appendChild(m), m.src = String(g), N = m.contentWindow.document, N.open(), N.write(A("document.F=Object")), N.close(), N.F;
  }, S, p = function() {
    try {
      S = new ActiveXObject("htmlfile");
    } catch {
    }
    p = typeof document < "u" ? document.domain && S ? f(S) : h() : f(S);
    for (var m = t.length; m--; )
      delete p[c][t[m]];
    return p();
  };
  return n[u] = !0, z0 = Object.create || function(g, N) {
    var R;
    return g !== null ? (d[c] = r(g), R = new d(), d[c] = null, R[u] = g) : R = p(), N === void 0 ? R : e.f(R, N);
  }, z0;
}
var $0, Od;
function sS() {
  if (Od)
    return $0;
  Od = 1;
  var r = Je(), e = di(), t = bt().f, n = r("unscopables"), i = Array.prototype;
  return i[n] == null && t(i, n, {
    configurable: !0,
    value: e(null)
  }), $0 = function(s) {
    i[n][s] = !0;
  }, $0;
}
var V0, yd;
function Gu() {
  return yd || (yd = 1, V0 = {}), V0;
}
var q0, bd;
function lS() {
  if (bd)
    return q0;
  bd = 1;
  var r = $e();
  return q0 = !r(function() {
    function e() {
    }
    return e.prototype.constructor = null, Object.getPrototypeOf(new e()) !== e.prototype;
  }), q0;
}
var W0, Cd;
function kh() {
  if (Cd)
    return W0;
  Cd = 1;
  var r = st(), e = Ke(), t = yr(), n = Ma(), i = lS(), s = n("IE_PROTO"), o = Object, l = o.prototype;
  return W0 = i ? o.getPrototypeOf : function(a) {
    var c = t(a);
    if (r(c, s))
      return c[s];
    var T = c.constructor;
    return e(T) && c instanceof T ? T.prototype : c instanceof o ? l : null;
  }, W0;
}
var Q0, _d;
function Ph() {
  if (_d)
    return Q0;
  _d = 1;
  var r = $e(), e = Ke(), t = Gt(), n = di(), i = kh(), s = Qt(), o = Je(), l = Nn(), a = o("iterator"), c = !1, T, u, d;
  [].keys && (d = [].keys(), "next" in d ? (u = i(i(d)), u !== Object.prototype && (T = u)) : c = !0);
  var A = !t(T) || r(function() {
    var f = {};
    return T[a].call(f) !== f;
  });
  return A ? T = {} : l && (T = n(T)), e(T[a]) || s(T, a, function() {
    return this;
  }), Q0 = {
    IteratorPrototype: T,
    BUGGY_SAFARI_ITERATORS: c
  }, Q0;
}
var K0, Md;
function Uu() {
  if (Md)
    return K0;
  Md = 1;
  var r = bt().f, e = st(), t = Je(), n = t("toStringTag");
  return K0 = function(i, s, o) {
    i && !o && (i = i.prototype), i && !e(i, n) && r(i, n, { configurable: !0, value: s });
  }, K0;
}
var J0, Yd;
function uS() {
  if (Yd)
    return J0;
  Yd = 1;
  var r = Ph().IteratorPrototype, e = di(), t = oi(), n = Uu(), i = Gu(), s = function() {
    return this;
  };
  return J0 = function(o, l, a, c) {
    var T = l + " Iterator";
    return o.prototype = e(r, { next: t(+!c, a) }), n(o, T, !1, !0), i[T] = s, o;
  }, J0;
}
var X0, Id;
function cS() {
  if (Id)
    return X0;
  Id = 1;
  var r = Ke(), e = String, t = TypeError;
  return X0 = function(n) {
    if (typeof n == "object" || r(n))
      return n;
    throw t("Can't set " + e(n) + " as a prototype");
  }, X0;
}
var es, Bd;
function Gh() {
  if (Bd)
    return es;
  Bd = 1;
  var r = Ve(), e = Ut(), t = cS();
  return es = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var n = !1, i = {}, s;
    try {
      s = r(Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set), s(i, []), n = i instanceof Array;
    } catch {
    }
    return function(l, a) {
      return e(l), t(a), n ? s(l, a) : l.__proto__ = a, l;
    };
  }() : void 0), es;
}
var ts, Zd;
function Uh() {
  if (Zd)
    return ts;
  Zd = 1;
  var r = St(), e = It(), t = Nn(), n = yu(), i = Ke(), s = uS(), o = kh(), l = Gh(), a = Uu(), c = ci(), T = Qt(), u = Je(), d = Gu(), A = Ph(), f = n.PROPER, h = n.CONFIGURABLE, S = A.IteratorPrototype, p = A.BUGGY_SAFARI_ITERATORS, m = u("iterator"), g = "keys", N = "values", R = "entries", D = function() {
    return this;
  };
  return ts = function(v, O, y, Z, F, b, Y) {
    s(y, O, Z);
    var I = function(re) {
      if (re === F && C)
        return C;
      if (!p && re in z)
        return z[re];
      switch (re) {
        case g:
          return function() {
            return new y(this, re);
          };
        case N:
          return function() {
            return new y(this, re);
          };
        case R:
          return function() {
            return new y(this, re);
          };
      }
      return function() {
        return new y(this);
      };
    }, q = O + " Iterator", _ = !1, z = v.prototype, E = z[m] || z["@@iterator"] || F && z[F], C = !p && E || I(F), P = O == "Array" && z.entries || E, M, Q, H;
    if (P && (M = o(P.call(new v())), M !== Object.prototype && M.next && (!t && o(M) !== S && (l ? l(M, S) : i(M[m]) || T(M, m, D)), a(M, q, !0, !0), t && (d[q] = D))), f && F == N && E && E.name !== N && (!t && h ? c(z, "name", N) : (_ = !0, C = function() {
      return e(E, this);
    })), F)
      if (Q = {
        values: I(N),
        keys: b ? C : I(g),
        entries: I(R)
      }, Y)
        for (H in Q)
          (p || _ || !(H in z)) && T(z, H, Q[H]);
      else
        r({ target: O, proto: !0, forced: p || _ }, Q);
    return (!t || Y) && z[m] !== C && T(z, m, C, { name: F }), d[O] = C, Q;
  }, ts;
}
var rs, wd;
function Hh() {
  return wd || (wd = 1, rs = function(r, e) {
    return { value: r, done: e };
  }), rs;
}
var ns, xd;
function Hu() {
  if (xd)
    return ns;
  xd = 1;
  var r = Wr(), e = sS(), t = Gu(), n = Ti(), i = bt().f, s = Uh(), o = Hh(), l = Nn(), a = Rt(), c = "Array Iterator", T = n.set, u = n.getterFor(c);
  ns = s(Array, "Array", function(A, f) {
    T(this, {
      type: c,
      target: r(A),
      // target
      index: 0,
      // next index
      kind: f
      // kind
    });
  }, function() {
    var A = u(this), f = A.target, h = A.kind, S = A.index++;
    return !f || S >= f.length ? (A.target = void 0, o(void 0, !0)) : h == "keys" ? o(S, !1) : h == "values" ? o(f[S], !1) : o([S, f[S]], !1);
  }, "values");
  var d = t.Arguments = t.Array;
  if (e("keys"), e("values"), e("entries"), !l && a && d.name !== "values")
    try {
      i(d, "name", { value: "values" });
    } catch {
    }
  return ns;
}
var Ld = {}, is, kd;
function Kt() {
  if (kd)
    return is;
  kd = 1;
  var r = Yu(), e = String;
  return is = function(t) {
    if (r(t) === "Symbol")
      throw TypeError("Cannot convert a Symbol value to a string");
    return e(t);
  }, is;
}
var as, Pd;
function jh() {
  if (Pd)
    return as;
  Pd = 1;
  var r = Ve(), e = Ia(), t = Kt(), n = Rn(), i = r("".charAt), s = r("".charCodeAt), o = r("".slice), l = function(a) {
    return function(c, T) {
      var u = t(n(c)), d = e(T), A = u.length, f, h;
      return d < 0 || d >= A ? a ? "" : void 0 : (f = s(u, d), f < 55296 || f > 56319 || d + 1 === A || (h = s(u, d + 1)) < 56320 || h > 57343 ? a ? i(u, d) : f : a ? o(u, d, d + 2) : (f - 55296 << 10) + (h - 56320) + 65536);
    };
  };
  return as = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: l(!1),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: l(!0)
  }, as;
}
var Gd;
function zh() {
  if (Gd)
    return Ld;
  Gd = 1;
  var r = jh().charAt, e = Kt(), t = Ti(), n = Uh(), i = Hh(), s = "String Iterator", o = t.set, l = t.getterFor(s);
  return n(String, "String", function(a) {
    o(this, {
      type: s,
      string: e(a),
      index: 0
    });
  }, function() {
    var c = l(this), T = c.string, u = c.index, d;
    return u >= T.length ? i(void 0, !0) : (d = r(T, u), c.index += d.length, i(d, !1));
  }), Ld;
}
var Ud = {}, os, Hd;
function TS() {
  return Hd || (Hd = 1, os = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
  }), os;
}
var ss, jd;
function dS() {
  if (jd)
    return ss;
  jd = 1;
  var r = Ou(), e = r("span").classList, t = e && e.constructor && e.constructor.prototype;
  return ss = t === Object.prototype ? void 0 : t, ss;
}
var zd;
function $h() {
  if (zd)
    return Ud;
  zd = 1;
  var r = ot(), e = TS(), t = dS(), n = Hu(), i = ci(), s = Je(), o = s("iterator"), l = s("toStringTag"), a = n.values, c = function(u, d) {
    if (u) {
      if (u[o] !== a)
        try {
          i(u, o, a);
        } catch {
          u[o] = a;
        }
      if (u[l] || i(u, l, d), e[d]) {
        for (var A in n)
          if (u[A] !== n[A])
            try {
              i(u, A, n[A]);
            } catch {
              u[A] = n[A];
            }
      }
    }
  };
  for (var T in e)
    c(r[T] && r[T].prototype, T);
  return c(t, "DOMTokenList"), Ud;
}
var $d = {}, ls, Vd;
function AS() {
  if (Vd)
    return ls;
  Vd = 1;
  var r = Rt(), e = Ve(), t = It(), n = $e(), i = La(), s = wa(), o = Su(), l = yr(), a = Du(), c = Object.assign, T = Object.defineProperty, u = e([].concat);
  return ls = !c || n(function() {
    if (r && c({ b: 1 }, c(T({}, "a", {
      enumerable: !0,
      get: function() {
        T(this, "b", {
          value: 3,
          enumerable: !1
        });
      }
    }), { b: 2 })).b !== 1)
      return !0;
    var d = {}, A = {}, f = Symbol(), h = "abcdefghijklmnopqrst";
    return d[f] = 7, h.split("").forEach(function(S) {
      A[S] = S;
    }), c({}, d)[f] != 7 || i(c({}, A)).join("") != h;
  }) ? function(A, f) {
    for (var h = l(A), S = arguments.length, p = 1, m = s.f, g = o.f; S > p; )
      for (var N = a(arguments[p++]), R = m ? u(i(N), m(N)) : i(N), D = R.length, v = 0, O; D > v; )
        O = R[v++], (!r || t(g, N, O)) && (h[O] = N[O]);
    return h;
  } : c, ls;
}
var qd;
function fS() {
  if (qd)
    return $d;
  qd = 1;
  var r = St(), e = AS();
  return r({ target: "Object", stat: !0, arity: 2, forced: Object.assign !== e }, {
    assign: e
  }), $d;
}
var Wd = {}, us, Qd;
function Vh() {
  if (Qd)
    return us;
  Qd = 1;
  var r = It(), e = Or(), t = Je(), n = Qt();
  return us = function() {
    var i = e("Symbol"), s = i && i.prototype, o = s && s.valueOf, l = t("toPrimitive");
    s && !s[l] && n(s, l, function(a) {
      return r(o, this);
    }, { arity: 1 });
  }, us;
}
var Kd;
function qh() {
  if (Kd)
    return Wd;
  Kd = 1;
  var r = Pu(), e = Vh();
  return r("toPrimitive"), e(), Wd;
}
var Jd = {}, cs, Xd;
function pS() {
  if (Xd)
    return cs;
  Xd = 1;
  var r = Ut(), e = mh(), t = TypeError;
  return cs = function(n) {
    if (r(this), n === "string" || n === "default")
      n = "string";
    else if (n !== "number")
      throw t("Incorrect hint");
    return e(this, n);
  }, cs;
}
var eA;
function Wh() {
  if (eA)
    return Jd;
  eA = 1;
  var r = st(), e = Qt(), t = pS(), n = Je(), i = n("toPrimitive"), s = Date.prototype;
  return r(s, i) || e(s, i, t), Jd;
}
var tA = {}, rA = {}, Ts = {}, ds, nA;
function hS() {
  if (nA)
    return ds;
  nA = 1;
  var r = Rh(), e = Ba(), t = Oh(), n = Array, i = Math.max;
  return ds = function(s, o, l) {
    for (var a = e(s), c = r(o, a), T = r(l === void 0 ? a : l, a), u = n(i(T - c, 0)), d = 0; c < T; c++, d++)
      t(u, d, s[c]);
    return u.length = d, u;
  }, ds;
}
var iA;
function mS() {
  if (iA)
    return Ts;
  iA = 1;
  var r = qr(), e = Wr(), t = Za().f, n = hS(), i = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [], s = function(o) {
    try {
      return t(o);
    } catch {
      return n(i);
    }
  };
  return Ts.f = function(l) {
    return i && r(l) == "Window" ? s(l) : t(e(l));
  }, Ts;
}
var As, aA;
function ES() {
  if (aA)
    return As;
  aA = 1;
  var r = Ve(), e = ph(), t = Ca(), n = r(r.bind);
  return As = function(i, s) {
    return e(i), s === void 0 ? i : t ? n(i, s) : function() {
      return i.apply(s, arguments);
    };
  }, As;
}
var fs, oA;
function ju() {
  if (oA)
    return fs;
  oA = 1;
  var r = ES(), e = Ve(), t = Du(), n = yr(), i = Ba(), s = yh(), o = e([].push), l = function(a) {
    var c = a == 1, T = a == 2, u = a == 3, d = a == 4, A = a == 6, f = a == 7, h = a == 5 || A;
    return function(S, p, m, g) {
      for (var N = n(S), R = t(N), D = r(p, m), v = i(R), O = 0, y = g || s, Z = c ? y(S, v) : T || f ? y(S, 0) : void 0, F, b; v > O; O++)
        if ((h || O in R) && (F = R[O], b = D(F, O, N), a))
          if (c)
            Z[O] = b;
          else if (b)
            switch (a) {
              case 3:
                return !0;
              case 5:
                return F;
              case 6:
                return O;
              case 2:
                o(Z, F);
            }
          else
            switch (a) {
              case 4:
                return !1;
              case 7:
                o(Z, F);
            }
      return A ? -1 : u || d ? d : Z;
    };
  };
  return fs = {
    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    forEach: l(0),
    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    map: l(1),
    // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    filter: l(2),
    // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some
    some: l(3),
    // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every
    every: l(4),
    // `Array.prototype.find` method
    // https://tc39.es/ecma262/#sec-array.prototype.find
    find: l(5),
    // `Array.prototype.findIndex` method
    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
    findIndex: l(6),
    // `Array.prototype.filterReject` method
    // https://github.com/tc39/proposal-array-filtering
    filterReject: l(7)
  }, fs;
}
var sA;
function SS() {
  if (sA)
    return rA;
  sA = 1;
  var r = St(), e = ot(), t = It(), n = Ve(), i = Nn(), s = Rt(), o = vn(), l = $e(), a = st(), c = si(), T = Ut(), u = Wr(), d = _a(), A = Kt(), f = oi(), h = di(), S = La(), p = Za(), m = mS(), g = wa(), N = ui(), R = bt(), D = Lh(), v = Su(), O = Qt(), y = Fn(), Z = Ma(), F = Ya(), b = Fu(), Y = Je(), I = wh(), q = Pu(), _ = Vh(), z = Uu(), E = Ti(), C = ju().forEach, P = Z("hidden"), M = "Symbol", Q = "prototype", H = E.set, re = E.getterFor(M), U = Object[Q], w = e.Symbol, W = w && w[Q], se = e.TypeError, ie = e.QObject, Fe = N.f, V = R.f, $ = m.f, J = v.f, ae = n([].push), X = y("symbols"), pe = y("op-symbols"), L = y("wks"), ee = !ie || !ie[Q] || !ie[Q].findChild, Ae = s && l(function() {
    return h(V({}, "a", {
      get: function() {
        return V(this, "a", { value: 7 }).a;
      }
    })).a != 7;
  }) ? function(K, k, B) {
    var j = Fe(U, k);
    j && delete U[k], V(K, k, B), j && K !== U && V(U, k, j);
  } : V, Ne = function(K, k) {
    var B = X[K] = h(W);
    return H(B, {
      type: M,
      tag: K,
      description: k
    }), s || (B.description = k), B;
  }, ye = function(k, B, j) {
    k === U && ye(pe, B, j), T(k);
    var le = d(B);
    return T(j), a(X, le) ? (j.enumerable ? (a(k, P) && k[P][le] && (k[P][le] = !1), j = h(j, { enumerable: f(0, !1) })) : (a(k, P) || V(k, P, f(1, {})), k[P][le] = !0), Ae(k, le, j)) : V(k, le, j);
  }, be = function(k, B) {
    T(k);
    var j = u(B), le = S(j).concat(te(j));
    return C(le, function(ce) {
      (!s || t(Ze, j, ce)) && ye(k, ce, j[ce]);
    }), k;
  }, Ge = function(k, B) {
    return B === void 0 ? h(k) : be(h(k), B);
  }, Ze = function(k) {
    var B = d(k), j = t(J, this, B);
    return this === U && a(X, B) && !a(pe, B) ? !1 : j || !a(this, B) || !a(X, B) || a(this, P) && this[P][B] ? j : !0;
  }, _e = function(k, B) {
    var j = u(k), le = d(B);
    if (!(j === U && a(X, le) && !a(pe, le))) {
      var ce = Fe(j, le);
      return ce && a(X, le) && !(a(j, P) && j[P][le]) && (ce.enumerable = !0), ce;
    }
  }, oe = function(k) {
    var B = $(u(k)), j = [];
    return C(B, function(le) {
      !a(X, le) && !a(F, le) && ae(j, le);
    }), j;
  }, te = function(K) {
    var k = K === U, B = $(k ? pe : u(K)), j = [];
    return C(B, function(le) {
      a(X, le) && (!k || a(U, le)) && ae(j, X[le]);
    }), j;
  };
  return o || (w = function() {
    if (c(W, this))
      throw se("Symbol is not a constructor");
    var k = !arguments.length || arguments[0] === void 0 ? void 0 : A(arguments[0]), B = b(k), j = function(le) {
      this === U && t(j, pe, le), a(this, P) && a(this[P], B) && (this[P][B] = !1), Ae(this, B, f(1, le));
    };
    return s && ee && Ae(U, B, { configurable: !0, set: j }), Ne(B, k);
  }, W = w[Q], O(W, "toString", function() {
    return re(this).tag;
  }), O(w, "withoutSetter", function(K) {
    return Ne(b(K), K);
  }), v.f = Ze, R.f = ye, D.f = be, N.f = _e, p.f = m.f = oe, g.f = te, I.f = function(K) {
    return Ne(Y(K), K);
  }, s && (V(W, "description", {
    configurable: !0,
    get: function() {
      return re(this).description;
    }
  }), i || O(U, "propertyIsEnumerable", Ze, { unsafe: !0 }))), r({ global: !0, constructor: !0, wrap: !0, forced: !o, sham: !o }, {
    Symbol: w
  }), C(S(L), function(K) {
    q(K);
  }), r({ target: M, stat: !0, forced: !o }, {
    useSetter: function() {
      ee = !0;
    },
    useSimple: function() {
      ee = !1;
    }
  }), r({ target: "Object", stat: !0, forced: !o, sham: !s }, {
    // `Object.create` method
    // https://tc39.es/ecma262/#sec-object.create
    create: Ge,
    // `Object.defineProperty` method
    // https://tc39.es/ecma262/#sec-object.defineproperty
    defineProperty: ye,
    // `Object.defineProperties` method
    // https://tc39.es/ecma262/#sec-object.defineproperties
    defineProperties: be,
    // `Object.getOwnPropertyDescriptor` method
    // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
    getOwnPropertyDescriptor: _e
  }), r({ target: "Object", stat: !0, forced: !o }, {
    // `Object.getOwnPropertyNames` method
    // https://tc39.es/ecma262/#sec-object.getownpropertynames
    getOwnPropertyNames: oe
  }), _(), z(w, M), F[P] = !0, rA;
}
var lA = {}, ps, uA;
function Qh() {
  if (uA)
    return ps;
  uA = 1;
  var r = vn();
  return ps = r && !!Symbol.for && !!Symbol.keyFor, ps;
}
var cA;
function DS() {
  if (cA)
    return lA;
  cA = 1;
  var r = St(), e = Or(), t = st(), n = Kt(), i = Fn(), s = Qh(), o = i("string-to-symbol-registry"), l = i("symbol-to-string-registry");
  return r({ target: "Symbol", stat: !0, forced: !s }, {
    for: function(a) {
      var c = n(a);
      if (t(o, c))
        return o[c];
      var T = e("Symbol")(c);
      return o[c] = T, l[T] = c, T;
    }
  }), lA;
}
var TA = {}, dA;
function gS() {
  if (dA)
    return TA;
  dA = 1;
  var r = St(), e = st(), t = li(), n = fh(), i = Fn(), s = Qh(), o = i("symbol-to-string-registry");
  return r({ target: "Symbol", stat: !0, forced: !s }, {
    keyFor: function(a) {
      if (!t(a))
        throw TypeError(n(a) + " is not a symbol");
      if (e(o, a))
        return o[a];
    }
  }), TA;
}
var AA = {}, hs, fA;
function Kh() {
  if (fA)
    return hs;
  fA = 1;
  var r = Ca(), e = Function.prototype, t = e.apply, n = e.call;
  return hs = typeof Reflect == "object" && Reflect.apply || (r ? n.bind(t) : function() {
    return n.apply(t, arguments);
  }), hs;
}
var ms, pA;
function RS() {
  if (pA)
    return ms;
  pA = 1;
  var r = Ve();
  return ms = r([].slice), ms;
}
var hA;
function vS() {
  if (hA)
    return AA;
  hA = 1;
  var r = St(), e = Or(), t = Kh(), n = It(), i = Ve(), s = $e(), o = _u(), l = Ke(), a = Gt(), c = li(), T = RS(), u = vn(), d = e("JSON", "stringify"), A = i(/./.exec), f = i("".charAt), h = i("".charCodeAt), S = i("".replace), p = i(1 .toString), m = /[\uD800-\uDFFF]/g, g = /^[\uD800-\uDBFF]$/, N = /^[\uDC00-\uDFFF]$/, R = !u || s(function() {
    var y = e("Symbol")();
    return d([y]) != "[null]" || d({ a: y }) != "{}" || d(Object(y)) != "{}";
  }), D = s(function() {
    return d("\uDF06\uD834") !== '"\\udf06\\ud834"' || d("\uDEAD") !== '"\\udead"';
  }), v = function(y, Z) {
    var F = T(arguments), b = Z;
    if (!(!a(Z) && y === void 0 || c(y)))
      return o(Z) || (Z = function(Y, I) {
        if (l(b) && (I = n(b, this, Y, I)), !c(I))
          return I;
      }), F[1] = Z, t(d, null, F);
  }, O = function(y, Z, F) {
    var b = f(F, Z - 1), Y = f(F, Z + 1);
    return A(g, y) && !A(N, Y) || A(N, y) && !A(g, b) ? "\\u" + p(h(y, 0), 16) : y;
  };
  return d && r({ target: "JSON", stat: !0, arity: 3, forced: R || D }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function(Z, F, b) {
      var Y = T(arguments), I = t(R ? v : d, null, Y);
      return D && typeof I == "string" ? S(I, m, O) : I;
    }
  }), AA;
}
var mA = {}, EA;
function NS() {
  if (EA)
    return mA;
  EA = 1;
  var r = St(), e = vn(), t = $e(), n = wa(), i = yr(), s = !e || t(function() {
    n.f(1);
  });
  return r({ target: "Object", stat: !0, forced: s }, {
    getOwnPropertySymbols: function(l) {
      var a = n.f;
      return a ? a(i(l)) : [];
    }
  }), mA;
}
var SA;
function Jh() {
  return SA || (SA = 1, SS(), DS(), gS(), vS(), NS()), tA;
}
var DA = {}, gA;
function Xh() {
  if (gA)
    return DA;
  gA = 1;
  var r = St(), e = Rt(), t = ot(), n = Ve(), i = st(), s = Ke(), o = si(), l = Kt(), a = bt().f, c = Nh(), T = t.Symbol, u = T && T.prototype;
  if (e && s(T) && (!("description" in u) || // Safari 12 bug
  T().description !== void 0)) {
    var d = {}, A = function() {
      var R = arguments.length < 1 || arguments[0] === void 0 ? void 0 : l(arguments[0]), D = o(u, this) ? new T(R) : R === void 0 ? T() : T(R);
      return R === "" && (d[D] = !0), D;
    };
    c(A, T), A.prototype = u, u.constructor = A;
    var f = String(T("test")) == "Symbol(test)", h = n(u.valueOf), S = n(u.toString), p = /^Symbol\((.*)\)[^)]+$/, m = n("".replace), g = n("".slice);
    a(u, "description", {
      configurable: !0,
      get: function() {
        var R = h(this);
        if (i(d, R))
          return "";
        var D = S(R), v = f ? g(D, 7, -1) : m(D, p, "$1");
        return v === "" ? void 0 : v;
      }
    }), r({ global: !0, constructor: !0, forced: !0 }, {
      Symbol: A
    });
  }
  return DA;
}
var RA = {}, Es, vA;
function FS() {
  if (vA)
    return Es;
  vA = 1;
  var r = Mu(), e = Yu();
  return Es = r ? {}.toString : function() {
    return "[object " + e(this) + "]";
  }, Es;
}
var NA;
function Ai() {
  if (NA)
    return RA;
  NA = 1;
  var r = Mu(), e = Qt(), t = FS();
  return r || e(Object.prototype, "toString", t, { unsafe: !0 }), RA;
}
var FA = {}, Ss, OA;
function OS() {
  if (OA)
    return Ss;
  OA = 1;
  var r = Ke(), e = Gt(), t = Gh();
  return Ss = function(n, i, s) {
    var o, l;
    return (
      // it can work only with native `setPrototypeOf`
      t && // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
      r(o = i.constructor) && o !== s && e(l = o.prototype) && l !== s.prototype && t(n, l), n
    );
  }, Ss;
}
var Ds, yA;
function yS() {
  if (yA)
    return Ds;
  yA = 1;
  var r = Ve();
  return Ds = r(1 .valueOf), Ds;
}
var gs, bA;
function bS() {
  return bA || (bA = 1, gs = `	
\v\f\r                　\u2028\u2029\uFEFF`), gs;
}
var Rs, CA;
function CS() {
  if (CA)
    return Rs;
  CA = 1;
  var r = Ve(), e = Rn(), t = Kt(), n = bS(), i = r("".replace), s = "[" + n + "]", o = RegExp("^" + s + s + "*"), l = RegExp(s + s + "*$"), a = function(c) {
    return function(T) {
      var u = t(e(T));
      return c & 1 && (u = i(u, o, "")), c & 2 && (u = i(u, l, "")), u;
    };
  };
  return Rs = {
    // `String.prototype.{ trimLeft, trimStart }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimstart
    start: a(1),
    // `String.prototype.{ trimRight, trimEnd }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimend
    end: a(2),
    // `String.prototype.trim` method
    // https://tc39.es/ecma262/#sec-string.prototype.trim
    trim: a(3)
  }, Rs;
}
var _A;
function em() {
  if (_A)
    return FA;
  _A = 1;
  var r = Rt(), e = ot(), t = Ve(), n = Fh(), i = Qt(), s = st(), o = OS(), l = si(), a = li(), c = Eh(), T = $e(), u = Za().f, d = ui().f, A = bt().f, f = yS(), h = CS().trim, S = "Number", p = e[S], m = p.prototype, g = e.TypeError, N = t("".slice), R = t("".charCodeAt), D = function(b) {
    var Y = c(b, "number");
    return typeof Y == "bigint" ? Y : v(Y);
  }, v = function(b) {
    var Y = c(b, "number"), I, q, _, z, E, C, P, M;
    if (a(Y))
      throw g("Cannot convert a Symbol value to a number");
    if (typeof Y == "string" && Y.length > 2) {
      if (Y = h(Y), I = R(Y, 0), I === 43 || I === 45) {
        if (q = R(Y, 2), q === 88 || q === 120)
          return NaN;
      } else if (I === 48) {
        switch (R(Y, 1)) {
          case 66:
          case 98:
            _ = 2, z = 49;
            break;
          case 79:
          case 111:
            _ = 8, z = 55;
            break;
          default:
            return +Y;
        }
        for (E = N(Y, 2), C = E.length, P = 0; P < C; P++)
          if (M = R(E, P), M < 48 || M > z)
            return NaN;
        return parseInt(E, _);
      }
    }
    return +Y;
  };
  if (n(S, !p(" 0o1") || !p("0b1") || p("+0x1"))) {
    for (var O = function(Y) {
      var I = arguments.length < 1 ? 0 : p(D(Y)), q = this;
      return l(m, q) && T(function() {
        f(q);
      }) ? o(Object(I), q, O) : I;
    }, y = r ? u(p) : (
      // ES3:
      "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,fromString,range".split(",")
    ), Z = 0, F; y.length > Z; Z++)
      s(p, F = y[Z]) && !s(O, F) && A(O, F, d(p, F));
    O.prototype = m, m.constructor = O, i(e, S, O, { constructor: !0 });
  }
  return FA;
}
var Jr = {}, MA;
function zu() {
  if (MA)
    return Jr;
  MA = 1, dr(), Object.defineProperty(Jr, "__esModule", {
    value: !0
  }), Jr.LogLevel = void 0;
  var r;
  return Jr.LogLevel = r, function(e) {
    e[e.Debug = 0] = "Debug", e[e.Info = 1] = "Info", e[e.Warn = 2] = "Warn", e[e.Error = 3] = "Error", e[e.Fatal = 4] = "Fatal";
  }(r || (Jr.LogLevel = r = {})), Jr;
}
var YA;
function _S() {
  if (YA)
    return Kr;
  YA = 1, dr(), xh(), Hu(), zh(), $h(), Object.defineProperty(Kr, "__esModule", {
    value: !0
  }), Kr.ConsoleLogger = void 0, Kr.buildConsoleLogger = c, fS(), qh(), Wh(), Jh(), Xh(), Ai(), em();
  var r = zu();
  function e(T) {
    return e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(u) {
      return typeof u;
    } : function(u) {
      return u && typeof Symbol == "function" && u.constructor === Symbol && u !== Symbol.prototype ? "symbol" : typeof u;
    }, e(T);
  }
  function t(T, u) {
    if (!(T instanceof u))
      throw new TypeError("Cannot call a class as a function");
  }
  function n(T, u) {
    for (var d = 0; d < u.length; d++) {
      var A = u[d];
      A.enumerable = A.enumerable || !1, A.configurable = !0, "value" in A && (A.writable = !0), Object.defineProperty(T, o(A.key), A);
    }
  }
  function i(T, u, d) {
    return u && n(T.prototype, u), d && n(T, d), Object.defineProperty(T, "prototype", { writable: !1 }), T;
  }
  function s(T, u, d) {
    return u = o(u), u in T ? Object.defineProperty(T, u, { value: d, enumerable: !0, configurable: !0, writable: !0 }) : T[u] = d, T;
  }
  function o(T) {
    var u = l(T, "string");
    return e(u) === "symbol" ? u : String(u);
  }
  function l(T, u) {
    if (e(T) !== "object" || T === null)
      return T;
    var d = T[Symbol.toPrimitive];
    if (d !== void 0) {
      var A = d.call(T, u || "default");
      if (e(A) !== "object")
        return A;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (u === "string" ? String : Number)(T);
  }
  var a = /* @__PURE__ */ function() {
    function T(u) {
      t(this, T), s(this, "context", void 0), this.context = u;
    }
    return i(T, [{
      key: "formatMessage",
      value: function(d, A, f) {
        var h = "[" + r.LogLevel[A].toUpperCase() + "]";
        return f && f.app && (h += " " + f.app + ": "), h + d;
      }
    }, {
      key: "log",
      value: function(d, A, f) {
        var h;
        if (!(d < ((h = this.context) === null || h === void 0 ? void 0 : h.level)))
          switch (d) {
            case r.LogLevel.Debug:
              console.debug(this.formatMessage(A, r.LogLevel.Debug, f), f);
              break;
            case r.LogLevel.Info:
              console.info(this.formatMessage(A, r.LogLevel.Info, f), f);
              break;
            case r.LogLevel.Warn:
              console.warn(this.formatMessage(A, r.LogLevel.Warn, f), f);
              break;
            case r.LogLevel.Error:
              console.error(this.formatMessage(A, r.LogLevel.Error, f), f);
              break;
            case r.LogLevel.Fatal:
            default:
              console.error(this.formatMessage(A, r.LogLevel.Fatal, f), f);
              break;
          }
      }
    }, {
      key: "debug",
      value: function(d, A) {
        this.log(r.LogLevel.Debug, d, Object.assign({}, this.context, A));
      }
    }, {
      key: "info",
      value: function(d, A) {
        this.log(r.LogLevel.Info, d, Object.assign({}, this.context, A));
      }
    }, {
      key: "warn",
      value: function(d, A) {
        this.log(r.LogLevel.Warn, d, Object.assign({}, this.context, A));
      }
    }, {
      key: "error",
      value: function(d, A) {
        this.log(r.LogLevel.Error, d, Object.assign({}, this.context, A));
      }
    }, {
      key: "fatal",
      value: function(d, A) {
        this.log(r.LogLevel.Fatal, d, Object.assign({}, this.context, A));
      }
    }]), T;
  }();
  Kr.ConsoleLogger = a;
  function c(T) {
    return new a(T);
  }
  return Kr;
}
var Yn = {}, Xr = {}, mr = {}, vs, IA;
function $u() {
  if (IA)
    return vs;
  IA = 1;
  const r = "2.0.0", e = 256, t = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */
  9007199254740991;
  return vs = {
    SEMVER_SPEC_VERSION: r,
    MAX_LENGTH: e,
    MAX_SAFE_INTEGER: t,
    MAX_SAFE_COMPONENT_LENGTH: 16
  }, vs;
}
var Hn = {}, MS = {
  get exports() {
    return Hn;
  },
  set exports(r) {
    Hn = r;
  }
}, Ns, BA;
function tm() {
  return BA || (BA = 1, Ns = typeof process == "object" && process.env && process.env.NODE_DEBUG && /\bsemver\b/i.test(process.env.NODE_DEBUG) ? (...e) => console.error("SEMVER", ...e) : () => {
  }), Ns;
}
var ZA;
function rm() {
  return ZA || (ZA = 1, function(r, e) {
    const { MAX_SAFE_COMPONENT_LENGTH: t } = $u(), n = tm();
    e = r.exports = {};
    const i = e.re = [], s = e.src = [], o = e.t = {};
    let l = 0;
    const a = (c, T, u) => {
      const d = l++;
      n(c, d, T), o[c] = d, s[d] = T, i[d] = new RegExp(T, u ? "g" : void 0);
    };
    a("NUMERICIDENTIFIER", "0|[1-9]\\d*"), a("NUMERICIDENTIFIERLOOSE", "[0-9]+"), a("NONNUMERICIDENTIFIER", "\\d*[a-zA-Z-][a-zA-Z0-9-]*"), a("MAINVERSION", `(${s[o.NUMERICIDENTIFIER]})\\.(${s[o.NUMERICIDENTIFIER]})\\.(${s[o.NUMERICIDENTIFIER]})`), a("MAINVERSIONLOOSE", `(${s[o.NUMERICIDENTIFIERLOOSE]})\\.(${s[o.NUMERICIDENTIFIERLOOSE]})\\.(${s[o.NUMERICIDENTIFIERLOOSE]})`), a("PRERELEASEIDENTIFIER", `(?:${s[o.NUMERICIDENTIFIER]}|${s[o.NONNUMERICIDENTIFIER]})`), a("PRERELEASEIDENTIFIERLOOSE", `(?:${s[o.NUMERICIDENTIFIERLOOSE]}|${s[o.NONNUMERICIDENTIFIER]})`), a("PRERELEASE", `(?:-(${s[o.PRERELEASEIDENTIFIER]}(?:\\.${s[o.PRERELEASEIDENTIFIER]})*))`), a("PRERELEASELOOSE", `(?:-?(${s[o.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${s[o.PRERELEASEIDENTIFIERLOOSE]})*))`), a("BUILDIDENTIFIER", "[0-9A-Za-z-]+"), a("BUILD", `(?:\\+(${s[o.BUILDIDENTIFIER]}(?:\\.${s[o.BUILDIDENTIFIER]})*))`), a("FULLPLAIN", `v?${s[o.MAINVERSION]}${s[o.PRERELEASE]}?${s[o.BUILD]}?`), a("FULL", `^${s[o.FULLPLAIN]}$`), a("LOOSEPLAIN", `[v=\\s]*${s[o.MAINVERSIONLOOSE]}${s[o.PRERELEASELOOSE]}?${s[o.BUILD]}?`), a("LOOSE", `^${s[o.LOOSEPLAIN]}$`), a("GTLT", "((?:<|>)?=?)"), a("XRANGEIDENTIFIERLOOSE", `${s[o.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`), a("XRANGEIDENTIFIER", `${s[o.NUMERICIDENTIFIER]}|x|X|\\*`), a("XRANGEPLAIN", `[v=\\s]*(${s[o.XRANGEIDENTIFIER]})(?:\\.(${s[o.XRANGEIDENTIFIER]})(?:\\.(${s[o.XRANGEIDENTIFIER]})(?:${s[o.PRERELEASE]})?${s[o.BUILD]}?)?)?`), a("XRANGEPLAINLOOSE", `[v=\\s]*(${s[o.XRANGEIDENTIFIERLOOSE]})(?:\\.(${s[o.XRANGEIDENTIFIERLOOSE]})(?:\\.(${s[o.XRANGEIDENTIFIERLOOSE]})(?:${s[o.PRERELEASELOOSE]})?${s[o.BUILD]}?)?)?`), a("XRANGE", `^${s[o.GTLT]}\\s*${s[o.XRANGEPLAIN]}$`), a("XRANGELOOSE", `^${s[o.GTLT]}\\s*${s[o.XRANGEPLAINLOOSE]}$`), a("COERCE", `(^|[^\\d])(\\d{1,${t}})(?:\\.(\\d{1,${t}}))?(?:\\.(\\d{1,${t}}))?(?:$|[^\\d])`), a("COERCERTL", s[o.COERCE], !0), a("LONETILDE", "(?:~>?)"), a("TILDETRIM", `(\\s*)${s[o.LONETILDE]}\\s+`, !0), e.tildeTrimReplace = "$1~", a("TILDE", `^${s[o.LONETILDE]}${s[o.XRANGEPLAIN]}$`), a("TILDELOOSE", `^${s[o.LONETILDE]}${s[o.XRANGEPLAINLOOSE]}$`), a("LONECARET", "(?:\\^)"), a("CARETTRIM", `(\\s*)${s[o.LONECARET]}\\s+`, !0), e.caretTrimReplace = "$1^", a("CARET", `^${s[o.LONECARET]}${s[o.XRANGEPLAIN]}$`), a("CARETLOOSE", `^${s[o.LONECARET]}${s[o.XRANGEPLAINLOOSE]}$`), a("COMPARATORLOOSE", `^${s[o.GTLT]}\\s*(${s[o.LOOSEPLAIN]})$|^$`), a("COMPARATOR", `^${s[o.GTLT]}\\s*(${s[o.FULLPLAIN]})$|^$`), a("COMPARATORTRIM", `(\\s*)${s[o.GTLT]}\\s*(${s[o.LOOSEPLAIN]}|${s[o.XRANGEPLAIN]})`, !0), e.comparatorTrimReplace = "$1$2$3", a("HYPHENRANGE", `^\\s*(${s[o.XRANGEPLAIN]})\\s+-\\s+(${s[o.XRANGEPLAIN]})\\s*$`), a("HYPHENRANGELOOSE", `^\\s*(${s[o.XRANGEPLAINLOOSE]})\\s+-\\s+(${s[o.XRANGEPLAINLOOSE]})\\s*$`), a("STAR", "(<|>)?=?\\s*\\*"), a("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$"), a("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");
  }(MS, Hn)), Hn;
}
var Fs, wA;
function nm() {
  if (wA)
    return Fs;
  wA = 1;
  const r = ["includePrerelease", "loose", "rtl"];
  return Fs = (t) => t ? typeof t != "object" ? { loose: !0 } : r.filter((n) => t[n]).reduce((n, i) => (n[i] = !0, n), {}) : {}, Fs;
}
var Os, xA;
function YS() {
  if (xA)
    return Os;
  xA = 1;
  const r = /^[0-9]+$/, e = (n, i) => {
    const s = r.test(n), o = r.test(i);
    return s && o && (n = +n, i = +i), n === i ? 0 : s && !o ? -1 : o && !s ? 1 : n < i ? -1 : 1;
  };
  return Os = {
    compareIdentifiers: e,
    rcompareIdentifiers: (n, i) => e(i, n)
  }, Os;
}
var ys, LA;
function im() {
  if (LA)
    return ys;
  LA = 1;
  const r = tm(), { MAX_LENGTH: e, MAX_SAFE_INTEGER: t } = $u(), { re: n, t: i } = rm(), s = nm(), { compareIdentifiers: o } = YS();
  class l {
    constructor(c, T) {
      if (T = s(T), c instanceof l) {
        if (c.loose === !!T.loose && c.includePrerelease === !!T.includePrerelease)
          return c;
        c = c.version;
      } else if (typeof c != "string")
        throw new TypeError(`Invalid Version: ${c}`);
      if (c.length > e)
        throw new TypeError(
          `version is longer than ${e} characters`
        );
      r("SemVer", c, T), this.options = T, this.loose = !!T.loose, this.includePrerelease = !!T.includePrerelease;
      const u = c.trim().match(T.loose ? n[i.LOOSE] : n[i.FULL]);
      if (!u)
        throw new TypeError(`Invalid Version: ${c}`);
      if (this.raw = c, this.major = +u[1], this.minor = +u[2], this.patch = +u[3], this.major > t || this.major < 0)
        throw new TypeError("Invalid major version");
      if (this.minor > t || this.minor < 0)
        throw new TypeError("Invalid minor version");
      if (this.patch > t || this.patch < 0)
        throw new TypeError("Invalid patch version");
      u[4] ? this.prerelease = u[4].split(".").map((d) => {
        if (/^[0-9]+$/.test(d)) {
          const A = +d;
          if (A >= 0 && A < t)
            return A;
        }
        return d;
      }) : this.prerelease = [], this.build = u[5] ? u[5].split(".") : [], this.format();
    }
    format() {
      return this.version = `${this.major}.${this.minor}.${this.patch}`, this.prerelease.length && (this.version += `-${this.prerelease.join(".")}`), this.version;
    }
    toString() {
      return this.version;
    }
    compare(c) {
      if (r("SemVer.compare", this.version, this.options, c), !(c instanceof l)) {
        if (typeof c == "string" && c === this.version)
          return 0;
        c = new l(c, this.options);
      }
      return c.version === this.version ? 0 : this.compareMain(c) || this.comparePre(c);
    }
    compareMain(c) {
      return c instanceof l || (c = new l(c, this.options)), o(this.major, c.major) || o(this.minor, c.minor) || o(this.patch, c.patch);
    }
    comparePre(c) {
      if (c instanceof l || (c = new l(c, this.options)), this.prerelease.length && !c.prerelease.length)
        return -1;
      if (!this.prerelease.length && c.prerelease.length)
        return 1;
      if (!this.prerelease.length && !c.prerelease.length)
        return 0;
      let T = 0;
      do {
        const u = this.prerelease[T], d = c.prerelease[T];
        if (r("prerelease compare", T, u, d), u === void 0 && d === void 0)
          return 0;
        if (d === void 0)
          return 1;
        if (u === void 0)
          return -1;
        if (u === d)
          continue;
        return o(u, d);
      } while (++T);
    }
    compareBuild(c) {
      c instanceof l || (c = new l(c, this.options));
      let T = 0;
      do {
        const u = this.build[T], d = c.build[T];
        if (r("prerelease compare", T, u, d), u === void 0 && d === void 0)
          return 0;
        if (d === void 0)
          return 1;
        if (u === void 0)
          return -1;
        if (u === d)
          continue;
        return o(u, d);
      } while (++T);
    }
    // preminor will bump the version up to the next minor release, and immediately
    // down to pre-release. premajor and prepatch work the same way.
    inc(c, T) {
      switch (c) {
        case "premajor":
          this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", T);
          break;
        case "preminor":
          this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", T);
          break;
        case "prepatch":
          this.prerelease.length = 0, this.inc("patch", T), this.inc("pre", T);
          break;
        case "prerelease":
          this.prerelease.length === 0 && this.inc("patch", T), this.inc("pre", T);
          break;
        case "major":
          (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) && this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
          break;
        case "minor":
          (this.patch !== 0 || this.prerelease.length === 0) && this.minor++, this.patch = 0, this.prerelease = [];
          break;
        case "patch":
          this.prerelease.length === 0 && this.patch++, this.prerelease = [];
          break;
        case "pre":
          if (this.prerelease.length === 0)
            this.prerelease = [0];
          else {
            let u = this.prerelease.length;
            for (; --u >= 0; )
              typeof this.prerelease[u] == "number" && (this.prerelease[u]++, u = -2);
            u === -1 && this.prerelease.push(0);
          }
          T && (o(this.prerelease[0], T) === 0 ? isNaN(this.prerelease[1]) && (this.prerelease = [T, 0]) : this.prerelease = [T, 0]);
          break;
        default:
          throw new Error(`invalid increment argument: ${c}`);
      }
      return this.format(), this.raw = this.version, this;
    }
  }
  return ys = l, ys;
}
var bs, kA;
function IS() {
  if (kA)
    return bs;
  kA = 1;
  const { MAX_LENGTH: r } = $u(), { re: e, t } = rm(), n = im(), i = nm();
  return bs = (o, l) => {
    if (l = i(l), o instanceof n)
      return o;
    if (typeof o != "string" || o.length > r || !(l.loose ? e[t.LOOSE] : e[t.FULL]).test(o))
      return null;
    try {
      return new n(o, l);
    } catch {
      return null;
    }
  }, bs;
}
var Cs, PA;
function BS() {
  if (PA)
    return Cs;
  PA = 1;
  const r = IS();
  return Cs = (t, n) => {
    const i = r(t, n);
    return i ? i.version : null;
  }, Cs;
}
var _s, GA;
function ZS() {
  if (GA)
    return _s;
  GA = 1;
  const r = im();
  return _s = (t, n) => new r(t, n).major, _s;
}
var UA;
function am() {
  if (UA)
    return mr;
  UA = 1, Object.defineProperty(mr, "__esModule", { value: !0 });
  var r = BS(), e = ZS();
  function t(d) {
    return d && typeof d == "object" && "default" in d ? d : { default: d };
  }
  var n = /* @__PURE__ */ t(r), i = /* @__PURE__ */ t(e), s = (
    /** @class */
    function() {
      function d(A) {
        typeof A.getVersion != "function" || !n.default(A.getVersion()) ? console.warn("Proxying an event bus with an unknown or invalid version") : i.default(A.getVersion()) !== i.default(this.getVersion()) && console.warn("Proxying an event bus of version " + A.getVersion() + " with " + this.getVersion()), this.bus = A;
      }
      return d.prototype.getVersion = function() {
        return "3.0.1";
      }, d.prototype.subscribe = function(A, f) {
        this.bus.subscribe(A, f);
      }, d.prototype.unsubscribe = function(A, f) {
        this.bus.unsubscribe(A, f);
      }, d.prototype.emit = function(A, f) {
        this.bus.emit(A, f);
      }, d;
    }()
  ), o = (
    /** @class */
    function() {
      function d() {
        this.handlers = /* @__PURE__ */ new Map();
      }
      return d.prototype.getVersion = function() {
        return "3.0.1";
      }, d.prototype.subscribe = function(A, f) {
        this.handlers.set(A, (this.handlers.get(A) || []).concat(f));
      }, d.prototype.unsubscribe = function(A, f) {
        this.handlers.set(A, (this.handlers.get(A) || []).filter(function(h) {
          return h != f;
        }));
      }, d.prototype.emit = function(A, f) {
        (this.handlers.get(A) || []).forEach(function(h) {
          try {
            h(f);
          } catch (S) {
            console.error("could not invoke event listener", S);
          }
        });
      }, d;
    }()
  );
  function l() {
    return typeof window.OC < "u" && window.OC._eventBus && typeof window._nc_event_bus > "u" && (console.warn("found old event bus instance at OC._eventBus. Update your version!"), window._nc_event_bus = window.OC._eventBus), typeof window._nc_event_bus < "u" ? new s(window._nc_event_bus) : window._nc_event_bus = new o();
  }
  var a = l();
  function c(d, A) {
    a.subscribe(d, A);
  }
  function T(d, A) {
    a.unsubscribe(d, A);
  }
  function u(d, A) {
    a.emit(d, A);
  }
  return mr.ProxyBus = s, mr.SimpleBus = o, mr.emit = u, mr.subscribe = c, mr.unsubscribe = T, mr;
}
var HA;
function Vu() {
  if (HA)
    return Xr;
  HA = 1, Object.defineProperty(Xr, "__esModule", { value: !0 });
  var r = am(), e = document.getElementsByTagName("head")[0], t = e ? e.getAttribute("data-requesttoken") : null, n = [];
  function i() {
    return t;
  }
  function s(d) {
    n.push(d);
  }
  r.subscribe("csrf-token-update", function(d) {
    t = d.token, n.forEach(function(A) {
      try {
        A(d.token);
      } catch (f) {
        console.error("error updating CSRF token observer", f);
      }
    });
  });
  var o = function(d, A) {
    return d ? d.getAttribute(A) : null;
  }, l = document.getElementsByTagName("head")[0], a = o(l, "data-user"), c = o(l, "data-user-displayname"), T = typeof OC > "u" ? !1 : OC.isUserAdmin();
  function u() {
    return a === null ? null : {
      uid: a,
      displayName: c,
      isAdmin: T
    };
  }
  return Xr.getCurrentUser = u, Xr.getRequestToken = i, Xr.onRequestTokenUpdate = s, Xr;
}
var jA;
function wS() {
  if (jA)
    return Yn;
  jA = 1, dr(), xh(), Hu(), zh(), $h(), Object.defineProperty(Yn, "__esModule", {
    value: !0
  }), Yn.LoggerBuilder = void 0, qh(), Wh(), Jh(), Xh(), Ai(), em();
  var r = Vu(), e = zu();
  function t(T) {
    return t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(u) {
      return typeof u;
    } : function(u) {
      return u && typeof Symbol == "function" && u.constructor === Symbol && u !== Symbol.prototype ? "symbol" : typeof u;
    }, t(T);
  }
  function n(T, u) {
    if (!(T instanceof u))
      throw new TypeError("Cannot call a class as a function");
  }
  function i(T, u) {
    for (var d = 0; d < u.length; d++) {
      var A = u[d];
      A.enumerable = A.enumerable || !1, A.configurable = !0, "value" in A && (A.writable = !0), Object.defineProperty(T, l(A.key), A);
    }
  }
  function s(T, u, d) {
    return u && i(T.prototype, u), d && i(T, d), Object.defineProperty(T, "prototype", { writable: !1 }), T;
  }
  function o(T, u, d) {
    return u = l(u), u in T ? Object.defineProperty(T, u, { value: d, enumerable: !0, configurable: !0, writable: !0 }) : T[u] = d, T;
  }
  function l(T) {
    var u = a(T, "string");
    return t(u) === "symbol" ? u : String(u);
  }
  function a(T, u) {
    if (t(T) !== "object" || T === null)
      return T;
    var d = T[Symbol.toPrimitive];
    if (d !== void 0) {
      var A = d.call(T, u || "default");
      if (t(A) !== "object")
        return A;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (u === "string" ? String : Number)(T);
  }
  var c = /* @__PURE__ */ function() {
    function T(u) {
      n(this, T), o(this, "context", void 0), o(this, "factory", void 0), this.context = {}, this.factory = u;
    }
    return s(T, [{
      key: "setApp",
      value: function(d) {
        return this.context.app = d, this;
      }
      /** Set the logging level within the logging context */
    }, {
      key: "setLogLevel",
      value: function(d) {
        return this.context.level = d, this;
      }
      /** Set the user id within the logging context
       * @see {@link detectUser}
      */
    }, {
      key: "setUid",
      value: function(d) {
        return this.context.uid = d, this;
      }
      /** Detect the currently logged in user and set the user id within the logging context */
    }, {
      key: "detectUser",
      value: function() {
        var d = (0, r.getCurrentUser)();
        return d !== null && (this.context.uid = d.uid), this;
      }
      /** Detect and use logging level configured in nextcloud config */
    }, {
      key: "detectLogLevel",
      value: function() {
        var d = this, A = function f() {
          if (document.readyState === "complete" || document.readyState === "interactive" && window.OC !== void 0) {
            var h, S, p;
            d.context.level = ((h = window.OC) === null || h === void 0 || (S = h.config) === null || S === void 0 ? void 0 : S.loglevel) !== void 0 ? window.OC.config.loglevel : e.LogLevel.Warn, (p = window.OC) !== null && p !== void 0 && p.debug && (d.context.level = e.LogLevel.Debug), document.removeEventListener("readystatechange", f);
          } else
            document.addEventListener("readystatechange", f);
        };
        return A(), this;
      }
      /** Build a logger using the logging context and factory */
    }, {
      key: "build",
      value: function() {
        return this.context.level === void 0 && this.detectLogLevel(), this.factory(this.context);
      }
    }]), T;
  }();
  return Yn.LoggerBuilder = c, Yn;
}
var zA;
function om() {
  return zA || (zA = 1, function(r) {
    dr(), Object.defineProperty(r, "__esModule", {
      value: !0
    }), Object.defineProperty(r, "LogLevel", {
      enumerable: !0,
      get: function() {
        return n.LogLevel;
      }
    }), r.getLogger = s, r.getLoggerBuilder = i;
    var e = _S(), t = wS(), n = zu();
    function i() {
      return new t.LoggerBuilder(e.buildConsoleLogger);
    }
    function s() {
      return i().build();
    }
  }(L0)), L0;
}
var ua = {}, xS = {
  get exports() {
    return ua;
  },
  set exports(r) {
    ua = r;
  }
}, jn = {}, LS = {
  get exports() {
    return jn;
  },
  set exports(r) {
    jn = r;
  }
}, Ms, $A;
function sm() {
  return $A || ($A = 1, Ms = function(e, t) {
    return function() {
      for (var i = new Array(arguments.length), s = 0; s < i.length; s++)
        i[s] = arguments[s];
      return e.apply(t, i);
    };
  }), Ms;
}
var Ys, VA;
function lt() {
  if (VA)
    return Ys;
  VA = 1;
  var r = sm(), e = Object.prototype.toString, t = function(_) {
    return function(z) {
      var E = e.call(z);
      return _[E] || (_[E] = E.slice(8, -1).toLowerCase());
    };
  }(/* @__PURE__ */ Object.create(null));
  function n(_) {
    return _ = _.toLowerCase(), function(E) {
      return t(E) === _;
    };
  }
  function i(_) {
    return Array.isArray(_);
  }
  function s(_) {
    return typeof _ > "u";
  }
  function o(_) {
    return _ !== null && !s(_) && _.constructor !== null && !s(_.constructor) && typeof _.constructor.isBuffer == "function" && _.constructor.isBuffer(_);
  }
  var l = n("ArrayBuffer");
  function a(_) {
    var z;
    return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? z = ArrayBuffer.isView(_) : z = _ && _.buffer && l(_.buffer), z;
  }
  function c(_) {
    return typeof _ == "string";
  }
  function T(_) {
    return typeof _ == "number";
  }
  function u(_) {
    return _ !== null && typeof _ == "object";
  }
  function d(_) {
    if (t(_) !== "object")
      return !1;
    var z = Object.getPrototypeOf(_);
    return z === null || z === Object.prototype;
  }
  var A = n("Date"), f = n("File"), h = n("Blob"), S = n("FileList");
  function p(_) {
    return e.call(_) === "[object Function]";
  }
  function m(_) {
    return u(_) && p(_.pipe);
  }
  function g(_) {
    var z = "[object FormData]";
    return _ && (typeof FormData == "function" && _ instanceof FormData || e.call(_) === z || p(_.toString) && _.toString() === z);
  }
  var N = n("URLSearchParams");
  function R(_) {
    return _.trim ? _.trim() : _.replace(/^\s+|\s+$/g, "");
  }
  function D() {
    return typeof navigator < "u" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS") ? !1 : typeof window < "u" && typeof document < "u";
  }
  function v(_, z) {
    if (!(_ === null || typeof _ > "u"))
      if (typeof _ != "object" && (_ = [_]), i(_))
        for (var E = 0, C = _.length; E < C; E++)
          z.call(null, _[E], E, _);
      else
        for (var P in _)
          Object.prototype.hasOwnProperty.call(_, P) && z.call(null, _[P], P, _);
  }
  function O() {
    var _ = {};
    function z(P, M) {
      d(_[M]) && d(P) ? _[M] = O(_[M], P) : d(P) ? _[M] = O({}, P) : i(P) ? _[M] = P.slice() : _[M] = P;
    }
    for (var E = 0, C = arguments.length; E < C; E++)
      v(arguments[E], z);
    return _;
  }
  function y(_, z, E) {
    return v(z, function(P, M) {
      E && typeof P == "function" ? _[M] = r(P, E) : _[M] = P;
    }), _;
  }
  function Z(_) {
    return _.charCodeAt(0) === 65279 && (_ = _.slice(1)), _;
  }
  function F(_, z, E, C) {
    _.prototype = Object.create(z.prototype, C), _.prototype.constructor = _, E && Object.assign(_.prototype, E);
  }
  function b(_, z, E) {
    var C, P, M, Q = {};
    z = z || {};
    do {
      for (C = Object.getOwnPropertyNames(_), P = C.length; P-- > 0; )
        M = C[P], Q[M] || (z[M] = _[M], Q[M] = !0);
      _ = Object.getPrototypeOf(_);
    } while (_ && (!E || E(_, z)) && _ !== Object.prototype);
    return z;
  }
  function Y(_, z, E) {
    _ = String(_), (E === void 0 || E > _.length) && (E = _.length), E -= z.length;
    var C = _.indexOf(z, E);
    return C !== -1 && C === E;
  }
  function I(_) {
    if (!_)
      return null;
    var z = _.length;
    if (s(z))
      return null;
    for (var E = new Array(z); z-- > 0; )
      E[z] = _[z];
    return E;
  }
  var q = function(_) {
    return function(z) {
      return _ && z instanceof _;
    };
  }(typeof Uint8Array < "u" && Object.getPrototypeOf(Uint8Array));
  return Ys = {
    isArray: i,
    isArrayBuffer: l,
    isBuffer: o,
    isFormData: g,
    isArrayBufferView: a,
    isString: c,
    isNumber: T,
    isObject: u,
    isPlainObject: d,
    isUndefined: s,
    isDate: A,
    isFile: f,
    isBlob: h,
    isFunction: p,
    isStream: m,
    isURLSearchParams: N,
    isStandardBrowserEnv: D,
    forEach: v,
    merge: O,
    extend: y,
    trim: R,
    stripBOM: Z,
    inherits: F,
    toFlatObject: b,
    kindOf: t,
    kindOfTest: n,
    endsWith: Y,
    toArray: I,
    isTypedArray: q,
    isFileList: S
  }, Ys;
}
var Is, qA;
function lm() {
  if (qA)
    return Is;
  qA = 1;
  var r = lt();
  function e(t) {
    return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
  }
  return Is = function(n, i, s) {
    if (!i)
      return n;
    var o;
    if (s)
      o = s(i);
    else if (r.isURLSearchParams(i))
      o = i.toString();
    else {
      var l = [];
      r.forEach(i, function(T, u) {
        T === null || typeof T > "u" || (r.isArray(T) ? u = u + "[]" : T = [T], r.forEach(T, function(A) {
          r.isDate(A) ? A = A.toISOString() : r.isObject(A) && (A = JSON.stringify(A)), l.push(e(u) + "=" + e(A));
        }));
      }), o = l.join("&");
    }
    if (o) {
      var a = n.indexOf("#");
      a !== -1 && (n = n.slice(0, a)), n += (n.indexOf("?") === -1 ? "?" : "&") + o;
    }
    return n;
  }, Is;
}
var Bs, WA;
function kS() {
  if (WA)
    return Bs;
  WA = 1;
  var r = lt();
  function e() {
    this.handlers = [];
  }
  return e.prototype.use = function(n, i, s) {
    return this.handlers.push({
      fulfilled: n,
      rejected: i,
      synchronous: s ? s.synchronous : !1,
      runWhen: s ? s.runWhen : null
    }), this.handlers.length - 1;
  }, e.prototype.eject = function(n) {
    this.handlers[n] && (this.handlers[n] = null);
  }, e.prototype.forEach = function(n) {
    r.forEach(this.handlers, function(s) {
      s !== null && n(s);
    });
  }, Bs = e, Bs;
}
var Zs, QA;
function PS() {
  if (QA)
    return Zs;
  QA = 1;
  var r = lt();
  return Zs = function(t, n) {
    r.forEach(t, function(s, o) {
      o !== n && o.toUpperCase() === n.toUpperCase() && (t[n] = s, delete t[o]);
    });
  }, Zs;
}
var ws, KA;
function On() {
  if (KA)
    return ws;
  KA = 1;
  var r = lt();
  function e(i, s, o, l, a) {
    Error.call(this), this.message = i, this.name = "AxiosError", s && (this.code = s), o && (this.config = o), l && (this.request = l), a && (this.response = a);
  }
  r.inherits(e, Error, {
    toJSON: function() {
      return {
        // Standard
        message: this.message,
        name: this.name,
        // Microsoft
        description: this.description,
        number: this.number,
        // Mozilla
        fileName: this.fileName,
        lineNumber: this.lineNumber,
        columnNumber: this.columnNumber,
        stack: this.stack,
        // Axios
        config: this.config,
        code: this.code,
        status: this.response && this.response.status ? this.response.status : null
      };
    }
  });
  var t = e.prototype, n = {};
  return [
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED"
    // eslint-disable-next-line func-names
  ].forEach(function(i) {
    n[i] = { value: i };
  }), Object.defineProperties(e, n), Object.defineProperty(t, "isAxiosError", { value: !0 }), e.from = function(i, s, o, l, a, c) {
    var T = Object.create(t);
    return r.toFlatObject(i, T, function(d) {
      return d !== Error.prototype;
    }), e.call(T, i.message, s, o, l, a), T.name = i.name, c && Object.assign(T, c), T;
  }, ws = e, ws;
}
var xs, JA;
function um() {
  return JA || (JA = 1, xs = {
    silentJSONParsing: !0,
    forcedJSONParsing: !0,
    clarifyTimeoutError: !1
  }), xs;
}
var Ls, XA;
function cm() {
  if (XA)
    return Ls;
  XA = 1;
  var r = lt();
  function e(t, n) {
    n = n || new FormData();
    var i = [];
    function s(l) {
      return l === null ? "" : r.isDate(l) ? l.toISOString() : r.isArrayBuffer(l) || r.isTypedArray(l) ? typeof Blob == "function" ? new Blob([l]) : Buffer.from(l) : l;
    }
    function o(l, a) {
      if (r.isPlainObject(l) || r.isArray(l)) {
        if (i.indexOf(l) !== -1)
          throw Error("Circular reference detected in " + a);
        i.push(l), r.forEach(l, function(T, u) {
          if (!r.isUndefined(T)) {
            var d = a ? a + "." + u : u, A;
            if (T && !a && typeof T == "object") {
              if (r.endsWith(u, "{}"))
                T = JSON.stringify(T);
              else if (r.endsWith(u, "[]") && (A = r.toArray(T))) {
                A.forEach(function(f) {
                  !r.isUndefined(f) && n.append(d, s(f));
                });
                return;
              }
            }
            o(T, d);
          }
        }), i.pop();
      } else
        n.append(a, s(l));
    }
    return o(t), n;
  }
  return Ls = e, Ls;
}
var ks, ef;
function GS() {
  if (ef)
    return ks;
  ef = 1;
  var r = On();
  return ks = function(t, n, i) {
    var s = i.config.validateStatus;
    !i.status || !s || s(i.status) ? t(i) : n(new r(
      "Request failed with status code " + i.status,
      [r.ERR_BAD_REQUEST, r.ERR_BAD_RESPONSE][Math.floor(i.status / 100) - 4],
      i.config,
      i.request,
      i
    ));
  }, ks;
}
var Ps, tf;
function US() {
  if (tf)
    return Ps;
  tf = 1;
  var r = lt();
  return Ps = r.isStandardBrowserEnv() ? (
    // Standard browser envs support document.cookie
    function() {
      return {
        write: function(n, i, s, o, l, a) {
          var c = [];
          c.push(n + "=" + encodeURIComponent(i)), r.isNumber(s) && c.push("expires=" + new Date(s).toGMTString()), r.isString(o) && c.push("path=" + o), r.isString(l) && c.push("domain=" + l), a === !0 && c.push("secure"), document.cookie = c.join("; ");
        },
        read: function(n) {
          var i = document.cookie.match(new RegExp("(^|;\\s*)(" + n + ")=([^;]*)"));
          return i ? decodeURIComponent(i[3]) : null;
        },
        remove: function(n) {
          this.write(n, "", Date.now() - 864e5);
        }
      };
    }()
  ) : (
    // Non standard browser env (web workers, react-native) lack needed support.
    function() {
      return {
        write: function() {
        },
        read: function() {
          return null;
        },
        remove: function() {
        }
      };
    }()
  ), Ps;
}
var Gs, rf;
function HS() {
  return rf || (rf = 1, Gs = function(e) {
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
  }), Gs;
}
var Us, nf;
function jS() {
  return nf || (nf = 1, Us = function(e, t) {
    return t ? e.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : e;
  }), Us;
}
var Hs, af;
function Tm() {
  if (af)
    return Hs;
  af = 1;
  var r = HS(), e = jS();
  return Hs = function(n, i) {
    return n && !r(i) ? e(n, i) : i;
  }, Hs;
}
var js, of;
function zS() {
  if (of)
    return js;
  of = 1;
  var r = lt(), e = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ];
  return js = function(n) {
    var i = {}, s, o, l;
    return n && r.forEach(n.split(`
`), function(c) {
      if (l = c.indexOf(":"), s = r.trim(c.substr(0, l)).toLowerCase(), o = r.trim(c.substr(l + 1)), s) {
        if (i[s] && e.indexOf(s) >= 0)
          return;
        s === "set-cookie" ? i[s] = (i[s] ? i[s] : []).concat([o]) : i[s] = i[s] ? i[s] + ", " + o : o;
      }
    }), i;
  }, js;
}
var zs, sf;
function $S() {
  if (sf)
    return zs;
  sf = 1;
  var r = lt();
  return zs = r.isStandardBrowserEnv() ? (
    // Standard browser envs have full support of the APIs needed to test
    // whether the request URL is of the same origin as current location.
    function() {
      var t = /(msie|trident)/i.test(navigator.userAgent), n = document.createElement("a"), i;
      function s(o) {
        var l = o;
        return t && (n.setAttribute("href", l), l = n.href), n.setAttribute("href", l), {
          href: n.href,
          protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
          host: n.host,
          search: n.search ? n.search.replace(/^\?/, "") : "",
          hash: n.hash ? n.hash.replace(/^#/, "") : "",
          hostname: n.hostname,
          port: n.port,
          pathname: n.pathname.charAt(0) === "/" ? n.pathname : "/" + n.pathname
        };
      }
      return i = s(window.location.href), function(l) {
        var a = r.isString(l) ? s(l) : l;
        return a.protocol === i.protocol && a.host === i.host;
      };
    }()
  ) : (
    // Non standard browser envs (web workers, react-native) lack needed support.
    function() {
      return function() {
        return !0;
      };
    }()
  ), zs;
}
var $s, lf;
function ka() {
  if (lf)
    return $s;
  lf = 1;
  var r = On(), e = lt();
  function t(n) {
    r.call(this, n == null ? "canceled" : n, r.ERR_CANCELED), this.name = "CanceledError";
  }
  return e.inherits(t, r, {
    __CANCEL__: !0
  }), $s = t, $s;
}
var Vs, uf;
function VS() {
  return uf || (uf = 1, Vs = function(e) {
    var t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
    return t && t[1] || "";
  }), Vs;
}
var qs, cf;
function Tf() {
  if (cf)
    return qs;
  cf = 1;
  var r = lt(), e = GS(), t = US(), n = lm(), i = Tm(), s = zS(), o = $S(), l = um(), a = On(), c = ka(), T = VS();
  return qs = function(d) {
    return new Promise(function(f, h) {
      var S = d.data, p = d.headers, m = d.responseType, g;
      function N() {
        d.cancelToken && d.cancelToken.unsubscribe(g), d.signal && d.signal.removeEventListener("abort", g);
      }
      r.isFormData(S) && r.isStandardBrowserEnv() && delete p["Content-Type"];
      var R = new XMLHttpRequest();
      if (d.auth) {
        var D = d.auth.username || "", v = d.auth.password ? unescape(encodeURIComponent(d.auth.password)) : "";
        p.Authorization = "Basic " + btoa(D + ":" + v);
      }
      var O = i(d.baseURL, d.url);
      R.open(d.method.toUpperCase(), n(O, d.params, d.paramsSerializer), !0), R.timeout = d.timeout;
      function y() {
        if (R) {
          var b = "getAllResponseHeaders" in R ? s(R.getAllResponseHeaders()) : null, Y = !m || m === "text" || m === "json" ? R.responseText : R.response, I = {
            data: Y,
            status: R.status,
            statusText: R.statusText,
            headers: b,
            config: d,
            request: R
          };
          e(function(_) {
            f(_), N();
          }, function(_) {
            h(_), N();
          }, I), R = null;
        }
      }
      if ("onloadend" in R ? R.onloadend = y : R.onreadystatechange = function() {
        !R || R.readyState !== 4 || R.status === 0 && !(R.responseURL && R.responseURL.indexOf("file:") === 0) || setTimeout(y);
      }, R.onabort = function() {
        R && (h(new a("Request aborted", a.ECONNABORTED, d, R)), R = null);
      }, R.onerror = function() {
        h(new a("Network Error", a.ERR_NETWORK, d, R, R)), R = null;
      }, R.ontimeout = function() {
        var Y = d.timeout ? "timeout of " + d.timeout + "ms exceeded" : "timeout exceeded", I = d.transitional || l;
        d.timeoutErrorMessage && (Y = d.timeoutErrorMessage), h(new a(
          Y,
          I.clarifyTimeoutError ? a.ETIMEDOUT : a.ECONNABORTED,
          d,
          R
        )), R = null;
      }, r.isStandardBrowserEnv()) {
        var Z = (d.withCredentials || o(O)) && d.xsrfCookieName ? t.read(d.xsrfCookieName) : void 0;
        Z && (p[d.xsrfHeaderName] = Z);
      }
      "setRequestHeader" in R && r.forEach(p, function(Y, I) {
        typeof S > "u" && I.toLowerCase() === "content-type" ? delete p[I] : R.setRequestHeader(I, Y);
      }), r.isUndefined(d.withCredentials) || (R.withCredentials = !!d.withCredentials), m && m !== "json" && (R.responseType = d.responseType), typeof d.onDownloadProgress == "function" && R.addEventListener("progress", d.onDownloadProgress), typeof d.onUploadProgress == "function" && R.upload && R.upload.addEventListener("progress", d.onUploadProgress), (d.cancelToken || d.signal) && (g = function(b) {
        R && (h(!b || b && b.type ? new c() : b), R.abort(), R = null);
      }, d.cancelToken && d.cancelToken.subscribe(g), d.signal && (d.signal.aborted ? g() : d.signal.addEventListener("abort", g))), S || (S = null);
      var F = T(O);
      if (F && ["http", "https", "file"].indexOf(F) === -1) {
        h(new a("Unsupported protocol " + F + ":", a.ERR_BAD_REQUEST, d));
        return;
      }
      R.send(S);
    });
  }, qs;
}
var Ws, df;
function qS() {
  return df || (df = 1, Ws = null), Ws;
}
var Qs, Af;
function qu() {
  if (Af)
    return Qs;
  Af = 1;
  var r = lt(), e = PS(), t = On(), n = um(), i = cm(), s = {
    "Content-Type": "application/x-www-form-urlencoded"
  };
  function o(T, u) {
    !r.isUndefined(T) && r.isUndefined(T["Content-Type"]) && (T["Content-Type"] = u);
  }
  function l() {
    var T;
    return (typeof XMLHttpRequest < "u" || typeof process < "u" && Object.prototype.toString.call(process) === "[object process]") && (T = Tf()), T;
  }
  function a(T, u, d) {
    if (r.isString(T))
      try {
        return (u || JSON.parse)(T), r.trim(T);
      } catch (A) {
        if (A.name !== "SyntaxError")
          throw A;
      }
    return (d || JSON.stringify)(T);
  }
  var c = {
    transitional: n,
    adapter: l(),
    transformRequest: [function(u, d) {
      if (e(d, "Accept"), e(d, "Content-Type"), r.isFormData(u) || r.isArrayBuffer(u) || r.isBuffer(u) || r.isStream(u) || r.isFile(u) || r.isBlob(u))
        return u;
      if (r.isArrayBufferView(u))
        return u.buffer;
      if (r.isURLSearchParams(u))
        return o(d, "application/x-www-form-urlencoded;charset=utf-8"), u.toString();
      var A = r.isObject(u), f = d && d["Content-Type"], h;
      if ((h = r.isFileList(u)) || A && f === "multipart/form-data") {
        var S = this.env && this.env.FormData;
        return i(h ? { "files[]": u } : u, S && new S());
      } else if (A || f === "application/json")
        return o(d, "application/json"), a(u);
      return u;
    }],
    transformResponse: [function(u) {
      var d = this.transitional || c.transitional, A = d && d.silentJSONParsing, f = d && d.forcedJSONParsing, h = !A && this.responseType === "json";
      if (h || f && r.isString(u) && u.length)
        try {
          return JSON.parse(u);
        } catch (S) {
          if (h)
            throw S.name === "SyntaxError" ? t.from(S, t.ERR_BAD_RESPONSE, this, null, this.response) : S;
        }
      return u;
    }],
    /**
     * A timeout in milliseconds to abort a request. If set to 0 (default) a
     * timeout is not created.
     */
    timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
      FormData: qS()
    },
    validateStatus: function(u) {
      return u >= 200 && u < 300;
    },
    headers: {
      common: {
        Accept: "application/json, text/plain, */*"
      }
    }
  };
  return r.forEach(["delete", "get", "head"], function(u) {
    c.headers[u] = {};
  }), r.forEach(["post", "put", "patch"], function(u) {
    c.headers[u] = r.merge(s);
  }), Qs = c, Qs;
}
var Ks, ff;
function WS() {
  if (ff)
    return Ks;
  ff = 1;
  var r = lt(), e = qu();
  return Ks = function(n, i, s) {
    var o = this || e;
    return r.forEach(s, function(a) {
      n = a.call(o, n, i);
    }), n;
  }, Ks;
}
var Js, pf;
function dm() {
  return pf || (pf = 1, Js = function(e) {
    return !!(e && e.__CANCEL__);
  }), Js;
}
var Xs, hf;
function QS() {
  if (hf)
    return Xs;
  hf = 1;
  var r = lt(), e = WS(), t = dm(), n = qu(), i = ka();
  function s(o) {
    if (o.cancelToken && o.cancelToken.throwIfRequested(), o.signal && o.signal.aborted)
      throw new i();
  }
  return Xs = function(l) {
    s(l), l.headers = l.headers || {}, l.data = e.call(
      l,
      l.data,
      l.headers,
      l.transformRequest
    ), l.headers = r.merge(
      l.headers.common || {},
      l.headers[l.method] || {},
      l.headers
    ), r.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      function(T) {
        delete l.headers[T];
      }
    );
    var a = l.adapter || n.adapter;
    return a(l).then(function(T) {
      return s(l), T.data = e.call(
        l,
        T.data,
        T.headers,
        l.transformResponse
      ), T;
    }, function(T) {
      return t(T) || (s(l), T && T.response && (T.response.data = e.call(
        l,
        T.response.data,
        T.response.headers,
        l.transformResponse
      ))), Promise.reject(T);
    });
  }, Xs;
}
var el, mf;
function Am() {
  if (mf)
    return el;
  mf = 1;
  var r = lt();
  return el = function(t, n) {
    n = n || {};
    var i = {};
    function s(u, d) {
      return r.isPlainObject(u) && r.isPlainObject(d) ? r.merge(u, d) : r.isPlainObject(d) ? r.merge({}, d) : r.isArray(d) ? d.slice() : d;
    }
    function o(u) {
      if (r.isUndefined(n[u])) {
        if (!r.isUndefined(t[u]))
          return s(void 0, t[u]);
      } else
        return s(t[u], n[u]);
    }
    function l(u) {
      if (!r.isUndefined(n[u]))
        return s(void 0, n[u]);
    }
    function a(u) {
      if (r.isUndefined(n[u])) {
        if (!r.isUndefined(t[u]))
          return s(void 0, t[u]);
      } else
        return s(void 0, n[u]);
    }
    function c(u) {
      if (u in n)
        return s(t[u], n[u]);
      if (u in t)
        return s(void 0, t[u]);
    }
    var T = {
      url: l,
      method: l,
      data: l,
      baseURL: a,
      transformRequest: a,
      transformResponse: a,
      paramsSerializer: a,
      timeout: a,
      timeoutMessage: a,
      withCredentials: a,
      adapter: a,
      responseType: a,
      xsrfCookieName: a,
      xsrfHeaderName: a,
      onUploadProgress: a,
      onDownloadProgress: a,
      decompress: a,
      maxContentLength: a,
      maxBodyLength: a,
      beforeRedirect: a,
      transport: a,
      httpAgent: a,
      httpsAgent: a,
      cancelToken: a,
      socketPath: a,
      responseEncoding: a,
      validateStatus: c
    };
    return r.forEach(Object.keys(t).concat(Object.keys(n)), function(d) {
      var A = T[d] || o, f = A(d);
      r.isUndefined(f) && A !== c || (i[d] = f);
    }), i;
  }, el;
}
var tl, Ef;
function fm() {
  return Ef || (Ef = 1, tl = {
    version: "0.27.2"
  }), tl;
}
var rl, Sf;
function KS() {
  if (Sf)
    return rl;
  Sf = 1;
  var r = fm().version, e = On(), t = {};
  ["object", "boolean", "number", "function", "string", "symbol"].forEach(function(s, o) {
    t[s] = function(a) {
      return typeof a === s || "a" + (o < 1 ? "n " : " ") + s;
    };
  });
  var n = {};
  t.transitional = function(o, l, a) {
    function c(T, u) {
      return "[Axios v" + r + "] Transitional option '" + T + "'" + u + (a ? ". " + a : "");
    }
    return function(T, u, d) {
      if (o === !1)
        throw new e(
          c(u, " has been removed" + (l ? " in " + l : "")),
          e.ERR_DEPRECATED
        );
      return l && !n[u] && (n[u] = !0, console.warn(
        c(
          u,
          " has been deprecated since v" + l + " and will be removed in the near future"
        )
      )), o ? o(T, u, d) : !0;
    };
  };
  function i(s, o, l) {
    if (typeof s != "object")
      throw new e("options must be an object", e.ERR_BAD_OPTION_VALUE);
    for (var a = Object.keys(s), c = a.length; c-- > 0; ) {
      var T = a[c], u = o[T];
      if (u) {
        var d = s[T], A = d === void 0 || u(d, T, s);
        if (A !== !0)
          throw new e("option " + T + " must be " + A, e.ERR_BAD_OPTION_VALUE);
        continue;
      }
      if (l !== !0)
        throw new e("Unknown option " + T, e.ERR_BAD_OPTION);
    }
  }
  return rl = {
    assertOptions: i,
    validators: t
  }, rl;
}
var nl, Df;
function JS() {
  if (Df)
    return nl;
  Df = 1;
  var r = lt(), e = lm(), t = kS(), n = QS(), i = Am(), s = Tm(), o = KS(), l = o.validators;
  function a(c) {
    this.defaults = c, this.interceptors = {
      request: new t(),
      response: new t()
    };
  }
  return a.prototype.request = function(T, u) {
    typeof T == "string" ? (u = u || {}, u.url = T) : u = T || {}, u = i(this.defaults, u), u.method ? u.method = u.method.toLowerCase() : this.defaults.method ? u.method = this.defaults.method.toLowerCase() : u.method = "get";
    var d = u.transitional;
    d !== void 0 && o.assertOptions(d, {
      silentJSONParsing: l.transitional(l.boolean),
      forcedJSONParsing: l.transitional(l.boolean),
      clarifyTimeoutError: l.transitional(l.boolean)
    }, !1);
    var A = [], f = !0;
    this.interceptors.request.forEach(function(D) {
      typeof D.runWhen == "function" && D.runWhen(u) === !1 || (f = f && D.synchronous, A.unshift(D.fulfilled, D.rejected));
    });
    var h = [];
    this.interceptors.response.forEach(function(D) {
      h.push(D.fulfilled, D.rejected);
    });
    var S;
    if (!f) {
      var p = [n, void 0];
      for (Array.prototype.unshift.apply(p, A), p = p.concat(h), S = Promise.resolve(u); p.length; )
        S = S.then(p.shift(), p.shift());
      return S;
    }
    for (var m = u; A.length; ) {
      var g = A.shift(), N = A.shift();
      try {
        m = g(m);
      } catch (R) {
        N(R);
        break;
      }
    }
    try {
      S = n(m);
    } catch (R) {
      return Promise.reject(R);
    }
    for (; h.length; )
      S = S.then(h.shift(), h.shift());
    return S;
  }, a.prototype.getUri = function(T) {
    T = i(this.defaults, T);
    var u = s(T.baseURL, T.url);
    return e(u, T.params, T.paramsSerializer);
  }, r.forEach(["delete", "get", "head", "options"], function(T) {
    a.prototype[T] = function(u, d) {
      return this.request(i(d || {}, {
        method: T,
        url: u,
        data: (d || {}).data
      }));
    };
  }), r.forEach(["post", "put", "patch"], function(T) {
    function u(d) {
      return function(f, h, S) {
        return this.request(i(S || {}, {
          method: T,
          headers: d ? {
            "Content-Type": "multipart/form-data"
          } : {},
          url: f,
          data: h
        }));
      };
    }
    a.prototype[T] = u(), a.prototype[T + "Form"] = u(!0);
  }), nl = a, nl;
}
var il, gf;
function XS() {
  if (gf)
    return il;
  gf = 1;
  var r = ka();
  function e(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    var n;
    this.promise = new Promise(function(o) {
      n = o;
    });
    var i = this;
    this.promise.then(function(s) {
      if (i._listeners) {
        var o, l = i._listeners.length;
        for (o = 0; o < l; o++)
          i._listeners[o](s);
        i._listeners = null;
      }
    }), this.promise.then = function(s) {
      var o, l = new Promise(function(a) {
        i.subscribe(a), o = a;
      }).then(s);
      return l.cancel = function() {
        i.unsubscribe(o);
      }, l;
    }, t(function(o) {
      i.reason || (i.reason = new r(o), n(i.reason));
    });
  }
  return e.prototype.throwIfRequested = function() {
    if (this.reason)
      throw this.reason;
  }, e.prototype.subscribe = function(n) {
    if (this.reason) {
      n(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(n) : this._listeners = [n];
  }, e.prototype.unsubscribe = function(n) {
    if (this._listeners) {
      var i = this._listeners.indexOf(n);
      i !== -1 && this._listeners.splice(i, 1);
    }
  }, e.source = function() {
    var n, i = new e(function(o) {
      n = o;
    });
    return {
      token: i,
      cancel: n
    };
  }, il = e, il;
}
var al, Rf;
function eD() {
  return Rf || (Rf = 1, al = function(e) {
    return function(n) {
      return e.apply(null, n);
    };
  }), al;
}
var ol, vf;
function tD() {
  if (vf)
    return ol;
  vf = 1;
  var r = lt();
  return ol = function(t) {
    return r.isObject(t) && t.isAxiosError === !0;
  }, ol;
}
var Nf;
function rD() {
  if (Nf)
    return jn;
  Nf = 1;
  var r = lt(), e = sm(), t = JS(), n = Am(), i = qu();
  function s(l) {
    var a = new t(l), c = e(t.prototype.request, a);
    return r.extend(c, t.prototype, a), r.extend(c, a), c.create = function(u) {
      return s(n(l, u));
    }, c;
  }
  var o = s(i);
  return o.Axios = t, o.CanceledError = ka(), o.CancelToken = XS(), o.isCancel = dm(), o.VERSION = fm().version, o.toFormData = cm(), o.AxiosError = On(), o.Cancel = o.CanceledError, o.all = function(a) {
    return Promise.all(a);
  }, o.spread = eD(), o.isAxiosError = tD(), LS.exports = o, jn.default = o, jn;
}
var Ff;
function nD() {
  return Ff || (Ff = 1, function(r) {
    r.exports = rD();
  }(xS)), ua;
}
var sl, Of;
function iD() {
  if (Of)
    return sl;
  Of = 1;
  var r = nD(), e = Vu();
  function t(l) {
    return l && typeof l == "object" && "default" in l ? l : { default: l };
  }
  var n = /* @__PURE__ */ t(r), i, s = n.default.create({
    headers: {
      requesttoken: (i = e.getRequestToken()) !== null && i !== void 0 ? i : ""
    }
  }), o = Object.assign(s, {
    CancelToken: n.default.CancelToken,
    isCancel: n.default.isCancel
  });
  return e.onRequestTokenUpdate(function(l) {
    return s.defaults.headers.requesttoken = l;
  }), sl = o, sl;
}
var en = {}, yf = {}, bf;
function pm() {
  if (bf)
    return yf;
  bf = 1;
  var r = St(), e = ju().map, t = Iu(), n = t("map");
  return r({ target: "Array", proto: !0, forced: !n }, {
    map: function(s) {
      return e(this, s, arguments.length > 1 ? arguments[1] : void 0);
    }
  }), yf;
}
var Cf = {}, _f;
function hm() {
  if (_f)
    return Cf;
  _f = 1;
  var r = St(), e = ju().filter, t = Iu(), n = t("filter");
  return r({ target: "Array", proto: !0, forced: !n }, {
    filter: function(s) {
      return e(this, s, arguments.length > 1 ? arguments[1] : void 0);
    }
  }), Cf;
}
var Mf = {}, Yf;
function mm() {
  if (Yf)
    return Mf;
  Yf = 1;
  var r = St(), e = yr(), t = La(), n = $e(), i = n(function() {
    t(1);
  });
  return r({ target: "Object", stat: !0, forced: i }, {
    keys: function(o) {
      return t(e(o));
    }
  }), Mf;
}
var If = {}, ll, Bf;
function aD() {
  if (Bf)
    return ll;
  Bf = 1;
  var r = Gt(), e = qr(), t = Je(), n = t("match");
  return ll = function(i) {
    var s;
    return r(i) && ((s = i[n]) !== void 0 ? !!s : e(i) == "RegExp");
  }, ll;
}
var ul, Zf;
function oD() {
  if (Zf)
    return ul;
  Zf = 1;
  var r = aD(), e = TypeError;
  return ul = function(t) {
    if (r(t))
      throw e("The method doesn't accept regular expressions");
    return t;
  }, ul;
}
var cl, wf;
function sD() {
  if (wf)
    return cl;
  wf = 1;
  var r = Je(), e = r("match");
  return cl = function(t) {
    var n = /./;
    try {
      "/./"[t](n);
    } catch {
      try {
        return n[e] = !1, "/./"[t](n);
      } catch {
      }
    }
    return !1;
  }, cl;
}
var xf;
function Em() {
  if (xf)
    return If;
  xf = 1;
  var r = St(), e = Ve(), t = ui().f, n = bu(), i = Kt(), s = oD(), o = Rn(), l = sD(), a = Nn(), c = e("".startsWith), T = e("".slice), u = Math.min, d = l("startsWith"), A = !a && !d && !!function() {
    var f = t(String.prototype, "startsWith");
    return f && !f.writable;
  }();
  return r({ target: "String", proto: !0, forced: !A && !d }, {
    startsWith: function(h) {
      var S = i(o(this));
      s(h);
      var p = n(u(arguments.length > 1 ? arguments[1] : void 0, S.length)), m = i(h);
      return c ? c(S, m, p) : T(S, p, p + m.length) === m;
    }
  }), If;
}
var In = {}, Bn = {}, Lf;
function Sm() {
  if (Lf)
    return Bn;
  Lf = 1, Object.defineProperty(Bn, "__esModule", {
    value: !0
  }), Bn.default = void 0, bh(), pm(), hm(), Ai(), mm(), Em(), dr();
  function r(s, o) {
    if (!(s instanceof o))
      throw new TypeError("Cannot call a class as a function");
  }
  function e(s, o) {
    for (var l = 0; l < o.length; l++) {
      var a = o[l];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(s, a.key, a);
    }
  }
  function t(s, o, l) {
    return o && e(s.prototype, o), l && e(s, l), Object.defineProperty(s, "prototype", { writable: !1 }), s;
  }
  function n(s, o, l) {
    return o in s ? Object.defineProperty(s, o, { value: l, enumerable: !0, configurable: !0, writable: !0 }) : s[o] = l, s;
  }
  var i = /* @__PURE__ */ function() {
    function s(o, l, a) {
      r(this, s), n(this, "scope", void 0), n(this, "wrapped", void 0), this.scope = "".concat(a ? s.GLOBAL_SCOPE_PERSISTENT : s.GLOBAL_SCOPE_VOLATILE, "_").concat(btoa(o), "_"), this.wrapped = l;
    }
    return t(s, [{
      key: "scopeKey",
      value: function(l) {
        return "".concat(this.scope).concat(l);
      }
    }, {
      key: "setItem",
      value: function(l, a) {
        this.wrapped.setItem(this.scopeKey(l), a);
      }
    }, {
      key: "getItem",
      value: function(l) {
        return this.wrapped.getItem(this.scopeKey(l));
      }
    }, {
      key: "removeItem",
      value: function(l) {
        this.wrapped.removeItem(this.scopeKey(l));
      }
    }, {
      key: "clear",
      value: function() {
        var l = this;
        Object.keys(this.wrapped).filter(function(a) {
          return a.startsWith(l.scope);
        }).map(this.wrapped.removeItem.bind(this.wrapped));
      }
    }]), s;
  }();
  return Bn.default = i, n(i, "GLOBAL_SCOPE_VOLATILE", "nextcloud_vol"), n(i, "GLOBAL_SCOPE_PERSISTENT", "nextcloud_per"), Bn;
}
var kf;
function lD() {
  if (kf)
    return In;
  kf = 1, Object.defineProperty(In, "__esModule", {
    value: !0
  }), In.default = void 0, dr();
  var r = e(Sm());
  function e(l) {
    return l && l.__esModule ? l : { default: l };
  }
  function t(l, a) {
    if (!(l instanceof a))
      throw new TypeError("Cannot call a class as a function");
  }
  function n(l, a) {
    for (var c = 0; c < a.length; c++) {
      var T = a[c];
      T.enumerable = T.enumerable || !1, T.configurable = !0, "value" in T && (T.writable = !0), Object.defineProperty(l, T.key, T);
    }
  }
  function i(l, a, c) {
    return a && n(l.prototype, a), c && n(l, c), Object.defineProperty(l, "prototype", { writable: !1 }), l;
  }
  function s(l, a, c) {
    return a in l ? Object.defineProperty(l, a, { value: c, enumerable: !0, configurable: !0, writable: !0 }) : l[a] = c, l;
  }
  var o = /* @__PURE__ */ function() {
    function l(a) {
      t(this, l), s(this, "appId", void 0), s(this, "persisted", !1), s(this, "clearedOnLogout", !1), this.appId = a;
    }
    return i(l, [{
      key: "persist",
      value: function() {
        var c = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
        return this.persisted = c, this;
      }
    }, {
      key: "clearOnLogout",
      value: function() {
        var c = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
        return this.clearedOnLogout = c, this;
      }
    }, {
      key: "build",
      value: function() {
        return new r.default(this.appId, this.persisted ? window.localStorage : window.sessionStorage, !this.clearedOnLogout);
      }
    }]), l;
  }();
  return In.default = o, In;
}
var Pf;
function uD() {
  if (Pf)
    return en;
  Pf = 1, dr(), Object.defineProperty(en, "__esModule", {
    value: !0
  }), en.clearAll = s, en.clearNonPersistent = o, en.getBuilder = n, pm(), hm(), Ai(), mm(), Em();
  var r = t(lD()), e = t(Sm());
  function t(l) {
    return l && l.__esModule ? l : { default: l };
  }
  function n(l) {
    return new r.default(l);
  }
  function i(l, a) {
    Object.keys(l).filter(function(c) {
      return a ? a(c) : !0;
    }).map(l.removeItem.bind(l));
  }
  function s() {
    var l = [window.sessionStorage, window.localStorage];
    l.map(function(a) {
      return i(a);
    });
  }
  function o() {
    var l = [window.sessionStorage, window.localStorage];
    l.map(function(a) {
      return i(a, function(c) {
        return !c.startsWith(e.default.GLOBAL_SCOPE_PERSISTENT);
      });
    });
  }
  return en;
}
var Fi = {}, Gf = {}, Tl, Uf;
function Dm() {
  if (Uf)
    return Tl;
  Uf = 1;
  var r = Ut();
  return Tl = function() {
    var e = r(this), t = "";
    return e.hasIndices && (t += "d"), e.global && (t += "g"), e.ignoreCase && (t += "i"), e.multiline && (t += "m"), e.dotAll && (t += "s"), e.unicode && (t += "u"), e.unicodeSets && (t += "v"), e.sticky && (t += "y"), t;
  }, Tl;
}
var dl, Hf;
function cD() {
  if (Hf)
    return dl;
  Hf = 1;
  var r = $e(), e = ot(), t = e.RegExp, n = r(function() {
    var o = t("a", "y");
    return o.lastIndex = 2, o.exec("abcd") != null;
  }), i = n || r(function() {
    return !t("a", "y").sticky;
  }), s = n || r(function() {
    var o = t("^r", "gy");
    return o.lastIndex = 2, o.exec("str") != null;
  });
  return dl = {
    BROKEN_CARET: s,
    MISSED_STICKY: i,
    UNSUPPORTED_Y: n
  }, dl;
}
var Al, jf;
function TD() {
  if (jf)
    return Al;
  jf = 1;
  var r = $e(), e = ot(), t = e.RegExp;
  return Al = r(function() {
    var n = t(".", "s");
    return !(n.dotAll && n.exec(`
`) && n.flags === "s");
  }), Al;
}
var fl, zf;
function dD() {
  if (zf)
    return fl;
  zf = 1;
  var r = $e(), e = ot(), t = e.RegExp;
  return fl = r(function() {
    var n = t("(?<a>b)", "g");
    return n.exec("b").groups.a !== "b" || "b".replace(n, "$<a>c") !== "bc";
  }), fl;
}
var pl, $f;
function Wu() {
  if ($f)
    return pl;
  $f = 1;
  var r = It(), e = Ve(), t = Kt(), n = Dm(), i = cD(), s = Fn(), o = di(), l = Ti().get, a = TD(), c = dD(), T = s("native-string-replace", String.prototype.replace), u = RegExp.prototype.exec, d = u, A = e("".charAt), f = e("".indexOf), h = e("".replace), S = e("".slice), p = function() {
    var R = /a/, D = /b*/g;
    return r(u, R, "a"), r(u, D, "a"), R.lastIndex !== 0 || D.lastIndex !== 0;
  }(), m = i.BROKEN_CARET, g = /()??/.exec("")[1] !== void 0, N = p || g || m || a || c;
  return N && (d = function(D) {
    var v = this, O = l(v), y = t(D), Z = O.raw, F, b, Y, I, q, _, z;
    if (Z)
      return Z.lastIndex = v.lastIndex, F = r(d, Z, y), v.lastIndex = Z.lastIndex, F;
    var E = O.groups, C = m && v.sticky, P = r(n, v), M = v.source, Q = 0, H = y;
    if (C && (P = h(P, "y", ""), f(P, "g") === -1 && (P += "g"), H = S(y, v.lastIndex), v.lastIndex > 0 && (!v.multiline || v.multiline && A(y, v.lastIndex - 1) !== `
`) && (M = "(?: " + M + ")", H = " " + H, Q++), b = new RegExp("^(?:" + M + ")", P)), g && (b = new RegExp("^" + M + "$(?!\\s)", P)), p && (Y = v.lastIndex), I = r(u, C ? b : v, H), C ? I ? (I.input = S(I.input, Q), I[0] = S(I[0], Q), I.index = v.lastIndex, v.lastIndex += I[0].length) : v.lastIndex = 0 : p && I && (v.lastIndex = v.global ? I.index + I[0].length : Y), g && I && I.length > 1 && r(T, I[0], b, function() {
      for (q = 1; q < arguments.length - 2; q++)
        arguments[q] === void 0 && (I[q] = void 0);
    }), I && E)
      for (I.groups = _ = o(null), q = 0; q < E.length; q++)
        z = E[q], _[z[0]] = I[z[1]];
    return I;
  }), pl = d, pl;
}
var Vf;
function Qu() {
  if (Vf)
    return Gf;
  Vf = 1;
  var r = St(), e = Wu();
  return r({ target: "RegExp", proto: !0, forced: /./.exec !== e }, {
    exec: e
  }), Gf;
}
var qf = {}, hl, Wf;
function AD() {
  if (Wf)
    return hl;
  Wf = 1, Qu();
  var r = Ve(), e = Qt(), t = Wu(), n = $e(), i = Je(), s = ci(), o = i("species"), l = RegExp.prototype;
  return hl = function(a, c, T, u) {
    var d = i(a), A = !n(function() {
      var p = {};
      return p[d] = function() {
        return 7;
      }, ""[a](p) != 7;
    }), f = A && !n(function() {
      var p = !1, m = /a/;
      return a === "split" && (m = {}, m.constructor = {}, m.constructor[o] = function() {
        return m;
      }, m.flags = "", m[d] = /./[d]), m.exec = function() {
        return p = !0, null;
      }, m[d](""), !p;
    });
    if (!A || !f || T) {
      var h = r(/./[d]), S = c(d, ""[a], function(p, m, g, N, R) {
        var D = r(p), v = m.exec;
        return v === t || v === l.exec ? A && !R ? { done: !0, value: h(m, g, N) } : { done: !0, value: D(g, m, N) } : { done: !1 };
      });
      e(String.prototype, a, S[0]), e(l, d, S[1]);
    }
    u && s(l[d], "sham", !0);
  }, hl;
}
var ml, Qf;
function fD() {
  if (Qf)
    return ml;
  Qf = 1;
  var r = jh().charAt;
  return ml = function(e, t, n) {
    return t + (n ? r(e, t).length : 1);
  }, ml;
}
var El, Kf;
function pD() {
  if (Kf)
    return El;
  Kf = 1;
  var r = Ve(), e = yr(), t = Math.floor, n = r("".charAt), i = r("".replace), s = r("".slice), o = /\$([$&'`]|\d{1,2}|<[^>]*>)/g, l = /\$([$&'`]|\d{1,2})/g;
  return El = function(a, c, T, u, d, A) {
    var f = T + a.length, h = u.length, S = l;
    return d !== void 0 && (d = e(d), S = o), i(A, S, function(p, m) {
      var g;
      switch (n(m, 0)) {
        case "$":
          return "$";
        case "&":
          return a;
        case "`":
          return s(c, 0, T);
        case "'":
          return s(c, f);
        case "<":
          g = d[s(m, 1, -1)];
          break;
        default:
          var N = +m;
          if (N === 0)
            return p;
          if (N > h) {
            var R = t(N / 10);
            return R === 0 ? p : R <= h ? u[R - 1] === void 0 ? n(m, 1) : u[R - 1] + n(m, 1) : p;
          }
          g = u[N - 1];
      }
      return g === void 0 ? "" : g;
    });
  }, El;
}
var Sl, Jf;
function hD() {
  if (Jf)
    return Sl;
  Jf = 1;
  var r = It(), e = Ut(), t = Ke(), n = qr(), i = Wu(), s = TypeError;
  return Sl = function(o, l) {
    var a = o.exec;
    if (t(a)) {
      var c = r(a, o, l);
      return c !== null && e(c), c;
    }
    if (n(o) === "RegExp")
      return r(i, o, l);
    throw s("RegExp#exec called on incompatible receiver");
  }, Sl;
}
var Xf;
function Ku() {
  if (Xf)
    return qf;
  Xf = 1;
  var r = Kh(), e = It(), t = Ve(), n = AD(), i = $e(), s = Ut(), o = Ke(), l = gu(), a = Ia(), c = bu(), T = Kt(), u = Rn(), d = fD(), A = hh(), f = pD(), h = hD(), S = Je(), p = S("replace"), m = Math.max, g = Math.min, N = t([].concat), R = t([].push), D = t("".indexOf), v = t("".slice), O = function(b) {
    return b === void 0 ? b : String(b);
  }, y = function() {
    return "a".replace(/./, "$0") === "$0";
  }(), Z = function() {
    return /./[p] ? /./[p]("a", "$0") === "" : !1;
  }(), F = !i(function() {
    var b = /./;
    return b.exec = function() {
      var Y = [];
      return Y.groups = { a: "7" }, Y;
    }, "".replace(b, "$<a>") !== "7";
  });
  return n("replace", function(b, Y, I) {
    var q = Z ? "$" : "$0";
    return [
      // `String.prototype.replace` method
      // https://tc39.es/ecma262/#sec-string.prototype.replace
      function(z, E) {
        var C = u(this), P = l(z) ? void 0 : A(z, p);
        return P ? e(P, z, C, E) : e(Y, T(C), z, E);
      },
      // `RegExp.prototype[@@replace]` method
      // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
      function(_, z) {
        var E = s(this), C = T(_);
        if (typeof z == "string" && D(z, q) === -1 && D(z, "$<") === -1) {
          var P = I(Y, E, C, z);
          if (P.done)
            return P.value;
        }
        var M = o(z);
        M || (z = T(z));
        var Q = E.global;
        if (Q) {
          var H = E.unicode;
          E.lastIndex = 0;
        }
        for (var re = []; ; ) {
          var U = h(E, C);
          if (U === null || (R(re, U), !Q))
            break;
          var w = T(U[0]);
          w === "" && (E.lastIndex = d(C, c(E.lastIndex), H));
        }
        for (var W = "", se = 0, ie = 0; ie < re.length; ie++) {
          U = re[ie];
          for (var Fe = T(U[0]), V = m(g(a(U.index), C.length), 0), $ = [], J = 1; J < U.length; J++)
            R($, O(U[J]));
          var ae = U.groups;
          if (M) {
            var X = N([Fe], $, V, C);
            ae !== void 0 && R(X, ae);
            var pe = T(r(z, void 0, X));
          } else
            pe = f(Fe, C, V, $, ae, z);
          V >= se && (W += v(C, se, V) + pe, se = V + Fe.length);
        }
        return W + v(C, se);
      }
    ];
  }, !F || !y || Z), qf;
}
var ep = {}, Dl, tp;
function mD() {
  if (tp)
    return Dl;
  tp = 1;
  var r = It(), e = st(), t = si(), n = Dm(), i = RegExp.prototype;
  return Dl = function(s) {
    var o = s.flags;
    return o === void 0 && !("flags" in i) && !e(s, "flags") && t(i, s) ? r(n, s) : o;
  }, Dl;
}
var rp;
function ED() {
  if (rp)
    return ep;
  rp = 1;
  var r = yu().PROPER, e = Qt(), t = Ut(), n = Kt(), i = $e(), s = mD(), o = "toString", l = RegExp.prototype, a = l[o], c = i(function() {
    return a.call({ source: "a", flags: "b" }) != "/a/b";
  }), T = r && a.name != o;
  return (c || T) && e(RegExp.prototype, o, function() {
    var d = t(this), A = n(d.source), f = n(s(d));
    return "/" + A + "/" + f;
  }, { unsafe: !0 }), ep;
}
var gl, np;
function SD() {
  if (np)
    return gl;
  np = 1;
  var r = "Expected a function", e = "__lodash_hash_undefined__", t = 1 / 0, n = "[object Function]", i = "[object GeneratorFunction]", s = "[object Symbol]", o = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, l = /^\w*$/, a = /^\./, c = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, T = /[\\^$.*+?()[\]{}|]/g, u = /\\(\\)?/g, d = /^\[object .+?Constructor\]$/, A = typeof nr == "object" && nr && nr.Object === Object && nr, f = typeof self == "object" && self && self.Object === Object && self, h = A || f || Function("return this")();
  function S(G, ne) {
    return G == null ? void 0 : G[ne];
  }
  function p(G) {
    var ne = !1;
    if (G != null && typeof G.toString != "function")
      try {
        ne = !!(G + "");
      } catch {
      }
    return ne;
  }
  var m = Array.prototype, g = Function.prototype, N = Object.prototype, R = h["__core-js_shared__"], D = function() {
    var G = /[^.]+$/.exec(R && R.keys && R.keys.IE_PROTO || "");
    return G ? "Symbol(src)_1." + G : "";
  }(), v = g.toString, O = N.hasOwnProperty, y = N.toString, Z = RegExp(
    "^" + v.call(O).replace(T, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), F = h.Symbol, b = m.splice, Y = ye(h, "Map"), I = ye(Object, "create"), q = F ? F.prototype : void 0, _ = q ? q.toString : void 0;
  function z(G) {
    var ne = -1, Ee = G ? G.length : 0;
    for (this.clear(); ++ne < Ee; ) {
      var Ie = G[ne];
      this.set(Ie[0], Ie[1]);
    }
  }
  function E() {
    this.__data__ = I ? I(null) : {};
  }
  function C(G) {
    return this.has(G) && delete this.__data__[G];
  }
  function P(G) {
    var ne = this.__data__;
    if (I) {
      var Ee = ne[G];
      return Ee === e ? void 0 : Ee;
    }
    return O.call(ne, G) ? ne[G] : void 0;
  }
  function M(G) {
    var ne = this.__data__;
    return I ? ne[G] !== void 0 : O.call(ne, G);
  }
  function Q(G, ne) {
    var Ee = this.__data__;
    return Ee[G] = I && ne === void 0 ? e : ne, this;
  }
  z.prototype.clear = E, z.prototype.delete = C, z.prototype.get = P, z.prototype.has = M, z.prototype.set = Q;
  function H(G) {
    var ne = -1, Ee = G ? G.length : 0;
    for (this.clear(); ++ne < Ee; ) {
      var Ie = G[ne];
      this.set(Ie[0], Ie[1]);
    }
  }
  function re() {
    this.__data__ = [];
  }
  function U(G) {
    var ne = this.__data__, Ee = X(ne, G);
    if (Ee < 0)
      return !1;
    var Ie = ne.length - 1;
    return Ee == Ie ? ne.pop() : b.call(ne, Ee, 1), !0;
  }
  function w(G) {
    var ne = this.__data__, Ee = X(ne, G);
    return Ee < 0 ? void 0 : ne[Ee][1];
  }
  function W(G) {
    return X(this.__data__, G) > -1;
  }
  function se(G, ne) {
    var Ee = this.__data__, Ie = X(Ee, G);
    return Ie < 0 ? Ee.push([G, ne]) : Ee[Ie][1] = ne, this;
  }
  H.prototype.clear = re, H.prototype.delete = U, H.prototype.get = w, H.prototype.has = W, H.prototype.set = se;
  function ie(G) {
    var ne = -1, Ee = G ? G.length : 0;
    for (this.clear(); ++ne < Ee; ) {
      var Ie = G[ne];
      this.set(Ie[0], Ie[1]);
    }
  }
  function Fe() {
    this.__data__ = {
      hash: new z(),
      map: new (Y || H)(),
      string: new z()
    };
  }
  function V(G) {
    return Ne(this, G).delete(G);
  }
  function $(G) {
    return Ne(this, G).get(G);
  }
  function J(G) {
    return Ne(this, G).has(G);
  }
  function ae(G, ne) {
    return Ne(this, G).set(G, ne), this;
  }
  ie.prototype.clear = Fe, ie.prototype.delete = V, ie.prototype.get = $, ie.prototype.has = J, ie.prototype.set = ae;
  function X(G, ne) {
    for (var Ee = G.length; Ee--; )
      if (k(G[Ee][0], ne))
        return Ee;
    return -1;
  }
  function pe(G, ne) {
    ne = be(ne, G) ? [ne] : Ae(ne);
    for (var Ee = 0, Ie = ne.length; G != null && Ee < Ie; )
      G = G[oe(ne[Ee++])];
    return Ee && Ee == Ie ? G : void 0;
  }
  function L(G) {
    if (!le(G) || Ze(G))
      return !1;
    var ne = j(G) || p(G) ? Z : d;
    return ne.test(te(G));
  }
  function ee(G) {
    if (typeof G == "string")
      return G;
    if (De(G))
      return _ ? _.call(G) : "";
    var ne = G + "";
    return ne == "0" && 1 / G == -t ? "-0" : ne;
  }
  function Ae(G) {
    return B(G) ? G : _e(G);
  }
  function Ne(G, ne) {
    var Ee = G.__data__;
    return Ge(ne) ? Ee[typeof ne == "string" ? "string" : "hash"] : Ee.map;
  }
  function ye(G, ne) {
    var Ee = S(G, ne);
    return L(Ee) ? Ee : void 0;
  }
  function be(G, ne) {
    if (B(G))
      return !1;
    var Ee = typeof G;
    return Ee == "number" || Ee == "symbol" || Ee == "boolean" || G == null || De(G) ? !0 : l.test(G) || !o.test(G) || ne != null && G in Object(ne);
  }
  function Ge(G) {
    var ne = typeof G;
    return ne == "string" || ne == "number" || ne == "symbol" || ne == "boolean" ? G !== "__proto__" : G === null;
  }
  function Ze(G) {
    return !!D && D in G;
  }
  var _e = K(function(G) {
    G = Ye(G);
    var ne = [];
    return a.test(G) && ne.push(""), G.replace(c, function(Ee, Ie, He, ut) {
      ne.push(He ? ut.replace(u, "$1") : Ie || Ee);
    }), ne;
  });
  function oe(G) {
    if (typeof G == "string" || De(G))
      return G;
    var ne = G + "";
    return ne == "0" && 1 / G == -t ? "-0" : ne;
  }
  function te(G) {
    if (G != null) {
      try {
        return v.call(G);
      } catch {
      }
      try {
        return G + "";
      } catch {
      }
    }
    return "";
  }
  function K(G, ne) {
    if (typeof G != "function" || ne && typeof ne != "function")
      throw new TypeError(r);
    var Ee = function() {
      var Ie = arguments, He = ne ? ne.apply(this, Ie) : Ie[0], ut = Ee.cache;
      if (ut.has(He))
        return ut.get(He);
      var fr = G.apply(this, Ie);
      return Ee.cache = ut.set(He, fr), fr;
    };
    return Ee.cache = new (K.Cache || ie)(), Ee;
  }
  K.Cache = ie;
  function k(G, ne) {
    return G === ne || G !== G && ne !== ne;
  }
  var B = Array.isArray;
  function j(G) {
    var ne = le(G) ? y.call(G) : "";
    return ne == n || ne == i;
  }
  function le(G) {
    var ne = typeof G;
    return !!G && (ne == "object" || ne == "function");
  }
  function ce(G) {
    return !!G && typeof G == "object";
  }
  function De(G) {
    return typeof G == "symbol" || ce(G) && y.call(G) == s;
  }
  function Ye(G) {
    return G == null ? "" : ee(G);
  }
  function Ue(G, ne, Ee) {
    var Ie = G == null ? void 0 : pe(G, ne);
    return Ie === void 0 ? Ee : Ie;
  }
  return gl = Ue, gl;
}
var Rl, ip;
function DD() {
  return ip || (ip = 1, Rl = {
    ach: {
      name: "Acholi",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n > 1)",
      pluralsFunc: function(r) {
        return r > 1;
      }
    },
    af: {
      name: "Afrikaans",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    ak: {
      name: "Akan",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n > 1)",
      pluralsFunc: function(r) {
        return r > 1;
      }
    },
    am: {
      name: "Amharic",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n > 1)",
      pluralsFunc: function(r) {
        return r > 1;
      }
    },
    an: {
      name: "Aragonese",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    ar: {
      name: "Arabic",
      examples: [{
        plural: 0,
        sample: 0
      }, {
        plural: 1,
        sample: 1
      }, {
        plural: 2,
        sample: 2
      }, {
        plural: 3,
        sample: 3
      }, {
        plural: 4,
        sample: 11
      }, {
        plural: 5,
        sample: 100
      }],
      nplurals: 6,
      pluralsText: "nplurals = 6; plural = (n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5)",
      pluralsFunc: function(r) {
        return r === 0 ? 0 : r === 1 ? 1 : r === 2 ? 2 : r % 100 >= 3 && r % 100 <= 10 ? 3 : r % 100 >= 11 ? 4 : 5;
      }
    },
    arn: {
      name: "Mapudungun",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n > 1)",
      pluralsFunc: function(r) {
        return r > 1;
      }
    },
    ast: {
      name: "Asturian",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    ay: {
      name: "Aymará",
      examples: [{
        plural: 0,
        sample: 1
      }],
      nplurals: 1,
      pluralsText: "nplurals = 1; plural = 0",
      pluralsFunc: function() {
        return 0;
      }
    },
    az: {
      name: "Azerbaijani",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    be: {
      name: "Belarusian",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }, {
        plural: 2,
        sample: 5
      }],
      nplurals: 3,
      pluralsText: "nplurals = 3; plural = (n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2)",
      pluralsFunc: function(r) {
        return r % 10 === 1 && r % 100 !== 11 ? 0 : r % 10 >= 2 && r % 10 <= 4 && (r % 100 < 10 || r % 100 >= 20) ? 1 : 2;
      }
    },
    bg: {
      name: "Bulgarian",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    bn: {
      name: "Bengali",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    bo: {
      name: "Tibetan",
      examples: [{
        plural: 0,
        sample: 1
      }],
      nplurals: 1,
      pluralsText: "nplurals = 1; plural = 0",
      pluralsFunc: function() {
        return 0;
      }
    },
    br: {
      name: "Breton",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n > 1)",
      pluralsFunc: function(r) {
        return r > 1;
      }
    },
    brx: {
      name: "Bodo",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    bs: {
      name: "Bosnian",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }, {
        plural: 2,
        sample: 5
      }],
      nplurals: 3,
      pluralsText: "nplurals = 3; plural = (n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2)",
      pluralsFunc: function(r) {
        return r % 10 === 1 && r % 100 !== 11 ? 0 : r % 10 >= 2 && r % 10 <= 4 && (r % 100 < 10 || r % 100 >= 20) ? 1 : 2;
      }
    },
    ca: {
      name: "Catalan",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    cgg: {
      name: "Chiga",
      examples: [{
        plural: 0,
        sample: 1
      }],
      nplurals: 1,
      pluralsText: "nplurals = 1; plural = 0",
      pluralsFunc: function() {
        return 0;
      }
    },
    cs: {
      name: "Czech",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }, {
        plural: 2,
        sample: 5
      }],
      nplurals: 3,
      pluralsText: "nplurals = 3; plural = (n === 1 ? 0 : (n >= 2 && n <= 4) ? 1 : 2)",
      pluralsFunc: function(r) {
        return r === 1 ? 0 : r >= 2 && r <= 4 ? 1 : 2;
      }
    },
    csb: {
      name: "Kashubian",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }, {
        plural: 2,
        sample: 5
      }],
      nplurals: 3,
      pluralsText: "nplurals = 3; plural = (n === 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2)",
      pluralsFunc: function(r) {
        return r === 1 ? 0 : r % 10 >= 2 && r % 10 <= 4 && (r % 100 < 10 || r % 100 >= 20) ? 1 : 2;
      }
    },
    cy: {
      name: "Welsh",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }, {
        plural: 2,
        sample: 3
      }, {
        plural: 3,
        sample: 8
      }],
      nplurals: 4,
      pluralsText: "nplurals = 4; plural = (n === 1 ? 0 : n === 2 ? 1 : (n !== 8 && n !== 11) ? 2 : 3)",
      pluralsFunc: function(r) {
        return r === 1 ? 0 : r === 2 ? 1 : r !== 8 && r !== 11 ? 2 : 3;
      }
    },
    da: {
      name: "Danish",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    de: {
      name: "German",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    doi: {
      name: "Dogri",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    dz: {
      name: "Dzongkha",
      examples: [{
        plural: 0,
        sample: 1
      }],
      nplurals: 1,
      pluralsText: "nplurals = 1; plural = 0",
      pluralsFunc: function() {
        return 0;
      }
    },
    el: {
      name: "Greek",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    en: {
      name: "English",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    eo: {
      name: "Esperanto",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    es: {
      name: "Spanish",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    et: {
      name: "Estonian",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    eu: {
      name: "Basque",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    fa: {
      name: "Persian",
      examples: [{
        plural: 0,
        sample: 1
      }],
      nplurals: 1,
      pluralsText: "nplurals = 1; plural = 0",
      pluralsFunc: function() {
        return 0;
      }
    },
    ff: {
      name: "Fulah",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    fi: {
      name: "Finnish",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    fil: {
      name: "Filipino",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n > 1)",
      pluralsFunc: function(r) {
        return r > 1;
      }
    },
    fo: {
      name: "Faroese",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    fr: {
      name: "French",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n > 1)",
      pluralsFunc: function(r) {
        return r > 1;
      }
    },
    fur: {
      name: "Friulian",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    fy: {
      name: "Frisian",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    ga: {
      name: "Irish",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }, {
        plural: 2,
        sample: 3
      }, {
        plural: 3,
        sample: 7
      }, {
        plural: 4,
        sample: 11
      }],
      nplurals: 5,
      pluralsText: "nplurals = 5; plural = (n === 1 ? 0 : n === 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4)",
      pluralsFunc: function(r) {
        return r === 1 ? 0 : r === 2 ? 1 : r < 7 ? 2 : r < 11 ? 3 : 4;
      }
    },
    gd: {
      name: "Scottish Gaelic",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }, {
        plural: 2,
        sample: 3
      }, {
        plural: 3,
        sample: 20
      }],
      nplurals: 4,
      pluralsText: "nplurals = 4; plural = ((n === 1 || n === 11) ? 0 : (n === 2 || n === 12) ? 1 : (n > 2 && n < 20) ? 2 : 3)",
      pluralsFunc: function(r) {
        return r === 1 || r === 11 ? 0 : r === 2 || r === 12 ? 1 : r > 2 && r < 20 ? 2 : 3;
      }
    },
    gl: {
      name: "Galician",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    gu: {
      name: "Gujarati",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    gun: {
      name: "Gun",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n > 1)",
      pluralsFunc: function(r) {
        return r > 1;
      }
    },
    ha: {
      name: "Hausa",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    he: {
      name: "Hebrew",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    hi: {
      name: "Hindi",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    hne: {
      name: "Chhattisgarhi",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    hr: {
      name: "Croatian",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }, {
        plural: 2,
        sample: 5
      }],
      nplurals: 3,
      pluralsText: "nplurals = 3; plural = (n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2)",
      pluralsFunc: function(r) {
        return r % 10 === 1 && r % 100 !== 11 ? 0 : r % 10 >= 2 && r % 10 <= 4 && (r % 100 < 10 || r % 100 >= 20) ? 1 : 2;
      }
    },
    hu: {
      name: "Hungarian",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    hy: {
      name: "Armenian",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    id: {
      name: "Indonesian",
      examples: [{
        plural: 0,
        sample: 1
      }],
      nplurals: 1,
      pluralsText: "nplurals = 1; plural = 0",
      pluralsFunc: function() {
        return 0;
      }
    },
    is: {
      name: "Icelandic",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n % 10 !== 1 || n % 100 === 11)",
      pluralsFunc: function(r) {
        return r % 10 !== 1 || r % 100 === 11;
      }
    },
    it: {
      name: "Italian",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    ja: {
      name: "Japanese",
      examples: [{
        plural: 0,
        sample: 1
      }],
      nplurals: 1,
      pluralsText: "nplurals = 1; plural = 0",
      pluralsFunc: function() {
        return 0;
      }
    },
    jbo: {
      name: "Lojban",
      examples: [{
        plural: 0,
        sample: 1
      }],
      nplurals: 1,
      pluralsText: "nplurals = 1; plural = 0",
      pluralsFunc: function() {
        return 0;
      }
    },
    jv: {
      name: "Javanese",
      examples: [{
        plural: 0,
        sample: 0
      }, {
        plural: 1,
        sample: 1
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 0)",
      pluralsFunc: function(r) {
        return r !== 0;
      }
    },
    ka: {
      name: "Georgian",
      examples: [{
        plural: 0,
        sample: 1
      }],
      nplurals: 1,
      pluralsText: "nplurals = 1; plural = 0",
      pluralsFunc: function() {
        return 0;
      }
    },
    kk: {
      name: "Kazakh",
      examples: [{
        plural: 0,
        sample: 1
      }],
      nplurals: 1,
      pluralsText: "nplurals = 1; plural = 0",
      pluralsFunc: function() {
        return 0;
      }
    },
    km: {
      name: "Khmer",
      examples: [{
        plural: 0,
        sample: 1
      }],
      nplurals: 1,
      pluralsText: "nplurals = 1; plural = 0",
      pluralsFunc: function() {
        return 0;
      }
    },
    kn: {
      name: "Kannada",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    ko: {
      name: "Korean",
      examples: [{
        plural: 0,
        sample: 1
      }],
      nplurals: 1,
      pluralsText: "nplurals = 1; plural = 0",
      pluralsFunc: function() {
        return 0;
      }
    },
    ku: {
      name: "Kurdish",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    kw: {
      name: "Cornish",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }, {
        plural: 2,
        sample: 3
      }, {
        plural: 3,
        sample: 4
      }],
      nplurals: 4,
      pluralsText: "nplurals = 4; plural = (n === 1 ? 0 : n === 2 ? 1 : n === 3 ? 2 : 3)",
      pluralsFunc: function(r) {
        return r === 1 ? 0 : r === 2 ? 1 : r === 3 ? 2 : 3;
      }
    },
    ky: {
      name: "Kyrgyz",
      examples: [{
        plural: 0,
        sample: 1
      }],
      nplurals: 1,
      pluralsText: "nplurals = 1; plural = 0",
      pluralsFunc: function() {
        return 0;
      }
    },
    lb: {
      name: "Letzeburgesch",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    ln: {
      name: "Lingala",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n > 1)",
      pluralsFunc: function(r) {
        return r > 1;
      }
    },
    lo: {
      name: "Lao",
      examples: [{
        plural: 0,
        sample: 1
      }],
      nplurals: 1,
      pluralsText: "nplurals = 1; plural = 0",
      pluralsFunc: function() {
        return 0;
      }
    },
    lt: {
      name: "Lithuanian",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }, {
        plural: 2,
        sample: 10
      }],
      nplurals: 3,
      pluralsText: "nplurals = 3; plural = (n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2)",
      pluralsFunc: function(r) {
        return r % 10 === 1 && r % 100 !== 11 ? 0 : r % 10 >= 2 && (r % 100 < 10 || r % 100 >= 20) ? 1 : 2;
      }
    },
    lv: {
      name: "Latvian",
      examples: [{
        plural: 2,
        sample: 0
      }, {
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 3,
      pluralsText: "nplurals = 3; plural = (n % 10 === 1 && n % 100 !== 11 ? 0 : n !== 0 ? 1 : 2)",
      pluralsFunc: function(r) {
        return r % 10 === 1 && r % 100 !== 11 ? 0 : r !== 0 ? 1 : 2;
      }
    },
    mai: {
      name: "Maithili",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    mfe: {
      name: "Mauritian Creole",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n > 1)",
      pluralsFunc: function(r) {
        return r > 1;
      }
    },
    mg: {
      name: "Malagasy",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n > 1)",
      pluralsFunc: function(r) {
        return r > 1;
      }
    },
    mi: {
      name: "Maori",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n > 1)",
      pluralsFunc: function(r) {
        return r > 1;
      }
    },
    mk: {
      name: "Macedonian",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n === 1 || n % 10 === 1 ? 0 : 1)",
      pluralsFunc: function(r) {
        return r === 1 || r % 10 === 1 ? 0 : 1;
      }
    },
    ml: {
      name: "Malayalam",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    mn: {
      name: "Mongolian",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    mni: {
      name: "Manipuri",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    mnk: {
      name: "Mandinka",
      examples: [{
        plural: 0,
        sample: 0
      }, {
        plural: 1,
        sample: 1
      }, {
        plural: 2,
        sample: 2
      }],
      nplurals: 3,
      pluralsText: "nplurals = 3; plural = (n === 0 ? 0 : n === 1 ? 1 : 2)",
      pluralsFunc: function(r) {
        return r === 0 ? 0 : r === 1 ? 1 : 2;
      }
    },
    mr: {
      name: "Marathi",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    ms: {
      name: "Malay",
      examples: [{
        plural: 0,
        sample: 1
      }],
      nplurals: 1,
      pluralsText: "nplurals = 1; plural = 0",
      pluralsFunc: function() {
        return 0;
      }
    },
    mt: {
      name: "Maltese",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }, {
        plural: 2,
        sample: 11
      }, {
        plural: 3,
        sample: 20
      }],
      nplurals: 4,
      pluralsText: "nplurals = 4; plural = (n === 1 ? 0 : n === 0 || ( n % 100 > 1 && n % 100 < 11) ? 1 : (n % 100 > 10 && n % 100 < 20 ) ? 2 : 3)",
      pluralsFunc: function(r) {
        return r === 1 ? 0 : r === 0 || r % 100 > 1 && r % 100 < 11 ? 1 : r % 100 > 10 && r % 100 < 20 ? 2 : 3;
      }
    },
    my: {
      name: "Burmese",
      examples: [{
        plural: 0,
        sample: 1
      }],
      nplurals: 1,
      pluralsText: "nplurals = 1; plural = 0",
      pluralsFunc: function() {
        return 0;
      }
    },
    nah: {
      name: "Nahuatl",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    nap: {
      name: "Neapolitan",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    nb: {
      name: "Norwegian Bokmal",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    ne: {
      name: "Nepali",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    nl: {
      name: "Dutch",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    nn: {
      name: "Norwegian Nynorsk",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    no: {
      name: "Norwegian",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    nso: {
      name: "Northern Sotho",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    oc: {
      name: "Occitan",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n > 1)",
      pluralsFunc: function(r) {
        return r > 1;
      }
    },
    or: {
      name: "Oriya",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    pa: {
      name: "Punjabi",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    pap: {
      name: "Papiamento",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    pl: {
      name: "Polish",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }, {
        plural: 2,
        sample: 5
      }],
      nplurals: 3,
      pluralsText: "nplurals = 3; plural = (n === 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2)",
      pluralsFunc: function(r) {
        return r === 1 ? 0 : r % 10 >= 2 && r % 10 <= 4 && (r % 100 < 10 || r % 100 >= 20) ? 1 : 2;
      }
    },
    pms: {
      name: "Piemontese",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    ps: {
      name: "Pashto",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    pt: {
      name: "Portuguese",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    rm: {
      name: "Romansh",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    ro: {
      name: "Romanian",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }, {
        plural: 2,
        sample: 20
      }],
      nplurals: 3,
      pluralsText: "nplurals = 3; plural = (n === 1 ? 0 : (n === 0 || (n % 100 > 0 && n % 100 < 20)) ? 1 : 2)",
      pluralsFunc: function(r) {
        return r === 1 ? 0 : r === 0 || r % 100 > 0 && r % 100 < 20 ? 1 : 2;
      }
    },
    ru: {
      name: "Russian",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }, {
        plural: 2,
        sample: 5
      }],
      nplurals: 3,
      pluralsText: "nplurals = 3; plural = (n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2)",
      pluralsFunc: function(r) {
        return r % 10 === 1 && r % 100 !== 11 ? 0 : r % 10 >= 2 && r % 10 <= 4 && (r % 100 < 10 || r % 100 >= 20) ? 1 : 2;
      }
    },
    rw: {
      name: "Kinyarwanda",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    sah: {
      name: "Yakut",
      examples: [{
        plural: 0,
        sample: 1
      }],
      nplurals: 1,
      pluralsText: "nplurals = 1; plural = 0",
      pluralsFunc: function() {
        return 0;
      }
    },
    sat: {
      name: "Santali",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    sco: {
      name: "Scots",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    sd: {
      name: "Sindhi",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    se: {
      name: "Northern Sami",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    si: {
      name: "Sinhala",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    sk: {
      name: "Slovak",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }, {
        plural: 2,
        sample: 5
      }],
      nplurals: 3,
      pluralsText: "nplurals = 3; plural = (n === 1 ? 0 : (n >= 2 && n <= 4) ? 1 : 2)",
      pluralsFunc: function(r) {
        return r === 1 ? 0 : r >= 2 && r <= 4 ? 1 : 2;
      }
    },
    sl: {
      name: "Slovenian",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }, {
        plural: 2,
        sample: 3
      }, {
        plural: 3,
        sample: 5
      }],
      nplurals: 4,
      pluralsText: "nplurals = 4; plural = (n % 100 === 1 ? 0 : n % 100 === 2 ? 1 : n % 100 === 3 || n % 100 === 4 ? 2 : 3)",
      pluralsFunc: function(r) {
        return r % 100 === 1 ? 0 : r % 100 === 2 ? 1 : r % 100 === 3 || r % 100 === 4 ? 2 : 3;
      }
    },
    so: {
      name: "Somali",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    son: {
      name: "Songhay",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    sq: {
      name: "Albanian",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    sr: {
      name: "Serbian",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }, {
        plural: 2,
        sample: 5
      }],
      nplurals: 3,
      pluralsText: "nplurals = 3; plural = (n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2)",
      pluralsFunc: function(r) {
        return r % 10 === 1 && r % 100 !== 11 ? 0 : r % 10 >= 2 && r % 10 <= 4 && (r % 100 < 10 || r % 100 >= 20) ? 1 : 2;
      }
    },
    su: {
      name: "Sundanese",
      examples: [{
        plural: 0,
        sample: 1
      }],
      nplurals: 1,
      pluralsText: "nplurals = 1; plural = 0",
      pluralsFunc: function() {
        return 0;
      }
    },
    sv: {
      name: "Swedish",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    sw: {
      name: "Swahili",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    ta: {
      name: "Tamil",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    te: {
      name: "Telugu",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    tg: {
      name: "Tajik",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n > 1)",
      pluralsFunc: function(r) {
        return r > 1;
      }
    },
    th: {
      name: "Thai",
      examples: [{
        plural: 0,
        sample: 1
      }],
      nplurals: 1,
      pluralsText: "nplurals = 1; plural = 0",
      pluralsFunc: function() {
        return 0;
      }
    },
    ti: {
      name: "Tigrinya",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n > 1)",
      pluralsFunc: function(r) {
        return r > 1;
      }
    },
    tk: {
      name: "Turkmen",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    tr: {
      name: "Turkish",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n > 1)",
      pluralsFunc: function(r) {
        return r > 1;
      }
    },
    tt: {
      name: "Tatar",
      examples: [{
        plural: 0,
        sample: 1
      }],
      nplurals: 1,
      pluralsText: "nplurals = 1; plural = 0",
      pluralsFunc: function() {
        return 0;
      }
    },
    ug: {
      name: "Uyghur",
      examples: [{
        plural: 0,
        sample: 1
      }],
      nplurals: 1,
      pluralsText: "nplurals = 1; plural = 0",
      pluralsFunc: function() {
        return 0;
      }
    },
    uk: {
      name: "Ukrainian",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }, {
        plural: 2,
        sample: 5
      }],
      nplurals: 3,
      pluralsText: "nplurals = 3; plural = (n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2)",
      pluralsFunc: function(r) {
        return r % 10 === 1 && r % 100 !== 11 ? 0 : r % 10 >= 2 && r % 10 <= 4 && (r % 100 < 10 || r % 100 >= 20) ? 1 : 2;
      }
    },
    ur: {
      name: "Urdu",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    uz: {
      name: "Uzbek",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n > 1)",
      pluralsFunc: function(r) {
        return r > 1;
      }
    },
    vi: {
      name: "Vietnamese",
      examples: [{
        plural: 0,
        sample: 1
      }],
      nplurals: 1,
      pluralsText: "nplurals = 1; plural = 0",
      pluralsFunc: function() {
        return 0;
      }
    },
    wa: {
      name: "Walloon",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n > 1)",
      pluralsFunc: function(r) {
        return r > 1;
      }
    },
    wo: {
      name: "Wolof",
      examples: [{
        plural: 0,
        sample: 1
      }],
      nplurals: 1,
      pluralsText: "nplurals = 1; plural = 0",
      pluralsFunc: function() {
        return 0;
      }
    },
    yo: {
      name: "Yoruba",
      examples: [{
        plural: 0,
        sample: 1
      }, {
        plural: 1,
        sample: 2
      }],
      nplurals: 2,
      pluralsText: "nplurals = 2; plural = (n !== 1)",
      pluralsFunc: function(r) {
        return r !== 1;
      }
    },
    zh: {
      name: "Chinese",
      examples: [{
        plural: 0,
        sample: 1
      }],
      nplurals: 1,
      pluralsText: "nplurals = 1; plural = 0",
      pluralsFunc: function() {
        return 0;
      }
    }
  }), Rl;
}
var vl, ap;
function gD() {
  if (ap)
    return vl;
  ap = 1;
  var r = SD(), e = DD();
  vl = t;
  function t(n) {
    n = n || {}, this.catalogs = {}, this.locale = "", this.domain = "messages", this.listeners = [], this.sourceLocale = "", n.sourceLocale && (typeof n.sourceLocale == "string" ? this.sourceLocale = n.sourceLocale : this.warn("The `sourceLocale` option should be a string")), this.debug = "debug" in n && n.debug === !0;
  }
  return t.prototype.on = function(n, i) {
    this.listeners.push({
      eventName: n,
      callback: i
    });
  }, t.prototype.off = function(n, i) {
    this.listeners = this.listeners.filter(function(s) {
      return !(s.eventName === n && s.callback === i);
    });
  }, t.prototype.emit = function(n, i) {
    for (var s = 0; s < this.listeners.length; s++) {
      var o = this.listeners[s];
      o.eventName === n && o.callback(i);
    }
  }, t.prototype.warn = function(n) {
    this.debug && console.warn(n), this.emit("error", new Error(n));
  }, t.prototype.addTranslations = function(n, i, s) {
    this.catalogs[n] || (this.catalogs[n] = {}), this.catalogs[n][i] = s;
  }, t.prototype.setLocale = function(n) {
    if (typeof n != "string") {
      this.warn(
        "You called setLocale() with an argument of type " + typeof n + ". The locale must be a string."
      );
      return;
    }
    n.trim() === "" && this.warn("You called setLocale() with an empty value, which makes little sense."), n !== this.sourceLocale && !this.catalogs[n] && this.warn('You called setLocale() with "' + n + '", but no translations for that locale has been added.'), this.locale = n;
  }, t.prototype.setTextDomain = function(n) {
    if (typeof n != "string") {
      this.warn(
        "You called setTextDomain() with an argument of type " + typeof n + ". The domain must be a string."
      );
      return;
    }
    n.trim() === "" && this.warn("You called setTextDomain() with an empty `domain` value."), this.domain = n;
  }, t.prototype.gettext = function(n) {
    return this.dnpgettext(this.domain, "", n);
  }, t.prototype.dgettext = function(n, i) {
    return this.dnpgettext(n, "", i);
  }, t.prototype.ngettext = function(n, i, s) {
    return this.dnpgettext(this.domain, "", n, i, s);
  }, t.prototype.dngettext = function(n, i, s, o) {
    return this.dnpgettext(n, "", i, s, o);
  }, t.prototype.pgettext = function(n, i) {
    return this.dnpgettext(this.domain, n, i);
  }, t.prototype.dpgettext = function(n, i, s) {
    return this.dnpgettext(n, i, s);
  }, t.prototype.npgettext = function(n, i, s, o) {
    return this.dnpgettext(this.domain, n, i, s, o);
  }, t.prototype.dnpgettext = function(n, i, s, o, l) {
    var a = s, c, T;
    if (i = i || "", !isNaN(l) && l !== 1 && (a = o || s), c = this._getTranslation(n, i, s), c) {
      if (typeof l == "number") {
        var u = e[t.getLanguageCode(this.locale)].pluralsFunc;
        T = u(l), typeof T == "boolean" && (T = T ? 1 : 0);
      } else
        T = 0;
      return c.msgstr[T] || a;
    } else
      (!this.sourceLocale || this.locale !== this.sourceLocale) && this.warn('No translation was found for msgid "' + s + '" in msgctxt "' + i + '" and domain "' + n + '"');
    return a;
  }, t.prototype.getComment = function(n, i, s) {
    var o;
    return o = this._getTranslation(n, i, s), o ? o.comments || {} : {};
  }, t.prototype._getTranslation = function(n, i, s) {
    return i = i || "", r(this.catalogs, [this.locale, n, "translations", i, s]);
  }, t.getLanguageCode = function(n) {
    return n.split(/[\-_]/)[0].toLowerCase();
  }, t.prototype.textdomain = function(n) {
    this.debug && console.warn(`textdomain(domain) was used to set locales in node-gettext v1. Make sure you are using it for domains, and switch to setLocale(locale) if you are not.

 To read more about the migration from node-gettext v1 to v2, see https://github.com/alexanderwallin/node-gettext/#migrating-from-1x-to-2x

This warning will be removed in the final 2.0.0`), this.setTextDomain(n);
  }, t.prototype.setlocale = function(n) {
    this.setLocale(n);
  }, t.prototype.addTextdomain = function() {
    console.error(`addTextdomain() is deprecated.

* To add translations, use addTranslations()
* To set the default domain, use setTextDomain() (or its alias textdomain())

To read more about the migration from node-gettext v1 to v2, see https://github.com/alexanderwallin/node-gettext/#migrating-from-1x-to-2x`);
  }, vl;
}
var gt = {}, op;
function gm() {
  if (op)
    return gt;
  op = 1, dr(), Object.defineProperty(gt, "__esModule", {
    value: !0
  }), gt.getCanonicalLocale = e, gt.getDayNames = o, gt.getDayNamesMin = a, gt.getDayNamesShort = l, gt.getFirstDay = s, gt.getLanguage = t, gt.getLocale = r, gt.getMonthNames = c, gt.getMonthNamesShort = T, gt.translate = n, gt.translatePlural = i, Qu(), Ku();
  function r() {
    return document.documentElement.dataset.locale || "en";
  }
  function e() {
    return r().replace(/_/g, "-");
  }
  function t() {
    return document.documentElement.lang || "en";
  }
  function n(u, d, A, f, h) {
    return typeof OC > "u" ? (console.warn("No OC found"), d) : OC.L10N.translate(u, d, A, f, h);
  }
  function i(u, d, A, f, h, S) {
    return typeof OC > "u" ? (console.warn("No OC found"), d) : OC.L10N.translatePlural(u, d, A, f, h, S);
  }
  function s() {
    return typeof window.firstDay > "u" ? (console.warn("No firstDay found"), 1) : window.firstDay;
  }
  function o() {
    return typeof window.dayNames > "u" ? (console.warn("No dayNames found"), ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]) : window.dayNames;
  }
  function l() {
    return typeof window.dayNamesShort > "u" ? (console.warn("No dayNamesShort found"), ["Sun.", "Mon.", "Tue.", "Wed.", "Thu.", "Fri.", "Sat."]) : window.dayNamesShort;
  }
  function a() {
    return typeof window.dayNamesMin > "u" ? (console.warn("No dayNamesMin found"), ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"]) : window.dayNamesMin;
  }
  function c() {
    return typeof window.monthNames > "u" ? (console.warn("No monthNames found"), ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]) : window.monthNames;
  }
  function T() {
    return typeof window.monthNamesShort > "u" ? (console.warn("No monthNamesShort found"), ["Jan.", "Feb.", "Mar.", "Apr.", "May.", "Jun.", "Jul.", "Aug.", "Sep.", "Oct.", "Nov.", "Dec."]) : window.monthNamesShort;
  }
  return gt;
}
var sp;
function RD() {
  if (sp)
    return Fi;
  sp = 1, Object.defineProperty(Fi, "__esModule", {
    value: !0
  }), Fi.getGettextBuilder = a, Qu(), Ku(), dr(), Ai(), ED();
  var r = t(gD()), e = gm();
  function t(c) {
    return c && c.__esModule ? c : { default: c };
  }
  function n(c, T) {
    if (!(c instanceof T))
      throw new TypeError("Cannot call a class as a function");
  }
  function i(c, T) {
    for (var u = 0; u < T.length; u++) {
      var d = T[u];
      d.enumerable = d.enumerable || !1, d.configurable = !0, "value" in d && (d.writable = !0), Object.defineProperty(c, d.key, d);
    }
  }
  function s(c, T, u) {
    return T && i(c.prototype, T), u && i(c, u), Object.defineProperty(c, "prototype", { writable: !1 }), c;
  }
  var o = /* @__PURE__ */ function() {
    function c() {
      n(this, c), this.translations = {}, this.debug = !1;
    }
    return s(c, [{
      key: "setLanguage",
      value: function(u) {
        return this.locale = u, this;
      }
    }, {
      key: "detectLocale",
      value: function() {
        return this.setLanguage((0, e.getLanguage)().replace("-", "_"));
      }
    }, {
      key: "addTranslation",
      value: function(u, d) {
        return this.translations[u] = d, this;
      }
    }, {
      key: "enableDebugMode",
      value: function() {
        return this.debug = !0, this;
      }
    }, {
      key: "build",
      value: function() {
        return new l(this.locale || "en", this.translations, this.debug);
      }
    }]), c;
  }(), l = /* @__PURE__ */ function() {
    function c(T, u, d) {
      n(this, c), this.gt = new r.default({
        debug: d,
        sourceLocale: "en"
      });
      for (var A in u)
        this.gt.addTranslations(A, "messages", u[A]);
      this.gt.setLocale(T);
    }
    return s(c, [{
      key: "subtitudePlaceholders",
      value: function(u, d) {
        return u.replace(/{([^{}]*)}/g, function(A, f) {
          var h = d[f];
          return typeof h == "string" || typeof h == "number" ? h.toString() : A;
        });
      }
    }, {
      key: "gettext",
      value: function(u) {
        var d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return this.subtitudePlaceholders(this.gt.gettext(u), d);
      }
    }, {
      key: "ngettext",
      value: function(u, d, A) {
        var f = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
        return this.subtitudePlaceholders(this.gt.ngettext(u, d, A).replace(/%n/g, A.toString()), f);
      }
    }]), c;
  }();
  function a() {
    return new o();
  }
  return Fi;
}
var nt = {}, lp;
function Rm() {
  if (lp)
    return nt;
  lp = 1, Object.defineProperty(nt, "__esModule", {
    value: !0
  }), nt.getRootUrl = nt.generateFilePath = nt.imagePath = nt.generateUrl = nt.generateOcsUrl = nt.generateRemoteUrl = nt.linkTo = void 0, Ku();
  const r = (c, T) => l(c, "", T);
  nt.linkTo = r;
  const e = (c) => a() + "/remote.php/" + c, t = (c) => window.location.protocol + "//" + window.location.host + e(c);
  nt.generateRemoteUrl = t;
  const n = (c, T, u) => {
    const A = Object.assign({
      ocsVersion: 2
    }, u || {}).ocsVersion === 1 ? 1 : 2;
    return window.location.protocol + "//" + window.location.host + a() + "/ocs/v" + A + ".php" + i(c, T, u);
  };
  nt.generateOcsUrl = n;
  const i = (c, T, u) => {
    const d = Object.assign({
      escape: !0
    }, u || {}), A = function(f, h) {
      return h = h || {}, f.replace(/{([^{}]*)}/g, function(S, p) {
        var m = h[p];
        return d.escape ? encodeURIComponent(typeof m == "string" || typeof m == "number" ? m.toString() : S) : typeof m == "string" || typeof m == "number" ? m.toString() : S;
      });
    };
    return c.charAt(0) !== "/" && (c = "/" + c), A(c, T || {});
  }, s = (c, T, u) => {
    const d = Object.assign({
      noRewrite: !1
    }, u || {});
    return OC.config.modRewriteWorking === !0 && !d.noRewrite ? a() + i(c, T, u) : a() + "/index.php" + i(c, T, u);
  };
  nt.generateUrl = s;
  const o = (c, T) => T.indexOf(".") === -1 ? l(c, "img", T + ".svg") : l(c, "img", T);
  nt.imagePath = o;
  const l = (c, T, u) => {
    const d = OC.coreApps.indexOf(c) !== -1;
    let A = a();
    return u.substring(u.length - 3) === "php" && !d ? (A += "/index.php/apps/" + c, u !== "index.php" && (A += "/", T && (A += encodeURI(T + "/")), A += u)) : u.substring(u.length - 3) !== "php" && !d ? (A = OC.appswebroots[c], T && (A += "/" + T + "/"), A.substring(A.length - 1) !== "/" && (A += "/"), A += u) : ((c === "settings" || c === "core" || c === "search") && T === "ajax" ? A += "/index.php/" : A += "/", d || (A += "apps/"), c !== "" && (c += "/", A += c), T && (A += T + "/"), A += u), A;
  };
  nt.generateFilePath = l;
  const a = () => OC.webroot;
  return nt.getRootUrl = a, nt;
}
function Ar(r) {
  return r.split("-")[0];
}
function cn(r) {
  return r.split("-")[1];
}
function fi(r) {
  return ["top", "bottom"].includes(Ar(r)) ? "x" : "y";
}
function Ju(r) {
  return r === "y" ? "height" : "width";
}
function up(r) {
  let {
    reference: e,
    floating: t,
    placement: n
  } = r;
  const i = e.x + e.width / 2 - t.width / 2, s = e.y + e.height / 2 - t.height / 2;
  let o;
  switch (Ar(n)) {
    case "top":
      o = {
        x: i,
        y: e.y - t.height
      };
      break;
    case "bottom":
      o = {
        x: i,
        y: e.y + e.height
      };
      break;
    case "right":
      o = {
        x: e.x + e.width,
        y: s
      };
      break;
    case "left":
      o = {
        x: e.x - t.width,
        y: s
      };
      break;
    default:
      o = {
        x: e.x,
        y: e.y
      };
  }
  const l = fi(n), a = Ju(l);
  switch (cn(n)) {
    case "start":
      o[l] = o[l] - (e[a] / 2 - t[a] / 2);
      break;
    case "end":
      o[l] = o[l] + (e[a] / 2 - t[a] / 2);
      break;
  }
  return o;
}
const vD = async (r, e, t) => {
  const {
    placement: n = "bottom",
    strategy: i = "absolute",
    middleware: s = [],
    platform: o
  } = t;
  if (process.env.NODE_ENV !== "production" && (o == null && console.error(["Floating UI: `platform` property was not passed to config. If you", "want to use Floating UI on the web, install @floating-ui/dom", "instead of the /core package. Otherwise, you can create your own", "`platform`: https://floating-ui.com/docs/platform"].join(" ")), s.filter((A) => {
    let {
      name: f
    } = A;
    return f === "autoPlacement" || f === "flip";
  }).length > 1))
    throw new Error(["Floating UI: duplicate `flip` and/or `autoPlacement`", "middleware detected. This will lead to an infinite loop. Ensure only", "one of either has been passed to the `middleware` array."].join(" "));
  let l = await o.getElementRects({
    reference: r,
    floating: e,
    strategy: i
  }), {
    x: a,
    y: c
  } = up({
    ...l,
    placement: n
  }), T = n, u = {}, d = 0;
  for (let A = 0; A < s.length; A++) {
    if (process.env.NODE_ENV !== "production" && (d++, d > 100))
      throw new Error(["Floating UI: The middleware lifecycle appears to be", "running in an infinite loop. This is usually caused by a `reset`", "continually being returned without a break condition."].join(" "));
    const {
      name: f,
      fn: h
    } = s[A], {
      x: S,
      y: p,
      data: m,
      reset: g
    } = await h({
      x: a,
      y: c,
      initialPlacement: n,
      placement: T,
      strategy: i,
      middlewareData: u,
      rects: l,
      platform: o,
      elements: {
        reference: r,
        floating: e
      }
    });
    if (a = S != null ? S : a, c = p != null ? p : c, u = {
      ...u,
      [f]: m != null ? m : {}
    }, g) {
      typeof g == "object" && (g.placement && (T = g.placement), g.rects && (l = g.rects === !0 ? await o.getElementRects({
        reference: r,
        floating: e,
        strategy: i
      }) : g.rects), {
        x: a,
        y: c
      } = up({
        ...l,
        placement: T
      })), A = -1;
      continue;
    }
  }
  return {
    x: a,
    y: c,
    placement: T,
    strategy: i,
    middlewareData: u
  };
};
function ND(r) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...r
  };
}
function vm(r) {
  return typeof r != "number" ? ND(r) : {
    top: r,
    right: r,
    bottom: r,
    left: r
  };
}
function Vl(r) {
  return {
    ...r,
    top: r.y,
    left: r.x,
    right: r.x + r.width,
    bottom: r.y + r.height
  };
}
async function Pa(r, e) {
  e === void 0 && (e = {});
  const {
    x: t,
    y: n,
    platform: i,
    rects: s,
    elements: o,
    strategy: l
  } = r, {
    boundary: a = "clippingParents",
    rootBoundary: c = "viewport",
    elementContext: T = "floating",
    altBoundary: u = !1,
    padding: d = 0
  } = e, A = vm(d), h = o[u ? T === "floating" ? "reference" : "floating" : T], S = await i.getClippingClientRect({
    element: await i.isElement(h) ? h : h.contextElement || await i.getDocumentElement({
      element: o.floating
    }),
    boundary: a,
    rootBoundary: c
  }), p = Vl(await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: T === "floating" ? {
      ...s.floating,
      x: t,
      y: n
    } : s.reference,
    offsetParent: await i.getOffsetParent({
      element: o.floating
    }),
    strategy: l
  }));
  return {
    top: S.top - p.top + A.top,
    bottom: p.bottom - S.bottom + A.bottom,
    left: S.left - p.left + A.left,
    right: p.right - S.right + A.right
  };
}
const FD = Math.min, wr = Math.max;
function ql(r, e, t) {
  return wr(r, FD(e, t));
}
const OD = (r) => ({
  name: "arrow",
  options: r,
  async fn(e) {
    const {
      element: t,
      padding: n = 0
    } = r != null ? r : {}, {
      x: i,
      y: s,
      placement: o,
      rects: l,
      platform: a
    } = e;
    if (t == null)
      return process.env.NODE_ENV !== "production" && console.warn("Floating UI: No `element` was passed to the `arrow` middleware."), {};
    const c = vm(n), T = {
      x: i,
      y: s
    }, u = Ar(o), d = fi(u), A = Ju(d), f = await a.getDimensions({
      element: t
    }), h = d === "y" ? "top" : "left", S = d === "y" ? "bottom" : "right", p = l.reference[A] + l.reference[d] - T[d] - l.floating[A], m = T[d] - l.reference[d], g = await a.getOffsetParent({
      element: t
    }), N = g ? d === "y" ? g.clientHeight || 0 : g.clientWidth || 0 : 0, R = p / 2 - m / 2, D = c[h], v = N - f[A] - c[S], O = N / 2 - f[A] / 2 + R, y = ql(D, O, v);
    return {
      data: {
        [d]: y,
        centerOffset: O - y
      }
    };
  }
}), yD = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function ca(r) {
  return r.replace(/left|right|bottom|top/g, (e) => yD[e]);
}
function Nm(r, e) {
  const t = cn(r) === "start", n = fi(r), i = Ju(n);
  let s = n === "x" ? t ? "right" : "left" : t ? "bottom" : "top";
  return e.reference[i] > e.floating[i] && (s = ca(s)), {
    main: s,
    cross: ca(s)
  };
}
const bD = {
  start: "end",
  end: "start"
};
function Wl(r) {
  return r.replace(/start|end/g, (e) => bD[e]);
}
const CD = ["top", "right", "bottom", "left"], _D = /* @__PURE__ */ CD.reduce((r, e) => r.concat(e, e + "-start", e + "-end"), []);
function MD(r, e, t) {
  return (r ? [...t.filter((i) => cn(i) === r), ...t.filter((i) => cn(i) !== r)] : t.filter((i) => Ar(i) === i)).filter((i) => r ? cn(i) === r || (e ? Wl(i) !== i : !1) : !0);
}
const YD = function(r) {
  return r === void 0 && (r = {}), {
    name: "autoPlacement",
    options: r,
    async fn(e) {
      var t, n, i, s, o, l;
      const {
        x: a,
        y: c,
        rects: T,
        middlewareData: u,
        placement: d
      } = e, {
        alignment: A = null,
        allowedPlacements: f = _D,
        autoAlignment: h = !0,
        ...S
      } = r;
      if ((t = u.autoPlacement) != null && t.skip)
        return {};
      const p = MD(A, h, f), m = await Pa(e, S), g = (n = (i = u.autoPlacement) == null ? void 0 : i.index) != null ? n : 0, N = p[g], {
        main: R,
        cross: D
      } = Nm(N, T);
      if (d !== N)
        return {
          x: a,
          y: c,
          reset: {
            placement: p[0]
          }
        };
      const v = [m[Ar(N)], m[R], m[D]], O = [...(s = (o = u.autoPlacement) == null ? void 0 : o.overflows) != null ? s : [], {
        placement: N,
        overflows: v
      }], y = p[g + 1];
      if (y)
        return {
          data: {
            index: g + 1,
            overflows: O
          },
          reset: {
            placement: y
          }
        };
      const Z = O.slice().sort((b, Y) => b.overflows[0] - Y.overflows[0]), F = (l = Z.find((b) => {
        let {
          overflows: Y
        } = b;
        return Y.every((I) => I <= 0);
      })) == null ? void 0 : l.placement;
      return {
        data: {
          skip: !0
        },
        reset: {
          placement: F != null ? F : Z[0].placement
        }
      };
    }
  };
};
function ID(r) {
  const e = ca(r);
  return [Wl(r), e, Wl(e)];
}
const BD = function(r) {
  return r === void 0 && (r = {}), {
    name: "flip",
    options: r,
    async fn(e) {
      var t, n;
      const {
        placement: i,
        middlewareData: s,
        rects: o,
        initialPlacement: l
      } = e;
      if ((t = s.flip) != null && t.skip)
        return {};
      const {
        mainAxis: a = !0,
        crossAxis: c = !0,
        fallbackPlacements: T,
        fallbackStrategy: u = "bestFit",
        flipAlignment: d = !0,
        ...A
      } = r, f = Ar(i), S = T || (f === l || !d ? [ca(l)] : ID(l)), p = [l, ...S], m = await Pa(e, A), g = [];
      let N = ((n = s.flip) == null ? void 0 : n.overflows) || [];
      if (a && g.push(m[f]), c) {
        const {
          main: O,
          cross: y
        } = Nm(i, o);
        g.push(m[O], m[y]);
      }
      if (N = [...N, {
        placement: i,
        overflows: g
      }], !g.every((O) => O <= 0)) {
        var R, D;
        const O = ((R = (D = s.flip) == null ? void 0 : D.index) != null ? R : 0) + 1, y = p[O];
        if (y)
          return {
            data: {
              index: O,
              overflows: N
            },
            reset: {
              placement: y
            }
          };
        let Z = "bottom";
        switch (u) {
          case "bestFit": {
            var v;
            const F = (v = N.slice().sort((b, Y) => b.overflows.filter((I) => I > 0).reduce((I, q) => I + q, 0) - Y.overflows.filter((I) => I > 0).reduce((I, q) => I + q, 0))[0]) == null ? void 0 : v.placement;
            F && (Z = F);
            break;
          }
          case "initialPlacement":
            Z = l;
            break;
        }
        return {
          data: {
            skip: !0
          },
          reset: {
            placement: Z
          }
        };
      }
      return {};
    }
  };
};
function ZD(r) {
  let {
    placement: e,
    rects: t,
    value: n
  } = r;
  const i = Ar(e), s = ["left", "top"].includes(i) ? -1 : 1, o = typeof n == "function" ? n({
    ...t,
    placement: e
  }) : n, {
    mainAxis: l,
    crossAxis: a
  } = typeof o == "number" ? {
    mainAxis: o,
    crossAxis: 0
  } : {
    mainAxis: 0,
    crossAxis: 0,
    ...o
  };
  return fi(i) === "x" ? {
    x: a,
    y: l * s
  } : {
    x: l * s,
    y: a
  };
}
const wD = function(r) {
  return r === void 0 && (r = 0), {
    name: "offset",
    options: r,
    fn(e) {
      const {
        x: t,
        y: n,
        placement: i,
        rects: s
      } = e, o = ZD({
        placement: i,
        rects: s,
        value: r
      });
      return {
        x: t + o.x,
        y: n + o.y,
        data: o
      };
    }
  };
};
function xD(r) {
  return r === "x" ? "y" : "x";
}
const LD = function(r) {
  return r === void 0 && (r = {}), {
    name: "shift",
    options: r,
    async fn(e) {
      const {
        x: t,
        y: n,
        placement: i
      } = e, {
        mainAxis: s = !0,
        crossAxis: o = !1,
        limiter: l = {
          fn: (S) => {
            let {
              x: p,
              y: m
            } = S;
            return {
              x: p,
              y: m
            };
          }
        },
        ...a
      } = r, c = {
        x: t,
        y: n
      }, T = await Pa(e, a), u = fi(Ar(i)), d = xD(u);
      let A = c[u], f = c[d];
      if (s) {
        const S = u === "y" ? "top" : "left", p = u === "y" ? "bottom" : "right", m = A + T[S], g = A - T[p];
        A = ql(m, A, g);
      }
      if (o) {
        const S = d === "y" ? "top" : "left", p = d === "y" ? "bottom" : "right", m = f + T[S], g = f - T[p];
        f = ql(m, f, g);
      }
      const h = l.fn({
        ...e,
        [u]: A,
        [d]: f
      });
      return {
        ...h,
        data: {
          x: h.x - t,
          y: h.y - n
        }
      };
    }
  };
}, kD = function(r) {
  return r === void 0 && (r = {}), {
    name: "size",
    options: r,
    async fn(e) {
      var t;
      const {
        placement: n,
        rects: i,
        middlewareData: s
      } = e, {
        apply: o,
        ...l
      } = r;
      if ((t = s.size) != null && t.skip)
        return {};
      const a = await Pa(e, l), c = Ar(n), T = cn(n) === "end";
      let u, d;
      c === "top" || c === "bottom" ? (u = c, d = T ? "left" : "right") : (d = c, u = T ? "top" : "bottom");
      const A = wr(a.left, 0), f = wr(a.right, 0), h = wr(a.top, 0), S = wr(a.bottom, 0), p = {
        height: i.floating.height - (["left", "right"].includes(n) ? 2 * (h !== 0 || S !== 0 ? h + S : wr(a.top, a.bottom)) : a[u]),
        width: i.floating.width - (["top", "bottom"].includes(n) ? 2 * (A !== 0 || f !== 0 ? A + f : wr(a.left, a.right)) : a[d])
      };
      return o == null || o({
        ...p,
        ...i
      }), {
        data: {
          skip: !0
        },
        reset: {
          rects: !0
        }
      };
    }
  };
};
function Xu(r) {
  return (r == null ? void 0 : r.toString()) === "[object Window]";
}
function br(r) {
  if (r == null)
    return window;
  if (!Xu(r)) {
    const e = r.ownerDocument;
    return e && e.defaultView || window;
  }
  return r;
}
function Ga(r) {
  return br(r).getComputedStyle(r);
}
function lr(r) {
  return Xu(r) ? "" : r ? (r.nodeName || "").toLowerCase() : "";
}
function ur(r) {
  return r instanceof br(r).HTMLElement;
}
function Ta(r) {
  return r instanceof br(r).Element;
}
function PD(r) {
  return r instanceof br(r).Node;
}
function Fm(r) {
  const e = br(r).ShadowRoot;
  return r instanceof e || r instanceof ShadowRoot;
}
function Ua(r) {
  const {
    overflow: e,
    overflowX: t,
    overflowY: n
  } = Ga(r);
  return /auto|scroll|overlay|hidden/.test(e + n + t);
}
function GD(r) {
  return ["table", "td", "th"].includes(lr(r));
}
function Om(r) {
  const e = navigator.userAgent.toLowerCase().includes("firefox"), t = Ga(r);
  return t.transform !== "none" || t.perspective !== "none" || t.contain === "paint" || ["transform", "perspective"].includes(t.willChange) || e && t.willChange === "filter" || e && (t.filter ? t.filter !== "none" : !1);
}
const cp = Math.min, zn = Math.max, da = Math.round;
function dn(r, e) {
  e === void 0 && (e = !1);
  const t = r.getBoundingClientRect();
  let n = 1, i = 1;
  return e && ur(r) && (n = r.offsetWidth > 0 && da(t.width) / r.offsetWidth || 1, i = r.offsetHeight > 0 && da(t.height) / r.offsetHeight || 1), {
    width: t.width / n,
    height: t.height / i,
    top: t.top / i,
    right: t.right / n,
    bottom: t.bottom / i,
    left: t.left / n,
    x: t.left / n,
    y: t.top / i
  };
}
function Cr(r) {
  return ((PD(r) ? r.ownerDocument : r.document) || window.document).documentElement;
}
function Ha(r) {
  return Xu(r) ? {
    scrollLeft: r.pageXOffset,
    scrollTop: r.pageYOffset
  } : {
    scrollLeft: r.scrollLeft,
    scrollTop: r.scrollTop
  };
}
function ym(r) {
  return dn(Cr(r)).left + Ha(r).scrollLeft;
}
function UD(r) {
  const e = dn(r);
  return da(e.width) !== r.offsetWidth || da(e.height) !== r.offsetHeight;
}
function HD(r, e, t) {
  const n = ur(e), i = Cr(e), s = dn(r, n && UD(e));
  let o = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = {
    x: 0,
    y: 0
  };
  if (n || !n && t !== "fixed")
    if ((lr(e) !== "body" || Ua(i)) && (o = Ha(e)), ur(e)) {
      const a = dn(e, !0);
      l.x = a.x + e.clientLeft, l.y = a.y + e.clientTop;
    } else
      i && (l.x = ym(i));
  return {
    x: s.left + o.scrollLeft - l.x,
    y: s.top + o.scrollTop - l.y,
    width: s.width,
    height: s.height
  };
}
function ja(r) {
  return lr(r) === "html" ? r : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // @ts-ignore
    r.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    r.parentNode || // DOM Element detected
    (Fm(r) ? r.host : null) || // ShadowRoot detected
    Cr(r)
  );
}
function Tp(r) {
  return !ur(r) || getComputedStyle(r).position === "fixed" ? null : r.offsetParent;
}
function jD(r) {
  let e = ja(r);
  for (; ur(e) && !["html", "body"].includes(lr(e)); ) {
    if (Om(e))
      return e;
    e = e.parentNode;
  }
  return null;
}
function Ql(r) {
  const e = br(r);
  let t = Tp(r);
  for (; t && GD(t) && getComputedStyle(t).position === "static"; )
    t = Tp(t);
  return t && (lr(t) === "html" || lr(t) === "body" && getComputedStyle(t).position === "static" && !Om(t)) ? e : t || jD(r) || e;
}
function dp(r) {
  return {
    width: r.offsetWidth,
    height: r.offsetHeight
  };
}
function zD(r) {
  let {
    rect: e,
    offsetParent: t,
    strategy: n
  } = r;
  const i = ur(t), s = Cr(t);
  if (t === s)
    return e;
  let o = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = {
    x: 0,
    y: 0
  };
  if ((i || !i && n !== "fixed") && ((lr(t) !== "body" || Ua(s)) && (o = Ha(t)), ur(t))) {
    const a = dn(t, !0);
    l.x = a.x + t.clientLeft, l.y = a.y + t.clientTop;
  }
  return {
    ...e,
    x: e.x - o.scrollLeft + l.x,
    y: e.y - o.scrollTop + l.y
  };
}
function $D(r) {
  const e = br(r), t = Cr(r), n = e.visualViewport;
  let i = t.clientWidth, s = t.clientHeight, o = 0, l = 0;
  return n && (i = n.width, s = n.height, Math.abs(e.innerWidth / n.scale - n.width) < 0.01 && (o = n.offsetLeft, l = n.offsetTop)), {
    width: i,
    height: s,
    x: o,
    y: l
  };
}
function VD(r) {
  var e;
  const t = Cr(r), n = Ha(r), i = (e = r.ownerDocument) == null ? void 0 : e.body, s = zn(t.scrollWidth, t.clientWidth, i ? i.scrollWidth : 0, i ? i.clientWidth : 0), o = zn(t.scrollHeight, t.clientHeight, i ? i.scrollHeight : 0, i ? i.clientHeight : 0);
  let l = -n.scrollLeft + ym(r);
  const a = -n.scrollTop;
  return Ga(i || t).direction === "rtl" && (l += zn(t.clientWidth, i ? i.clientWidth : 0) - s), {
    width: s,
    height: o,
    x: l,
    y: a
  };
}
function bm(r) {
  return ["html", "body", "#document"].includes(lr(r)) ? r.ownerDocument.body : ur(r) && Ua(r) ? r : bm(ja(r));
}
function Aa(r, e) {
  var t;
  e === void 0 && (e = []);
  const n = bm(r), i = n === ((t = r.ownerDocument) == null ? void 0 : t.body), s = br(n), o = i ? [s].concat(s.visualViewport || [], Ua(n) ? n : []) : n, l = e.concat(o);
  return i ? l : (
    // @ts-ignore: isBody tells us target will be an HTMLElement here
    l.concat(Aa(ja(o)))
  );
}
function qD(r, e) {
  const t = e.getRootNode == null ? void 0 : e.getRootNode();
  if (r.contains(e))
    return !0;
  if (t && Fm(t)) {
    let n = e;
    do {
      if (n && r === n)
        return !0;
      n = n.parentNode || n.host;
    } while (n);
  }
  return !1;
}
function WD(r) {
  const e = dn(r), t = e.top + r.clientTop, n = e.left + r.clientLeft;
  return {
    top: t,
    left: n,
    x: n,
    y: t,
    right: n + r.clientWidth,
    bottom: t + r.clientHeight,
    width: r.clientWidth,
    height: r.clientHeight
  };
}
function Ap(r, e) {
  return e === "viewport" ? Vl($D(r)) : Ta(e) ? WD(e) : Vl(VD(Cr(r)));
}
function QD(r) {
  const e = Aa(ja(r)), n = ["absolute", "fixed"].includes(Ga(r).position) && ur(r) ? Ql(r) : r;
  return Ta(n) ? e.filter((i) => Ta(i) && qD(i, n) && lr(i) !== "body") : [];
}
function KD(r) {
  let {
    element: e,
    boundary: t,
    rootBoundary: n
  } = r;
  const s = [...t === "clippingParents" ? QD(e) : [].concat(t), n], o = s[0], l = s.reduce((a, c) => {
    const T = Ap(e, c);
    return a.top = zn(T.top, a.top), a.right = cp(T.right, a.right), a.bottom = cp(T.bottom, a.bottom), a.left = zn(T.left, a.left), a;
  }, Ap(e, o));
  return l.width = l.right - l.left, l.height = l.bottom - l.top, l.x = l.left, l.y = l.top, l;
}
const JD = {
  getElementRects: (r) => {
    let {
      reference: e,
      floating: t,
      strategy: n
    } = r;
    return {
      reference: HD(e, Ql(t), n),
      floating: {
        ...dp(t),
        x: 0,
        y: 0
      }
    };
  },
  convertOffsetParentRelativeRectToViewportRelativeRect: (r) => zD(r),
  getOffsetParent: (r) => {
    let {
      element: e
    } = r;
    return Ql(e);
  },
  isElement: (r) => Ta(r),
  getDocumentElement: (r) => {
    let {
      element: e
    } = r;
    return Cr(e);
  },
  getClippingClientRect: (r) => KD(r),
  getDimensions: (r) => {
    let {
      element: e
    } = r;
    return dp(e);
  },
  getClientRects: (r) => {
    let {
      element: e
    } = r;
    return e.getClientRects();
  }
}, XD = (r, e, t) => vD(r, e, {
  platform: JD,
  ...t
});
var eg = Object.defineProperty, tg = Object.defineProperties, rg = Object.getOwnPropertyDescriptors, fa = Object.getOwnPropertySymbols, Cm = Object.prototype.hasOwnProperty, _m = Object.prototype.propertyIsEnumerable, fp = (r, e, t) => e in r ? eg(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t, Rr = (r, e) => {
  for (var t in e || (e = {}))
    Cm.call(e, t) && fp(r, t, e[t]);
  if (fa)
    for (var t of fa(e))
      _m.call(e, t) && fp(r, t, e[t]);
  return r;
}, za = (r, e) => tg(r, rg(e)), ng = (r, e) => {
  var t = {};
  for (var n in r)
    Cm.call(r, n) && e.indexOf(n) < 0 && (t[n] = r[n]);
  if (r != null && fa)
    for (var n of fa(r))
      e.indexOf(n) < 0 && _m.call(r, n) && (t[n] = r[n]);
  return t;
};
function Mm(r, e) {
  for (const t in e)
    Object.prototype.hasOwnProperty.call(e, t) && (typeof e[t] == "object" && r[t] ? Mm(r[t], e[t]) : r[t] = e[t]);
}
const $t = {
  disabled: !1,
  distance: 5,
  skidding: 0,
  container: "body",
  boundary: void 0,
  instantMove: !1,
  disposeTimeout: 5e3,
  popperTriggers: [],
  strategy: "absolute",
  preventOverflow: !0,
  flip: !0,
  shift: !0,
  overflowPadding: 0,
  arrowPadding: 0,
  arrowOverflow: !0,
  themes: {
    tooltip: {
      placement: "top",
      triggers: ["hover", "focus", "touch"],
      hideTriggers: (r) => [...r, "click"],
      delay: {
        show: 200,
        hide: 0
      },
      handleResize: !1,
      html: !1,
      loadingContent: "..."
    },
    dropdown: {
      placement: "bottom",
      triggers: ["click"],
      delay: 0,
      handleResize: !0,
      autoHide: !0
    },
    menu: {
      $extend: "dropdown",
      triggers: ["hover", "focus"],
      popperTriggers: ["hover", "focus"],
      delay: {
        show: 0,
        hide: 400
      }
    }
  }
};
function An(r, e) {
  let t = $t.themes[r] || {}, n;
  do
    n = t[e], typeof n > "u" ? t.$extend ? t = $t.themes[t.$extend] || {} : (t = null, n = $t[e]) : t = null;
  while (t);
  return n;
}
function ig(r) {
  const e = [r];
  let t = $t.themes[r] || {};
  do
    t.$extend && !t.$resetCss ? (e.push(t.$extend), t = $t.themes[t.$extend] || {}) : t = null;
  while (t);
  return e.map((n) => `v-popper--theme-${n}`);
}
function pp(r) {
  const e = [r];
  let t = $t.themes[r] || {};
  do
    t.$extend ? (e.push(t.$extend), t = $t.themes[t.$extend] || {}) : t = null;
  while (t);
  return e;
}
let zr = !1;
if (typeof window < "u") {
  zr = !1;
  try {
    const r = Object.defineProperty({}, "passive", {
      get() {
        zr = !0;
      }
    });
    window.addEventListener("test", null, r);
  } catch {
  }
}
let Ym = !1;
typeof window < "u" && typeof navigator < "u" && (Ym = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream);
const ec = ["auto", "top", "bottom", "left", "right"].reduce((r, e) => r.concat([
  e,
  `${e}-start`,
  `${e}-end`
]), []), Kl = {
  hover: "mouseenter",
  focus: "focus",
  click: "click",
  touch: "touchstart"
}, Jl = {
  hover: "mouseleave",
  focus: "blur",
  click: "click",
  touch: "touchend"
};
function hp(r, e) {
  const t = r.indexOf(e);
  t !== -1 && r.splice(t, 1);
}
function Nl() {
  return new Promise((r) => requestAnimationFrame(() => {
    requestAnimationFrame(r);
  }));
}
const Ft = [];
let Br = null;
const mp = {};
function Ep(r) {
  let e = mp[r];
  return e || (e = mp[r] = []), e;
}
let Xl = function() {
};
typeof window < "u" && (Xl = window.Element);
function xe(r) {
  return function() {
    const e = this.$props;
    return An(e.theme, r);
  };
}
const Fl = "__floating-vue__popper";
var tc = () => ({
  name: "VPopper",
  props: {
    theme: {
      type: String,
      required: !0
    },
    targetNodes: {
      type: Function,
      required: !0
    },
    referenceNode: {
      type: Function,
      required: !0
    },
    popperNode: {
      type: Function,
      required: !0
    },
    shown: {
      type: Boolean,
      default: !1
    },
    showGroup: {
      type: String,
      default: null
    },
    ariaId: {
      default: null
    },
    disabled: {
      type: Boolean,
      default: xe("disabled")
    },
    positioningDisabled: {
      type: Boolean,
      default: xe("positioningDisabled")
    },
    placement: {
      type: String,
      default: xe("placement"),
      validator: (r) => ec.includes(r)
    },
    delay: {
      type: [String, Number, Object],
      default: xe("delay")
    },
    distance: {
      type: [Number, String],
      default: xe("distance")
    },
    skidding: {
      type: [Number, String],
      default: xe("skidding")
    },
    triggers: {
      type: Array,
      default: xe("triggers")
    },
    showTriggers: {
      type: [Array, Function],
      default: xe("showTriggers")
    },
    hideTriggers: {
      type: [Array, Function],
      default: xe("hideTriggers")
    },
    popperTriggers: {
      type: Array,
      default: xe("popperTriggers")
    },
    popperShowTriggers: {
      type: [Array, Function],
      default: xe("popperShowTriggers")
    },
    popperHideTriggers: {
      type: [Array, Function],
      default: xe("popperHideTriggers")
    },
    container: {
      type: [String, Object, Xl, Boolean],
      default: xe("container")
    },
    boundary: {
      type: [String, Xl],
      default: xe("boundary")
    },
    strategy: {
      type: String,
      validator: (r) => ["absolute", "fixed"].includes(r),
      default: xe("strategy")
    },
    autoHide: {
      type: [Boolean, Function],
      default: xe("autoHide")
    },
    handleResize: {
      type: Boolean,
      default: xe("handleResize")
    },
    instantMove: {
      type: Boolean,
      default: xe("instantMove")
    },
    eagerMount: {
      type: Boolean,
      default: xe("eagerMount")
    },
    popperClass: {
      type: [String, Array, Object],
      default: xe("popperClass")
    },
    computeTransformOrigin: {
      type: Boolean,
      default: xe("computeTransformOrigin")
    },
    autoMinSize: {
      type: Boolean,
      default: xe("autoMinSize")
    },
    autoSize: {
      type: [Boolean, String],
      default: xe("autoSize")
    },
    autoMaxSize: {
      type: Boolean,
      default: xe("autoMaxSize")
    },
    autoBoundaryMaxSize: {
      type: Boolean,
      default: xe("autoBoundaryMaxSize")
    },
    preventOverflow: {
      type: Boolean,
      default: xe("preventOverflow")
    },
    overflowPadding: {
      type: [Number, String],
      default: xe("overflowPadding")
    },
    arrowPadding: {
      type: [Number, String],
      default: xe("arrowPadding")
    },
    arrowOverflow: {
      type: Boolean,
      default: xe("arrowOverflow")
    },
    flip: {
      type: Boolean,
      default: xe("flip")
    },
    shift: {
      type: Boolean,
      default: xe("shift")
    },
    shiftCrossAxis: {
      type: Boolean,
      default: xe("shiftCrossAxis")
    },
    noAutoFocus: {
      type: Boolean,
      default: xe("noAutoFocus")
    }
  },
  provide() {
    return {
      [Fl]: {
        parentPopper: this
      }
    };
  },
  inject: {
    [Fl]: { default: null }
  },
  data() {
    return {
      isShown: !1,
      isMounted: !1,
      skipTransition: !1,
      classes: {
        showFrom: !1,
        showTo: !1,
        hideFrom: !1,
        hideTo: !0
      },
      result: {
        x: 0,
        y: 0,
        placement: "",
        strategy: this.strategy,
        arrow: {
          x: 0,
          y: 0,
          centerOffset: 0
        },
        transformOrigin: null
      },
      shownChildren: /* @__PURE__ */ new Set(),
      lastAutoHide: !0
    };
  },
  computed: {
    popperId() {
      return this.ariaId != null ? this.ariaId : this.randomId;
    },
    shouldMountContent() {
      return this.eagerMount || this.isMounted;
    },
    slotData() {
      return {
        popperId: this.popperId,
        isShown: this.isShown,
        shouldMountContent: this.shouldMountContent,
        skipTransition: this.skipTransition,
        autoHide: typeof this.autoHide == "function" ? this.lastAutoHide : this.autoHide,
        show: this.show,
        hide: this.hide,
        handleResize: this.handleResize,
        onResize: this.onResize,
        classes: za(Rr({}, this.classes), {
          popperClass: this.popperClass
        }),
        result: this.positioningDisabled ? null : this.result
      };
    },
    parentPopper() {
      var r;
      return (r = this[Fl]) == null ? void 0 : r.parentPopper;
    },
    hasPopperShowTriggerHover() {
      var r, e;
      return ((r = this.popperTriggers) == null ? void 0 : r.includes("hover")) || ((e = this.popperShowTriggers) == null ? void 0 : e.includes("hover"));
    }
  },
  watch: Rr(Rr({
    shown: "$_autoShowHide",
    disabled(r) {
      r ? this.dispose() : this.init();
    },
    async container() {
      this.isShown && (this.$_ensureTeleport(), await this.$_computePosition());
    }
  }, [
    "triggers",
    "positioningDisabled"
  ].reduce((r, e) => (r[e] = "$_refreshListeners", r), {})), [
    "placement",
    "distance",
    "skidding",
    "boundary",
    "strategy",
    "overflowPadding",
    "arrowPadding",
    "preventOverflow",
    "shift",
    "shiftCrossAxis",
    "flip"
  ].reduce((r, e) => (r[e] = "$_computePosition", r), {})),
  created() {
    this.$_isDisposed = !0, this.randomId = `popper_${[Math.random(), Date.now()].map((r) => r.toString(36).substring(2, 10)).join("_")}`, this.autoMinSize && console.warn('[floating-vue] `autoMinSize` option is deprecated. Use `autoSize="min"` instead.'), this.autoMaxSize && console.warn("[floating-vue] `autoMaxSize` option is deprecated. Use `autoBoundaryMaxSize` instead.");
  },
  mounted() {
    this.init(), this.$_detachPopperNode();
  },
  activated() {
    this.$_autoShowHide();
  },
  deactivated() {
    this.hide();
  },
  beforeDestroy() {
    this.dispose();
  },
  methods: {
    show({ event: r = null, skipDelay: e = !1, force: t = !1 } = {}) {
      var n, i;
      (n = this.parentPopper) != null && n.lockedChild && this.parentPopper.lockedChild !== this || (this.$_pendingHide = !1, (t || !this.disabled) && (((i = this.parentPopper) == null ? void 0 : i.lockedChild) === this && (this.parentPopper.lockedChild = null), this.$_scheduleShow(r, e), this.$emit("show"), this.$_showFrameLocked = !0, requestAnimationFrame(() => {
        this.$_showFrameLocked = !1;
      })), this.$emit("update:shown", !0));
    },
    hide({ event: r = null, skipDelay: e = !1, skipAiming: t = !1 } = {}) {
      var n;
      if (!this.$_hideInProgress) {
        if (this.shownChildren.size > 0) {
          this.$_pendingHide = !0;
          return;
        }
        if (!t && this.hasPopperShowTriggerHover && this.$_isAimingPopper()) {
          this.parentPopper && (this.parentPopper.lockedChild = this, clearTimeout(this.parentPopper.lockedChildTimer), this.parentPopper.lockedChildTimer = setTimeout(() => {
            this.parentPopper.lockedChild === this && (this.parentPopper.lockedChild.hide({ skipDelay: e }), this.parentPopper.lockedChild = null);
          }, 1e3));
          return;
        }
        ((n = this.parentPopper) == null ? void 0 : n.lockedChild) === this && (this.parentPopper.lockedChild = null), this.$_pendingHide = !1, this.$_scheduleHide(r, e), this.$emit("hide"), this.$emit("update:shown", !1);
      }
    },
    init() {
      this.$_isDisposed && (this.$_isDisposed = !1, this.isMounted = !1, this.$_events = [], this.$_preventShow = !1, this.$_referenceNode = this.referenceNode(), this.$_targetNodes = this.targetNodes().filter((r) => r.nodeType === r.ELEMENT_NODE), this.$_popperNode = this.popperNode(), this.$_innerNode = this.$_popperNode.querySelector(".v-popper__inner"), this.$_arrowNode = this.$_popperNode.querySelector(".v-popper__arrow-container"), this.$_swapTargetAttrs("title", "data-original-title"), this.$_detachPopperNode(), this.triggers.length && this.$_addEventListeners(), this.shown && this.show());
    },
    dispose() {
      this.$_isDisposed || (this.$_isDisposed = !0, this.$_removeEventListeners(), this.hide({ skipDelay: !0 }), this.$_detachPopperNode(), this.isMounted = !1, this.isShown = !1, this.$_updateParentShownChildren(!1), this.$_swapTargetAttrs("data-original-title", "title"), this.$emit("dispose"));
    },
    async onResize() {
      this.isShown && (await this.$_computePosition(), this.$emit("resize"));
    },
    async $_computePosition() {
      var r;
      if (this.$_isDisposed || this.positioningDisabled)
        return;
      const e = {
        strategy: this.strategy,
        middleware: []
      };
      (this.distance || this.skidding) && e.middleware.push(wD({
        mainAxis: this.distance,
        crossAxis: this.skidding
      }));
      const t = this.placement.startsWith("auto");
      if (t ? e.middleware.push(YD({
        alignment: (r = this.placement.split("-")[1]) != null ? r : ""
      })) : e.placement = this.placement, this.preventOverflow && (this.shift && e.middleware.push(LD({
        padding: this.overflowPadding,
        boundary: this.boundary,
        crossAxis: this.shiftCrossAxis
      })), !t && this.flip && e.middleware.push(BD({
        padding: this.overflowPadding,
        boundary: this.boundary
      }))), e.middleware.push(OD({
        element: this.$_arrowNode,
        padding: this.arrowPadding
      })), this.arrowOverflow && e.middleware.push({
        name: "arrowOverflow",
        fn: ({ placement: i, rects: s, middlewareData: o }) => {
          let l;
          const { centerOffset: a } = o.arrow;
          return i.startsWith("top") || i.startsWith("bottom") ? l = Math.abs(a) > s.reference.width / 2 : l = Math.abs(a) > s.reference.height / 2, {
            data: {
              overflow: l
            }
          };
        }
      }), this.autoMinSize || this.autoSize) {
        const i = this.autoSize ? this.autoSize : this.autoMinSize ? "min" : null;
        e.middleware.push({
          name: "autoSize",
          fn: ({ rects: s, placement: o, middlewareData: l }) => {
            var a;
            if ((a = l.autoSize) != null && a.skip)
              return {};
            let c, T;
            return o.startsWith("top") || o.startsWith("bottom") ? c = s.reference.width : T = s.reference.height, this.$_innerNode.style[i === "min" ? "minWidth" : i === "max" ? "maxWidth" : "width"] = c != null ? `${c}px` : null, this.$_innerNode.style[i === "min" ? "minHeight" : i === "max" ? "maxHeight" : "height"] = T != null ? `${T}px` : null, {
              data: {
                skip: !0
              },
              reset: {
                rects: !0
              }
            };
          }
        });
      }
      (this.autoMaxSize || this.autoBoundaryMaxSize) && (this.$_innerNode.style.maxWidth = null, this.$_innerNode.style.maxHeight = null, e.middleware.push(kD({
        boundary: this.boundary,
        padding: this.overflowPadding,
        apply: ({ width: i, height: s }) => {
          this.$_innerNode.style.maxWidth = i != null ? `${i}px` : null, this.$_innerNode.style.maxHeight = s != null ? `${s}px` : null;
        }
      })));
      const n = await XD(this.$_referenceNode, this.$_popperNode, e);
      Object.assign(this.result, {
        x: n.x,
        y: n.y,
        placement: n.placement,
        strategy: n.strategy,
        arrow: Rr(Rr({}, n.middlewareData.arrow), n.middlewareData.arrowOverflow)
      });
    },
    $_scheduleShow(r = null, e = !1) {
      if (this.$_updateParentShownChildren(!0), this.$_hideInProgress = !1, clearTimeout(this.$_scheduleTimer), Br && this.instantMove && Br.instantMove && Br !== this.parentPopper) {
        Br.$_applyHide(!0), this.$_applyShow(!0);
        return;
      }
      e ? this.$_applyShow() : this.$_scheduleTimer = setTimeout(this.$_applyShow.bind(this), this.$_computeDelay("show"));
    },
    $_scheduleHide(r = null, e = !1) {
      if (this.shownChildren.size > 0) {
        this.$_pendingHide = !0;
        return;
      }
      this.$_updateParentShownChildren(!1), this.$_hideInProgress = !0, clearTimeout(this.$_scheduleTimer), this.isShown && (Br = this), e ? this.$_applyHide() : this.$_scheduleTimer = setTimeout(this.$_applyHide.bind(this), this.$_computeDelay("hide"));
    },
    $_computeDelay(r) {
      const e = this.delay;
      return parseInt(e && e[r] || e || 0);
    },
    async $_applyShow(r = !1) {
      clearTimeout(this.$_disposeTimer), clearTimeout(this.$_scheduleTimer), this.skipTransition = r, !this.isShown && (this.$_ensureTeleport(), await Nl(), await this.$_computePosition(), await this.$_applyShowEffect(), this.positioningDisabled || this.$_registerEventListeners([
        ...Aa(this.$_referenceNode),
        ...Aa(this.$_popperNode)
      ], "scroll", () => {
        this.$_computePosition();
      }));
    },
    async $_applyShowEffect() {
      if (this.$_hideInProgress)
        return;
      if (this.computeTransformOrigin) {
        const e = this.$_referenceNode.getBoundingClientRect(), t = this.$_popperNode.querySelector(".v-popper__wrapper"), n = t.parentNode.getBoundingClientRect(), i = e.x + e.width / 2 - (n.left + t.offsetLeft), s = e.y + e.height / 2 - (n.top + t.offsetTop);
        this.result.transformOrigin = `${i}px ${s}px`;
      }
      this.isShown = !0, this.$_applyAttrsToTarget({
        "aria-describedby": this.popperId,
        "data-popper-shown": ""
      });
      const r = this.showGroup;
      if (r) {
        let e;
        for (let t = 0; t < Ft.length; t++)
          e = Ft[t], e.showGroup !== r && (e.hide(), e.$emit("close-group"));
      }
      Ft.push(this), document.body.classList.add("v-popper--some-open");
      for (const e of pp(this.theme))
        Ep(e).push(this), document.body.classList.add(`v-popper--some-open--${e}`);
      this.$emit("apply-show"), this.classes.showFrom = !0, this.classes.showTo = !1, this.classes.hideFrom = !1, this.classes.hideTo = !1, await Nl(), this.classes.showFrom = !1, this.classes.showTo = !0, this.noAutoFocus || this.$_popperNode.focus();
    },
    async $_applyHide(r = !1) {
      if (this.shownChildren.size > 0) {
        this.$_pendingHide = !0, this.$_hideInProgress = !1;
        return;
      }
      if (clearTimeout(this.$_scheduleTimer), !this.isShown)
        return;
      this.skipTransition = r, hp(Ft, this), Ft.length === 0 && document.body.classList.remove("v-popper--some-open");
      for (const t of pp(this.theme)) {
        const n = Ep(t);
        hp(n, this), n.length === 0 && document.body.classList.remove(`v-popper--some-open--${t}`);
      }
      Br === this && (Br = null), this.isShown = !1, this.$_applyAttrsToTarget({
        "aria-describedby": void 0,
        "data-popper-shown": void 0
      }), clearTimeout(this.$_disposeTimer);
      const e = An(this.theme, "disposeTimeout");
      e !== null && (this.$_disposeTimer = setTimeout(() => {
        this.$_popperNode && (this.$_detachPopperNode(), this.isMounted = !1);
      }, e)), this.$_removeEventListeners("scroll"), this.$emit("apply-hide"), this.classes.showFrom = !1, this.classes.showTo = !1, this.classes.hideFrom = !0, this.classes.hideTo = !1, await Nl(), this.classes.hideFrom = !1, this.classes.hideTo = !0;
    },
    $_autoShowHide() {
      this.shown ? this.show() : this.hide();
    },
    $_ensureTeleport() {
      if (this.$_isDisposed)
        return;
      let r = this.container;
      if (typeof r == "string" ? r = window.document.querySelector(r) : r === !1 && (r = this.$_targetNodes[0].parentNode), !r)
        throw new Error("No container for popover: " + this.container);
      r.appendChild(this.$_popperNode), this.isMounted = !0;
    },
    $_addEventListeners() {
      const r = (t) => {
        this.isShown && !this.$_hideInProgress || (t.usedByTooltip = !0, !this.$_preventShow && this.show({ event: t }));
      };
      this.$_registerTriggerListeners(this.$_targetNodes, Kl, this.triggers, this.showTriggers, r), this.$_registerTriggerListeners([this.$_popperNode], Kl, this.popperTriggers, this.popperShowTriggers, r);
      const e = (t) => (n) => {
        n.usedByTooltip || this.hide({ event: n, skipAiming: t });
      };
      this.$_registerTriggerListeners(this.$_targetNodes, Jl, this.triggers, this.hideTriggers, e(!1)), this.$_registerTriggerListeners([this.$_popperNode], Jl, this.popperTriggers, this.popperHideTriggers, e(!0));
    },
    $_registerEventListeners(r, e, t) {
      this.$_events.push({ targetNodes: r, eventType: e, handler: t }), r.forEach((n) => n.addEventListener(e, t, zr ? {
        passive: !0
      } : void 0));
    },
    $_registerTriggerListeners(r, e, t, n, i) {
      let s = t;
      n != null && (s = typeof n == "function" ? n(s) : n), s.forEach((o) => {
        const l = e[o];
        l && this.$_registerEventListeners(r, l, i);
      });
    },
    $_removeEventListeners(r) {
      const e = [];
      this.$_events.forEach((t) => {
        const { targetNodes: n, eventType: i, handler: s } = t;
        !r || r === i ? n.forEach((o) => o.removeEventListener(i, s)) : e.push(t);
      }), this.$_events = e;
    },
    $_refreshListeners() {
      this.$_isDisposed || (this.$_removeEventListeners(), this.$_addEventListeners());
    },
    $_handleGlobalClose(r, e = !1) {
      this.$_showFrameLocked || (this.hide({ event: r }), r.closePopover ? this.$emit("close-directive") : this.$emit("auto-hide"), e && (this.$_preventShow = !0, setTimeout(() => {
        this.$_preventShow = !1;
      }, 300)));
    },
    $_detachPopperNode() {
      this.$_popperNode.parentNode && this.$_popperNode.parentNode.removeChild(this.$_popperNode);
    },
    $_swapTargetAttrs(r, e) {
      for (const t of this.$_targetNodes) {
        const n = t.getAttribute(r);
        n && (t.removeAttribute(r), t.setAttribute(e, n));
      }
    },
    $_applyAttrsToTarget(r) {
      for (const e of this.$_targetNodes)
        for (const t in r) {
          const n = r[t];
          n == null ? e.removeAttribute(t) : e.setAttribute(t, n);
        }
    },
    $_updateParentShownChildren(r) {
      let e = this.parentPopper;
      for (; e; )
        r ? e.shownChildren.add(this.randomId) : (e.shownChildren.delete(this.randomId), e.$_pendingHide && e.hide()), e = e.parentPopper;
    },
    $_isAimingPopper() {
      const r = this.$el.getBoundingClientRect();
      if ($n >= r.left && $n <= r.right && Vn >= r.top && Vn <= r.bottom) {
        const e = this.$_popperNode.getBoundingClientRect(), t = $n - Er, n = Vn - Sr, s = e.left + e.width / 2 - Er + (e.top + e.height / 2) - Sr + e.width + e.height, o = Er + t * s, l = Sr + n * s;
        return Oi(Er, Sr, o, l, e.left, e.top, e.left, e.bottom) || Oi(Er, Sr, o, l, e.left, e.top, e.right, e.top) || Oi(Er, Sr, o, l, e.right, e.top, e.right, e.bottom) || Oi(Er, Sr, o, l, e.left, e.bottom, e.right, e.bottom);
      }
      return !1;
    }
  },
  render() {
    return this.$scopedSlots.default(this.slotData)[0];
  }
});
typeof document < "u" && typeof window < "u" && (Ym ? (document.addEventListener("touchstart", Sp, zr ? {
  passive: !0,
  capture: !0
} : !0), document.addEventListener("touchend", og, zr ? {
  passive: !0,
  capture: !0
} : !0)) : (window.addEventListener("mousedown", Sp, !0), window.addEventListener("click", ag, !0)), window.addEventListener("resize", ug));
function Sp(r) {
  for (let e = 0; e < Ft.length; e++) {
    const t = Ft[e];
    try {
      const n = t.popperNode();
      t.$_mouseDownContains = n.contains(r.target);
    } catch {
    }
  }
}
function ag(r) {
  Im(r);
}
function og(r) {
  Im(r, !0);
}
function Im(r, e = !1) {
  const t = {};
  for (let n = Ft.length - 1; n >= 0; n--) {
    const i = Ft[n];
    try {
      const s = i.$_containsGlobalTarget = sg(i, r);
      i.$_pendingHide = !1, requestAnimationFrame(() => {
        if (i.$_pendingHide = !1, !t[i.randomId] && Dp(i, s, r)) {
          if (i.$_handleGlobalClose(r, e), !r.closeAllPopover && r.closePopover && s) {
            let l = i.parentPopper;
            for (; l; )
              t[l.randomId] = !0, l = l.parentPopper;
            return;
          }
          let o = i.parentPopper;
          for (; o && Dp(o, o.$_containsGlobalTarget, r); ) {
            o.$_handleGlobalClose(r, e);
            o = o.parentPopper;
          }
        }
      });
    } catch {
    }
  }
}
function sg(r, e) {
  const t = r.popperNode();
  return r.$_mouseDownContains || t.contains(e.target);
}
function Dp(r, e, t) {
  return t.closeAllPopover || t.closePopover && e || lg(r, t) && !e;
}
function lg(r, e) {
  if (typeof r.autoHide == "function") {
    const t = r.autoHide(e);
    return r.lastAutoHide = t, t;
  }
  return r.autoHide;
}
function ug(r) {
  for (let e = 0; e < Ft.length; e++)
    Ft[e].$_computePosition(r);
}
function cg() {
  for (let r = 0; r < Ft.length; r++)
    Ft[r].hide();
}
let Er = 0, Sr = 0, $n = 0, Vn = 0;
typeof window < "u" && window.addEventListener("mousemove", (r) => {
  Er = $n, Sr = Vn, $n = r.clientX, Vn = r.clientY;
}, zr ? {
  passive: !0
} : void 0);
function Oi(r, e, t, n, i, s, o, l) {
  const a = ((o - i) * (e - s) - (l - s) * (r - i)) / ((l - s) * (t - r) - (o - i) * (n - e)), c = ((t - r) * (e - s) - (n - e) * (r - i)) / ((l - s) * (t - r) - (o - i) * (n - e));
  return a >= 0 && a <= 1 && c >= 0 && c <= 1;
}
function Tg() {
  var r = window.navigator.userAgent, e = r.indexOf("MSIE ");
  if (e > 0)
    return parseInt(r.substring(e + 5, r.indexOf(".", e)), 10);
  var t = r.indexOf("Trident/");
  if (t > 0) {
    var n = r.indexOf("rv:");
    return parseInt(r.substring(n + 3, r.indexOf(".", n)), 10);
  }
  var i = r.indexOf("Edge/");
  return i > 0 ? parseInt(r.substring(i + 5, r.indexOf(".", i)), 10) : -1;
}
var wi;
function eu() {
  eu.init || (eu.init = !0, wi = Tg() !== -1);
}
var dg = {
  name: "ResizeObserver",
  props: {
    emitOnMount: {
      type: Boolean,
      default: !1
    },
    ignoreWidth: {
      type: Boolean,
      default: !1
    },
    ignoreHeight: {
      type: Boolean,
      default: !1
    }
  },
  mounted: function() {
    var e = this;
    eu(), this.$nextTick(function() {
      e._w = e.$el.offsetWidth, e._h = e.$el.offsetHeight, e.emitOnMount && e.emitSize();
    });
    var t = document.createElement("object");
    this._resizeObject = t, t.setAttribute("aria-hidden", "true"), t.setAttribute("tabindex", -1), t.onload = this.addResizeHandlers, t.type = "text/html", wi && this.$el.appendChild(t), t.data = "about:blank", wi || this.$el.appendChild(t);
  },
  beforeDestroy: function() {
    this.removeResizeHandlers();
  },
  methods: {
    compareAndNotify: function() {
      (!this.ignoreWidth && this._w !== this.$el.offsetWidth || !this.ignoreHeight && this._h !== this.$el.offsetHeight) && (this._w = this.$el.offsetWidth, this._h = this.$el.offsetHeight, this.emitSize());
    },
    emitSize: function() {
      this.$emit("notify", {
        width: this._w,
        height: this._h
      });
    },
    addResizeHandlers: function() {
      this._resizeObject.contentDocument.defaultView.addEventListener("resize", this.compareAndNotify), this.compareAndNotify();
    },
    removeResizeHandlers: function() {
      this._resizeObject && this._resizeObject.onload && (!wi && this._resizeObject.contentDocument && this._resizeObject.contentDocument.defaultView.removeEventListener("resize", this.compareAndNotify), this.$el.removeChild(this._resizeObject), this._resizeObject.onload = null, this._resizeObject = null);
    }
  }
};
function Ag(r, e, t, n, i, s, o, l, a, c) {
  typeof o != "boolean" && (a = l, l = o, o = !1);
  var T = typeof t == "function" ? t.options : t;
  r && r.render && (T.render = r.render, T.staticRenderFns = r.staticRenderFns, T._compiled = !0, i && (T.functional = !0)), n && (T._scopeId = n);
  var u;
  if (s ? (u = function(h) {
    h = h || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !h && typeof __VUE_SSR_CONTEXT__ < "u" && (h = __VUE_SSR_CONTEXT__), e && e.call(this, a(h)), h && h._registeredComponents && h._registeredComponents.add(s);
  }, T._ssrRegister = u) : e && (u = o ? function(f) {
    e.call(this, c(f, this.$root.$options.shadowRoot));
  } : function(f) {
    e.call(this, l(f));
  }), u)
    if (T.functional) {
      var d = T.render;
      T.render = function(h, S) {
        return u.call(S), d(h, S);
      };
    } else {
      var A = T.beforeCreate;
      T.beforeCreate = A ? [].concat(A, u) : [u];
    }
  return t;
}
var fg = dg, Bm = function() {
  var e = this, t = e.$createElement, n = e._self._c || t;
  return n("div", {
    staticClass: "resize-observer",
    attrs: {
      tabindex: "-1"
    }
  });
}, pg = [];
Bm._withStripped = !0;
var hg = void 0, mg = "data-v-8859cc6c", Eg = void 0, Sg = !1, tu = /* @__PURE__ */ Ag({
  render: Bm,
  staticRenderFns: pg
}, hg, fg, mg, Sg, Eg, !1, void 0, void 0, void 0);
function Dg(r) {
  r.component("resize-observer", tu), r.component("ResizeObserver", tu);
}
var gg = {
  version: "1.0.1",
  install: Dg
}, pa = null;
typeof window < "u" ? pa = window.Vue : typeof global < "u" && (pa = global.Vue);
pa && pa.use(gg);
var rc = {
  computed: {
    themeClass() {
      return ig(this.theme);
    }
  }
}, Rg = {
  name: "VPopperContent",
  components: {
    ResizeObserver: tu
  },
  mixins: [
    rc
  ],
  props: {
    popperId: String,
    theme: String,
    shown: Boolean,
    mounted: Boolean,
    skipTransition: Boolean,
    autoHide: Boolean,
    handleResize: Boolean,
    classes: Object,
    result: Object
  },
  methods: {
    toPx(r) {
      return r != null && !isNaN(r) ? `${r}px` : null;
    }
  }
}, vg = function() {
  var r = this, e = r.$createElement, t = r._self._c || e;
  return t("div", { ref: "popover", staticClass: "v-popper__popper", class: [
    r.themeClass,
    r.classes.popperClass,
    {
      "v-popper__popper--shown": r.shown,
      "v-popper__popper--hidden": !r.shown,
      "v-popper__popper--show-from": r.classes.showFrom,
      "v-popper__popper--show-to": r.classes.showTo,
      "v-popper__popper--hide-from": r.classes.hideFrom,
      "v-popper__popper--hide-to": r.classes.hideTo,
      "v-popper__popper--skip-transition": r.skipTransition,
      "v-popper__popper--arrow-overflow": r.result && r.result.arrow.overflow,
      "v-popper__popper--no-positioning": !r.result
    }
  ], style: r.result ? {
    position: r.result.strategy,
    transform: "translate3d(" + Math.round(r.result.x) + "px," + Math.round(r.result.y) + "px,0)"
  } : void 0, attrs: { id: r.popperId, "aria-hidden": r.shown ? "false" : "true", tabindex: r.autoHide ? 0 : void 0, "data-popper-placement": r.result ? r.result.placement : void 0 }, on: { keyup: function(n) {
    if (!n.type.indexOf("key") && r._k(n.keyCode, "esc", 27, n.key, ["Esc", "Escape"]))
      return null;
    r.autoHide && r.$emit("hide");
  } } }, [t("div", { staticClass: "v-popper__backdrop", on: { click: function(n) {
    r.autoHide && r.$emit("hide");
  } } }), t("div", { staticClass: "v-popper__wrapper", style: r.result ? {
    transformOrigin: r.result.transformOrigin
  } : void 0 }, [t("div", { ref: "inner", staticClass: "v-popper__inner" }, [r.mounted ? [t("div", [r._t("default")], 2), r.handleResize ? t("ResizeObserver", { on: { notify: function(n) {
    return r.$emit("resize", n);
  } } }) : r._e()] : r._e()], 2), t("div", { ref: "arrow", staticClass: "v-popper__arrow-container", style: r.result ? {
    left: r.toPx(r.result.arrow.x),
    top: r.toPx(r.result.arrow.y)
  } : void 0 }, [t("div", { staticClass: "v-popper__arrow-outer" }), t("div", { staticClass: "v-popper__arrow-inner" })])])]);
}, Ng = [];
function yn(r, e, t, n, i, s, o, l) {
  var a = typeof r == "function" ? r.options : r;
  e && (a.render = e, a.staticRenderFns = t, a._compiled = !0), n && (a.functional = !0), s && (a._scopeId = "data-v-" + s);
  var c;
  if (o ? (c = function(d) {
    d = d || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !d && typeof __VUE_SSR_CONTEXT__ < "u" && (d = __VUE_SSR_CONTEXT__), i && i.call(this, d), d && d._registeredComponents && d._registeredComponents.add(o);
  }, a._ssrRegister = c) : i && (c = l ? function() {
    i.call(this, (a.functional ? this.parent : this).$root.$options.shadowRoot);
  } : i), c)
    if (a.functional) {
      a._injectStyles = c;
      var T = a.render;
      a.render = function(A, f) {
        return c.call(f), T(A, f);
      };
    } else {
      var u = a.beforeCreate;
      a.beforeCreate = u ? [].concat(u, c) : [c];
    }
  return {
    exports: r,
    options: a
  };
}
const gp = {};
var Fg = /* @__PURE__ */ yn(Rg, vg, Ng, !1, Og, null, null, null);
function Og(r) {
  for (let e in gp)
    this[e] = gp[e];
}
var nc = /* @__PURE__ */ function() {
  return Fg.exports;
}(), $a = {
  methods: {
    show(...r) {
      return this.$refs.popper.show(...r);
    },
    hide(...r) {
      return this.$refs.popper.hide(...r);
    },
    dispose(...r) {
      return this.$refs.popper.dispose(...r);
    },
    onResize(...r) {
      return this.$refs.popper.onResize(...r);
    }
  }
}, yg = {
  name: "VPopperWrapper",
  components: {
    Popper: tc(),
    PopperContent: nc
  },
  mixins: [
    $a,
    rc
  ],
  inheritAttrs: !1,
  props: {
    theme: {
      type: String,
      default() {
        return this.$options.vPopperTheme;
      }
    }
  },
  methods: {
    getTargetNodes() {
      return Array.from(this.$refs.reference.children).filter((r) => r !== this.$refs.popperContent.$el);
    }
  }
}, bg = function() {
  var r = this, e = r.$createElement, t = r._self._c || e;
  return t("Popper", r._g(r._b({ ref: "popper", attrs: { theme: r.theme, "target-nodes": r.getTargetNodes, "reference-node": function() {
    return r.$refs.reference;
  }, "popper-node": function() {
    return r.$refs.popperContent.$el;
  } }, scopedSlots: r._u([{ key: "default", fn: function(n) {
    var i = n.popperId, s = n.isShown, o = n.shouldMountContent, l = n.skipTransition, a = n.autoHide, c = n.show, T = n.hide, u = n.handleResize, d = n.onResize, A = n.classes, f = n.result;
    return [t("div", { ref: "reference", staticClass: "v-popper", class: [
      r.themeClass,
      {
        "v-popper--shown": s
      }
    ] }, [r._t("default", null, { shown: s, show: c, hide: T }), t("PopperContent", { ref: "popperContent", attrs: { "popper-id": i, theme: r.theme, shown: s, mounted: o, "skip-transition": l, "auto-hide": a, "handle-resize": u, classes: A, result: f }, on: { hide: T, resize: d } }, [r._t("popper", null, { shown: s, hide: T })], 2)], 2)];
  } }], null, !0) }, "Popper", r.$attrs, !1), r.$listeners));
}, Cg = [];
const Rp = {};
var _g = /* @__PURE__ */ yn(yg, bg, Cg, !1, Mg, null, null, null);
function Mg(r) {
  for (let e in Rp)
    this[e] = Rp[e];
}
var Va = /* @__PURE__ */ function() {
  return _g.exports;
}(), Yg = za(Rr({}, Va), {
  name: "VDropdown",
  vPopperTheme: "dropdown"
});
let Ig, Bg;
const vp = {};
var Zg = /* @__PURE__ */ yn(Yg, Ig, Bg, !1, wg, null, null, null);
function wg(r) {
  for (let e in vp)
    this[e] = vp[e];
}
var ru = /* @__PURE__ */ function() {
  return Zg.exports;
}(), xg = za(Rr({}, Va), {
  name: "VMenu",
  vPopperTheme: "menu"
});
let Lg, kg;
const Np = {};
var Pg = /* @__PURE__ */ yn(xg, Lg, kg, !1, Gg, null, null, null);
function Gg(r) {
  for (let e in Np)
    this[e] = Np[e];
}
var nu = /* @__PURE__ */ function() {
  return Pg.exports;
}(), Ug = za(Rr({}, Va), {
  name: "VTooltip",
  vPopperTheme: "tooltip"
});
let Hg, jg;
const Fp = {};
var zg = /* @__PURE__ */ yn(Ug, Hg, jg, !1, $g, null, null, null);
function $g(r) {
  for (let e in Fp)
    this[e] = Fp[e];
}
var iu = /* @__PURE__ */ function() {
  return zg.exports;
}(), Vg = {
  name: "VTooltipDirective",
  components: {
    Popper: tc(),
    PopperContent: nc
  },
  mixins: [
    $a
  ],
  inheritAttrs: !1,
  props: {
    theme: {
      type: String,
      default: "tooltip"
    },
    html: {
      type: Boolean,
      default() {
        return An(this.theme, "html");
      }
    },
    content: {
      type: [String, Number, Function],
      default: null
    },
    loadingContent: {
      type: String,
      default() {
        return An(this.theme, "loadingContent");
      }
    }
  },
  data() {
    return {
      asyncContent: null
    };
  },
  computed: {
    isContentAsync() {
      return typeof this.content == "function";
    },
    loading() {
      return this.isContentAsync && this.asyncContent == null;
    },
    finalContent() {
      return this.isContentAsync ? this.loading ? this.loadingContent : this.asyncContent : this.content;
    }
  },
  watch: {
    content: {
      handler() {
        this.fetchContent(!0);
      },
      immediate: !0
    },
    async finalContent(r) {
      await this.$nextTick(), this.$refs.popper.onResize();
    }
  },
  created() {
    this.$_fetchId = 0;
  },
  methods: {
    fetchContent(r) {
      if (typeof this.content == "function" && this.$_isShown && (r || !this.$_loading && this.asyncContent == null)) {
        this.asyncContent = null, this.$_loading = !0;
        const e = ++this.$_fetchId, t = this.content(this);
        t.then ? t.then((n) => this.onResult(e, n)) : this.onResult(e, t);
      }
    },
    onResult(r, e) {
      r === this.$_fetchId && (this.$_loading = !1, this.asyncContent = e);
    },
    onShow() {
      this.$_isShown = !0, this.fetchContent();
    },
    onHide() {
      this.$_isShown = !1;
    }
  }
}, qg = function() {
  var r = this, e = r.$createElement, t = r._self._c || e;
  return t("Popper", r._g(r._b({ ref: "popper", attrs: { theme: r.theme, "popper-node": function() {
    return r.$refs.popperContent.$el;
  } }, on: { "apply-show": r.onShow, "apply-hide": r.onHide }, scopedSlots: r._u([{ key: "default", fn: function(n) {
    var i = n.popperId, s = n.isShown, o = n.shouldMountContent, l = n.skipTransition, a = n.autoHide, c = n.hide, T = n.handleResize, u = n.onResize, d = n.classes, A = n.result;
    return [t("PopperContent", { ref: "popperContent", class: {
      "v-popper--tooltip-loading": r.loading
    }, attrs: { "popper-id": i, theme: r.theme, shown: s, mounted: o, "skip-transition": l, "auto-hide": a, "handle-resize": T, classes: d, result: A }, on: { hide: c, resize: u } }, [r.html ? t("div", { domProps: { innerHTML: r._s(r.finalContent) } }) : t("div", { domProps: { textContent: r._s(r.finalContent) } })])];
  } }]) }, "Popper", r.$attrs, !1), r.$listeners));
}, Wg = [];
const Op = {};
var Qg = /* @__PURE__ */ yn(Vg, qg, Wg, !1, Kg, null, null, null);
function Kg(r) {
  for (let e in Op)
    this[e] = Op[e];
}
var Zm = /* @__PURE__ */ function() {
  return Qg.exports;
}();
const wm = "v-popper--has-tooltip";
function Jg(r, e) {
  let t = r.placement;
  if (!t && e)
    for (const n of ec)
      e[n] && (t = n);
  return t || (t = An(r.theme || "tooltip", "placement")), t;
}
function xm(r, e, t) {
  let n;
  const i = typeof e;
  return i === "string" ? n = { content: e } : e && i === "object" ? n = e : n = { content: !1 }, n.placement = Jg(n, t), n.targetNodes = () => [r], n.referenceNode = () => r, n;
}
function Lm(r, e, t) {
  const n = xm(r, e, t), i = r.$_popper = new Jp({
    mixins: [
      $a
    ],
    data() {
      return {
        options: n
      };
    },
    render(o) {
      const l = this.options, {
        theme: a,
        html: c,
        content: T,
        loadingContent: u
      } = l, d = ng(l, [
        "theme",
        "html",
        "content",
        "loadingContent"
      ]);
      return o(Zm, {
        props: {
          theme: a,
          html: c,
          content: T,
          loadingContent: u
        },
        attrs: d,
        ref: "popper"
      });
    },
    devtools: {
      hide: !0
    }
  }), s = document.createElement("div");
  return document.body.appendChild(s), i.$mount(s), r.classList && r.classList.add(wm), i;
}
function ic(r) {
  r.$_popper && (r.$_popper.$destroy(), delete r.$_popper, delete r.$_popperOldShown), r.classList && r.classList.remove(wm);
}
function yp(r, { value: e, oldValue: t, modifiers: n }) {
  const i = xm(r, e, n);
  if (!i.content || An(i.theme || "tooltip", "disabled"))
    ic(r);
  else {
    let s;
    r.$_popper ? (s = r.$_popper, s.options = i) : s = Lm(r, e, n), typeof e.shown < "u" && e.shown !== r.$_popperOldShown && (r.$_popperOldShown = e.shown, e.shown ? s.show() : s.hide());
  }
}
var km = {
  bind: yp,
  update: yp,
  unbind(r) {
    ic(r);
  }
};
function bp(r) {
  r.addEventListener("click", Pm), r.addEventListener("touchstart", Gm, zr ? {
    passive: !0
  } : !1);
}
function Cp(r) {
  r.removeEventListener("click", Pm), r.removeEventListener("touchstart", Gm), r.removeEventListener("touchend", Um), r.removeEventListener("touchcancel", Hm);
}
function Pm(r) {
  const e = r.currentTarget;
  r.closePopover = !e.$_vclosepopover_touch, r.closeAllPopover = e.$_closePopoverModifiers && !!e.$_closePopoverModifiers.all;
}
function Gm(r) {
  if (r.changedTouches.length === 1) {
    const e = r.currentTarget;
    e.$_vclosepopover_touch = !0;
    const t = r.changedTouches[0];
    e.$_vclosepopover_touchPoint = t, e.addEventListener("touchend", Um), e.addEventListener("touchcancel", Hm);
  }
}
function Um(r) {
  const e = r.currentTarget;
  if (e.$_vclosepopover_touch = !1, r.changedTouches.length === 1) {
    const t = r.changedTouches[0], n = e.$_vclosepopover_touchPoint;
    r.closePopover = Math.abs(t.screenY - n.screenY) < 20 && Math.abs(t.screenX - n.screenX) < 20, r.closeAllPopover = e.$_closePopoverModifiers && !!e.$_closePopoverModifiers.all;
  }
}
function Hm(r) {
  const e = r.currentTarget;
  e.$_vclosepopover_touch = !1;
}
var jm = {
  bind(r, { value: e, modifiers: t }) {
    r.$_closePopoverModifiers = t, (typeof e > "u" || e) && bp(r);
  },
  update(r, { value: e, oldValue: t, modifiers: n }) {
    r.$_closePopoverModifiers = n, e !== t && (typeof e > "u" || e ? bp(r) : Cp(r));
  },
  unbind(r) {
    Cp(r);
  }
};
const Xg = $t, eR = km, tR = jm, rR = ru, nR = nu, iR = tc, aR = nc, oR = $a, sR = Va, lR = rc, uR = iu, cR = Zm;
function zm(r, e = {}) {
  r.$_vTooltipInstalled || (r.$_vTooltipInstalled = !0, Mm($t, e), r.directive("tooltip", km), r.directive("close-popper", jm), r.component("v-tooltip", iu), r.component("VTooltip", iu), r.component("v-dropdown", ru), r.component("VDropdown", ru), r.component("v-menu", nu), r.component("VMenu", nu));
}
const $m = {
  version: "1.0.0-beta.19",
  install: zm,
  options: $t
};
let ha = null;
typeof window < "u" ? ha = window.Vue : typeof global < "u" && (ha = global.Vue);
ha && ha.use($m);
const TR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Dropdown: rR,
  HIDE_EVENT_MAP: Jl,
  Menu: nR,
  Popper: iR,
  PopperContent: aR,
  PopperMethods: oR,
  PopperWrapper: sR,
  SHOW_EVENT_MAP: Kl,
  ThemeClass: lR,
  Tooltip: uR,
  TooltipDirective: cR,
  VClosePopper: tR,
  VTooltip: eR,
  createTooltip: Lm,
  default: $m,
  destroyTooltip: ic,
  hideAllPoppers: cg,
  install: zm,
  options: Xg,
  placements: ec
}, Symbol.toStringTag, { value: "Module" })), dR = /* @__PURE__ */ Vr(TR);
/*!
* tabbable 6.0.1
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var Vm = ["input", "select", "textarea", "a[href]", "button", "[tabindex]:not(slot)", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])', "details>summary:first-of-type", "details"], ma = /* @__PURE__ */ Vm.join(","), qm = typeof Element > "u", $r = qm ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, Ea = !qm && Element.prototype.getRootNode ? function(r) {
  return r.getRootNode();
} : function(r) {
  return r.ownerDocument;
}, Wm = function(e, t, n) {
  var i = Array.prototype.slice.apply(e.querySelectorAll(ma));
  return t && $r.call(e, ma) && i.unshift(e), i = i.filter(n), i;
}, Qm = function r(e, t, n) {
  for (var i = [], s = Array.from(e); s.length; ) {
    var o = s.shift();
    if (o.tagName === "SLOT") {
      var l = o.assignedElements(), a = l.length ? l : o.children, c = r(a, !0, n);
      n.flatten ? i.push.apply(i, c) : i.push({
        scopeParent: o,
        candidates: c
      });
    } else {
      var T = $r.call(o, ma);
      T && n.filter(o) && (t || !e.includes(o)) && i.push(o);
      var u = o.shadowRoot || // check for an undisclosed shadow
      typeof n.getShadowRoot == "function" && n.getShadowRoot(o), d = !n.shadowRootFilter || n.shadowRootFilter(o);
      if (u && d) {
        var A = r(u === !0 ? o.children : u.children, !0, n);
        n.flatten ? i.push.apply(i, A) : i.push({
          scopeParent: o,
          candidates: A
        });
      } else
        s.unshift.apply(s, o.children);
    }
  }
  return i;
}, Km = function(e, t) {
  return e.tabIndex < 0 && (t || /^(AUDIO|VIDEO|DETAILS)$/.test(e.tagName) || e.isContentEditable) && isNaN(parseInt(e.getAttribute("tabindex"), 10)) ? 0 : e.tabIndex;
}, AR = function(e, t) {
  return e.tabIndex === t.tabIndex ? e.documentOrder - t.documentOrder : e.tabIndex - t.tabIndex;
}, Jm = function(e) {
  return e.tagName === "INPUT";
}, fR = function(e) {
  return Jm(e) && e.type === "hidden";
}, pR = function(e) {
  var t = e.tagName === "DETAILS" && Array.prototype.slice.apply(e.children).some(function(n) {
    return n.tagName === "SUMMARY";
  });
  return t;
}, hR = function(e, t) {
  for (var n = 0; n < e.length; n++)
    if (e[n].checked && e[n].form === t)
      return e[n];
}, mR = function(e) {
  if (!e.name)
    return !0;
  var t = e.form || Ea(e), n = function(l) {
    return t.querySelectorAll('input[type="radio"][name="' + l + '"]');
  }, i;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    i = n(window.CSS.escape(e.name));
  else
    try {
      i = n(e.name);
    } catch (o) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", o.message), !1;
    }
  var s = hR(i, e.form);
  return !s || s === e;
}, ER = function(e) {
  return Jm(e) && e.type === "radio";
}, SR = function(e) {
  return ER(e) && !mR(e);
}, DR = function(e) {
  for (var t, n = Ea(e).host, i = !!((t = n) !== null && t !== void 0 && t.ownerDocument.contains(n) || e.ownerDocument.contains(e)); !i && n; ) {
    var s;
    n = Ea(n).host, i = !!((s = n) !== null && s !== void 0 && s.ownerDocument.contains(n));
  }
  return i;
}, _p = function(e) {
  var t = e.getBoundingClientRect(), n = t.width, i = t.height;
  return n === 0 && i === 0;
}, gR = function(e, t) {
  var n = t.displayCheck, i = t.getShadowRoot;
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  var s = $r.call(e, "details>summary:first-of-type"), o = s ? e.parentElement : e;
  if ($r.call(o, "details:not([open]) *"))
    return !0;
  if (!n || n === "full" || n === "legacy-full") {
    if (typeof i == "function") {
      for (var l = e; e; ) {
        var a = e.parentElement, c = Ea(e);
        if (a && !a.shadowRoot && i(a) === !0)
          return _p(e);
        e.assignedSlot ? e = e.assignedSlot : !a && c !== e.ownerDocument ? e = c.host : e = a;
      }
      e = l;
    }
    if (DR(e))
      return !e.getClientRects().length;
    if (n !== "legacy-full")
      return !0;
  } else if (n === "non-zero-area")
    return _p(e);
  return !1;
}, RR = function(e) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(e.tagName))
    for (var t = e.parentElement; t; ) {
      if (t.tagName === "FIELDSET" && t.disabled) {
        for (var n = 0; n < t.children.length; n++) {
          var i = t.children.item(n);
          if (i.tagName === "LEGEND")
            return $r.call(t, "fieldset[disabled] *") ? !0 : !i.contains(e);
        }
        return !0;
      }
      t = t.parentElement;
    }
  return !1;
}, Sa = function(e, t) {
  return !(t.disabled || fR(t) || gR(t, e) || // For a details element with a summary, the summary element gets the focus
  pR(t) || RR(t));
}, au = function(e, t) {
  return !(SR(t) || Km(t) < 0 || !Sa(e, t));
}, vR = function(e) {
  var t = parseInt(e.getAttribute("tabindex"), 10);
  return !!(isNaN(t) || t >= 0);
}, NR = function r(e) {
  var t = [], n = [];
  return e.forEach(function(i, s) {
    var o = !!i.scopeParent, l = o ? i.scopeParent : i, a = Km(l, o), c = o ? r(i.candidates) : l;
    a === 0 ? o ? t.push.apply(t, c) : t.push(l) : n.push({
      documentOrder: s,
      tabIndex: a,
      item: i,
      isScope: o,
      content: c
    });
  }), n.sort(AR).reduce(function(i, s) {
    return s.isScope ? i.push.apply(i, s.content) : i.push(s.content), i;
  }, []).concat(t);
}, FR = function(e, t) {
  t = t || {};
  var n;
  return t.getShadowRoot ? n = Qm([e], t.includeContainer, {
    filter: au.bind(null, t),
    flatten: !1,
    getShadowRoot: t.getShadowRoot,
    shadowRootFilter: vR
  }) : n = Wm(e, t.includeContainer, au.bind(null, t)), NR(n);
}, OR = function(e, t) {
  t = t || {};
  var n;
  return t.getShadowRoot ? n = Qm([e], t.includeContainer, {
    filter: Sa.bind(null, t),
    flatten: !0,
    getShadowRoot: t.getShadowRoot
  }) : n = Wm(e, t.includeContainer, Sa.bind(null, t)), n;
}, yi = function(e, t) {
  if (t = t || {}, !e)
    throw new Error("No node provided");
  return $r.call(e, ma) === !1 ? !1 : au(t, e);
}, yR = /* @__PURE__ */ Vm.concat("iframe").join(","), Ol = function(e, t) {
  if (t = t || {}, !e)
    throw new Error("No node provided");
  return $r.call(e, yR) === !1 ? !1 : Sa(t, e);
};
/*!
* focus-trap 7.2.0
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function Mp(r, e) {
  var t = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(r);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(r, i).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function Yp(r) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Mp(Object(t), !0).forEach(function(n) {
      bR(r, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(t)) : Mp(Object(t)).forEach(function(n) {
      Object.defineProperty(r, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return r;
}
function bR(r, e, t) {
  return e = _R(e), e in r ? Object.defineProperty(r, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : r[e] = t, r;
}
function CR(r, e) {
  if (typeof r != "object" || r === null)
    return r;
  var t = r[Symbol.toPrimitive];
  if (t !== void 0) {
    var n = t.call(r, e || "default");
    if (typeof n != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(r);
}
function _R(r) {
  var e = CR(r, "string");
  return typeof e == "symbol" ? e : String(e);
}
var Ip = {
  activateTrap: function(e, t) {
    if (e.length > 0) {
      var n = e[e.length - 1];
      n !== t && n.pause();
    }
    var i = e.indexOf(t);
    i === -1 || e.splice(i, 1), e.push(t);
  },
  deactivateTrap: function(e, t) {
    var n = e.indexOf(t);
    n !== -1 && e.splice(n, 1), e.length > 0 && e[e.length - 1].unpause();
  }
}, MR = function(e) {
  return e.tagName && e.tagName.toLowerCase() === "input" && typeof e.select == "function";
}, YR = function(e) {
  return e.key === "Escape" || e.key === "Esc" || e.keyCode === 27;
}, qn = function(e) {
  return e.key === "Tab" || e.keyCode === 9;
}, IR = function(e) {
  return qn(e) && !e.shiftKey;
}, BR = function(e) {
  return qn(e) && e.shiftKey;
}, Bp = function(e) {
  return setTimeout(e, 0);
}, Zp = function(e, t) {
  var n = -1;
  return e.every(function(i, s) {
    return t(i) ? (n = s, !1) : !0;
  }), n;
}, Zn = function(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
    n[i - 1] = arguments[i];
  return typeof e == "function" ? e.apply(void 0, n) : e;
}, bi = function(e) {
  return e.target.shadowRoot && typeof e.composedPath == "function" ? e.composedPath()[0] : e.target;
}, ZR = [], wR = function(e, t) {
  var n = (t == null ? void 0 : t.document) || document, i = (t == null ? void 0 : t.trapStack) || ZR, s = Yp({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    isKeyForward: IR,
    isKeyBackward: BR
  }, t), o = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   firstTabbableNode: HTMLElement|null,
    //   lastTabbableNode: HTMLElement|null,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0
  }, l, a = function(v, O, y) {
    return v && v[O] !== void 0 ? v[O] : s[y || O];
  }, c = function(v) {
    return o.containerGroups.findIndex(function(O) {
      var y = O.container, Z = O.tabbableNodes;
      return y.contains(v) || // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      Z.find(function(F) {
        return F === v;
      });
    });
  }, T = function(v) {
    var O = s[v];
    if (typeof O == "function") {
      for (var y = arguments.length, Z = new Array(y > 1 ? y - 1 : 0), F = 1; F < y; F++)
        Z[F - 1] = arguments[F];
      O = O.apply(void 0, Z);
    }
    if (O === !0 && (O = void 0), !O) {
      if (O === void 0 || O === !1)
        return O;
      throw new Error("`".concat(v, "` was specified but was not a node, or did not return a node"));
    }
    var b = O;
    if (typeof O == "string" && (b = n.querySelector(O), !b))
      throw new Error("`".concat(v, "` as selector refers to no known node"));
    return b;
  }, u = function() {
    var v = T("initialFocus");
    if (v === !1)
      return !1;
    if (v === void 0)
      if (c(n.activeElement) >= 0)
        v = n.activeElement;
      else {
        var O = o.tabbableGroups[0], y = O && O.firstTabbableNode;
        v = y || T("fallbackFocus");
      }
    if (!v)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return v;
  }, d = function() {
    if (o.containerGroups = o.containers.map(function(v) {
      var O = FR(v, s.tabbableOptions), y = OR(v, s.tabbableOptions);
      return {
        container: v,
        tabbableNodes: O,
        focusableNodes: y,
        firstTabbableNode: O.length > 0 ? O[0] : null,
        lastTabbableNode: O.length > 0 ? O[O.length - 1] : null,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(F) {
          var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, Y = y.findIndex(function(I) {
            return I === F;
          });
          if (!(Y < 0))
            return b ? y.slice(Y + 1).find(function(I) {
              return yi(I, s.tabbableOptions);
            }) : y.slice(0, Y).reverse().find(function(I) {
              return yi(I, s.tabbableOptions);
            });
        }
      };
    }), o.tabbableGroups = o.containerGroups.filter(function(v) {
      return v.tabbableNodes.length > 0;
    }), o.tabbableGroups.length <= 0 && !T("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
  }, A = function D(v) {
    if (v !== !1 && v !== n.activeElement) {
      if (!v || !v.focus) {
        D(u());
        return;
      }
      v.focus({
        preventScroll: !!s.preventScroll
      }), o.mostRecentlyFocusedNode = v, MR(v) && v.select();
    }
  }, f = function(v) {
    var O = T("setReturnFocus", v);
    return O || (O === !1 ? !1 : v);
  }, h = function(v) {
    var O = bi(v);
    if (!(c(O) >= 0)) {
      if (Zn(s.clickOutsideDeactivates, v)) {
        l.deactivate({
          // if, on deactivation, we should return focus to the node originally-focused
          //  when the trap was activated (or the configured `setReturnFocus` node),
          //  then assume it's also OK to return focus to the outside node that was
          //  just clicked, causing deactivation, as long as that node is focusable;
          //  if it isn't focusable, then return focus to the original node focused
          //  on activation (or the configured `setReturnFocus` node)
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked, whether it's focusable or not; by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node)
          returnFocus: s.returnFocusOnDeactivate && !Ol(O, s.tabbableOptions)
        });
        return;
      }
      Zn(s.allowOutsideClick, v) || v.preventDefault();
    }
  }, S = function(v) {
    var O = bi(v), y = c(O) >= 0;
    y || O instanceof Document ? y && (o.mostRecentlyFocusedNode = O) : (v.stopImmediatePropagation(), A(o.mostRecentlyFocusedNode || u()));
  }, p = function(v) {
    var O = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, y = bi(v);
    d();
    var Z = null;
    if (o.tabbableGroups.length > 0) {
      var F = c(y), b = F >= 0 ? o.containerGroups[F] : void 0;
      if (F < 0)
        O ? Z = o.tabbableGroups[o.tabbableGroups.length - 1].lastTabbableNode : Z = o.tabbableGroups[0].firstTabbableNode;
      else if (O) {
        var Y = Zp(o.tabbableGroups, function(C) {
          var P = C.firstTabbableNode;
          return y === P;
        });
        if (Y < 0 && (b.container === y || Ol(y, s.tabbableOptions) && !yi(y, s.tabbableOptions) && !b.nextTabbableNode(y, !1)) && (Y = F), Y >= 0) {
          var I = Y === 0 ? o.tabbableGroups.length - 1 : Y - 1, q = o.tabbableGroups[I];
          Z = q.lastTabbableNode;
        } else
          qn(v) || (Z = b.nextTabbableNode(y, !1));
      } else {
        var _ = Zp(o.tabbableGroups, function(C) {
          var P = C.lastTabbableNode;
          return y === P;
        });
        if (_ < 0 && (b.container === y || Ol(y, s.tabbableOptions) && !yi(y, s.tabbableOptions) && !b.nextTabbableNode(y)) && (_ = F), _ >= 0) {
          var z = _ === o.tabbableGroups.length - 1 ? 0 : _ + 1, E = o.tabbableGroups[z];
          Z = E.firstTabbableNode;
        } else
          qn(v) || (Z = b.nextTabbableNode(y));
      }
    } else
      Z = T("fallbackFocus");
    Z && (qn(v) && v.preventDefault(), A(Z));
  }, m = function(v) {
    if (YR(v) && Zn(s.escapeDeactivates, v) !== !1) {
      v.preventDefault(), l.deactivate();
      return;
    }
    (s.isKeyForward(v) || s.isKeyBackward(v)) && p(v, s.isKeyBackward(v));
  }, g = function(v) {
    var O = bi(v);
    c(O) >= 0 || Zn(s.clickOutsideDeactivates, v) || Zn(s.allowOutsideClick, v) || (v.preventDefault(), v.stopImmediatePropagation());
  }, N = function() {
    if (o.active)
      return Ip.activateTrap(i, l), o.delayInitialFocusTimer = s.delayInitialFocus ? Bp(function() {
        A(u());
      }) : A(u()), n.addEventListener("focusin", S, !0), n.addEventListener("mousedown", h, {
        capture: !0,
        passive: !1
      }), n.addEventListener("touchstart", h, {
        capture: !0,
        passive: !1
      }), n.addEventListener("click", g, {
        capture: !0,
        passive: !1
      }), n.addEventListener("keydown", m, {
        capture: !0,
        passive: !1
      }), l;
  }, R = function() {
    if (o.active)
      return n.removeEventListener("focusin", S, !0), n.removeEventListener("mousedown", h, !0), n.removeEventListener("touchstart", h, !0), n.removeEventListener("click", g, !0), n.removeEventListener("keydown", m, !0), l;
  };
  return l = {
    get active() {
      return o.active;
    },
    get paused() {
      return o.paused;
    },
    activate: function(v) {
      if (o.active)
        return this;
      var O = a(v, "onActivate"), y = a(v, "onPostActivate"), Z = a(v, "checkCanFocusTrap");
      Z || d(), o.active = !0, o.paused = !1, o.nodeFocusedBeforeActivation = n.activeElement, O && O();
      var F = function() {
        Z && d(), N(), y && y();
      };
      return Z ? (Z(o.containers.concat()).then(F, F), this) : (F(), this);
    },
    deactivate: function(v) {
      if (!o.active)
        return this;
      var O = Yp({
        onDeactivate: s.onDeactivate,
        onPostDeactivate: s.onPostDeactivate,
        checkCanReturnFocus: s.checkCanReturnFocus
      }, v);
      clearTimeout(o.delayInitialFocusTimer), o.delayInitialFocusTimer = void 0, R(), o.active = !1, o.paused = !1, Ip.deactivateTrap(i, l);
      var y = a(O, "onDeactivate"), Z = a(O, "onPostDeactivate"), F = a(O, "checkCanReturnFocus"), b = a(O, "returnFocus", "returnFocusOnDeactivate");
      y && y();
      var Y = function() {
        Bp(function() {
          b && A(f(o.nodeFocusedBeforeActivation)), Z && Z();
        });
      };
      return b && F ? (F(f(o.nodeFocusedBeforeActivation)).then(Y, Y), this) : (Y(), this);
    },
    pause: function() {
      return o.paused || !o.active ? this : (o.paused = !0, R(), this);
    },
    unpause: function() {
      return !o.paused || !o.active ? this : (o.paused = !1, d(), N(), this);
    },
    updateContainerElements: function(v) {
      var O = [].concat(v).filter(Boolean);
      return o.containers = O.map(function(y) {
        return typeof y == "string" ? n.querySelector(y) : y;
      }), o.active && d(), this;
    }
  }, l.updateContainerElements(e), l;
};
const xR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createFocusTrap: wR
}, Symbol.toStringTag, { value: "Module" })), LR = /* @__PURE__ */ Vr(xR);
var Da = {}, kR = {
  get exports() {
    return Da;
  },
  set exports(r) {
    Da = r;
  }
}, wp;
function PR() {
  return wp || (wp = 1, function(r, e) {
    (function(t, n) {
      r.exports = n();
    })(nr, function() {
      var t = "__v-click-outside", n = typeof window < "u", i = typeof navigator < "u", s = n && ("ontouchstart" in window || i && navigator.msMaxTouchPoints > 0) ? ["touchstart"] : ["click"];
      function o(T) {
        var u = T.event, d = T.handler;
        (0, T.middleware)(u) && d(u);
      }
      function l(T, u) {
        var d = function(m) {
          var g = typeof m == "function";
          if (!g && typeof m != "object")
            throw new Error("v-click-outside: Binding value must be a function or an object");
          return { handler: g ? m : m.handler, middleware: m.middleware || function(N) {
            return N;
          }, events: m.events || s, isActive: m.isActive !== !1, detectIframe: m.detectIframe !== !1, capture: !!m.capture };
        }(u.value), A = d.handler, f = d.middleware, h = d.detectIframe, S = d.capture;
        if (d.isActive) {
          if (T[t] = d.events.map(function(m) {
            return { event: m, srcTarget: document.documentElement, handler: function(g) {
              return function(N) {
                var R = N.el, D = N.event, v = N.handler, O = N.middleware, y = D.composedPath && D.composedPath() || D.path;
                (y ? y.indexOf(R) < 0 : !R.contains(D.target)) && o({ event: D, handler: v, middleware: O });
              }({ el: T, event: g, handler: A, middleware: f });
            }, capture: S };
          }), h) {
            var p = { event: "blur", srcTarget: window, handler: function(m) {
              return function(g) {
                var N = g.el, R = g.event, D = g.handler, v = g.middleware;
                setTimeout(function() {
                  var O = document.activeElement;
                  O && O.tagName === "IFRAME" && !N.contains(O) && o({ event: R, handler: D, middleware: v });
                }, 0);
              }({ el: T, event: m, handler: A, middleware: f });
            }, capture: S };
            T[t] = [].concat(T[t], [p]);
          }
          T[t].forEach(function(m) {
            var g = m.event, N = m.srcTarget, R = m.handler;
            return setTimeout(function() {
              T[t] && N.addEventListener(g, R, S);
            }, 0);
          });
        }
      }
      function a(T) {
        (T[t] || []).forEach(function(u) {
          return u.srcTarget.removeEventListener(u.event, u.handler, u.capture);
        }), delete T[t];
      }
      var c = n ? { bind: l, update: function(T, u) {
        var d = u.value, A = u.oldValue;
        JSON.stringify(d) !== JSON.stringify(A) && (a(T), l(T, { value: d }));
      }, unbind: a } : {};
      return { install: function(T) {
        T.directive("click-outside", c);
      }, directive: c };
    });
  }(kR)), Da;
}
function Xm(r, e, t, n, i, s, o, l) {
  var a = typeof r == "function" ? r.options : r;
  e && (a.render = e, a.staticRenderFns = t, a._compiled = !0), n && (a.functional = !0), s && (a._scopeId = "data-v-" + s);
  var c;
  if (o ? (c = function(d) {
    d = d || // cached call
    this.$vnode && this.$vnode.ssrContext || // stateful
    this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !d && typeof __VUE_SSR_CONTEXT__ < "u" && (d = __VUE_SSR_CONTEXT__), i && i.call(this, d), d && d._registeredComponents && d._registeredComponents.add(o);
  }, a._ssrRegister = c) : i && (c = l ? function() {
    i.call(
      this,
      (a.functional ? this.parent : this).$root.$options.shadowRoot
    );
  } : i), c)
    if (a.functional) {
      a._injectStyles = c;
      var T = a.render;
      a.render = function(A, f) {
        return c.call(f), T(A, f);
      };
    } else {
      var u = a.beforeCreate;
      a.beforeCreate = u ? [].concat(u, c) : [c];
    }
  return {
    exports: r,
    options: a
  };
}
const GR = {
  name: "DotsHorizontalIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var UR = function() {
  var e = this, t = e._self._c;
  return t("span", e._b({ staticClass: "material-design-icon dots-horizontal-icon", attrs: { "aria-hidden": !e.title, "aria-label": e.title, role: "img" }, on: { click: function(n) {
    return e.$emit("click", n);
  } } }, "span", e.$attrs, !1), [t("svg", { staticClass: "material-design-icon__svg", attrs: { fill: e.fillColor, width: e.size, height: e.size, viewBox: "0 0 24 24" } }, [t("path", { attrs: { d: "M16,12A2,2 0 0,1 18,10A2,2 0 0,1 20,12A2,2 0 0,1 18,14A2,2 0 0,1 16,12M10,12A2,2 0 0,1 12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12M4,12A2,2 0 0,1 6,10A2,2 0 0,1 8,12A2,2 0 0,1 6,14A2,2 0 0,1 4,12Z" } }, [e.title ? t("title", [e._v(e._s(e.title))]) : e._e()])])]);
}, HR = [], jR = /* @__PURE__ */ Xm(
  GR,
  UR,
  HR,
  !1,
  null,
  null,
  null,
  null
);
const zR = jR.exports, $R = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: zR
}, Symbol.toStringTag, { value: "Module" })), VR = /* @__PURE__ */ Vr($R);
function eE(r) {
  return r instanceof Date || Object.prototype.toString.call(r) === "[object Date]";
}
function qa(r) {
  return eE(r) ? new Date(r.getTime()) : r == null ? new Date(NaN) : new Date(r);
}
function qR(r) {
  return eE(r) && !isNaN(r.getTime());
}
function tE(r) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  if (!(e >= 0 && e <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6");
  var t = qa(r), n = t.getDay(), i = (n + 7 - e) % 7;
  return t.setDate(t.getDate() - i), t.setHours(0, 0, 0, 0), t;
}
function rE(r) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = e.firstDayOfWeek, n = t === void 0 ? 0 : t, i = e.firstWeekContainsDate, s = i === void 0 ? 1 : i;
  if (!(s >= 1 && s <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7");
  for (var o = qa(r), l = o.getFullYear(), a = new Date(0), c = l + 1; c >= l - 1 && (a.setFullYear(c, 0, s), a.setHours(0, 0, 0, 0), a = tE(a, n), !(o.getTime() >= a.getTime())); c--)
    ;
  return a;
}
function ac(r) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = e.firstDayOfWeek, n = t === void 0 ? 0 : t, i = e.firstWeekContainsDate, s = i === void 0 ? 1 : i, o = qa(r), l = tE(o, n), a = rE(o, {
    firstDayOfWeek: n,
    firstWeekContainsDate: s
  }), c = l.getTime() - a.getTime();
  return Math.round(c / (7 * 24 * 3600 * 1e3)) + 1;
}
var nE = {
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  weekdays: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  weekdaysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  weekdaysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  firstDayOfWeek: 0,
  firstWeekContainsDate: 1
}, WR = /\[([^\]]+)]|YYYY|YY?|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|m{1,2}|s{1,2}|Z{1,2}|S{1,3}|w{1,2}|x|X|a|A/g;
function vt(r) {
  for (var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, t = "".concat(Math.abs(r)), n = r < 0 ? "-" : ""; t.length < e; )
    t = "0".concat(t);
  return n + t;
}
function xp(r) {
  return Math.round(r.getTimezoneOffset() / 15) * 15;
}
function Lp(r) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", t = r > 0 ? "-" : "+", n = Math.abs(r), i = Math.floor(n / 60), s = n % 60;
  return t + vt(i, 2) + e + vt(s, 2);
}
var kp = function(e, t, n) {
  var i = e < 12 ? "AM" : "PM";
  return n ? i.toLocaleLowerCase() : i;
}, Wn = {
  Y: function(e) {
    var t = e.getFullYear();
    return t <= 9999 ? "".concat(t) : "+".concat(t);
  },
  // Year: 00, 01, ..., 99
  YY: function(e) {
    return vt(e.getFullYear(), 4).substr(2);
  },
  // Year: 1900, 1901, ..., 2099
  YYYY: function(e) {
    return vt(e.getFullYear(), 4);
  },
  // Month: 1, 2, ..., 12
  M: function(e) {
    return e.getMonth() + 1;
  },
  // Month: 01, 02, ..., 12
  MM: function(e) {
    return vt(e.getMonth() + 1, 2);
  },
  MMM: function(e, t) {
    return t.monthsShort[e.getMonth()];
  },
  MMMM: function(e, t) {
    return t.months[e.getMonth()];
  },
  // Day of month: 1, 2, ..., 31
  D: function(e) {
    return e.getDate();
  },
  // Day of month: 01, 02, ..., 31
  DD: function(e) {
    return vt(e.getDate(), 2);
  },
  // Hour: 0, 1, ... 23
  H: function(e) {
    return e.getHours();
  },
  // Hour: 00, 01, ..., 23
  HH: function(e) {
    return vt(e.getHours(), 2);
  },
  // Hour: 1, 2, ..., 12
  h: function(e) {
    var t = e.getHours();
    return t === 0 ? 12 : t > 12 ? t % 12 : t;
  },
  // Hour: 01, 02, ..., 12
  hh: function() {
    var e = Wn.h.apply(Wn, arguments);
    return vt(e, 2);
  },
  // Minute: 0, 1, ..., 59
  m: function(e) {
    return e.getMinutes();
  },
  // Minute: 00, 01, ..., 59
  mm: function(e) {
    return vt(e.getMinutes(), 2);
  },
  // Second: 0, 1, ..., 59
  s: function(e) {
    return e.getSeconds();
  },
  // Second: 00, 01, ..., 59
  ss: function(e) {
    return vt(e.getSeconds(), 2);
  },
  // 1/10 of second: 0, 1, ..., 9
  S: function(e) {
    return Math.floor(e.getMilliseconds() / 100);
  },
  // 1/100 of second: 00, 01, ..., 99
  SS: function(e) {
    return vt(Math.floor(e.getMilliseconds() / 10), 2);
  },
  // Millisecond: 000, 001, ..., 999
  SSS: function(e) {
    return vt(e.getMilliseconds(), 3);
  },
  // Day of week: 0, 1, ..., 6
  d: function(e) {
    return e.getDay();
  },
  // Day of week: 'Su', 'Mo', ..., 'Sa'
  dd: function(e, t) {
    return t.weekdaysMin[e.getDay()];
  },
  // Day of week: 'Sun', 'Mon',..., 'Sat'
  ddd: function(e, t) {
    return t.weekdaysShort[e.getDay()];
  },
  // Day of week: 'Sunday', 'Monday', ...,'Saturday'
  dddd: function(e, t) {
    return t.weekdays[e.getDay()];
  },
  // AM, PM
  A: function(e, t) {
    var n = t.meridiem || kp;
    return n(e.getHours(), e.getMinutes(), !1);
  },
  // am, pm
  a: function(e, t) {
    var n = t.meridiem || kp;
    return n(e.getHours(), e.getMinutes(), !0);
  },
  // Timezone: -01:00, +00:00, ... +12:00
  Z: function(e) {
    return Lp(xp(e), ":");
  },
  // Timezone: -0100, +0000, ... +1200
  ZZ: function(e) {
    return Lp(xp(e));
  },
  // Seconds timestamp: 512969520
  X: function(e) {
    return Math.floor(e.getTime() / 1e3);
  },
  // Milliseconds timestamp: 512969520900
  x: function(e) {
    return e.getTime();
  },
  w: function(e, t) {
    return ac(e, {
      firstDayOfWeek: t.firstDayOfWeek,
      firstWeekContainsDate: t.firstWeekContainsDate
    });
  },
  ww: function(e, t) {
    return vt(Wn.w(e, t), 2);
  }
};
function Wa(r, e) {
  var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n = e ? String(e) : "YYYY-MM-DDTHH:mm:ss.SSSZ", i = qa(r);
  if (!qR(i))
    return "Invalid Date";
  var s = t.locale || nE;
  return n.replace(WR, function(o, l) {
    return l || (typeof Wn[o] == "function" ? "".concat(Wn[o](i, s)) : o);
  });
}
function Pp(r) {
  return JR(r) || KR(r) || QR();
}
function QR() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function KR(r) {
  if (Symbol.iterator in Object(r) || Object.prototype.toString.call(r) === "[object Arguments]")
    return Array.from(r);
}
function JR(r) {
  if (Array.isArray(r)) {
    for (var e = 0, t = new Array(r.length); e < r.length; e++)
      t[e] = r[e];
    return t;
  }
}
function Gp(r, e) {
  var t = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(r);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(r, i).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function XR(r) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Gp(t, !0).forEach(function(n) {
      _r(r, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(t)) : Gp(t).forEach(function(n) {
      Object.defineProperty(r, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return r;
}
function ev(r, e) {
  return nv(r) || rv(r, e) || tv();
}
function tv() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function rv(r, e) {
  if (Symbol.iterator in Object(r) || Object.prototype.toString.call(r) === "[object Arguments]") {
    var t = [], n = !0, i = !1, s = void 0;
    try {
      for (var o = r[Symbol.iterator](), l; !(n = (l = o.next()).done) && (t.push(l.value), !(e && t.length === e)); n = !0)
        ;
    } catch (a) {
      i = !0, s = a;
    } finally {
      try {
        !n && o.return != null && o.return();
      } finally {
        if (i)
          throw s;
      }
    }
    return t;
  }
}
function nv(r) {
  if (Array.isArray(r))
    return r;
}
function _r(r, e, t) {
  return e in r ? Object.defineProperty(r, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : r[e] = t, r;
}
var iv = /(\[[^\[]*\])|(MM?M?M?|Do|DD?|ddd?d?|w[o|w]?|YYYY|YY|a|A|hh?|HH?|mm?|ss?|S{1,3}|x|X|ZZ?|.)/g, iE = /\d/, Mr = /\d\d/, av = /\d{3}/, ov = /\d{4}/, bn = /\d\d?/, sv = /[+-]\d\d:?\d\d/, aE = /[+-]?\d+/, lv = /[+-]?\d+(\.\d{1,3})?/, oc = "year", Qa = "month", oE = "day", sE = "hour", lE = "minute", uE = "second", sc = "millisecond", cE = {}, je = function(e, t, n) {
  var i = Array.isArray(e) ? e : [e], s;
  typeof n == "string" ? s = function(l) {
    var a = parseInt(l, 10);
    return _r({}, n, a);
  } : s = n, i.forEach(function(o) {
    cE[o] = [t, s];
  });
}, uv = function(e) {
  return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
}, pi = function(e) {
  return function(t) {
    var n = t[e];
    if (!Array.isArray(n))
      throw new Error("Locale[".concat(e, "] need an array"));
    return new RegExp(n.map(uv).join("|"));
  };
}, hi = function(e, t) {
  return function(n, i) {
    var s = i[e];
    if (!Array.isArray(s))
      throw new Error("Locale[".concat(e, "] need an array"));
    var o = s.indexOf(n);
    if (o < 0)
      throw new Error("Invalid Word");
    return _r({}, t, o);
  };
};
je("Y", aE, oc);
je("YY", Mr, function(r) {
  var e = new Date().getFullYear(), t = Math.floor(e / 100), n = parseInt(r, 10);
  return n = (n > 68 ? t - 1 : t) * 100 + n, _r({}, oc, n);
});
je("YYYY", ov, oc);
je("M", bn, function(r) {
  return _r({}, Qa, parseInt(r, 10) - 1);
});
je("MM", Mr, function(r) {
  return _r({}, Qa, parseInt(r, 10) - 1);
});
je("MMM", pi("monthsShort"), hi("monthsShort", Qa));
je("MMMM", pi("months"), hi("months", Qa));
je("D", bn, oE);
je("DD", Mr, oE);
je(["H", "h"], bn, sE);
je(["HH", "hh"], Mr, sE);
je("m", bn, lE);
je("mm", Mr, lE);
je("s", bn, uE);
je("ss", Mr, uE);
je("S", iE, function(r) {
  return _r({}, sc, parseInt(r, 10) * 100);
});
je("SS", Mr, function(r) {
  return _r({}, sc, parseInt(r, 10) * 10);
});
je("SSS", av, sc);
function cv(r) {
  return r.meridiemParse || /[ap]\.?m?\.?/i;
}
function Tv(r) {
  return "".concat(r).toLowerCase().charAt(0) === "p";
}
je(["A", "a"], cv, function(r, e) {
  var t = typeof e.isPM == "function" ? e.isPM(r) : Tv(r);
  return {
    isPM: t
  };
});
function dv(r) {
  var e = r.match(/([+-]|\d\d)/g) || ["-", "0", "0"], t = ev(e, 3), n = t[0], i = t[1], s = t[2], o = parseInt(i, 10) * 60 + parseInt(s, 10);
  return o === 0 ? 0 : n === "+" ? -o : +o;
}
je(["Z", "ZZ"], sv, function(r) {
  return {
    offset: dv(r)
  };
});
je("x", aE, function(r) {
  return {
    date: new Date(parseInt(r, 10))
  };
});
je("X", lv, function(r) {
  return {
    date: new Date(parseFloat(r) * 1e3)
  };
});
je("d", iE, "weekday");
je("dd", pi("weekdaysMin"), hi("weekdaysMin", "weekday"));
je("ddd", pi("weekdaysShort"), hi("weekdaysShort", "weekday"));
je("dddd", pi("weekdays"), hi("weekdays", "weekday"));
je("w", bn, "week");
je("ww", Mr, "week");
function Av(r, e) {
  if (r !== void 0 && e !== void 0) {
    if (e) {
      if (r < 12)
        return r + 12;
    } else if (r === 12)
      return 0;
  }
  return r;
}
function fv(r) {
  for (var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new Date(), t = [0, 0, 1, 0, 0, 0, 0], n = [e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()], i = !0, s = 0; s < 7; s++)
    r[s] === void 0 ? t[s] = i ? n[s] : t[s] : (t[s] = r[s], i = !1);
  return t;
}
function pv(r, e, t, n, i, s, o) {
  var l;
  return r < 100 && r >= 0 ? (l = new Date(r + 400, e, t, n, i, s, o), isFinite(l.getFullYear()) && l.setFullYear(r)) : l = new Date(r, e, t, n, i, s, o), l;
}
function hv() {
  for (var r, e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var i = t[0];
  return i < 100 && i >= 0 ? (t[0] += 400, r = new Date(Date.UTC.apply(Date, t)), isFinite(r.getUTCFullYear()) && r.setUTCFullYear(i)) : r = new Date(Date.UTC.apply(Date, t)), r;
}
function mv(r, e, t) {
  var n = e.match(iv);
  if (!n)
    throw new Error();
  for (var i = n.length, s = {}, o = 0; o < i; o += 1) {
    var l = n[o], a = cE[l];
    if (a) {
      var T = typeof a[0] == "function" ? a[0](t) : a[0], u = a[1], d = (T.exec(r) || [])[0], A = u(d, t);
      s = XR({}, s, {}, A), r = r.replace(d, "");
    } else {
      var c = l.replace(/^\[|\]$/g, "");
      if (r.indexOf(c) === 0)
        r = r.substr(c.length);
      else
        throw new Error("not match");
    }
  }
  return s;
}
function Ev(r, e) {
  var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  try {
    var n = t.locale, i = n === void 0 ? nE : n, s = t.backupDate, o = s === void 0 ? new Date() : s, l = mv(r, e, i), a = l.year, c = l.month, T = l.day, u = l.hour, d = l.minute, A = l.second, f = l.millisecond, h = l.isPM, S = l.date, p = l.offset, m = l.weekday, g = l.week;
    if (S)
      return S;
    var N = [a, c, T, u, d, A, f];
    if (N[3] = Av(N[3], h), g !== void 0 && c === void 0 && T === void 0) {
      var R = rE(a === void 0 ? o : new Date(a, 3), {
        firstDayOfWeek: i.firstDayOfWeek,
        firstWeekContainsDate: i.firstWeekContainsDate
      });
      return new Date(R.getTime() + (g - 1) * 7 * 24 * 3600 * 1e3);
    }
    var D, v = fv(N, o);
    return p !== void 0 ? (v[6] += p * 60 * 1e3, D = hv.apply(void 0, Pp(v))) : D = pv.apply(void 0, Pp(v)), m !== void 0 && D.getDay() !== m ? new Date(NaN) : D;
  } catch {
    return new Date(NaN);
  }
}
function xi(r) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? xi = function(e) {
    return typeof e;
  } : xi = function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, xi(r);
}
function Gr(r, e, t) {
  return e in r ? Object.defineProperty(r, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : r[e] = t, r;
}
function ou() {
  return ou = Object.assign || function(r) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (r[n] = t[n]);
    }
    return r;
  }, ou.apply(this, arguments);
}
function Up(r, e) {
  var t = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(r);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(r, i).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function ze(r) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Up(Object(t), !0).forEach(function(n) {
      Gr(r, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(t)) : Up(Object(t)).forEach(function(n) {
      Object.defineProperty(r, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return r;
}
function Sv(r, e) {
  if (r == null)
    return {};
  var t = {}, n = Object.keys(r), i, s;
  for (s = 0; s < n.length; s++)
    i = n[s], !(e.indexOf(i) >= 0) && (t[i] = r[i]);
  return t;
}
function Dv(r, e) {
  if (r == null)
    return {};
  var t = Sv(r, e), n, i;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(r);
    for (i = 0; i < s.length; i++)
      n = s[i], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(r, n) && (t[n] = r[n]);
  }
  return t;
}
function Qn(r, e) {
  return gv(r) || Rv(r, e) || vv(r, e) || Nv();
}
function gv(r) {
  if (Array.isArray(r))
    return r;
}
function Rv(r, e) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(r)))) {
    var t = [], n = !0, i = !1, s = void 0;
    try {
      for (var o = r[Symbol.iterator](), l; !(n = (l = o.next()).done) && (t.push(l.value), !(e && t.length === e)); n = !0)
        ;
    } catch (a) {
      i = !0, s = a;
    } finally {
      try {
        !n && o.return != null && o.return();
      } finally {
        if (i)
          throw s;
      }
    }
    return t;
  }
}
function vv(r, e) {
  if (r) {
    if (typeof r == "string")
      return Hp(r, e);
    var t = Object.prototype.toString.call(r).slice(8, -1);
    if (t === "Object" && r.constructor && (t = r.constructor.name), t === "Map" || t === "Set")
      return Array.from(t);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return Hp(r, e);
  }
}
function Hp(r, e) {
  (e == null || e > r.length) && (e = r.length);
  for (var t = 0, n = new Array(e); t < e; t++)
    n[t] = r[t];
  return n;
}
function Nv() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function su() {
  return su = Object.assign || function(r) {
    for (var e, t = 1; t < arguments.length; t++)
      for (var n in e = arguments[t], e)
        Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
    return r;
  }, su.apply(this, arguments);
}
var Fv = ["attrs", "props", "domProps"], Ov = ["class", "style", "directives"], yv = ["on", "nativeOn"], bv = function(e) {
  return e.reduce(function(t, n) {
    for (var i in n)
      if (!t[i])
        t[i] = n[i];
      else if (Fv.indexOf(i) !== -1)
        t[i] = su({}, t[i], n[i]);
      else if (Ov.indexOf(i) !== -1) {
        var s = t[i] instanceof Array ? t[i] : [t[i]], o = n[i] instanceof Array ? n[i] : [n[i]];
        t[i] = s.concat(o);
      } else if (yv.indexOf(i) !== -1)
        for (var l in n[i])
          if (t[i][l]) {
            var a = t[i][l] instanceof Array ? t[i][l] : [t[i][l]], c = n[i][l] instanceof Array ? n[i][l] : [n[i][l]];
            t[i][l] = a.concat(c);
          } else
            t[i][l] = n[i][l];
      else if (i == "hook")
        for (var T in n[i])
          t[i][T] = t[i][T] ? Cv(t[i][T], n[i][T]) : n[i][T];
      else
        t[i] = n[i];
    return t;
  }, {});
}, Cv = function(e, t) {
  return function() {
    e && e.apply(this, arguments), t && t.apply(this, arguments);
  };
}, ni = bv;
function ir(r) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0, s = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0, o = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : 0, l = new Date(r, e, t, n, i, s, o);
  return r < 100 && r >= 0 && l.setFullYear(r), l;
}
function cr(r) {
  return r instanceof Date && !isNaN(r);
}
function Ka(r) {
  return Array.isArray(r) && r.length === 2 && r.every(cr) && r[0] <= r[1];
}
function _v(r) {
  return Array.isArray(r) && r.every(cr);
}
function fn(r) {
  var e = new Date(r);
  if (cr(e))
    return e;
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
    n[i - 1] = arguments[i];
  return n.length ? fn.apply(void 0, n) : new Date();
}
function Mv(r) {
  var e = new Date(r);
  return e.setMonth(0, 1), e.setHours(0, 0, 0, 0), e;
}
function lu(r) {
  var e = new Date(r);
  return e.setDate(1), e.setHours(0, 0, 0, 0), e;
}
function Yv(r) {
  var e = new Date(r);
  return e.setHours(0, 0, 0, 0), e;
}
function Iv(r) {
  for (var e = r.firstDayOfWeek, t = r.year, n = r.month, i = [], s = ir(t, n, 0), o = s.getDate(), l = o - (s.getDay() + 7 - e) % 7, a = l; a <= o; a++)
    i.push(ir(t, n, a - o));
  s.setMonth(n + 1, 0);
  for (var c = s.getDate(), T = 1; T <= c; T++)
    i.push(ir(t, n, T));
  for (var u = o - l + 1, d = 6 * 7 - u - c, A = 1; A <= d; A++)
    i.push(ir(t, n, c + A));
  return i;
}
function uu(r, e) {
  var t = new Date(r), n = typeof e == "function" ? e(t.getMonth()) : Number(e), i = t.getFullYear(), s = ir(i, n + 1, 0).getDate(), o = t.getDate();
  return t.setMonth(n, Math.min(o, s)), t;
}
function pn(r, e) {
  var t = new Date(r), n = typeof e == "function" ? e(t.getFullYear()) : e;
  return t.setFullYear(n), t;
}
function ga(r, e) {
  var t = new Date(r), n = new Date(e);
  return t.setHours(n.getHours(), n.getMinutes(), n.getSeconds()), t;
}
function lc(r, e) {
  if (!Array.isArray(r))
    return [];
  var t = [], n = r.length, i = 0;
  for (e = e || n; i < n; )
    t.push(r.slice(i, i += e));
  return t;
}
function zt(r) {
  return Object.prototype.toString.call(r) === "[object Object]";
}
function hn(r, e) {
  if (!zt(r))
    return {};
  Array.isArray(e) || (e = [e]);
  var t = {};
  return e.forEach(function(n) {
    n in r && (t[n] = r[n]);
  }), t;
}
function TE(r, e) {
  if (!zt(r))
    return {};
  var t = r;
  return zt(e) && Object.keys(e).forEach(function(n) {
    var i = e[n];
    zt(i) && zt(r[n]) && (i = TE(r[n], i)), t = ze({}, t, Gr({}, n, i));
  }), t;
}
function Bv(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
function Zv(r, e) {
  return e = { exports: {} }, r(e, e.exports), e.exports;
}
var wv = Zv(function(r, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = {
    months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    weekdays: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    weekdaysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    weekdaysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    firstDayOfWeek: 0,
    firstWeekContainsDate: 1
  }, n = t;
  e.default = n, r.exports = e.default;
}), xv = Bv(wv), Lv = {
  formatLocale: xv,
  yearFormat: "YYYY",
  monthFormat: "MMM",
  monthBeforeYear: !0
}, xn = "en", rn = {};
rn[xn] = Lv;
function dE(r, e, t) {
  if (typeof r != "string")
    return rn[xn];
  var n = xn;
  return rn[r] && (n = r), e && (rn[r] = e, n = r), t || (xn = n), rn[r] || rn[xn];
}
function mn(r) {
  return dE(r, null, !0);
}
function kv(r) {
  var e = !1;
  return function() {
    for (var n = this, i = arguments.length, s = new Array(i), o = 0; o < i; o++)
      s[o] = arguments[o];
    e || (e = !0, requestAnimationFrame(function() {
      e = !1, r.apply(n, s);
    }));
  };
}
function Pv(r) {
  var e = r.style.display, t = r.style.visibility;
  r.style.display = "block", r.style.visibility = "hidden";
  var n = window.getComputedStyle(r), i = r.offsetWidth + parseInt(n.marginLeft, 10) + parseInt(n.marginRight, 10), s = r.offsetHeight + parseInt(n.marginTop, 10) + parseInt(n.marginBottom, 10);
  return r.style.display = e, r.style.visibility = t, {
    width: i,
    height: s
  };
}
function Gv(r, e, t, n) {
  var i = 0, s = 0, o = 0, l = 0, a = r.getBoundingClientRect(), c = document.documentElement.clientWidth, T = document.documentElement.clientHeight;
  return n && (o = window.pageXOffset + a.left, l = window.pageYOffset + a.top), c - a.left < e && a.right < e ? i = o - a.left + 1 : a.left + a.width / 2 <= c / 2 ? i = o : i = o + a.width - e, a.top <= t && T - a.bottom <= t ? s = l + T - a.top - t : a.top + a.height / 2 <= T / 2 ? s = l + a.height : s = l - t, {
    left: "".concat(i, "px"),
    top: "".concat(s, "px")
  };
}
function Ja(r) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : document.body;
  if (!r || r === e)
    return null;
  var t = function(o, l) {
    return getComputedStyle(o, null).getPropertyValue(l);
  }, n = /(auto|scroll)/, i = n.test(t(r, "overflow") + t(r, "overflow-y") + t(r, "overflow-x"));
  return i ? r : Ja(r.parentNode, e);
}
var Uv = {
  name: "Popup",
  inject: {
    prefixClass: {
      default: "mx"
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: !1
    },
    appendToBody: {
      type: Boolean,
      default: !0
    }
  },
  data: function() {
    return {
      top: "",
      left: ""
    };
  },
  watch: {
    visible: {
      immediate: !0,
      handler: function(e) {
        var t = this;
        this.$nextTick(function() {
          e && t.displayPopup();
        });
      }
    }
  },
  mounted: function() {
    var e = this;
    this.appendToBody && document.body.appendChild(this.$el), this._clickoutEvent = "ontouchend" in document ? "touchstart" : "mousedown", document.addEventListener(this._clickoutEvent, this.handleClickOutside);
    var t = this.$parent.$el;
    this._displayPopup = kv(function() {
      return e.displayPopup();
    }), this._scrollParent = Ja(t) || window, this._scrollParent.addEventListener("scroll", this._displayPopup), window.addEventListener("resize", this._displayPopup);
  },
  beforeDestroy: function() {
    this.appendToBody && this.$el.parentNode && this.$el.parentNode.removeChild(this.$el), document.removeEventListener(this._clickoutEvent, this.handleClickOutside), this._scrollParent.removeEventListener("scroll", this._displayPopup), window.removeEventListener("resize", this._displayPopup);
  },
  methods: {
    handleClickOutside: function(e) {
      if (this.visible) {
        var t = e.target, n = this.$el;
        n && !n.contains(t) && this.$emit("clickoutside", e);
      }
    },
    displayPopup: function() {
      if (this.visible) {
        var e = this.$el, t = this.$parent.$el, n = this.appendToBody;
        this._popupRect || (this._popupRect = Pv(e));
        var i = this._popupRect, s = i.width, o = i.height, l = Gv(t, s, o, n), a = l.left, c = l.top;
        this.left = a, this.top = c;
      }
    }
  }
};
function Bt(r, e, t, n, i, s, o, l, a, c) {
  typeof o != "boolean" && (a = l, l = o, o = !1);
  var T = typeof t == "function" ? t.options : t;
  r && r.render && (T.render = r.render, T.staticRenderFns = r.staticRenderFns, T._compiled = !0, i && (T.functional = !0)), n && (T._scopeId = n);
  var u;
  if (s ? (u = function(h) {
    h = h || // cached call
    this.$vnode && this.$vnode.ssrContext || // stateful
    this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !h && typeof __VUE_SSR_CONTEXT__ < "u" && (h = __VUE_SSR_CONTEXT__), e && e.call(this, a(h)), h && h._registeredComponents && h._registeredComponents.add(s);
  }, T._ssrRegister = u) : e && (u = o ? function(f) {
    e.call(this, c(f, this.$root.$options.shadowRoot));
  } : function(f) {
    e.call(this, l(f));
  }), u)
    if (T.functional) {
      var d = T.render;
      T.render = function(h, S) {
        return u.call(S), d(h, S);
      };
    } else {
      var A = T.beforeCreate;
      T.beforeCreate = A ? [].concat(A, u) : [u];
    }
  return t;
}
var Hv = Uv, jv = function() {
  var e = this, t = e.$createElement, n = e._self._c || t;
  return n("transition", {
    attrs: {
      name: e.prefixClass + "-zoom-in-down"
    }
  }, [e.visible ? n("div", {
    class: e.prefixClass + "-datepicker-main " + e.prefixClass + "-datepicker-popup",
    style: {
      top: e.top,
      left: e.left,
      position: "absolute"
    }
  }, [e._t("default")], 2) : e._e()]);
}, zv = [], $v = void 0, Vv = void 0, qv = void 0, Wv = !1, Qv = Bt({
  render: jv,
  staticRenderFns: zv
}, $v, Hv, Vv, Wv, qv, !1, void 0, void 0, void 0), Kv = function() {
  var e = this, t = e.$createElement, n = e._self._c || t;
  return n("svg", {
    attrs: {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024",
      width: "1em",
      height: "1em"
    }
  }, [n("path", {
    attrs: {
      d: "M940.218182 107.054545h-209.454546V46.545455h-65.163636v60.50909H363.054545V46.545455H297.890909v60.50909H83.781818c-18.618182 0-32.581818 13.963636-32.581818 32.581819v805.236363c0 18.618182 13.963636 32.581818 32.581818 32.581818h861.090909c18.618182 0 32.581818-13.963636 32.581818-32.581818V139.636364c-4.654545-18.618182-18.618182-32.581818-37.236363-32.581819zM297.890909 172.218182V232.727273h65.163636V172.218182h307.2V232.727273h65.163637V172.218182h176.872727v204.8H116.363636V172.218182h181.527273zM116.363636 912.290909V442.181818h795.927273v470.109091H116.363636z"
    }
  })]);
}, Jv = [], Xv = void 0, eN = void 0, tN = void 0, rN = !1, nN = Bt({
  render: Kv,
  staticRenderFns: Jv
}, Xv, {}, eN, rN, tN, !1, void 0, void 0, void 0), iN = function() {
  var e = this, t = e.$createElement, n = e._self._c || t;
  return n("svg", {
    attrs: {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "1em",
      height: "1em"
    }
  }, [n("path", {
    attrs: {
      d: "M0 0h24v24H0z",
      fill: "none"
    }
  }), e._v(" "), n("path", {
    attrs: {
      d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
    }
  }), e._v(" "), n("path", {
    attrs: {
      d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
    }
  })]);
}, aN = [], oN = void 0, sN = void 0, lN = void 0, uN = !1, cN = Bt({
  render: iN,
  staticRenderFns: aN
}, oN, {}, sN, uN, lN, !1, void 0, void 0, void 0), TN = function() {
  var e = this, t = e.$createElement, n = e._self._c || t;
  return n("svg", {
    attrs: {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024",
      width: "1em",
      height: "1em"
    }
  }, [n("path", {
    attrs: {
      d: "M810.005333 274.005333l-237.994667 237.994667 237.994667 237.994667-60.010667 60.010667-237.994667-237.994667-237.994667 237.994667-60.010667-60.010667 237.994667-237.994667-237.994667-237.994667 60.010667-60.010667 237.994667 237.994667 237.994667-237.994667z"
    }
  })]);
}, dN = [], AN = void 0, fN = void 0, pN = void 0, hN = !1, mN = Bt({
  render: TN,
  staticRenderFns: dN
}, AN, {}, fN, hN, pN, !1, void 0, void 0, void 0), EN = {
  props: {
    type: String,
    disabled: Boolean
  },
  inject: {
    prefixClass: {
      default: "mx"
    }
  }
}, SN = EN, DN = function() {
  var e = this, t = e.$createElement, n = e._self._c || t;
  return n("button", e._g({
    class: [e.prefixClass + "-btn " + e.prefixClass + "-btn-text " + e.prefixClass + "-btn-icon-" + e.type, {
      disabled: e.disabled
    }],
    attrs: {
      type: "button",
      disabled: e.disabled
    }
  }, e.$listeners), [n("i", {
    class: e.prefixClass + "-icon-" + e.type
  })]);
}, gN = [], RN = void 0, vN = void 0, NN = void 0, FN = !1, uc = Bt({
  render: DN,
  staticRenderFns: gN
}, RN, SN, vN, FN, NN, !1, void 0, void 0, void 0), ON = {
  name: "TableDate",
  components: {
    IconButton: uc
  },
  inject: {
    getLocale: {
      default: function() {
        return mn;
      }
    },
    getWeek: {
      default: function() {
        return ac;
      }
    },
    prefixClass: {
      default: "mx"
    },
    onDateMouseEnter: {
      default: void 0
    },
    onDateMouseLeave: {
      default: void 0
    }
  },
  props: {
    disabledCalendarChanger: {
      type: Function,
      default: function() {
        return !1;
      }
    },
    calendar: {
      type: Date,
      default: function() {
        return new Date();
      }
    },
    showWeekNumber: {
      type: Boolean,
      default: !1
    },
    titleFormat: {
      type: String,
      default: "YYYY-MM-DD"
    },
    getRowClasses: {
      type: Function,
      default: function() {
        return [];
      }
    },
    getCellClasses: {
      type: Function,
      default: function() {
        return [];
      }
    }
  },
  computed: {
    firstDayOfWeek: function() {
      return this.getLocale().formatLocale.firstDayOfWeek || 0;
    },
    yearMonth: function() {
      var e = this.getLocale(), t = e.yearFormat, n = e.monthBeforeYear, i = e.monthFormat, s = i === void 0 ? "MMM" : i, o = {
        panel: "year",
        label: this.formatDate(this.calendar, t)
      }, l = {
        panel: "month",
        label: this.formatDate(this.calendar, s)
      };
      return n ? [l, o] : [o, l];
    },
    days: function() {
      var e = this.getLocale(), t = e.days || e.formatLocale.weekdaysMin;
      return t.concat(t).slice(this.firstDayOfWeek, this.firstDayOfWeek + 7);
    },
    dates: function() {
      var e = this.calendar.getFullYear(), t = this.calendar.getMonth(), n = Iv({
        firstDayOfWeek: this.firstDayOfWeek,
        year: e,
        month: t
      });
      return lc(n, 7);
    }
  },
  methods: {
    isDisabledArrows: function(e) {
      var t = new Date(this.calendar);
      switch (e) {
        case "last-year":
          t.setFullYear(t.getFullYear() - 1, t.getMonth() + 1, 0), t.setHours(23, 59, 59, 999);
          break;
        case "next-year":
          t.setFullYear(t.getFullYear() + 1);
          break;
        case "last-month":
          t.setMonth(t.getMonth(), 0), t.setHours(23, 59, 59, 999);
          break;
        case "next-month":
          t.setMonth(t.getMonth() + 1);
          break;
      }
      return this.disabledCalendarChanger(t, e);
    },
    handleIconLeftClick: function() {
      this.$emit("changecalendar", uu(this.calendar, function(e) {
        return e - 1;
      }), "last-month");
    },
    handleIconRightClick: function() {
      this.$emit("changecalendar", uu(this.calendar, function(e) {
        return e + 1;
      }), "next-month");
    },
    handleIconDoubleLeftClick: function() {
      this.$emit("changecalendar", pn(this.calendar, function(e) {
        return e - 1;
      }), "last-year");
    },
    handleIconDoubleRightClick: function() {
      this.$emit("changecalendar", pn(this.calendar, function(e) {
        return e + 1;
      }), "next-year");
    },
    handlePanelChange: function(e) {
      this.$emit("changepanel", e);
    },
    handleMouseEnter: function(e) {
      typeof this.onDateMouseEnter == "function" && this.onDateMouseEnter(e);
    },
    handleMouseLeave: function(e) {
      typeof this.onDateMouseLeave == "function" && this.onDateMouseLeave(e);
    },
    handleCellClick: function(e) {
      var t = e.target;
      t.tagName.toUpperCase() === "DIV" && (t = t.parentNode);
      var n = t.getAttribute("data-row-col");
      if (n) {
        var i = n.split(",").map(function(c) {
          return parseInt(c, 10);
        }), s = Qn(i, 2), o = s[0], l = s[1], a = this.dates[o][l];
        this.$emit("select", new Date(a));
      }
    },
    formatDate: function(e, t) {
      return Wa(e, t, {
        locale: this.getLocale().formatLocale
      });
    },
    getCellTitle: function(e) {
      var t = this.titleFormat;
      return this.formatDate(e, t);
    },
    getWeekNumber: function(e) {
      return this.getWeek(e, this.getLocale().formatLocale);
    }
  }
}, yN = ON, bN = function() {
  var e = this, t = e.$createElement, n = e._self._c || t;
  return n("div", {
    class: e.prefixClass + "-calendar " + e.prefixClass + "-calendar-panel-date"
  }, [n("div", {
    class: e.prefixClass + "-calendar-header"
  }, [n("icon-button", {
    attrs: {
      type: "double-left",
      disabled: e.isDisabledArrows("last-year")
    },
    on: {
      click: e.handleIconDoubleLeftClick
    }
  }), e._v(" "), n("icon-button", {
    attrs: {
      type: "left",
      disabled: e.isDisabledArrows("last-month")
    },
    on: {
      click: e.handleIconLeftClick
    }
  }), e._v(" "), n("icon-button", {
    attrs: {
      type: "double-right",
      disabled: e.isDisabledArrows("next-year")
    },
    on: {
      click: e.handleIconDoubleRightClick
    }
  }), e._v(" "), n("icon-button", {
    attrs: {
      type: "right",
      disabled: e.isDisabledArrows("next-month")
    },
    on: {
      click: e.handleIconRightClick
    }
  }), e._v(" "), n("span", {
    class: e.prefixClass + "-calendar-header-label"
  }, e._l(e.yearMonth, function(i) {
    return n("button", {
      key: i.panel,
      class: e.prefixClass + "-btn " + e.prefixClass + "-btn-text " + e.prefixClass + "-btn-current-" + i.panel,
      attrs: {
        type: "button"
      },
      on: {
        click: function(o) {
          return e.handlePanelChange(i.panel);
        }
      }
    }, [e._v(`
        ` + e._s(i.label) + `
      `)]);
  }), 0)], 1), e._v(" "), n("div", {
    class: e.prefixClass + "-calendar-content"
  }, [n("table", {
    class: e.prefixClass + "-table " + e.prefixClass + "-table-date"
  }, [n("thead", [n("tr", [e.showWeekNumber ? n("th", {
    class: e.prefixClass + "-week-number-header"
  }) : e._e(), e._v(" "), e._l(e.days, function(i) {
    return n("th", {
      key: i
    }, [e._v(e._s(i))]);
  })], 2)]), e._v(" "), n("tbody", {
    on: {
      click: e.handleCellClick
    }
  }, e._l(e.dates, function(i, s) {
    return n("tr", {
      key: s,
      class: [e.prefixClass + "-date-row", e.getRowClasses(i)]
    }, [e.showWeekNumber ? n("td", {
      class: e.prefixClass + "-week-number",
      attrs: {
        "data-row-col": s + ",0"
      }
    }, [e._v(`
            ` + e._s(e.getWeekNumber(i[0])) + `
          `)]) : e._e(), e._v(" "), e._l(i, function(o, l) {
      return n("td", {
        key: l,
        staticClass: "cell",
        class: e.getCellClasses(o),
        attrs: {
          "data-row-col": s + "," + l,
          title: e.getCellTitle(o)
        },
        on: {
          mouseenter: function(c) {
            return e.handleMouseEnter(o);
          },
          mouseleave: function(c) {
            return e.handleMouseLeave(o);
          }
        }
      }, [n("div", [e._v(e._s(o.getDate()))])]);
    })], 2);
  }), 0)])])]);
}, CN = [], _N = void 0, MN = void 0, YN = void 0, IN = !1, BN = Bt({
  render: bN,
  staticRenderFns: CN
}, _N, yN, MN, IN, YN, !1, void 0, void 0, void 0), ZN = {
  name: "TableMonth",
  components: {
    IconButton: uc
  },
  inject: {
    getLocale: {
      default: function() {
        return mn;
      }
    },
    prefixClass: {
      default: "mx"
    }
  },
  props: {
    disabledCalendarChanger: {
      type: Function,
      default: function() {
        return !1;
      }
    },
    calendar: {
      type: Date,
      default: function() {
        return new Date();
      }
    },
    getCellClasses: {
      type: Function,
      default: function() {
        return [];
      }
    }
  },
  computed: {
    calendarYear: function() {
      return this.calendar.getFullYear();
    },
    months: function() {
      var e = this.getLocale(), t = e.months || e.formatLocale.monthsShort, n = t.map(function(i, s) {
        return {
          text: i,
          month: s
        };
      });
      return lc(n, 3);
    }
  },
  methods: {
    isDisabledArrows: function(e) {
      var t = new Date(this.calendar);
      switch (e) {
        case "last-year":
          t.setFullYear(t.getFullYear() - 1, 11, 31), t.setHours(23, 59, 59, 999);
          break;
        case "next-year":
          t.setFullYear(t.getFullYear() + 1, 0, 1);
          break;
      }
      return this.disabledCalendarChanger(t, e);
    },
    handleIconDoubleLeftClick: function() {
      this.$emit("changecalendar", pn(this.calendar, function(e) {
        return e - 1;
      }), "last-year");
    },
    handleIconDoubleRightClick: function() {
      this.$emit("changecalendar", pn(this.calendar, function(e) {
        return e + 1;
      }), "next-year");
    },
    handlePanelChange: function() {
      this.$emit("changepanel", "year");
    },
    handleClick: function(e) {
      var t = e.target;
      t.tagName.toUpperCase() === "DIV" && (t = t.parentNode);
      var n = t.getAttribute("data-month");
      n && !t.classList.contains("disabled") && this.$emit("select", parseInt(n, 10));
    }
  }
}, wN = ZN, xN = function() {
  var e = this, t = e.$createElement, n = e._self._c || t;
  return n("div", {
    class: e.prefixClass + "-calendar " + e.prefixClass + "-calendar-panel-month"
  }, [n("div", {
    class: e.prefixClass + "-calendar-header"
  }, [n("icon-button", {
    attrs: {
      type: "double-left",
      disabled: e.isDisabledArrows("last-year")
    },
    on: {
      click: e.handleIconDoubleLeftClick
    }
  }), e._v(" "), n("icon-button", {
    attrs: {
      type: "double-right",
      disabled: e.isDisabledArrows("next-year")
    },
    on: {
      click: e.handleIconDoubleRightClick
    }
  }), e._v(" "), n("span", {
    class: e.prefixClass + "-calendar-header-label"
  }, [n("button", {
    class: e.prefixClass + "-btn " + e.prefixClass + "-btn-text",
    attrs: {
      type: "button"
    },
    on: {
      click: e.handlePanelChange
    }
  }, [e._v(`
        ` + e._s(e.calendarYear) + `
      `)])])], 1), e._v(" "), n("div", {
    class: e.prefixClass + "-calendar-content"
  }, [n("table", {
    class: e.prefixClass + "-table " + e.prefixClass + "-table-month",
    on: {
      click: e.handleClick
    }
  }, e._l(e.months, function(i, s) {
    return n("tr", {
      key: s
    }, e._l(i, function(o, l) {
      return n("td", {
        key: l,
        staticClass: "cell",
        class: e.getCellClasses(o.month),
        attrs: {
          "data-month": o.month
        }
      }, [n("div", [e._v(e._s(o.text))])]);
    }), 0);
  }), 0)])]);
}, LN = [], kN = void 0, PN = void 0, GN = void 0, UN = !1, HN = Bt({
  render: xN,
  staticRenderFns: LN
}, kN, wN, PN, UN, GN, !1, void 0, void 0, void 0), jN = {
  name: "TableYear",
  components: {
    IconButton: uc
  },
  inject: {
    prefixClass: {
      default: "mx"
    }
  },
  props: {
    disabledCalendarChanger: {
      type: Function,
      default: function() {
        return !1;
      }
    },
    calendar: {
      type: Date,
      default: function() {
        return new Date();
      }
    },
    getCellClasses: {
      type: Function,
      default: function() {
        return [];
      }
    },
    getYearPanel: {
      type: Function
    }
  },
  computed: {
    years: function() {
      var e = new Date(this.calendar);
      return typeof this.getYearPanel == "function" ? this.getYearPanel(e) : this.getYears(e);
    },
    firstYear: function() {
      return this.years[0][0];
    },
    lastYear: function() {
      var e = function(n) {
        return n[n.length - 1];
      };
      return e(e(this.years));
    }
  },
  methods: {
    isDisabledArrows: function(e) {
      var t = new Date(this.calendar);
      switch (e) {
        case "last-decade":
          t.setFullYear(this.firstYear - 1, 11, 31), t.setHours(23, 59, 59, 999);
          break;
        case "next-decade":
          t.setFullYear(this.lastYear + 1, 0, 1);
          break;
      }
      return this.disabledCalendarChanger(t, e);
    },
    getYears: function(e) {
      for (var t = Math.floor(e.getFullYear() / 10) * 10, n = [], i = 0; i < 10; i++)
        n.push(t + i);
      return lc(n, 2);
    },
    handleIconDoubleLeftClick: function() {
      this.$emit("changecalendar", pn(this.calendar, function(e) {
        return e - 10;
      }), "last-decade");
    },
    handleIconDoubleRightClick: function() {
      this.$emit("changecalendar", pn(this.calendar, function(e) {
        return e + 10;
      }), "next-decade");
    },
    handleClick: function(e) {
      var t = e.target;
      t.tagName.toUpperCase() === "DIV" && (t = t.parentNode);
      var n = t.getAttribute("data-year");
      n && !t.classList.contains("disabled") && this.$emit("select", parseInt(n, 10));
    }
  }
}, zN = jN, $N = function() {
  var e = this, t = e.$createElement, n = e._self._c || t;
  return n("div", {
    class: e.prefixClass + "-calendar " + e.prefixClass + "-calendar-panel-year"
  }, [n("div", {
    class: e.prefixClass + "-calendar-header"
  }, [n("icon-button", {
    attrs: {
      type: "double-left",
      disabled: e.isDisabledArrows("last-decade")
    },
    on: {
      click: e.handleIconDoubleLeftClick
    }
  }), e._v(" "), n("icon-button", {
    attrs: {
      type: "double-right",
      disabled: e.isDisabledArrows("next-decade")
    },
    on: {
      click: e.handleIconDoubleRightClick
    }
  }), e._v(" "), n("span", {
    class: e.prefixClass + "-calendar-header-label"
  }, [n("span", [e._v(e._s(e.firstYear))]), e._v(" "), n("span", {
    class: e.prefixClass + "-calendar-decade-separator"
  }), e._v(" "), n("span", [e._v(e._s(e.lastYear))])])], 1), e._v(" "), n("div", {
    class: e.prefixClass + "-calendar-content"
  }, [n("table", {
    class: e.prefixClass + "-table " + e.prefixClass + "-table-year",
    on: {
      click: e.handleClick
    }
  }, e._l(e.years, function(i, s) {
    return n("tr", {
      key: s
    }, e._l(i, function(o, l) {
      return n("td", {
        key: l,
        staticClass: "cell",
        class: e.getCellClasses(o),
        attrs: {
          "data-year": o
        }
      }, [n("div", [e._v(e._s(o))])]);
    }), 0);
  }), 0)])]);
}, VN = [], qN = void 0, WN = void 0, QN = void 0, KN = !1, JN = Bt({
  render: $N,
  staticRenderFns: VN
}, qN, zN, WN, KN, QN, !1, void 0, void 0, void 0), Ur = {
  name: "CalendarPanel",
  inject: {
    prefixClass: {
      default: "mx"
    },
    dispatchDatePicker: {
      default: function() {
        return function() {
        };
      }
    }
  },
  props: {
    value: {},
    defaultValue: {
      default: function() {
        var e = new Date();
        return e.setHours(0, 0, 0, 0), e;
      }
    },
    defaultPanel: {
      type: String
    },
    disabledCalendarChanger: {
      type: Function,
      default: function() {
        return !1;
      }
    },
    disabledDate: {
      type: Function,
      default: function() {
        return !1;
      }
    },
    type: {
      type: String,
      default: "date"
    },
    getClasses: {
      type: Function,
      default: function() {
        return [];
      }
    },
    showWeekNumber: {
      type: Boolean,
      default: void 0
    },
    getYearPanel: {
      type: Function
    },
    titleFormat: {
      type: String,
      default: "YYYY-MM-DD"
    },
    calendar: Date,
    // update date when select year or month
    partialUpdate: {
      type: Boolean,
      default: !1
    }
  },
  data: function() {
    var e = ["date", "month", "year"], t = Math.max(e.indexOf(this.type), e.indexOf(this.defaultPanel)), n = t !== -1 ? e[t] : "date";
    return {
      panel: n,
      innerCalendar: new Date()
    };
  },
  computed: {
    innerValue: function() {
      var e = Array.isArray(this.value) ? this.value : [this.value], t = {
        year: Mv,
        month: lu,
        date: Yv
      }, n = t[this.type] || t.date;
      return e.filter(cr).map(function(i) {
        return n(i);
      });
    },
    calendarYear: function() {
      return this.innerCalendar.getFullYear();
    },
    calendarMonth: function() {
      return this.innerCalendar.getMonth();
    }
  },
  watch: {
    value: {
      immediate: !0,
      handler: "initCalendar"
    },
    calendar: {
      handler: "initCalendar"
    },
    defaultValue: {
      handler: "initCalendar"
    }
  },
  methods: {
    initCalendar: function() {
      var e = this.calendar;
      if (!cr(e)) {
        var t = this.innerValue.length;
        e = fn(t > 0 ? this.innerValue[t - 1] : this.defaultValue);
      }
      this.innerCalendar = lu(e);
    },
    isDisabled: function(e) {
      return this.disabledDate(new Date(e), this.innerValue);
    },
    emitDate: function(e, t) {
      this.isDisabled(e) || (this.$emit("select", e, t, this.innerValue), this.dispatchDatePicker("pick", e, t));
    },
    handleCalendarChange: function(e, t) {
      var n = new Date(this.innerCalendar);
      this.innerCalendar = e, this.$emit("update:calendar", e), this.dispatchDatePicker("calendar-change", e, n, t);
    },
    handelPanelChange: function(e) {
      var t = this.panel;
      this.panel = e, this.dispatchDatePicker("panel-change", e, t);
    },
    handleSelectYear: function(e) {
      if (this.type === "year") {
        var t = this.getYearCellDate(e);
        this.emitDate(t, "year");
      } else if (this.handleCalendarChange(ir(e, this.calendarMonth), "year"), this.handelPanelChange("month"), this.partialUpdate && this.innerValue.length === 1) {
        var n = new Date(this.innerValue[0]);
        n.setFullYear(e), this.emitDate(n, "year");
      }
    },
    handleSelectMonth: function(e) {
      if (this.type === "month") {
        var t = this.getMonthCellDate(e);
        this.emitDate(t, "month");
      } else if (this.handleCalendarChange(ir(this.calendarYear, e), "month"), this.handelPanelChange("date"), this.partialUpdate && this.innerValue.length === 1) {
        var n = new Date(this.innerValue[0]);
        n.setFullYear(this.calendarYear), this.emitDate(uu(n, e), "month");
      }
    },
    handleSelectDate: function(e) {
      this.emitDate(e, this.type === "week" ? "week" : "date");
    },
    getMonthCellDate: function(e) {
      return ir(this.calendarYear, e);
    },
    getYearCellDate: function(e) {
      return ir(e, 0);
    },
    getDateClasses: function(e) {
      var t = e.getMonth() !== this.calendarMonth, n = [];
      e.getTime() === new Date().setHours(0, 0, 0, 0) && n.push("today"), t && n.push("not-current-month");
      var i = this.getStateClass(e);
      return i === "active" && t || n.push(i), n.concat(this.getClasses(e, this.innerValue, n.join(" ")));
    },
    getMonthClasses: function(e) {
      var t = [];
      if (this.type !== "month") {
        this.calendarMonth === e && t.push("active");
        var n = this.getMonthCellDate(e);
        return this.disabledCalendarChanger(n, "month") && t.push("disabled"), t;
      }
      var i = this.getMonthCellDate(e);
      return t.push(this.getStateClass(i)), t.concat(this.getClasses(i, this.innerValue, t.join(" ")));
    },
    getYearClasses: function(e) {
      var t = [];
      if (this.type !== "year") {
        this.calendarYear === e && t.push("active");
        var n = this.getYearCellDate(e);
        return this.disabledCalendarChanger(n, "year") && t.push("disabled"), t;
      }
      var i = this.getYearCellDate(e);
      return t.push(this.getStateClass(i)), t.concat(this.getClasses(i, this.innerValue, t.join(" ")));
    },
    getStateClass: function(e) {
      return this.isDisabled(e) ? "disabled" : this.innerValue.some(function(t) {
        return t.getTime() === e.getTime();
      }) ? "active" : "";
    },
    getWeekState: function(e) {
      if (this.type !== "week")
        return "";
      var t = e[0].getTime(), n = e[6].getTime(), i = this.innerValue.some(function(s) {
        var o = s.getTime();
        return o >= t && o <= n;
      });
      return i ? "".concat(this.prefixClass, "-active-week") : "";
    }
  },
  render: function() {
    var e = arguments[0], t = this.panel, n = this.innerCalendar;
    return t === "year" ? e(JN, {
      attrs: {
        disabledCalendarChanger: this.disabledCalendarChanger,
        calendar: n,
        getCellClasses: this.getYearClasses,
        getYearPanel: this.getYearPanel
      },
      on: {
        select: this.handleSelectYear,
        changecalendar: this.handleCalendarChange
      }
    }) : t === "month" ? e(HN, {
      attrs: {
        disabledCalendarChanger: this.disabledCalendarChanger,
        calendar: n,
        getCellClasses: this.getMonthClasses
      },
      on: {
        select: this.handleSelectMonth,
        changepanel: this.handelPanelChange,
        changecalendar: this.handleCalendarChange
      }
    }) : e(BN, {
      attrs: {
        disabledCalendarChanger: this.disabledCalendarChanger,
        calendar: n,
        getCellClasses: this.getDateClasses,
        getRowClasses: this.getWeekState,
        titleFormat: this.titleFormat,
        showWeekNumber: typeof this.showWeekNumber == "boolean" ? this.showWeekNumber : this.type === "week"
      },
      class: Gr({}, "".concat(this.prefixClass, "-calendar-week-mode"), this.type === "week"),
      on: {
        select: this.handleSelectDate,
        changepanel: this.handelPanelChange,
        changecalendar: this.handleCalendarChange
      }
    });
  }
}, Kn = {
  name: "CalendarRange",
  components: {
    CalendarPanel: Ur
  },
  provide: function() {
    return {
      onDateMouseEnter: this.onDateMouseEnter,
      onDateMouseLeave: this.onDateMouseLeave
    };
  },
  inject: {
    prefixClass: {
      default: "mx"
    }
  },
  props: ze({}, Ur.props),
  data: function() {
    return {
      innerValue: [],
      calendars: [],
      hoveredValue: null
    };
  },
  computed: {
    // Minimum difference between start and end calendars
    calendarMinDiff: function() {
      var e = {
        date: 1,
        // type:date  min 1 month
        month: 12,
        // type:month min 1 year
        year: 120
        // type:year  min 10 year
      };
      return e[this.type] || e.date;
    },
    calendarMaxDiff: function() {
      return 1 / 0;
    },
    defaultValues: function() {
      return Array.isArray(this.defaultValue) ? this.defaultValue : [this.defaultValue, this.defaultValue];
    }
  },
  watch: {
    value: {
      immediate: !0,
      handler: function() {
        var e = this;
        this.innerValue = Ka(this.value) ? this.value : [new Date(NaN), new Date(NaN)];
        var t = this.innerValue.map(function(n, i) {
          return lu(fn(n, e.defaultValues[i]));
        });
        this.updateCalendars(t);
      }
    }
  },
  methods: {
    handleSelect: function(e, t) {
      var n = Qn(this.innerValue, 2), i = n[0], s = n[1];
      cr(i) && !cr(s) ? (i.getTime() > e.getTime() ? this.innerValue = [e, i] : this.innerValue = [i, e], this.emitDate(this.innerValue, t)) : this.innerValue = [e, new Date(NaN)];
    },
    onDateMouseEnter: function(e) {
      this.hoveredValue = e;
    },
    onDateMouseLeave: function() {
      this.hoveredValue = null;
    },
    emitDate: function(e, t) {
      this.$emit("select", e, t);
    },
    updateStartCalendar: function(e) {
      this.updateCalendars([e, this.calendars[1]], 1);
    },
    updateEndCalendar: function(e) {
      this.updateCalendars([this.calendars[0], e], 0);
    },
    updateCalendars: function(e) {
      var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, n = this.getCalendarGap(e);
      if (n) {
        var i = new Date(e[t]);
        i.setMonth(i.getMonth() + (t === 0 ? -n : n)), e[t] = i;
      }
      this.calendars = e;
    },
    getCalendarGap: function(e) {
      var t = Qn(e, 2), n = t[0], i = t[1], s = i.getFullYear() - n.getFullYear(), o = i.getMonth() - n.getMonth(), l = s * 12 + o, a = this.calendarMinDiff, c = this.calendarMaxDiff;
      return l < a ? a - l : l > c ? c - l : 0;
    },
    getRangeClasses: function(e, t, n) {
      var i = [].concat(this.getClasses(e, t, n));
      if (/disabled|active/.test(n))
        return i;
      var s = function(l, a) {
        var c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function(S) {
          return S.getTime();
        }, T = c(l), u = a.map(c), d = Qn(u, 2), A = d[0], f = d[1];
        if (A > f) {
          var h = [f, A];
          A = h[0], f = h[1];
        }
        return T > A && T < f;
      };
      return t.length === 2 && s(e, t) ? i.concat("in-range") : t.length === 1 && this.hoveredValue && s(e, [t[0], this.hoveredValue]) ? i.concat("hover-in-range") : i;
    }
  },
  render: function() {
    var e = this, t = arguments[0], n = this.calendars.map(function(s, o) {
      var l = ze({}, e.$props, {
        calendar: s,
        value: e.innerValue,
        defaultValue: e.defaultValues[o],
        getClasses: e.getRangeClasses,
        // don't update when range is true
        partialUpdate: !1
      }), a = {
        select: e.handleSelect,
        "update:calendar": o === 0 ? e.updateStartCalendar : e.updateEndCalendar
      };
      return t("calendar-panel", {
        props: ze({}, l),
        on: ze({}, a)
      });
    }), i = this.prefixClass;
    return t("div", {
      class: "".concat(i, "-range-wrapper")
    }, [n]);
  }
}, Ci;
function XN() {
  if (typeof window > "u")
    return 0;
  if (Ci !== void 0)
    return Ci;
  var r = document.createElement("div");
  r.style.visibility = "hidden", r.style.overflow = "scroll", r.style.width = "100px", r.style.position = "absolute", r.style.top = "-9999px", document.body.appendChild(r);
  var e = document.createElement("div");
  return e.style.width = "100%", r.appendChild(e), Ci = r.offsetWidth - e.offsetWidth, r.parentNode.removeChild(r), Ci;
}
var eF = {
  inject: {
    prefixClass: {
      default: "mx"
    }
  },
  data: function() {
    return {
      scrollbarWidth: 0,
      thumbTop: "",
      thumbHeight: ""
    };
  },
  created: function() {
    this.scrollbarWidth = XN(), document.addEventListener("mouseup", this.handleDragend);
  },
  beforeDestroy: function() {
    document.addEventListener("mouseup", this.handleDragend);
  },
  mounted: function() {
    this.$nextTick(this.getThumbSize);
  },
  methods: {
    getThumbSize: function() {
      var e = this.$refs.wrap;
      if (e) {
        var t = e.clientHeight * 100 / e.scrollHeight;
        this.thumbHeight = t < 100 ? "".concat(t, "%") : "";
      }
    },
    handleScroll: function(e) {
      var t = e.currentTarget, n = t.scrollHeight, i = t.scrollTop;
      this.thumbTop = "".concat(i * 100 / n, "%");
    },
    handleDragstart: function(e) {
      e.stopImmediatePropagation(), this._draggable = !0;
      var t = this.$refs.thumb.offsetTop;
      this._prevY = e.clientY - t, document.addEventListener("mousemove", this.handleDraging);
    },
    handleDraging: function(e) {
      if (this._draggable) {
        var t = e.clientY, n = this.$refs.wrap, i = n.scrollHeight, s = n.clientHeight, o = t - this._prevY, l = o * i / s;
        n.scrollTop = l;
      }
    },
    handleDragend: function() {
      this._draggable && (this._draggable = !1, document.removeEventListener("mousemove", this.handleDraging));
    }
  }
}, tF = eF, rF = function() {
  var e = this, t = e.$createElement, n = e._self._c || t;
  return n("div", {
    class: e.prefixClass + "-scrollbar",
    style: {
      position: "relative",
      overflow: "hidden"
    }
  }, [n("div", {
    ref: "wrap",
    class: e.prefixClass + "-scrollbar-wrap",
    style: {
      marginRight: "-" + e.scrollbarWidth + "px"
    },
    on: {
      scroll: e.handleScroll
    }
  }, [e._t("default")], 2), e._v(" "), n("div", {
    class: e.prefixClass + "-scrollbar-track"
  }, [n("div", {
    ref: "thumb",
    class: e.prefixClass + "-scrollbar-thumb",
    style: {
      height: e.thumbHeight,
      top: e.thumbTop
    },
    on: {
      mousedown: e.handleDragstart
    }
  })])]);
}, nF = [], iF = void 0, aF = void 0, oF = void 0, sF = !1, AE = Bt({
  render: rF,
  staticRenderFns: nF
}, iF, tF, aF, sF, oF, !1, void 0, void 0, void 0), yl = function(e) {
  return e = parseInt(e, 10), e < 10 ? "0".concat(e) : "".concat(e);
}, bl = function(e, t, n) {
  if (Array.isArray(n))
    return n.filter(function(o) {
      return o >= 0 && o < e;
    });
  t <= 0 && (t = 1);
  for (var i = [], s = 0; s < e; s += t)
    i.push(s);
  return i;
}, lF = function r(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
  if (n <= 0) {
    requestAnimationFrame(function() {
      e.scrollTop = t;
    });
    return;
  }
  var i = t - e.scrollTop, s = i / n * 10;
  requestAnimationFrame(function() {
    var o = e.scrollTop + s;
    if (o >= t) {
      e.scrollTop = t;
      return;
    }
    e.scrollTop = o, r(e, t, n - 10);
  });
}, uF = {
  name: "ListColumns",
  components: {
    ScrollbarVertical: AE
  },
  inject: {
    prefixClass: {
      default: "mx"
    }
  },
  props: {
    date: Date,
    scrollDuration: {
      type: Number,
      default: 100
    },
    getClasses: {
      type: Function,
      default: function() {
        return [];
      }
    },
    hourOptions: Array,
    minuteOptions: Array,
    secondOptions: Array,
    showHour: {
      type: Boolean,
      default: !0
    },
    showMinute: {
      type: Boolean,
      default: !0
    },
    showSecond: {
      type: Boolean,
      default: !0
    },
    hourStep: {
      type: Number,
      default: 1
    },
    minuteStep: {
      type: Number,
      default: 1
    },
    secondStep: {
      type: Number,
      default: 1
    },
    use12h: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    columns: function() {
      var e = [];
      return this.showHour && e.push({
        type: "hour",
        list: this.getHoursList()
      }), this.showMinute && e.push({
        type: "minute",
        list: this.getMinutesList()
      }), this.showSecond && e.push({
        type: "second",
        list: this.getSecondsList()
      }), this.use12h && e.push({
        type: "ampm",
        list: this.getAMPMList()
      }), e.filter(function(t) {
        return t.list.length > 0;
      });
    }
  },
  watch: {
    date: {
      handler: function() {
        var e = this;
        this.$nextTick(function() {
          e.scrollToSelected(e.scrollDuration);
        });
      }
    }
  },
  mounted: function() {
    this.scrollToSelected(0);
  },
  methods: {
    getHoursList: function() {
      var e = this;
      return bl(this.use12h ? 12 : 24, this.hourStep, this.hourOptions).map(function(t) {
        var n = new Date(e.date), i = yl(t);
        e.use12h && (t === 0 && (i = "12"), n.getHours() >= 12 && (t += 12));
        var s = n.setHours(t);
        return {
          value: s,
          text: i
        };
      });
    },
    getMinutesList: function() {
      var e = this;
      return bl(60, this.minuteStep, this.minuteOptions).map(function(t) {
        var n = new Date(e.date).setMinutes(t);
        return {
          value: n,
          text: yl(t)
        };
      });
    },
    getSecondsList: function() {
      var e = this;
      return bl(60, this.secondStep, this.secondOptions).map(function(t) {
        var n = new Date(e.date).setSeconds(t);
        return {
          value: n,
          text: yl(t)
        };
      });
    },
    getAMPMList: function() {
      var e = this;
      return ["AM", "PM"].map(function(t, n) {
        var i = new Date(e.date), s = i.setHours(i.getHours() % 12 + n * 12);
        return {
          text: t,
          value: s
        };
      });
    },
    scrollToSelected: function(e) {
      for (var t = this.$el.querySelectorAll(".active"), n = 0; n < t.length; n++) {
        var i = t[n], s = Ja(i, this.$el);
        if (s) {
          var o = i.offsetTop;
          lF(s, o, e);
        }
      }
    },
    handleSelect: function(e) {
      var t = e.target, n = e.currentTarget;
      if (t.tagName.toUpperCase() === "LI") {
        var i = n.getAttribute("data-type"), s = parseInt(n.getAttribute("data-index"), 10), o = parseInt(t.getAttribute("data-index"), 10), l = this.columns[s].list[o].value;
        this.$emit("select", l, i);
      }
    }
  }
}, cF = uF, TF = function() {
  var e = this, t = e.$createElement, n = e._self._c || t;
  return n("div", {
    class: e.prefixClass + "-time-columns"
  }, e._l(e.columns, function(i, s) {
    return n("scrollbar-vertical", {
      key: s,
      class: e.prefixClass + "-time-column"
    }, [n("ul", {
      class: e.prefixClass + "-time-list",
      attrs: {
        "data-type": i.type,
        "data-index": s
      },
      on: {
        click: e.handleSelect
      }
    }, e._l(i.list, function(o, l) {
      return n("li", {
        key: o.value,
        class: [e.prefixClass + "-time-item", e.getClasses(o.value, i.type)],
        attrs: {
          "data-index": l
        }
      }, [e._v(`
        ` + e._s(o.text) + `
      `)]);
    }), 0)]);
  }), 1);
}, dF = [], AF = void 0, fF = void 0, pF = void 0, hF = !1, mF = Bt({
  render: TF,
  staticRenderFns: dF
}, AF, cF, fF, hF, pF, !1, void 0, void 0, void 0);
function Cl() {
  var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", e = r.split(":");
  if (e.length >= 2) {
    var t = parseInt(e[0], 10), n = parseInt(e[1], 10);
    return {
      hours: t,
      minutes: n
    };
  }
  return null;
}
var EF = function(e, t) {
  e && (e.scrollTop = t);
}, SF = {
  name: "ListOptions",
  components: {
    ScrollbarVertical: AE
  },
  inject: {
    getLocale: {
      default: function() {
        return mn;
      }
    },
    prefixClass: {
      default: "mx"
    }
  },
  props: {
    date: Date,
    options: {
      type: [Object, Function],
      default: function() {
        return [];
      }
    },
    format: {
      type: String,
      default: "HH:mm:ss"
    },
    getClasses: {
      type: Function,
      default: function() {
        return [];
      }
    }
  },
  computed: {
    list: function() {
      var e = [], t = this.options;
      if (typeof t == "function")
        return t() || [];
      var n = Cl(t.start), i = Cl(t.end), s = Cl(t.step), o = t.format || this.format;
      if (n && i && s)
        for (var l = n.minutes + n.hours * 60, a = i.minutes + i.hours * 60, c = s.minutes + s.hours * 60, T = Math.floor((a - l) / c), u = 0; u <= T; u++) {
          var d = l + u * c, A = Math.floor(d / 60), f = d % 60, h = new Date(this.date).setHours(A, f, 0);
          e.push({
            value: h,
            text: this.formatDate(h, o)
          });
        }
      return e;
    }
  },
  mounted: function() {
    this.scrollToSelected();
  },
  methods: {
    formatDate: function(e, t) {
      return Wa(e, t, {
        locale: this.getLocale().formatLocale
      });
    },
    scrollToSelected: function() {
      var e = this.$el.querySelector(".active");
      if (e) {
        var t = Ja(e, this.$el);
        if (t) {
          var n = e.offsetTop;
          EF(t, n);
        }
      }
    },
    handleSelect: function(e) {
      this.$emit("select", e, "time");
    }
  }
}, DF = SF, gF = function() {
  var e = this, t = e.$createElement, n = e._self._c || t;
  return n("scrollbar-vertical", e._l(e.list, function(i) {
    return n("div", {
      key: i.value,
      class: [e.prefixClass + "-time-option", e.getClasses(i.value)],
      on: {
        click: function(o) {
          return e.handleSelect(i.value);
        }
      }
    }, [e._v(`
    ` + e._s(i.text) + `
  `)]);
  }), 0);
}, RF = [], vF = void 0, NF = void 0, FF = void 0, OF = !1, yF = Bt({
  render: gF,
  staticRenderFns: RF
}, vF, DF, NF, OF, FF, !1, void 0, void 0, void 0), bF = {
  name: "TimePanel",
  components: {
    ListColumns: mF,
    ListOptions: yF
  },
  inject: {
    getLocale: {
      default: function() {
        return mn;
      }
    },
    prefixClass: {
      default: "mx"
    }
  },
  props: {
    value: {},
    defaultValue: {
      default: function() {
        var e = new Date();
        return e.setHours(0, 0, 0, 0), e;
      }
    },
    format: {
      default: "HH:mm:ss"
    },
    timeTitleFormat: {
      type: String,
      default: "YYYY-MM-DD"
    },
    showTimeHeader: {
      type: Boolean,
      default: !1
    },
    disabledTime: {
      type: Function,
      default: function() {
        return !1;
      }
    },
    timePickerOptions: {
      type: [Object, Function],
      default: function() {
        return null;
      }
    },
    hourOptions: Array,
    minuteOptions: Array,
    secondOptions: Array,
    hourStep: {
      type: Number,
      default: 1
    },
    minuteStep: {
      type: Number,
      default: 1
    },
    secondStep: {
      type: Number,
      default: 1
    },
    showHour: {
      type: Boolean,
      default: void 0
    },
    showMinute: {
      type: Boolean,
      default: void 0
    },
    showSecond: {
      type: Boolean,
      default: void 0
    },
    use12h: {
      type: Boolean,
      default: void 0
    },
    scrollDuration: {
      type: Number,
      default: 100
    }
  },
  data: function() {
    return {
      innerValue: fn(this.value, this.defaultValue)
    };
  },
  computed: {
    title: function() {
      var e = this.timeTitleFormat, t = new Date(this.innerValue);
      return this.formatDate(t, e);
    },
    innerForamt: function() {
      return typeof this.format == "string" ? this.format : "HH:mm:ss";
    },
    ShowHourMinuteSecondAMPM: function() {
      var e = this, t = this.innerForamt, n = {
        showHour: /[HhKk]/.test(t),
        showMinute: /m/.test(t),
        showSecond: /s/.test(t),
        use12h: /a/i.test(t)
      }, i = {};
      return Object.keys(n).forEach(function(s) {
        i[s] = typeof e[s] == "boolean" ? e[s] : n[s];
      }), i;
    }
  },
  watch: {
    value: {
      immediate: !0,
      handler: function() {
        this.innerValue = fn(this.value, this.defaultValue);
      }
    }
  },
  methods: {
    formatDate: function(e, t) {
      return Wa(e, t, {
        locale: this.getLocale().formatLocale
      });
    },
    isDisabledTime: function(e) {
      return this.disabledTime(new Date(e));
    },
    isDisabledHour: function(e) {
      var t = new Date(e);
      return this.isDisabledTime(t) && this.isDisabledTime(t.setMinutes(0, 0, 0)) && this.isDisabledTime(t.setMinutes(59, 59, 999));
    },
    isDisabledMinute: function(e) {
      var t = new Date(e);
      return this.isDisabledTime(t) && this.isDisabledTime(t.setSeconds(0, 0)) && this.isDisabledTime(t.setSeconds(59, 999));
    },
    isDisabledAMPM: function(e) {
      var t = new Date(e), n = t.getHours() < 12 ? 0 : 12, i = n + 11;
      return this.isDisabledTime(t) && this.isDisabledTime(t.setHours(n, 0, 0, 0)) && this.isDisabledTime(t.setHours(i, 59, 59, 999));
    },
    isDisabled: function(e, t) {
      return t === "hour" ? this.isDisabledHour(e) : t === "minute" ? this.isDisabledMinute(e) : t === "ampm" ? this.isDisabledAMPM(e) : this.isDisabledTime(e);
    },
    handleSelect: function(e, t) {
      var n = new Date(e);
      this.isDisabled(e, t) || (this.innerValue = n, this.isDisabledTime(n) || this.$emit("select", n, t));
    },
    handleClickTitle: function() {
      this.$emit("clicktitle");
    },
    getClasses: function(e, t) {
      var n = new Date(e);
      return this.isDisabled(e, t) ? "disabled" : n.getTime() === this.innerValue.getTime() ? "active" : "";
    }
  }
}, CF = bF, _F = function() {
  var e = this, t = e.$createElement, n = e._self._c || t;
  return n("div", {
    class: e.prefixClass + "-time"
  }, [e.showTimeHeader ? n("div", {
    class: e.prefixClass + "-time-header"
  }, [n("button", {
    class: e.prefixClass + "-btn " + e.prefixClass + "-btn-text " + e.prefixClass + "-time-header-title",
    attrs: {
      type: "button"
    },
    on: {
      click: e.handleClickTitle
    }
  }, [e._v(`
      ` + e._s(e.title) + `
    `)])]) : e._e(), e._v(" "), n("div", {
    class: e.prefixClass + "-time-content"
  }, [e.timePickerOptions ? n("list-options", {
    attrs: {
      date: e.innerValue,
      "get-classes": e.getClasses,
      options: e.timePickerOptions,
      format: e.innerForamt
    },
    on: {
      select: e.handleSelect
    }
  }) : n("list-columns", e._b({
    attrs: {
      date: e.innerValue,
      "get-classes": e.getClasses,
      "hour-options": e.hourOptions,
      "minute-options": e.minuteOptions,
      "second-options": e.secondOptions,
      "hour-step": e.hourStep,
      "minute-step": e.minuteStep,
      "second-step": e.secondStep,
      "scroll-duration": e.scrollDuration
    },
    on: {
      select: e.handleSelect
    }
  }, "list-columns", e.ShowHourMinuteSecondAMPM, !1))], 1)]);
}, MF = [], YF = void 0, IF = void 0, BF = void 0, ZF = !1, Nr = Bt({
  render: _F,
  staticRenderFns: MF
}, YF, CF, IF, ZF, BF, !1, void 0, void 0, void 0), Jn = {
  name: "TimeRange",
  inject: {
    prefixClass: {
      default: "mx"
    }
  },
  props: ze({}, Nr.props),
  data: function() {
    return {
      startValue: new Date(NaN),
      endValue: new Date(NaN)
    };
  },
  watch: {
    value: {
      immediate: !0,
      handler: function() {
        if (Ka(this.value)) {
          var e = Qn(this.value, 2), t = e[0], n = e[1];
          this.startValue = t, this.endValue = n;
        } else
          this.startValue = new Date(NaN), this.endValue = new Date(NaN);
      }
    }
  },
  methods: {
    emitChange: function(e, t) {
      var n = [this.startValue, this.endValue];
      this.$emit("select", n, e === "time" ? "time-range" : e, t);
    },
    handleSelectStart: function(e, t) {
      this.startValue = e, this.endValue.getTime() >= e.getTime() || (this.endValue = e), this.emitChange(t, 0);
    },
    handleSelectEnd: function(e, t) {
      this.endValue = e, this.startValue.getTime() <= e.getTime() || (this.startValue = e), this.emitChange(t, 1);
    },
    disabledStartTime: function(e) {
      return this.disabledTime(e, 0);
    },
    disabledEndTime: function(e) {
      return e.getTime() < this.startValue.getTime() || this.disabledTime(e, 1);
    }
  },
  render: function() {
    var e = arguments[0], t = Array.isArray(this.defaultValue) ? this.defaultValue : [this.defaultValue, this.defaultValue], n = this.prefixClass;
    return e("div", {
      class: "".concat(n, "-range-wrapper")
    }, [e(Nr, {
      props: ze({}, ze({}, this.$props, {
        value: this.startValue,
        defaultValue: t[0],
        disabledTime: this.disabledStartTime
      })),
      on: ze({}, ze({}, this.$listeners, {
        select: this.handleSelectStart
      }))
    }), e(Nr, {
      props: ze({}, ze({}, this.$props, {
        value: this.endValue,
        defaultValue: t[1],
        disabledTime: this.disabledEndTime
      })),
      on: ze({}, ze({}, this.$listeners, {
        select: this.handleSelectEnd
      }))
    })]);
  }
}, cc = {
  name: "DatetimePanel",
  inject: {
    prefixClass: {
      default: "mx"
    }
  },
  emits: ["select", "update:show-time-panel"],
  props: ze({}, Ur.props, {}, Nr.props, {
    showTimePanel: {
      type: Boolean,
      default: void 0
    }
  }),
  data: function() {
    return {
      defaultTimeVisible: !1,
      currentValue: this.value
    };
  },
  computed: {
    timeVisible: function() {
      return typeof this.showTimePanel == "boolean" ? this.showTimePanel : this.defaultTimeVisible;
    }
  },
  watch: {
    value: function(e) {
      this.currentValue = e;
    }
  },
  methods: {
    closeTimePanel: function() {
      this.defaultTimeVisible = !1, this.$emit("update:show-time-panel", !1);
    },
    openTimePanel: function() {
      this.defaultTimeVisible = !0, this.$emit("update:show-time-panel", !0);
    },
    emitDate: function(e, t) {
      this.$emit("select", e, t);
    },
    handleSelect: function(e, t) {
      t === "date" && this.openTimePanel();
      var n = ga(e, fn(this.value, this.defaultValue));
      if (this.disabledTime(new Date(n)) && (n = ga(e, this.defaultValue), this.disabledTime(new Date(n)))) {
        this.currentValue = n;
        return;
      }
      this.emitDate(n, t);
    }
  },
  render: function() {
    var e = arguments[0], t = {
      props: ze({}, hn(this.$props, Object.keys(Ur.props)), {
        type: "date",
        value: this.currentValue
      }),
      on: {
        select: this.handleSelect
      }
    }, n = {
      props: ze({}, hn(this.$props, Object.keys(Nr.props)), {
        showTimeHeader: !0,
        value: this.currentValue
      }),
      on: {
        select: this.emitDate,
        clicktitle: this.closeTimePanel
      }
    }, i = this.prefixClass;
    return e("div", [e(Ur, ni([{}, t])), this.timeVisible && e(Nr, ni([{
      class: "".concat(i, "-calendar-time")
    }, n]))]);
  }
}, fE = {
  name: "DatetimeRange",
  inject: {
    prefixClass: {
      default: "mx"
    }
  },
  emits: ["select", "update:show-time-panel"],
  props: ze({}, Kn.props, {}, Jn.props, {
    showTimePanel: {
      type: Boolean,
      default: void 0
    }
  }),
  data: function() {
    return {
      defaultTimeVisible: !1,
      currentValue: this.value
    };
  },
  computed: {
    timeVisible: function() {
      return typeof this.showTimePanel == "boolean" ? this.showTimePanel : this.defaultTimeVisible;
    }
  },
  watch: {
    value: function(e) {
      this.currentValue = e;
    }
  },
  methods: {
    closeTimePanel: function() {
      this.defaultTimeVisible = !1, this.$emit("update:show-time-panel", !1);
    },
    openTimePanel: function() {
      this.defaultTimeVisible = !0, this.$emit("update:show-time-panel", !0);
    },
    emitDate: function(e, t) {
      this.$emit("select", e, t);
    },
    handleSelect: function(e, t) {
      var n = this;
      t === "date" && this.openTimePanel();
      var i = Array.isArray(this.defaultValue) ? this.defaultValue : [this.defaultValue, this.defaultValue], s = e.map(function(o, l) {
        var a = Ka(n.value) ? n.value[l] : i[l];
        return ga(o, a);
      });
      if (s[1].getTime() < s[0].getTime() && (s = [s[0], s[0]]), s.some(this.disabledTime) && (s = e.map(function(o, l) {
        return ga(o, i[l]);
      }), s.some(this.disabledTime))) {
        this.currentValue = s;
        return;
      }
      this.emitDate(s, t);
    }
  },
  render: function() {
    var e = arguments[0], t = {
      props: ze({}, hn(this.$props, Object.keys(Kn.props)), {
        type: "date",
        value: this.currentValue
      }),
      on: {
        select: this.handleSelect
      }
    }, n = {
      props: ze({}, hn(this.$props, Object.keys(Jn.props)), {
        value: this.currentValue,
        showTimeHeader: !0
      }),
      on: {
        select: this.emitDate,
        clicktitle: this.closeTimePanel
      }
    }, i = this.prefixClass;
    return e("div", [e(Kn, ni([{}, t])), this.timeVisible && e(Jn, ni([{
      class: "".concat(i, "-calendar-time")
    }, n]))]);
  }
}, wF = {
  default: Ur,
  time: Nr,
  datetime: cc
}, xF = {
  default: Kn,
  time: Jn,
  datetime: fE
}, Hr = {
  name: "DatePicker",
  provide: function() {
    var e = this;
    return {
      // make locale reactive
      getLocale: function() {
        return e.locale;
      },
      getWeek: this.getWeek,
      prefixClass: this.prefixClass,
      dispatchDatePicker: this.$emit.bind(this)
    };
  },
  props: ze({}, cc.props, {
    value: {},
    valueType: {
      type: String,
      default: "date"
      // date, format, timestamp, or token like 'YYYY-MM-DD'
    },
    type: {
      type: String,
      // ['date', 'datetime', 'time', 'year', 'month', 'week']
      default: "date"
    },
    format: {
      type: String
    },
    formatter: {
      type: Object
    },
    range: {
      type: Boolean,
      default: !1
    },
    multiple: {
      type: Boolean,
      default: !1
    },
    rangeSeparator: {
      type: String
    },
    lang: {
      type: [String, Object]
    },
    placeholder: {
      type: String,
      default: ""
    },
    editable: {
      type: Boolean,
      default: !0
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    clearable: {
      type: Boolean,
      default: !0
    },
    prefixClass: {
      type: String,
      default: "mx"
    },
    inputClass: {},
    inputAttr: {
      type: Object,
      default: function() {
        return {};
      }
    },
    appendToBody: {
      type: Boolean,
      default: !0
    },
    open: {
      type: Boolean,
      default: void 0
    },
    popupClass: {},
    popupStyle: {
      type: Object,
      default: function() {
        return {};
      }
    },
    inline: {
      type: Boolean,
      default: !1
    },
    confirm: {
      type: Boolean,
      default: !1
    },
    confirmText: {
      type: String,
      default: "OK"
    },
    renderInputText: {
      type: Function
    },
    shortcuts: {
      type: Array,
      validator: function(e) {
        return Array.isArray(e) && e.every(function(t) {
          return zt(t) && typeof t.text == "string" && typeof t.onClick == "function";
        });
      },
      default: function() {
        return [];
      }
    }
  }),
  data: function() {
    return {
      // cache the innervalue, wait to confirm
      currentValue: null,
      userInput: null,
      defaultOpen: !1
    };
  },
  computed: {
    popupVisible: function() {
      return !this.disabled && (typeof this.open == "boolean" ? this.open : this.defaultOpen);
    },
    innerRangeSeparator: function() {
      return this.rangeSeparator || (this.multiple ? "," : " ~ ");
    },
    innerFormat: function() {
      var e = {
        date: "YYYY-MM-DD",
        datetime: "YYYY-MM-DD HH:mm:ss",
        year: "YYYY",
        month: "YYYY-MM",
        time: "HH:mm:ss",
        week: "w"
      };
      return this.format || e[this.type] || e.date;
    },
    innerValue: function() {
      var e = this.value;
      return this.validMultipleType ? (e = Array.isArray(e) ? e : [], e.map(this.value2date)) : this.range ? (e = Array.isArray(e) ? e.slice(0, 2) : [null, null], e.map(this.value2date)) : this.value2date(e);
    },
    text: function() {
      var e = this;
      return this.userInput !== null ? this.userInput : typeof this.renderInputText == "function" ? this.renderInputText(this.innerValue) : this.isValidValue(this.innerValue) ? Array.isArray(this.innerValue) ? this.innerValue.map(function(t) {
        return e.formatDate(t);
      }).join(this.innerRangeSeparator) : this.formatDate(this.innerValue) : "";
    },
    showClearIcon: function() {
      return !this.disabled && this.clearable && this.text;
    },
    locale: function() {
      return zt(this.lang) ? TE(mn(), this.lang) : mn(this.lang);
    },
    validMultipleType: function() {
      var e = ["date", "month", "year"];
      return this.multiple && !this.range && e.indexOf(this.type) !== -1;
    }
  },
  watch: {
    innerValue: {
      immediate: !0,
      handler: function(e) {
        this.currentValue = e;
      }
    },
    popupVisible: {
      handler: function(e) {
        e && (this.currentValue = this.innerValue);
      }
    }
  },
  created: function() {
    xi(this.format) === "object" && console.warn("[vue2-datepicker]: The prop `format` don't support Object any more. You can use the new prop `formatter` to replace it");
  },
  methods: {
    handleClickOutSide: function(e) {
      var t = e.target;
      this.$el.contains(t) || this.closePopup();
    },
    getFormatter: function(e) {
      return zt(this.formatter) && this.formatter[e] || zt(this.format) && this.format[e];
    },
    getWeek: function(e, t) {
      return typeof this.getFormatter("getWeek") == "function" ? this.getFormatter("getWeek")(e, t) : ac(e, t);
    },
    parseDate: function(e, t) {
      if (t = t || this.innerFormat, typeof this.getFormatter("parse") == "function")
        return this.getFormatter("parse")(e, t);
      var n = new Date();
      return Ev(e, t, {
        locale: this.locale.formatLocale,
        backupDate: n
      });
    },
    formatDate: function(e, t) {
      return t = t || this.innerFormat, typeof this.getFormatter("stringify") == "function" ? this.getFormatter("stringify")(e, t) : Wa(e, t, {
        locale: this.locale.formatLocale
      });
    },
    // transform the outer value to inner date
    value2date: function(e) {
      switch (this.valueType) {
        case "date":
          return e instanceof Date ? new Date(e.getTime()) : new Date(NaN);
        case "timestamp":
          return typeof e == "number" ? new Date(e) : new Date(NaN);
        case "format":
          return typeof e == "string" ? this.parseDate(e) : new Date(NaN);
        default:
          return typeof e == "string" ? this.parseDate(e, this.valueType) : new Date(NaN);
      }
    },
    // transform the inner date to outer value
    date2value: function(e) {
      if (!cr(e))
        return null;
      switch (this.valueType) {
        case "date":
          return e;
        case "timestamp":
          return e.getTime();
        case "format":
          return this.formatDate(e);
        default:
          return this.formatDate(e, this.valueType);
      }
    },
    emitValue: function(e, t) {
      var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
      this.userInput = null;
      var i = Array.isArray(e) ? e.map(this.date2value) : this.date2value(e);
      return this.$emit("input", i), this.$emit("change", i, t), n && this.closePopup(), i;
    },
    isValidValue: function(e) {
      return this.validMultipleType ? _v(e) : this.range ? Ka(e) : cr(e);
    },
    isValidValueAndNotDisabled: function(e) {
      if (!this.isValidValue(e))
        return !1;
      var t = typeof this.disabledDate == "function" ? this.disabledDate : function() {
        return !1;
      }, n = typeof this.disabledTime == "function" ? this.disabledTime : function() {
        return !1;
      };
      return Array.isArray(e) || (e = [e]), e.every(function(i) {
        return !t(i) && !n(i);
      });
    },
    handleMultipleDates: function(e, t) {
      if (this.validMultipleType && t) {
        var n = t.filter(function(i) {
          return i.getTime() !== e.getTime();
        });
        return n.length === t.length && n.push(e), n;
      }
      return e;
    },
    handleSelectDate: function(e, t, n) {
      e = this.handleMultipleDates(e, n), this.confirm ? this.currentValue = e : this.emitValue(
        e,
        t,
        // this.type === 'datetime', click the time should close popup
        !this.validMultipleType && (t === this.type || t === "time")
      );
    },
    clear: function() {
      this.emitValue(this.range ? [null, null] : null), this.$emit("clear");
    },
    handleClear: function(e) {
      e.stopPropagation(), this.clear();
    },
    handleConfirmDate: function() {
      var e = this.emitValue(this.currentValue);
      this.$emit("confirm", e);
    },
    handleSelectShortcut: function(e) {
      var t = e.currentTarget.getAttribute("data-index"), n = this.shortcuts[parseInt(t, 10)];
      if (zt(n) && typeof n.onClick == "function") {
        var i = n.onClick(this);
        i && this.emitValue(i);
      }
    },
    openPopup: function(e) {
      this.popupVisible || this.disabled || (this.defaultOpen = !0, this.$emit("open", e), this.$emit("update:open", !0));
    },
    closePopup: function() {
      this.popupVisible && (this.defaultOpen = !1, this.$emit("close"), this.$emit("update:open", !1));
    },
    blur: function() {
      this.$refs.input && this.$refs.input.blur();
    },
    focus: function() {
      this.$refs.input && this.$refs.input.focus();
    },
    handleInputChange: function() {
      var e = this;
      if (!(!this.editable || this.userInput === null)) {
        var t = this.userInput.trim();
        if (this.userInput = null, t === "") {
          this.clear();
          return;
        }
        var n;
        if (this.validMultipleType)
          n = t.split(this.innerRangeSeparator).map(function(s) {
            return e.parseDate(s.trim());
          });
        else if (this.range) {
          var i = t.split(this.innerRangeSeparator);
          i.length !== 2 && (i = t.split(this.innerRangeSeparator.trim())), n = i.map(function(s) {
            return e.parseDate(s.trim());
          });
        } else
          n = this.parseDate(t);
        this.isValidValueAndNotDisabled(n) ? (this.emitValue(n), this.blur()) : this.$emit("input-error", t);
      }
    },
    handleInputInput: function(e) {
      this.userInput = typeof e == "string" ? e : e.target.value;
    },
    handleInputKeydown: function(e) {
      var t = e.keyCode;
      t === 9 ? this.closePopup() : t === 13 && this.handleInputChange();
    },
    handleInputBlur: function(e) {
      this.$emit("blur", e);
    },
    handleInputFocus: function(e) {
      this.openPopup(e), this.$emit("focus", e);
    },
    hasSlot: function(e) {
      return !!(this.$slots[e] || this.$scopedSlots[e]);
    },
    renderSlot: function(e, t, n) {
      var i = this.$scopedSlots[e];
      return i ? i(n) || t : this.$slots[e] || t;
    },
    renderInput: function() {
      var e = this.$createElement, t = this.prefixClass, n = ze({
        name: "date",
        type: "text",
        autocomplete: "off",
        value: this.text,
        class: this.inputClass || "".concat(this.prefixClass, "-input"),
        readonly: !this.editable,
        disabled: this.disabled,
        placeholder: this.placeholder
      }, this.inputAttr), i = n.value, s = n.class, o = Dv(n, ["value", "class"]), l = {
        keydown: this.handleInputKeydown,
        focus: this.handleInputFocus,
        blur: this.handleInputBlur,
        input: this.handleInputInput,
        change: this.handleInputChange
      }, a = this.renderSlot("input", e("input", {
        domProps: {
          value: i
        },
        class: s,
        attrs: ze({}, o),
        on: ze({}, l),
        ref: "input"
      }), {
        props: n,
        events: l
      }), c = this.type === "time" ? e(cN) : e(nN);
      return e("div", {
        class: "".concat(t, "-input-wrapper"),
        on: {
          mousedown: this.openPopup,
          touchstart: this.openPopup
        }
      }, [a, this.showClearIcon ? e("i", {
        class: "".concat(t, "-icon-clear"),
        on: {
          mousedown: this.handleClear,
          touchstart: this.handleClear
        }
      }, [this.renderSlot("icon-clear", e(mN))]) : null, e("i", {
        class: "".concat(t, "-icon-calendar")
      }, [this.renderSlot("icon-calendar", c)])]);
    },
    renderContent: function() {
      var e = this.$createElement, t = this.range ? xF : wF, n = t[this.type] || t.default, i = ze({}, hn(this.$props, Object.keys(n.props)), {
        value: this.currentValue
      }), s = ze({}, hn(this.$listeners, n.emits || []), {
        select: this.handleSelectDate
      }), o = e(n, ni([{}, {
        props: i,
        on: s,
        ref: "picker"
      }]));
      return e("div", {
        class: "".concat(this.prefixClass, "-datepicker-body")
      }, [this.renderSlot("content", o, {
        value: this.currentValue,
        emit: this.handleSelectDate
      })]);
    },
    renderSidebar: function() {
      var e = this, t = this.$createElement, n = this.prefixClass;
      return t("div", {
        class: "".concat(n, "-datepicker-sidebar")
      }, [this.renderSlot("sidebar", null, {
        value: this.currentValue,
        emit: this.handleSelectDate
      }), this.shortcuts.map(function(i, s) {
        return t("button", {
          key: s,
          attrs: {
            "data-index": s,
            type: "button"
          },
          class: "".concat(n, "-btn ").concat(n, "-btn-text ").concat(n, "-btn-shortcut"),
          on: {
            click: e.handleSelectShortcut
          }
        }, [i.text]);
      })]);
    },
    renderHeader: function() {
      var e = this.$createElement;
      return e("div", {
        class: "".concat(this.prefixClass, "-datepicker-header")
      }, [this.renderSlot("header", null, {
        value: this.currentValue,
        emit: this.handleSelectDate
      })]);
    },
    renderFooter: function() {
      var e = this.$createElement, t = this.prefixClass;
      return e("div", {
        class: "".concat(t, "-datepicker-footer")
      }, [this.renderSlot("footer", null, {
        value: this.currentValue,
        emit: this.handleSelectDate
      }), this.confirm ? e("button", {
        attrs: {
          type: "button"
        },
        class: "".concat(t, "-btn ").concat(t, "-datepicker-btn-confirm"),
        on: {
          click: this.handleConfirmDate
        }
      }, [this.confirmText]) : null]);
    }
  },
  render: function() {
    var e, t = arguments[0], n = this.prefixClass, i = this.inline, s = this.disabled, o = this.hasSlot("sidebar") || this.shortcuts.length ? this.renderSidebar() : null, l = t("div", {
      class: "".concat(n, "-datepicker-content")
    }, [this.hasSlot("header") ? this.renderHeader() : null, this.renderContent(), this.hasSlot("footer") || this.confirm ? this.renderFooter() : null]);
    return t("div", {
      class: (e = {}, Gr(e, "".concat(n, "-datepicker"), !0), Gr(e, "".concat(n, "-datepicker-range"), this.range), Gr(e, "".concat(n, "-datepicker-inline"), i), Gr(e, "disabled", s), e)
    }, [i ? null : this.renderInput(), i ? t("div", {
      class: "".concat(n, "-datepicker-main")
    }, [o, l]) : t(Qv, {
      ref: "popup",
      class: this.popupClass,
      style: this.popupStyle,
      attrs: {
        visible: this.popupVisible,
        appendToBody: this.appendToBody
      },
      on: {
        clickoutside: this.handleClickOutSide
      }
    }, [o, l])]);
  }
};
Hr.locale = dE;
Hr.install = function(e) {
  e.component(Hr.name, Hr);
};
typeof window < "u" && window.Vue && Hr.install(window.Vue);
ou(Hr, {
  CalendarPanel: Ur,
  CalendarRange: Kn,
  TimePanel: Nr,
  TimeRange: Jn,
  DatetimePanel: cc,
  DatetimeRange: fE
});
const LF = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Hr
}, Symbol.toStringTag, { value: "Module" })), kF = /* @__PURE__ */ Vr(LF);
/*! For license information please see NcDatetimePicker.js.LICENSE.txt */
(function(r, e) {
  (function(t, n) {
    r.exports = n();
  })(self, () => (() => {
    var t = { 1906: (o, l, a) => {
      a.d(l, { default: () => pe });
      var c = a(2963), T = a(1215), u = a(6903), d = a(336), A = a(7993), f = a(3351), h = a(932), S = a(3607), p = a(768), m = a.n(p), g = a(542), N = a(7672), R = a(4262), D = a(1441), v = a.n(D), O = a(453), y = a(5108);
      function Z(L) {
        return Z = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(ee) {
          return typeof ee;
        } : function(ee) {
          return ee && typeof Symbol == "function" && ee.constructor === Symbol && ee !== Symbol.prototype ? "symbol" : typeof ee;
        }, Z(L);
      }
      function F() {
        F = function() {
          return L;
        };
        var L = {}, ee = Object.prototype, Ae = ee.hasOwnProperty, Ne = Object.defineProperty || function(Te, ue, he) {
          Te[ue] = he.value;
        }, ye = typeof Symbol == "function" ? Symbol : {}, be = ye.iterator || "@@iterator", Ge = ye.asyncIterator || "@@asyncIterator", Ze = ye.toStringTag || "@@toStringTag";
        function _e(Te, ue, he) {
          return Object.defineProperty(Te, ue, { value: he, enumerable: !0, configurable: !0, writable: !0 }), Te[ue];
        }
        try {
          _e({}, "");
        } catch {
          _e = function(ue, he, Ce) {
            return ue[he] = Ce;
          };
        }
        function oe(Te, ue, he, Ce) {
          var Se = ue && ue.prototype instanceof k ? ue : k, ke = Object.create(Se.prototype), Qe = new ut(Ce || []);
          return Ne(ke, "_invoke", { value: ne(Te, he, Qe) }), ke;
        }
        function te(Te, ue, he) {
          try {
            return { type: "normal", arg: Te.call(ue, he) };
          } catch (Ce) {
            return { type: "throw", arg: Ce };
          }
        }
        L.wrap = oe;
        var K = {};
        function k() {
        }
        function B() {
        }
        function j() {
        }
        var le = {};
        _e(le, be, function() {
          return this;
        });
        var ce = Object.getPrototypeOf, De = ce && ce(ce(fr([])));
        De && De !== ee && Ae.call(De, be) && (le = De);
        var Ye = j.prototype = k.prototype = Object.create(le);
        function Ue(Te) {
          ["next", "throw", "return"].forEach(function(ue) {
            _e(Te, ue, function(he) {
              return this._invoke(ue, he);
            });
          });
        }
        function G(Te, ue) {
          function he(Se, ke, Qe, We) {
            var tt = te(Te[Se], Te, ke);
            if (tt.type !== "throw") {
              var Jt = tt.arg, pr = Jt.value;
              return pr && Z(pr) == "object" && Ae.call(pr, "__await") ? ue.resolve(pr.__await).then(function(Xt) {
                he("next", Xt, Qe, We);
              }, function(Xt) {
                he("throw", Xt, Qe, We);
              }) : ue.resolve(pr).then(function(Xt) {
                Jt.value = Xt, Qe(Jt);
              }, function(Xt) {
                return he("throw", Xt, Qe, We);
              });
            }
            We(tt.arg);
          }
          var Ce;
          Ne(this, "_invoke", { value: function(Se, ke) {
            function Qe() {
              return new ue(function(We, tt) {
                he(Se, ke, We, tt);
              });
            }
            return Ce = Ce ? Ce.then(Qe, Qe) : Qe();
          } });
        }
        function ne(Te, ue, he) {
          var Ce = "suspendedStart";
          return function(Se, ke) {
            if (Ce === "executing")
              throw new Error("Generator is already running");
            if (Ce === "completed") {
              if (Se === "throw")
                throw ke;
              return Cn();
            }
            for (he.method = Se, he.arg = ke; ; ) {
              var Qe = he.delegate;
              if (Qe) {
                var We = Ee(Qe, he);
                if (We) {
                  if (We === K)
                    continue;
                  return We;
                }
              }
              if (he.method === "next")
                he.sent = he._sent = he.arg;
              else if (he.method === "throw") {
                if (Ce === "suspendedStart")
                  throw Ce = "completed", he.arg;
                he.dispatchException(he.arg);
              } else
                he.method === "return" && he.abrupt("return", he.arg);
              Ce = "executing";
              var tt = te(Te, ue, he);
              if (tt.type === "normal") {
                if (Ce = he.done ? "completed" : "suspendedYield", tt.arg === K)
                  continue;
                return { value: tt.arg, done: he.done };
              }
              tt.type === "throw" && (Ce = "completed", he.method = "throw", he.arg = tt.arg);
            }
          };
        }
        function Ee(Te, ue) {
          var he = ue.method, Ce = Te.iterator[he];
          if (Ce === void 0)
            return ue.delegate = null, he === "throw" && Te.iterator.return && (ue.method = "return", ue.arg = void 0, Ee(Te, ue), ue.method === "throw") || he !== "return" && (ue.method = "throw", ue.arg = new TypeError("The iterator does not provide a '" + he + "' method")), K;
          var Se = te(Ce, Te.iterator, ue.arg);
          if (Se.type === "throw")
            return ue.method = "throw", ue.arg = Se.arg, ue.delegate = null, K;
          var ke = Se.arg;
          return ke ? ke.done ? (ue[Te.resultName] = ke.value, ue.next = Te.nextLoc, ue.method !== "return" && (ue.method = "next", ue.arg = void 0), ue.delegate = null, K) : ke : (ue.method = "throw", ue.arg = new TypeError("iterator result is not an object"), ue.delegate = null, K);
        }
        function Ie(Te) {
          var ue = { tryLoc: Te[0] };
          1 in Te && (ue.catchLoc = Te[1]), 2 in Te && (ue.finallyLoc = Te[2], ue.afterLoc = Te[3]), this.tryEntries.push(ue);
        }
        function He(Te) {
          var ue = Te.completion || {};
          ue.type = "normal", delete ue.arg, Te.completion = ue;
        }
        function ut(Te) {
          this.tryEntries = [{ tryLoc: "root" }], Te.forEach(Ie, this), this.reset(!0);
        }
        function fr(Te) {
          if (Te) {
            var ue = Te[be];
            if (ue)
              return ue.call(Te);
            if (typeof Te.next == "function")
              return Te;
            if (!isNaN(Te.length)) {
              var he = -1, Ce = function Se() {
                for (; ++he < Te.length; )
                  if (Ae.call(Te, he))
                    return Se.value = Te[he], Se.done = !1, Se;
                return Se.value = void 0, Se.done = !0, Se;
              };
              return Ce.next = Ce;
            }
          }
          return { next: Cn };
        }
        function Cn() {
          return { value: void 0, done: !0 };
        }
        return B.prototype = j, Ne(Ye, "constructor", { value: j, configurable: !0 }), Ne(j, "constructor", { value: B, configurable: !0 }), B.displayName = _e(j, Ze, "GeneratorFunction"), L.isGeneratorFunction = function(Te) {
          var ue = typeof Te == "function" && Te.constructor;
          return !!ue && (ue === B || (ue.displayName || ue.name) === "GeneratorFunction");
        }, L.mark = function(Te) {
          return Object.setPrototypeOf ? Object.setPrototypeOf(Te, j) : (Te.__proto__ = j, _e(Te, Ze, "GeneratorFunction")), Te.prototype = Object.create(Ye), Te;
        }, L.awrap = function(Te) {
          return { __await: Te };
        }, Ue(G.prototype), _e(G.prototype, Ge, function() {
          return this;
        }), L.AsyncIterator = G, L.async = function(Te, ue, he, Ce, Se) {
          Se === void 0 && (Se = Promise);
          var ke = new G(oe(Te, ue, he, Ce), Se);
          return L.isGeneratorFunction(ue) ? ke : ke.next().then(function(Qe) {
            return Qe.done ? Qe.value : ke.next();
          });
        }, Ue(Ye), _e(Ye, Ze, "Generator"), _e(Ye, be, function() {
          return this;
        }), _e(Ye, "toString", function() {
          return "[object Generator]";
        }), L.keys = function(Te) {
          var ue = Object(Te), he = [];
          for (var Ce in ue)
            he.push(Ce);
          return he.reverse(), function Se() {
            for (; he.length; ) {
              var ke = he.pop();
              if (ke in ue)
                return Se.value = ke, Se.done = !1, Se;
            }
            return Se.done = !0, Se;
          };
        }, L.values = fr, ut.prototype = { constructor: ut, reset: function(Te) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(He), !Te)
            for (var ue in this)
              ue.charAt(0) === "t" && Ae.call(this, ue) && !isNaN(+ue.slice(1)) && (this[ue] = void 0);
        }, stop: function() {
          this.done = !0;
          var Te = this.tryEntries[0].completion;
          if (Te.type === "throw")
            throw Te.arg;
          return this.rval;
        }, dispatchException: function(Te) {
          if (this.done)
            throw Te;
          var ue = this;
          function he(tt, Jt) {
            return ke.type = "throw", ke.arg = Te, ue.next = tt, Jt && (ue.method = "next", ue.arg = void 0), !!Jt;
          }
          for (var Ce = this.tryEntries.length - 1; Ce >= 0; --Ce) {
            var Se = this.tryEntries[Ce], ke = Se.completion;
            if (Se.tryLoc === "root")
              return he("end");
            if (Se.tryLoc <= this.prev) {
              var Qe = Ae.call(Se, "catchLoc"), We = Ae.call(Se, "finallyLoc");
              if (Qe && We) {
                if (this.prev < Se.catchLoc)
                  return he(Se.catchLoc, !0);
                if (this.prev < Se.finallyLoc)
                  return he(Se.finallyLoc);
              } else if (Qe) {
                if (this.prev < Se.catchLoc)
                  return he(Se.catchLoc, !0);
              } else {
                if (!We)
                  throw new Error("try statement without catch or finally");
                if (this.prev < Se.finallyLoc)
                  return he(Se.finallyLoc);
              }
            }
          }
        }, abrupt: function(Te, ue) {
          for (var he = this.tryEntries.length - 1; he >= 0; --he) {
            var Ce = this.tryEntries[he];
            if (Ce.tryLoc <= this.prev && Ae.call(Ce, "finallyLoc") && this.prev < Ce.finallyLoc) {
              var Se = Ce;
              break;
            }
          }
          Se && (Te === "break" || Te === "continue") && Se.tryLoc <= ue && ue <= Se.finallyLoc && (Se = null);
          var ke = Se ? Se.completion : {};
          return ke.type = Te, ke.arg = ue, Se ? (this.method = "next", this.next = Se.finallyLoc, K) : this.complete(ke);
        }, complete: function(Te, ue) {
          if (Te.type === "throw")
            throw Te.arg;
          return Te.type === "break" || Te.type === "continue" ? this.next = Te.arg : Te.type === "return" ? (this.rval = this.arg = Te.arg, this.method = "return", this.next = "end") : Te.type === "normal" && ue && (this.next = ue), K;
        }, finish: function(Te) {
          for (var ue = this.tryEntries.length - 1; ue >= 0; --ue) {
            var he = this.tryEntries[ue];
            if (he.finallyLoc === Te)
              return this.complete(he.completion, he.afterLoc), He(he), K;
          }
        }, catch: function(Te) {
          for (var ue = this.tryEntries.length - 1; ue >= 0; --ue) {
            var he = this.tryEntries[ue];
            if (he.tryLoc === Te) {
              var Ce = he.completion;
              if (Ce.type === "throw") {
                var Se = Ce.arg;
                He(he);
              }
              return Se;
            }
          }
          throw new Error("illegal catch attempt");
        }, delegateYield: function(Te, ue, he) {
          return this.delegate = { iterator: fr(Te), resultName: ue, nextLoc: he }, this.method === "next" && (this.arg = void 0), K;
        } }, L;
      }
      function b(L, ee, Ae, Ne, ye, be, Ge) {
        try {
          var Ze = L[be](Ge), _e = Ze.value;
        } catch (oe) {
          return void Ae(oe);
        }
        Ze.done ? ee(_e) : Promise.resolve(_e).then(Ne, ye);
      }
      function Y(L) {
        return function() {
          var ee = this, Ae = arguments;
          return new Promise(function(Ne, ye) {
            var be = L.apply(ee, Ae);
            function Ge(_e) {
              b(be, Ne, ye, Ge, Ze, "next", _e);
            }
            function Ze(_e) {
              b(be, Ne, ye, Ge, Ze, "throw", _e);
            }
            Ge(void 0);
          });
        };
      }
      var I = (0, N.getBuilder)("nextcloud").persist().build();
      function q(L) {
        var ee = I.getItem("user-has-avatar." + L);
        return typeof ee == "string" ? Boolean(ee) : null;
      }
      function _(L, ee) {
        L && I.setItem("user-has-avatar." + L, ee);
      }
      const z = { name: "NcAvatar", directives: { ClickOutside: O.directive, tooltip: d.default }, components: { DotsHorizontal: v(), NcLoadingIcon: u.default, NcPopover: c.default, NcPopoverMenu: T.default }, mixins: [f.iQ], props: { url: { type: String, default: void 0 }, iconClass: { type: String, default: void 0 }, user: { type: String, default: void 0 }, showUserStatus: { type: Boolean, default: !0 }, showUserStatusCompact: { type: Boolean, default: !0 }, preloadedUserStatus: { type: Object, default: void 0 }, isGuest: { type: Boolean, default: !1 }, displayName: { type: String, default: void 0 }, size: { type: Number, default: 32 }, allowPlaceholder: { type: Boolean, default: !0 }, disableTooltip: { type: Boolean, default: !1 }, disableMenu: { type: Boolean, default: !1 }, tooltipMessage: { type: String, default: null }, title: { type: String, default: null }, isNoUser: { type: Boolean, default: !1 }, menuPosition: { type: String, default: "center" }, menuContainer: { type: [String, Object, Element, Boolean], default: "body" }, ariaLabel: { type: String, default: null } }, data: function() {
        return { avatarUrlLoaded: null, avatarSrcSetLoaded: null, userDoesNotExist: !1, isAvatarLoaded: !1, isMenuLoaded: !1, contactsMenuLoading: !1, contactsMenuActions: [], contactsMenuOpenState: !1 };
      }, computed: { avatarAriaLabel: function() {
        var L, ee;
        if (this.hasMenu)
          return this.ariaLabel !== null ? this.ariaLabel : this.hasStatus && this.showUserStatus && this.showUserStatusCompact ? (0, h.t)("Avatar of {displayName}, {status}", { displayName: (ee = this.displayName) !== null && ee !== void 0 ? ee : this.user, status: this.userStatus.status }) : (0, h.t)("Avatar of {displayName}", { displayName: (L = this.displayName) !== null && L !== void 0 ? L : this.user });
      }, canDisplayUserStatus: function() {
        return this.showUserStatus && this.hasStatus && ["online", "away", "dnd"].includes(this.userStatus.status);
      }, showUserStatusIconOnAvatar: function() {
        return this.showUserStatus && this.showUserStatusCompact && this.hasStatus && this.userStatus.status !== "dnd" && this.userStatus.icon;
      }, getUserIdentifier: function() {
        return this.isDisplayNameDefined ? this.displayName : this.isUserDefined ? this.user : "";
      }, isUserDefined: function() {
        return this.user !== void 0;
      }, isDisplayNameDefined: function() {
        return this.displayName !== void 0;
      }, isUrlDefined: function() {
        return this.url !== void 0;
      }, hasMenu: function() {
        var L;
        return !this.disableMenu && (this.isMenuLoaded ? this.menu.length > 0 : !(this.user === ((L = (0, S.getCurrentUser)()) === null || L === void 0 ? void 0 : L.uid) || this.userDoesNotExist || this.url));
      }, shouldShowPlaceholder: function() {
        return this.allowPlaceholder && this.userDoesNotExist;
      }, avatarStyle: function() {
        return { "--size": this.size + "px", lineHeight: this.size + "px", fontSize: Math.round(0.45 * this.size) + "px" };
      }, initialsWrapperStyle: function() {
        var L = (0, A.default)(this.getUserIdentifier), ee = L.r, Ae = L.g, Ne = L.b;
        return { backgroundColor: "rgba(".concat(ee, ", ").concat(Ae, ", ").concat(Ne, ", 0.1)") };
      }, initialsStyle: function() {
        var L = (0, A.default)(this.getUserIdentifier), ee = L.r, Ae = L.g, Ne = L.b;
        return { color: "rgb(".concat(ee, ", ").concat(Ae, ", ").concat(Ne, ")") };
      }, tooltip: function() {
        return !this.disableTooltip && !this.title && (this.tooltipMessage ? this.tooltipMessage : this.displayName);
      }, initials: function() {
        var L;
        if (this.shouldShowPlaceholder) {
          var ee = this.getUserIdentifier, Ae = ee.indexOf(" ");
          ee === "" ? L = "?" : (L = String.fromCodePoint(ee.codePointAt(0)), Ae !== -1 && (L = L.concat(String.fromCodePoint(ee.codePointAt(Ae + 1)))));
        }
        return L.toUpperCase();
      }, menu: function() {
        var L, ee, Ae, Ne = this.contactsMenuActions.map(function(ye) {
          return { href: ye.hyperlink, icon: ye.icon, longtext: ye.title };
        });
        return this.showUserStatus && (this.userStatus.icon || this.userStatus.message) ? [{ href: "#", icon: "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg'><text x='0' y='14' font-size='14'>".concat((L = this.userStatus.icon, ee = document.createTextNode(L), Ae = document.createElement("p"), Ae.appendChild(ee), Ae.innerHTML), "</text></svg>"), text: "".concat(this.userStatus.message) }].concat(Ne) : Ne;
      } }, watch: { url: function() {
        this.userDoesNotExist = !1, this.loadAvatarUrl();
      }, user: function() {
        this.userDoesNotExist = !1, this.isMenuLoaded = !1, this.loadAvatarUrl();
      } }, mounted: function() {
        this.loadAvatarUrl(), (0, g.subscribe)("settings:avatar:updated", this.loadAvatarUrl), (0, g.subscribe)("settings:display-name:updated", this.loadAvatarUrl), this.showUserStatus && this.user && !this.isNoUser && (this.preloadedUserStatus ? (this.userStatus.status = this.preloadedUserStatus.status || "", this.userStatus.message = this.preloadedUserStatus.message || "", this.userStatus.icon = this.preloadedUserStatus.icon || "", this.hasStatus = this.preloadedUserStatus.status !== null) : this.fetchUserStatus(this.user), (0, g.subscribe)("user_status:status.updated", this.handleUserStatusUpdated));
      }, beforeDestroy: function() {
        (0, g.unsubscribe)("settings:avatar:updated", this.loadAvatarUrl), (0, g.unsubscribe)("settings:display-name:updated", this.loadAvatarUrl), this.showUserStatus && this.user && !this.isNoUser && (0, g.unsubscribe)("user_status:status.updated", this.handleUserStatusUpdated);
      }, methods: { handlePopoverAfterShow: function() {
        var L = this.$refs.popoverMenu.$el.getElementsByTagName("a");
        L.length && L[0].focus();
      }, handlePopoverAfterHide: function() {
        this.$refs.main.focus();
      }, handleUserStatusUpdated: function(L) {
        this.user === L.userId && (this.userStatus = { status: L.status, icon: L.icon, message: L.message });
      }, toggleMenu: function() {
        var L = this;
        return Y(F().mark(function ee() {
          return F().wrap(function(Ae) {
            for (; ; )
              switch (Ae.prev = Ae.next) {
                case 0:
                  if (L.hasMenu) {
                    Ae.next = 2;
                    break;
                  }
                  return Ae.abrupt("return");
                case 2:
                  if (L.contactsMenuOpenState) {
                    Ae.next = 5;
                    break;
                  }
                  return Ae.next = 5, L.fetchContactsMenu();
                case 5:
                  L.contactsMenuOpenState = !L.contactsMenuOpenState;
                case 6:
                case "end":
                  return Ae.stop();
              }
          }, ee);
        }))();
      }, closeMenu: function() {
        this.contactsMenuOpenState = !1;
      }, fetchContactsMenu: function() {
        var L = this;
        return Y(F().mark(function ee() {
          var Ae, Ne, ye;
          return F().wrap(function(be) {
            for (; ; )
              switch (be.prev = be.next) {
                case 0:
                  return L.contactsMenuLoading = !0, be.prev = 1, Ae = encodeURIComponent(L.user), be.next = 5, m().post((0, R.generateUrl)("contactsmenu/findOne"), "shareType=0&shareWith=".concat(Ae));
                case 5:
                  Ne = be.sent, ye = Ne.data, L.contactsMenuActions = ye.topAction ? [ye.topAction].concat(ye.actions) : ye.actions, be.next = 13;
                  break;
                case 10:
                  be.prev = 10, be.t0 = be.catch(1), L.contactsMenuOpenState = !1;
                case 13:
                  L.contactsMenuLoading = !1, L.isMenuLoaded = !0;
                case 15:
                case "end":
                  return be.stop();
              }
          }, ee, null, [[1, 10]]);
        }))();
      }, loadAvatarUrl: function() {
        if (this.isAvatarLoaded = !1, !this.isUrlDefined && (!this.isUserDefined || this.isNoUser))
          return this.isAvatarLoaded = !0, void (this.userDoesNotExist = !0);
        if (this.isUrlDefined)
          this.updateImageIfValid(this.url);
        else if (this.size <= 64) {
          var L = this.avatarUrlGenerator(this.user, 64), ee = [L + " 1x", this.avatarUrlGenerator(this.user, 512) + " 8x"].join(", ");
          this.updateImageIfValid(L, ee);
        } else {
          var Ae = this.avatarUrlGenerator(this.user, 512);
          this.updateImageIfValid(Ae);
        }
      }, avatarUrlGenerator: function(L, ee) {
        var Ae, Ne = window.getComputedStyle(this.$el).getPropertyValue("--background-invert-if-dark") === "invert(100%)", ye = "/avatar/{user}/{size}" + (Ne ? "/dark" : "");
        this.isGuest && (ye = "/avatar/guest/{user}/{size}" + (Ne ? "/dark" : ""));
        var be = (0, R.generateUrl)(ye, { user: L, size: ee });
        return L === ((Ae = (0, S.getCurrentUser)()) === null || Ae === void 0 ? void 0 : Ae.uid) && typeof oc_userconfig < "u" && (be += "?v=" + oc_userconfig.avatar.version), be;
      }, updateImageIfValid: function(L) {
        var ee = this, Ae = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, Ne = q(this.user);
        if (this.isUserDefined && typeof Ne == "boolean")
          return this.isAvatarLoaded = !0, this.avatarUrlLoaded = L, Ae && (this.avatarSrcSetLoaded = Ae), void (Ne === !1 && (this.userDoesNotExist = !0));
        var ye = new Image();
        ye.onload = function() {
          ee.avatarUrlLoaded = L, Ae && (ee.avatarSrcSetLoaded = Ae), ee.isAvatarLoaded = !0, _(ee.user, !0);
        }, ye.onerror = function() {
          y.debug("Invalid avatar url", L), ee.avatarUrlLoaded = null, ee.avatarSrcSetLoaded = null, ee.userDoesNotExist = !0, ee.isAvatarLoaded = !1, _(ee.user, !1);
        }, Ae && (ye.srcset = Ae), ye.src = L;
      } } };
      var E = a(3379), C = a.n(E), P = a(7795), M = a.n(P), Q = a(569), H = a.n(Q), re = a(3565), U = a.n(re), w = a(9216), W = a.n(w), se = a(4589), ie = a.n(se), Fe = a(1435), V = {};
      V.styleTagTransform = ie(), V.setAttributes = U(), V.insert = H().bind(null, "head"), V.domAPI = M(), V.insertStyleElement = W(), C()(Fe.Z, V), Fe.Z && Fe.Z.locals && Fe.Z.locals;
      var $ = a(1900), J = a(3051), ae = a.n(J), X = (0, $.Z)(z, function() {
        var L = this, ee = L._self._c;
        return ee("div", L._g({ directives: [{ name: "tooltip", rawName: "v-tooltip", value: L.tooltip, expression: "tooltip" }, { name: "click-outside", rawName: "v-click-outside", value: L.closeMenu, expression: "closeMenu" }], ref: "main", staticClass: "avatardiv popovermenu-wrapper", class: { "avatardiv--unknown": L.userDoesNotExist, "avatardiv--with-menu": L.hasMenu }, style: L.avatarStyle, attrs: { title: L.title, tabindex: L.hasMenu ? "0" : void 0, "aria-label": L.avatarAriaLabel, role: L.hasMenu ? "button" : void 0 }, on: { keydown: function(Ae) {
          return !Ae.type.indexOf("key") && L._k(Ae.keyCode, "enter", 13, Ae.key, "Enter") ? null : L.toggleMenu.apply(null, arguments);
        } } }, L.hasMenu ? { click: L.toggleMenu } : {}), [L._t("icon", function() {
          return [L.iconClass ? ee("div", { staticClass: "avatar-class-icon", class: L.iconClass }) : L.isAvatarLoaded && !L.userDoesNotExist ? ee("img", { attrs: { src: L.avatarUrlLoaded, srcset: L.avatarSrcSetLoaded, alt: "" } }) : L._e()];
        }), L._v(" "), L.hasMenu ? ee("NcPopover", { attrs: { placement: "auto", container: L.menuContainer, open: L.contactsMenuOpenState }, on: { "after-show": L.handlePopoverAfterShow, "after-hide": L.handlePopoverAfterHide }, scopedSlots: L._u([{ key: "trigger", fn: function() {
          return [L.contactsMenuLoading ? ee("NcLoadingIcon") : ee("DotsHorizontal", { staticClass: "icon-more", attrs: { size: 20 } })];
        }, proxy: !0 }], null, !1, 2037777893) }, [ee("NcPopoverMenu", { ref: "popoverMenu", attrs: { menu: L.menu } })], 1) : L._e(), L._v(" "), L.showUserStatusIconOnAvatar ? ee("div", { staticClass: "avatardiv__user-status avatardiv__user-status--icon" }, [L._v(`
		` + L._s(L.userStatus.icon) + `
	`)]) : L.canDisplayUserStatus ? ee("div", { staticClass: "avatardiv__user-status", class: "avatardiv__user-status--" + L.userStatus.status }) : L._e(), L._v(" "), !L.userDoesNotExist || L.iconClass || L.$slots.icon ? L._e() : ee("div", { staticClass: "avatardiv__initials-wrapper", style: L.initialsWrapperStyle }, [ee("div", { staticClass: "unknown", style: L.initialsStyle }, [L._v(`
			` + L._s(L.initials) + `
		`)])])], 2);
      }, [], !1, null, "69f6cb9a", null);
      typeof ae() == "function" && ae()(X);
      const pe = X.exports;
    }, 3905: (o, l, a) => {
      a.d(l, { default: () => Z });
      var c = a(281), T = a(1336);
      const u = { name: "NcEllipsisedOption", components: { NcHighlight: c.default }, props: { name: { type: String, default: "" }, search: { type: String, default: "" } }, computed: { needsTruncate: function() {
        return this.name && this.name.length >= 10;
      }, split: function() {
        return this.name.length - Math.min(Math.floor(this.name.length / 2), 10);
      }, part1: function() {
        return this.needsTruncate ? this.name.slice(0, this.split) : this.name;
      }, part2: function() {
        return this.needsTruncate ? this.name.slice(this.split) : "";
      }, highlight1: function() {
        return this.search ? (0, T.Z)(this.name, this.search) : [];
      }, highlight2: function() {
        var F = this;
        return this.highlight1.map(function(b) {
          return { start: b.start - F.split, end: b.end - F.split };
        });
      } } };
      var d = a(3379), A = a.n(d), f = a(7795), h = a.n(f), S = a(569), p = a.n(S), m = a(3565), g = a.n(m), N = a(9216), R = a.n(N), D = a(4589), v = a.n(D), O = a(436), y = {};
      y.styleTagTransform = v(), y.setAttributes = g(), y.insert = p().bind(null, "head"), y.domAPI = h(), y.insertStyleElement = R(), A()(O.Z, y), O.Z && O.Z.locals && O.Z.locals;
      const Z = (0, a(1900).Z)(u, function() {
        var F = this, b = F._self._c;
        return b("span", { staticClass: "name-parts", attrs: { title: F.name } }, [b("NcHighlight", { staticClass: "name-parts__first", attrs: { text: F.part1, search: F.search, highlight: F.highlight1 } }), F._v(" "), F.part2 ? b("NcHighlight", { staticClass: "name-parts__last", attrs: { text: F.part2, search: F.search, highlight: F.highlight2 } }) : F._e()], 1);
      }, [], !1, null, "3daafbe0", null).exports;
    }, 281: (o, l, a) => {
      a.d(l, { default: () => g });
      var c = a(1336);
      function T(N) {
        return T = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(R) {
          return typeof R;
        } : function(R) {
          return R && typeof Symbol == "function" && R.constructor === Symbol && R !== Symbol.prototype ? "symbol" : typeof R;
        }, T(N);
      }
      function u(N, R) {
        var D = Object.keys(N);
        if (Object.getOwnPropertySymbols) {
          var v = Object.getOwnPropertySymbols(N);
          R && (v = v.filter(function(O) {
            return Object.getOwnPropertyDescriptor(N, O).enumerable;
          })), D.push.apply(D, v);
        }
        return D;
      }
      function d(N) {
        for (var R = 1; R < arguments.length; R++) {
          var D = arguments[R] != null ? arguments[R] : {};
          R % 2 ? u(Object(D), !0).forEach(function(v) {
            A(N, v, D[v]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(N, Object.getOwnPropertyDescriptors(D)) : u(Object(D)).forEach(function(v) {
            Object.defineProperty(N, v, Object.getOwnPropertyDescriptor(D, v));
          });
        }
        return N;
      }
      function A(N, R, D) {
        return (R = function(v) {
          var O = function(y, Z) {
            if (T(y) !== "object" || y === null)
              return y;
            var F = y[Symbol.toPrimitive];
            if (F !== void 0) {
              var b = F.call(y, Z || "default");
              if (T(b) !== "object")
                return b;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return (Z === "string" ? String : Number)(y);
          }(v, "string");
          return T(O) === "symbol" ? O : String(O);
        }(R)) in N ? Object.defineProperty(N, R, { value: D, enumerable: !0, configurable: !0, writable: !0 }) : N[R] = D, N;
      }
      const f = { name: "NcHighlight", props: { text: { type: String, default: "" }, search: { type: String, default: "" }, highlight: { type: Array, default: function() {
        return [];
      } } }, computed: { ranges: function() {
        var N = this, R = [];
        return (this.search || this.highlight.length !== 0) && (R = this.highlight.length > 0 ? this.highlight : (0, c.Z)(this.text, this.search), R.forEach(function(D, v) {
          D.end < D.start && (R[v] = { start: D.end, end: D.start });
        }), R = R.reduce(function(D, v) {
          return v.start < N.text.length && v.end > 0 && D.push({ start: v.start < 0 ? 0 : v.start, end: v.end > N.text.length ? N.text.length : v.end }), D;
        }, []), R.sort(function(D, v) {
          return D.start - v.start;
        }), R = R.reduce(function(D, v) {
          if (D.length) {
            var O = D.length - 1;
            D[O].end >= v.start ? D[O] = { start: D[O].start, end: Math.max(D[O].end, v.end) } : D.push(v);
          } else
            D.push(v);
          return D;
        }, [])), R;
      }, chunks: function() {
        if (this.ranges.length === 0)
          return [{ start: 0, end: this.text.length, highlight: !1, text: this.text }];
        for (var N = [], R = 0, D = 0; R < this.text.length; ) {
          var v = this.ranges[D];
          v.start !== R ? (N.push({ start: R, end: v.start, highlight: !1, text: this.text.slice(R, v.start) }), R = v.start) : (N.push(d(d({}, v), {}, { highlight: !0, text: this.text.slice(v.start, v.end) })), D++, R = v.end, D >= this.ranges.length && R < this.text.length && (N.push({ start: R, end: this.text.length, highlight: !1, text: this.text.slice(R) }), R = this.text.length));
        }
        return N;
      } }, render: function(N) {
        return this.ranges.length ? N("span", {}, this.chunks.map(function(R) {
          return R.highlight ? N("strong", {}, R.text) : R.text;
        })) : N("span", {}, this.text);
      } };
      var h = a(1900), S = a(6274), p = a.n(S), m = (0, h.Z)(f, void 0, void 0, !1, null, null, null);
      typeof p() == "function" && p()(m);
      const g = m.exports;
    }, 7207: (o, l, a) => {
      a.d(l, { default: () => z });
      const c = ZE();
      function T(E) {
        return T = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(C) {
          return typeof C;
        } : function(C) {
          return C && typeof Symbol == "function" && C.constructor === Symbol && C !== Symbol.prototype ? "symbol" : typeof C;
        }, T(E);
      }
      function u() {
        u = function() {
          return E;
        };
        var E = {}, C = Object.prototype, P = C.hasOwnProperty, M = Object.defineProperty || function(oe, te, K) {
          oe[te] = K.value;
        }, Q = typeof Symbol == "function" ? Symbol : {}, H = Q.iterator || "@@iterator", re = Q.asyncIterator || "@@asyncIterator", U = Q.toStringTag || "@@toStringTag";
        function w(oe, te, K) {
          return Object.defineProperty(oe, te, { value: K, enumerable: !0, configurable: !0, writable: !0 }), oe[te];
        }
        try {
          w({}, "");
        } catch {
          w = function(te, K, k) {
            return te[K] = k;
          };
        }
        function W(oe, te, K, k) {
          var B = te && te.prototype instanceof Fe ? te : Fe, j = Object.create(B.prototype), le = new Ge(k || []);
          return M(j, "_invoke", { value: Ae(oe, K, le) }), j;
        }
        function se(oe, te, K) {
          try {
            return { type: "normal", arg: oe.call(te, K) };
          } catch (k) {
            return { type: "throw", arg: k };
          }
        }
        E.wrap = W;
        var ie = {};
        function Fe() {
        }
        function V() {
        }
        function $() {
        }
        var J = {};
        w(J, H, function() {
          return this;
        });
        var ae = Object.getPrototypeOf, X = ae && ae(ae(Ze([])));
        X && X !== C && P.call(X, H) && (J = X);
        var pe = $.prototype = Fe.prototype = Object.create(J);
        function L(oe) {
          ["next", "throw", "return"].forEach(function(te) {
            w(oe, te, function(K) {
              return this._invoke(te, K);
            });
          });
        }
        function ee(oe, te) {
          function K(B, j, le, ce) {
            var De = se(oe[B], oe, j);
            if (De.type !== "throw") {
              var Ye = De.arg, Ue = Ye.value;
              return Ue && T(Ue) == "object" && P.call(Ue, "__await") ? te.resolve(Ue.__await).then(function(G) {
                K("next", G, le, ce);
              }, function(G) {
                K("throw", G, le, ce);
              }) : te.resolve(Ue).then(function(G) {
                Ye.value = G, le(Ye);
              }, function(G) {
                return K("throw", G, le, ce);
              });
            }
            ce(De.arg);
          }
          var k;
          M(this, "_invoke", { value: function(B, j) {
            function le() {
              return new te(function(ce, De) {
                K(B, j, ce, De);
              });
            }
            return k = k ? k.then(le, le) : le();
          } });
        }
        function Ae(oe, te, K) {
          var k = "suspendedStart";
          return function(B, j) {
            if (k === "executing")
              throw new Error("Generator is already running");
            if (k === "completed") {
              if (B === "throw")
                throw j;
              return _e();
            }
            for (K.method = B, K.arg = j; ; ) {
              var le = K.delegate;
              if (le) {
                var ce = Ne(le, K);
                if (ce) {
                  if (ce === ie)
                    continue;
                  return ce;
                }
              }
              if (K.method === "next")
                K.sent = K._sent = K.arg;
              else if (K.method === "throw") {
                if (k === "suspendedStart")
                  throw k = "completed", K.arg;
                K.dispatchException(K.arg);
              } else
                K.method === "return" && K.abrupt("return", K.arg);
              k = "executing";
              var De = se(oe, te, K);
              if (De.type === "normal") {
                if (k = K.done ? "completed" : "suspendedYield", De.arg === ie)
                  continue;
                return { value: De.arg, done: K.done };
              }
              De.type === "throw" && (k = "completed", K.method = "throw", K.arg = De.arg);
            }
          };
        }
        function Ne(oe, te) {
          var K = te.method, k = oe.iterator[K];
          if (k === void 0)
            return te.delegate = null, K === "throw" && oe.iterator.return && (te.method = "return", te.arg = void 0, Ne(oe, te), te.method === "throw") || K !== "return" && (te.method = "throw", te.arg = new TypeError("The iterator does not provide a '" + K + "' method")), ie;
          var B = se(k, oe.iterator, te.arg);
          if (B.type === "throw")
            return te.method = "throw", te.arg = B.arg, te.delegate = null, ie;
          var j = B.arg;
          return j ? j.done ? (te[oe.resultName] = j.value, te.next = oe.nextLoc, te.method !== "return" && (te.method = "next", te.arg = void 0), te.delegate = null, ie) : j : (te.method = "throw", te.arg = new TypeError("iterator result is not an object"), te.delegate = null, ie);
        }
        function ye(oe) {
          var te = { tryLoc: oe[0] };
          1 in oe && (te.catchLoc = oe[1]), 2 in oe && (te.finallyLoc = oe[2], te.afterLoc = oe[3]), this.tryEntries.push(te);
        }
        function be(oe) {
          var te = oe.completion || {};
          te.type = "normal", delete te.arg, oe.completion = te;
        }
        function Ge(oe) {
          this.tryEntries = [{ tryLoc: "root" }], oe.forEach(ye, this), this.reset(!0);
        }
        function Ze(oe) {
          if (oe) {
            var te = oe[H];
            if (te)
              return te.call(oe);
            if (typeof oe.next == "function")
              return oe;
            if (!isNaN(oe.length)) {
              var K = -1, k = function B() {
                for (; ++K < oe.length; )
                  if (P.call(oe, K))
                    return B.value = oe[K], B.done = !1, B;
                return B.value = void 0, B.done = !0, B;
              };
              return k.next = k;
            }
          }
          return { next: _e };
        }
        function _e() {
          return { value: void 0, done: !0 };
        }
        return V.prototype = $, M(pe, "constructor", { value: $, configurable: !0 }), M($, "constructor", { value: V, configurable: !0 }), V.displayName = w($, U, "GeneratorFunction"), E.isGeneratorFunction = function(oe) {
          var te = typeof oe == "function" && oe.constructor;
          return !!te && (te === V || (te.displayName || te.name) === "GeneratorFunction");
        }, E.mark = function(oe) {
          return Object.setPrototypeOf ? Object.setPrototypeOf(oe, $) : (oe.__proto__ = $, w(oe, U, "GeneratorFunction")), oe.prototype = Object.create(pe), oe;
        }, E.awrap = function(oe) {
          return { __await: oe };
        }, L(ee.prototype), w(ee.prototype, re, function() {
          return this;
        }), E.AsyncIterator = ee, E.async = function(oe, te, K, k, B) {
          B === void 0 && (B = Promise);
          var j = new ee(W(oe, te, K, k), B);
          return E.isGeneratorFunction(te) ? j : j.next().then(function(le) {
            return le.done ? le.value : j.next();
          });
        }, L(pe), w(pe, U, "Generator"), w(pe, H, function() {
          return this;
        }), w(pe, "toString", function() {
          return "[object Generator]";
        }), E.keys = function(oe) {
          var te = Object(oe), K = [];
          for (var k in te)
            K.push(k);
          return K.reverse(), function B() {
            for (; K.length; ) {
              var j = K.pop();
              if (j in te)
                return B.value = j, B.done = !1, B;
            }
            return B.done = !0, B;
          };
        }, E.values = Ze, Ge.prototype = { constructor: Ge, reset: function(oe) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(be), !oe)
            for (var te in this)
              te.charAt(0) === "t" && P.call(this, te) && !isNaN(+te.slice(1)) && (this[te] = void 0);
        }, stop: function() {
          this.done = !0;
          var oe = this.tryEntries[0].completion;
          if (oe.type === "throw")
            throw oe.arg;
          return this.rval;
        }, dispatchException: function(oe) {
          if (this.done)
            throw oe;
          var te = this;
          function K(De, Ye) {
            return j.type = "throw", j.arg = oe, te.next = De, Ye && (te.method = "next", te.arg = void 0), !!Ye;
          }
          for (var k = this.tryEntries.length - 1; k >= 0; --k) {
            var B = this.tryEntries[k], j = B.completion;
            if (B.tryLoc === "root")
              return K("end");
            if (B.tryLoc <= this.prev) {
              var le = P.call(B, "catchLoc"), ce = P.call(B, "finallyLoc");
              if (le && ce) {
                if (this.prev < B.catchLoc)
                  return K(B.catchLoc, !0);
                if (this.prev < B.finallyLoc)
                  return K(B.finallyLoc);
              } else if (le) {
                if (this.prev < B.catchLoc)
                  return K(B.catchLoc, !0);
              } else {
                if (!ce)
                  throw new Error("try statement without catch or finally");
                if (this.prev < B.finallyLoc)
                  return K(B.finallyLoc);
              }
            }
          }
        }, abrupt: function(oe, te) {
          for (var K = this.tryEntries.length - 1; K >= 0; --K) {
            var k = this.tryEntries[K];
            if (k.tryLoc <= this.prev && P.call(k, "finallyLoc") && this.prev < k.finallyLoc) {
              var B = k;
              break;
            }
          }
          B && (oe === "break" || oe === "continue") && B.tryLoc <= te && te <= B.finallyLoc && (B = null);
          var j = B ? B.completion : {};
          return j.type = oe, j.arg = te, B ? (this.method = "next", this.next = B.finallyLoc, ie) : this.complete(j);
        }, complete: function(oe, te) {
          if (oe.type === "throw")
            throw oe.arg;
          return oe.type === "break" || oe.type === "continue" ? this.next = oe.arg : oe.type === "return" ? (this.rval = this.arg = oe.arg, this.method = "return", this.next = "end") : oe.type === "normal" && te && (this.next = te), ie;
        }, finish: function(oe) {
          for (var te = this.tryEntries.length - 1; te >= 0; --te) {
            var K = this.tryEntries[te];
            if (K.finallyLoc === oe)
              return this.complete(K.completion, K.afterLoc), be(K), ie;
          }
        }, catch: function(oe) {
          for (var te = this.tryEntries.length - 1; te >= 0; --te) {
            var K = this.tryEntries[te];
            if (K.tryLoc === oe) {
              var k = K.completion;
              if (k.type === "throw") {
                var B = k.arg;
                be(K);
              }
              return B;
            }
          }
          throw new Error("illegal catch attempt");
        }, delegateYield: function(oe, te, K) {
          return this.delegate = { iterator: Ze(oe), resultName: te, nextLoc: K }, this.method === "next" && (this.arg = void 0), ie;
        } }, E;
      }
      function d(E, C, P, M, Q, H, re) {
        try {
          var U = E[H](re), w = U.value;
        } catch (W) {
          return void P(W);
        }
        U.done ? C(w) : Promise.resolve(w).then(M, Q);
      }
      function A(E) {
        return function() {
          var C = this, P = arguments;
          return new Promise(function(M, Q) {
            var H = E.apply(C, P);
            function re(w) {
              d(H, M, Q, re, U, "next", w);
            }
            function U(w) {
              d(H, M, Q, re, U, "throw", w);
            }
            re(void 0);
          });
        };
      }
      const f = { name: "NcIconSvgWrapper", props: { svg: { type: String, default: "" }, title: { type: String, default: "" } }, data: function() {
        return { cleanSvg: "" };
      }, beforeMount: function() {
        var E = this;
        return A(u().mark(function C() {
          return u().wrap(function(P) {
            for (; ; )
              switch (P.prev = P.next) {
                case 0:
                  return P.next = 2, E.sanitizeSVG();
                case 2:
                case "end":
                  return P.stop();
              }
          }, C);
        }))();
      }, methods: { sanitizeSVG: function() {
        var E = this;
        return A(u().mark(function C() {
          return u().wrap(function(P) {
            for (; ; )
              switch (P.prev = P.next) {
                case 0:
                  if (E.svg) {
                    P.next = 2;
                    break;
                  }
                  return P.abrupt("return");
                case 2:
                  return P.next = 4, (0, c.sanitizeSVG)(E.svg);
                case 4:
                  E.cleanSvg = P.sent;
                case 5:
                case "end":
                  return P.stop();
              }
          }, C);
        }))();
      } } };
      var h = a(3379), S = a.n(h), p = a(7795), m = a.n(p), g = a(569), N = a.n(g), R = a(3565), D = a.n(R), v = a(9216), O = a.n(v), y = a(4589), Z = a.n(y), F = a(4180), b = {};
      b.styleTagTransform = Z(), b.setAttributes = D(), b.insert = N().bind(null, "head"), b.domAPI = m(), b.insertStyleElement = O(), S()(F.Z, b), F.Z && F.Z.locals && F.Z.locals;
      var Y = a(1900), I = a(1287), q = a.n(I), _ = (0, Y.Z)(f, function() {
        var E = this;
        return (0, E._self._c)("span", { staticClass: "icon-vue", attrs: { role: "img", "aria-hidden": !E.title, "aria-label": E.title }, domProps: { innerHTML: E._s(E.cleanSvg) } });
      }, [], !1, null, "1b2ab2dd", null);
      typeof q() == "function" && q()(_);
      const z = _.exports;
    }, 7322: (o, l, a) => {
      a.d(l, { default: () => z });
      var c = a(1906), T = a(281), u = a(7207), d = a(3351);
      const A = { name: "NcListItemIcon", components: { NcAvatar: c.default, NcHighlight: T.default, NcIconSvgWrapper: u.default }, mixins: [d.iQ], props: { title: { type: String, required: !0 }, subtitle: { type: String, default: "" }, icon: { type: String, default: "" }, iconSvg: { type: String, default: "" }, iconTitle: { type: String, default: "" }, search: { type: String, default: "" }, avatarSize: { type: Number, default: 32 }, noMargin: { type: Boolean, default: !1 }, displayName: { type: String, default: null }, isNoUser: { type: Boolean, default: !1 }, id: { type: String, default: null } }, data: function() {
        return { margin: 8 };
      }, computed: { hasIcon: function() {
        return this.icon !== "";
      }, hasIconSvg: function() {
        return this.iconSvg !== "";
      }, isValidSubtitle: function() {
        var E, C;
        return ((E = this.subtitle) === null || E === void 0 || (C = E.trim) === null || C === void 0 ? void 0 : C.call(E)) !== "";
      }, isSizeBigEnough: function() {
        return this.avatarSize >= 32;
      }, cssVars: function() {
        var E = this.noMargin ? 0 : this.margin;
        return { "--height": this.avatarSize + 2 * E + "px", "--margin": this.margin + "px" };
      } }, beforeMount: function() {
        this.isNoUser || this.subtitle || this.fetchUserStatus(this.user);
      } }, f = A;
      var h = a(3379), S = a.n(h), p = a(7795), m = a.n(p), g = a(569), N = a.n(g), R = a(3565), D = a.n(R), v = a(9216), O = a.n(v), y = a(4589), Z = a.n(y), F = a(808), b = {};
      b.styleTagTransform = Z(), b.setAttributes = D(), b.insert = N().bind(null, "head"), b.domAPI = m(), b.insertStyleElement = O(), S()(F.Z, b), F.Z && F.Z.locals && F.Z.locals;
      var Y = a(1900), I = a(8488), q = a.n(I), _ = (0, Y.Z)(f, function() {
        var E = this, C = E._self._c;
        return C("span", E._g({ staticClass: "option", style: E.cssVars, attrs: { id: E.id } }, E.$listeners), [C("NcAvatar", E._b({ staticClass: "option__avatar", attrs: { "disable-menu": !0, "disable-tooltip": !0, "display-name": E.displayName || E.title, "is-no-user": E.isNoUser, size: E.avatarSize } }, "NcAvatar", E.$attrs, !1)), E._v(" "), C("div", { staticClass: "option__details" }, [C("NcHighlight", { staticClass: "option__lineone", attrs: { text: E.title, search: E.search } }), E._v(" "), E.isValidSubtitle && E.isSizeBigEnough ? C("NcHighlight", { staticClass: "option__linetwo", attrs: { text: E.subtitle, search: E.search } }) : E.hasStatus ? C("span", [C("span", [E._v(E._s(E.userStatus.icon))]), E._v(" "), C("span", [E._v(E._s(E.userStatus.message))])]) : E._e()], 1), E._v(" "), E._t("default", function() {
          return [E.hasIconSvg ? C("NcIconSvgWrapper", { staticClass: "option__icon", attrs: { svg: E.iconSvg, title: E.iconTitle } }) : E.hasIcon ? C("span", { staticClass: "icon option__icon", class: E.icon, attrs: { "aria-label": E.iconTitle } }) : E._e()];
        })], 2);
      }, [], !1, null, "4f3daf70", null);
      typeof q() == "function" && q()(_);
      const z = _.exports;
    }, 6903: (o, l, a) => {
      a.d(l, { default: () => b });
      const c = { name: "NcLoadingIcon", props: { size: { type: Number, default: 20 }, appearance: { type: String, validator: function(Y) {
        return ["auto", "light", "dark"].includes(Y);
      }, default: "auto" }, title: { type: String, default: "" } }, computed: { colors: function() {
        var Y = ["#777", "#CCC"];
        return this.appearance === "light" ? Y : this.appearance === "dark" ? Y.reverse() : ["var(--color-loading-light)", "var(--color-loading-dark)"];
      } } };
      var T = a(3379), u = a.n(T), d = a(7795), A = a.n(d), f = a(569), h = a.n(f), S = a(3565), p = a.n(S), m = a(9216), g = a.n(m), N = a(4589), R = a.n(N), D = a(5030), v = {};
      v.styleTagTransform = R(), v.setAttributes = p(), v.insert = h().bind(null, "head"), v.domAPI = A(), v.insertStyleElement = g(), u()(D.Z, v), D.Z && D.Z.locals && D.Z.locals;
      var O = a(1900), y = a(9280), Z = a.n(y), F = (0, O.Z)(c, function() {
        var Y = this, I = Y._self._c;
        return I("span", { staticClass: "material-design-icon loading-icon", attrs: { "aria-label": Y.title, role: "img" } }, [I("svg", { attrs: { width: Y.size, height: Y.size, viewBox: "0 0 24 24" } }, [I("path", { attrs: { fill: Y.colors[0], d: "M12,4V2A10,10 0 1,0 22,12H20A8,8 0 1,1 12,4Z" } }), Y._v(" "), I("path", { attrs: { fill: Y.colors[1], d: "M12,4V2A10,10 0 0,1 22,12H20A8,8 0 0,0 12,4Z" } }, [Y.title ? I("title", [Y._v(Y._s(Y.title))]) : Y._e()])])]);
      }, [], !1, null, "c4a9cada", null);
      typeof Z() == "function" && Z()(F);
      const b = F.exports;
    }, 2974: (o, l, a) => {
      a.d(l, { default: () => Q });
      var c = a(3379), T = a.n(c), u = a(7795), d = a.n(u), A = a(569), f = a.n(A), h = a(3565), S = a.n(h), p = a(9216), m = a.n(p), g = a(4589), N = a.n(g), R = a(636), D = {};
      D.styleTagTransform = N(), D.setAttributes = S(), D.insert = f().bind(null, "head"), D.domAPI = d(), D.insertStyleElement = m(), T()(R.Z, D), R.Z && R.Z.locals && R.Z.locals;
      var v = a(3905), O = a(7322), y = a(6903), Z = a(336), F = a(3648);
      const b = xE();
      var Y = a.n(b);
      function I(H) {
        return I = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(re) {
          return typeof re;
        } : function(re) {
          return re && typeof Symbol == "function" && re.constructor === Symbol && re !== Symbol.prototype ? "symbol" : typeof re;
        }, I(H);
      }
      const q = { name: "NcMultiselect", components: { NcEllipsisedOption: v.default, NcListItemIcon: O.default, NcLoadingIcon: y.default, VueMultiselect: Y() }, directives: { tooltip: Z.default }, mixins: [F.Z], inheritAttrs: !1, props: { value: { default: function() {
        return [];
      } }, closeOnSelect: { type: Boolean, default: void 0 }, multiple: { type: Boolean, default: !1 }, limit: { type: Number, default: 99999 }, label: { type: String, default: "" }, trackBy: { type: String, default: "" }, options: { type: Array, required: !0 }, userSelect: { type: Boolean, default: !1 }, loading: { type: Boolean, default: !1 }, autoLimit: { type: Boolean, default: !0 }, tagWidth: { type: Number, default: 150, validator: function(H) {
        return H > 0;
      } } }, emits: ["change", "update:value"], data: function() {
        return { elWidth: 0, ariaExpanded: !1 };
      }, computed: { maxOptions: function() {
        if (this.autoLimit && this.elWidth > 0 && this.tagWidth !== 0) {
          var H = Math.floor(this.elWidth / this.tagWidth);
          return H > 0 ? H : 1;
        }
        return this.limit ? this.limit : 9999;
      }, limitString: function() {
        return "+".concat(this.value.length - this.maxOptions);
      }, localValue: { get: function() {
        return this.trackBy && this.options && I(this.value) !== "object" && this.options[this.value] ? this.options[this.value] : this.value;
      }, set: function(H) {
        this.$emit("update:value", H), this.$emit("change", H);
      } }, willCloseOnSelect: function() {
        return this.closeOnSelect === void 0 ? !this.multiple : this.closeOnSelect;
      } }, watch: { value: function() {
        this.updateWidth();
      } }, mounted: function() {
        this.updateWidth(), window.addEventListener("resize", this.updateWidth);
      }, beforeDestroy: function() {
        window.removeEventListener("resize", this.updateWidth);
      }, methods: { getOptionLabel: function(H) {
        var re;
        return String((re = this.$refs.VueMultiselect) === null || re === void 0 ? void 0 : re.getOptionLabel(H));
      }, formatLimitTitle: function(H) {
        var re = this;
        if (Array.isArray(H) && H.length > 0) {
          var U = H;
          return I(H[0]) === "object" && (U = H.map(function(w) {
            return w[re.label];
          })), U.slice(this.maxOptions).join(", ");
        }
        return "";
      }, updateWidth: function() {
        this.$el && this.$el.querySelector(".multiselect__tags-wrap") && (this.elWidth = this.$el.querySelector(".multiselect__tags-wrap").offsetWidth - 10);
      } } }, _ = q;
      var z = a(1900), E = a(6049), C = a.n(E), P = (0, z.Z)(_, function() {
        var H = this, re = H._self._c;
        return re("VueMultiselect", H._g(H._b({ ref: "VueMultiselect", class: [H.multiple ? "multiselect--multiple" : "multiselect--single"], attrs: { options: H.options, limit: H.maxOptions, loading: H.loading, "aria-expanded": H.ariaExpanded.toString(), "close-on-select": H.willCloseOnSelect, multiple: H.multiple, label: H.label, "track-by": H.trackBy, "tag-placeholder": "create" }, on: { close: function(U) {
          H.ariaExpanded = !1;
        }, open: function(U) {
          H.ariaExpanded = !0;
        } }, scopedSlots: H._u([{ key: "option", fn: function(U) {
          return [H.userSelect && !H.$scopedSlots.option ? re("NcListItemIcon", H._b({ attrs: { title: U.option[H.label], search: U.search } }, "NcListItemIcon", U.option, !1)) : H.$scopedSlots.option ? H._t("option", null, null, U) : re("NcEllipsisedOption", { attrs: { name: H.getOptionLabel(U.option), search: U.search } })];
        } }, H.multiple ? { key: "limit", fn: function() {
          return [re("span", { directives: [{ name: "tooltip", rawName: "v-tooltip.auto", value: H.formatLimitTitle(H.value), expression: "formatLimitTitle(value)", modifiers: { auto: !0 } }], staticClass: "multiselect__limit" }, [H._v(`
			` + H._s(H.limitString) + `
		`)])];
        }, proxy: !0 } : null, H._l(H.$scopedSlots, function(U, w) {
          return { key: w, fn: function(W) {
            return [H._t(w, null, null, W)];
          } };
        }), { key: "noResult", fn: function() {
          return [H._t("noResult", function() {
            return [re("span", [H._v(H._s(H.t("No results")))])];
          })];
        }, proxy: !0 }, { key: "loading", fn: function() {
          return [H.loading ? re("NcLoadingIcon") : H._e()];
        }, proxy: !0 }], null, !0), model: { value: H.localValue, callback: function(U) {
          H.localValue = U;
        }, expression: "localValue" } }, "VueMultiselect", H.$attrs, !1), H.$listeners));
      }, [], !1, null, null, null);
      typeof C() == "function" && C()(P);
      const M = P.exports;
      (0, a(7645).Z)(M);
      const Q = M;
    }, 2963: (o, l, a) => {
      a.d(l, { default: () => P });
      var c = a(9454), T = a(4505), u = a(1206), d = a(5108);
      function A(M) {
        return A = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(Q) {
          return typeof Q;
        } : function(Q) {
          return Q && typeof Symbol == "function" && Q.constructor === Symbol && Q !== Symbol.prototype ? "symbol" : typeof Q;
        }, A(M);
      }
      function f() {
        f = function() {
          return M;
        };
        var M = {}, Q = Object.prototype, H = Q.hasOwnProperty, re = Object.defineProperty || function(k, B, j) {
          k[B] = j.value;
        }, U = typeof Symbol == "function" ? Symbol : {}, w = U.iterator || "@@iterator", W = U.asyncIterator || "@@asyncIterator", se = U.toStringTag || "@@toStringTag";
        function ie(k, B, j) {
          return Object.defineProperty(k, B, { value: j, enumerable: !0, configurable: !0, writable: !0 }), k[B];
        }
        try {
          ie({}, "");
        } catch {
          ie = function(B, j, le) {
            return B[j] = le;
          };
        }
        function Fe(k, B, j, le) {
          var ce = B && B.prototype instanceof J ? B : J, De = Object.create(ce.prototype), Ye = new oe(le || []);
          return re(De, "_invoke", { value: be(k, j, Ye) }), De;
        }
        function V(k, B, j) {
          try {
            return { type: "normal", arg: k.call(B, j) };
          } catch (le) {
            return { type: "throw", arg: le };
          }
        }
        M.wrap = Fe;
        var $ = {};
        function J() {
        }
        function ae() {
        }
        function X() {
        }
        var pe = {};
        ie(pe, w, function() {
          return this;
        });
        var L = Object.getPrototypeOf, ee = L && L(L(te([])));
        ee && ee !== Q && H.call(ee, w) && (pe = ee);
        var Ae = X.prototype = J.prototype = Object.create(pe);
        function Ne(k) {
          ["next", "throw", "return"].forEach(function(B) {
            ie(k, B, function(j) {
              return this._invoke(B, j);
            });
          });
        }
        function ye(k, B) {
          function j(ce, De, Ye, Ue) {
            var G = V(k[ce], k, De);
            if (G.type !== "throw") {
              var ne = G.arg, Ee = ne.value;
              return Ee && A(Ee) == "object" && H.call(Ee, "__await") ? B.resolve(Ee.__await).then(function(Ie) {
                j("next", Ie, Ye, Ue);
              }, function(Ie) {
                j("throw", Ie, Ye, Ue);
              }) : B.resolve(Ee).then(function(Ie) {
                ne.value = Ie, Ye(ne);
              }, function(Ie) {
                return j("throw", Ie, Ye, Ue);
              });
            }
            Ue(G.arg);
          }
          var le;
          re(this, "_invoke", { value: function(ce, De) {
            function Ye() {
              return new B(function(Ue, G) {
                j(ce, De, Ue, G);
              });
            }
            return le = le ? le.then(Ye, Ye) : Ye();
          } });
        }
        function be(k, B, j) {
          var le = "suspendedStart";
          return function(ce, De) {
            if (le === "executing")
              throw new Error("Generator is already running");
            if (le === "completed") {
              if (ce === "throw")
                throw De;
              return K();
            }
            for (j.method = ce, j.arg = De; ; ) {
              var Ye = j.delegate;
              if (Ye) {
                var Ue = Ge(Ye, j);
                if (Ue) {
                  if (Ue === $)
                    continue;
                  return Ue;
                }
              }
              if (j.method === "next")
                j.sent = j._sent = j.arg;
              else if (j.method === "throw") {
                if (le === "suspendedStart")
                  throw le = "completed", j.arg;
                j.dispatchException(j.arg);
              } else
                j.method === "return" && j.abrupt("return", j.arg);
              le = "executing";
              var G = V(k, B, j);
              if (G.type === "normal") {
                if (le = j.done ? "completed" : "suspendedYield", G.arg === $)
                  continue;
                return { value: G.arg, done: j.done };
              }
              G.type === "throw" && (le = "completed", j.method = "throw", j.arg = G.arg);
            }
          };
        }
        function Ge(k, B) {
          var j = B.method, le = k.iterator[j];
          if (le === void 0)
            return B.delegate = null, j === "throw" && k.iterator.return && (B.method = "return", B.arg = void 0, Ge(k, B), B.method === "throw") || j !== "return" && (B.method = "throw", B.arg = new TypeError("The iterator does not provide a '" + j + "' method")), $;
          var ce = V(le, k.iterator, B.arg);
          if (ce.type === "throw")
            return B.method = "throw", B.arg = ce.arg, B.delegate = null, $;
          var De = ce.arg;
          return De ? De.done ? (B[k.resultName] = De.value, B.next = k.nextLoc, B.method !== "return" && (B.method = "next", B.arg = void 0), B.delegate = null, $) : De : (B.method = "throw", B.arg = new TypeError("iterator result is not an object"), B.delegate = null, $);
        }
        function Ze(k) {
          var B = { tryLoc: k[0] };
          1 in k && (B.catchLoc = k[1]), 2 in k && (B.finallyLoc = k[2], B.afterLoc = k[3]), this.tryEntries.push(B);
        }
        function _e(k) {
          var B = k.completion || {};
          B.type = "normal", delete B.arg, k.completion = B;
        }
        function oe(k) {
          this.tryEntries = [{ tryLoc: "root" }], k.forEach(Ze, this), this.reset(!0);
        }
        function te(k) {
          if (k) {
            var B = k[w];
            if (B)
              return B.call(k);
            if (typeof k.next == "function")
              return k;
            if (!isNaN(k.length)) {
              var j = -1, le = function ce() {
                for (; ++j < k.length; )
                  if (H.call(k, j))
                    return ce.value = k[j], ce.done = !1, ce;
                return ce.value = void 0, ce.done = !0, ce;
              };
              return le.next = le;
            }
          }
          return { next: K };
        }
        function K() {
          return { value: void 0, done: !0 };
        }
        return ae.prototype = X, re(Ae, "constructor", { value: X, configurable: !0 }), re(X, "constructor", { value: ae, configurable: !0 }), ae.displayName = ie(X, se, "GeneratorFunction"), M.isGeneratorFunction = function(k) {
          var B = typeof k == "function" && k.constructor;
          return !!B && (B === ae || (B.displayName || B.name) === "GeneratorFunction");
        }, M.mark = function(k) {
          return Object.setPrototypeOf ? Object.setPrototypeOf(k, X) : (k.__proto__ = X, ie(k, se, "GeneratorFunction")), k.prototype = Object.create(Ae), k;
        }, M.awrap = function(k) {
          return { __await: k };
        }, Ne(ye.prototype), ie(ye.prototype, W, function() {
          return this;
        }), M.AsyncIterator = ye, M.async = function(k, B, j, le, ce) {
          ce === void 0 && (ce = Promise);
          var De = new ye(Fe(k, B, j, le), ce);
          return M.isGeneratorFunction(B) ? De : De.next().then(function(Ye) {
            return Ye.done ? Ye.value : De.next();
          });
        }, Ne(Ae), ie(Ae, se, "Generator"), ie(Ae, w, function() {
          return this;
        }), ie(Ae, "toString", function() {
          return "[object Generator]";
        }), M.keys = function(k) {
          var B = Object(k), j = [];
          for (var le in B)
            j.push(le);
          return j.reverse(), function ce() {
            for (; j.length; ) {
              var De = j.pop();
              if (De in B)
                return ce.value = De, ce.done = !1, ce;
            }
            return ce.done = !0, ce;
          };
        }, M.values = te, oe.prototype = { constructor: oe, reset: function(k) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(_e), !k)
            for (var B in this)
              B.charAt(0) === "t" && H.call(this, B) && !isNaN(+B.slice(1)) && (this[B] = void 0);
        }, stop: function() {
          this.done = !0;
          var k = this.tryEntries[0].completion;
          if (k.type === "throw")
            throw k.arg;
          return this.rval;
        }, dispatchException: function(k) {
          if (this.done)
            throw k;
          var B = this;
          function j(G, ne) {
            return De.type = "throw", De.arg = k, B.next = G, ne && (B.method = "next", B.arg = void 0), !!ne;
          }
          for (var le = this.tryEntries.length - 1; le >= 0; --le) {
            var ce = this.tryEntries[le], De = ce.completion;
            if (ce.tryLoc === "root")
              return j("end");
            if (ce.tryLoc <= this.prev) {
              var Ye = H.call(ce, "catchLoc"), Ue = H.call(ce, "finallyLoc");
              if (Ye && Ue) {
                if (this.prev < ce.catchLoc)
                  return j(ce.catchLoc, !0);
                if (this.prev < ce.finallyLoc)
                  return j(ce.finallyLoc);
              } else if (Ye) {
                if (this.prev < ce.catchLoc)
                  return j(ce.catchLoc, !0);
              } else {
                if (!Ue)
                  throw new Error("try statement without catch or finally");
                if (this.prev < ce.finallyLoc)
                  return j(ce.finallyLoc);
              }
            }
          }
        }, abrupt: function(k, B) {
          for (var j = this.tryEntries.length - 1; j >= 0; --j) {
            var le = this.tryEntries[j];
            if (le.tryLoc <= this.prev && H.call(le, "finallyLoc") && this.prev < le.finallyLoc) {
              var ce = le;
              break;
            }
          }
          ce && (k === "break" || k === "continue") && ce.tryLoc <= B && B <= ce.finallyLoc && (ce = null);
          var De = ce ? ce.completion : {};
          return De.type = k, De.arg = B, ce ? (this.method = "next", this.next = ce.finallyLoc, $) : this.complete(De);
        }, complete: function(k, B) {
          if (k.type === "throw")
            throw k.arg;
          return k.type === "break" || k.type === "continue" ? this.next = k.arg : k.type === "return" ? (this.rval = this.arg = k.arg, this.method = "return", this.next = "end") : k.type === "normal" && B && (this.next = B), $;
        }, finish: function(k) {
          for (var B = this.tryEntries.length - 1; B >= 0; --B) {
            var j = this.tryEntries[B];
            if (j.finallyLoc === k)
              return this.complete(j.completion, j.afterLoc), _e(j), $;
          }
        }, catch: function(k) {
          for (var B = this.tryEntries.length - 1; B >= 0; --B) {
            var j = this.tryEntries[B];
            if (j.tryLoc === k) {
              var le = j.completion;
              if (le.type === "throw") {
                var ce = le.arg;
                _e(j);
              }
              return ce;
            }
          }
          throw new Error("illegal catch attempt");
        }, delegateYield: function(k, B, j) {
          return this.delegate = { iterator: te(k), resultName: B, nextLoc: j }, this.method === "next" && (this.arg = void 0), $;
        } }, M;
      }
      function h(M, Q, H, re, U, w, W) {
        try {
          var se = M[w](W), ie = se.value;
        } catch (Fe) {
          return void H(Fe);
        }
        se.done ? Q(ie) : Promise.resolve(ie).then(re, U);
      }
      const S = { name: "NcPopover", components: { Dropdown: c.Dropdown }, props: { popoverBaseClass: { type: String, default: "" }, focusTrap: { type: Boolean, default: !0 }, setReturnFocus: { required: !1 } }, emits: ["after-show", "after-hide"], beforeDestroy: function() {
        this.clearFocusTrap();
      }, methods: { useFocusTrap: function() {
        var M, Q = this;
        return (M = f().mark(function H() {
          var re, U, w;
          return f().wrap(function(W) {
            for (; ; )
              switch (W.prev = W.next) {
                case 0:
                  return W.next = 2, Q.$nextTick();
                case 2:
                  if (Q.focusTrap) {
                    W.next = 4;
                    break;
                  }
                  return W.abrupt("return");
                case 4:
                  if (w = (re = Q.$refs.popover) === null || re === void 0 || (U = re.$refs.popperContent) === null || U === void 0 ? void 0 : U.$el) {
                    W.next = 7;
                    break;
                  }
                  return W.abrupt("return");
                case 7:
                  Q.$focusTrap = (0, T.createFocusTrap)(w, { escapeDeactivates: !1, allowOutsideClick: !0, setReturnFocus: Q.setReturnFocus, trapStack: (0, u.L)() }), Q.$focusTrap.activate();
                case 9:
                case "end":
                  return W.stop();
              }
          }, H);
        }), function() {
          var H = this, re = arguments;
          return new Promise(function(U, w) {
            var W = M.apply(H, re);
            function se(Fe) {
              h(W, U, w, se, ie, "next", Fe);
            }
            function ie(Fe) {
              h(W, U, w, se, ie, "throw", Fe);
            }
            se(void 0);
          });
        })();
      }, clearFocusTrap: function() {
        var M = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        try {
          var Q;
          (Q = this.$focusTrap) === null || Q === void 0 || Q.deactivate(M), this.$focusTrap = null;
        } catch (H) {
          d.warn(H);
        }
      }, afterShow: function() {
        var M = this;
        this.$nextTick(function() {
          M.$emit("after-show"), M.useFocusTrap();
        });
      }, afterHide: function() {
        this.$emit("after-hide"), this.clearFocusTrap();
      } } }, p = S;
      var m = a(3379), g = a.n(m), N = a(7795), R = a.n(N), D = a(569), v = a.n(D), O = a(3565), y = a.n(O), Z = a(9216), F = a.n(Z), b = a(4589), Y = a.n(b), I = a(978), q = {};
      q.styleTagTransform = Y(), q.setAttributes = y(), q.insert = v().bind(null, "head"), q.domAPI = R(), q.insertStyleElement = F(), g()(I.Z, q), I.Z && I.Z.locals && I.Z.locals;
      var _ = a(1900), z = a(2405), E = a.n(z), C = (0, _.Z)(p, function() {
        var M = this;
        return (0, M._self._c)("Dropdown", M._g(M._b({ ref: "popover", attrs: { distance: 10, "arrow-padding": 10, "no-auto-focus": !0, "popper-class": M.popoverBaseClass }, on: { "apply-show": M.afterShow, "apply-hide": M.afterHide }, scopedSlots: M._u([{ key: "popper", fn: function() {
          return [M._t("default")];
        }, proxy: !0 }], null, !0) }, "Dropdown", M.$attrs, !1), M.$listeners), [M._t("trigger")], 2);
      }, [], !1, null, null, null);
      typeof E() == "function" && E()(C);
      const P = C.exports;
    }, 1215: (o, l, a) => {
      a.d(l, { default: () => z });
      const c = { name: "NcPopoverMenuItem", props: { item: { type: Object, required: !0, default: function() {
        return { key: "nextcloud-link", href: "https://nextcloud.com", icon: "icon-links", text: "Nextcloud" };
      }, validator: function(E) {
        return !E.input || ["text", "checkbox"].indexOf(E.input) !== -1;
      } } }, computed: { key: function() {
        return this.item.key ? this.item.key : Math.round(16 * Math.random() * 1e6).toString(16);
      }, iconIsUrl: function() {
        try {
          return new URL(this.item.icon), !0;
        } catch {
          return !1;
        }
      } }, methods: { action: function(E) {
        this.item.action && this.item.action(E);
      } } };
      var T = a(3379), u = a.n(T), d = a(7795), A = a.n(d), f = a(569), h = a.n(f), S = a(3565), p = a.n(S), m = a(9216), g = a.n(m), N = a(4589), R = a.n(N), D = a(5578), v = {};
      v.styleTagTransform = R(), v.setAttributes = p(), v.insert = h().bind(null, "head"), v.domAPI = A(), v.insertStyleElement = g(), u()(D.Z, v), D.Z && D.Z.locals && D.Z.locals;
      var O = a(5772), y = {};
      y.styleTagTransform = R(), y.setAttributes = p(), y.insert = h().bind(null, "head"), y.domAPI = A(), y.insertStyleElement = g(), u()(O.Z, y), O.Z && O.Z.locals && O.Z.locals;
      var Z = a(1900);
      const F = { name: "NcPopoverMenu", components: { NcPopoverMenuItem: (0, Z.Z)(c, function() {
        var E = this, C = E._self._c;
        return C("li", { staticClass: "popover__menuitem" }, [E.item.href ? C("a", { staticClass: "focusable", attrs: { href: E.item.href ? E.item.href : "#", target: E.item.target ? E.item.target : "", download: E.item.download, rel: "nofollow noreferrer noopener" }, on: { click: E.action } }, [E.iconIsUrl ? C("img", { attrs: { src: E.item.icon } }) : C("span", { class: E.item.icon }), E._v(" "), E.item.text && E.item.longtext ? C("p", [C("strong", { staticClass: "menuitem-text" }, [E._v(`
				` + E._s(E.item.text) + `
			`)]), C("br"), E._v(" "), C("span", { staticClass: "menuitem-text-detail" }, [E._v(`
				` + E._s(E.item.longtext) + `
			`)])]) : E.item.text ? C("span", [E._v(`
			` + E._s(E.item.text) + `
		`)]) : E.item.longtext ? C("p", [E._v(`
			` + E._s(E.item.longtext) + `
		`)]) : E._e()]) : E.item.input ? C("span", { staticClass: "menuitem", class: { active: E.item.active } }, [E.item.input !== "checkbox" ? C("span", { class: E.item.icon }) : E._e(), E._v(" "), E.item.input === "text" ? C("form", { class: E.item.input, on: { submit: function(P) {
          return P.preventDefault(), E.item.action.apply(null, arguments);
        } } }, [C("input", { attrs: { type: E.item.input, placeholder: E.item.text, required: "" }, domProps: { value: E.item.value } }), E._v(" "), C("input", { staticClass: "icon-confirm", attrs: { type: "submit", value: "" } })]) : [E.item.input === "checkbox" ? C("input", { directives: [{ name: "model", rawName: "v-model", value: E.item.model, expression: "item.model" }], class: E.item.input, attrs: { id: E.key, type: "checkbox" }, domProps: { checked: Array.isArray(E.item.model) ? E._i(E.item.model, null) > -1 : E.item.model }, on: { change: [function(P) {
          var M = E.item.model, Q = P.target, H = !!Q.checked;
          if (Array.isArray(M)) {
            var re = E._i(M, null);
            Q.checked ? re < 0 && E.$set(E.item, "model", M.concat([null])) : re > -1 && E.$set(E.item, "model", M.slice(0, re).concat(M.slice(re + 1)));
          } else
            E.$set(E.item, "model", H);
        }, E.item.action] } }) : E.item.input === "radio" ? C("input", { directives: [{ name: "model", rawName: "v-model", value: E.item.model, expression: "item.model" }], class: E.item.input, attrs: { id: E.key, type: "radio" }, domProps: { checked: E._q(E.item.model, null) }, on: { change: [function(P) {
          return E.$set(E.item, "model", null);
        }, E.item.action] } }) : C("input", { directives: [{ name: "model", rawName: "v-model", value: E.item.model, expression: "item.model" }], class: E.item.input, attrs: { id: E.key, type: E.item.input }, domProps: { value: E.item.model }, on: { change: E.item.action, input: function(P) {
          P.target.composing || E.$set(E.item, "model", P.target.value);
        } } }), E._v(" "), C("label", { attrs: { for: E.key }, on: { click: function(P) {
          return P.stopPropagation(), P.preventDefault(), E.item.action.apply(null, arguments);
        } } }, [E._v(`
				` + E._s(E.item.text) + `
			`)])]], 2) : E.item.action ? C("button", { staticClass: "menuitem focusable", class: { active: E.item.active }, attrs: { disabled: E.item.disabled, type: "button" }, on: { click: function(P) {
          return P.stopPropagation(), P.preventDefault(), E.item.action.apply(null, arguments);
        } } }, [C("span", { class: E.item.icon }), E._v(" "), E.item.text && E.item.longtext ? C("p", [C("strong", { staticClass: "menuitem-text" }, [E._v(`
				` + E._s(E.item.text) + `
			`)]), C("br"), E._v(" "), C("span", { staticClass: "menuitem-text-detail" }, [E._v(`
				` + E._s(E.item.longtext) + `
			`)])]) : E.item.text ? C("span", [E._v(`
			` + E._s(E.item.text) + `
		`)]) : E.item.longtext ? C("p", [E._v(`
			` + E._s(E.item.longtext) + `
		`)]) : E._e()]) : C("span", { staticClass: "menuitem", class: { active: E.item.active } }, [C("span", { class: E.item.icon }), E._v(" "), E.item.text && E.item.longtext ? C("p", [C("strong", { staticClass: "menuitem-text" }, [E._v(`
				` + E._s(E.item.text) + `
			`)]), C("br"), E._v(" "), C("span", { staticClass: "menuitem-text-detail" }, [E._v(`
				` + E._s(E.item.longtext) + `
			`)])]) : E.item.text ? C("span", [E._v(`
			` + E._s(E.item.text) + `
		`)]) : E.item.longtext ? C("p", [E._v(`
			` + E._s(E.item.longtext) + `
		`)]) : E._e()])]);
      }, [], !1, null, "0ce1cbf1", null).exports }, props: { menu: { type: Array, default: function() {
        return [{ href: "https://nextcloud.com", icon: "icon-links", text: "Nextcloud" }];
      }, required: !0 } } };
      var b = a(2), Y = {};
      Y.styleTagTransform = R(), Y.setAttributes = p(), Y.insert = h().bind(null, "head"), Y.domAPI = A(), Y.insertStyleElement = g(), u()(b.Z, Y), b.Z && b.Z.locals && b.Z.locals;
      var I = a(1174), q = a.n(I), _ = (0, Z.Z)(F, function() {
        var E = this, C = E._self._c;
        return C("ul", { staticClass: "popover__menu" }, E._l(E.menu, function(P, M) {
          return C("NcPopoverMenuItem", { key: M, attrs: { item: P } });
        }), 1);
      }, [], !1, null, "31ffd2d4", null);
      typeof q() == "function" && q()(_);
      const z = _.exports;
    }, 1651: (o, l, a) => {
      a.d(l, { default: () => U });
      var c = a(932);
      function T(w, W) {
        var se = typeof Symbol < "u" && w[Symbol.iterator] || w["@@iterator"];
        if (!se) {
          if (Array.isArray(w) || (se = function(ae, X) {
            if (ae) {
              if (typeof ae == "string")
                return u(ae, X);
              var pe = Object.prototype.toString.call(ae).slice(8, -1);
              if (pe === "Object" && ae.constructor && (pe = ae.constructor.name), pe === "Map" || pe === "Set")
                return Array.from(ae);
              if (pe === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(pe))
                return u(ae, X);
            }
          }(w)) || W && w && typeof w.length == "number") {
            se && (w = se);
            var ie = 0, Fe = function() {
            };
            return { s: Fe, n: function() {
              return ie >= w.length ? { done: !0 } : { done: !1, value: w[ie++] };
            }, e: function(ae) {
              throw ae;
            }, f: Fe };
          }
          throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
        }
        var V, $ = !0, J = !1;
        return { s: function() {
          se = se.call(w);
        }, n: function() {
          var ae = se.next();
          return $ = ae.done, ae;
        }, e: function(ae) {
          J = !0, V = ae;
        }, f: function() {
          try {
            $ || se.return == null || se.return();
          } finally {
            if (J)
              throw V;
          }
        } };
      }
      function u(w, W) {
        (W == null || W > w.length) && (W = w.length);
        for (var se = 0, ie = new Array(W); se < W; se++)
          ie[se] = w[se];
        return ie;
      }
      function d(w) {
        return w.split("_").join(" ").replace("St ", "St. ").split("/").join(" - ");
      }
      const A = JSON.parse('{"i8":"2.2019c","j3":{"AUS Central Standard Time":{"aliasTo":"Australia/Darwin"},"AUS Eastern Standard Time":{"aliasTo":"Australia/Sydney"},"Afghanistan Standard Time":{"aliasTo":"Asia/Kabul"},"Africa/Asmera":{"aliasTo":"Africa/Asmara"},"Africa/Timbuktu":{"aliasTo":"Africa/Bamako"},"Alaskan Standard Time":{"aliasTo":"America/Anchorage"},"America/Argentina/ComodRivadavia":{"aliasTo":"America/Argentina/Catamarca"},"America/Buenos_Aires":{"aliasTo":"America/Argentina/Buenos_Aires"},"America/Louisville":{"aliasTo":"America/Kentucky/Louisville"},"America/Montreal":{"aliasTo":"America/Toronto"},"America/Santa_Isabel":{"aliasTo":"America/Tijuana"},"Arab Standard Time":{"aliasTo":"Asia/Riyadh"},"Arabian Standard Time":{"aliasTo":"Asia/Dubai"},"Arabic Standard Time":{"aliasTo":"Asia/Baghdad"},"Argentina Standard Time":{"aliasTo":"America/Argentina/Buenos_Aires"},"Asia/Calcutta":{"aliasTo":"Asia/Kolkata"},"Asia/Katmandu":{"aliasTo":"Asia/Kathmandu"},"Asia/Rangoon":{"aliasTo":"Asia/Yangon"},"Asia/Saigon":{"aliasTo":"Asia/Ho_Chi_Minh"},"Atlantic Standard Time":{"aliasTo":"America/Halifax"},"Atlantic/Faeroe":{"aliasTo":"Atlantic/Faroe"},"Atlantic/Jan_Mayen":{"aliasTo":"Europe/Oslo"},"Azerbaijan Standard Time":{"aliasTo":"Asia/Baku"},"Azores Standard Time":{"aliasTo":"Atlantic/Azores"},"Bahia Standard Time":{"aliasTo":"America/Bahia"},"Bangladesh Standard Time":{"aliasTo":"Asia/Dhaka"},"Belarus Standard Time":{"aliasTo":"Europe/Minsk"},"Canada Central Standard Time":{"aliasTo":"America/Regina"},"Cape Verde Standard Time":{"aliasTo":"Atlantic/Cape_Verde"},"Caucasus Standard Time":{"aliasTo":"Asia/Yerevan"},"Cen. Australia Standard Time":{"aliasTo":"Australia/Adelaide"},"Central America Standard Time":{"aliasTo":"America/Guatemala"},"Central Asia Standard Time":{"aliasTo":"Asia/Almaty"},"Central Brazilian Standard Time":{"aliasTo":"America/Cuiaba"},"Central Europe Standard Time":{"aliasTo":"Europe/Budapest"},"Central European Standard Time":{"aliasTo":"Europe/Warsaw"},"Central Pacific Standard Time":{"aliasTo":"Pacific/Guadalcanal"},"Central Standard Time":{"aliasTo":"America/Chicago"},"Central Standard Time (Mexico)":{"aliasTo":"America/Mexico_City"},"China Standard Time":{"aliasTo":"Asia/Shanghai"},"E. Africa Standard Time":{"aliasTo":"Africa/Nairobi"},"E. Australia Standard Time":{"aliasTo":"Australia/Brisbane"},"E. South America Standard Time":{"aliasTo":"America/Sao_Paulo"},"Eastern Standard Time":{"aliasTo":"America/New_York"},"Egypt Standard Time":{"aliasTo":"Africa/Cairo"},"Ekaterinburg Standard Time":{"aliasTo":"Asia/Yekaterinburg"},"Etc/GMT":{"aliasTo":"UTC"},"Etc/GMT+0":{"aliasTo":"UTC"},"Etc/UCT":{"aliasTo":"UTC"},"Etc/UTC":{"aliasTo":"UTC"},"Etc/Unversal":{"aliasTo":"UTC"},"Etc/Zulu":{"aliasTo":"UTC"},"Europe/Belfast":{"aliasTo":"Europe/London"},"FLE Standard Time":{"aliasTo":"Europe/Kiev"},"Fiji Standard Time":{"aliasTo":"Pacific/Fiji"},"GMT":{"aliasTo":"UTC"},"GMT Standard Time":{"aliasTo":"Europe/London"},"GMT+0":{"aliasTo":"UTC"},"GMT0":{"aliasTo":"UTC"},"GTB Standard Time":{"aliasTo":"Europe/Bucharest"},"Georgian Standard Time":{"aliasTo":"Asia/Tbilisi"},"Greenland Standard Time":{"aliasTo":"America/Godthab"},"Greenwich":{"aliasTo":"UTC"},"Greenwich Standard Time":{"aliasTo":"Atlantic/Reykjavik"},"Hawaiian Standard Time":{"aliasTo":"Pacific/Honolulu"},"India Standard Time":{"aliasTo":"Asia/Calcutta"},"Iran Standard Time":{"aliasTo":"Asia/Tehran"},"Israel Standard Time":{"aliasTo":"Asia/Jerusalem"},"Jordan Standard Time":{"aliasTo":"Asia/Amman"},"Kaliningrad Standard Time":{"aliasTo":"Europe/Kaliningrad"},"Korea Standard Time":{"aliasTo":"Asia/Seoul"},"Libya Standard Time":{"aliasTo":"Africa/Tripoli"},"Line Islands Standard Time":{"aliasTo":"Pacific/Kiritimati"},"Magadan Standard Time":{"aliasTo":"Asia/Magadan"},"Mauritius Standard Time":{"aliasTo":"Indian/Mauritius"},"Middle East Standard Time":{"aliasTo":"Asia/Beirut"},"Montevideo Standard Time":{"aliasTo":"America/Montevideo"},"Morocco Standard Time":{"aliasTo":"Africa/Casablanca"},"Mountain Standard Time":{"aliasTo":"America/Denver"},"Mountain Standard Time (Mexico)":{"aliasTo":"America/Chihuahua"},"Myanmar Standard Time":{"aliasTo":"Asia/Rangoon"},"N. Central Asia Standard Time":{"aliasTo":"Asia/Novosibirsk"},"Namibia Standard Time":{"aliasTo":"Africa/Windhoek"},"Nepal Standard Time":{"aliasTo":"Asia/Katmandu"},"New Zealand Standard Time":{"aliasTo":"Pacific/Auckland"},"Newfoundland Standard Time":{"aliasTo":"America/St_Johns"},"North Asia East Standard Time":{"aliasTo":"Asia/Irkutsk"},"North Asia Standard Time":{"aliasTo":"Asia/Krasnoyarsk"},"Pacific SA Standard Time":{"aliasTo":"America/Santiago"},"Pacific Standard Time":{"aliasTo":"America/Los_Angeles"},"Pacific Standard Time (Mexico)":{"aliasTo":"America/Santa_Isabel"},"Pacific/Johnston":{"aliasTo":"Pacific/Honolulu"},"Pakistan Standard Time":{"aliasTo":"Asia/Karachi"},"Paraguay Standard Time":{"aliasTo":"America/Asuncion"},"Romance Standard Time":{"aliasTo":"Europe/Paris"},"Russia Time Zone 10":{"aliasTo":"Asia/Srednekolymsk"},"Russia Time Zone 11":{"aliasTo":"Asia/Kamchatka"},"Russia Time Zone 3":{"aliasTo":"Europe/Samara"},"Russian Standard Time":{"aliasTo":"Europe/Moscow"},"SA Eastern Standard Time":{"aliasTo":"America/Cayenne"},"SA Pacific Standard Time":{"aliasTo":"America/Bogota"},"SA Western Standard Time":{"aliasTo":"America/La_Paz"},"SE Asia Standard Time":{"aliasTo":"Asia/Bangkok"},"Samoa Standard Time":{"aliasTo":"Pacific/Apia"},"Singapore Standard Time":{"aliasTo":"Asia/Singapore"},"South Africa Standard Time":{"aliasTo":"Africa/Johannesburg"},"Sri Lanka Standard Time":{"aliasTo":"Asia/Colombo"},"Syria Standard Time":{"aliasTo":"Asia/Damascus"},"Taipei Standard Time":{"aliasTo":"Asia/Taipei"},"Tasmania Standard Time":{"aliasTo":"Australia/Hobart"},"Tokyo Standard Time":{"aliasTo":"Asia/Tokyo"},"Tonga Standard Time":{"aliasTo":"Pacific/Tongatapu"},"Turkey Standard Time":{"aliasTo":"Europe/Istanbul"},"UCT":{"aliasTo":"UTC"},"US Eastern Standard Time":{"aliasTo":"America/Indiana/Indianapolis"},"US Mountain Standard Time":{"aliasTo":"America/Phoenix"},"US/Central":{"aliasTo":"America/Chicago"},"US/Eastern":{"aliasTo":"America/New_York"},"US/Mountain":{"aliasTo":"America/Denver"},"US/Pacific":{"aliasTo":"America/Los_Angeles"},"US/Pacific-New":{"aliasTo":"America/Los_Angeles"},"Ulaanbaatar Standard Time":{"aliasTo":"Asia/Ulaanbaatar"},"Universal":{"aliasTo":"UTC"},"Venezuela Standard Time":{"aliasTo":"America/Caracas"},"Vladivostok Standard Time":{"aliasTo":"Asia/Vladivostok"},"W. Australia Standard Time":{"aliasTo":"Australia/Perth"},"W. Central Africa Standard Time":{"aliasTo":"Africa/Lagos"},"W. Europe Standard Time":{"aliasTo":"Europe/Berlin"},"West Asia Standard Time":{"aliasTo":"Asia/Tashkent"},"West Pacific Standard Time":{"aliasTo":"Pacific/Port_Moresby"},"Yakutsk Standard Time":{"aliasTo":"Asia/Yakutsk"},"Z":{"aliasTo":"UTC"},"Zulu":{"aliasTo":"UTC"},"utc":{"aliasTo":"UTC"}},"Ao":{"Africa/Abidjan":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0000\\r\\nTZOFFSETTO:+0000\\r\\nTZNAME:GMT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0051900","longitude":"-0040200"},"Africa/Accra":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0000\\r\\nTZOFFSETTO:+0000\\r\\nTZNAME:GMT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0053300","longitude":"+0001300"},"Africa/Addis_Ababa":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0300\\r\\nTZOFFSETTO:+0300\\r\\nTZNAME:EAT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0090200","longitude":"+0384200"},"Africa/Algiers":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:CET\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0364700","longitude":"+0030300"},"Africa/Asmara":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0300\\r\\nTZOFFSETTO:+0300\\r\\nTZNAME:EAT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0152000","longitude":"+0385300"},"Africa/Bamako":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0000\\r\\nTZOFFSETTO:+0000\\r\\nTZNAME:GMT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0123900","longitude":"-0080000"},"Africa/Bangui":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:WAT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0042200","longitude":"+0183500"},"Africa/Banjul":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0000\\r\\nTZOFFSETTO:+0000\\r\\nTZNAME:GMT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0132800","longitude":"-0163900"},"Africa/Bissau":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0000\\r\\nTZOFFSETTO:+0000\\r\\nTZNAME:GMT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0115100","longitude":"-0153500"},"Africa/Blantyre":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:CAT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0154700","longitude":"+0350000"},"Africa/Brazzaville":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:WAT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0041600","longitude":"+0151700"},"Africa/Bujumbura":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:CAT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0032300","longitude":"+0292200"},"Africa/Cairo":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:EET\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0300300","longitude":"+0311500"},"Africa/Casablanca":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0000\\r\\nTZOFFSETTO:+0000\\r\\nTZNAME:+00\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD","BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0000\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:+01\\r\\nDTSTART:20180325T020000\\r\\nRDATE:20180325T020000\\r\\nRDATE:20180617T020000\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0000\\r\\nTZNAME:+00\\r\\nDTSTART:20180513T030000\\r\\nRDATE:20180513T030000\\r\\nEND:STANDARD","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0000\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:+01\\r\\nDTSTART:20190609T020000\\r\\nRDATE:20190609T020000\\r\\nRDATE:20200524T020000\\r\\nRDATE:20210516T020000\\r\\nRDATE:20220508T020000\\r\\nEND:STANDARD","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:+01\\r\\nDTSTART:20181028T030000\\r\\nRDATE:20181028T030000\\r\\nEND:STANDARD","BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0000\\r\\nTZNAME:+00\\r\\nDTSTART:20190505T030000\\r\\nRDATE:20190505T030000\\r\\nRDATE:20200419T030000\\r\\nRDATE:20210411T030000\\r\\nRDATE:20220327T030000\\r\\nEND:DAYLIGHT"],"latitude":"+0333900","longitude":"-0073500"},"Africa/Ceuta":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:CEST\\r\\nDTSTART:19700329T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:CET\\r\\nDTSTART:19701025T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0355300","longitude":"-0051900"},"Africa/Conakry":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0000\\r\\nTZOFFSETTO:+0000\\r\\nTZNAME:GMT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0093100","longitude":"-0134300"},"Africa/Dakar":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0000\\r\\nTZOFFSETTO:+0000\\r\\nTZNAME:GMT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0144000","longitude":"-0172600"},"Africa/Dar_es_Salaam":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0300\\r\\nTZOFFSETTO:+0300\\r\\nTZNAME:EAT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0064800","longitude":"+0391700"},"Africa/Djibouti":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0300\\r\\nTZOFFSETTO:+0300\\r\\nTZNAME:EAT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0113600","longitude":"+0430900"},"Africa/Douala":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:WAT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0040300","longitude":"+0094200"},"Africa/El_Aaiun":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0100\\r\\nTZOFFSETTO:+0000\\r\\nTZNAME:+00\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD","BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0000\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:+01\\r\\nDTSTART:20180325T020000\\r\\nRDATE:20180325T020000\\r\\nRDATE:20180617T020000\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0000\\r\\nTZNAME:+00\\r\\nDTSTART:20180513T030000\\r\\nRDATE:20180513T030000\\r\\nEND:STANDARD","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:+01\\r\\nDTSTART:20181028T030000\\r\\nRDATE:20181028T030000\\r\\nEND:STANDARD","BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0000\\r\\nTZNAME:+00\\r\\nDTSTART:20190505T030000\\r\\nRDATE:20190505T030000\\r\\nRDATE:20200419T030000\\r\\nRDATE:20210411T030000\\r\\nRDATE:20220327T030000\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0000\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:+01\\r\\nDTSTART:20190609T020000\\r\\nRDATE:20190609T020000\\r\\nRDATE:20200524T020000\\r\\nRDATE:20210516T020000\\r\\nRDATE:20220508T020000\\r\\nEND:STANDARD"],"latitude":"+0270900","longitude":"-0131200"},"Africa/Freetown":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0000\\r\\nTZOFFSETTO:+0000\\r\\nTZNAME:GMT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0083000","longitude":"-0131500"},"Africa/Gaborone":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:CAT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0243900","longitude":"+0255500"},"Africa/Harare":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:CAT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0175000","longitude":"+0310300"},"Africa/Johannesburg":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:SAST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0261500","longitude":"+0280000"},"Africa/Juba":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0300\\r\\nTZOFFSETTO:+0300\\r\\nTZNAME:EAT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0045100","longitude":"+0313700"},"Africa/Kampala":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0300\\r\\nTZOFFSETTO:+0300\\r\\nTZNAME:EAT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0001900","longitude":"+0322500"},"Africa/Khartoum":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:CAT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0153600","longitude":"+0323200"},"Africa/Kigali":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:CAT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0015700","longitude":"+0300400"},"Africa/Kinshasa":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:WAT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0041800","longitude":"+0151800"},"Africa/Lagos":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:WAT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0062700","longitude":"+0032400"},"Africa/Libreville":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:WAT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0002300","longitude":"+0092700"},"Africa/Lome":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0000\\r\\nTZOFFSETTO:+0000\\r\\nTZNAME:GMT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0060800","longitude":"+0011300"},"Africa/Luanda":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:WAT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0084800","longitude":"+0131400"},"Africa/Lubumbashi":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:CAT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0114000","longitude":"+0272800"},"Africa/Lusaka":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:CAT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0152500","longitude":"+0281700"},"Africa/Malabo":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:WAT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0034500","longitude":"+0084700"},"Africa/Maputo":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:CAT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0255800","longitude":"+0323500"},"Africa/Maseru":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:SAST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0292800","longitude":"+0273000"},"Africa/Mbabane":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:SAST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0261800","longitude":"+0310600"},"Africa/Mogadishu":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0300\\r\\nTZOFFSETTO:+0300\\r\\nTZNAME:EAT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0020400","longitude":"+0452200"},"Africa/Monrovia":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0000\\r\\nTZOFFSETTO:+0000\\r\\nTZNAME:GMT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0061800","longitude":"-0104700"},"Africa/Nairobi":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0300\\r\\nTZOFFSETTO:+0300\\r\\nTZNAME:EAT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0011700","longitude":"+0364900"},"Africa/Ndjamena":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:WAT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0120700","longitude":"+0150300"},"Africa/Niamey":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:WAT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0133100","longitude":"+0020700"},"Africa/Nouakchott":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0000\\r\\nTZOFFSETTO:+0000\\r\\nTZNAME:GMT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0180600","longitude":"-0155700"},"Africa/Ouagadougou":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0000\\r\\nTZOFFSETTO:+0000\\r\\nTZNAME:GMT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0122200","longitude":"-0013100"},"Africa/Porto-Novo":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:WAT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0062900","longitude":"+0023700"},"Africa/Sao_Tome":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0000\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:WAT\\r\\nDTSTART:20180101T010000\\r\\nRDATE:20180101T010000\\r\\nEND:STANDARD","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0000\\r\\nTZNAME:GMT\\r\\nDTSTART:20190101T020000\\r\\nRDATE:20190101T020000\\r\\nEND:STANDARD"],"latitude":"+0002000","longitude":"+0064400"},"Africa/Tripoli":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:EET\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0325400","longitude":"+0131100"},"Africa/Tunis":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:CET\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0364800","longitude":"+0101100"},"Africa/Windhoek":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:CAT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0223400","longitude":"+0170600"},"America/Adak":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-1000\\r\\nTZOFFSETTO:-0900\\r\\nTZNAME:HDT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0900\\r\\nTZOFFSETTO:-1000\\r\\nTZNAME:HST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0515248","longitude":"-1763929"},"America/Anchorage":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0900\\r\\nTZOFFSETTO:-0800\\r\\nTZNAME:AKDT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0800\\r\\nTZOFFSETTO:-0900\\r\\nTZNAME:AKST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0611305","longitude":"-1495401"},"America/Anguilla":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:AST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0181200","longitude":"-0630400"},"America/Antigua":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:AST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0170300","longitude":"-0614800"},"America/Araguaina":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0300\\r\\nTZOFFSETTO:-0300\\r\\nTZNAME:-03\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0071200","longitude":"-0481200"},"America/Argentina/Buenos_Aires":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0300\\r\\nTZOFFSETTO:-0300\\r\\nTZNAME:-03\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0343600","longitude":"-0582700"},"America/Argentina/Catamarca":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0300\\r\\nTZOFFSETTO:-0300\\r\\nTZNAME:-03\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0282800","longitude":"-0654700"},"America/Argentina/Cordoba":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0300\\r\\nTZOFFSETTO:-0300\\r\\nTZNAME:-03\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0312400","longitude":"-0641100"},"America/Argentina/Jujuy":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0300\\r\\nTZOFFSETTO:-0300\\r\\nTZNAME:-03\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0241100","longitude":"-0651800"},"America/Argentina/La_Rioja":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0300\\r\\nTZOFFSETTO:-0300\\r\\nTZNAME:-03\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0292600","longitude":"-0665100"},"America/Argentina/Mendoza":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0300\\r\\nTZOFFSETTO:-0300\\r\\nTZNAME:-03\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0325300","longitude":"-0684900"},"America/Argentina/Rio_Gallegos":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0300\\r\\nTZOFFSETTO:-0300\\r\\nTZNAME:-03\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0513800","longitude":"-0691300"},"America/Argentina/Salta":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0300\\r\\nTZOFFSETTO:-0300\\r\\nTZNAME:-03\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0244700","longitude":"-0652500"},"America/Argentina/San_Juan":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0300\\r\\nTZOFFSETTO:-0300\\r\\nTZNAME:-03\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0313200","longitude":"-0683100"},"America/Argentina/San_Luis":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0300\\r\\nTZOFFSETTO:-0300\\r\\nTZNAME:-03\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0331900","longitude":"-0662100"},"America/Argentina/Tucuman":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0300\\r\\nTZOFFSETTO:-0300\\r\\nTZNAME:-03\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0264900","longitude":"-0651300"},"America/Argentina/Ushuaia":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0300\\r\\nTZOFFSETTO:-0300\\r\\nTZNAME:-03\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0544800","longitude":"-0681800"},"America/Aruba":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:AST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0123000","longitude":"-0695800"},"America/Asuncion":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0300\\r\\nTZNAME:-03\\r\\nDTSTART:19701004T000000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0300\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:-04\\r\\nDTSTART:19700322T000000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=4SU\\r\\nEND:STANDARD"],"latitude":"-0251600","longitude":"-0574000"},"America/Atikokan":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0500\\r\\nTZOFFSETTO:-0500\\r\\nTZNAME:EST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0484531","longitude":"-0913718"},"America/Bahia":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0300\\r\\nTZOFFSETTO:-0300\\r\\nTZNAME:-03\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0125900","longitude":"-0383100"},"America/Bahia_Banderas":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0500\\r\\nTZOFFSETTO:-0600\\r\\nTZNAME:CST\\r\\nDTSTART:19701025T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD","BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0600\\r\\nTZOFFSETTO:-0500\\r\\nTZNAME:CDT\\r\\nDTSTART:19700405T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=4;BYDAY=1SU\\r\\nEND:DAYLIGHT"],"latitude":"+0204800","longitude":"-1051500"},"America/Barbados":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:AST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0130600","longitude":"-0593700"},"America/Belem":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0300\\r\\nTZOFFSETTO:-0300\\r\\nTZNAME:-03\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0012700","longitude":"-0482900"},"America/Belize":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0600\\r\\nTZOFFSETTO:-0600\\r\\nTZNAME:CST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0173000","longitude":"-0881200"},"America/Blanc-Sablon":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:AST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0512500","longitude":"-0570700"},"America/Boa_Vista":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:-04\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0024900","longitude":"-0604000"},"America/Bogota":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0500\\r\\nTZOFFSETTO:-0500\\r\\nTZNAME:-05\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0043600","longitude":"-0740500"},"America/Boise":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0700\\r\\nTZOFFSETTO:-0600\\r\\nTZNAME:MDT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0600\\r\\nTZOFFSETTO:-0700\\r\\nTZNAME:MST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0433649","longitude":"-1161209"},"America/Cambridge_Bay":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0700\\r\\nTZOFFSETTO:-0600\\r\\nTZNAME:MDT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0600\\r\\nTZOFFSETTO:-0700\\r\\nTZNAME:MST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0690650","longitude":"-1050310"},"America/Campo_Grande":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:-04\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD","BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0300\\r\\nTZNAME:-03\\r\\nDTSTART:20181104T000000\\r\\nRDATE:20181104T000000\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0300\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:-04\\r\\nDTSTART:20180218T000000\\r\\nRDATE:20180218T000000\\r\\nRDATE:20190217T000000\\r\\nEND:STANDARD"],"latitude":"-0202700","longitude":"-0543700"},"America/Cancun":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0500\\r\\nTZOFFSETTO:-0500\\r\\nTZNAME:EST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0210500","longitude":"-0864600"},"America/Caracas":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:-04\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0103000","longitude":"-0665600"},"America/Cayenne":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0300\\r\\nTZOFFSETTO:-0300\\r\\nTZNAME:-03\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0045600","longitude":"-0522000"},"America/Cayman":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0500\\r\\nTZOFFSETTO:-0500\\r\\nTZNAME:EST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0191800","longitude":"-0812300"},"America/Chicago":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0600\\r\\nTZOFFSETTO:-0500\\r\\nTZNAME:CDT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0500\\r\\nTZOFFSETTO:-0600\\r\\nTZNAME:CST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0415100","longitude":"-0873900"},"America/Chihuahua":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0700\\r\\nTZOFFSETTO:-0600\\r\\nTZNAME:MDT\\r\\nDTSTART:19700405T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=4;BYDAY=1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0600\\r\\nTZOFFSETTO:-0700\\r\\nTZNAME:MST\\r\\nDTSTART:19701025T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0283800","longitude":"-1060500"},"America/Costa_Rica":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0600\\r\\nTZOFFSETTO:-0600\\r\\nTZNAME:CST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0095600","longitude":"-0840500"},"America/Creston":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0700\\r\\nTZOFFSETTO:-0700\\r\\nTZNAME:MST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0490600","longitude":"-1163100"},"America/Cuiaba":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0300\\r\\nTZNAME:-03\\r\\nDTSTART:20181104T000000\\r\\nRDATE:20181104T000000\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0300\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:-04\\r\\nDTSTART:20180218T000000\\r\\nRDATE:20180218T000000\\r\\nRDATE:20190217T000000\\r\\nEND:STANDARD","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:-04\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0153500","longitude":"-0560500"},"America/Curacao":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:AST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0121100","longitude":"-0690000"},"America/Danmarkshavn":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0000\\r\\nTZOFFSETTO:+0000\\r\\nTZNAME:GMT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0764600","longitude":"-0184000"},"America/Dawson":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0800\\r\\nTZOFFSETTO:-0700\\r\\nTZNAME:PDT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0700\\r\\nTZOFFSETTO:-0800\\r\\nTZNAME:PST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0640400","longitude":"-1392500"},"America/Dawson_Creek":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0700\\r\\nTZOFFSETTO:-0700\\r\\nTZNAME:MST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0594600","longitude":"-1201400"},"America/Denver":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0700\\r\\nTZOFFSETTO:-0600\\r\\nTZNAME:MDT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0600\\r\\nTZOFFSETTO:-0700\\r\\nTZNAME:MST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0394421","longitude":"-1045903"},"America/Detroit":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0500\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:EDT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0500\\r\\nTZNAME:EST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0421953","longitude":"-0830245"},"America/Dominica":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:AST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0151800","longitude":"-0612400"},"America/Edmonton":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0700\\r\\nTZOFFSETTO:-0600\\r\\nTZNAME:MDT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0600\\r\\nTZOFFSETTO:-0700\\r\\nTZNAME:MST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0533300","longitude":"-1132800"},"America/Eirunepe":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0500\\r\\nTZOFFSETTO:-0500\\r\\nTZNAME:-05\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0064000","longitude":"-0695200"},"America/El_Salvador":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0600\\r\\nTZOFFSETTO:-0600\\r\\nTZNAME:CST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0134200","longitude":"-0891200"},"America/Fort_Nelson":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0700\\r\\nTZOFFSETTO:-0700\\r\\nTZNAME:MST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0584800","longitude":"-1224200"},"America/Fortaleza":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0300\\r\\nTZOFFSETTO:-0300\\r\\nTZNAME:-03\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0034300","longitude":"-0383000"},"America/Glace_Bay":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0300\\r\\nTZNAME:ADT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0300\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:AST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0461200","longitude":"-0595700"},"America/Godthab":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0300\\r\\nTZOFFSETTO:-0200\\r\\nTZNAME:-02\\r\\nDTSTART:19700328T220000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYMONTHDAY=24,25,26,27,28,29,30;BYDAY=SA\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0200\\r\\nTZOFFSETTO:-0300\\r\\nTZNAME:-03\\r\\nDTSTART:19701024T230000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYMONTHDAY=24,25,26,27,28,29,30;BYDAY=SA\\r\\nEND:STANDARD"],"latitude":"+0641100","longitude":"-0514400"},"America/Goose_Bay":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0300\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:AST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD","BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0300\\r\\nTZNAME:ADT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT"],"latitude":"+0532000","longitude":"-0602500"},"America/Grand_Turk":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0500\\r\\nTZNAME:EST\\r\\nDTSTART:20181104T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD","BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0500\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:EDT\\r\\nDTSTART:20190310T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:AST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD","BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:EDT\\r\\nDTSTART:20180311T020000\\r\\nRDATE:20180311T020000\\r\\nEND:DAYLIGHT"],"latitude":"+0212800","longitude":"-0710800"},"America/Grenada":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:AST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0120300","longitude":"-0614500"},"America/Guadeloupe":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:AST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0161400","longitude":"-0613200"},"America/Guatemala":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0600\\r\\nTZOFFSETTO:-0600\\r\\nTZNAME:CST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0143800","longitude":"-0903100"},"America/Guayaquil":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0500\\r\\nTZOFFSETTO:-0500\\r\\nTZNAME:-05\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0021000","longitude":"-0795000"},"America/Guyana":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:-04\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0064800","longitude":"-0581000"},"America/Halifax":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0300\\r\\nTZNAME:ADT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0300\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:AST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0443900","longitude":"-0633600"},"America/Havana":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0500\\r\\nTZNAME:CST\\r\\nDTSTART:19701101T010000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD","BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0500\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:CDT\\r\\nDTSTART:19700308T000000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT"],"latitude":"+0230800","longitude":"-0822200"},"America/Hermosillo":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0700\\r\\nTZOFFSETTO:-0700\\r\\nTZNAME:MST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0290400","longitude":"-1105800"},"America/Indiana/Indianapolis":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0500\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:EDT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0500\\r\\nTZNAME:EST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0394606","longitude":"-0860929"},"America/Indiana/Knox":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0600\\r\\nTZOFFSETTO:-0500\\r\\nTZNAME:CDT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0500\\r\\nTZOFFSETTO:-0600\\r\\nTZNAME:CST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0411745","longitude":"-0863730"},"America/Indiana/Marengo":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0500\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:EDT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0500\\r\\nTZNAME:EST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0382232","longitude":"-0862041"},"America/Indiana/Petersburg":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0500\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:EDT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0500\\r\\nTZNAME:EST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0382931","longitude":"-0871643"},"America/Indiana/Tell_City":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0600\\r\\nTZOFFSETTO:-0500\\r\\nTZNAME:CDT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0500\\r\\nTZOFFSETTO:-0600\\r\\nTZNAME:CST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0375711","longitude":"-0864541"},"America/Indiana/Vevay":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0500\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:EDT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0500\\r\\nTZNAME:EST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0384452","longitude":"-0850402"},"America/Indiana/Vincennes":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0500\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:EDT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0500\\r\\nTZNAME:EST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0384038","longitude":"-0873143"},"America/Indiana/Winamac":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0500\\r\\nTZNAME:EST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD","BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0500\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:EDT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT"],"latitude":"+0410305","longitude":"-0863611"},"America/Inuvik":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0700\\r\\nTZOFFSETTO:-0600\\r\\nTZNAME:MDT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0600\\r\\nTZOFFSETTO:-0700\\r\\nTZNAME:MST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0682059","longitude":"-1334300"},"America/Iqaluit":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0500\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:EDT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0500\\r\\nTZNAME:EST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0634400","longitude":"-0682800"},"America/Jamaica":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0500\\r\\nTZOFFSETTO:-0500\\r\\nTZNAME:EST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0175805","longitude":"-0764736"},"America/Juneau":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0900\\r\\nTZOFFSETTO:-0800\\r\\nTZNAME:AKDT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0800\\r\\nTZOFFSETTO:-0900\\r\\nTZNAME:AKST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0581807","longitude":"-1342511"},"America/Kentucky/Louisville":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0500\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:EDT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0500\\r\\nTZNAME:EST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0381515","longitude":"-0854534"},"America/Kentucky/Monticello":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0500\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:EDT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0500\\r\\nTZNAME:EST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0364947","longitude":"-0845057"},"America/Kralendijk":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:AST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0120903","longitude":"-0681636"},"America/La_Paz":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:-04\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0163000","longitude":"-0680900"},"America/Lima":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0500\\r\\nTZOFFSETTO:-0500\\r\\nTZNAME:-05\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0120300","longitude":"-0770300"},"America/Los_Angeles":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0800\\r\\nTZOFFSETTO:-0700\\r\\nTZNAME:PDT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0700\\r\\nTZOFFSETTO:-0800\\r\\nTZNAME:PST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0340308","longitude":"-1181434"},"America/Lower_Princes":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:AST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0180305","longitude":"-0630250"},"America/Maceio":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0300\\r\\nTZOFFSETTO:-0300\\r\\nTZNAME:-03\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0094000","longitude":"-0354300"},"America/Managua":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0600\\r\\nTZOFFSETTO:-0600\\r\\nTZNAME:CST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0120900","longitude":"-0861700"},"America/Manaus":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:-04\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0030800","longitude":"-0600100"},"America/Marigot":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:AST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0180400","longitude":"-0630500"},"America/Martinique":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:AST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0143600","longitude":"-0610500"},"America/Matamoros":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0600\\r\\nTZOFFSETTO:-0500\\r\\nTZNAME:CDT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0500\\r\\nTZOFFSETTO:-0600\\r\\nTZNAME:CST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0255000","longitude":"-0973000"},"America/Mazatlan":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0700\\r\\nTZOFFSETTO:-0600\\r\\nTZNAME:MDT\\r\\nDTSTART:19700405T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=4;BYDAY=1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0600\\r\\nTZOFFSETTO:-0700\\r\\nTZNAME:MST\\r\\nDTSTART:19701025T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0231300","longitude":"-1062500"},"America/Menominee":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0600\\r\\nTZOFFSETTO:-0500\\r\\nTZNAME:CDT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0500\\r\\nTZOFFSETTO:-0600\\r\\nTZNAME:CST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0450628","longitude":"-0873651"},"America/Merida":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0600\\r\\nTZOFFSETTO:-0500\\r\\nTZNAME:CDT\\r\\nDTSTART:19700405T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=4;BYDAY=1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0500\\r\\nTZOFFSETTO:-0600\\r\\nTZNAME:CST\\r\\nDTSTART:19701025T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0205800","longitude":"-0893700"},"America/Metlakatla":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0900\\r\\nTZOFFSETTO:-0800\\r\\nTZNAME:AKDT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0800\\r\\nTZOFFSETTO:-0900\\r\\nTZNAME:AKST\\r\\nDTSTART:20191103T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0800\\r\\nTZOFFSETTO:-0800\\r\\nTZNAME:PST\\r\\nDTSTART:20181104T020000\\r\\nRDATE:20181104T020000\\r\\nEND:STANDARD","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0800\\r\\nTZOFFSETTO:-0900\\r\\nTZNAME:AKST\\r\\nDTSTART:20190120T020000\\r\\nRDATE:20190120T020000\\r\\nEND:STANDARD"],"latitude":"+0550737","longitude":"-1313435"},"America/Mexico_City":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0600\\r\\nTZOFFSETTO:-0500\\r\\nTZNAME:CDT\\r\\nDTSTART:19700405T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=4;BYDAY=1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0500\\r\\nTZOFFSETTO:-0600\\r\\nTZNAME:CST\\r\\nDTSTART:19701025T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0192400","longitude":"-0990900"},"America/Miquelon":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0300\\r\\nTZOFFSETTO:-0200\\r\\nTZNAME:-02\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0200\\r\\nTZOFFSETTO:-0300\\r\\nTZNAME:-03\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0470300","longitude":"-0562000"},"America/Moncton":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0300\\r\\nTZNAME:ADT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0300\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:AST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0460600","longitude":"-0644700"},"America/Monterrey":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0600\\r\\nTZOFFSETTO:-0500\\r\\nTZNAME:CDT\\r\\nDTSTART:19700405T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=4;BYDAY=1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0500\\r\\nTZOFFSETTO:-0600\\r\\nTZNAME:CST\\r\\nDTSTART:19701025T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0254000","longitude":"-1001900"},"America/Montevideo":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0300\\r\\nTZOFFSETTO:-0300\\r\\nTZNAME:-03\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0345433","longitude":"-0561245"},"America/Montserrat":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:AST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0164300","longitude":"-0621300"},"America/Nassau":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0500\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:EDT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0500\\r\\nTZNAME:EST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0250500","longitude":"-0772100"},"America/New_York":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0500\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:EDT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0500\\r\\nTZNAME:EST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0404251","longitude":"-0740023"},"America/Nipigon":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0500\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:EDT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0500\\r\\nTZNAME:EST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0490100","longitude":"-0881600"},"America/Nome":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0900\\r\\nTZOFFSETTO:-0800\\r\\nTZNAME:AKDT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0800\\r\\nTZOFFSETTO:-0900\\r\\nTZNAME:AKST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0643004","longitude":"-1652423"},"America/Noronha":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0200\\r\\nTZOFFSETTO:-0200\\r\\nTZNAME:-02\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0035100","longitude":"-0322500"},"America/North_Dakota/Beulah":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0600\\r\\nTZOFFSETTO:-0500\\r\\nTZNAME:CDT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0500\\r\\nTZOFFSETTO:-0600\\r\\nTZNAME:CST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0471551","longitude":"-1014640"},"America/North_Dakota/Center":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0600\\r\\nTZOFFSETTO:-0500\\r\\nTZNAME:CDT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0500\\r\\nTZOFFSETTO:-0600\\r\\nTZNAME:CST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0470659","longitude":"-1011757"},"America/North_Dakota/New_Salem":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0600\\r\\nTZOFFSETTO:-0500\\r\\nTZNAME:CDT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0500\\r\\nTZOFFSETTO:-0600\\r\\nTZNAME:CST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0465042","longitude":"-1012439"},"America/Ojinaga":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0700\\r\\nTZOFFSETTO:-0600\\r\\nTZNAME:MDT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0600\\r\\nTZOFFSETTO:-0700\\r\\nTZNAME:MST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0293400","longitude":"-1042500"},"America/Panama":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0500\\r\\nTZOFFSETTO:-0500\\r\\nTZNAME:EST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0085800","longitude":"-0793200"},"America/Pangnirtung":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0500\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:EDT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0500\\r\\nTZNAME:EST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0660800","longitude":"-0654400"},"America/Paramaribo":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0300\\r\\nTZOFFSETTO:-0300\\r\\nTZNAME:-03\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0055000","longitude":"-0551000"},"America/Phoenix":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0700\\r\\nTZOFFSETTO:-0700\\r\\nTZNAME:MST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0332654","longitude":"-1120424"},"America/Port-au-Prince":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0500\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:EDT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0500\\r\\nTZNAME:EST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0183200","longitude":"-0722000"},"America/Port_of_Spain":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:AST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0103900","longitude":"-0613100"},"America/Porto_Velho":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:-04\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0084600","longitude":"-0635400"},"America/Puerto_Rico":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:AST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0182806","longitude":"-0660622"},"America/Punta_Arenas":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0300\\r\\nTZOFFSETTO:-0300\\r\\nTZNAME:-03\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0530900","longitude":"-0705500"},"America/Rainy_River":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0600\\r\\nTZOFFSETTO:-0500\\r\\nTZNAME:CDT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0500\\r\\nTZOFFSETTO:-0600\\r\\nTZNAME:CST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0484300","longitude":"-0943400"},"America/Rankin_Inlet":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0600\\r\\nTZOFFSETTO:-0500\\r\\nTZNAME:CDT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0500\\r\\nTZOFFSETTO:-0600\\r\\nTZNAME:CST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0624900","longitude":"-0920459"},"America/Recife":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0300\\r\\nTZOFFSETTO:-0300\\r\\nTZNAME:-03\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0080300","longitude":"-0345400"},"America/Regina":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0600\\r\\nTZOFFSETTO:-0600\\r\\nTZNAME:CST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0502400","longitude":"-1043900"},"America/Resolute":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0500\\r\\nTZOFFSETTO:-0600\\r\\nTZNAME:CST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD","BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0600\\r\\nTZOFFSETTO:-0500\\r\\nTZNAME:CDT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT"],"latitude":"+0744144","longitude":"-0944945"},"America/Rio_Branco":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0500\\r\\nTZOFFSETTO:-0500\\r\\nTZNAME:-05\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0095800","longitude":"-0674800"},"America/Santarem":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0300\\r\\nTZOFFSETTO:-0300\\r\\nTZNAME:-03\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0022600","longitude":"-0545200"},"America/Santiago":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0300\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:-04\\r\\nDTSTART:20190407T000000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=4;BYMONTHDAY=2,3,4,5,6,7,8;BYDAY=SU\\r\\nEND:STANDARD","BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0300\\r\\nTZNAME:-03\\r\\nDTSTART:20190908T000000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=9;BYMONTHDAY=2,3,4,5,6,7,8;BYDAY=SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0500\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:-04\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD","BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0300\\r\\nTZNAME:-03\\r\\nDTSTART:20180812T000000\\r\\nRDATE:20180812T000000\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0300\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:-04\\r\\nDTSTART:20180513T000000\\r\\nRDATE:20180513T000000\\r\\nEND:STANDARD"],"latitude":"-0332700","longitude":"-0704000"},"America/Santo_Domingo":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:AST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0182800","longitude":"-0695400"},"America/Sao_Paulo":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0300\\r\\nTZOFFSETTO:-0200\\r\\nTZNAME:-02\\r\\nDTSTART:20181104T000000\\r\\nRDATE:20181104T000000\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0200\\r\\nTZOFFSETTO:-0300\\r\\nTZNAME:-03\\r\\nDTSTART:20180218T000000\\r\\nRDATE:20180218T000000\\r\\nRDATE:20190217T000000\\r\\nEND:STANDARD","BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0200\\r\\nTZOFFSETTO:-0200\\r\\nTZNAME:-02\\r\\nDTSTART:19700101T000000\\r\\nEND:DAYLIGHT"],"latitude":"-0233200","longitude":"-0463700"},"America/Scoresbysund":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0100\\r\\nTZOFFSETTO:+0000\\r\\nTZNAME:+00\\r\\nDTSTART:19700329T000000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0000\\r\\nTZOFFSETTO:-0100\\r\\nTZNAME:-01\\r\\nDTSTART:19701025T010000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0702900","longitude":"-0215800"},"America/Sitka":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0900\\r\\nTZOFFSETTO:-0800\\r\\nTZNAME:AKDT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0800\\r\\nTZOFFSETTO:-0900\\r\\nTZNAME:AKST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0571035","longitude":"-1351807"},"America/St_Barthelemy":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:AST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0175300","longitude":"-0625100"},"America/St_Johns":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0230\\r\\nTZOFFSETTO:-0330\\r\\nTZNAME:NST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD","BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0330\\r\\nTZOFFSETTO:-0230\\r\\nTZNAME:NDT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT"],"latitude":"+0473400","longitude":"-0524300"},"America/St_Kitts":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:AST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0171800","longitude":"-0624300"},"America/St_Lucia":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:AST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0140100","longitude":"-0610000"},"America/St_Thomas":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:AST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0182100","longitude":"-0645600"},"America/St_Vincent":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:AST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0130900","longitude":"-0611400"},"America/Swift_Current":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0600\\r\\nTZOFFSETTO:-0600\\r\\nTZNAME:CST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0501700","longitude":"-1075000"},"America/Tegucigalpa":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0600\\r\\nTZOFFSETTO:-0600\\r\\nTZNAME:CST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0140600","longitude":"-0871300"},"America/Thule":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0300\\r\\nTZNAME:ADT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0300\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:AST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0763400","longitude":"-0684700"},"America/Thunder_Bay":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0500\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:EDT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0500\\r\\nTZNAME:EST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0482300","longitude":"-0891500"},"America/Tijuana":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0800\\r\\nTZOFFSETTO:-0700\\r\\nTZNAME:PDT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0700\\r\\nTZOFFSETTO:-0800\\r\\nTZNAME:PST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0323200","longitude":"-1170100"},"America/Toronto":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0500\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:EDT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0500\\r\\nTZNAME:EST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0433900","longitude":"-0792300"},"America/Tortola":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:AST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0182700","longitude":"-0643700"},"America/Vancouver":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0800\\r\\nTZOFFSETTO:-0700\\r\\nTZNAME:PDT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0700\\r\\nTZOFFSETTO:-0800\\r\\nTZNAME:PST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0491600","longitude":"-1230700"},"America/Whitehorse":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0800\\r\\nTZOFFSETTO:-0700\\r\\nTZNAME:PDT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0700\\r\\nTZOFFSETTO:-0800\\r\\nTZNAME:PST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0604300","longitude":"-1350300"},"America/Winnipeg":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0600\\r\\nTZOFFSETTO:-0500\\r\\nTZNAME:CDT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0500\\r\\nTZOFFSETTO:-0600\\r\\nTZNAME:CST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0495300","longitude":"-0970900"},"America/Yakutat":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0900\\r\\nTZOFFSETTO:-0800\\r\\nTZNAME:AKDT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0800\\r\\nTZOFFSETTO:-0900\\r\\nTZNAME:AKST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0593249","longitude":"-1394338"},"America/Yellowknife":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0700\\r\\nTZOFFSETTO:-0600\\r\\nTZNAME:MDT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0600\\r\\nTZOFFSETTO:-0700\\r\\nTZNAME:MST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0622700","longitude":"-1142100"},"Antarctica/Casey":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0800\\r\\nTZOFFSETTO:+1100\\r\\nTZNAME:+11\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+1100\\r\\nTZOFFSETTO:+0800\\r\\nTZNAME:+08\\r\\nDTSTART:20180311T040000\\r\\nRDATE:20180311T040000\\r\\nEND:STANDARD"],"latitude":"-0661700","longitude":"+1103100"},"Antarctica/Davis":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0700\\r\\nTZOFFSETTO:+0700\\r\\nTZNAME:+07\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0683500","longitude":"+0775800"},"Antarctica/DumontDUrville":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+1000\\r\\nTZOFFSETTO:+1000\\r\\nTZNAME:+10\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0664000","longitude":"+1400100"},"Antarctica/Macquarie":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+1100\\r\\nTZOFFSETTO:+1100\\r\\nTZNAME:+11\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0543000","longitude":"+1585700"},"Antarctica/Mawson":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0500\\r\\nTZOFFSETTO:+0500\\r\\nTZNAME:+05\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0673600","longitude":"+0625300"},"Antarctica/McMurdo":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+1200\\r\\nTZOFFSETTO:+1300\\r\\nTZNAME:NZDT\\r\\nDTSTART:19700927T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=9;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+1300\\r\\nTZOFFSETTO:+1200\\r\\nTZNAME:NZST\\r\\nDTSTART:19700405T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=4;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"-0775000","longitude":"+1663600"},"Antarctica/Palmer":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0300\\r\\nTZOFFSETTO:-0300\\r\\nTZNAME:-03\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0644800","longitude":"-0640600"},"Antarctica/Rothera":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0300\\r\\nTZOFFSETTO:-0300\\r\\nTZNAME:-03\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0673400","longitude":"-0680800"},"Antarctica/Syowa":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0300\\r\\nTZOFFSETTO:+0300\\r\\nTZNAME:+03\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0690022","longitude":"+0393524"},"Antarctica/Troll":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0000\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:+02\\r\\nDTSTART:19700329T010000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0000\\r\\nTZNAME:+00\\r\\nDTSTART:19701025T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"-0720041","longitude":"+0023206"},"Antarctica/Vostok":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0600\\r\\nTZOFFSETTO:+0600\\r\\nTZNAME:+06\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0782400","longitude":"+1065400"},"Arctic/Longyearbyen":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:CEST\\r\\nDTSTART:19700329T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:CET\\r\\nDTSTART:19701025T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0780000","longitude":"+0160000"},"Asia/Aden":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0300\\r\\nTZOFFSETTO:+0300\\r\\nTZNAME:+03\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0124500","longitude":"+0451200"},"Asia/Almaty":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0600\\r\\nTZOFFSETTO:+0600\\r\\nTZNAME:+06\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0431500","longitude":"+0765700"},"Asia/Amman":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0300\\r\\nTZNAME:EEST\\r\\nDTSTART:19700326T235959\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1TH\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0300\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:EET\\r\\nDTSTART:19701030T010000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1FR\\r\\nEND:STANDARD"],"latitude":"+0315700","longitude":"+0355600"},"Asia/Anadyr":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+1200\\r\\nTZOFFSETTO:+1200\\r\\nTZNAME:+12\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0644500","longitude":"+1772900"},"Asia/Aqtau":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0500\\r\\nTZOFFSETTO:+0500\\r\\nTZNAME:+05\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0443100","longitude":"+0501600"},"Asia/Aqtobe":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0500\\r\\nTZOFFSETTO:+0500\\r\\nTZNAME:+05\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0501700","longitude":"+0571000"},"Asia/Ashgabat":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0500\\r\\nTZOFFSETTO:+0500\\r\\nTZNAME:+05\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0375700","longitude":"+0582300"},"Asia/Atyrau":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0500\\r\\nTZOFFSETTO:+0500\\r\\nTZNAME:+05\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0470700","longitude":"+0515600"},"Asia/Baghdad":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0300\\r\\nTZOFFSETTO:+0300\\r\\nTZNAME:+03\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0332100","longitude":"+0442500"},"Asia/Bahrain":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0300\\r\\nTZOFFSETTO:+0300\\r\\nTZNAME:+03\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0262300","longitude":"+0503500"},"Asia/Baku":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0400\\r\\nTZOFFSETTO:+0400\\r\\nTZNAME:+04\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0402300","longitude":"+0495100"},"Asia/Bangkok":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0700\\r\\nTZOFFSETTO:+0700\\r\\nTZNAME:+07\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0134500","longitude":"+1003100"},"Asia/Barnaul":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0700\\r\\nTZOFFSETTO:+0700\\r\\nTZNAME:+07\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0532200","longitude":"+0834500"},"Asia/Beirut":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0300\\r\\nTZNAME:EEST\\r\\nDTSTART:19700329T000000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0300\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:EET\\r\\nDTSTART:19701025T000000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0335300","longitude":"+0353000"},"Asia/Bishkek":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0600\\r\\nTZOFFSETTO:+0600\\r\\nTZNAME:+06\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0425400","longitude":"+0743600"},"Asia/Brunei":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0800\\r\\nTZOFFSETTO:+0800\\r\\nTZNAME:+08\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0045600","longitude":"+1145500"},"Asia/Chita":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0900\\r\\nTZOFFSETTO:+0900\\r\\nTZNAME:+09\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0520300","longitude":"+1132800"},"Asia/Choibalsan":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0800\\r\\nTZOFFSETTO:+0800\\r\\nTZNAME:+08\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0480400","longitude":"+1143000"},"Asia/Colombo":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0530\\r\\nTZOFFSETTO:+0530\\r\\nTZNAME:+0530\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0065600","longitude":"+0795100"},"Asia/Damascus":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0300\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:EET\\r\\nDTSTART:19701030T000000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1FR\\r\\nEND:STANDARD","BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0300\\r\\nTZNAME:EEST\\r\\nDTSTART:19700327T000000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1FR\\r\\nEND:DAYLIGHT"],"latitude":"+0333000","longitude":"+0361800"},"Asia/Dhaka":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0600\\r\\nTZOFFSETTO:+0600\\r\\nTZNAME:+06\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0234300","longitude":"+0902500"},"Asia/Dili":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0900\\r\\nTZOFFSETTO:+0900\\r\\nTZNAME:+09\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0083300","longitude":"+1253500"},"Asia/Dubai":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0400\\r\\nTZOFFSETTO:+0400\\r\\nTZNAME:+04\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0251800","longitude":"+0551800"},"Asia/Dushanbe":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0500\\r\\nTZOFFSETTO:+0500\\r\\nTZNAME:+05\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0383500","longitude":"+0684800"},"Asia/Famagusta":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0300\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:EET\\r\\nDTSTART:19701025T040000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD","BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0300\\r\\nTZNAME:EEST\\r\\nDTSTART:20180325T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT"],"latitude":"+0350700","longitude":"+0335700"},"Asia/Gaza":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0300\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:EET\\r\\nDTSTART:19701031T010000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SA\\r\\nEND:STANDARD","BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0300\\r\\nTZNAME:EEST\\r\\nDTSTART:20190329T000000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1FR\\r\\nEND:DAYLIGHT","BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0300\\r\\nTZNAME:EEST\\r\\nDTSTART:20180324T010000\\r\\nRDATE:20180324T010000\\r\\nEND:DAYLIGHT"],"latitude":"+0313000","longitude":"+0342800"},"Asia/Hebron":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0300\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:EET\\r\\nDTSTART:19701031T010000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SA\\r\\nEND:STANDARD","BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0300\\r\\nTZNAME:EEST\\r\\nDTSTART:20190329T000000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1FR\\r\\nEND:DAYLIGHT","BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0300\\r\\nTZNAME:EEST\\r\\nDTSTART:20180324T010000\\r\\nRDATE:20180324T010000\\r\\nEND:DAYLIGHT"],"latitude":"+0313200","longitude":"+0350542"},"Asia/Ho_Chi_Minh":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0700\\r\\nTZOFFSETTO:+0700\\r\\nTZNAME:+07\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0104500","longitude":"+1064000"},"Asia/Hong_Kong":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0800\\r\\nTZOFFSETTO:+0800\\r\\nTZNAME:HKT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0221700","longitude":"+1140900"},"Asia/Hovd":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0700\\r\\nTZOFFSETTO:+0700\\r\\nTZNAME:+07\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0480100","longitude":"+0913900"},"Asia/Irkutsk":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0800\\r\\nTZOFFSETTO:+0800\\r\\nTZNAME:+08\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0521600","longitude":"+1042000"},"Asia/Istanbul":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0300\\r\\nTZOFFSETTO:+0300\\r\\nTZNAME:+03\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0410100","longitude":"+0285800"},"Asia/Jakarta":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0700\\r\\nTZOFFSETTO:+0700\\r\\nTZNAME:WIB\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0061000","longitude":"+1064800"},"Asia/Jayapura":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0900\\r\\nTZOFFSETTO:+0900\\r\\nTZNAME:WIT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0023200","longitude":"+1404200"},"Asia/Jerusalem":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0300\\r\\nTZNAME:IDT\\r\\nDTSTART:19700327T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYMONTHDAY=23,24,25,26,27,28,29;BYDAY=FR\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0300\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:IST\\r\\nDTSTART:19701025T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0314650","longitude":"+0351326"},"Asia/Kabul":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0430\\r\\nTZOFFSETTO:+0430\\r\\nTZNAME:+0430\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0343100","longitude":"+0691200"},"Asia/Kamchatka":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+1200\\r\\nTZOFFSETTO:+1200\\r\\nTZNAME:+12\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0530100","longitude":"+1583900"},"Asia/Karachi":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0500\\r\\nTZOFFSETTO:+0500\\r\\nTZNAME:PKT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0245200","longitude":"+0670300"},"Asia/Kathmandu":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0545\\r\\nTZOFFSETTO:+0545\\r\\nTZNAME:+0545\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0274300","longitude":"+0851900"},"Asia/Khandyga":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0900\\r\\nTZOFFSETTO:+0900\\r\\nTZNAME:+09\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0623923","longitude":"+1353314"},"Asia/Kolkata":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0530\\r\\nTZOFFSETTO:+0530\\r\\nTZNAME:IST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0223200","longitude":"+0882200"},"Asia/Krasnoyarsk":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0700\\r\\nTZOFFSETTO:+0700\\r\\nTZNAME:+07\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0560100","longitude":"+0925000"},"Asia/Kuala_Lumpur":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0800\\r\\nTZOFFSETTO:+0800\\r\\nTZNAME:+08\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0031000","longitude":"+1014200"},"Asia/Kuching":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0800\\r\\nTZOFFSETTO:+0800\\r\\nTZNAME:+08\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0013300","longitude":"+1102000"},"Asia/Kuwait":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0300\\r\\nTZOFFSETTO:+0300\\r\\nTZNAME:+03\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0292000","longitude":"+0475900"},"Asia/Macau":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0800\\r\\nTZOFFSETTO:+0800\\r\\nTZNAME:CST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0221150","longitude":"+1133230"},"Asia/Magadan":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+1100\\r\\nTZOFFSETTO:+1100\\r\\nTZNAME:+11\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0593400","longitude":"+1504800"},"Asia/Makassar":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0800\\r\\nTZOFFSETTO:+0800\\r\\nTZNAME:WITA\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0050700","longitude":"+1192400"},"Asia/Manila":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0800\\r\\nTZOFFSETTO:+0800\\r\\nTZNAME:PST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0143500","longitude":"+1210000"},"Asia/Muscat":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0400\\r\\nTZOFFSETTO:+0400\\r\\nTZNAME:+04\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0233600","longitude":"+0583500"},"Asia/Nicosia":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0300\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:EET\\r\\nDTSTART:19701025T040000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD","BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0300\\r\\nTZNAME:EEST\\r\\nDTSTART:19700329T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT"],"latitude":"+0351000","longitude":"+0332200"},"Asia/Novokuznetsk":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0700\\r\\nTZOFFSETTO:+0700\\r\\nTZNAME:+07\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0534500","longitude":"+0870700"},"Asia/Novosibirsk":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0700\\r\\nTZOFFSETTO:+0700\\r\\nTZNAME:+07\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0550200","longitude":"+0825500"},"Asia/Omsk":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0600\\r\\nTZOFFSETTO:+0600\\r\\nTZNAME:+06\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0550000","longitude":"+0732400"},"Asia/Oral":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0500\\r\\nTZOFFSETTO:+0500\\r\\nTZNAME:+05\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0511300","longitude":"+0512100"},"Asia/Phnom_Penh":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0700\\r\\nTZOFFSETTO:+0700\\r\\nTZNAME:+07\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0113300","longitude":"+1045500"},"Asia/Pontianak":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0700\\r\\nTZOFFSETTO:+0700\\r\\nTZNAME:WIB\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0000200","longitude":"+1092000"},"Asia/Pyongyang":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0900\\r\\nTZOFFSETTO:+0830\\r\\nTZNAME:KST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0830\\r\\nTZOFFSETTO:+0900\\r\\nTZNAME:KST\\r\\nDTSTART:20180504T233000\\r\\nRDATE:20180504T233000\\r\\nEND:STANDARD"],"latitude":"+0390100","longitude":"+1254500"},"Asia/Qatar":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0300\\r\\nTZOFFSETTO:+0300\\r\\nTZNAME:+03\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0251700","longitude":"+0513200"},"Asia/Qostanay":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0600\\r\\nTZOFFSETTO:+0600\\r\\nTZNAME:+06\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0531200","longitude":"+0633700"},"Asia/Qyzylorda":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0600\\r\\nTZOFFSETTO:+0600\\r\\nTZNAME:+06\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0600\\r\\nTZOFFSETTO:+0500\\r\\nTZNAME:+05\\r\\nDTSTART:20181221T000000\\r\\nRDATE:20181221T000000\\r\\nEND:STANDARD"],"latitude":"+0444800","longitude":"+0652800"},"Asia/Riyadh":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0300\\r\\nTZOFFSETTO:+0300\\r\\nTZNAME:+03\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0243800","longitude":"+0464300"},"Asia/Sakhalin":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+1100\\r\\nTZOFFSETTO:+1100\\r\\nTZNAME:+11\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0465800","longitude":"+1424200"},"Asia/Samarkand":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0500\\r\\nTZOFFSETTO:+0500\\r\\nTZNAME:+05\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0394000","longitude":"+0664800"},"Asia/Seoul":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0900\\r\\nTZOFFSETTO:+0900\\r\\nTZNAME:KST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0373300","longitude":"+1265800"},"Asia/Shanghai":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0800\\r\\nTZOFFSETTO:+0800\\r\\nTZNAME:CST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0311400","longitude":"+1212800"},"Asia/Singapore":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0800\\r\\nTZOFFSETTO:+0800\\r\\nTZNAME:+08\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0011700","longitude":"+1035100"},"Asia/Srednekolymsk":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+1100\\r\\nTZOFFSETTO:+1100\\r\\nTZNAME:+11\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0672800","longitude":"+1534300"},"Asia/Taipei":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0800\\r\\nTZOFFSETTO:+0800\\r\\nTZNAME:CST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0250300","longitude":"+1213000"},"Asia/Tashkent":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0500\\r\\nTZOFFSETTO:+0500\\r\\nTZNAME:+05\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0412000","longitude":"+0691800"},"Asia/Tbilisi":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0400\\r\\nTZOFFSETTO:+0400\\r\\nTZNAME:+04\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0414300","longitude":"+0444900"},"Asia/Tehran":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0400\\r\\nTZOFFSETTO:+0330\\r\\nTZNAME:+0330\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD","BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0330\\r\\nTZOFFSETTO:+0430\\r\\nTZNAME:+0430\\r\\nDTSTART:20180321T235959\\r\\nRDATE:20180321T235959\\r\\nRDATE:20190321T235959\\r\\nRDATE:20200320T235959\\r\\nRDATE:20210321T235959\\r\\nRDATE:20220321T235959\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0430\\r\\nTZOFFSETTO:+0330\\r\\nTZNAME:+0330\\r\\nDTSTART:20180921T235959\\r\\nRDATE:20180921T235959\\r\\nRDATE:20190921T235959\\r\\nRDATE:20200920T235959\\r\\nRDATE:20210921T235959\\r\\nRDATE:20220921T235959\\r\\nEND:STANDARD"],"latitude":"+0354000","longitude":"+0512600"},"Asia/Thimphu":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0600\\r\\nTZOFFSETTO:+0600\\r\\nTZNAME:+06\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0272800","longitude":"+0893900"},"Asia/Tokyo":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0900\\r\\nTZOFFSETTO:+0900\\r\\nTZNAME:JST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0353916","longitude":"+1394441"},"Asia/Tomsk":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0700\\r\\nTZOFFSETTO:+0700\\r\\nTZNAME:+07\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0563000","longitude":"+0845800"},"Asia/Ulaanbaatar":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0800\\r\\nTZOFFSETTO:+0800\\r\\nTZNAME:+08\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0475500","longitude":"+1065300"},"Asia/Urumqi":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0600\\r\\nTZOFFSETTO:+0600\\r\\nTZNAME:+06\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0434800","longitude":"+0873500"},"Asia/Ust-Nera":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+1000\\r\\nTZOFFSETTO:+1000\\r\\nTZNAME:+10\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0643337","longitude":"+1431336"},"Asia/Vientiane":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0700\\r\\nTZOFFSETTO:+0700\\r\\nTZNAME:+07\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0175800","longitude":"+1023600"},"Asia/Vladivostok":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+1000\\r\\nTZOFFSETTO:+1000\\r\\nTZNAME:+10\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0431000","longitude":"+1315600"},"Asia/Yakutsk":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0900\\r\\nTZOFFSETTO:+0900\\r\\nTZNAME:+09\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0620000","longitude":"+1294000"},"Asia/Yangon":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0630\\r\\nTZOFFSETTO:+0630\\r\\nTZNAME:+0630\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0164700","longitude":"+0961000"},"Asia/Yekaterinburg":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0500\\r\\nTZOFFSETTO:+0500\\r\\nTZNAME:+05\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0565100","longitude":"+0603600"},"Asia/Yerevan":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0400\\r\\nTZOFFSETTO:+0400\\r\\nTZNAME:+04\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0401100","longitude":"+0443000"},"Atlantic/Azores":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0100\\r\\nTZOFFSETTO:+0000\\r\\nTZNAME:+00\\r\\nDTSTART:19700329T000000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0000\\r\\nTZOFFSETTO:-0100\\r\\nTZNAME:-01\\r\\nDTSTART:19701025T010000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0374400","longitude":"-0254000"},"Atlantic/Bermuda":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0400\\r\\nTZOFFSETTO:-0300\\r\\nTZNAME:ADT\\r\\nDTSTART:19700308T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0300\\r\\nTZOFFSETTO:-0400\\r\\nTZNAME:AST\\r\\nDTSTART:19701101T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"+0321700","longitude":"-0644600"},"Atlantic/Canary":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0000\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:WEST\\r\\nDTSTART:19700329T010000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0000\\r\\nTZNAME:WET\\r\\nDTSTART:19701025T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0280600","longitude":"-0152400"},"Atlantic/Cape_Verde":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0100\\r\\nTZOFFSETTO:-0100\\r\\nTZNAME:-01\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0145500","longitude":"-0233100"},"Atlantic/Faroe":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0000\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:WEST\\r\\nDTSTART:19700329T010000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0000\\r\\nTZNAME:WET\\r\\nDTSTART:19701025T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0620100","longitude":"-0064600"},"Atlantic/Madeira":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0000\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:WEST\\r\\nDTSTART:19700329T010000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0000\\r\\nTZNAME:WET\\r\\nDTSTART:19701025T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0323800","longitude":"-0165400"},"Atlantic/Reykjavik":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0000\\r\\nTZOFFSETTO:+0000\\r\\nTZNAME:GMT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0640900","longitude":"-0215100"},"Atlantic/South_Georgia":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0200\\r\\nTZOFFSETTO:-0200\\r\\nTZNAME:-02\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0541600","longitude":"-0363200"},"Atlantic/St_Helena":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0000\\r\\nTZOFFSETTO:+0000\\r\\nTZNAME:GMT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0155500","longitude":"-0054200"},"Atlantic/Stanley":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0300\\r\\nTZOFFSETTO:-0300\\r\\nTZNAME:-03\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0514200","longitude":"-0575100"},"Australia/Adelaide":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+1030\\r\\nTZOFFSETTO:+0930\\r\\nTZNAME:ACST\\r\\nDTSTART:19700405T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=4;BYDAY=1SU\\r\\nEND:STANDARD","BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0930\\r\\nTZOFFSETTO:+1030\\r\\nTZNAME:ACDT\\r\\nDTSTART:19701004T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=1SU\\r\\nEND:DAYLIGHT"],"latitude":"-0345500","longitude":"+1383500"},"Australia/Brisbane":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+1000\\r\\nTZOFFSETTO:+1000\\r\\nTZNAME:AEST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0272800","longitude":"+1530200"},"Australia/Broken_Hill":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+1030\\r\\nTZOFFSETTO:+0930\\r\\nTZNAME:ACST\\r\\nDTSTART:19700405T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=4;BYDAY=1SU\\r\\nEND:STANDARD","BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0930\\r\\nTZOFFSETTO:+1030\\r\\nTZNAME:ACDT\\r\\nDTSTART:19701004T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=1SU\\r\\nEND:DAYLIGHT"],"latitude":"-0315700","longitude":"+1412700"},"Australia/Currie":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+1000\\r\\nTZOFFSETTO:+1100\\r\\nTZNAME:AEDT\\r\\nDTSTART:19701004T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+1100\\r\\nTZOFFSETTO:+1000\\r\\nTZNAME:AEST\\r\\nDTSTART:19700405T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=4;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"-0395600","longitude":"+1435200"},"Australia/Darwin":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0930\\r\\nTZOFFSETTO:+0930\\r\\nTZNAME:ACST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0122800","longitude":"+1305000"},"Australia/Eucla":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0845\\r\\nTZOFFSETTO:+0845\\r\\nTZNAME:+0845\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0314300","longitude":"+1285200"},"Australia/Hobart":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+1000\\r\\nTZOFFSETTO:+1100\\r\\nTZNAME:AEDT\\r\\nDTSTART:19701004T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+1100\\r\\nTZOFFSETTO:+1000\\r\\nTZNAME:AEST\\r\\nDTSTART:19700405T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=4;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"-0425300","longitude":"+1471900"},"Australia/Lindeman":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+1000\\r\\nTZOFFSETTO:+1000\\r\\nTZNAME:AEST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0201600","longitude":"+1490000"},"Australia/Lord_Howe":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+1100\\r\\nTZOFFSETTO:+1030\\r\\nTZNAME:+1030\\r\\nDTSTART:19700405T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=4;BYDAY=1SU\\r\\nEND:STANDARD","BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+1030\\r\\nTZOFFSETTO:+1100\\r\\nTZNAME:+11\\r\\nDTSTART:19701004T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=1SU\\r\\nEND:DAYLIGHT"],"latitude":"-0313300","longitude":"+1590500"},"Australia/Melbourne":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+1100\\r\\nTZOFFSETTO:+1000\\r\\nTZNAME:AEST\\r\\nDTSTART:19700405T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=4;BYDAY=1SU\\r\\nEND:STANDARD","BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+1000\\r\\nTZOFFSETTO:+1100\\r\\nTZNAME:AEDT\\r\\nDTSTART:19701004T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=1SU\\r\\nEND:DAYLIGHT"],"latitude":"-0374900","longitude":"+1445800"},"Australia/Perth":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0800\\r\\nTZOFFSETTO:+0800\\r\\nTZNAME:AWST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0315700","longitude":"+1155100"},"Australia/Sydney":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+1100\\r\\nTZOFFSETTO:+1000\\r\\nTZNAME:AEST\\r\\nDTSTART:19700405T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=4;BYDAY=1SU\\r\\nEND:STANDARD","BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+1000\\r\\nTZOFFSETTO:+1100\\r\\nTZNAME:AEDT\\r\\nDTSTART:19701004T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=1SU\\r\\nEND:DAYLIGHT"],"latitude":"-0335200","longitude":"+1511300"},"Europe/Amsterdam":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:CEST\\r\\nDTSTART:19700329T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:CET\\r\\nDTSTART:19701025T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0522200","longitude":"+0045400"},"Europe/Andorra":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:CEST\\r\\nDTSTART:19700329T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:CET\\r\\nDTSTART:19701025T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0423000","longitude":"+0013100"},"Europe/Astrakhan":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0400\\r\\nTZOFFSETTO:+0400\\r\\nTZNAME:+04\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0462100","longitude":"+0480300"},"Europe/Athens":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0300\\r\\nTZNAME:EEST\\r\\nDTSTART:19700329T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0300\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:EET\\r\\nDTSTART:19701025T040000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0375800","longitude":"+0234300"},"Europe/Belgrade":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:CEST\\r\\nDTSTART:19700329T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:CET\\r\\nDTSTART:19701025T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0445000","longitude":"+0203000"},"Europe/Berlin":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:CEST\\r\\nDTSTART:19700329T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:CET\\r\\nDTSTART:19701025T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0523000","longitude":"+0132200"},"Europe/Bratislava":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:CEST\\r\\nDTSTART:19700329T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:CET\\r\\nDTSTART:19701025T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0480900","longitude":"+0170700"},"Europe/Brussels":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:CEST\\r\\nDTSTART:19700329T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:CET\\r\\nDTSTART:19701025T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0505000","longitude":"+0042000"},"Europe/Bucharest":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0300\\r\\nTZNAME:EEST\\r\\nDTSTART:19700329T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0300\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:EET\\r\\nDTSTART:19701025T040000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0442600","longitude":"+0260600"},"Europe/Budapest":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:CEST\\r\\nDTSTART:19700329T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:CET\\r\\nDTSTART:19701025T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0473000","longitude":"+0190500"},"Europe/Busingen":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:CEST\\r\\nDTSTART:19700329T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:CET\\r\\nDTSTART:19701025T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0474200","longitude":"+0084100"},"Europe/Chisinau":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0300\\r\\nTZNAME:EEST\\r\\nDTSTART:19700329T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0300\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:EET\\r\\nDTSTART:19701025T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0470000","longitude":"+0285000"},"Europe/Copenhagen":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:CEST\\r\\nDTSTART:19700329T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:CET\\r\\nDTSTART:19701025T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0554000","longitude":"+0123500"},"Europe/Dublin":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0000\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:IST\\r\\nDTSTART:19700329T010000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:STANDARD","BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0000\\r\\nTZNAME:GMT\\r\\nDTSTART:19701025T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:DAYLIGHT"],"latitude":"+0532000","longitude":"-0061500"},"Europe/Gibraltar":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:CEST\\r\\nDTSTART:19700329T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:CET\\r\\nDTSTART:19701025T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0360800","longitude":"-0052100"},"Europe/Guernsey":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0000\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:BST\\r\\nDTSTART:19700329T010000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0000\\r\\nTZNAME:GMT\\r\\nDTSTART:19701025T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0492717","longitude":"-0023210"},"Europe/Helsinki":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0300\\r\\nTZNAME:EEST\\r\\nDTSTART:19700329T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0300\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:EET\\r\\nDTSTART:19701025T040000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0601000","longitude":"+0245800"},"Europe/Isle_of_Man":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0000\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:BST\\r\\nDTSTART:19700329T010000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0000\\r\\nTZNAME:GMT\\r\\nDTSTART:19701025T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0540900","longitude":"-0042800"},"Europe/Istanbul":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0300\\r\\nTZOFFSETTO:+0300\\r\\nTZNAME:+03\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0410100","longitude":"+0285800"},"Europe/Jersey":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0000\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:BST\\r\\nDTSTART:19700329T010000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0000\\r\\nTZNAME:GMT\\r\\nDTSTART:19701025T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0491101","longitude":"-0020624"},"Europe/Kaliningrad":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:EET\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0544300","longitude":"+0203000"},"Europe/Kiev":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0300\\r\\nTZNAME:EEST\\r\\nDTSTART:19700329T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0300\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:EET\\r\\nDTSTART:19701025T040000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0502600","longitude":"+0303100"},"Europe/Kirov":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0300\\r\\nTZOFFSETTO:+0300\\r\\nTZNAME:+03\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0583600","longitude":"+0493900"},"Europe/Lisbon":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0000\\r\\nTZNAME:WET\\r\\nDTSTART:19701025T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD","BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0000\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:WEST\\r\\nDTSTART:19700329T010000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT"],"latitude":"+0384300","longitude":"-0090800"},"Europe/Ljubljana":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:CEST\\r\\nDTSTART:19700329T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:CET\\r\\nDTSTART:19701025T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0460300","longitude":"+0143100"},"Europe/London":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0000\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:BST\\r\\nDTSTART:19700329T010000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0000\\r\\nTZNAME:GMT\\r\\nDTSTART:19701025T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0513030","longitude":"+0000731"},"Europe/Luxembourg":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:CEST\\r\\nDTSTART:19700329T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:CET\\r\\nDTSTART:19701025T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0493600","longitude":"+0060900"},"Europe/Madrid":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:CEST\\r\\nDTSTART:19700329T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:CET\\r\\nDTSTART:19701025T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0402400","longitude":"-0034100"},"Europe/Malta":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:CEST\\r\\nDTSTART:19700329T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:CET\\r\\nDTSTART:19701025T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0355400","longitude":"+0143100"},"Europe/Mariehamn":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0300\\r\\nTZNAME:EEST\\r\\nDTSTART:19700329T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0300\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:EET\\r\\nDTSTART:19701025T040000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0600600","longitude":"+0195700"},"Europe/Minsk":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0300\\r\\nTZOFFSETTO:+0300\\r\\nTZNAME:+03\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0535400","longitude":"+0273400"},"Europe/Monaco":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:CEST\\r\\nDTSTART:19700329T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:CET\\r\\nDTSTART:19701025T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0434200","longitude":"+0072300"},"Europe/Moscow":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0300\\r\\nTZOFFSETTO:+0300\\r\\nTZNAME:MSK\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0554521","longitude":"+0373704"},"Europe/Nicosia":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0300\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:EET\\r\\nDTSTART:19701025T040000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD","BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0300\\r\\nTZNAME:EEST\\r\\nDTSTART:19700329T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT"],"latitude":"+0351000","longitude":"+0332200"},"Europe/Oslo":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:CEST\\r\\nDTSTART:19700329T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:CET\\r\\nDTSTART:19701025T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0595500","longitude":"+0104500"},"Europe/Paris":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:CEST\\r\\nDTSTART:19700329T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:CET\\r\\nDTSTART:19701025T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0485200","longitude":"+0022000"},"Europe/Podgorica":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:CEST\\r\\nDTSTART:19700329T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:CET\\r\\nDTSTART:19701025T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0422600","longitude":"+0191600"},"Europe/Prague":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:CEST\\r\\nDTSTART:19700329T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:CET\\r\\nDTSTART:19701025T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0500500","longitude":"+0142600"},"Europe/Riga":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0300\\r\\nTZNAME:EEST\\r\\nDTSTART:19700329T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0300\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:EET\\r\\nDTSTART:19701025T040000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0565700","longitude":"+0240600"},"Europe/Rome":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:CEST\\r\\nDTSTART:19700329T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:CET\\r\\nDTSTART:19701025T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0415400","longitude":"+0122900"},"Europe/Samara":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0400\\r\\nTZOFFSETTO:+0400\\r\\nTZNAME:+04\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0531200","longitude":"+0500900"},"Europe/San_Marino":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:CEST\\r\\nDTSTART:19700329T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:CET\\r\\nDTSTART:19701025T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0435500","longitude":"+0122800"},"Europe/Sarajevo":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:CEST\\r\\nDTSTART:19700329T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:CET\\r\\nDTSTART:19701025T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0435200","longitude":"+0182500"},"Europe/Saratov":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0400\\r\\nTZOFFSETTO:+0400\\r\\nTZNAME:+04\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0513400","longitude":"+0460200"},"Europe/Simferopol":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0300\\r\\nTZOFFSETTO:+0300\\r\\nTZNAME:MSK\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0445700","longitude":"+0340600"},"Europe/Skopje":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:CEST\\r\\nDTSTART:19700329T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:CET\\r\\nDTSTART:19701025T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0415900","longitude":"+0212600"},"Europe/Sofia":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0300\\r\\nTZNAME:EEST\\r\\nDTSTART:19700329T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0300\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:EET\\r\\nDTSTART:19701025T040000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0424100","longitude":"+0231900"},"Europe/Stockholm":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:CEST\\r\\nDTSTART:19700329T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:CET\\r\\nDTSTART:19701025T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0592000","longitude":"+0180300"},"Europe/Tallinn":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0300\\r\\nTZNAME:EEST\\r\\nDTSTART:19700329T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0300\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:EET\\r\\nDTSTART:19701025T040000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0592500","longitude":"+0244500"},"Europe/Tirane":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:CEST\\r\\nDTSTART:19700329T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:CET\\r\\nDTSTART:19701025T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0412000","longitude":"+0195000"},"Europe/Ulyanovsk":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0400\\r\\nTZOFFSETTO:+0400\\r\\nTZNAME:+04\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0542000","longitude":"+0482400"},"Europe/Uzhgorod":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0300\\r\\nTZNAME:EEST\\r\\nDTSTART:19700329T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0300\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:EET\\r\\nDTSTART:19701025T040000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0483700","longitude":"+0221800"},"Europe/Vaduz":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:CEST\\r\\nDTSTART:19700329T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:CET\\r\\nDTSTART:19701025T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0470900","longitude":"+0093100"},"Europe/Vatican":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:CEST\\r\\nDTSTART:19700329T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:CET\\r\\nDTSTART:19701025T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0415408","longitude":"+0122711"},"Europe/Vienna":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:CEST\\r\\nDTSTART:19700329T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:CET\\r\\nDTSTART:19701025T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0481300","longitude":"+0162000"},"Europe/Vilnius":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0300\\r\\nTZNAME:EEST\\r\\nDTSTART:19700329T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0300\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:EET\\r\\nDTSTART:19701025T040000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0544100","longitude":"+0251900"},"Europe/Volgograd":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0300\\r\\nTZOFFSETTO:+0400\\r\\nTZNAME:+04\\r\\nDTSTART:20181028T020000\\r\\nRDATE:20181028T020000\\r\\nEND:STANDARD","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0400\\r\\nTZOFFSETTO:+0300\\r\\nTZNAME:+03\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0484400","longitude":"+0442500"},"Europe/Warsaw":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:CEST\\r\\nDTSTART:19700329T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:CET\\r\\nDTSTART:19701025T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0521500","longitude":"+0210000"},"Europe/Zagreb":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:CEST\\r\\nDTSTART:19700329T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:CET\\r\\nDTSTART:19701025T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0454800","longitude":"+0155800"},"Europe/Zaporozhye":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0300\\r\\nTZNAME:EEST\\r\\nDTSTART:19700329T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0300\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:EET\\r\\nDTSTART:19701025T040000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0475000","longitude":"+0351000"},"Europe/Zurich":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+0100\\r\\nTZOFFSETTO:+0200\\r\\nTZNAME:CEST\\r\\nDTSTART:19700329T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0200\\r\\nTZOFFSETTO:+0100\\r\\nTZNAME:CET\\r\\nDTSTART:19701025T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\\r\\nEND:STANDARD"],"latitude":"+0472300","longitude":"+0083200"},"Indian/Antananarivo":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0300\\r\\nTZOFFSETTO:+0300\\r\\nTZNAME:EAT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0185500","longitude":"+0473100"},"Indian/Chagos":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0600\\r\\nTZOFFSETTO:+0600\\r\\nTZNAME:+06\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0072000","longitude":"+0722500"},"Indian/Christmas":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0700\\r\\nTZOFFSETTO:+0700\\r\\nTZNAME:+07\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0102500","longitude":"+1054300"},"Indian/Cocos":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0630\\r\\nTZOFFSETTO:+0630\\r\\nTZNAME:+0630\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0121000","longitude":"+0965500"},"Indian/Comoro":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0300\\r\\nTZOFFSETTO:+0300\\r\\nTZNAME:EAT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0114100","longitude":"+0431600"},"Indian/Kerguelen":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0500\\r\\nTZOFFSETTO:+0500\\r\\nTZNAME:+05\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0492110","longitude":"+0701303"},"Indian/Mahe":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0400\\r\\nTZOFFSETTO:+0400\\r\\nTZNAME:+04\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0044000","longitude":"+0552800"},"Indian/Maldives":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0500\\r\\nTZOFFSETTO:+0500\\r\\nTZNAME:+05\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0041000","longitude":"+0733000"},"Indian/Mauritius":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0400\\r\\nTZOFFSETTO:+0400\\r\\nTZNAME:+04\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0201000","longitude":"+0573000"},"Indian/Mayotte":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0300\\r\\nTZOFFSETTO:+0300\\r\\nTZNAME:EAT\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0124700","longitude":"+0451400"},"Indian/Reunion":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0400\\r\\nTZOFFSETTO:+0400\\r\\nTZNAME:+04\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0205200","longitude":"+0552800"},"Pacific/Apia":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+1400\\r\\nTZOFFSETTO:+1300\\r\\nTZNAME:+13\\r\\nDTSTART:19700405T040000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=4;BYDAY=1SU\\r\\nEND:STANDARD","BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+1300\\r\\nTZOFFSETTO:+1400\\r\\nTZNAME:+14\\r\\nDTSTART:19700927T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=9;BYDAY=-1SU\\r\\nEND:DAYLIGHT"],"latitude":"-0135000","longitude":"-1714400"},"Pacific/Auckland":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+1200\\r\\nTZOFFSETTO:+1300\\r\\nTZNAME:NZDT\\r\\nDTSTART:19700927T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=9;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+1300\\r\\nTZOFFSETTO:+1200\\r\\nTZNAME:NZST\\r\\nDTSTART:19700405T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=4;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"-0365200","longitude":"+1744600"},"Pacific/Bougainville":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+1100\\r\\nTZOFFSETTO:+1100\\r\\nTZNAME:+11\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0061300","longitude":"+1553400"},"Pacific/Chatham":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+1245\\r\\nTZOFFSETTO:+1345\\r\\nTZNAME:+1345\\r\\nDTSTART:19700927T024500\\r\\nRRULE:FREQ=YEARLY;BYMONTH=9;BYDAY=-1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+1345\\r\\nTZOFFSETTO:+1245\\r\\nTZNAME:+1245\\r\\nDTSTART:19700405T034500\\r\\nRRULE:FREQ=YEARLY;BYMONTH=4;BYDAY=1SU\\r\\nEND:STANDARD"],"latitude":"-0435700","longitude":"-1763300"},"Pacific/Chuuk":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+1000\\r\\nTZOFFSETTO:+1000\\r\\nTZNAME:+10\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0072500","longitude":"+1514700"},"Pacific/Easter":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0500\\r\\nTZOFFSETTO:-0600\\r\\nTZNAME:-06\\r\\nDTSTART:20190406T220000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=4;BYDAY=1SA\\r\\nEND:STANDARD","BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0600\\r\\nTZOFFSETTO:-0500\\r\\nTZNAME:-05\\r\\nDTSTART:20190907T220000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=9;BYDAY=1SA\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0600\\r\\nTZOFFSETTO:-0600\\r\\nTZNAME:-06\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD","BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:-0600\\r\\nTZOFFSETTO:-0500\\r\\nTZNAME:-05\\r\\nDTSTART:20180811T220000\\r\\nRDATE:20180811T220000\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0500\\r\\nTZOFFSETTO:-0600\\r\\nTZNAME:-06\\r\\nDTSTART:20180512T220000\\r\\nRDATE:20180512T220000\\r\\nEND:STANDARD"],"latitude":"-0270900","longitude":"-1092600"},"Pacific/Efate":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+1100\\r\\nTZOFFSETTO:+1100\\r\\nTZNAME:+11\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0174000","longitude":"+1682500"},"Pacific/Enderbury":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+1300\\r\\nTZOFFSETTO:+1300\\r\\nTZNAME:+13\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0030800","longitude":"-1710500"},"Pacific/Fakaofo":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+1300\\r\\nTZOFFSETTO:+1300\\r\\nTZNAME:+13\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0092200","longitude":"-1711400"},"Pacific/Fiji":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+1300\\r\\nTZOFFSETTO:+1200\\r\\nTZNAME:+12\\r\\nDTSTART:19700118T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=1;BYMONTHDAY=12,13,14,15,16,17,18;BYDAY=SU\\r\\nEND:STANDARD","BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+1200\\r\\nTZOFFSETTO:+1300\\r\\nTZNAME:+13\\r\\nDTSTART:20191110T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=2SU\\r\\nEND:DAYLIGHT","BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+1200\\r\\nTZOFFSETTO:+1300\\r\\nTZNAME:+13\\r\\nDTSTART:20181104T020000\\r\\nRDATE:20181104T020000\\r\\nEND:DAYLIGHT"],"latitude":"-0180800","longitude":"+1782500"},"Pacific/Funafuti":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+1200\\r\\nTZOFFSETTO:+1200\\r\\nTZNAME:+12\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0083100","longitude":"+1791300"},"Pacific/Galapagos":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0600\\r\\nTZOFFSETTO:-0600\\r\\nTZNAME:-06\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0005400","longitude":"-0893600"},"Pacific/Gambier":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0900\\r\\nTZOFFSETTO:-0900\\r\\nTZNAME:-09\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0230800","longitude":"-1345700"},"Pacific/Guadalcanal":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+1100\\r\\nTZOFFSETTO:+1100\\r\\nTZNAME:+11\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0093200","longitude":"+1601200"},"Pacific/Guam":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+1000\\r\\nTZOFFSETTO:+1000\\r\\nTZNAME:ChST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0132800","longitude":"+1444500"},"Pacific/Honolulu":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-1000\\r\\nTZOFFSETTO:-1000\\r\\nTZNAME:HST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0211825","longitude":"-1575130"},"Pacific/Kiritimati":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+1400\\r\\nTZOFFSETTO:+1400\\r\\nTZNAME:+14\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0015200","longitude":"-1572000"},"Pacific/Kosrae":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+1100\\r\\nTZOFFSETTO:+1100\\r\\nTZNAME:+11\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0051900","longitude":"+1625900"},"Pacific/Kwajalein":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+1200\\r\\nTZOFFSETTO:+1200\\r\\nTZNAME:+12\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0090500","longitude":"+1672000"},"Pacific/Majuro":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+1200\\r\\nTZOFFSETTO:+1200\\r\\nTZNAME:+12\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0070900","longitude":"+1711200"},"Pacific/Marquesas":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0930\\r\\nTZOFFSETTO:-0930\\r\\nTZNAME:-0930\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0090000","longitude":"-1393000"},"Pacific/Midway":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-1100\\r\\nTZOFFSETTO:-1100\\r\\nTZNAME:SST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0281300","longitude":"-1772200"},"Pacific/Nauru":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+1200\\r\\nTZOFFSETTO:+1200\\r\\nTZNAME:+12\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0003100","longitude":"+1665500"},"Pacific/Niue":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-1100\\r\\nTZOFFSETTO:-1100\\r\\nTZNAME:-11\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0190100","longitude":"-1695500"},"Pacific/Norfolk":{"ics":["BEGIN:DAYLIGHT\\r\\nTZOFFSETFROM:+1100\\r\\nTZOFFSETTO:+1200\\r\\nTZNAME:+12\\r\\nDTSTART:20191006T020000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=1SU\\r\\nEND:DAYLIGHT","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+1200\\r\\nTZOFFSETTO:+1100\\r\\nTZNAME:+11\\r\\nDTSTART:20200405T030000\\r\\nRRULE:FREQ=YEARLY;BYMONTH=4;BYDAY=1SU\\r\\nEND:STANDARD","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+1130\\r\\nTZOFFSETTO:+1100\\r\\nTZNAME:+11\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD","BEGIN:STANDARD\\r\\nTZOFFSETFROM:+1100\\r\\nTZOFFSETTO:+1100\\r\\nTZNAME:+11\\r\\nDTSTART:20190701T000000\\r\\nRDATE:20190701T000000\\r\\nEND:STANDARD"],"latitude":"-0290300","longitude":"+1675800"},"Pacific/Noumea":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+1100\\r\\nTZOFFSETTO:+1100\\r\\nTZNAME:+11\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0221600","longitude":"+1662700"},"Pacific/Pago_Pago":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-1100\\r\\nTZOFFSETTO:-1100\\r\\nTZNAME:SST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0141600","longitude":"-1704200"},"Pacific/Palau":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+0900\\r\\nTZOFFSETTO:+0900\\r\\nTZNAME:+09\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0072000","longitude":"+1342900"},"Pacific/Pitcairn":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-0800\\r\\nTZOFFSETTO:-0800\\r\\nTZNAME:-08\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0250400","longitude":"-1300500"},"Pacific/Pohnpei":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+1100\\r\\nTZOFFSETTO:+1100\\r\\nTZNAME:+11\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0065800","longitude":"+1581300"},"Pacific/Port_Moresby":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+1000\\r\\nTZOFFSETTO:+1000\\r\\nTZNAME:+10\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0093000","longitude":"+1471000"},"Pacific/Rarotonga":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-1000\\r\\nTZOFFSETTO:-1000\\r\\nTZNAME:-10\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0211400","longitude":"-1594600"},"Pacific/Saipan":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+1000\\r\\nTZOFFSETTO:+1000\\r\\nTZNAME:ChST\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0151200","longitude":"+1454500"},"Pacific/Tahiti":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:-1000\\r\\nTZOFFSETTO:-1000\\r\\nTZNAME:-10\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0173200","longitude":"-1493400"},"Pacific/Tarawa":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+1200\\r\\nTZOFFSETTO:+1200\\r\\nTZNAME:+12\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0012500","longitude":"+1730000"},"Pacific/Tongatapu":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+1300\\r\\nTZOFFSETTO:+1300\\r\\nTZNAME:+13\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0211000","longitude":"-1751000"},"Pacific/Wake":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+1200\\r\\nTZOFFSETTO:+1200\\r\\nTZNAME:+12\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"+0191700","longitude":"+1663700"},"Pacific/Wallis":{"ics":["BEGIN:STANDARD\\r\\nTZOFFSETFROM:+1200\\r\\nTZOFFSETTO:+1200\\r\\nTZNAME:+12\\r\\nDTSTART:19700101T000000\\r\\nEND:STANDARD"],"latitude":"-0131800","longitude":"-1761000"}}}');
      var f = a(6115);
      function h(w) {
        return function(W) {
          if (Array.isArray(W))
            return S(W);
        }(w) || function(W) {
          if (typeof Symbol < "u" && W[Symbol.iterator] != null || W["@@iterator"] != null)
            return Array.from(W);
        }(w) || function(W, se) {
          if (W) {
            if (typeof W == "string")
              return S(W, se);
            var ie = Object.prototype.toString.call(W).slice(8, -1);
            if (ie === "Object" && W.constructor && (ie = W.constructor.name), ie === "Map" || ie === "Set")
              return Array.from(W);
            if (ie === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(ie))
              return S(W, se);
          }
        }(w) || function() {
          throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
        }();
      }
      function S(w, W) {
        (W == null || W > w.length) && (W = w.length);
        for (var se = 0, ie = new Array(W); se < W; se++)
          ie[se] = w[se];
        return ie;
      }
      var p = (0, m1.getTimezoneManager)(), m = !1;
      function g() {
        return m || function() {
          for (var w in f.Z.debug("Using version ".concat(A.i8, " of the timezone database")), A.Ao)
            if (Object.prototype.hasOwnProperty.call(A.Ao, [w])) {
              var W = ["BEGIN:VTIMEZONE", "TZID:" + w].concat(h(A.Ao[w].ics), ["END:VTIMEZONE"]).join(`\r
`);
              p.registerTimezoneFromICS(w, W);
            }
          for (var se in A.j3)
            Object.prototype.hasOwnProperty.call(A.j3, [se]) && p.registerAlias(se, A.j3[se].aliasTo);
          m = !0;
        }(), p;
      }
      function N(w, W) {
        var se = typeof Symbol < "u" && w[Symbol.iterator] || w["@@iterator"];
        if (!se) {
          if (Array.isArray(w) || (se = function(ae, X) {
            if (ae) {
              if (typeof ae == "string")
                return R(ae, X);
              var pe = Object.prototype.toString.call(ae).slice(8, -1);
              if (pe === "Object" && ae.constructor && (pe = ae.constructor.name), pe === "Map" || pe === "Set")
                return Array.from(ae);
              if (pe === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(pe))
                return R(ae, X);
            }
          }(w)) || W && w && typeof w.length == "number") {
            se && (w = se);
            var ie = 0, Fe = function() {
            };
            return { s: Fe, n: function() {
              return ie >= w.length ? { done: !0 } : { done: !1, value: w[ie++] };
            }, e: function(ae) {
              throw ae;
            }, f: Fe };
          }
          throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
        }
        var V, $ = !0, J = !1;
        return { s: function() {
          se = se.call(w);
        }, n: function() {
          var ae = se.next();
          return $ = ae.done, ae;
        }, e: function(ae) {
          J = !0, V = ae;
        }, f: function() {
          try {
            $ || se.return == null || se.return();
          } finally {
            if (J)
              throw V;
          }
        } };
      }
      function R(w, W) {
        (W == null || W > w.length) && (W = w.length);
        for (var se = 0, ie = new Array(W); se < W; se++)
          ie[se] = w[se];
        return ie;
      }
      const D = { name: "NcTimezonePicker", components: { NcMultiselect: a(2974).default }, props: { additionalTimezones: { type: Array, default: function() {
        return [];
      } }, value: { type: String, default: "floating" } }, emits: ["input"], computed: { placeholder: function() {
        return (0, c.t)("Type to search time zone");
      }, selectedTimezone: function() {
        var w, W = N(this.additionalTimezones);
        try {
          for (W.s(); !(w = W.n()).done; ) {
            var se = w.value;
            if (se.timezoneId === this.value)
              return se;
          }
        } catch (ie) {
          W.e(ie);
        } finally {
          W.f();
        }
        return { label: d(this.value), timezoneId: this.value };
      }, options: function() {
        return function() {
          var w, W = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], se = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], ie = {}, Fe = [], V = T(W);
          try {
            for (V.s(); !(w = V.n()).done; ) {
              var $ = w.value, J = $.split("/"), ae = [J.shift(), J.join("/")], X = ae[0], pe = ae[1];
              pe || (pe = X, X = (0, c.t)("Global")), ie[X] = ie[X] || { continent: X, regions: [] }, ie[X].regions.push({ label: d(pe), cities: [], timezoneId: $ });
            }
          } catch (Ze) {
            V.e(Ze);
          } finally {
            V.f();
          }
          var L, ee = T(se);
          try {
            for (ee.s(); !(L = ee.n()).done; ) {
              var Ae = L.value, Ne = Ae.continent, ye = Ae.label, be = Ae.timezoneId;
              ie[Ne] = ie[Ne] || { continent: Ne, regions: [] }, ie[Ne].regions.push({ label: ye, cities: [], timezoneId: be });
            }
          } catch (Ze) {
            ee.e(Ze);
          } finally {
            ee.f();
          }
          for (var Ge in ie)
            Object.prototype.hasOwnProperty.call(ie, Ge) && (ie[Ge].regions.sort(function(Ze, _e) {
              return Ze.label < _e.label ? -1 : 1;
            }), Fe.push(ie[Ge]));
          return Fe.sort(function(Ze, _e) {
            return Ze.continent < _e.continent ? -1 : 1;
          }), Fe;
        }(g().listAllTimezones(), this.additionalTimezones);
      } }, methods: { change: function(w) {
        w && this.$emit("input", w.timezoneId);
      } } };
      var v = a(3379), O = a.n(v), y = a(7795), Z = a.n(y), F = a(569), b = a.n(F), Y = a(3565), I = a.n(Y), q = a(9216), _ = a.n(q), z = a(4589), E = a.n(z), C = a(7887), P = {};
      P.styleTagTransform = E(), P.setAttributes = I(), P.insert = b().bind(null, "head"), P.domAPI = Z(), P.insertStyleElement = _(), O()(C.Z, P), C.Z && C.Z.locals && C.Z.locals;
      var M = a(1900), Q = a(189), H = a.n(Q), re = (0, M.Z)(D, function() {
        var w = this;
        return (0, w._self._c)("NcMultiselect", { attrs: { value: w.selectedTimezone, options: w.options, multiple: !1, "group-select": !1, placeholder: w.placeholder, "group-values": "regions", "group-label": "continent", "track-by": "timezoneId", label: "label", "open-direction": "above" }, on: { input: w.change } });
      }, [], !1, null, "3992c512", null);
      typeof H() == "function" && H()(re);
      const U = re.exports;
    }, 336: (o, l, a) => {
      a.d(l, { default: () => O });
      var c = a(9454), T = a(3379), u = a.n(T), d = a(7795), A = a.n(d), f = a(569), h = a.n(f), S = a(3565), p = a.n(S), m = a(9216), g = a.n(m), N = a(4589), R = a.n(N), D = a(8384), v = {};
      v.styleTagTransform = R(), v.setAttributes = p(), v.insert = h().bind(null, "head"), v.domAPI = A(), v.insertStyleElement = g(), u()(D.Z, v), D.Z && D.Z.locals && D.Z.locals, c.options.themes.tooltip.html = !1, c.options.themes.tooltip.delay = { show: 500, hide: 200 }, c.options.themes.tooltip.distance = 10, c.options.themes.tooltip["arrow-padding"] = 3;
      const O = c.VTooltip;
    }, 7993: (o, l, a) => {
      a.d(l, { default: () => d });
      var c = a(6609);
      const T = R1();
      var u = a.n(T);
      const d = function(A) {
        var f = A.toLowerCase();
        return f.match(/^([0-9a-f]{4}-?){8}$/) === null && (f = u()(f)), f = f.replace(/[^0-9a-f]/g, ""), (0, c.Z)(6)[function(h, S) {
          for (var p = 0, m = [], g = 0; g < h.length; g++)
            m.push(parseInt(h.charAt(g), 16) % 16);
          for (var N in m)
            p += m[N];
          return parseInt(parseInt(p, 10) % S, 10);
        }(f, 18)];
      };
    }, 932: (o, l, a) => {
      a.d(l, { n: () => d, t: () => A });
      var c = a(754), T = (0, c.getGettextBuilder)().detectLocale();
      [{ locale: "ar", translations: { "{tag} (invisible)": "{tag} (غير مرئي)", "{tag} (restricted)": "{tag} (مقيد)", Actions: "الإجراءات", Activities: "النشاطات", "Animals & Nature": "الحيوانات والطبيعة", "Anything shared with the same group of people will show up here": "أي مادة تمت مشاركتها مع نفس المجموعة من الأشخاص سيتم عرضها هنا", "Avatar of {displayName}": "صورة {displayName} الرمزية", "Avatar of {displayName}, {status}": "صورة {displayName} الرمزية، {status}", "Cancel changes": "إلغاء التغييرات", "Change title": "تغيير العنوان", Choose: "إختيار", "Clear text": "مسح النص", Close: "أغلق", "Close modal": "قفل الشرط", "Close navigation": "إغلاق المتصفح", "Close sidebar": "قفل الشريط الجانبي", "Confirm changes": "تأكيد التغييرات", Custom: "مخصص", "Edit item": "تعديل عنصر", "Error getting related resources": "خطأ في تحصيل مصادر ذات صلة", "External documentation for {title}": "الوثائق الخارجية لـ{title}", Favorite: "مفضلة", Flags: "الأعلام", "Food & Drink": "الطعام والشراب", "Frequently used": "كثيرا ما تستخدم", Global: "عالمي", "Go back to the list": "العودة إلى القائمة", "Hide password": "إخفاء كلمة السر", "Message limit of {count} characters reached": "تم الوصول إلى الحد الأقصى لعدد الأحرف في الرسالة: {count} حرف", "More items …": "عناصر أخرى ...", Next: "التالي", "No emoji found": "لم يتم العثور على أي رمز تعبيري", "No results": "ليس هناك أية نتيجة", Objects: "الأشياء", Open: "فتح", 'Open link to "{resourceTitle}"': 'فتح رابط إلى "{resourceTitle}"', "Open navigation": "فتح المتصفح", "Password is secure": "كلمة السر مُؤمّنة", "Pause slideshow": "إيقاف العرض مؤقتًا", "People & Body": "الناس والجسم", "Pick an emoji": "اختر رمزًا تعبيريًا", "Please select a time zone:": "الرجاء تحديد المنطقة الزمنية:", Previous: "السابق", "Related resources": "مصادر ذات صلة", Search: "بحث", "Search results": "نتائج البحث", "Select a tag": "اختر علامة", Settings: "الإعدادات", "Settings navigation": "إعدادات المتصفح", "Show password": "أعرض كلمة السر", "Smileys & Emotion": "الوجوه و الرموز التعبيرية", "Start slideshow": "بدء العرض", Submit: "إرسال", Symbols: "الرموز", "Travel & Places": "السفر والأماكن", "Type to search time zone": "اكتب للبحث عن منطقة زمنية", "Unable to search the group": "تعذر البحث في المجموعة", "Undo changes": "التراجع عن التغييرات", "Write message, @ to mention someone, : for emoji autocompletion …": "اكتب رسالة، @ للإشارة إلى شخص ما، : للإكمال التلقائي للرموز التعبيرية ..." } }, { locale: "br", translations: { "{tag} (invisible)": "{tag} (diwelus)", "{tag} (restricted)": "{tag} (bevennet)", Actions: "Oberioù", Activities: "Oberiantizoù", "Animals & Nature": "Loened & Natur", Choose: "Dibab", Close: "Serriñ", Custom: "Personelañ", Flags: "Bannieloù", "Food & Drink": "Boued & Evajoù", "Frequently used": "Implijet alies", Next: "Da heul", "No emoji found": "Emoji ebet kavet", "No results": "Disoc'h ebet", Objects: "Traoù", "Pause slideshow": "Arsav an diaporama", "People & Body": "Tud & Korf", "Pick an emoji": "Choaz un emoji", Previous: "A-raok", Search: "Klask", "Search results": "Disoc'hoù an enklask", "Select a tag": "Choaz ur c'hlav", Settings: "Arventennoù", "Smileys & Emotion": "Smileyioù & Fromoù", "Start slideshow": "Kregiñ an diaporama", Symbols: "Arouezioù", "Travel & Places": "Beaj & Lec'hioù", "Unable to search the group": "Dibosupl eo klask ar strollad" } }, { locale: "ca", translations: { "{tag} (invisible)": "{tag} (invisible)", "{tag} (restricted)": "{tag} (restringit)", Actions: "Accions", Activities: "Activitats", "Animals & Nature": "Animals i natura", "Anything shared with the same group of people will show up here": "Qualsevol cosa compartida amb el mateix grup de persones es mostrarà aquí", "Avatar of {displayName}": "Avatar de {displayName}", "Avatar of {displayName}, {status}": "Avatar de {displayName}, {status}", "Cancel changes": "Cancel·la els canvis", "Change title": "Canviar títol", Choose: "Tria", "Clear text": "Netejar text", Close: "Tanca", "Close modal": "Tancar el mode", "Close navigation": "Tanca la navegació", "Close sidebar": "Tancar la barra lateral", "Confirm changes": "Confirmeu els canvis", Custom: "Personalitzat", "Edit item": "Edita l'element", "Error getting related resources": "Error obtenint els recursos relacionats", "External documentation for {title}": "Documentació externa per a {title}", Favorite: "Preferit", Flags: "Marques", "Food & Drink": "Menjar i begudes", "Frequently used": "Utilitzats recentment", Global: "Global", "Go back to the list": "Torna a la llista", "Hide password": "Amagar contrasenya", "Message limit of {count} characters reached": "S'ha arribat al límit de {count} caràcters per missatge", "More items …": "Més artícles...", Next: "Següent", "No emoji found": "No s'ha trobat cap emoji", "No results": "Sense resultats", Objects: "Objectes", Open: "Obrir", 'Open link to "{resourceTitle}"': 'Obrir enllaç a "{resourceTitle}"', "Open navigation": "Obre la navegació", "Password is secure": "Contrasenya segura<br>", "Pause slideshow": "Atura la presentació", "People & Body": "Persones i cos", "Pick an emoji": "Trieu un emoji", "Please select a time zone:": "Seleccioneu una zona horària:", Previous: "Anterior", "Related resources": "Recursos relacionats", Search: "Cerca", "Search results": "Resultats de cerca", "Select a tag": "Seleccioneu una etiqueta", Settings: "Paràmetres", "Settings navigation": "Navegació d'opcions", "Show password": "Mostrar contrasenya", "Smileys & Emotion": "Cares i emocions", "Start slideshow": "Inicia la presentació", Submit: "Envia", Symbols: "Símbols", "Travel & Places": "Viatges i llocs", "Type to search time zone": "Escriviu per cercar la zona horària", "Unable to search the group": "No es pot cercar el grup", "Undo changes": "Desfés els canvis", 'Write message, use "@" to mention someone, use ":" for emoji autocompletion …': 'Escriu missatge, fes servir "@" per esmentar algú, fes servir ":" per autocompletar emojis...' } }, { locale: "cs_CZ", translations: { "{tag} (invisible)": "{tag} (neviditelné)", "{tag} (restricted)": "{tag} (omezené)", Actions: "Akce", Activities: "Aktivity", "Animals & Nature": "Zvířata a příroda", "Anything shared with the same group of people will show up here": "Cokoli nasdíleného stejné skupině lidí se zobrazí zde", "Avatar of {displayName}": "Zástupný obrázek uživatele {displayName}", "Avatar of {displayName}, {status}": "Zástupný obrázek uživatele {displayName}, {status}", "Cancel changes": "Zrušit změny", "Change title": "Změnit nadpis", Choose: "Zvolit", "Clear text": "Čitelný text", Close: "Zavřít", "Close modal": "Zavřít dialogové okno", "Close navigation": "Zavřít navigaci", "Close sidebar": "Zavřít postranní panel", "Confirm changes": "Potvrdit změny", Custom: "Uživatelsky určené", "Edit item": "Upravit položku", "Error getting related resources": "Chyba při získávání souvisejících prostředků", "Error parsing svg": "Chyba při zpracovávání svg", "External documentation for {title}": "Externí dokumentace k {title}", Favorite: "Oblíbené", Flags: "Příznaky", "Food & Drink": "Jídlo a pití", "Frequently used": "Často používané", Global: "Globální", "Go back to the list": "Jít zpět na seznam", "Hide password": "Skrýt heslo", "Message limit of {count} characters reached": "Dosaženo limitu počtu ({count}) znaků zprávy", "More items …": "Další položky…", Next: "Následující", "No emoji found": "Nenalezeno žádné emoji", "No results": "Nic nenalezeno", Objects: "Objekty", Open: "Otevřít", 'Open link to "{resourceTitle}"': "Otevřít odkaz na „{resourceTitle}“", "Open navigation": "Otevřít navigaci", "Password is secure": "Heslo je bezpečné", "Pause slideshow": "Pozastavit prezentaci", "People & Body": "Lidé a tělo", "Pick an emoji": "Vybrat emoji", "Please select a time zone:": "Vyberte časovou zónu:", Previous: "Předchozí", "Related resources": "Související prostředky", Search: "Hledat", "Search results": "Výsledky hledání", "Select a tag": "Vybrat štítek", Settings: "Nastavení", "Settings navigation": "Pohyb po nastavení", "Show password": "Zobrazit heslo", "Smileys & Emotion": "Úsměvy a emoce", "Start slideshow": "Spustit prezentaci", Submit: "Odeslat", Symbols: "Symboly", "Travel & Places": "Cestování a místa", "Type to search time zone": "Psaním vyhledejte časovou zónu", "Unable to search the group": "Nedaří se hledat skupinu", "Undo changes": "Vzít změny zpět", 'Write message, use "@" to mention someone, use ":" for emoji autocompletion …': "Napište zprávu – pokud chcete někoho zmínit, napište před jeho uživatelským jménem „@“ (zavináč); automatické doplňování emotikonů zahájíte napsáním „:“ (dvojtečky)…" } }, { locale: "da", translations: { "{tag} (invisible)": "{tag} (usynlig)", "{tag} (restricted)": "{tag} (begrænset)", Actions: "Handlinger", Activities: "Aktiviteter", "Animals & Nature": "Dyr & Natur", "Anything shared with the same group of people will show up here": "Alt der deles med samme gruppe af personer vil vises her", "Avatar of {displayName}": "Avatar af {displayName}", "Avatar of {displayName}, {status}": "Avatar af {displayName}, {status}", "Cancel changes": "Annuller ændringer", "Change title": "Ret titel", Choose: "Vælg", "Clear text": "Ryd tekst", Close: "Luk", "Close modal": "Luk vindue", "Close navigation": "Luk navigation", "Close sidebar": "Luk sidepanel", "Confirm changes": "Bekræft ændringer", Custom: "Brugerdefineret", "Edit item": "Rediger emne", "Error getting related resources": "Kunne ikke hente tilknyttede data", "External documentation for {title}": "Ekstern dokumentation for {title}", Favorite: "Favorit", Flags: "Flag", "Food & Drink": "Mad & Drikke", "Frequently used": "Ofte brugt", Global: "Global", "Go back to the list": "Tilbage til listen", "Hide password": "Skjul kodeord", "Message limit of {count} characters reached": "Begrænsning på {count} tegn er nået", "More items …": "Mere ...", Next: "Videre", "No emoji found": "Ingen emoji fundet", "No results": "Ingen resultater", Objects: "Objekter", Open: "Åbn", 'Open link to "{resourceTitle}"': 'Åbn link til "{resourceTitle}"', "Open navigation": "Åbn navigation", "Password is secure": "Kodeordet er sikkert", "Pause slideshow": "Suspender fremvisning", "People & Body": "Mennesker & Menneskekroppen", "Pick an emoji": "Vælg en emoji", "Please select a time zone:": "Vælg venligst en tidszone:", Previous: "Forrige", "Related resources": "Relaterede emner", Search: "Søg", "Search results": "Søgeresultater", "Select a tag": "Vælg et mærke", Settings: "Indstillinger", "Settings navigation": "Naviger i indstillinger", "Show password": "Vis kodeord", "Smileys & Emotion": "Smileys & Emotion", "Start slideshow": "Start fremvisning", Submit: "Send", Symbols: "Symboler", "Travel & Places": "Rejser & Rejsemål", "Type to search time zone": "Indtast for at søge efter tidszone", "Unable to search the group": "Kan ikke søge på denne gruppe", "Undo changes": "Fortryd ændringer", "Write message, @ to mention someone, : for emoji autocompletion …": "Skriv besked, bruge @ til at nævne personer, : til emoji valg ..." } }, { locale: "de", translations: { "{tag} (invisible)": "{tag} (unsichtbar)", "{tag} (restricted)": "{tag} (eingeschränkt)", Actions: "Aktionen", Activities: "Aktivitäten", "Animals & Nature": "Tiere & Natur", "Avatar of {displayName}": "Avatar von {displayName}", "Avatar of {displayName}, {status}": "Avatar von {displayName}, {status}", "Cancel changes": "Änderungen verwerfen", "Change title": "Titel ändern", Choose: "Auswählen", "Clear text": "Klartext", Close: "Schließen", "Close modal": "Modal schließen", "Close navigation": "Navigation schließen", "Close sidebar": "Seitenleiste schließen", "Confirm changes": "Änderungen bestätigen", Custom: "Benutzerdefiniert", "Edit item": "Objekt bearbeiten", "Error getting related resources": "Fehler beim Abrufen verwandter Ressourcen", "External documentation for {title}": "Externe Dokumentation für {title}", Favorite: "Favorit", Flags: "Flaggen", "Food & Drink": "Essen & Trinken", "Frequently used": "Häufig verwendet", Global: "Global", "Go back to the list": "Zurück zur Liste", "Hide password": "Passwort verbergen", "Message limit of {count} characters reached": "Nachrichtenlimit von {count} Zeichen erreicht", "More items …": "Weitere Elemente …", Next: "Weiter", "No emoji found": "Kein Emoji gefunden", "No results": "Keine Ergebnisse", Objects: "Gegenstände", Open: "Öffnen", 'Open link to "{resourceTitle}"': 'Link zu "{resourceTitle}" öffnen', "Open navigation": "Navigation öffnen", "Password is secure": "Passwort ist sicher", "Pause slideshow": "Diashow pausieren", "People & Body": "Menschen & Körper", "Pick a date": "Ein Datum auswählen", "Pick a date and a time": "Datum und Uhrzeit auswählen", "Pick a month": "Einen Monat auswählen", "Pick a time": "Eine Uhrzeit auswählen", "Pick a week": "Eine Woche auswählen", "Pick a year": "Ein Jahr auswählen", "Pick an emoji": "Ein Emoji auswählen", "Please select a time zone:": "Bitte wählen Sie eine Zeitzone:", Previous: "Vorherige", "Related resources": "Verwandte Ressourcen", Search: "Suche", "Search results": "Suchergebnisse", "Select a tag": "Schlagwort auswählen", Settings: "Einstellungen", "Settings navigation": "Einstellungen für die Navigation", "Show password": "Passwort anzeigen", "Smileys & Emotion": "Smileys & Emotionen", "Start slideshow": "Diashow starten", Submit: "Einreichen", Symbols: "Symbole", "Travel & Places": "Reisen & Orte", "Type to search time zone": "Tippen, um Zeitzone zu suchen", "Unable to search the group": "Die Gruppe konnte nicht durchsucht werden", "Undo changes": "Änderungen rückgängig machen", "Write message, @ to mention someone, : for emoji autocompletion …": "Nachricht schreiben, @, um jemanden zu erwähnen, : für die automatische Vervollständigung von Emojis … " } }, { locale: "de_DE", translations: { "{tag} (invisible)": "{tag} (unsichtbar)", "{tag} (restricted)": "{tag} (eingeschränkt)", Actions: "Aktionen", Activities: "Aktivitäten", "Animals & Nature": "Tiere & Natur", "Anything shared with the same group of people will show up here": "Alles, das mit derselben Gruppe von Personen geteilt wird, wird hier angezeigt", "Avatar of {displayName}": "Avatar von {displayName}", "Avatar of {displayName}, {status}": "Avatar von {displayName}, {status}", "Cancel changes": "Änderungen verwerfen", "Change title": "Titel ändern", Choose: "Auswählen", "Clear text": "Klartext", Close: "Schließen", "Close modal": "Modal schließen", "Close navigation": "Navigation schließen", "Close sidebar": "Seitenleiste schließen", "Confirm changes": "Änderungen bestätigen", Custom: "Benutzerdefiniert", "Edit item": "Objekt bearbeiten", "Error getting related resources": "Fehler beim Abrufen verwandter Ressourcen", "Error parsing svg": "Fehler beim Einlesen der SVG", "External documentation for {title}": "Externe Dokumentation für {title}", Favorite: "Favorit", Flags: "Flaggen", "Food & Drink": "Essen & Trinken", "Frequently used": "Häufig verwendet", Global: "Global", "Go back to the list": "Zurück zur Liste", "Hide password": "Passwort verbergen", "Message limit of {count} characters reached": "Nachrichtenlimit von {count} Zeichen erreicht", "More items …": "Weitere Elemente …", Next: "Weiter", "No emoji found": "Kein Emoji gefunden", "No results": "Keine Ergebnisse", Objects: "Objekte", Open: "Öffnen", 'Open link to "{resourceTitle}"': 'Link zu "{resourceTitle}" öffnen', "Open navigation": "Navigation öffnen", "Password is secure": "Passwort ist sicher", "Pause slideshow": "Diashow pausieren", "People & Body": "Menschen & Körper", "Pick an emoji": "Ein Emoji auswählen", "Please select a time zone:": "Bitte eine Zeitzone auswählen:", Previous: "Vorherige", "Related resources": "Verwandte Ressourcen", Search: "Suche", "Search results": "Suchergebnisse", "Select a tag": "Schlagwort auswählen", Settings: "Einstellungen", "Settings navigation": "Einstellungen für die Navigation", "Show password": "Passwort anzeigen", "Smileys & Emotion": "Smileys & Emotionen", "Start slideshow": "Diashow starten", Submit: "Einreichen", Symbols: "Symbole", "Travel & Places": "Reisen & Orte", "Type to search time zone": "Tippen, um eine Zeitzone zu suchen", "Unable to search the group": "Die Gruppe kann nicht durchsucht werden", "Undo changes": "Änderungen rückgängig machen", 'Write message, use "@" to mention someone, use ":" for emoji autocompletion …': 'Nachricht schreiben, "@" um jemanden zu erwähnen, ":" für die automatische Vervollständigung von Emojis …' } }, { locale: "el", translations: { "{tag} (invisible)": "{tag} (αόρατο)", "{tag} (restricted)": "{tag} (περιορισμένο)", Actions: "Ενέργειες", Activities: "Δραστηριότητες", "Animals & Nature": "Ζώα & Φύση", "Anything shared with the same group of people will show up here": "Οτιδήποτε μοιράζεται με την ίδια ομάδα ατόμων θα εμφανίζεται εδώ", "Avatar of {displayName}": "Άβαταρ του {displayName}", "Avatar of {displayName}, {status}": "Άβαταρ του {displayName}, {status}", "Cancel changes": "Ακύρωση αλλαγών", "Change title": "Αλλαγή τίτλου", Choose: "Επιλογή", "Clear text": "Εκκαθάριση κειμένου", Close: "Κλείσιμο", "Close modal": "Βοηθητικό κλείσιμο", "Close navigation": "Κλείσιμο πλοήγησης", "Close sidebar": "Κλείσιμο πλευρικής μπάρας", "Confirm changes": "Επιβεβαίωση αλλαγών", Custom: "Προσαρμογή", "Edit item": "Επεξεργασία", "Error getting related resources": "Σφάλμα λήψης σχετικών πόρων", "Error parsing svg": "Σφάλμα ανάλυσης svg", "External documentation for {title}": "Εξωτερική τεκμηρίωση για {title}", Favorite: "Αγαπημένα", Flags: "Σημαίες", "Food & Drink": "Φαγητό & Ποτό", "Frequently used": "Συχνά χρησιμοποιούμενο", Global: "Καθολικό", "Go back to the list": "Επιστροφή στην αρχική λίστα ", "Hide password": "Απόκρυψη κωδικού πρόσβασης", "Message limit of {count} characters reached": "Συμπληρώθηκε το όριο των {count} χαρακτήρων του μηνύματος", "More items …": "Περισσότερα στοιχεία …", Next: "Επόμενο", "No emoji found": "Δεν βρέθηκε emoji", "No results": "Κανένα αποτέλεσμα", Objects: "Αντικείμενα", Open: "Άνοιγμα", 'Open link to "{resourceTitle}"': 'Άνοιγμα συνδέσμου στο "{resourceTitle}"', "Open navigation": "Άνοιγμα πλοήγησης", "Password is secure": "Ο κωδικός πρόσβασης είναι ασφαλής", "Pause slideshow": "Παύση προβολής διαφανειών", "People & Body": "Άνθρωποι & Σώμα", "Pick an emoji": "Επιλέξτε ένα emoji", "Please select a time zone:": "Παρακαλούμε επιλέξτε μια ζώνη ώρας:", Previous: "Προηγούμενο", "Related resources": "Σχετικοί πόροι", Search: "Αναζήτηση", "Search results": "Αποτελέσματα αναζήτησης", "Select a tag": "Επιλογή ετικέτας", Settings: "Ρυθμίσεις", "Settings navigation": "Πλοήγηση ρυθμίσεων", "Show password": "Εμφάνιση κωδικού πρόσβασης", "Smileys & Emotion": "Φατσούλες & Συναίσθημα", "Start slideshow": "Έναρξη προβολής διαφανειών", Submit: "Υποβολή", Symbols: "Σύμβολα", "Travel & Places": "Ταξίδια & Τοποθεσίες", "Type to search time zone": "Πληκτρολογήστε για αναζήτηση ζώνης ώρας", "Unable to search the group": "Δεν είναι δυνατή η αναζήτηση της ομάδας", "Undo changes": "Αναίρεση Αλλαγών", 'Write message, use "@" to mention someone, use ":" for emoji autocompletion …': 'Γράψτε μήνυμα, χρησιμοποιείστε "@" για να αναφέρετε κάποιον, χρησιμοποιείστε ":" για αυτόματη συμπλήρωση emoji …' } }, { locale: "en_GB", translations: { "{tag} (invisible)": "{tag} (invisible)", "{tag} (restricted)": "{tag} (restricted)", Actions: "Actions", Activities: "Activities", "Animals & Nature": "Animals & Nature", "Anything shared with the same group of people will show up here": "Anything shared with the same group of people will show up here", "Avatar of {displayName}": "Avatar of {displayName}", "Avatar of {displayName}, {status}": "Avatar of {displayName}, {status}", "Cancel changes": "Cancel changes", "Change title": "Change title", Choose: "Choose", "Clear text": "Clear text", Close: "Close", "Close modal": "Close modal", "Close navigation": "Close navigation", "Close sidebar": "Close sidebar", "Confirm changes": "Confirm changes", Custom: "Custom", "Edit item": "Edit item", "Error getting related resources": "Error getting related resources", "Error parsing svg": "Error parsing svg", "External documentation for {title}": "External documentation for {title}", Favorite: "Favourite", Flags: "Flags", "Food & Drink": "Food & Drink", "Frequently used": "Frequently used", Global: "Global", "Go back to the list": "Go back to the list", "Hide password": "Hide password", "Message limit of {count} characters reached": "Message limit of {count} characters reached", "More items …": "More items …", Next: "Next", "No emoji found": "No emoji found", "No results": "No results", Objects: "Objects", Open: "Open", 'Open link to "{resourceTitle}"': 'Open link to "{resourceTitle}"', "Open navigation": "Open navigation", "Password is secure": "Password is secure", "Pause slideshow": "Pause slideshow", "People & Body": "People & Body", "Pick an emoji": "Pick an emoji", "Please select a time zone:": "Please select a time zone:", Previous: "Previous", "Related resources": "Related resources", Search: "Search", "Search results": "Search results", "Select a tag": "Select a tag", Settings: "Settings", "Settings navigation": "Settings navigation", "Show password": "Show password", "Smileys & Emotion": "Smileys & Emotion", "Start slideshow": "Start slideshow", Submit: "Submit", Symbols: "Symbols", "Travel & Places": "Travel & Places", "Type to search time zone": "Type to search time zone", "Unable to search the group": "Unable to search the group", "Undo changes": "Undo changes", 'Write message, use "@" to mention someone, use ":" for emoji autocompletion …': 'Write message, use "@" to mention someone, use ":" for emoji autocompletion …' } }, { locale: "eo", translations: { "{tag} (invisible)": "{tag} (kaŝita)", "{tag} (restricted)": "{tag} (limigita)", Actions: "Agoj", Activities: "Aktiveco", "Animals & Nature": "Bestoj & Naturo", Choose: "Elektu", Close: "Fermu", Custom: "Propra", Flags: "Flagoj", "Food & Drink": "Manĝaĵo & Trinkaĵo", "Frequently used": "Ofte uzataj", "Message limit of {count} characters reached": "La limo je {count} da literoj atingita", Next: "Sekva", "No emoji found": "La emoĝio forestas", "No results": "La rezulto forestas", Objects: "Objektoj", "Pause slideshow": "Payzi bildprezenton", "People & Body": "Homoj & Korpo", "Pick an emoji": "Elekti emoĝion ", Previous: "Antaŭa", Search: "Serĉi", "Search results": "Serĉrezultoj", "Select a tag": "Elektu etikedon", Settings: "Agordo", "Settings navigation": "Agorda navigado", "Smileys & Emotion": "Ridoj kaj Emocioj", "Start slideshow": "Komenci bildprezenton", Symbols: "Signoj", "Travel & Places": "Vojaĵoj & Lokoj", "Unable to search the group": "Ne eblas serĉi en la grupo", "Write message, @ to mention someone …": "Mesaĝi, uzu @ por mencii iun ..." } }, { locale: "es", translations: { "{tag} (invisible)": "{tag} (invisible)", "{tag} (restricted)": "{tag} (restringido)", Actions: "Acciones", Activities: "Actividades", "Animals & Nature": "Animales y naturaleza", "Anything shared with the same group of people will show up here": "Cualquier cosa que sea compartida con el mismo grupo de personas se mostrará aquí", "Avatar of {displayName}": "Avatar de {displayName}", "Avatar of {displayName}, {status}": "Avatar de {displayName}, {status}", "Cancel changes": "Cancelar cambios", "Change title": "Cambiar título", Choose: "Elegir", "Clear text": "Limpiar texto", Close: "Cerrar", "Close modal": "Cerrar modal", "Close navigation": "Cerrar navegación", "Close sidebar": "Cerrar barra lateral", "Confirm changes": "Confirmar cambios", Custom: "Personalizado", "Edit item": "Editar elemento", "Error getting related resources": "Se encontró un error al obtener los recursos relacionados", "Error parsing svg": "Error procesando svg", "External documentation for {title}": "Documentacion externa de {title}", Favorite: "Favorito", Flags: "Banderas", "Food & Drink": "Comida y bebida", "Frequently used": "Usado con frecuenca", Global: "Global", "Go back to the list": "Volver a la lista", "Hide password": "Ocultar contraseña", "Message limit of {count} characters reached": "El mensaje ha alcanzado el límite de {count} caracteres", "More items …": "Más ítems...", Next: "Siguiente", "No emoji found": "No hay ningún emoji", "No results": " Ningún resultado", Objects: "Objetos", Open: "Abrir", 'Open link to "{resourceTitle}"': 'Abrir enlace a "{resourceTitle}"', "Open navigation": "Abrir navegación", "Password is secure": "La contraseña es segura", "Pause slideshow": "Pausar la presentación ", "People & Body": "Personas y cuerpos", "Pick an emoji": "Elegir un emoji", "Please select a time zone:": "Por favor elige un huso de horario:", Previous: "Anterior", "Related resources": "Recursos relacionados", Search: "Buscar", "Search results": "Resultados de la búsqueda", "Select a tag": "Seleccione una etiqueta", Settings: "Ajustes", "Settings navigation": "Navegación por ajustes", "Show password": "Mostrar contraseña", "Smileys & Emotion": "Smileys y emoticonos", "Start slideshow": "Iniciar la presentación", Submit: "Enviar", Symbols: "Símbolos", "Travel & Places": "Viajes y lugares", "Type to search time zone": "Escribe para buscar un huso de horario", "Unable to search the group": "No es posible buscar en el grupo", "Undo changes": "Deshacer cambios", 'Write message, use "@" to mention someone, use ":" for emoji autocompletion …': 'Escribir mensaje, utilice "@" para mencionar a alguien, utilice ":" para autocompletado de emojis ...' } }, { locale: "eu", translations: { "{tag} (invisible)": "{tag} (ikusezina)", "{tag} (restricted)": "{tag} (mugatua)", Actions: "Ekintzak", Activities: "Jarduerak", "Animals & Nature": "Animaliak eta Natura", "Anything shared with the same group of people will show up here": "Pertsona-talde berarekin partekatutako edozer agertuko da hemen", "Avatar of {displayName}": "{displayName}-(e)n irudia", "Avatar of {displayName}, {status}": "{displayName} -(e)n irudia, {status}", "Cancel changes": "Ezeztatu aldaketak", "Change title": "Aldatu titulua", Choose: "Aukeratu", "Clear text": "Garbitu testua", Close: "Itxi", "Close modal": "Itxi modala", "Close navigation": "Itxi nabigazioa", "Close sidebar": "Itxi albo-barra", "Confirm changes": "Baieztatu aldaketak", Custom: "Pertsonalizatua", "Edit item": "Editatu elementua", "Error getting related resources": "Errorea erlazionatutako baliabideak lortzerakoan", "Error parsing svg": "Errore bat gertatu da svg-a analizatzean", "External documentation for {title}": "Kanpoko dokumentazioa {title}(r)entzat", Favorite: "Gogokoa", Flags: "Banderak", "Food & Drink": "Janaria eta edariak", "Frequently used": "Askotan erabilia", Global: "Globala", "Go back to the list": "Bueltatu zerrendara", "Hide password": "Ezkutatu pasahitza", "Message limit of {count} characters reached": "Mezuaren {count} karaketere-limitera heldu zara", "More items …": "Elementu gehiago …", Next: "Hurrengoa", "No emoji found": "Ez da emojirik aurkitu", "No results": "Emaitzarik ez", Objects: "Objektuak", Open: "Ireki", 'Open link to "{resourceTitle}"': 'Ireki esteka: "{resourceTitle}"', "Open navigation": "Ireki nabigazioa", "Password is secure": "Pasahitza segurua da", "Pause slideshow": "Pausatu diaporama", "People & Body": "Jendea eta gorputza", "Pick an emoji": "Hautatu emoji bat", "Please select a time zone:": "Mesedez hautatu ordu-zona bat:", Previous: "Aurrekoa", "Related resources": "Erlazionatutako baliabideak", Search: "Bilatu", "Search results": "Bilaketa emaitzak", "Select a tag": "Hautatu etiketa bat", Settings: "Ezarpenak", "Settings navigation": "Nabigazio ezarpenak", "Show password": "Erakutsi pasahitza", "Smileys & Emotion": "Smileyak eta emozioa", "Start slideshow": "Hasi diaporama", Submit: "Bidali", Symbols: "Sinboloak", "Travel & Places": "Bidaiak eta lekuak", "Type to search time zone": "Idatzi ordu-zona bat bilatzeko", "Unable to search the group": "Ezin izan da taldea bilatu", "Undo changes": "Aldaketak desegin", 'Write message, use "@" to mention someone, use ":" for emoji autocompletion …': 'Idatzi mezua, erabili "@" norbait aipatzeko, erabili ":" emojiak automatikoki osatzeko...' } }, { locale: "fi_FI", translations: { "{tag} (invisible)": "{tag} (näkymätön)", "{tag} (restricted)": "{tag} (rajoitettu)", Actions: "Toiminnot", Activities: "Aktiviteetit", "Animals & Nature": "Eläimet & luonto", "Avatar of {displayName}": "Käyttäjän {displayName} avatar", "Avatar of {displayName}, {status}": "Käyttäjän {displayName} avatar, {status}", "Cancel changes": "Peruuta muutokset", Choose: "Valitse", Close: "Sulje", "Close navigation": "Sulje navigaatio", "Confirm changes": "Vahvista muutokset", Custom: "Mukautettu", "Edit item": "Muokkaa kohdetta", "External documentation for {title}": "Ulkoinen dokumentaatio kohteelle {title}", Flags: "Liput", "Food & Drink": "Ruoka & juoma", "Frequently used": "Usein käytetyt", Global: "Yleinen", "Go back to the list": "Siirry takaisin listaan", "Message limit of {count} characters reached": "Viestin merkken enimmäisimäärä {count} täynnä ", Next: "Seuraava", "No emoji found": "Emojia ei löytynyt", "No results": "Ei tuloksia", Objects: "Esineet & asiat", "Open navigation": "Avaa navigaatio", "Pause slideshow": "Keskeytä diaesitys", "People & Body": "Ihmiset & keho", "Pick an emoji": "Valitse emoji", "Please select a time zone:": "Valitse aikavyöhyke:", Previous: "Edellinen", Search: "Etsi", "Search results": "Hakutulokset", "Select a tag": "Valitse tagi", Settings: "Asetukset", "Settings navigation": "Asetusnavigaatio", "Smileys & Emotion": "Hymiöt & tunteet", "Start slideshow": "Aloita diaesitys", Submit: "Lähetä", Symbols: "Symbolit", "Travel & Places": "Matkustus & kohteet", "Type to search time zone": "Kirjoita etsiäksesi aikavyöhyke", "Unable to search the group": "Ryhmää ei voi hakea", "Undo changes": "Kumoa muutokset", "Write message, @ to mention someone, : for emoji autocompletion …": "Kirjoita viesti, @ mainitaksesi käyttäjän, : emojin automaattitäydennykseen…" } }, { locale: "fr", translations: { "{tag} (invisible)": "{tag} (invisible)", "{tag} (restricted)": "{tag} (restreint)", Actions: "Actions", Activities: "Activités", "Animals & Nature": "Animaux & Nature", "Anything shared with the same group of people will show up here": "Tout ce qui est partagé avec le même groupe de personnes apparaîtra ici", "Avatar of {displayName}": "Avatar de {displayName}", "Avatar of {displayName}, {status}": "Avatar de {displayName}, {status}", "Cancel changes": "Annuler les modifications", "Change title": "Modifier le titre", Choose: "Choisir", "Clear text": "Effacer le texte", Close: "Fermer", "Close modal": "Fermer la fenêtre", "Close navigation": "Fermer la navigation", "Close sidebar": "Fermer la barre latérale", "Confirm changes": "Confirmer les modifications", Custom: "Personnalisé", "Edit item": "Éditer l'élément", "Error getting related resources": "Erreur à la récupération des ressources liées", "External documentation for {title}": "Documentation externe pour {title}", Favorite: "Favori", Flags: "Drapeaux", "Food & Drink": "Nourriture & Boissons", "Frequently used": "Utilisés fréquemment", Global: "Global", "Go back to the list": "Retourner à la liste", "Hide password": "Cacher le mot de passe", "Message limit of {count} characters reached": "Limite de messages de {count} caractères atteinte", "More items …": "Plus d'éléments...", Next: "Suivant", "No emoji found": "Pas d’émoji trouvé", "No results": "Aucun résultat", Objects: "Objets", Open: "Ouvrir", 'Open link to "{resourceTitle}"': 'Ouvrir le lien vers "{resourceTitle}"', "Open navigation": "Ouvrir la navigation", "Password is secure": "Le mot de passe est sécurisé", "Pause slideshow": "Mettre le diaporama en pause", "People & Body": "Personnes & Corps", "Pick an emoji": "Choisissez un émoji", "Please select a time zone:": "Sélectionnez un fuseau horaire : ", Previous: "Précédent", "Related resources": "Ressources liées", Search: "Chercher", "Search results": "Résultats de recherche", "Select a tag": "Sélectionnez une balise", Settings: "Paramètres", "Settings navigation": "Navigation dans les paramètres", "Show password": "Afficher le mot de passe", "Smileys & Emotion": "Smileys & Émotions", "Start slideshow": "Démarrer le diaporama", Submit: "Valider", Symbols: "Symboles", "Travel & Places": "Voyage & Lieux", "Type to search time zone": "Saisissez les premiers lettres pour rechercher un fuseau horaire", "Unable to search the group": "Impossible de chercher le groupe", "Undo changes": "Annuler les changements", "Write message, @ to mention someone, : for emoji autocompletion …": "Ecrire un message, @ pour mentionner quelqu'un, : pour l'auto-complétion des émoticônes" } }, { locale: "gl", translations: { "{tag} (invisible)": "{tag} (invisíbel)", "{tag} (restricted)": "{tag} (restrinxido)", Actions: "Accións", Activities: "Actividades", "Animals & Nature": "Animais e natureza", "Cancel changes": "Cancelar os cambios", Choose: "Escoller", Close: "Pechar", "Confirm changes": "Confirma os cambios", Custom: "Personalizado", "External documentation for {title}": "Documentación externa para {title}", Flags: "Bandeiras", "Food & Drink": "Comida e bebida", "Frequently used": "Usado con frecuencia", "Message limit of {count} characters reached": "Acadouse o límite de {count} caracteres por mensaxe", Next: "Seguinte", "No emoji found": "Non se atopou ningún «emoji»", "No results": "Sen resultados", Objects: "Obxectos", "Pause slideshow": "Pausar o diaporama", "People & Body": "Persoas e corpo", "Pick an emoji": "Escolla un «emoji»", Previous: "Anterir", Search: "Buscar", "Search results": "Resultados da busca", "Select a tag": "Seleccione unha etiqueta", Settings: "Axustes", "Settings navigation": "Navegación polos axustes", "Smileys & Emotion": "Sorrisos e emocións", "Start slideshow": "Iniciar o diaporama", Submit: "Enviar", Symbols: "Símbolos", "Travel & Places": "Viaxes e lugares", "Unable to search the group": "Non foi posíbel buscar o grupo", "Write message, @ to mention someone …": "Escriba a mensaxe, @ para mencionar a alguén…" } }, { locale: "he", translations: { "{tag} (invisible)": "{tag} (נסתר)", "{tag} (restricted)": "{tag} (מוגבל)", Actions: "פעולות", Activities: "פעילויות", "Animals & Nature": "חיות וטבע", Choose: "בחירה", Close: "סגירה", Custom: "בהתאמה אישית", Flags: "דגלים", "Food & Drink": "מזון ומשקאות", "Frequently used": "בשימוש תדיר", Next: "הבא", "No emoji found": "לא נמצא אמוג׳י", "No results": "אין תוצאות", Objects: "חפצים", "Pause slideshow": "השהיית מצגת", "People & Body": "אנשים וגוף", "Pick an emoji": "נא לבחור אמוג׳י", Previous: "הקודם", Search: "חיפוש", "Search results": "תוצאות חיפוש", "Select a tag": "בחירת תגית", Settings: "הגדרות", "Smileys & Emotion": "חייכנים ורגשונים", "Start slideshow": "התחלת המצגת", Symbols: "סמלים", "Travel & Places": "טיולים ומקומות", "Unable to search the group": "לא ניתן לחפש בקבוצה" } }, { locale: "hu_HU", translations: { "{tag} (invisible)": "{tag} (láthatatlan)", "{tag} (restricted)": "{tag} (korlátozott)", Actions: "Műveletek", Activities: "Tevékenységek", "Animals & Nature": "Állatok és természet", "Avatar of {displayName}": "{displayName} profilképe", "Avatar of {displayName}, {status}": "{displayName} profilképe, {status}", "Cancel changes": "Változtatások elvetése", Choose: "Válassszon", Close: "Bezárás", "Close modal": "Ablak bezárása", "Close navigation": "Navigáció bezárása", "Confirm changes": "Változtatások megerősítése", Custom: "Egyéni", "Edit item": "Elem szerkesztése", "External documentation for {title}": "Külső dokumentáció ehhez: {title}", Flags: "Zászló", "Food & Drink": "Étel és ital", "Frequently used": "Gyakran használt", Global: "Globális", "Go back to the list": "Ugrás vissza a listához", items: "elemek", "Message limit of {count} characters reached": "{count} karakteres üzenetkorlát elérve", "More {dashboardItemType} …": "Több {dashboardItemType}…", Next: "Következő", "No emoji found": "Nem található emodzsi", "No results": "Nincs találat", Objects: "Tárgyak", Open: "Megnyitás", "Open navigation": "Navigáció megnyitása", "Pause slideshow": "Diavetítés szüneteltetése", "People & Body": "Emberek és test", "Pick an emoji": "Válasszon egy emodzsit", "Please select a time zone:": "Válasszon időzónát:", Previous: "Előző", Search: "Keresés", "Search results": "Találatok", "Select a tag": "Válasszon címkét", Settings: "Beállítások", "Settings navigation": "Navigáció a beállításokban", "Smileys & Emotion": "Mosolyok és érzelmek", "Start slideshow": "Diavetítés indítása", Submit: "Beküldés", Symbols: "Szimbólumok", "Travel & Places": "Utazás és helyek", "Type to search time zone": "Gépeljen az időzóna kereséséhez", "Unable to search the group": "A csoport nem kereshető", "Undo changes": "Változtatások visszavonása", "Write message, @ to mention someone, : for emoji autocompletion …": "Írjon üzenetet, @ valaki megemlítéséhez, : az emodzsik automatikus kiegészítéséhez…" } }, { locale: "is", translations: { "{tag} (invisible)": "{tag} (ósýnilegt)", "{tag} (restricted)": "{tag} (takmarkað)", Actions: "Aðgerðir", Activities: "Aðgerðir", "Animals & Nature": "Dýr og náttúra", Choose: "Velja", Close: "Loka", Custom: "Sérsniðið", Flags: "Flögg", "Food & Drink": "Matur og drykkur", "Frequently used": "Oftast notað", Next: "Næsta", "No emoji found": "Ekkert tjáningartákn fannst", "No results": "Engar niðurstöður", Objects: "Hlutir", "Pause slideshow": "Gera hlé á skyggnusýningu", "People & Body": "Fólk og líkami", "Pick an emoji": "Veldu tjáningartákn", Previous: "Fyrri", Search: "Leita", "Search results": "Leitarniðurstöður", "Select a tag": "Veldu merki", Settings: "Stillingar", "Smileys & Emotion": "Broskallar og tilfinningar", "Start slideshow": "Byrja skyggnusýningu", Symbols: "Tákn", "Travel & Places": "Staðir og ferðalög", "Unable to search the group": "Get ekki leitað í hópnum" } }, { locale: "it", translations: { "{tag} (invisible)": "{tag} (invisibile)", "{tag} (restricted)": "{tag} (limitato)", Actions: "Azioni", Activities: "Attività", "Animals & Nature": "Animali e natura", "Anything shared with the same group of people will show up here": "Tutto ciò che è stato condiviso con lo stesso gruppo di persone viene visualizzato qui", "Avatar of {displayName}": "Avatar di {displayName}", "Avatar of {displayName}, {status}": "Avatar di {displayName}, {status}", "Cancel changes": "Annulla modifiche", "Change title": "Modifica il titolo", Choose: "Scegli", "Clear text": "Cancella il testo", Close: "Chiudi", "Close modal": "Chiudi il messaggio modale", "Close navigation": "Chiudi la navigazione", "Close sidebar": "Chiudi la barra laterale", "Confirm changes": "Conferma modifiche", Custom: "Personalizzato", "Edit item": "Modifica l'elemento", "Error getting related resources": "Errore nell'ottenere risorse correlate", "Error parsing svg": "Errore nell'analizzare l'svg", "External documentation for {title}": "Documentazione esterna per {title}", Favorite: "Preferito", Flags: "Bandiere", "Food & Drink": "Cibo e bevande", "Frequently used": "Usati di frequente", Global: "Globale", "Go back to the list": "Torna all'elenco", "Hide password": "Nascondi la password", "Message limit of {count} characters reached": "Limite dei messaggi di {count} caratteri raggiunto", "More items …": "Più elementi ...", Next: "Successivo", "No emoji found": "Nessun emoji trovato", "No results": "Nessun risultato", Objects: "Oggetti", Open: "Apri", 'Open link to "{resourceTitle}"': 'Apri il link a "{resourceTitle}"', "Open navigation": "Apri la navigazione", "Password is secure": "La password è sicura", "Pause slideshow": "Presentazione in pausa", "People & Body": "Persone e corpo", "Pick an emoji": "Scegli un emoji", "Please select a time zone:": "Si prega di selezionare un fuso orario:", Previous: "Precedente", "Related resources": "Risorse correlate", Search: "Cerca", "Search results": "Risultati di ricerca", "Select a tag": "Seleziona un'etichetta", Settings: "Impostazioni", "Settings navigation": "Navigazione delle impostazioni", "Show password": "Mostra la password", "Smileys & Emotion": "Faccine ed emozioni", "Start slideshow": "Avvia presentazione", Submit: "Invia", Symbols: "Simboli", "Travel & Places": "Viaggi e luoghi", "Type to search time zone": "Digita per cercare un fuso orario", "Unable to search the group": "Impossibile cercare il gruppo", "Undo changes": "Cancella i cambiamenti", 'Write message, use "@" to mention someone, use ":" for emoji autocompletion …': 'Scrivi un messaggio, "@" per menzionare qualcuno, ":" per il completamento automatico delle emoji ...' } }, { locale: "ja_JP", translations: { "{tag} (invisible)": "{タグ} (不可視)", "{tag} (restricted)": "{タグ} (制限付)", Actions: "操作", Activities: "アクティビティ", "Animals & Nature": "動物と自然", "Anything shared with the same group of people will show up here": "同じグループで共有しているものは、全てここに表示されます", "Avatar of {displayName}": "{displayName} のアバター", "Avatar of {displayName}, {status}": "{displayName}, {status} のアバター", "Cancel changes": "変更をキャンセル", "Change title": "タイトルを変更", Choose: "選択", "Clear text": "テキストをクリア", Close: "閉じる", "Close modal": "モーダルを閉じる", "Close navigation": "ナビゲーションを閉じる", "Close sidebar": "サイドバーを閉じる", "Confirm changes": "変更を承認", Custom: "カスタム", "Edit item": "編集", "Error getting related resources": "関連リソースの取得エラー", "External documentation for {title}": "{title} のための添付文書", Favorite: "お気に入り", Flags: "国旗", "Food & Drink": "食べ物と飲み物", "Frequently used": "よく使うもの", Global: "全体", "Go back to the list": "リストに戻る", "Hide password": "パスワードを非表示", "Message limit of {count} characters reached": "{count} 文字のメッセージ上限に達しています", "More items …": "他のアイテム", Next: "次", "No emoji found": "絵文字が見つかりません", "No results": "なし", Objects: "物", Open: "開く", 'Open link to "{resourceTitle}"': '"{resourceTitle}"のリンクを開く', "Open navigation": "ナビゲーションを開く", "Password is secure": "パスワードは保護されています", "Pause slideshow": "スライドショーを一時停止", "People & Body": "様々な人と体の部位", "Pick an emoji": "絵文字を選択", "Please select a time zone:": "タイムゾーンを選んで下さい：", Previous: "前", "Related resources": "関連リソース", Search: "検索", "Search results": "検索結果", "Select a tag": "タグを選択", Settings: "設定", "Settings navigation": "ナビゲーション設定", "Show password": "パスワードを表示", "Smileys & Emotion": "感情表現", "Start slideshow": "スライドショーを開始", Submit: "提出", Symbols: "記号", "Travel & Places": "旅行と場所", "Type to search time zone": "タイムゾーン検索のため入力してください", "Unable to search the group": "グループを検索できません", "Undo changes": "変更を取り消し", "Write message, @ to mention someone, : for emoji autocompletion …": "メッセージを書く、@で誰かを紹介する、: で絵文字を自動補完する ..." } }, { locale: "lt_LT", translations: { "{tag} (invisible)": "{tag} (nematoma)", "{tag} (restricted)": "{tag} (apribota)", Actions: "Veiksmai", Activities: "Veiklos", "Animals & Nature": "Gyvūnai ir gamta", Choose: "Pasirinkti", Close: "Užverti", Custom: "Tinkinti", "External documentation for {title}": "Išorinė {title} dokumentacija", Flags: "Vėliavos", "Food & Drink": "Maistas ir gėrimai", "Frequently used": "Dažniausiai naudoti", "Message limit of {count} characters reached": "Pasiekta {count} simbolių žinutės riba", Next: "Kitas", "No emoji found": "Nerasta jaustukų", "No results": "Nėra rezultatų", Objects: "Objektai", "Pause slideshow": "Pristabdyti skaidrių rodymą", "People & Body": "Žmonės ir kūnas", "Pick an emoji": "Pasirinkti jaustuką", Previous: "Ankstesnis", Search: "Ieškoti", "Search results": "Paieškos rezultatai", "Select a tag": "Pasirinkti žymę", Settings: "Nustatymai", "Settings navigation": "Naršymas nustatymuose", "Smileys & Emotion": "Šypsenos ir emocijos", "Start slideshow": "Pradėti skaidrių rodymą", Submit: "Pateikti", Symbols: "Simboliai", "Travel & Places": "Kelionės ir vietos", "Unable to search the group": "Nepavyko atlikti paiešką grupėje", "Write message, @ to mention someone …": "Rašykite žinutę, naudokite @ norėdami kažką paminėti…" } }, { locale: "lv", translations: { "{tag} (invisible)": "{tag} (neredzams)", "{tag} (restricted)": "{tag} (ierobežots)", Choose: "Izvēlēties", Close: "Aizvērt", Next: "Nākamais", "No results": "Nav rezultātu", "Pause slideshow": "Pauzēt slaidrādi", Previous: "Iepriekšējais", "Select a tag": "Izvēlēties birku", Settings: "Iestatījumi", "Start slideshow": "Sākt slaidrādi" } }, { locale: "mk", translations: { "{tag} (invisible)": "{tag} (невидливо)", "{tag} (restricted)": "{tag} (ограничено)", Actions: "Акции", Activities: "Активности", "Animals & Nature": "Животни & Природа", "Avatar of {displayName}": "Аватар на {displayName}", "Avatar of {displayName}, {status}": "Аватар на {displayName}, {status}", "Cancel changes": "Откажи ги промените", "Change title": "Промени наслов", Choose: "Избери", Close: "Затвори", "Close modal": "Затвори модал", "Close navigation": "Затвори навигација", "Confirm changes": "Потврди ги промените", Custom: "Прилагодени", "Edit item": "Уреди", "External documentation for {title}": "Надворешна документација за {title}", Favorite: "Фаворити", Flags: "Знамиња", "Food & Drink": "Храна & Пијалоци", "Frequently used": "Најчесто користени", Global: "Глобално", "Go back to the list": "Врати се на листата", items: "ставки", "Message limit of {count} characters reached": "Ограничувањето на должината на пораката од {count} карактери е надминато", "More {dashboardItemType} …": "Повеќе {dashboardItemType} …", Next: "Следно", "No emoji found": "Не се пронајдени емотикони", "No results": "Нема резултати", Objects: "Објекти", Open: "Отвори", "Open navigation": "Отвори навигација", "Pause slideshow": "Пузирај слајдшоу", "People & Body": "Луѓе & Тело", "Pick an emoji": "Избери емотикон", "Please select a time zone:": "Изберете временска зона:", Previous: "Предходно", Search: "Барај", "Search results": "Резултати од барувањето", "Select a tag": "Избери ознака", Settings: "Параметри", "Settings navigation": "Параметри за навигација", "Smileys & Emotion": "Смешковци & Емотикони", "Start slideshow": "Стартувај слајдшоу", Submit: "Испрати", Symbols: "Симболи", "Travel & Places": "Патувања & Места", "Type to search time zone": "Напишете за да пребарате временска зона", "Unable to search the group": "Неможе да се принајде групата", "Undo changes": "Врати ги промените", "Write message, @ to mention someone, : for emoji autocompletion …": "Напиши порака, @ за да спомнете некого, : за емотинони автоатско комплетирање ..." } }, { locale: "my", translations: { "{tag} (invisible)": "{tag} (ကွယ်ဝှက်ထား)", "{tag} (restricted)": "{tag} (ကန့်သတ်)", Actions: "လုပ်ဆောင်ချက်များ", Activities: "ပြုလုပ်ဆောင်တာများ", "Animals & Nature": "တိရစ္ဆာန်များနှင့် သဘာဝ", "Avatar of {displayName}": "{displayName} ၏ ကိုယ်ပွား", "Cancel changes": "ပြောင်းလဲမှုများ ပယ်ဖျက်ရန်", Choose: "ရွေးချယ်ရန်", Close: "ပိတ်ရန်", "Confirm changes": "ပြောင်းလဲမှုများ အတည်ပြုရန်", Custom: "အလိုကျချိန်ညှိမှု", "External documentation for {title}": "{title} အတွက် ပြင်ပ စာရွက်စာတမ်း", Flags: "အလံများ", "Food & Drink": "အစားအသောက်", "Frequently used": "မကြာခဏအသုံးပြုသော", Global: "ကမ္ဘာလုံးဆိုင်ရာ", "Message limit of {count} characters reached": "ကန့်သတ် စာလုံးရေ {count} လုံး ပြည့်ပါပြီ", Next: "နောက်သို့ဆက်ရန်", "No emoji found": "အီမိုဂျီ ရှာဖွေမတွေ့နိုင်ပါ", "No results": "ရလဒ်မရှိပါ", Objects: "အရာဝတ္ထုများ", "Pause slideshow": "စလိုက်ရှိုး ခေတ္တရပ်ရန်", "People & Body": "လူပုဂ္ဂိုလ်များနှင့် ခန္ဓာကိုယ်", "Pick an emoji": "အီမိုဂျီရွေးရန်", "Please select a time zone:": "ဒေသစံတော်ချိန် ရွေးချယ်ပေးပါ", Previous: "ယခင်", Search: "ရှာဖွေရန်", "Search results": "ရှာဖွေမှု ရလဒ်များ", "Select a tag": "tag ရွေးချယ်ရန်", Settings: "ချိန်ညှိချက်များ", "Settings navigation": "ချိန်ညှိချက်အညွှန်း", "Smileys & Emotion": "စမိုင်လီများနှင့် အီမိုရှင်း", "Start slideshow": "စလိုက်ရှိုးအား စတင်ရန်", Submit: "တင်သွင်းရန်", Symbols: "သင်္ကေတများ", "Travel & Places": "ခရီးသွားလာခြင်းနှင့် နေရာများ", "Type to search time zone": "ဒေသစံတော်ချိန်များ ရှာဖွေရန် စာရိုက်ပါ", "Unable to search the group": "အဖွဲ့အား ရှာဖွေ၍ မရနိုင်ပါ", "Write message, @ to mention someone …": "စာရေးသားရန်၊ တစ်စုံတစ်ဦးအား @ အသုံးပြု ရည်ညွှန်းရန်..." } }, { locale: "nb_NO", translations: { "{tag} (invisible)": "{tag} (usynlig)", "{tag} (restricted)": "{tag} (beskyttet)", Actions: "Handlinger", Activities: "Aktiviteter", "Animals & Nature": "Dyr og natur", "Anything shared with the same group of people will show up here": "Alt som er delt med den samme gruppen vil vises her", "Avatar of {displayName}": "Avataren til {displayName}", "Avatar of {displayName}, {status}": "{displayName}'s avatar, {status}", "Cancel changes": "Avbryt endringer", "Change title": "Endre tittel", Choose: "Velg", "Clear text": "Fjern tekst", Close: "Lukk", "Close modal": "Lukk modal", "Close navigation": "Lukk navigasjon", "Close sidebar": "Lukk sidepanel", "Confirm changes": "Bekreft endringer", Custom: "Tilpasset", "Edit item": "Rediger", "Error getting related resources": "Feil ved henting av relaterte ressurser", "External documentation for {title}": "Ekstern dokumentasjon for {title}", Favorite: "Favoritt", Flags: "Flagg", "Food & Drink": "Mat og drikke", "Frequently used": "Ofte brukt", Global: "Global", "Go back to the list": "Gå tilbake til listen", "Hide password": "Skjul passord", "Message limit of {count} characters reached": "Karakter begrensing {count} nådd i melding", "More items …": "Flere gjenstander...", Next: "Neste", "No emoji found": "Fant ingen emoji", "No results": "Ingen resultater", Objects: "Objekter", Open: "Åpne", 'Open link to "{resourceTitle}"': 'Åpne link til "{resourceTitle}"', "Open navigation": "Åpne navigasjon", "Password is secure": "Passordet er sikkert", "Pause slideshow": "Pause lysbildefremvisning", "People & Body": "Mennesker og kropp", "Pick an emoji": "Velg en emoji", "Please select a time zone:": "Vennligst velg tidssone", Previous: "Forrige", "Related resources": "Relaterte ressurser", Search: "Søk", "Search results": "Søkeresultater", "Select a tag": "Velg en merkelapp", Settings: "Innstillinger", "Settings navigation": "Navigasjonsinstillinger", "Show password": "Vis passord", "Smileys & Emotion": "Smilefjes og følelser", "Start slideshow": "Start lysbildefremvisning", Submit: "Send", Symbols: "Symboler", "Travel & Places": "Reise og steder", "Type to search time zone": "Tast for å søke etter tidssone", "Unable to search the group": "Kunne ikke søke i gruppen", "Undo changes": "Tilbakestill endringer", "Write message, @ to mention someone, : for emoji autocompletion …": "Skriv melding, @ for å nevne noen, : for emoji-autofullføring…" } }, { locale: "nl", translations: { "{tag} (invisible)": "{tag} (onzichtbaar)", "{tag} (restricted)": "{tag} (beperkt)", Actions: "Acties", Activities: "Activiteiten", "Animals & Nature": "Dieren & Natuur", "Avatar of {displayName}": "Avatar van {displayName}", "Avatar of {displayName}, {status}": "Avatar van {displayName}, {status}", "Cancel changes": "Wijzigingen annuleren", Choose: "Kies", Close: "Sluiten", "Close navigation": "Navigatie sluiten", "Confirm changes": "Wijzigingen bevestigen", Custom: "Aangepast", "Edit item": "Item bewerken", "External documentation for {title}": "Externe documentatie voor {title}", Flags: "Vlaggen", "Food & Drink": "Eten & Drinken", "Frequently used": "Vaak gebruikt", Global: "Globaal", "Go back to the list": "Ga terug naar de lijst", "Message limit of {count} characters reached": "Berichtlimiet van {count} karakters bereikt", Next: "Volgende", "No emoji found": "Geen emoji gevonden", "No results": "Geen resultaten", Objects: "Objecten", "Open navigation": "Navigatie openen", "Pause slideshow": "Pauzeer diavoorstelling", "People & Body": "Mensen & Lichaam", "Pick an emoji": "Kies een emoji", "Please select a time zone:": "Selecteer een tijdzone:", Previous: "Vorige", Search: "Zoeken", "Search results": "Zoekresultaten", "Select a tag": "Selecteer een label", Settings: "Instellingen", "Settings navigation": "Instellingen navigatie", "Smileys & Emotion": "Smileys & Emotie", "Start slideshow": "Start diavoorstelling", Submit: "Verwerken", Symbols: "Symbolen", "Travel & Places": "Reizen & Plaatsen", "Type to search time zone": "Type om de tijdzone te zoeken", "Unable to search the group": "Kan niet in de groep zoeken", "Undo changes": "Wijzigingen ongedaan maken", "Write message, @ to mention someone, : for emoji autocompletion …": "Schrijf bericht, @ om iemand te noemen, : voor emoji auto-aanvullen ..." } }, { locale: "oc", translations: { "{tag} (invisible)": "{tag} (invisible)", "{tag} (restricted)": "{tag} (limit)", Actions: "Accions", Choose: "Causir", Close: "Tampar", Next: "Seguent", "No results": "Cap de resultat", "Pause slideshow": "Metre en pausa lo diaporama", Previous: "Precedent", "Select a tag": "Seleccionar una etiqueta", Settings: "Paramètres", "Start slideshow": "Lançar lo diaporama" } }, { locale: "pl", translations: { "{tag} (invisible)": "{tag} (niewidoczna)", "{tag} (restricted)": "{tag} (ograniczona)", Actions: "Działania", Activities: "Aktywność", "Animals & Nature": "Zwierzęta i natura", "Anything shared with the same group of people will show up here": "Tutaj pojawi się wszystko, co zostało udostępnione tej samej grupie osób", "Avatar of {displayName}": "Awatar {displayName}", "Avatar of {displayName}, {status}": "Awatar {displayName}, {status}", "Cancel changes": "Anuluj zmiany", "Change title": "Zmień tytuł", Choose: "Wybierz", "Clear text": "Wyczyść tekst", Close: "Zamknij", "Close modal": "Zamknij modal", "Close navigation": "Zamknij nawigację", "Close sidebar": "Zamknij pasek boczny", "Confirm changes": "Potwierdź zmiany", Custom: "Zwyczajne", "Edit item": "Edytuj element", "Error getting related resources": "Błąd podczas pobierania powiązanych zasobów", "Error parsing svg": "Błąd podczas analizowania svg", "External documentation for {title}": "Dokumentacja zewnętrzna dla {title}", Favorite: "Ulubiony", Flags: "Flagi", "Food & Drink": "Jedzenie i picie", "Frequently used": "Często używane", Global: "Globalnie", "Go back to the list": "Powrót do listy", "Hide password": "Ukryj hasło", "Message limit of {count} characters reached": "Przekroczono limit wiadomości wynoszący {count} znaków", "More items …": "Więcej pozycji…", Next: "Następny", "No emoji found": "Nie znaleziono emoji", "No results": "Brak wyników", Objects: "Obiekty", Open: "Otwórz", 'Open link to "{resourceTitle}"': 'Otwórz link do "{resourceTitle}"', "Open navigation": "Otwórz nawigację", "Password is secure": "Hasło jest bezpieczne", "Pause slideshow": "Wstrzymaj pokaz slajdów", "People & Body": "Ludzie i ciało", "Pick an emoji": "Wybierz emoji", "Please select a time zone:": "Wybierz strefę czasową:", Previous: "Poprzedni", "Related resources": "Powiązane zasoby", Search: "Szukaj", "Search results": "Wyniki wyszukiwania", "Select a tag": "Wybierz etykietę", Settings: "Ustawienia", "Settings navigation": "Ustawienia nawigacji", "Show password": "Pokaż hasło", "Smileys & Emotion": "Buźki i emotikony", "Start slideshow": "Rozpocznij pokaz slajdów", Submit: "Wyślij", Symbols: "Symbole", "Travel & Places": "Podróże i miejsca", "Type to search time zone": "Wpisz, aby wyszukać strefę czasową", "Unable to search the group": "Nie można przeszukać grupy", "Undo changes": "Cofnij zmiany", 'Write message, use "@" to mention someone, use ":" for emoji autocompletion …': 'Napisz wiadomość, "@" aby o kimś wspomnieć, ":" dla autouzupełniania emoji…' } }, { locale: "pt_BR", translations: { "{tag} (invisible)": "{tag} (invisível)", "{tag} (restricted)": "{tag} (restrito) ", Actions: "Ações", Activities: "Atividades", "Animals & Nature": "Animais & Natureza", "Anything shared with the same group of people will show up here": "Qualquer coisa compartilhada com o mesmo grupo de pessoas aparecerá aqui", "Avatar of {displayName}": "Avatar de {displayName}", "Avatar of {displayName}, {status}": "Avatar de {displayName}, {status}", "Cancel changes": "Cancelar alterações", "Change title": "Alterar título", Choose: "Escolher", "Clear text": "Limpar texto", Close: "Fechar", "Close modal": "Fechar modal", "Close navigation": "Fechar navegação", "Close sidebar": "Fechar barra lateral", "Confirm changes": "Confirmar alterações", Custom: "Personalizado", "Edit item": "Editar item", "Error getting related resources": "Erro ao obter recursos relacionados", "Error parsing svg": "Erro ao analisar svg", "External documentation for {title}": "Documentação externa para {title}", Favorite: "Favorito", Flags: "Bandeiras", "Food & Drink": "Comida & Bebida", "Frequently used": "Mais usados", Global: "Global", "Go back to the list": "Volte para a lista", "Hide password": "Ocultar a senha", "Message limit of {count} characters reached": "Limite de mensagem de {count} caracteres atingido", "More items …": "Mais itens …", Next: "Próximo", "No emoji found": "Nenhum emoji encontrado", "No results": "Sem resultados", Objects: "Objetos", Open: "Aberto", 'Open link to "{resourceTitle}"': 'Abrir link para "{resourceTitle}"', "Open navigation": "Abrir navegação", "Password is secure": "A senha é segura", "Pause slideshow": "Pausar apresentação de slides", "People & Body": "Pessoas & Corpo", "Pick an emoji": "Escolha um emoji", "Please select a time zone:": "Selecione um fuso horário: ", Previous: "Anterior", "Related resources": "Recursos relacionados", Search: "Pesquisar", "Search results": "Resultados da pesquisa", "Select a tag": "Selecionar uma tag", Settings: "Configurações", "Settings navigation": "Navegação de configurações", "Show password": "Mostrar senha", "Smileys & Emotion": "Smiles & Emoções", "Start slideshow": "Iniciar apresentação de slides", Submit: "Enviar", Symbols: "Símbolo", "Travel & Places": "Viagem & Lugares", "Type to search time zone": "Digite para pesquisar o fuso horário ", "Unable to search the group": "Não foi possível pesquisar o grupo", "Undo changes": "Desfazer modificações", 'Write message, use "@" to mention someone, use ":" for emoji autocompletion …': 'Escreva mensagens, use "@" para mencionar algum, use ":" for autocompletar emoji …' } }, { locale: "pt_PT", translations: { "{tag} (invisible)": "{tag} (invisivel)", "{tag} (restricted)": "{tag} (restrito)", Actions: "Ações", Choose: "Escolher", Close: "Fechar", Next: "Seguinte", "No results": "Sem resultados", "Pause slideshow": "Pausar diaporama", Previous: "Anterior", "Select a tag": "Selecionar uma etiqueta", Settings: "Definições", "Start slideshow": "Iniciar diaporama", "Unable to search the group": "Não é possível pesquisar o grupo" } }, { locale: "ro", translations: { "{tag} (invisible)": "{tag} (invizibil)", "{tag} (restricted)": "{tag} (restricționat)", Actions: "Acțiuni", Activities: "Activități", "Animals & Nature": "Animale și natură", "Anything shared with the same group of people will show up here": "Tot ceea ce este partajat cu același grup de persoane va fi afișat aici", "Avatar of {displayName}": "Avatarul lui {displayName}", "Avatar of {displayName}, {status}": "Avatarul lui {displayName}, {status}", "Cancel changes": "Anulează modificările", "Change title": "Modificați titlul", Choose: "Alegeți", "Clear text": "Șterge textul", Close: "Închideți", "Close modal": "Închideți modulul", "Close navigation": "Închideți navigarea", "Close sidebar": "Închide bara laterală", "Confirm changes": "Confirmați modificările", Custom: "Personalizat", "Edit item": "Editați elementul", "Error getting related resources": " Eroare la returnarea resurselor legate", "External documentation for {title}": "Documentație externă pentru {title}", Favorite: "Favorit", Flags: "Marcaje", "Food & Drink": "Alimente și băuturi", "Frequently used": "Utilizate frecvent", Global: "Global", "Go back to the list": "Întoarceți-vă la listă", "Hide password": "Ascunde parola", "Message limit of {count} characters reached": "Limita mesajului de {count} caractere a fost atinsă", "More items …": "Mai multe articole ...", Next: "Următorul", "No emoji found": "Nu s-a găsit niciun emoji", "No results": "Nu există rezultate", Objects: "Obiecte", Open: "Deschideți", 'Open link to "{resourceTitle}"': 'Deschide legătura la "{resourceTitle}"', "Open navigation": "Deschideți navigația", "Password is secure": "Parola este sigură", "Pause slideshow": "Pauză prezentare de diapozitive", "People & Body": "Oameni și corp", "Pick an emoji": "Alege un emoji", "Please select a time zone:": "Vă rugăm să selectați un fus orar:", Previous: "Anterior", "Related resources": "Resurse legate", Search: "Căutare", "Search results": "Rezultatele căutării", "Select a tag": "Selectați o etichetă", Settings: "Setări", "Settings navigation": "Navigare setări", "Show password": "Arată parola", "Smileys & Emotion": "Zâmbete și emoții", "Start slideshow": "Începeți prezentarea de diapozitive", Submit: "Trimiteți", Symbols: "Simboluri", "Travel & Places": "Călătorii și locuri", "Type to search time zone": "Tastați pentru a căuta fusul orar", "Unable to search the group": "Imposibilitatea de a căuta în grup", "Undo changes": "Anularea modificărilor", 'Write message, use "@" to mention someone, use ":" for emoji autocompletion …': 'Scrie un mesaj, folosește "@" pentru a menționa pe cineva, folosește ":" pentru autocompletarea cu emoji ...' } }, { locale: "ru", translations: { "{tag} (invisible)": "{tag} (невидимое)", "{tag} (restricted)": "{tag} (ограниченное)", Actions: "Действия ", Activities: "События", "Animals & Nature": "Животные и природа ", "Avatar of {displayName}": "Аватар {displayName}", "Avatar of {displayName}, {status}": "Фотография {displayName}, {status}", "Cancel changes": "Отменить изменения", Choose: "Выберите", Close: "Закрыть", "Close modal": "Закрыть модальное окно", "Close navigation": "Закрыть навигацию", "Confirm changes": "Подтвердить изменения", Custom: "Пользовательское", "Edit item": "Изменить элемент", "External documentation for {title}": "Внешняя документация для {title}", Flags: "Флаги", "Food & Drink": "Еда, напиток", "Frequently used": "Часто используемый", Global: "Глобальный", "Go back to the list": "Вернуться к списку", items: "элементов", "Message limit of {count} characters reached": "Достигнуто ограничение на количество символов в {count}", "More {dashboardItemType} …": "Больше {dashboardItemType} …", Next: "Следующее", "No emoji found": "Эмодзи не найдено", "No results": "Результаты отсуствуют", Objects: "Объекты", Open: "Открыть", "Open navigation": "Открыть навигацию", "Pause slideshow": "Приостановить показ слйдов", "People & Body": "Люди и тело", "Pick an emoji": "Выберите эмодзи", "Please select a time zone:": "Пожалуйста, выберите часовой пояс:", Previous: "Предыдущее", Search: "Поиск", "Search results": "Результаты поиска", "Select a tag": "Выберите метку", Settings: "Параметры", "Settings navigation": "Навигация по настройкам", "Smileys & Emotion": "Смайлики и эмоции", "Start slideshow": "Начать показ слайдов", Submit: "Утвердить", Symbols: "Символы", "Travel & Places": "Путешествия и места", "Type to search time zone": "Введите для поиска часового пояса", "Unable to search the group": "Невозможно найти группу", "Undo changes": "Отменить изменения", "Write message, @ to mention someone, : for emoji autocompletion …": "Напишите сообщение, @ - чтобы упомянуть кого-то, : - для автозаполнения эмодзи …" } }, { locale: "sk_SK", translations: { "{tag} (invisible)": "{tag} (neviditeľný)", "{tag} (restricted)": "{tag} (obmedzený)", Actions: "Akcie", Activities: "Aktivity", "Animals & Nature": "Zvieratá a príroda", "Avatar of {displayName}": "Avatar {displayName}", "Avatar of {displayName}, {status}": "Avatar {displayName}, {status}", "Cancel changes": "Zrušiť zmeny", Choose: "Vybrať", Close: "Zatvoriť", "Close navigation": "Zavrieť navigáciu", "Confirm changes": "Potvrdiť zmeny", Custom: "Zvyk", "Edit item": "Upraviť položku", "External documentation for {title}": "Externá dokumentácia pre {title}", Flags: "Vlajky", "Food & Drink": "Jedlo a nápoje", "Frequently used": "Často používané", Global: "Globálne", "Go back to the list": "Naspäť na zoznam", "Message limit of {count} characters reached": "Limit správy na {count} znakov dosiahnutý", Next: "Ďalší", "No emoji found": "Nenašli sa žiadne emodži", "No results": "Žiadne výsledky", Objects: "Objekty", "Open navigation": "Otvoriť navigáciu", "Pause slideshow": "Pozastaviť prezentáciu", "People & Body": "Ľudia a telo", "Pick an emoji": "Vyberte si emodži", "Please select a time zone:": "Prosím vyberte časovú zónu:", Previous: "Predchádzajúci", Search: "Hľadať", "Search results": "Výsledky vyhľadávania", "Select a tag": "Vybrať štítok", Settings: "Nastavenia", "Settings navigation": "Navigácia v nastaveniach", "Smileys & Emotion": "Smajlíky a emócie", "Start slideshow": "Začať prezentáciu", Submit: "Odoslať", Symbols: "Symboly", "Travel & Places": "Cestovanie a miesta", "Type to search time zone": "Začníte písať pre vyhľadávanie časovej zóny", "Unable to search the group": "Skupinu sa nepodarilo nájsť", "Undo changes": "Vrátiť zmeny", "Write message, @ to mention someone, : for emoji autocompletion …": "Napíšte správu, @ ak chcete niekoho spomenúť, : pre automatické dopĺňanie emotikonov…" } }, { locale: "sl", translations: { "{tag} (invisible)": "{tag} (nevidno)", "{tag} (restricted)": "{tag} (omejeno)", Actions: "Dejanja", Activities: "Dejavnosti", "Animals & Nature": "Živali in Narava", "Avatar of {displayName}": "Podoba {displayName}", "Avatar of {displayName}, {status}": "Prikazna slika {displayName}, {status}", "Cancel changes": "Prekliči spremembe", "Change title": "Spremeni naziv", Choose: "Izbor", "Clear text": "Počisti besedilo", Close: "Zapri", "Close modal": "Zapri pojavno okno", "Close navigation": "Zapri krmarjenje", "Close sidebar": "Zapri stransko vrstico", "Confirm changes": "Potrdi spremembe", Custom: "Po meri", "Edit item": "Uredi predmet", "Error getting related resources": "Napaka pridobivanja povezanih virov", "External documentation for {title}": "Zunanja dokumentacija za {title}", Favorite: "Priljubljeno", Flags: "Zastavice", "Food & Drink": "Hrana in Pijača", "Frequently used": "Pogostost uporabe", Global: "Splošno", "Go back to the list": "Vrni se na seznam", "Hide password": "Skrij geslo", "Message limit of {count} characters reached": "Dosežena omejitev {count} znakov na sporočilo.", "More items …": "Več predmetov ...", Next: "Naslednji", "No emoji found": "Ni najdenih izraznih ikon", "No results": "Ni zadetkov", Objects: "Predmeti", Open: "Odpri", 'Open link to "{resourceTitle}"': "Odpri povezavo do »{resourceTitle}«", "Open navigation": "Odpri krmarjenje", "Password is secure": "Geslo je varno", "Pause slideshow": "Ustavi predstavitev", "People & Body": "Ljudje in Telo", "Pick a date": "Izbor datuma", "Pick a date and a time": "Izbor datuma in časa", "Pick a month": "Izbor meseca", "Pick a time": "Izbor časa", "Pick a week": "Izbor tedna", "Pick a year": "Izbor leta", "Pick an emoji": "Izbor izrazne ikone", "Please select a time zone:": "Izbor časovnega pasu:", Previous: "Predhodni", "Related resources": "Povezani viri", Search: "Iskanje", "Search results": "Zadetki iskanja", "Select a tag": "Izbor oznake", Settings: "Nastavitve", "Settings navigation": "Krmarjenje nastavitev", "Show password": "Pokaži geslo", "Smileys & Emotion": "Izrazne ikone", "Start slideshow": "Začni predstavitev", Submit: "Pošlji", Symbols: "Simboli", "Travel & Places": "Potovanja in Kraji", "Type to search time zone": "Vpišite niz za iskanje časovnega pasu", "Unable to search the group": "Ni mogoče iskati po skupini", "Undo changes": "Razveljavi spremembe", "Write message, @ to mention someone, : for emoji autocompletion …": "Napišite sporočilo, za omembo pred ime postavite@, začnite z : za vstavljanje izraznih ikon …" } }, { locale: "sr", translations: { "{tag} (invisible)": "{tag} (nevidljivo)", "{tag} (restricted)": "{tag} (ograničeno)", Actions: "Radnje", Activities: "Aktivnosti", "Animals & Nature": "Životinje i Priroda", "Avatar of {displayName}": "Avatar za {displayName}", "Avatar of {displayName}, {status}": "Avatar za {displayName}, {status}", "Cancel changes": "Otkaži izmene", "Change title": "Izmeni naziv", Choose: "Изаберите", Close: "Затвори", "Close modal": "Zatvori modal", "Close navigation": "Zatvori navigaciju", "Close sidebar": "Zatvori bočnu traku", "Confirm changes": "Potvrdite promene", Custom: "Po meri", "Edit item": "Uredi stavku", "External documentation for {title}": "Eksterna dokumentacija za {title}", Favorite: "Omiljeni", Flags: "Zastave", "Food & Drink": "Hrana i Piće", "Frequently used": "Često korišćeno", Global: "Globalno", "Go back to the list": "Natrag na listu", items: "stavke", "Message limit of {count} characters reached": "Dostignuto je ograničenje za poruke od {count} znakova", "More {dashboardItemType} …": "Više  {dashboardItemType} …", Next: "Следеће", "No emoji found": "Nije pronađen nijedan emodži", "No results": "Нема резултата", Objects: "Objekti", Open: "Otvori", "Open navigation": "Otvori navigaciju", "Pause slideshow": "Паузирај слајд шоу", "People & Body": "Ljudi i Telo", "Pick an emoji": "Izaberi emodži", "Please select a time zone:": "Molimo izaberite vremensku zonu:", Previous: "Претходно", Search: "Pretraži", "Search results": "Rezultati pretrage", "Select a tag": "Изаберите ознаку", Settings: "Поставке", "Settings navigation": "Navigacija u podešavanjima", "Smileys & Emotion": "Smajli i Emocije", "Start slideshow": "Покрени слајд шоу", Submit: "Prihvati", Symbols: "Simboli", "Travel & Places": "Putovanja i Mesta", "Type to search time zone": "Ukucaj da pretražiš vremenske zone", "Unable to search the group": "Nije moguće pretražiti grupu", "Undo changes": "Poništi promene", "Write message, @ to mention someone, : for emoji autocompletion …": "Napišite poruku, @ da pomenete nekoga, : za automatsko dovršavanje emodžija…" } }, { locale: "sv", translations: { "{tag} (invisible)": "{tag} (osynlig)", "{tag} (restricted)": "{tag} (begränsad)", Actions: "Åtgärder", Activities: "Aktiviteter", "Animals & Nature": "Djur & Natur", "Anything shared with the same group of people will show up here": "Något som delats med samma grupp av personer kommer att visas här", "Avatar of {displayName}": "{displayName}s avatar", "Avatar of {displayName}, {status}": "{displayName}s avatar, {status}", "Cancel changes": "Avbryt ändringar", "Change title": "Ändra titel", Choose: "Välj", "Clear text": "Ta bort text", Close: "Stäng", "Close modal": "Stäng modal", "Close navigation": "Stäng navigering", "Close sidebar": "Stäng sidopanel", "Confirm changes": "Bekräfta ändringar", Custom: "Anpassad", "Edit item": "Ändra", "Error getting related resources": "Problem att hämta relaterade resurser", "External documentation for {title}": "Extern dokumentation för {title}", Favorite: "Favorit", Flags: "Flaggor", "Food & Drink": "Mat & Dryck", "Frequently used": "Används ofta", Global: "Global", "Go back to the list": "Gå tillbaka till listan", "Hide password": "Göm lössenordet", "Message limit of {count} characters reached": "Meddelandegräns {count} tecken används", "More items …": "Fler objekt", Next: "Nästa", "No emoji found": "Hittade inga emojis", "No results": "Inga resultat", Objects: "Objekt", Open: "Öppna", 'Open link to "{resourceTitle}"': 'Öppna länk till "{resourceTitle}"', "Open navigation": "Öppna navigering", "Password is secure": "Lössenordet är säkert", "Pause slideshow": "Pausa bildspelet", "People & Body": "Kropp & Själ", "Pick an emoji": "Välj en emoji", "Please select a time zone:": "Välj tidszon:", Previous: "Föregående", "Related resources": "Relaterade resurser", Search: "Sök", "Search results": "Sökresultat", "Select a tag": "Välj en tag", Settings: "Inställningar", "Settings navigation": "Inställningsmeny", "Show password": "Visa lössenordet", "Smileys & Emotion": "Selfies & Känslor", "Start slideshow": "Starta bildspelet", Submit: "Skicka", Symbols: "Symboler", "Travel & Places": "Resor & Sevärdigheter", "Type to search time zone": "Skriv för att välja tidszon", "Unable to search the group": "Kunde inte söka i gruppen", "Undo changes": "Ångra ändringar", 'Write message, use "@" to mention someone, use ":" for emoji autocompletion …': 'Skriv meddelande, använd "@" för att nämna någon, använd ":" för automatiska emojiförslag ...' } }, { locale: "tr", translations: { "{tag} (invisible)": "{tag} (görünmez)", "{tag} (restricted)": "{tag} (kısıtlı)", Actions: "İşlemler", Activities: "Etkinlikler", "Animals & Nature": "Hayvanlar ve Doğa", "Anything shared with the same group of people will show up here": "Aynı kişi grubu ile paylaşılan herşey burada görüntülenir", "Avatar of {displayName}": "{displayName} avatarı", "Avatar of {displayName}, {status}": "{displayName}, {status} avatarı", "Cancel changes": "Değişiklikleri iptal et", "Change title": "Başlığı değiştir", Choose: "Seçin", "Clear text": "Metni temizle", Close: "Kapat", "Close modal": "Üste açılan pencereyi kapat", "Close navigation": "Gezinmeyi kapat", "Close sidebar": "Yan çubuğu kapat", "Confirm changes": "Değişiklikleri onayla", Custom: "Özel", "Edit item": "Ögeyi düzenle", "Error getting related resources": "İlgili kaynaklar alınırken sorun çıktı", "Error parsing svg": "svg işlenirken sorun çıktı", "External documentation for {title}": "{title} için dış belgeler", Favorite: "Sık kullanılanlara ekle", Flags: "Bayraklar", "Food & Drink": "Yeme ve İçme", "Frequently used": "Sık kullanılanlar", Global: "Evrensel", "Go back to the list": "Listeye dön", "Hide password": "Parolayı gizle", "Message limit of {count} characters reached": "{count} karakter ileti sınırına ulaşıldı", "More items …": "Diğer ögeler…", Next: "Sonraki", "No emoji found": "Herhangi bir emoji bulunamadı", "No results": "Herhangi bir sonuç bulunamadı", Objects: "Nesneler", Open: "Aç", 'Open link to "{resourceTitle}"': '"{resourceTitle}" bağlantısını aç', "Open navigation": "Gezinmeyi aç", "Password is secure": "Parola güvenli", "Pause slideshow": "Slayt sunumunu duraklat", "People & Body": "İnsanlar ve Beden", "Pick an emoji": "Bir emoji seçin", "Please select a time zone:": "Lütfen bir saat dilimi seçin:", Previous: "Önceki", "Related resources": "İlgili kaynaklar", Search: "Arama", "Search results": "Arama sonuçları", "Select a tag": "Bir etiket seçin", Settings: "Ayarlar", "Settings navigation": "Gezinme ayarları", "Show password": "Parolayı görüntüle", "Smileys & Emotion": "İfadeler ve Duygular", "Start slideshow": "Slayt sunumunu başlat", Submit: "Gönder", Symbols: "Simgeler", "Travel & Places": "Gezi ve Yerler", "Type to search time zone": "Saat dilimi aramak için yazmaya başlayın", "Unable to search the group": "Grupta arama yapılamadı", "Undo changes": "Değişiklikleri geri al", 'Write message, use "@" to mention someone, use ":" for emoji autocompletion …': 'İleti yazın, birini anmak için @, otomatik emoji tamamlamak için ":" kullanın…' } }, { locale: "uk", translations: { "{tag} (invisible)": "{tag} (невидимий)", "{tag} (restricted)": "{tag} (обмежений)", Actions: "Дії", Activities: "Діяльність", "Animals & Nature": "Тварини та природа", "Avatar of {displayName}": "Аватар {displayName}", "Avatar of {displayName}, {status}": "Аватар {displayName}, {status}", "Cancel changes": "Скасувати зміни", "Change title": "Змінити назву", Choose: "ВиберітьВиберіть", "Clear text": "Очистити текст", Close: "Закрити", "Close modal": "Закрити модаль", "Close navigation": "Закрити навігацію", "Close sidebar": "Закрити бічну панель", "Confirm changes": "Підтвердити зміни", Custom: "Власне", "Edit item": "Редагувати елемент", "External documentation for {title}": "Зовнішня документація для {title}", Favorite: "Улюблений", Flags: "Прапори", "Food & Drink": "Їжа та напої", "Frequently used": "Найчастіші", Global: "Глобальний", "Go back to the list": "Повернутися до списку", "Hide password": "Приховати пароль", items: "елементи", "Message limit of {count} characters reached": "Вичерпано ліміт у {count} символів для повідомлення", "More {dashboardItemType} …": "Більше {dashboardItemType}…", Next: "Вперед", "No emoji found": "Емоційки відсутні", "No results": "Відсутні результати", Objects: "Об'єкти", Open: "Відкрити", "Open navigation": "Відкрити навігацію", "Password is secure": "Пароль безпечний", "Pause slideshow": "Пауза у показі слайдів", "People & Body": "Люди та жести", "Pick an emoji": "Виберіть емоційку", "Please select a time zone:": "Виберіть часовий пояс:", Previous: "Назад", Search: "Пошук", "Search results": "Результати пошуку", "Select a tag": "Виберіть позначку", Settings: "Налаштування", "Settings navigation": "Навігація у налаштуваннях", "Show password": "Показати пароль", "Smileys & Emotion": "Смайли та емоції", "Start slideshow": "Почати показ слайдів", Submit: "Надіслати", Symbols: "Символи", "Travel & Places": "Поїздки та місця", "Type to search time zone": "Введіть для пошуку часовий пояс", "Unable to search the group": "Неможливо шукати в групі", "Undo changes": "Скасувати зміни", "Write message, @ to mention someone, : for emoji autocompletion …": "Напишіть повідомлення, @, щоб згадати когось, : для автозаповнення емодзі…" } }, { locale: "zh_CN", translations: { "{tag} (invisible)": "{tag} （不可见）", "{tag} (restricted)": "{tag} （受限）", Actions: "行为", Activities: "活动", "Animals & Nature": "动物 & 自然", "Anything shared with the same group of people will show up here": "与同组用户分享的所有内容都会显示于此", "Avatar of {displayName}": "{displayName}的头像", "Avatar of {displayName}, {status}": "{displayName}的头像，{status}", "Cancel changes": "取消更改", "Change title": "更改标题", Choose: "选择", "Clear text": "清除文本", Close: "关闭", "Close modal": "关闭窗口", "Close navigation": "关闭导航", "Close sidebar": "关闭侧边栏", "Confirm changes": "确认更改", Custom: "自定义", "Edit item": "编辑项目", "Error getting related resources": "获取相关资源时出错", "Error parsing svg": "解析 svg 时出错", "External documentation for {title}": "{title}的外部文档", Favorite: "喜爱", Flags: "旗帜", "Food & Drink": "食物 & 饮品", "Frequently used": "经常使用", Global: "全局", "Go back to the list": "返回至列表", "Hide password": "隐藏密码", "Message limit of {count} characters reached": "已达到 {count} 个字符的消息限制", "More items …": "更多项目…", Next: "下一个", "No emoji found": "表情未找到", "No results": "无结果", Objects: "物体", Open: "打开", 'Open link to "{resourceTitle}"': '打开"{resourceTitle}"的连接', "Open navigation": "开启导航", "Password is secure": "密码安全", "Pause slideshow": "暂停幻灯片", "People & Body": "人 & 身体", "Pick an emoji": "选择一个表情", "Please select a time zone:": "请选择一个时区：", Previous: "上一个", "Related resources": "相关资源", Search: "搜索", "Search results": "搜索结果", "Select a tag": "选择一个标签", Settings: "设置", "Settings navigation": "设置向导", "Show password": "显示密码", "Smileys & Emotion": "笑脸 & 情感", "Start slideshow": "开始幻灯片", Submit: "提交", Symbols: "符号", "Travel & Places": "旅游 & 地点", "Type to search time zone": "打字以搜索时区", "Unable to search the group": "无法搜索分组", "Undo changes": "撤销更改", 'Write message, use "@" to mention someone, use ":" for emoji autocompletion …': '写信息，使用"@"来提及某人，使用":"进行表情符号自动完成 ...' } }, { locale: "zh_HK", translations: { "{tag} (invisible)": "{tag} (隱藏)", "{tag} (restricted)": "{tag} (受限)", Actions: "動作", Activities: "活動", "Animals & Nature": "動物與自然", "Anything shared with the same group of people will show up here": "與同一組人共享的任何內容都會顯示在此處", "Avatar of {displayName}": "{displayName} 的頭像", "Avatar of {displayName}, {status}": "{displayName} 的頭像，{status}", "Cancel changes": "取消更改", "Change title": "更改標題", Choose: "選擇", "Clear text": "清除文本", Close: "關閉", "Close modal": "關閉模態", "Close navigation": "關閉導航", "Close sidebar": "關閉側邊欄", "Confirm changes": "確認更改", Custom: "自定義", "Edit item": "編輯項目", "Error getting related resources": "獲取相關資源出錯", "Error parsing svg": "解析 svg 時出錯", "External documentation for {title}": "{title} 的外部文檔", Favorite: "喜愛", Flags: "旗幟", "Food & Drink": "食物與飲料", "Frequently used": "經常使用", Global: "全球的", "Go back to the list": "返回清單", "Hide password": "隱藏密碼", "Message limit of {count} characters reached": "已達到訊息最多 {count} 字元限制", "More items …": "更多項目 …", Next: "下一個", "No emoji found": "未找到表情符號", "No results": "無結果", Objects: "物件", Open: "打開", 'Open link to "{resourceTitle}"': "打開指向 “{resourceTitle}” 的鏈結", "Open navigation": "開啟導航", "Password is secure": "密碼是安全的", "Pause slideshow": "暫停幻燈片", "People & Body": "人物", "Pick an emoji": "選擇表情符號", "Please select a time zone:": "請選擇時區：", Previous: "上一個", "Related resources": "相關資源", Search: "搜尋", "Search results": "搜尋結果", "Select a tag": "選擇標籤", Settings: "設定", "Settings navigation": "設定值導覽", "Show password": "顯示密碼", "Smileys & Emotion": "表情", "Start slideshow": "開始幻燈片", Submit: "提交", Symbols: "標誌", "Travel & Places": "旅遊與景點", "Type to search time zone": "鍵入以搜索時區", "Unable to search the group": "無法搜尋群組", "Undo changes": "取消更改", 'Write message, use "@" to mention someone, use ":" for emoji autocompletion …': '寫訊息，使用 "@" 來指代某人，使用 ":" 用於表情符號自動填充 ...' } }, { locale: "zh_TW", translations: { "{tag} (invisible)": "{tag} (隱藏)", "{tag} (restricted)": "{tag} (受限)", Actions: "動作", Activities: "活動", "Animals & Nature": "動物與自然", Choose: "選擇", Close: "關閉", Custom: "自定義", Flags: "旗幟", "Food & Drink": "食物與飲料", "Frequently used": "最近使用", "Message limit of {count} characters reached": "已達到訊息最多 {count} 字元限制", Next: "下一個", "No emoji found": "未找到表情符號", "No results": "無結果", Objects: "物件", "Pause slideshow": "暫停幻燈片", "People & Body": "人物", "Pick an emoji": "選擇表情符號", Previous: "上一個", Search: "搜尋", "Search results": "搜尋結果", "Select a tag": "選擇標籤", Settings: "設定", "Settings navigation": "設定值導覽", "Smileys & Emotion": "表情", "Start slideshow": "開始幻燈片", Symbols: "標誌", "Travel & Places": "旅遊與景點", "Unable to search the group": "無法搜尋群組", "Write message, @ to mention someone …": "輸入訊息時可使用 @ 來標示某人..." } }].forEach(function(f) {
        var h = {};
        for (var S in f.translations)
          f.translations[S].pluralId ? h[S] = { msgid: S, msgid_plural: f.translations[S].pluralId, msgstr: f.translations[S].msgstr } : h[S] = { msgid: S, msgstr: [f.translations[S]] };
        T.addTranslation(f.locale, { translations: { "": h } });
      });
      var u = T.build(), d = u.ngettext.bind(u), A = u.gettext.bind(u);
    }, 9150: () => {
    }, 3351: (o, l, a) => {
      a.d(l, { iQ: () => m }), a(9150), a(8136), a(334), a(3132);
      var c = a(3607), T = a(768), u = a.n(T);
      const d = Z1();
      var A = a(4262), f = a(5108);
      function h(g) {
        return h = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(N) {
          return typeof N;
        } : function(N) {
          return N && typeof Symbol == "function" && N.constructor === Symbol && N !== Symbol.prototype ? "symbol" : typeof N;
        }, h(g);
      }
      function S() {
        S = function() {
          return g;
        };
        var g = {}, N = Object.prototype, R = N.hasOwnProperty, D = Object.defineProperty || function(V, $, J) {
          V[$] = J.value;
        }, v = typeof Symbol == "function" ? Symbol : {}, O = v.iterator || "@@iterator", y = v.asyncIterator || "@@asyncIterator", Z = v.toStringTag || "@@toStringTag";
        function F(V, $, J) {
          return Object.defineProperty(V, $, { value: J, enumerable: !0, configurable: !0, writable: !0 }), V[$];
        }
        try {
          F({}, "");
        } catch {
          F = function($, J, ae) {
            return $[J] = ae;
          };
        }
        function b(V, $, J, ae) {
          var X = $ && $.prototype instanceof q ? $ : q, pe = Object.create(X.prototype), L = new se(ae || []);
          return D(pe, "_invoke", { value: re(V, J, L) }), pe;
        }
        function Y(V, $, J) {
          try {
            return { type: "normal", arg: V.call($, J) };
          } catch (ae) {
            return { type: "throw", arg: ae };
          }
        }
        g.wrap = b;
        var I = {};
        function q() {
        }
        function _() {
        }
        function z() {
        }
        var E = {};
        F(E, O, function() {
          return this;
        });
        var C = Object.getPrototypeOf, P = C && C(C(ie([])));
        P && P !== N && R.call(P, O) && (E = P);
        var M = z.prototype = q.prototype = Object.create(E);
        function Q(V) {
          ["next", "throw", "return"].forEach(function($) {
            F(V, $, function(J) {
              return this._invoke($, J);
            });
          });
        }
        function H(V, $) {
          function J(X, pe, L, ee) {
            var Ae = Y(V[X], V, pe);
            if (Ae.type !== "throw") {
              var Ne = Ae.arg, ye = Ne.value;
              return ye && h(ye) == "object" && R.call(ye, "__await") ? $.resolve(ye.__await).then(function(be) {
                J("next", be, L, ee);
              }, function(be) {
                J("throw", be, L, ee);
              }) : $.resolve(ye).then(function(be) {
                Ne.value = be, L(Ne);
              }, function(be) {
                return J("throw", be, L, ee);
              });
            }
            ee(Ae.arg);
          }
          var ae;
          D(this, "_invoke", { value: function(X, pe) {
            function L() {
              return new $(function(ee, Ae) {
                J(X, pe, ee, Ae);
              });
            }
            return ae = ae ? ae.then(L, L) : L();
          } });
        }
        function re(V, $, J) {
          var ae = "suspendedStart";
          return function(X, pe) {
            if (ae === "executing")
              throw new Error("Generator is already running");
            if (ae === "completed") {
              if (X === "throw")
                throw pe;
              return Fe();
            }
            for (J.method = X, J.arg = pe; ; ) {
              var L = J.delegate;
              if (L) {
                var ee = U(L, J);
                if (ee) {
                  if (ee === I)
                    continue;
                  return ee;
                }
              }
              if (J.method === "next")
                J.sent = J._sent = J.arg;
              else if (J.method === "throw") {
                if (ae === "suspendedStart")
                  throw ae = "completed", J.arg;
                J.dispatchException(J.arg);
              } else
                J.method === "return" && J.abrupt("return", J.arg);
              ae = "executing";
              var Ae = Y(V, $, J);
              if (Ae.type === "normal") {
                if (ae = J.done ? "completed" : "suspendedYield", Ae.arg === I)
                  continue;
                return { value: Ae.arg, done: J.done };
              }
              Ae.type === "throw" && (ae = "completed", J.method = "throw", J.arg = Ae.arg);
            }
          };
        }
        function U(V, $) {
          var J = $.method, ae = V.iterator[J];
          if (ae === void 0)
            return $.delegate = null, J === "throw" && V.iterator.return && ($.method = "return", $.arg = void 0, U(V, $), $.method === "throw") || J !== "return" && ($.method = "throw", $.arg = new TypeError("The iterator does not provide a '" + J + "' method")), I;
          var X = Y(ae, V.iterator, $.arg);
          if (X.type === "throw")
            return $.method = "throw", $.arg = X.arg, $.delegate = null, I;
          var pe = X.arg;
          return pe ? pe.done ? ($[V.resultName] = pe.value, $.next = V.nextLoc, $.method !== "return" && ($.method = "next", $.arg = void 0), $.delegate = null, I) : pe : ($.method = "throw", $.arg = new TypeError("iterator result is not an object"), $.delegate = null, I);
        }
        function w(V) {
          var $ = { tryLoc: V[0] };
          1 in V && ($.catchLoc = V[1]), 2 in V && ($.finallyLoc = V[2], $.afterLoc = V[3]), this.tryEntries.push($);
        }
        function W(V) {
          var $ = V.completion || {};
          $.type = "normal", delete $.arg, V.completion = $;
        }
        function se(V) {
          this.tryEntries = [{ tryLoc: "root" }], V.forEach(w, this), this.reset(!0);
        }
        function ie(V) {
          if (V) {
            var $ = V[O];
            if ($)
              return $.call(V);
            if (typeof V.next == "function")
              return V;
            if (!isNaN(V.length)) {
              var J = -1, ae = function X() {
                for (; ++J < V.length; )
                  if (R.call(V, J))
                    return X.value = V[J], X.done = !1, X;
                return X.value = void 0, X.done = !0, X;
              };
              return ae.next = ae;
            }
          }
          return { next: Fe };
        }
        function Fe() {
          return { value: void 0, done: !0 };
        }
        return _.prototype = z, D(M, "constructor", { value: z, configurable: !0 }), D(z, "constructor", { value: _, configurable: !0 }), _.displayName = F(z, Z, "GeneratorFunction"), g.isGeneratorFunction = function(V) {
          var $ = typeof V == "function" && V.constructor;
          return !!$ && ($ === _ || ($.displayName || $.name) === "GeneratorFunction");
        }, g.mark = function(V) {
          return Object.setPrototypeOf ? Object.setPrototypeOf(V, z) : (V.__proto__ = z, F(V, Z, "GeneratorFunction")), V.prototype = Object.create(M), V;
        }, g.awrap = function(V) {
          return { __await: V };
        }, Q(H.prototype), F(H.prototype, y, function() {
          return this;
        }), g.AsyncIterator = H, g.async = function(V, $, J, ae, X) {
          X === void 0 && (X = Promise);
          var pe = new H(b(V, $, J, ae), X);
          return g.isGeneratorFunction($) ? pe : pe.next().then(function(L) {
            return L.done ? L.value : pe.next();
          });
        }, Q(M), F(M, Z, "Generator"), F(M, O, function() {
          return this;
        }), F(M, "toString", function() {
          return "[object Generator]";
        }), g.keys = function(V) {
          var $ = Object(V), J = [];
          for (var ae in $)
            J.push(ae);
          return J.reverse(), function X() {
            for (; J.length; ) {
              var pe = J.pop();
              if (pe in $)
                return X.value = pe, X.done = !1, X;
            }
            return X.done = !0, X;
          };
        }, g.values = ie, se.prototype = { constructor: se, reset: function(V) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(W), !V)
            for (var $ in this)
              $.charAt(0) === "t" && R.call(this, $) && !isNaN(+$.slice(1)) && (this[$] = void 0);
        }, stop: function() {
          this.done = !0;
          var V = this.tryEntries[0].completion;
          if (V.type === "throw")
            throw V.arg;
          return this.rval;
        }, dispatchException: function(V) {
          if (this.done)
            throw V;
          var $ = this;
          function J(Ae, Ne) {
            return pe.type = "throw", pe.arg = V, $.next = Ae, Ne && ($.method = "next", $.arg = void 0), !!Ne;
          }
          for (var ae = this.tryEntries.length - 1; ae >= 0; --ae) {
            var X = this.tryEntries[ae], pe = X.completion;
            if (X.tryLoc === "root")
              return J("end");
            if (X.tryLoc <= this.prev) {
              var L = R.call(X, "catchLoc"), ee = R.call(X, "finallyLoc");
              if (L && ee) {
                if (this.prev < X.catchLoc)
                  return J(X.catchLoc, !0);
                if (this.prev < X.finallyLoc)
                  return J(X.finallyLoc);
              } else if (L) {
                if (this.prev < X.catchLoc)
                  return J(X.catchLoc, !0);
              } else {
                if (!ee)
                  throw new Error("try statement without catch or finally");
                if (this.prev < X.finallyLoc)
                  return J(X.finallyLoc);
              }
            }
          }
        }, abrupt: function(V, $) {
          for (var J = this.tryEntries.length - 1; J >= 0; --J) {
            var ae = this.tryEntries[J];
            if (ae.tryLoc <= this.prev && R.call(ae, "finallyLoc") && this.prev < ae.finallyLoc) {
              var X = ae;
              break;
            }
          }
          X && (V === "break" || V === "continue") && X.tryLoc <= $ && $ <= X.finallyLoc && (X = null);
          var pe = X ? X.completion : {};
          return pe.type = V, pe.arg = $, X ? (this.method = "next", this.next = X.finallyLoc, I) : this.complete(pe);
        }, complete: function(V, $) {
          if (V.type === "throw")
            throw V.arg;
          return V.type === "break" || V.type === "continue" ? this.next = V.arg : V.type === "return" ? (this.rval = this.arg = V.arg, this.method = "return", this.next = "end") : V.type === "normal" && $ && (this.next = $), I;
        }, finish: function(V) {
          for (var $ = this.tryEntries.length - 1; $ >= 0; --$) {
            var J = this.tryEntries[$];
            if (J.finallyLoc === V)
              return this.complete(J.completion, J.afterLoc), W(J), I;
          }
        }, catch: function(V) {
          for (var $ = this.tryEntries.length - 1; $ >= 0; --$) {
            var J = this.tryEntries[$];
            if (J.tryLoc === V) {
              var ae = J.completion;
              if (ae.type === "throw") {
                var X = ae.arg;
                W(J);
              }
              return X;
            }
          }
          throw new Error("illegal catch attempt");
        }, delegateYield: function(V, $, J) {
          return this.delegate = { iterator: ie(V), resultName: $, nextLoc: J }, this.method === "next" && (this.arg = void 0), I;
        } }, g;
      }
      function p(g, N, R, D, v, O, y) {
        try {
          var Z = g[O](y), F = Z.value;
        } catch (b) {
          return void R(b);
        }
        Z.done ? N(F) : Promise.resolve(F).then(D, v);
      }
      const m = { data: function() {
        return { hasStatus: !1, userStatus: { status: null, message: null, icon: null } };
      }, methods: { fetchUserStatus: function(g) {
        var N, R = this;
        return (N = S().mark(function D() {
          var v, O, y, Z, F, b, Y, I, q;
          return S().wrap(function(_) {
            for (; ; )
              switch (_.prev = _.next) {
                case 0:
                  if (g) {
                    _.next = 2;
                    break;
                  }
                  return _.abrupt("return");
                case 2:
                  if (v = (0, d.getCapabilities)(), Object.prototype.hasOwnProperty.call(v, "user_status") && v.user_status.enabled) {
                    _.next = 5;
                    break;
                  }
                  return _.abrupt("return");
                case 5:
                  if ((0, c.getCurrentUser)()) {
                    _.next = 7;
                    break;
                  }
                  return _.abrupt("return");
                case 7:
                  return _.prev = 7, _.next = 10, u().get((0, A.generateOcsUrl)("apps/user_status/api/v1/statuses/{userId}", { userId: g }));
                case 10:
                  O = _.sent, y = O.data, Z = y.ocs.data, F = Z.status, b = Z.message, Y = Z.icon, R.userStatus.status = F, R.userStatus.message = b || "", R.userStatus.icon = Y || "", R.hasStatus = !0, _.next = 24;
                  break;
                case 19:
                  if (_.prev = 19, _.t0 = _.catch(7), _.t0.response.status !== 404 || ((I = _.t0.response.data.ocs) === null || I === void 0 || (q = I.data) === null || q === void 0 ? void 0 : q.length) !== 0) {
                    _.next = 23;
                    break;
                  }
                  return _.abrupt("return");
                case 23:
                  f.error(_.t0);
                case 24:
                case "end":
                  return _.stop();
              }
          }, D, null, [[7, 19]]);
        }), function() {
          var D = this, v = arguments;
          return new Promise(function(O, y) {
            var Z = N.apply(D, v);
            function F(Y) {
              p(Z, O, y, F, b, "next", Y);
            }
            function b(Y) {
              p(Z, O, y, F, b, "throw", Y);
            }
            F(void 0);
          });
        })();
      } } };
    }, 8136: () => {
    }, 334: (o, l, a) => {
      var c = a(2734);
      new (a.n(c)())({ data: function() {
        return { isMobile: !1 };
      }, watch: { isMobile: function(T) {
        this.$emit("changed", T);
      } }, created: function() {
        window.addEventListener("resize", this.handleWindowResize), this.handleWindowResize();
      }, beforeDestroy: function() {
        window.removeEventListener("resize", this.handleWindowResize);
      }, methods: { handleWindowResize: function() {
        this.isMobile = document.documentElement.clientWidth < 1024;
      } } });
    }, 3648: (o, l, a) => {
      a.d(l, { Z: () => T });
      var c = a(932);
      const T = { methods: { n: c.n, t: c.t } };
    }, 3132: (o, l, a) => {
      a(2298), a(1390), x1(), a(2734);
    }, 1336: (o, l, a) => {
      a.d(l, { Z: () => c });
      const c = function(T, u) {
        for (var d = [], A = 0, f = T.toLowerCase().indexOf(u.toLowerCase(), A), h = 0; f > -1 && h < T.length; )
          A = f + u.length, d.push({ start: f, end: A }), f = T.toLowerCase().indexOf(u.toLowerCase(), A), h++;
        return d;
      };
    }, 6609: (o, l, a) => {
      function c(d, A, f) {
        this.r = d, this.g = A, this.b = f;
      }
      function T(d, A, f) {
        var h = [];
        h.push(A);
        for (var S = function(R, D) {
          var v = new Array(3);
          return v[0] = (D[1].r - D[0].r) / R, v[1] = (D[1].g - D[0].g) / R, v[2] = (D[1].b - D[0].b) / R, v;
        }(d, [A, f]), p = 1; p < d; p++) {
          var m = parseInt(A.r + S[0] * p, 10), g = parseInt(A.g + S[1] * p, 10), N = parseInt(A.b + S[2] * p, 10);
          h.push(new c(m, g, N));
        }
        return h;
      }
      a.d(l, { Z: () => u });
      const u = function(d) {
        d || (d = 6);
        var A = new c(182, 70, 157), f = new c(221, 203, 85), h = new c(0, 130, 201), S = T(d, A, f), p = T(d, f, h), m = T(d, h, A);
        return S.concat(p).concat(m);
      };
    }, 1390: (o, l, a) => {
      a.d(l, { Z: () => u });
      const c = iS;
      var T = a.n(c);
      const u = function(d) {
        return T()(d, { defaultProtocol: "https", target: "_blank", className: "external linkified", attributes: { rel: "nofollow noopener noreferrer" } });
      };
    }, 7645: (o, l, a) => {
      a.d(l, { Z: () => c });
      const c = function(T) {
        T.mounted ? Array.isArray(T.mounted) || (T.mounted = [T.mounted]) : T.mounted = [], T.mounted.push(function() {
          this.$el.setAttribute("data-v-".concat("3d66c94"), "");
        });
      };
    }, 1206: (o, l, a) => {
      a.d(l, { L: () => c }), a(4505);
      var c = function() {
        return Object.assign(window, { _nc_focus_trap: window._nc_focus_trap || [] }), window._nc_focus_trap;
      };
    }, 6115: (o, l, a) => {
      a.d(l, { Z: () => c });
      const c = (0, om().getLoggerBuilder)().detectUser().setApp("@nextcloud/vue").build();
    }, 5108: (o, l, a) => {
      var c = a(6464), T = a(9084);
      function u() {
        return new Date().getTime();
      }
      var d, A = Array.prototype.slice, f = {};
      d = a.g !== void 0 && a.g.console ? a.g.console : typeof window < "u" && window.console ? window.console : {};
      for (var h = [[function() {
      }, "log"], [function() {
        d.log.apply(d, arguments);
      }, "info"], [function() {
        d.log.apply(d, arguments);
      }, "warn"], [function() {
        d.warn.apply(d, arguments);
      }, "error"], [function(N) {
        f[N] = u();
      }, "time"], [function(N) {
        var R = f[N];
        if (!R)
          throw new Error("No such label: " + N);
        delete f[N];
        var D = u() - R;
        d.log(N + ": " + D + "ms");
      }, "timeEnd"], [function() {
        var N = new Error();
        N.name = "Trace", N.message = c.format.apply(null, arguments), d.error(N.stack);
      }, "trace"], [function(N) {
        d.log(c.inspect(N) + `
`);
      }, "dir"], [function(N) {
        if (!N) {
          var R = A.call(arguments, 1);
          T.ok(!1, c.format.apply(null, R));
        }
      }, "assert"]], S = 0; S < h.length; S++) {
        var p = h[S], m = p[0], g = p[1];
        d[g] || (d[g] = m);
      }
      o.exports = d;
    }, 9934: (o, l, a) => {
      a.d(l, { Z: () => _ });
      var c = a(7537), T = a.n(c), u = a(3645), d = a.n(u), A = a(1667), f = a.n(A), h = new URL(a(6417), a.b), S = new URL(a(7425), a.b), p = new URL(a(817), a.b), m = new URL(a(9039), a.b), g = new URL(a(3787), a.b), N = new URL(a(4259), a.b), R = new URL(a(5415), a.b), D = new URL(a(5322), a.b), v = d()(T()), O = f()(h), y = f()(S), Z = f()(p), F = f()(m), b = f()(g), Y = f()(N), I = f()(R), q = f()(D);
      v.push([o.id, '.material-design-icon{display:flex;align-self:center;justify-self:center;align-items:center;justify-content:center}.mx-icon-left:before,.mx-icon-right:before,.mx-icon-double-left:before,.mx-icon-double-right:before,.mx-icon-double-left:after,.mx-icon-double-right:after{content:"";position:relative;top:-1px;display:inline-block;width:10px;height:10px;vertical-align:middle;border-style:solid;border-color:currentColor;border-width:2px 0 0 2px;border-radius:1px;box-sizing:border-box;transform-origin:center;transform:rotate(-45deg) scale(0.7)}.mx-icon-double-left:after{left:-4px}.mx-icon-double-right:before{left:4px}.mx-icon-right:before,.mx-icon-double-right:before,.mx-icon-double-right:after{transform:rotate(135deg) scale(0.7)}.mx-btn{box-sizing:border-box;line-height:1;font-size:14px;font-weight:500;padding:7px 15px;margin:0;cursor:pointer;background-color:rgba(0,0,0,0);outline:none;border:1px solid rgba(0,0,0,.1);border-radius:4px;color:#73879c;white-space:nowrap}.mx-btn:hover{border-color:#1284e7;color:#1284e7}.mx-btn:disabled,.mx-btn.disabled{color:#ccc;cursor:not-allowed}.mx-btn-text{border:0;padding:0 4px;text-align:left;line-height:inherit}.mx-scrollbar{height:100%}.mx-scrollbar:hover .mx-scrollbar-track{opacity:1}.mx-scrollbar-wrap{height:100%;overflow-x:hidden;overflow-y:auto}.mx-scrollbar-track{position:absolute;top:2px;right:2px;bottom:2px;width:6px;z-index:1;border-radius:4px;opacity:0;transition:opacity .24s ease-out}.mx-scrollbar-track .mx-scrollbar-thumb{position:absolute;width:100%;height:0;cursor:pointer;border-radius:inherit;background-color:rgba(144,147,153,.3);transition:background-color .3s}.mx-zoom-in-down-enter-active,.mx-zoom-in-down-leave-active{opacity:1;transform:scaleY(1);transition:transform .3s cubic-bezier(0.23, 1, 0.32, 1),opacity .3s cubic-bezier(0.23, 1, 0.32, 1);transform-origin:center top}.mx-zoom-in-down-enter,.mx-zoom-in-down-enter-from,.mx-zoom-in-down-leave-to{opacity:0;transform:scaleY(0)}.mx-datepicker{position:relative;display:inline-block;width:210px}.mx-datepicker svg{width:1em;height:1em;vertical-align:-0.15em;fill:currentColor;overflow:hidden}.mx-datepicker-range{width:320px}.mx-datepicker-inline{width:auto}.mx-input-wrapper{position:relative}.mx-input{display:inline-block;box-sizing:border-box;width:100%;height:34px;padding:6px 30px;padding-left:10px;font-size:14px;line-height:1.4;color:#555;background-color:#fff;border:1px solid #ccc;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.mx-input:hover,.mx-input:focus{border-color:#409aff}.mx-input:disabled,.mx-input.disabled{color:#ccc;background-color:#f3f3f3;border-color:#ccc;cursor:not-allowed}.mx-input:focus{outline:none}.mx-input::-ms-clear{display:none}.mx-icon-calendar,.mx-icon-clear{position:absolute;top:50%;right:8px;transform:translateY(-50%);font-size:16px;line-height:1;color:rgba(0,0,0,.5);vertical-align:middle}.mx-icon-clear{cursor:pointer}.mx-icon-clear:hover{color:rgba(0,0,0,.8)}.mx-datepicker-main{font:14px/1.5 "Helvetica Neue",Helvetica,Arial,"Microsoft Yahei",sans-serif;color:#73879c;background-color:#fff;border:1px solid #e8e8e8}.mx-datepicker-popup{position:absolute;margin-top:1px;margin-bottom:1px;box-shadow:0 6px 12px rgba(0,0,0,.175);z-index:2001}.mx-datepicker-sidebar{float:left;box-sizing:border-box;width:100px;padding:6px;overflow:auto}.mx-datepicker-sidebar+.mx-datepicker-content{margin-left:100px;border-left:1px solid #e8e8e8}.mx-datepicker-body{position:relative;user-select:none}.mx-btn-shortcut{display:block;padding:0 6px;line-height:24px}.mx-range-wrapper{display:flex}@media(max-width: 750px){.mx-range-wrapper{flex-direction:column}}.mx-datepicker-header{padding:6px 8px;border-bottom:1px solid #e8e8e8}.mx-datepicker-footer{padding:6px 8px;text-align:right;border-top:1px solid #e8e8e8}.mx-calendar{box-sizing:border-box;width:248px;padding:6px 12px}.mx-calendar+.mx-calendar{border-left:1px solid #e8e8e8}.mx-calendar-header,.mx-time-header{box-sizing:border-box;height:34px;line-height:34px;text-align:center;overflow:hidden}.mx-btn-icon-left,.mx-btn-icon-double-left{float:left}.mx-btn-icon-right,.mx-btn-icon-double-right{float:right}.mx-calendar-header-label{font-size:14px}.mx-calendar-decade-separator{margin:0 2px}.mx-calendar-decade-separator:after{content:"~"}.mx-calendar-content{position:relative;height:224px;box-sizing:border-box}.mx-calendar-content .cell{cursor:pointer}.mx-calendar-content .cell:hover{color:#73879c;background-color:#f3f9fe}.mx-calendar-content .cell.active{color:#fff;background-color:#1284e7}.mx-calendar-content .cell.in-range,.mx-calendar-content .cell.hover-in-range{color:#73879c;background-color:#dbedfb}.mx-calendar-content .cell.disabled{cursor:not-allowed;color:#ccc;background-color:#f3f3f3}.mx-calendar-week-mode .mx-date-row{cursor:pointer}.mx-calendar-week-mode .mx-date-row:hover{background-color:#f3f9fe}.mx-calendar-week-mode .mx-date-row.mx-active-week{background-color:#dbedfb}.mx-calendar-week-mode .mx-date-row .cell:hover{color:inherit;background-color:rgba(0,0,0,0)}.mx-calendar-week-mode .mx-date-row .cell.active{color:inherit;background-color:rgba(0,0,0,0)}.mx-week-number{opacity:.5}.mx-table{table-layout:fixed;border-collapse:separate;border-spacing:0;width:100%;height:100%;box-sizing:border-box;text-align:center}.mx-table th{padding:0;font-weight:500;vertical-align:middle}.mx-table td{padding:0;vertical-align:middle}.mx-table-date td,.mx-table-date th{height:32px;font-size:12px}.mx-table-date .today{color:#2a90e9}.mx-table-date .cell.not-current-month{color:#ccc;background:none}.mx-time{flex:1;width:224px;background:#fff}.mx-time+.mx-time{border-left:1px solid #e8e8e8}.mx-calendar-time{position:absolute;top:0;left:0;width:100%;height:100%}.mx-time-header{border-bottom:1px solid #e8e8e8}.mx-time-content{height:224px;box-sizing:border-box;overflow:hidden}.mx-time-columns{display:flex;width:100%;height:100%;overflow:hidden}.mx-time-column{flex:1;position:relative;border-left:1px solid #e8e8e8;text-align:center}.mx-time-column:first-child{border-left:0}.mx-time-column .mx-time-list{margin:0;padding:0;list-style:none}.mx-time-column .mx-time-list::after{content:"";display:block;height:192px}.mx-time-column .mx-time-item{cursor:pointer;font-size:12px;height:32px;line-height:32px}.mx-time-column .mx-time-item:hover{color:#73879c;background-color:#f3f9fe}.mx-time-column .mx-time-item.active{color:#1284e7;background-color:rgba(0,0,0,0);font-weight:700}.mx-time-column .mx-time-item.disabled{cursor:not-allowed;color:#ccc;background-color:#f3f3f3}.mx-time-option{cursor:pointer;padding:8px 10px;font-size:14px;line-height:20px}.mx-time-option:hover{color:#73879c;background-color:#f3f9fe}.mx-time-option.active{color:#1284e7;background-color:rgba(0,0,0,0);font-weight:700}.mx-time-option.disabled{cursor:not-allowed;color:#ccc;background-color:#f3f3f3}.mx-datepicker[data-v-3d66c94]{user-select:none;color:var(--color-main-text)}.mx-datepicker[data-v-3d66c94] svg{fill:var(--color-main-text)}.mx-datepicker[data-v-3d66c94] .mx-input-wrapper .mx-input{width:100%;border:1px solid var(--color-border);background-color:var(--color-main-background);background-clip:content-box}.mx-datepicker[data-v-3d66c94] .mx-input-wrapper:disabled,.mx-datepicker[data-v-3d66c94] .mx-input-wrapper.disabled{cursor:not-allowed;opacity:.7}.mx-datepicker[data-v-3d66c94] .mx-input-wrapper .mx-icon-calendar,.mx-datepicker[data-v-3d66c94] .mx-input-wrapper .mx-icon-clear{color:var(--color-text-lighter)}.mx-datepicker-main{color:var(--color-main-text);border:1px solid var(--color-border);background-color:var(--color-main-background);font-family:var(--font-face) !important;line-height:1.5}.mx-datepicker-main svg{fill:var(--color-main-text)}.mx-datepicker-main.mx-datepicker-popup{z-index:2000;box-shadow:none}.mx-datepicker-main.mx-datepicker-popup .mx-datepicker-sidebar+.mx-datepicker-content{border-left:1px solid var(--color-border)}.mx-datepicker-main.show-week-number .mx-calendar{width:296px}.mx-datepicker-main .mx-datepicker-header{border-bottom:1px solid var(--color-border)}.mx-datepicker-main .mx-datepicker-footer{border-top:1px solid var(--color-border)}.mx-datepicker-main .mx-datepicker-btn-confirm{background-color:var(--color-primary-element);border-color:var(--color-primary-element);color:var(--color-primary-text) !important;opacity:1 !important}.mx-datepicker-main .mx-datepicker-btn-confirm:hover{background-color:var(--color-primary-element-light) !important;border-color:var(--color-primary-element-light) !important}.mx-datepicker-main .mx-calendar{width:264px;padding:5px}.mx-datepicker-main .mx-calendar.mx-calendar-week-mode{width:296px}.mx-datepicker-main .mx-time+.mx-time,.mx-datepicker-main .mx-calendar+.mx-calendar{border-left:1px solid var(--color-border)}.mx-datepicker-main .mx-range-wrapper{display:flex;overflow:hidden}.mx-datepicker-main .mx-range-wrapper .mx-calendar-content .mx-table-date .cell.active{border-radius:var(--border-radius) 0 0 var(--border-radius)}.mx-datepicker-main .mx-range-wrapper .mx-calendar-content .mx-table-date .cell.in-range+.cell.active{border-radius:0 var(--border-radius) var(--border-radius) 0}.mx-datepicker-main .mx-table{text-align:center}.mx-datepicker-main .mx-table thead>tr>th{text-align:center;opacity:.5;color:var(--color-text-lighter)}.mx-datepicker-main .mx-table tr:focus,.mx-datepicker-main .mx-table tr:hover,.mx-datepicker-main .mx-table tr:active{background-color:rgba(0,0,0,0)}.mx-datepicker-main .mx-table .cell{transition:all 100ms ease-in-out;text-align:center;opacity:.7;border-radius:50px}.mx-datepicker-main .mx-table .cell>*{cursor:pointer}.mx-datepicker-main .mx-table .cell.today{opacity:1;color:var(--color-primary-element);font-weight:bold}.mx-datepicker-main .mx-table .cell.today:hover,.mx-datepicker-main .mx-table .cell.today:focus{color:var(--color-primary-text)}.mx-datepicker-main .mx-table .cell.in-range,.mx-datepicker-main .mx-table .cell.disabled{border-radius:0;font-weight:normal}.mx-datepicker-main .mx-table .cell.in-range{opacity:.7}.mx-datepicker-main .mx-table .cell.not-current-month{opacity:.5;color:var(--color-text-lighter)}.mx-datepicker-main .mx-table .cell.not-current-month:hover,.mx-datepicker-main .mx-table .cell.not-current-month:focus{opacity:1}.mx-datepicker-main .mx-table .cell:hover,.mx-datepicker-main .mx-table .cell:focus,.mx-datepicker-main .mx-table .cell.actived,.mx-datepicker-main .mx-table .cell.active,.mx-datepicker-main .mx-table .cell.in-range{opacity:1;color:var(--color-primary-text);background-color:var(--color-primary-element);font-weight:bold}.mx-datepicker-main .mx-table .cell.disabled{opacity:.5;color:var(--color-text-lighter);border-radius:0;background-color:var(--color-background-darker)}.mx-datepicker-main .mx-table .mx-week-number{text-align:center;opacity:.7;border-radius:50px}.mx-datepicker-main .mx-table span.mx-week-number,.mx-datepicker-main .mx-table li.mx-week-number,.mx-datepicker-main .mx-table span.cell,.mx-datepicker-main .mx-table li.cell{min-height:32px}.mx-datepicker-main .mx-table.mx-table-date thead,.mx-datepicker-main .mx-table.mx-table-date tbody,.mx-datepicker-main .mx-table.mx-table-year,.mx-datepicker-main .mx-table.mx-table-month{display:flex;flex-direction:column;justify-content:space-around}.mx-datepicker-main .mx-table.mx-table-date thead tr,.mx-datepicker-main .mx-table.mx-table-date tbody tr,.mx-datepicker-main .mx-table.mx-table-year tr,.mx-datepicker-main .mx-table.mx-table-month tr{display:inline-flex;align-items:center;flex:1 1 32px;justify-content:space-around;min-height:32px}.mx-datepicker-main .mx-table.mx-table-date thead th,.mx-datepicker-main .mx-table.mx-table-date thead td,.mx-datepicker-main .mx-table.mx-table-date tbody th,.mx-datepicker-main .mx-table.mx-table-date tbody td,.mx-datepicker-main .mx-table.mx-table-year th,.mx-datepicker-main .mx-table.mx-table-year td,.mx-datepicker-main .mx-table.mx-table-month th,.mx-datepicker-main .mx-table.mx-table-month td{display:flex;align-items:center;flex:0 1 32%;justify-content:center;min-width:32px;height:95%;min-height:32px;transition:background 100ms ease-in-out}.mx-datepicker-main .mx-table.mx-table-year tr th,.mx-datepicker-main .mx-table.mx-table-year tr td{flex-basis:48%}.mx-datepicker-main .mx-table.mx-table-date tr th,.mx-datepicker-main .mx-table.mx-table-date tr td{flex-basis:32px}.mx-datepicker-main .mx-btn{min-width:32px;height:32px;margin:0 2px !important;padding:7px 10px;cursor:pointer;text-decoration:none;opacity:.5;color:var(--color-text-lighter);border-radius:32px;line-height:20px}.mx-datepicker-main .mx-btn:hover,.mx-datepicker-main .mx-btn:focus{opacity:1;color:var(--color-main-text);background-color:var(--color-background-darker)}.mx-datepicker-main .mx-calendar-header,.mx-datepicker-main .mx-time-header{display:inline-flex;align-items:center;justify-content:space-between;width:100%;height:44px;margin-bottom:4px}.mx-datepicker-main .mx-calendar-header button,.mx-datepicker-main .mx-time-header button{min-width:32px;min-height:32px;margin:0;cursor:pointer;text-align:center;text-decoration:none;opacity:.7;color:var(--color-main-text);border-radius:32px;line-height:20px}.mx-datepicker-main .mx-calendar-header button:hover,.mx-datepicker-main .mx-time-header button:hover,.mx-datepicker-main .mx-calendar-header button:focus,.mx-datepicker-main .mx-time-header button:focus{opacity:1;color:var(--color-main-text);background-color:var(--color-background-darker)}.mx-datepicker-main .mx-calendar-header button.mx-btn-icon-double-left,.mx-datepicker-main .mx-time-header button.mx-btn-icon-double-left,.mx-datepicker-main .mx-calendar-header button.mx-btn-icon-left,.mx-datepicker-main .mx-time-header button.mx-btn-icon-left,.mx-datepicker-main .mx-calendar-header button.mx-btn-icon-right,.mx-datepicker-main .mx-time-header button.mx-btn-icon-right,.mx-datepicker-main .mx-calendar-header button.mx-btn-icon-double-right,.mx-datepicker-main .mx-time-header button.mx-btn-icon-double-right{align-items:center;justify-content:center;width:32px;padding:0;background-repeat:no-repeat;background-size:16px;background-position:center}.mx-datepicker-main .mx-calendar-header button.mx-btn-icon-double-left>i,.mx-datepicker-main .mx-time-header button.mx-btn-icon-double-left>i,.mx-datepicker-main .mx-calendar-header button.mx-btn-icon-left>i,.mx-datepicker-main .mx-time-header button.mx-btn-icon-left>i,.mx-datepicker-main .mx-calendar-header button.mx-btn-icon-right>i,.mx-datepicker-main .mx-time-header button.mx-btn-icon-right>i,.mx-datepicker-main .mx-calendar-header button.mx-btn-icon-double-right>i,.mx-datepicker-main .mx-time-header button.mx-btn-icon-double-right>i{display:none}.mx-datepicker-main .mx-calendar-header button.mx-btn-text,.mx-datepicker-main .mx-time-header button.mx-btn-text{line-height:initial}.mx-datepicker-main .mx-calendar-header .mx-calendar-header-label,.mx-datepicker-main .mx-time-header .mx-calendar-header-label{display:flex}.mx-datepicker-main .mx-calendar-header .mx-btn-icon-double-left,.mx-datepicker-main .mx-time-header .mx-btn-icon-double-left{background-image:url(' + O + ")}body.theme--dark .mx-datepicker-main .mx-calendar-header .mx-btn-icon-double-left,body.theme--dark .mx-datepicker-main .mx-time-header .mx-btn-icon-double-left{background-image:url(" + y + ")}.mx-datepicker-main .mx-calendar-header .mx-btn-icon-left,.mx-datepicker-main .mx-time-header .mx-btn-icon-left{background-image:url(" + Z + ")}body.theme--dark .mx-datepicker-main .mx-calendar-header .mx-btn-icon-left,body.theme--dark .mx-datepicker-main .mx-time-header .mx-btn-icon-left{background-image:url(" + F + ")}.mx-datepicker-main .mx-calendar-header .mx-btn-icon-right,.mx-datepicker-main .mx-time-header .mx-btn-icon-right{background-image:url(" + b + ")}body.theme--dark .mx-datepicker-main .mx-calendar-header .mx-btn-icon-right,body.theme--dark .mx-datepicker-main .mx-time-header .mx-btn-icon-right{background-image:url(" + Y + ")}.mx-datepicker-main .mx-calendar-header .mx-btn-icon-double-right,.mx-datepicker-main .mx-time-header .mx-btn-icon-double-right{background-image:url(" + I + ")}body.theme--dark .mx-datepicker-main .mx-calendar-header .mx-btn-icon-double-right,body.theme--dark .mx-datepicker-main .mx-time-header .mx-btn-icon-double-right{background-image:url(" + q + ")}.mx-datepicker-main .mx-calendar-header button.mx-btn-icon-right,.mx-datepicker-main .mx-time-header button.mx-btn-icon-right{order:2}.mx-datepicker-main .mx-calendar-header button.mx-btn-icon-double-right,.mx-datepicker-main .mx-time-header button.mx-btn-icon-double-right{order:3}.mx-datepicker-main .mx-calendar-week-mode .mx-date-row .mx-week-number{font-weight:bold}.mx-datepicker-main .mx-calendar-week-mode .mx-date-row:hover,.mx-datepicker-main .mx-calendar-week-mode .mx-date-row.mx-active-week{opacity:1;border-radius:50px;background-color:var(--color-background-dark)}.mx-datepicker-main .mx-calendar-week-mode .mx-date-row:hover td,.mx-datepicker-main .mx-calendar-week-mode .mx-date-row.mx-active-week td{background-color:rgba(0,0,0,0)}.mx-datepicker-main .mx-calendar-week-mode .mx-date-row:hover td,.mx-datepicker-main .mx-calendar-week-mode .mx-date-row:hover td:hover,.mx-datepicker-main .mx-calendar-week-mode .mx-date-row:hover td:focus,.mx-datepicker-main .mx-calendar-week-mode .mx-date-row.mx-active-week td,.mx-datepicker-main .mx-calendar-week-mode .mx-date-row.mx-active-week td:hover,.mx-datepicker-main .mx-calendar-week-mode .mx-date-row.mx-active-week td:focus{color:inherit}.mx-datepicker-main .mx-calendar-week-mode .mx-date-row.mx-active-week{color:var(--color-primary-text);background-color:var(--color-primary-element)}.mx-datepicker-main .mx-calendar-week-mode .mx-date-row.mx-active-week td{opacity:.7;font-weight:normal}.mx-datepicker-main .mx-time{background-color:var(--color-main-background)}.mx-datepicker-main .mx-time .mx-time-header{justify-content:center;border-bottom:1px solid var(--color-border)}.mx-datepicker-main .mx-time .mx-time-column{border-left:1px solid var(--color-border)}.mx-datepicker-main .mx-time .mx-time-option.active,.mx-datepicker-main .mx-time .mx-time-option:hover,.mx-datepicker-main .mx-time .mx-time-item.active,.mx-datepicker-main .mx-time .mx-time-item:hover{color:var(--color-primary-text);background-color:var(--color-primary-element)}.mx-datepicker-main .mx-time .mx-time-option.disabled,.mx-datepicker-main .mx-time .mx-time-item.disabled{cursor:not-allowed;opacity:.5;color:var(--color-main-text);background-color:var(--color-main-background)}", "", { version: 3, sources: ["webpack://./src/assets/material-icons.css", "webpack://./node_modules/vue2-datepicker/scss/icon.scss", "webpack://./node_modules/vue2-datepicker/scss/btn.scss", "webpack://./node_modules/vue2-datepicker/scss/var.scss", "webpack://./node_modules/vue2-datepicker/scss/scrollbar.scss", "webpack://./node_modules/vue2-datepicker/scss/animation.scss", "webpack://./node_modules/vue2-datepicker/scss/index.scss", "webpack://./src/components/NcDatetimePicker/index.scss", "webpack://./src/assets/variables.scss"], names: [], mappings: "AAGA,sBACC,YAAA,CACA,iBAAA,CACA,mBAAA,CACA,kBAAA,CACA,sBAAA,CCND,2JAME,UAAA,CACA,iBAAA,CACA,QAAA,CACA,oBAAA,CACA,UAAA,CACA,WAAA,CACA,qBAAA,CACA,kBAAA,CACA,yBAAA,CACA,wBAAA,CACA,iBAAA,CACA,qBAAA,CACA,uBAAA,CACA,mCAAA,CAGF,2BACE,SAAA,CAGF,6BACE,QAAA,CAGF,+EAGE,mCAAA,CCjCF,QACE,qBAAA,CACA,aAAA,CACA,cAAA,CACA,eAAA,CACA,gBAAA,CACA,QAAA,CACA,cAAA,CACA,8BAAA,CACA,YAAA,CACA,+BAAA,CACA,iBAAA,CACA,aCZc,CDad,kBAAA,CACA,cACE,oBCdY,CDeZ,aCfY,CDiBd,kCAEE,UCTa,CDUb,kBAAA,CAIJ,aACE,QAAA,CACA,aAAA,CACA,eAAA,CACA,mBAAA,CE7BF,cACE,WAAA,CAEE,wCACE,SAAA,CAKN,mBACE,WAAA,CACA,iBAAA,CACA,eAAA,CAGF,oBACE,iBAAA,CACA,OAAA,CACA,SAAA,CACA,UAAA,CACA,SAAA,CACA,SAAA,CACA,iBAAA,CACA,SAAA,CACA,gCAAA,CACA,wCACE,iBAAA,CACA,UAAA,CACA,QAAA,CACA,cAAA,CACA,qBAAA,CACA,qCAAA,CACA,+BAAA,CChCJ,4DAEE,SAAA,CACA,mBAAA,CACA,kGAAA,CAEA,2BAAA,CAGF,6EAGE,SAAA,CACA,mBAAA,CCTF,eACE,iBAAA,CACA,oBAAA,CACA,WAAA,CACA,mBACE,SAAA,CACA,UAAA,CACA,sBAAA,CACA,iBAAA,CACA,eAAA,CAIJ,qBACE,WAAA,CAGF,sBACE,UAAA,CAGF,kBACE,iBAAA,CAGF,UACE,oBAAA,CACA,qBAAA,CACA,UAAA,CACA,WAAA,CACA,gBAAA,CACA,iBAAA,CACA,cAAA,CACA,eAAA,CACA,UH9BY,CG+BZ,qBAAA,CACA,qBAAA,CACA,iBHVoB,CGWpB,2CAAA,CAEA,gCAEE,oBHrCuB,CGuCzB,sCAEE,UHvCa,CGwCb,wBHvCwB,CGwCxB,iBH7CiB,CG8CjB,kBAAA,CAEF,gBACE,YAAA,CAEF,qBACE,YAAA,CAIJ,iCAEE,iBAAA,CACA,OAAA,CACA,SAAA,CACA,0BAAA,CACA,cAAA,CACA,aAAA,CACA,oBAAA,CACA,qBAAA,CAGF,eACE,cAAA,CACA,qBACE,oBAAA,CAIJ,oBACE,2EAAA,CACA,aHpFc,CGqFd,qBAAA,CACA,wBAAA,CAGF,qBACE,iBAAA,CACA,cAAA,CACA,iBAAA,CACA,sCAAA,CACA,YHzFc,CG4FhB,uBACE,UAAA,CACA,qBAAA,CACA,WHpEoB,CGqEpB,WAAA,CACA,aAAA,CAGF,8CACE,iBH1EoB,CG2EpB,6BAAA,CAGF,oBACE,iBAAA,CACA,gBAAA,CAGF,iBACE,aAAA,CACA,aAAA,CACA,gBAAA,CAGF,kBACE,YAAA,CACA,yBAFF,kBAGI,qBAAA,CAAA,CAIJ,sBACE,eAAA,CACA,+BAAA,CAGF,sBACE,eAAA,CACA,gBAAA,CACA,4BAAA,CAGF,aACE,qBAAA,CACA,WAAA,CACA,gBAAA,CACA,0BACE,6BAAA,CAIJ,oCACE,qBAAA,CACA,WAAA,CACA,gBAAA,CACA,iBAAA,CACA,eAAA,CAGF,2CAEE,UAAA,CAEF,6CAEE,WAAA,CAGF,0BACE,cAAA,CAGF,8BACE,YAAA,CACA,oCACE,WAAA,CAIJ,qBACE,iBAAA,CACA,YAAA,CACA,qBAAA,CACA,2BACE,cAAA,CACA,iCACE,aHvLU,CGwLV,wBHpK4B,CGsK9B,kCACE,UH3KkB,CG4KlB,wBH3LU,CG6LZ,8EAEE,aHhMU,CGiMV,wBH1K+B,CG4KjC,oCACE,kBAAA,CACA,UH1LW,CG2LX,wBH1LsB,CGgM1B,oCACE,cAAA,CACA,0CACE,wBH3L4B,CG6L9B,mDACE,wBH3L+B,CG8L/B,gDACE,aAAA,CACA,8BAAA,CAEF,iDACE,aAAA,CACA,8BAAA,CAMR,gBACE,UAAA,CAGF,UACE,kBAAA,CACA,wBAAA,CACA,gBAAA,CACA,UAAA,CACA,WAAA,CACA,qBAAA,CACA,iBAAA,CAEA,aACE,SAAA,CACA,eAAA,CACA,qBAAA,CAEF,aACE,SAAA,CACA,qBAAA,CAKF,oCAEE,WAAA,CACA,cAAA,CAGF,sBACE,aH9PU,CGgQZ,uCACE,UAAA,CACA,eAAA,CAIJ,SACE,MAAA,CACA,WAAA,CACA,eAAA,CACA,kBACE,6BAAA,CAGJ,kBACE,iBAAA,CACA,KAAA,CACA,MAAA,CACA,UAAA,CACA,WAAA,CAEF,gBAEE,+BAAA,CAGF,iBACE,YAAA,CACA,qBAAA,CACA,eAAA,CAGF,iBACE,YAAA,CACA,UAAA,CACA,WAAA,CACA,eAAA,CAGF,gBACE,MAAA,CACA,iBAAA,CACA,6BAAA,CACA,iBAAA,CAEA,4BACE,aAAA,CAEF,8BACE,QAAA,CACA,SAAA,CACA,eAAA,CACA,qCACE,UAAA,CACA,aAAA,CACA,YAAA,CAGJ,8BACE,cAAA,CACA,cAAA,CACA,WAAA,CACA,gBAAA,CACA,oCACE,aHnUU,CGoUV,wBHvSwB,CGyS1B,qCACE,aHtUU,CGuUV,8BH9SyB,CG+SzB,eAAA,CAEF,uCACE,kBAAA,CACA,UHlUW,CGmUX,wBHlUsB,CGuU5B,gBACE,cAAA,CACA,gBAAA,CACA,cAAA,CACA,gBAAA,CACA,sBACE,aHzVY,CG0VZ,wBH7T0B,CG+T5B,uBACE,aH5VY,CG6VZ,8BHpU2B,CGqU3B,eAAA,CAEF,yBACE,kBAAA,CACA,UHxVa,CGyVb,wBHxVwB,CIT5B,+BACC,gBAAA,CACA,4BAAA,CAEA,mCACC,2BAAA,CAMA,2DACC,UAAA,CACA,oCAAA,CACA,6CAAA,CACA,2BAAA,CAGD,oHAEC,kBAAA,CACA,UCiBc,CDdf,mIAEC,+BAAA,CAMH,oBACC,4BAAA,CACA,oCAAA,CACA,6CAAA,CACA,uCAAA,CACA,eAAA,CAEA,wBACC,2BAAA,CAGD,wCACC,YAAA,CACA,eAAA,CAEA,sFACC,yCAAA,CAIF,kDACC,WAAA,CAGD,0CACC,2CAAA,CAGD,0CACC,wCAAA,CAGD,+CACC,6CAAA,CACA,yCAAA,CACA,0CAAA,CACA,oBAAA,CAGD,qDACC,8DAAA,CACA,0DAAA,CAID,iCACC,WAAA,CACA,WAAA,CACA,uDACC,WAAA,CAIF,oFAEC,yCAAA,CAGD,sCACC,YAAA,CACA,eAAA,CAIC,uFACC,2DAAA,CAGD,sGACC,2DAAA,CAMH,8BACC,iBAAA,CAEA,0CACC,iBAAA,CACA,UC3EgB,CD4EhB,+BAAA,CAID,sHAGC,8BAAA,CAID,oCACC,gCAAA,CACA,iBAAA,CACA,UCzFc,CD0Fd,kBAAA,CAGA,sCACC,cAAA,CAID,0CACC,SClGW,CDmGX,kCAAA,CACA,gBAAA,CACA,gGAEC,+BAAA,CAGF,0FAEC,eAAA,CACA,kBAAA,CAED,6CACC,UCjHa,CDmHd,sDACC,UCrHe,CDsHf,+BAAA,CACA,wHAEC,SCvHU,CD4HZ,wNAKC,SCjIW,CDkIX,+BAAA,CACA,6CAAA,CACA,gBAAA,CAED,6CACC,UCzIe,CD0If,+BAAA,CACA,eAAA,CACA,+CAAA,CAIF,8CACC,iBAAA,CACA,UCjJc,CDkJd,kBAAA,CAID,gLAIC,eApMW,CAwMZ,6LAIC,YAAA,CACA,qBAAA,CACA,4BAAA,CACA,yMACC,mBAAA,CACA,kBAAA,CACA,aAAA,CACA,4BAAA,CACA,eApNU,CAuNX,kZAEC,YAAA,CACA,kBAAA,CAEA,YAAA,CACA,sBAAA,CACA,cA9NU,CAgOV,UAAA,CACA,eAjOU,CAkOV,uCAAA,CAID,oGAGC,cAAA,CAID,oGAGC,eAhPU,CAsPb,4BACC,cAvPY,CAwPZ,WAxPY,CAyPZ,uBAAA,CACA,gBAAA,CACA,cAAA,CACA,oBAAA,CACA,UCpNiB,CDqNjB,+BAAA,CACA,kBA/PY,CAgQZ,gBAAA,CAEA,oEAEC,SCzNY,CD0NZ,4BAAA,CACA,+CAAA,CAKF,4EACC,mBAAA,CACA,kBAAA,CACA,6BAAA,CACA,UAAA,CACA,WCxPe,CDyPf,iBAAA,CAEA,0FACC,cApRW,CAqRX,eArRW,CAsRX,QAAA,CACA,cAAA,CACA,iBAAA,CACA,oBAAA,CACA,UChPc,CDiPd,4BAAA,CACA,kBA5RW,CA6RX,gBAAA,CAGA,4MAEC,SCvPW,CDwPX,4BAAA,CACA,+CAAA,CAID,ghBAIC,kBAAA,CACA,sBAAA,CACA,UA9SU,CA+SV,SAAA,CACA,2BAAA,CACA,oBAAA,CACA,0BAAA,CAGA,giBACC,YAAA,CAGF,kHACC,mBAAA,CAIF,gIACC,YAAA,CAGD,8HACC,wDAAA,CACA,gKACC,wDAAA,CAIF,gHACC,wDAAA,CACA,kJACC,wDAAA,CAIF,kHACC,wDAAA,CACA,oJACC,wDAAA,CAIF,gIACC,wDAAA,CACA,kKACC,wDAAA,CAIF,8HACC,OAAA,CAGD,4IACC,OAAA,CAOA,wEACC,gBAAA,CAED,qIAEC,SCpUW,CDqUX,kBAAA,CACA,6CAAA,CACA,2IACC,8BAAA,CACA,ybACC,aAAA,CAIH,uEACC,+BAAA,CACA,6CAAA,CAEA,0EACC,UCpVY,CDqVZ,kBAAA,CAOJ,6BACC,6CAAA,CAEA,6CAEC,sBAAA,CACA,2CAAA,CAGD,6CACC,yCAAA,CAKA,0MAEC,+BAAA,CACA,6CAAA,CAGD,0GACC,kBAAA,CACA,UCpXe,CDqXf,4BAAA,CACA,6CAAA", sourcesContent: [`/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon {
	display: flex;
	align-self: center;
	justify-self: center;
	align-items: center;
	justify-content: center;
}
`, `@import './var.scss';

.#{$namespace}-icon-left:before,
.#{$namespace}-icon-right:before,
.#{$namespace}-icon-double-left:before,
.#{$namespace}-icon-double-right:before,
.#{$namespace}-icon-double-left:after,
.#{$namespace}-icon-double-right:after {
  content: '';
  position: relative;
  top: -1px;
  display: inline-block;
  width: 10px;
  height: 10px;
  vertical-align: middle;
  border-style: solid;
  border-color: currentColor;
  border-width: 2px 0 0 2px;
  border-radius: 1px;
  box-sizing: border-box;
  transform-origin: center;
  transform: rotate(-45deg) scale(0.7);
}

.#{$namespace}-icon-double-left:after {
  left: -4px;
}

.#{$namespace}-icon-double-right:before {
  left: 4px;
}

.#{$namespace}-icon-right:before,
.#{$namespace}-icon-double-right:before,
.#{$namespace}-icon-double-right:after {
  transform: rotate(135deg) scale(0.7);
}
`, `@import './var.scss';

.#{$namespace}-btn {
  box-sizing: border-box;
  line-height: 1;
  font-size: 14px;
  font-weight: 500;
  padding: 7px 15px;
  margin: 0;
  cursor: pointer;
  background-color: transparent;
  outline: none;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  color: $default-color;
  white-space: nowrap;
  &:hover {
    border-color: $primary-color;
    color: $primary-color;
  }
  &:disabled,
  &.disabled {
    color: $disabled-color;
    cursor: not-allowed;
  }
}

.#{$namespace}-btn-text {
  border: 0;
  padding: 0 4px;
  text-align: left;
  line-height: inherit;
}
`, `$namespace: 'mx' !default;

$default-color: #73879c !default;
$primary-color: #1284e7 !default;

$today-color: mix(#fff, $primary-color, 10%) !default;

$popup-z-index: 2001 !default;

$input-border-color: #ccc !default;
$input-color: #555 !default;
$input-hover-border-color: #409aff !default;

$disabled-color: #ccc !default;
$disabled-background-color: #f3f3f3 !default;

$border-color: #e8e8e8 !default;

$calendar-active-color: #fff !default;
$calendar-active-background-color: $primary-color !default;

$calendar-hover-color: $default-color !default;
$calendar-hover-background-color: mix(#fff, $calendar-active-background-color, 95%) !default;

$calendar-in-range-color: $default-color !default;
$calendar-in-range-background-color: mix(#fff, $calendar-active-background-color, 85%) !default;

$time-active-color: $primary-color !default;
$time-active-background-color: transparent !default;

$time-hover-color: $default-color !default;
$time-hover-background-color: mix(#fff, $calendar-active-background-color, 95%) !default;

$input-border-radius: 4px !default;
$sidebar-margin-left: 100px !default;
`, `@import './var.scss';

.#{$namespace}-scrollbar {
  height: 100%;
  &:hover {
    .#{$namespace}-scrollbar-track {
      opacity: 1;
    }
  }
}

.#{$namespace}-scrollbar-wrap {
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
}

.#{$namespace}-scrollbar-track {
  position: absolute;
  top: 2px;
  right: 2px;
  bottom: 2px;
  width: 6px;
  z-index: 1;
  border-radius: 4px;
  opacity: 0;
  transition: opacity 0.24s ease-out;
  .#{$namespace}-scrollbar-thumb {
    position: absolute;
    width: 100%;
    height: 0;
    cursor: pointer;
    border-radius: inherit;
    background-color: rgba(144, 147, 153, 0.3);
    transition: background-color 0.3s;
  }
}
`, `@import './var.scss';

.#{$namespace}-zoom-in-down-enter-active,
.#{$namespace}-zoom-in-down-leave-active {
  opacity: 1;
  transform: scaleY(1);
  transition: transform 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    opacity 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  transform-origin: center top;
}

.#{$namespace}-zoom-in-down-enter,
.#{$namespace}-zoom-in-down-enter-from,
.#{$namespace}-zoom-in-down-leave-to {
  opacity: 0;
  transform: scaleY(0);
}
`, `@import './var.scss';
@import './icon.scss';
@import './btn.scss';
@import './scrollbar.scss';
@import './animation.scss';

.#{$namespace}-datepicker {
  position: relative;
  display: inline-block;
  width: 210px;
  svg {
    width: 1em;
    height: 1em;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
  }
}

.#{$namespace}-datepicker-range {
  width: 320px;
}

.#{$namespace}-datepicker-inline {
  width: auto;
}

.#{$namespace}-input-wrapper {
  position: relative;
}

.#{$namespace}-input {
  display: inline-block;
  box-sizing: border-box;
  width: 100%;
  height: 34px;
  padding: 6px 30px;
  padding-left: 10px;
  font-size: 14px;
  line-height: 1.4;
  color: $input-color;
  background-color: #fff;
  border: 1px solid $input-border-color;
  border-radius: $input-border-radius;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);

  &:hover,
  &:focus {
    border-color: $input-hover-border-color;
  }
  &:disabled,
  &.disabled {
    color: $disabled-color;
    background-color: $disabled-background-color;
    border-color: $input-border-color;
    cursor: not-allowed;
  }
  &:focus {
    outline: none;
  }
  &::-ms-clear {
    display: none;
  }
}

.#{$namespace}-icon-calendar,
.#{$namespace}-icon-clear {
  position: absolute;
  top: 50%;
  right: 8px;
  transform: translateY(-50%);
  font-size: 16px;
  line-height: 1;
  color: rgba(0, 0, 0, 0.5);
  vertical-align: middle;
}

.#{$namespace}-icon-clear {
  cursor: pointer;
  &:hover {
    color: rgba(0, 0, 0, 0.8);
  }
}

.#{$namespace}-datepicker-main {
  font: 14px/1.5 'Helvetica Neue', Helvetica, Arial, 'Microsoft Yahei', sans-serif;
  color: $default-color;
  background-color: #fff;
  border: 1px solid $border-color;
}

.#{$namespace}-datepicker-popup {
  position: absolute;
  margin-top: 1px;
  margin-bottom: 1px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  z-index: $popup-z-index;
}

.#{$namespace}-datepicker-sidebar {
  float: left;
  box-sizing: border-box;
  width: $sidebar-margin-left;
  padding: 6px;
  overflow: auto;
}

.#{$namespace}-datepicker-sidebar + .#{$namespace}-datepicker-content {
  margin-left: $sidebar-margin-left;
  border-left: 1px solid $border-color;
}

.#{$namespace}-datepicker-body {
  position: relative;
  user-select: none;
}

.#{$namespace}-btn-shortcut {
  display: block;
  padding: 0 6px;
  line-height: 24px;
}

.#{$namespace}-range-wrapper {
  display: flex;
  @media (max-width: 750px) {
    flex-direction: column;
  }
}

.#{$namespace}-datepicker-header {
  padding: 6px 8px;
  border-bottom: 1px solid $border-color;
}

.#{$namespace}-datepicker-footer {
  padding: 6px 8px;
  text-align: right;
  border-top: 1px solid $border-color;
}

.#{$namespace}-calendar {
  box-sizing: border-box;
  width: 248px;
  padding: 6px 12px;
  & + & {
    border-left: 1px solid $border-color;
  }
}

.#{$namespace}-calendar-header {
  box-sizing: border-box;
  height: 34px;
  line-height: 34px;
  text-align: center;
  overflow: hidden;
}

.#{$namespace}-btn-icon-left,
.#{$namespace}-btn-icon-double-left {
  float: left;
}
.#{$namespace}-btn-icon-right,
.#{$namespace}-btn-icon-double-right {
  float: right;
}

.#{$namespace}-calendar-header-label {
  font-size: 14px;
}

.#{$namespace}-calendar-decade-separator {
  margin: 0 2px;
  &:after {
    content: '~';
  }
}

.#{$namespace}-calendar-content {
  position: relative;
  height: 224px;
  box-sizing: border-box;
  .cell {
    cursor: pointer;
    &:hover {
      color: $calendar-hover-color;
      background-color: $calendar-hover-background-color;
    }
    &.active {
      color: $calendar-active-color;
      background-color: $calendar-active-background-color;
    }
    &.in-range,
    &.hover-in-range {
      color: $calendar-in-range-color;
      background-color: $calendar-in-range-background-color;
    }
    &.disabled {
      cursor: not-allowed;
      color: $disabled-color;
      background-color: $disabled-background-color;
    }
  }
}

.#{$namespace}-calendar-week-mode {
  .#{$namespace}-date-row {
    cursor: pointer;
    &:hover {
      background-color: $calendar-hover-background-color;
    }
    &.#{$namespace}-active-week {
      background-color: $calendar-in-range-background-color;
    }
    .cell {
      &:hover {
        color: inherit;
        background-color: transparent;
      }
      &.active {
        color: inherit;
        background-color: transparent;
      }
    }
  }
}

.#{$namespace}-week-number {
  opacity: 0.5;
}

.#{$namespace}-table {
  table-layout: fixed;
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  text-align: center;

  th {
    padding: 0;
    font-weight: 500;
    vertical-align: middle;
  }
  td {
    padding: 0;
    vertical-align: middle;
  }
}

.#{$namespace}-table-date {
  td,
  th {
    height: 32px;
    font-size: 12px;
  }

  .today {
    color: $today-color;
  }
  .cell.not-current-month {
    color: #ccc;
    background: none; // cover the in-range style
  }
}

.#{$namespace}-time {
  flex: 1;
  width: 224px;
  background: #fff;
  & + & {
    border-left: 1px solid $border-color;
  }
}
.#{$namespace}-calendar-time {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.#{$namespace}-time-header {
  @extend .#{$namespace}-calendar-header;
  border-bottom: 1px solid $border-color;
}

.#{$namespace}-time-content {
  height: 224px;
  box-sizing: border-box;
  overflow: hidden;
}

.#{$namespace}-time-columns {
  display: flex;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.#{$namespace}-time-column {
  flex: 1;
  position: relative;
  border-left: 1px solid $border-color;
  text-align: center;

  &:first-child {
    border-left: 0;
  }
  .#{$namespace}-time-list {
    margin: 0;
    padding: 0;
    list-style: none;
    &::after {
      content: '';
      display: block;
      height: 32 * 6px;
    }
  }
  .#{$namespace}-time-item {
    cursor: pointer;
    font-size: 12px;
    height: 32px;
    line-height: 32px;
    &:hover {
      color: $time-hover-color;
      background-color: $time-hover-background-color;
    }
    &.active {
      color: $time-active-color;
      background-color: $time-active-background-color;
      font-weight: 700;
    }
    &.disabled {
      cursor: not-allowed;
      color: $disabled-color;
      background-color: $disabled-background-color;
    }
  }
}

.#{$namespace}-time-option {
  cursor: pointer;
  padding: 8px 10px;
  font-size: 14px;
  line-height: 20px;
  &:hover {
    color: $time-hover-color;
    background-color: $time-hover-background-color;
  }
  &.active {
    color: $time-active-color;
    background-color: $time-active-background-color;
    font-weight: 700;
  }
  &.disabled {
    cursor: not-allowed;
    color: $disabled-color;
    background-color: $disabled-background-color;
  }
}
`, `@use 'sass:math'; $scope_version:"3d66c94"; @import 'variables'; @import 'material-icons';
$cell_height: 32px;

@import '~vue2-datepicker/scss/index';

.mx-datepicker[data-v-#{$scope_version}] {
	user-select: none;
	color: var(--color-main-text);

	svg {
		fill: var(--color-main-text);
	}

	/* INPUT CONTAINER */
	.mx-input-wrapper {
		// input
		.mx-input {
			width: 100%;
			border: 1px solid var(--color-border);
			background-color: var(--color-main-background);
			background-clip: content-box;
		}

		&:disabled,
		&.disabled {
			cursor: not-allowed;
			opacity: $opacity_normal;
		}

		.mx-icon-calendar,
		.mx-icon-clear {
			color: var(--color-text-lighter);
		}
	}
}

// Datepicker popup wrapper
.mx-datepicker-main {
	color: var(--color-main-text);
	border: 1px solid var(--color-border);
	background-color: var(--color-main-background);
	font-family: var(--font-face) !important;
	line-height: 1.5;

	svg {
		fill: var(--color-main-text);
	}

	&.mx-datepicker-popup {
		z-index: 2000;
		box-shadow: none;

		.mx-datepicker-sidebar + .mx-datepicker-content {
			border-left: 1px solid var(--color-border);
		}
	}
	
	&.show-week-number .mx-calendar {
		width: $cell_height * 8 + 2 * 5px + 30px; // week number + 7 days + padding + 30px padding to fit the buttons
	}

	.mx-datepicker-header {
		border-bottom: 1px solid var(--color-border);
	}

	.mx-datepicker-footer {
		border-top: 1px solid var(--color-border);
	}

	.mx-datepicker-btn-confirm {
		background-color: var(--color-primary-element);
		border-color: var(--color-primary-element);
		color: var(--color-primary-text) !important;
		opacity: 1 !important;
	}

	.mx-datepicker-btn-confirm:hover {
		background-color: var(--color-primary-element-light) !important;
		border-color: var(--color-primary-element-light) !important;
	}

	// default popup styles
	.mx-calendar {
		width: $cell_height * 7 + 2 * 5px + 30px; // 7 days + padding + 30px padding to fit the buttons
		padding: 5px;
		&.mx-calendar-week-mode {
			width: $cell_height * 8 + 2 * 5px + 30px; // week number + 7 days + padding + 30px padding to fit the buttons
		}
	}

	.mx-time + .mx-time,
	.mx-calendar + .mx-calendar {
		border-left: 1px solid var(--color-border);
	}

	.mx-range-wrapper {
		display: flex;
		overflow: hidden;

		// first active cell, range style on day picker panel only
		.mx-calendar-content .mx-table-date .cell {
			&.active {
				border-radius: var(--border-radius) 0 0 var(--border-radius);
			}
			// second selected cell
			&.in-range + .cell.active {
				border-radius: 0 var(--border-radius) var(--border-radius) 0;
			}
		}
	}

	// Various panels
	.mx-table {
		text-align: center;

		thead > tr > th {
			text-align: center;
			opacity: $opacity_disabled;
			color: var(--color-text-lighter);
		}

		// Override table rule from server
		tr:focus,
		tr:hover,
		tr:active {
			background-color: transparent;
		}

		// regular cell style
		.cell {
			transition: all 100ms ease-in-out;
			text-align: center;
			opacity: $opacity_normal;
			border-radius: 50px;

			// force pointer on all content
			> * {
				cursor: pointer;
			}

			// Selected and mouse event
			&.today {
				opacity: $opacity_full;
				color: var(--color-primary-element);
				font-weight: bold;
				&:hover,
				&:focus {
					color: var(--color-primary-text);
				}
			}
			&.in-range,
			&.disabled {
				border-radius: 0;
				font-weight: normal;
			}
			&.in-range {
				opacity: $opacity_normal;
			}
			&.not-current-month {
				opacity: $opacity_disabled;
				color: var(--color-text-lighter);
				&:hover,
				&:focus {
					opacity: $opacity_full;
				}
			}

			// hover-/focus after the other rules
			&:hover,
			&:focus,
			&.actived,
			&.active,
			&.in-range {
				opacity: $opacity_full;
				color: var(--color-primary-text);
				background-color: var(--color-primary-element);
				font-weight: bold;
			}
			&.disabled {
				opacity: $opacity_disabled;
				color: var(--color-text-lighter);
				border-radius: 0;
				background-color: var(--color-background-darker);
			}
		}

		.mx-week-number {
			text-align: center;
			opacity: $opacity_normal;
			border-radius: 50px;
		}

		// cell that are not in a table
		span.mx-week-number,
		li.mx-week-number,
		span.cell,
		li.cell {
			min-height: $cell_height;
		}

		// Standard grid/flex layout for day/month/year panels
		&.mx-table-date thead,
		&.mx-table-date tbody,
		&.mx-table-year,
		&.mx-table-month {
			display: flex;
			flex-direction: column;
			justify-content: space-around;
			tr {
				display: inline-flex;
				align-items: center;
				flex: 1 1 $cell_height;
				justify-content: space-around;
				min-height: $cell_height;
			}
			// Default cell style
			th,
			td {
				display: flex;
				align-items: center;
				// 3 rows with a little spacing
				flex: 0 1 32%;
				justify-content: center;
				min-width: $cell_height;
				// spacing between rows
				height: 95%;
				min-height: $cell_height;
				transition: background 100ms ease-in-out;
			}
		}
		&.mx-table-year {
			tr th,
			tr td {
				// only two rows in year panel
				flex-basis: 48%;
			}
		}
		&.mx-table-date {
			tr th,
			tr td {
				// only two rows in year panel
				flex-basis: $cell_height;
			}
		}
	}

	// default buttons: header...
	.mx-btn {
		min-width: $cell_height;
		height: $cell_height;
		margin: 0 2px !important; // center also single element. Definitively use margin so that buttons are not touching
		padding: 7px 10px;
		cursor: pointer;
		text-decoration: none;
		opacity: $opacity_disabled;
		color: var(--color-text-lighter);
		border-radius: $cell_height;
		line-height: $cell_height - 12px; // padding minus 2px for better visual
		// Mouse feedback
		&:hover,
		&:focus {
			opacity: $opacity_full;
			color: var(--color-main-text);
			background-color: var(--color-background-darker);
		}
	}

	// Header, arrows, years, months
	.mx-calendar-header {
		display: inline-flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;
		height: $clickable-area;
		margin-bottom: 4px;

		button {
			min-width: $cell_height;
			min-height: $cell_height;
			margin: 0;
			cursor: pointer;
			text-align: center;
			text-decoration: none;
			opacity: $opacity_normal;
			color: var(--color-main-text);
			border-radius: $cell_height;
			line-height: $cell_height - 12px; // padding minus 2px for better visual

			// Mouse feedback
			&:hover,
			&:focus {
				opacity: $opacity_full;
				color: var(--color-main-text);
				background-color: var(--color-background-darker);
			}

			// Header arrows
			&.mx-btn-icon-double-left,
			&.mx-btn-icon-left,
			&.mx-btn-icon-right,
			&.mx-btn-icon-double-right {
				align-items: center;
				justify-content: center;
				width: $cell_height;
				padding: 0; // leave the centering to flex
				background-repeat: no-repeat;
				background-size: 16px;
				background-position: center;

				// Hide original icons
				> i {
					display: none;
				}
			}
			&.mx-btn-text {
				line-height: initial;
			}
		}

		.mx-calendar-header-label {
			display: flex;
		}

		.mx-btn-icon-double-left {
			background-image: url('./chevron-double-left.svg');
			body.theme--dark & {
				background-image: url('./chevron-double-left-light.svg');
			}
		}

		.mx-btn-icon-left {
			background-image: url('./chevron-left.svg');
			body.theme--dark & {
				background-image: url('./chevron-left-light.svg');
			}
		}

		.mx-btn-icon-right {
			background-image: url('./chevron-right.svg');
			body.theme--dark & {
				background-image: url('./chevron-right-light.svg');
			}
		}

		.mx-btn-icon-double-right {
			background-image: url('./chevron-double-right.svg');
			body.theme--dark & {
				background-image: url('./chevron-double-right-light.svg');
			}
		}

		button.mx-btn-icon-right {
			order: 2;
		}

		button.mx-btn-icon-double-right {
			order: 3;
		}
	}
	// Week panel
	.mx-calendar-week-mode {
		// move focus on row and not on cell
		.mx-date-row {
			.mx-week-number {
				font-weight: bold;
			}
			&:hover,
			&.mx-active-week {
				opacity: $opacity_full;
				border-radius: 50px;
				background-color: var(--color-background-dark);
				td {
					background-color: transparent;
					&, &:hover, &:focus {
						color: inherit;
					}
				}
			}
			&.mx-active-week {
				color: var(--color-primary-text);
				background-color: var(--color-primary-element);
				// Remove cell feedback on selected rows
				td {
					opacity: $opacity_normal;
					font-weight: normal;
				}
			}
		}
	}

	// Time panel
	.mx-time {
		background-color: var(--color-main-background);

		.mx-time-header {
			// only one button, center it
			justify-content: center;
			border-bottom: 1px solid var(--color-border);
		}

		.mx-time-column {
			border-left: 1px solid var(--color-border);
		}

		.mx-time-option,
		.mx-time-item {
			&.active,
			&:hover {
				color: var(--color-primary-text);
				background-color: var(--color-primary-element);
			}

			&.disabled {
				cursor: not-allowed;
				opacity: $opacity_disabled;
				color: var(--color-main-text);
				background-color: var(--color-main-background);
			}
		}
	}
}
`, `/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */

// https://uxplanet.org/7-rules-for-mobile-ui-button-design-e9cf2ea54556
// recommended is 48px
// 44px is what we choose and have very good visual-to-usability ratio
$clickable-area: 44px;

// background icon size
// also used for the scss icon font
$icon-size: 16px;

// icon padding for a $clickable-area width and a $icon-size icon
// ( 44px - 16px ) / 2
$icon-margin: math.div($clickable-area - $icon-size, 2);

// transparency background for icons
$icon-focus-bg: rgba(127, 127, 127, .25);

// popovermenu arrow width from the triangle center
$arrow-width: 9px;

// opacities
$opacity_disabled: .5;
$opacity_normal: .7;
$opacity_full: 1;

// menu round background hover feedback
// good looking on dark AND white bg
$action-background-hover: rgba(127, 127, 127, .25);

// various structure data used in the 
// \`AppNavigation\` component
$header-height: 50px;
$navigation-width: 300px;

// mobile breakpoint
$breakpoint-mobile: 1024px;

// top-bar spacing
$topbar-margin: 4px;

// navigation spacing
$app-navigation-settings-margin: 3px;
`], sourceRoot: "" }]);
      const _ = v;
    }, 636: (o, l, a) => {
      a.d(l, { Z: () => A });
      var c = a(7537), T = a.n(c), u = a(3645), d = a.n(u)()(T());
      d.push([o.id, '.material-design-icon{display:flex;align-self:center;justify-self:center;align-items:center;justify-content:center}.multiselect[data-v-3d66c94]{margin:0;padding:0 !important;display:inline-block;min-width:260px;position:relative}.multiselect[data-v-3d66c94]:not(.multiselect--active) .multiselect__single{width:100%;z-index:2 !important}.multiselect[data-v-3d66c94].multiselect--active.multiselect--above input.multiselect__input{border-radius:0 0 var(--border-radius) var(--border-radius)}.multiselect[data-v-3d66c94].multiselect--disabled,.multiselect[data-v-3d66c94].multiselect--disabled .multiselect__single{background-color:var(--color-background-dark) !important}.multiselect[data-v-3d66c94] .loading-icon{position:absolute;right:1px;top:1px;width:48px;height:35px;background:var(--color-main-background);z-index:3}.multiselect[data-v-3d66c94] .multiselect__tags{display:flex;flex-wrap:nowrap;overflow:hidden;border:2px solid var(--color-border-dark);cursor:pointer;position:relative;border-radius:var(--border-radius-large);min-height:44px;height:44px;padding:8px 12px !important;background-color:var(--color-main-background);box-sizing:border-box}.multiselect[data-v-3d66c94] .multiselect__tags:focus,.multiselect[data-v-3d66c94] .multiselect__tags:hover{border-color:var(--color-primary)}.multiselect[data-v-3d66c94] .multiselect__tags .multiselect__tags-wrap{align-items:center;display:inline-flex;overflow:hidden;max-width:100%;position:relative;gap:5px;flex:1 1;flex-wrap:nowrap}.multiselect[data-v-3d66c94] .multiselect__tags .multiselect__tags-wrap:empty~input.multiselect__input{opacity:1 !important;display:block !important}.multiselect[data-v-3d66c94] .multiselect__tags .multiselect__tags-wrap:empty~input.multiselect__input+span:not(.multiselect__single){display:none}.multiselect[data-v-3d66c94] .multiselect__tags .multiselect__tags-wrap .multiselect__tag{line-height:20px;padding:2px 5px;background-image:none;color:var(--color-main-text);border:1px solid var(--color-border-dark);display:inline-flex;align-items:center;border-radius:var(--border-radius);min-width:0;max-width:fit-content;max-width:-moz-fit-content;margin:0}.multiselect[data-v-3d66c94] .multiselect__tags .multiselect__tags-wrap .multiselect__tag:only-child{flex:0 1 auto}.multiselect[data-v-3d66c94] .multiselect__tags .multiselect__tags-wrap .multiselect__tag>span{white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.multiselect[data-v-3d66c94] .multiselect__tags .multiselect__single,.multiselect[data-v-3d66c94] .multiselect__tags .multiselect__placeholder{z-index:1;background-color:var(--color-main-background);line-height:18px;color:var(--color-text-lighter);display:flex;align-items:center;font-size:var(--default-font-size)}.multiselect[data-v-3d66c94] .multiselect__tags .multiselect__single,.multiselect[data-v-3d66c94] .multiselect__tags .multiselect__single *,.multiselect[data-v-3d66c94] .multiselect__tags .multiselect__placeholder,.multiselect[data-v-3d66c94] .multiselect__tags .multiselect__placeholder *{cursor:pointer}.multiselect[data-v-3d66c94] .multiselect__tags .multiselect__strong,.multiselect[data-v-3d66c94] .multiselect__tags .multiselect__limit{line-height:20px;color:var(--color-text-lighter);display:inline-flex;align-items:center;opacity:.7;margin-right:5px;z-index:5}.multiselect[data-v-3d66c94] .multiselect__tags input.multiselect__input{width:100% !important;height:auto !important;margin:0;opacity:0;border:none;cursor:pointer;display:none;height:40px;min-height:26px;padding:0 !important;font-size:var(--default-font-size)}.multiselect[data-v-3d66c94].multiselect--active input.multiselect__input{opacity:1 !important;cursor:text !important;border-radius:var(--border-radius) var(--border-radius) 0 0;display:block !important}.multiselect[data-v-3d66c94].multiselect--active .multiselect__limit{display:none}.multiselect[data-v-3d66c94] .multiselect__content-wrapper{position:absolute;width:100%;margin-top:-1px;border:1px solid var(--color-border-dark);background:var(--color-main-background);z-index:50;max-height:250px;overflow-y:auto;border-radius:0 0 var(--border-radius) var(--border-radius)}.multiselect[data-v-3d66c94] .multiselect__content-wrapper .multiselect__content{width:100%;padding:0}.multiselect[data-v-3d66c94] .multiselect__content-wrapper li{position:relative;display:flex;align-items:center;background-color:rgba(0,0,0,0)}.multiselect[data-v-3d66c94] .multiselect__content-wrapper li,.multiselect[data-v-3d66c94] .multiselect__content-wrapper li span{cursor:pointer}.multiselect[data-v-3d66c94] .multiselect__content-wrapper li>span{padding:8px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin:0;height:auto;min-height:1em;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;display:inline-flex;align-items:center;background-color:rgba(0,0,0,0);color:var(--color-text-lighter);width:100%}.multiselect[data-v-3d66c94] .multiselect__content-wrapper li>span::before{content:" ";background-repeat:no-repeat;background-position:center;min-width:16px;min-height:16px;display:block;opacity:.5;margin-right:5px;visibility:hidden}.multiselect[data-v-3d66c94] .multiselect__content-wrapper li>span.multiselect__option--disabled{background-color:var(--color-background-dark);opacity:.5}.multiselect[data-v-3d66c94] .multiselect__content-wrapper li>span.multiselect__option--highlight{color:var(--color-main-text);background-color:var(--color-background-dark)}.multiselect[data-v-3d66c94] .multiselect__content-wrapper li>span:not(.multiselect__option--disabled):hover::before{opacity:.3}.multiselect[data-v-3d66c94] .multiselect__content-wrapper li>span.multiselect__option--selected::before,.multiselect[data-v-3d66c94] .multiselect__content-wrapper li>span:not(.multiselect__option--disabled):hover::before{visibility:visible}.multiselect[data-v-3d66c94].multiselect--above .multiselect__content-wrapper{bottom:100%;margin-bottom:-1px}.multiselect[data-v-3d66c94].multiselect--multiple .multiselect__tags{flex-wrap:wrap}.multiselect[data-v-3d66c94].multiselect--multiple .multiselect__content-wrapper li>span::before{background-image:var(--icon-checkmark-dark)}.multiselect[data-v-3d66c94].multiselect--multiple .multiselect__content-wrapper li>span[data-select=create]::before{background-image:var(--icon-add-dark);visibility:visible}.multiselect[data-v-3d66c94].multiselect--single .multiselect__content-wrapper li>span::before{display:none}.multiselect[data-v-3d66c94]:hover .multiselect__placeholder,.multiselect[data-v-3d66c94] input.multiselect__input .multiselect__placeholder{color:var(--color-main-text)}', "", { version: 3, sources: ["webpack://./src/assets/material-icons.css", "webpack://./src/components/NcMultiselect/index.scss", "webpack://./src/assets/variables.scss"], names: [], mappings: "AAGA,sBACC,YAAA,CACA,iBAAA,CACA,mBAAA,CACA,kBAAA,CACA,sBAAA,CCJD,6BACC,QAAA,CACA,oBAAA,CACA,oBAAA,CAEA,eAAA,CACA,iBAAA,CAGA,4EACC,UAAA,CACA,oBAAA,CAKA,6FACC,2DAAA,CAKF,2HAEC,wDAAA,CAID,2CACC,iBAAA,CACA,SAAA,CACA,OAAA,CACA,UAAA,CACA,WAAA,CACA,uCAAA,CACA,SAAA,CAID,gDAGC,YAAA,CACA,gBAAA,CACA,eAAA,CACA,yCAAA,CACA,cAAA,CACA,iBAAA,CACA,wCAAA,CACA,eAAA,CACA,WAAA,CACA,2BAAA,CACA,6CAAA,CACA,qBAAA,CAEA,4GACC,iCAAA,CAID,wEACC,kBAAA,CACA,mBAAA,CACA,eAAA,CACA,cAAA,CACA,iBAAA,CACA,OAzBe,CA0Bf,QAAA,CACA,gBAAA,CAGA,uGACC,oBAAA,CACA,wBAAA,CAIA,sIACC,YAAA,CAIF,0FACC,gBAAA,CACA,eAAA,CACA,qBAAA,CACA,4BAAA,CACA,yCAAA,CACA,mBAAA,CACA,kBAAA,CACA,kCAAA,CAGA,WAAA,CACA,qBAAA,CACA,0BAAA,CACA,QAAA,CAGA,qGACC,aAAA,CAID,+FACC,kBAAA,CACA,sBAAA,CACA,eAAA,CAOH,+IAEC,SAAA,CACA,6CAAA,CACA,gBAAA,CACA,+BAAA,CAEA,YAAA,CACA,kBAAA,CACA,kCAAA,CAGA,kSACC,cAAA,CAIF,yIAEC,gBAAA,CACA,+BAAA,CACA,mBAAA,CACA,kBAAA,CACA,UClGc,CDmGd,gBAjGe,CAmGf,SAAA,CAGD,yEACC,qBAAA,CACA,sBAAA,CACA,QAAA,CACA,SAAA,CACA,WAAA,CAGA,cAAA,CAEA,YAAA,CACA,WAAA,CACA,eAAA,CACA,oBAAA,CACA,kCAAA,CAQD,0EACC,oBAAA,CACA,sBAAA,CAEA,2DAAA,CACA,wBAAA,CAID,qEACC,YAAA,CAKF,2DACC,iBAAA,CACA,UAAA,CACA,eAAA,CACA,yCAAA,CACA,uCAAA,CACA,UAAA,CACA,gBAAA,CACA,eAAA,CACA,2DAAA,CACA,iFACC,UAAA,CACA,SAAA,CAED,8DACC,iBAAA,CACA,YAAA,CACA,kBAAA,CACA,8BAAA,CACA,iIAEC,cAAA,CAED,mEACC,WAAA,CACA,kBAAA,CACA,eAAA,CACA,sBAAA,CACA,QAAA,CACA,WAAA,CACA,cAAA,CACA,0BAAA,CACA,wBAAA,CACA,qBAAA,CACA,oBAAA,CACA,gBAAA,CACA,mBAAA,CACA,kBAAA,CACA,8BAAA,CACA,+BAAA,CACA,UAAA,CAEA,2EACC,WAAA,CACA,2BAAA,CACA,0BAAA,CACA,cAAA,CACA,eAAA,CACA,aAAA,CACA,UC/Lc,CDgMd,gBAAA,CACA,iBAAA,CAED,iGACC,6CAAA,CACA,UCrMc,CDuMf,kGACC,4BAAA,CACA,6CAAA,CAED,qHACC,UAAA,CAIA,8NACC,kBAAA,CAOL,8EACC,WAAA,CACA,kBAAA,CAMA,sEACC,cAAA,CAIA,iGACC,2CAAA,CAMA,qHACC,qCAAA,CACA,kBAAA,CAOJ,+FACC,YAAA,CAMA,6IACC,4BAAA", sourcesContent: [`/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon {
	display: flex;
	align-self: center;
	justify-self: center;
	align-items: center;
	justify-content: center;
}
`, `@use 'sass:math'; $scope_version:"3d66c94"; @import 'variables'; @import 'material-icons';
// scoping is not working inside the Multiselect.vue component
// as the nested properties are not inside it
// Therefore we need to use an external scoping
.multiselect[data-v-#{$scope_version}] {
	margin: 0;
	padding: 0 !important;
	display: inline-block;
	/* override this rule with your width styling if you need */
	min-width: 260px;
	position: relative;

	/* Force single multiselect value to be shown when not active */
	&:not(.multiselect--active) .multiselect__single {
		width: 100%;
		z-index: 2 !important;
	}

	// Remove radius on top opening
	&.multiselect--active.multiselect--above {
		input.multiselect__input {
			border-radius: 0 0 var(--border-radius) var(--border-radius);
		}
	}

	// disabled state background
	&.multiselect--disabled,
	&.multiselect--disabled .multiselect__single {
		background-color: var(--color-background-dark) !important;
	}

	// loading state
	.loading-icon {
		position: absolute;
		right: 1px;
		top: 1px;
		width: 48px;
		height: 35px;
		background: var(--color-main-background);
		z-index: 3;
	}

	// multiple selected options display
	.multiselect__tags {
		/* space between tags and limit tag */
		$space-between: 5px;
		display: flex;
		flex-wrap: nowrap;
		overflow: hidden;
		border: 2px solid var(--color-border-dark);
		cursor: pointer;
		position: relative;
		border-radius: var(--border-radius-large);
		min-height: 44px;
		height: 44px;
		padding: 8px 12px !important;
		background-color: var(--color-main-background);
		box-sizing: border-box;

		&:focus, &:hover {
			border-color: var(--color-primary);
		}

		/* tag wrapper */
		.multiselect__tags-wrap {
			align-items: center;
			display: inline-flex;
			overflow: hidden;
			max-width: 100%;
			position: relative;
			gap: $space-between;
			flex: 1 1;
			flex-wrap: nowrap;
			/* no tags or simple select? Show input directly
			input is used to display single value */
			&:empty ~ input.multiselect__input {
				opacity: $opacity_full !important;
				display: block !important;
				/* hide default empty text like .multiselect__placeholder,
				and show input instead. It looks better without a transition between
				a span and the input that have different styling */
				+ span:not(.multiselect__single) {
					display: none;
				}
			}
			/* selected tag */
			.multiselect__tag {
				line-height: 20px;
				padding: 2px 5px;
				background-image: none;
				color: var(--color-main-text);
				border: 1px solid var(--color-border-dark);
				display: inline-flex;
				align-items: center;
				border-radius: var(--border-radius);
				/* require to override the default width
				and force the tag to shring properly */
				min-width: 0;
				max-width: fit-content;
				max-width: -moz-fit-content;
				margin: 0;
				/* css hack, detect if more than two tags
				if so, flex-basis is set to half */
				&:only-child {
					flex: 0 1 auto;
				}
				/* ellipsis the groups to be sure
				we display at least two of them */
				> span {
					white-space: nowrap;
					text-overflow: ellipsis;
					overflow: hidden;
				}
			}
		}

		/* Single select default value
		or default placeholder if search disabled*/
		.multiselect__single,
		.multiselect__placeholder {
			z-index: 1; /* above input */
			background-color: var(--color-main-background);
			line-height: 18px; // 32px - 2*6px (padding) - 2*1px (border)
			color: var(--color-text-lighter); // like the input
			// Align content and make the flow smoother
			display: flex;
			align-items: center;
			font-size: var(--default-font-size);

			// Anything inside will trigger the select opening
			&, * {
				cursor: pointer;
			}
		}
		/* displayed text if tag limit reached */
		.multiselect__strong,
		.multiselect__limit {
			line-height: 20px;
			color: var(--color-text-lighter);
			display: inline-flex;
			align-items: center;
			opacity: $opacity_normal;
			margin-right: $space-between;
			/* above the input */
			z-index: 5;
		}
		/* default multiselect input for search and placeholder */
		input.multiselect__input {
			width: 100% !important;
			height: auto !important;
			margin: 0;
			opacity: 0;
			border: none;
			/* override hide to force show the placeholder */
			/* only when not active */
			cursor: pointer;
			/* override inline styling of the lib */
			display: none;
			height: 40px;
			min-height: 26px;
			padding: 0 !important;
			font-size: var(--default-font-size);
		}
	}

	// active state, force the input to be shown, we don't want
	// the placeholder or the currently selected options
	&.multiselect--active {
		/* Opened: force display the input */
		input.multiselect__input {
			opacity: $opacity_full !important;
			cursor: text !important;
			// remove border radius on bottom opening
			border-radius: var(--border-radius) var(--border-radius) 0 0;
			display: block !important;
		}

		/* multiselect__limit hidden if active */
		.multiselect__limit {
			display: none;
		}
	}

	/* results wrapper */
	.multiselect__content-wrapper {
		position: absolute;
		width: 100%;
		margin-top: -1px;
		border: 1px solid var(--color-border-dark);
		background: var(--color-main-background);
		z-index: 50;
		max-height: 250px;
		overflow-y: auto;
		border-radius: 0 0 var(--border-radius) var(--border-radius);
		.multiselect__content {
			width: 100%;
			padding: 0;
		}
		li {
			position: relative;
			display: flex;
			align-items: center;
			background-color: transparent;
			&,
			span {
				cursor: pointer;
			}
			> span {
				padding: 8px;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				margin: 0;
				height: auto;
				min-height: 1em;
				-webkit-touch-callout: none;
				-webkit-user-select: none;
				-moz-user-select: none;
				-ms-user-select: none;
				user-select: none;
				display: inline-flex;
				align-items: center;
				background-color: transparent;
				color: var(--color-text-lighter);
				width: 100%;
				/* selected checkmark icon */
				&::before {
					content: ' ';
					background-repeat: no-repeat;
					background-position: center;
					min-width: 16px;
					min-height: 16px;
					display: block;
					opacity: $opacity_disabled;
					margin-right: 5px;
					visibility: hidden;
				}
				&.multiselect__option--disabled {
					background-color: var(--color-background-dark);
					opacity: $opacity_disabled;
				}
				&.multiselect__option--highlight {
					color: var(--color-main-text);
					background-color: var(--color-background-dark);
				}
				&:not(.multiselect__option--disabled):hover::before {
					opacity: .3;
				}
				&.multiselect__option--selected,
				&:not(.multiselect__option--disabled):hover {
					&::before {
						visibility: visible;
					}
				}
			}
		}
	}
	/* ABOVE display */
	&.multiselect--above .multiselect__content-wrapper {
		bottom: 100%;
		margin-bottom: -1px;
	}

	/* Icon before option select */
	&.multiselect--multiple {
		// push the input after the tag list
		.multiselect__tags {
			flex-wrap: wrap;
		}

		.multiselect__content-wrapper li > span {
			&::before {
				background-image: var(--icon-checkmark-dark);
			}

			/* add the prop tag-placeholder="create" to add the +
			icon on top of an unknown-and-ready-to-be-created entry */
			&[data-select='create'] {
				&::before {
					background-image: var(--icon-add-dark);
					visibility: visible;
				}
			}
		}
	}

	/* No need for an icon here */
	&.multiselect--single .multiselect__content-wrapper li > span::before {
		display: none;
	}

	/* Mouse feedback */
	&:hover,
	input.multiselect__input {
		.multiselect__placeholder {
			color: var(--color-main-text);
		}
	}
}
`, `/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */

// https://uxplanet.org/7-rules-for-mobile-ui-button-design-e9cf2ea54556
// recommended is 48px
// 44px is what we choose and have very good visual-to-usability ratio
$clickable-area: 44px;

// background icon size
// also used for the scss icon font
$icon-size: 16px;

// icon padding for a $clickable-area width and a $icon-size icon
// ( 44px - 16px ) / 2
$icon-margin: math.div($clickable-area - $icon-size, 2);

// transparency background for icons
$icon-focus-bg: rgba(127, 127, 127, .25);

// popovermenu arrow width from the triangle center
$arrow-width: 9px;

// opacities
$opacity_disabled: .5;
$opacity_normal: .7;
$opacity_full: 1;

// menu round background hover feedback
// good looking on dark AND white bg
$action-background-hover: rgba(127, 127, 127, .25);

// various structure data used in the 
// \`AppNavigation\` component
$header-height: 50px;
$navigation-width: 300px;

// mobile breakpoint
$breakpoint-mobile: 1024px;

// top-bar spacing
$topbar-margin: 4px;

// navigation spacing
$app-navigation-settings-margin: 3px;
`], sourceRoot: "" }]);
      const A = d;
    }, 8384: (o, l, a) => {
      a.d(l, { Z: () => A });
      var c = a(7537), T = a.n(c), u = a(3645), d = a.n(u)()(T());
      d.push([o.id, ".material-design-icon{display:flex;align-self:center;justify-self:center;align-items:center;justify-content:center}.v-popper--theme-tooltip.v-popper__popper{position:absolute;z-index:100000;top:0;right:auto;left:auto;display:block;margin:0;padding:0;text-align:left;text-align:start;opacity:0;line-height:1.6;line-break:auto;filter:drop-shadow(0 1px 10px var(--color-box-shadow))}.v-popper--theme-tooltip.v-popper__popper[data-popper-placement^=top] .v-popper__arrow-container{bottom:-10px;border-bottom-width:0;border-top-color:var(--color-main-background)}.v-popper--theme-tooltip.v-popper__popper[data-popper-placement^=bottom] .v-popper__arrow-container{top:-10px;border-top-width:0;border-bottom-color:var(--color-main-background)}.v-popper--theme-tooltip.v-popper__popper[data-popper-placement^=right] .v-popper__arrow-container{right:100%;border-left-width:0;border-right-color:var(--color-main-background)}.v-popper--theme-tooltip.v-popper__popper[data-popper-placement^=left] .v-popper__arrow-container{left:100%;border-right-width:0;border-left-color:var(--color-main-background)}.v-popper--theme-tooltip.v-popper__popper[aria-hidden=true]{visibility:hidden;transition:opacity .15s,visibility .15s;opacity:0}.v-popper--theme-tooltip.v-popper__popper[aria-hidden=false]{visibility:visible;transition:opacity .15s;opacity:1}.v-popper--theme-tooltip .v-popper__inner{max-width:350px;padding:5px 8px;text-align:center;color:var(--color-main-text);border-radius:var(--border-radius);background-color:var(--color-main-background)}.v-popper--theme-tooltip .v-popper__arrow-container{position:absolute;z-index:1;width:0;height:0;margin:0;border-style:solid;border-color:rgba(0,0,0,0);border-width:10px}", "", { version: 3, sources: ["webpack://./src/assets/material-icons.css", "webpack://./src/directives/Tooltip/index.scss"], names: [], mappings: "AAGA,sBACC,YAAA,CACA,iBAAA,CACA,mBAAA,CACA,kBAAA,CACA,sBAAA,CCQA,0CACC,iBAAA,CACA,cAAA,CACA,KAAA,CACA,UAAA,CACA,SAAA,CACA,aAAA,CACA,QAAA,CACA,SAAA,CACA,eAAA,CACA,gBAAA,CACA,SAAA,CACA,eAAA,CAEA,eAAA,CACA,sDAAA,CAGA,iGACC,YAAA,CACA,qBAAA,CACA,6CAAA,CAID,oGACC,SAAA,CACA,kBAAA,CACA,gDAAA,CAID,mGACC,UAAA,CACA,mBAAA,CACA,+CAAA,CAID,kGACC,SAAA,CACA,oBAAA,CACA,8CAAA,CAID,4DACC,iBAAA,CACA,uCAAA,CACA,SAAA,CAED,6DACC,kBAAA,CACA,uBAAA,CACA,SAAA,CAKF,0CACC,eAAA,CACA,eAAA,CACA,iBAAA,CACA,4BAAA,CACA,kCAAA,CACA,6CAAA,CAID,oDACC,iBAAA,CACA,SAAA,CACA,OAAA,CACA,QAAA,CACA,QAAA,CACA,kBAAA,CACA,0BAAA,CACA,iBAhFY", sourcesContent: [`/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon {
	display: flex;
	align-self: center;
	justify-self: center;
	align-items: center;
	justify-content: center;
}
`, `@use 'sass:math'; $scope_version:"3d66c94"; @import 'variables'; @import 'material-icons';
/**
* @copyright Copyright (c) 2016, John Molakvoæ <skjnldsv@protonmail.com>
* @copyright Copyright (c) 2016, Robin Appelman <robin@icewind.nl>
* @copyright Copyright (c) 2016, Jan-Christoph Borchardt <hey@jancborchardt.net>
* @copyright Copyright (c) 2016, Erik Pellikka <erik@pellikka.org>
* @copyright Copyright (c) 2015, Vincent Petry <pvince81@owncloud.com>
*
* Bootstrap v3.3.5 (http://getbootstrap.com)
* Copyright 2011-2015 Twitter, Inc.
* Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
*/

$arrow-width: 10px;

.v-popper--theme-tooltip {
	&.v-popper__popper {
		position: absolute;
		z-index: 100000;
		top: 0;
		right: auto;
		left: auto;
		display: block;
		margin: 0;
		padding: 0;
		text-align: left;
		text-align: start;
		opacity: 0;
		line-height: 1.6;

		line-break: auto;
		filter: drop-shadow(0 1px 10px var(--color-box-shadow));

		// TOP
		&[data-popper-placement^='top'] .v-popper__arrow-container {
			bottom: -$arrow-width;
			border-bottom-width: 0;
			border-top-color: var(--color-main-background);
		}

		// BOTTOM
		&[data-popper-placement^='bottom'] .v-popper__arrow-container {
			top: -$arrow-width;
			border-top-width: 0;
			border-bottom-color: var(--color-main-background);
		}

		// RIGHT
		&[data-popper-placement^='right'] .v-popper__arrow-container {
			right: 100%;
			border-left-width: 0;
			border-right-color: var(--color-main-background);
		}

		// LEFT
		&[data-popper-placement^='left'] .v-popper__arrow-container {
			left: 100%;
			border-right-width: 0;
			border-left-color: var(--color-main-background);
		}

		// HIDDEN / SHOWN
		&[aria-hidden='true'] {
			visibility: hidden;
			transition: opacity .15s, visibility .15s;
			opacity: 0;
		}
		&[aria-hidden='false'] {
			visibility: visible;
			transition: opacity .15s;
			opacity: 1;
		}
	}

	// CONTENT
	.v-popper__inner {
		max-width: 350px;
		padding: 5px 8px;
		text-align: center;
		color: var(--color-main-text);
		border-radius: var(--border-radius);
		background-color: var(--color-main-background);
	}

	// ARROW
	.v-popper__arrow-container {
		position: absolute;
		z-index: 1;
		width: 0;
		height: 0;
		margin: 0;
		border-style: solid;
		border-color: transparent;
		border-width: $arrow-width;
	}
}
`], sourceRoot: "" }]);
      const A = d;
    }, 1435: (o, l, a) => {
      a.d(l, { Z: () => D });
      var c = a(7537), T = a.n(c), u = a(3645), d = a.n(u), A = a(1667), f = a.n(A), h = new URL(a(3423), a.b), S = new URL(a(2605), a.b), p = new URL(a(7127), a.b), m = d()(T()), g = f()(h), N = f()(S), R = f()(p);
      m.push([o.id, ".material-design-icon[data-v-69f6cb9a]{display:flex;align-self:center;justify-self:center;align-items:center;justify-content:center}.avatardiv[data-v-69f6cb9a]{position:relative;display:inline-block;width:var(--size);height:var(--size)}.avatardiv--unknown[data-v-69f6cb9a]{position:relative;background-color:var(--color-main-background)}.avatardiv[data-v-69f6cb9a]:not(.avatardiv--unknown){background-color:var(--color-main-background) !important;box-shadow:0 0 5px rgba(0,0,0,.05) inset}.avatardiv--with-menu[data-v-69f6cb9a]{cursor:pointer}.avatardiv--with-menu[data-v-69f6cb9a] .v-popper{position:absolute;top:0;left:0}.avatardiv--with-menu .icon-more[data-v-69f6cb9a]{cursor:pointer;opacity:0}.avatardiv--with-menu:focus .icon-more[data-v-69f6cb9a],.avatardiv--with-menu:hover .icon-more[data-v-69f6cb9a]{opacity:1}.avatardiv--with-menu:focus img[data-v-69f6cb9a],.avatardiv--with-menu:hover img[data-v-69f6cb9a]{opacity:.3}.avatardiv--with-menu .icon-more[data-v-69f6cb9a],.avatardiv--with-menu img[data-v-69f6cb9a]{transition:opacity var(--animation-quick)}.avatardiv .avatardiv__initials-wrapper[data-v-69f6cb9a]{height:var(--size);width:var(--size);background-color:var(--color-main-background);border-radius:50%}.avatardiv .avatardiv__initials-wrapper .unknown[data-v-69f6cb9a]{position:absolute;top:0;left:0;display:block;width:100%;text-align:center;font-weight:normal}.avatardiv img[data-v-69f6cb9a]{width:100%;height:100%;object-fit:cover}.avatardiv .material-design-icon[data-v-69f6cb9a]{width:var(--size);height:var(--size)}.avatardiv .avatardiv__user-status[data-v-69f6cb9a]{position:absolute;right:-4px;bottom:-4px;max-height:18px;max-width:18px;height:40%;width:40%;line-height:15px;font-size:var(--default-font-size);border:2px solid var(--color-main-background);background-color:var(--color-main-background);background-repeat:no-repeat;background-size:16px;background-position:center;border-radius:50%}.acli:hover .avatardiv .avatardiv__user-status[data-v-69f6cb9a]{border-color:var(--color-background-hover);background-color:var(--color-background-hover)}.acli.active .avatardiv .avatardiv__user-status[data-v-69f6cb9a]{border-color:var(--color-primary-light);background-color:var(--color-primary-light)}.avatardiv .avatardiv__user-status--online[data-v-69f6cb9a]{background-image:url(" + g + ")}.avatardiv .avatardiv__user-status--dnd[data-v-69f6cb9a]{background-image:url(" + N + ");background-color:#fff}.avatardiv .avatardiv__user-status--away[data-v-69f6cb9a]{background-image:url(" + R + ")}.avatardiv .avatardiv__user-status--icon[data-v-69f6cb9a]{border:none;background-color:rgba(0,0,0,0)}.avatardiv .popovermenu-wrapper[data-v-69f6cb9a]{position:relative;display:inline-block}.avatar-class-icon[data-v-69f6cb9a]{border-radius:50%;background-color:var(--color-background-darker);height:100%}", "", { version: 3, sources: ["webpack://./src/assets/material-icons.css", "webpack://./src/components/NcAvatar/NcAvatar.vue"], names: [], mappings: "AAGA,uCACC,YAAA,CACA,iBAAA,CACA,mBAAA,CACA,kBAAA,CACA,sBAAA,CCND,4BACC,iBAAA,CACA,oBAAA,CACA,iBAAA,CACA,kBAAA,CAEA,qCACC,iBAAA,CACA,6CAAA,CAGD,qDAEC,wDAAA,CACA,wCAAA,CAGD,uCACC,cAAA,CACA,iDACC,iBAAA,CACA,KAAA,CACA,MAAA,CAED,kDACC,cAAA,CACA,SAAA,CAIA,gHACC,SAAA,CAED,kGACC,UAAA,CAGF,6FAEC,yCAAA,CAIF,yDACC,kBAAA,CACA,iBAAA,CACA,6CAAA,CACA,iBAAA,CAEA,kEACC,iBAAA,CACA,KAAA,CACA,MAAA,CACA,aAAA,CACA,UAAA,CACA,iBAAA,CACA,kBAAA,CAIF,gCAEC,UAAA,CACA,WAAA,CAEA,gBAAA,CAGD,kDACC,iBAAA,CACA,kBAAA,CAGD,oDACC,iBAAA,CACA,UAAA,CACA,WAAA,CACA,eAAA,CACA,cAAA,CACA,UAAA,CACA,SAAA,CACA,gBAAA,CACA,kCAAA,CACA,6CAAA,CACA,6CAAA,CACA,2BAAA,CACA,oBAAA,CACA,0BAAA,CACA,iBAAA,CAEA,gEACC,0CAAA,CACA,8CAAA,CAED,iEACC,uCAAA,CACA,2CAAA,CAGD,4DACC,wDAAA,CAED,yDACC,wDAAA,CACA,qBAAA,CAED,0DACC,wDAAA,CAED,0DACC,WAAA,CACA,8BAAA,CAIF,iDACC,iBAAA,CACA,oBAAA,CAIF,oCACC,iBAAA,CACA,+CAAA,CACA,WAAA", sourcesContent: [`/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon {
	display: flex;
	align-self: center;
	justify-self: center;
	align-items: center;
	justify-content: center;
}
`, `@use 'sass:math'; $scope_version:"3d66c94"; @import 'variables'; @import 'material-icons';

.avatardiv {
	position: relative;
	display: inline-block;
	width: var(--size);
	height: var(--size);

	&--unknown {
		position: relative;
		background-color: var(--color-main-background);
	}

	&:not(&--unknown) {
		// White/black background for avatars with transparency
		background-color: var(--color-main-background) !important;
		box-shadow: 0 0 5px rgba(0, 0, 0, 0.05) inset;
	}

	&--with-menu {
		cursor: pointer;
		:deep(.v-popper) {
			position: absolute;
			top: 0;
			left: 0;
		}
		.icon-more {
			cursor: pointer;
			opacity: 0;
		}
		&:focus,
		&:hover {
			.icon-more {
				opacity: 1;
			}
			img {
				opacity: 0.3;
			}
		}
		.icon-more,
		img {
			transition: opacity var(--animation-quick);
		}
	}

	.avatardiv__initials-wrapper {
		height: var(--size);
		width: var(--size);
		background-color: var(--color-main-background);
		border-radius: 50%;

		.unknown {
			position: absolute;
			top: 0;
			left: 0;
			display: block;
			width: 100%;
			text-align: center;
			font-weight: normal;
		}
	}

	img {
		// Cover entire area
		width: 100%;
		height: 100%;
		// Keep ratio
		object-fit: cover;
	}

	.material-design-icon {
		width: var(--size);
		height: var(--size);
	}

	.avatardiv__user-status {
		position: absolute;
		right: -4px;
		bottom: -4px;
		max-height: 18px;
		max-width: 18px;
		height: 40%;
		width: 40%;
		line-height: 15px;
		font-size: var(--default-font-size);
		border: 2px solid var(--color-main-background);
		background-color: var(--color-main-background);
		background-repeat: no-repeat;
		background-size: 16px;
		background-position: center;
		border-radius: 50%;

		.acli:hover & {
			border-color: var(--color-background-hover);
			background-color: var(--color-background-hover);
		}
		.acli.active & {
			border-color: var(--color-primary-light);
			background-color: var(--color-primary-light);
		}

		&--online{
			background-image: url('../../assets/status-icons/user-status-online.svg');
		}
		&--dnd{
			background-image: url('../../assets/status-icons/user-status-dnd.svg');
			background-color: #ffffff;
		}
		&--away{
			background-image: url('../../assets/status-icons/user-status-away.svg');
		}
		&--icon {
			border: none;
			background-color: transparent;
		}
	}

	.popovermenu-wrapper {
		position: relative;
		display: inline-block;
	}
}

.avatar-class-icon {
	border-radius: 50%;
	background-color: var(--color-background-darker);
	height: 100%;
}

`], sourceRoot: "" }]);
      const D = m;
    }, 5308: (o, l, a) => {
      a.d(l, { Z: () => A });
      var c = a(7537), T = a.n(c), u = a(3645), d = a.n(u)()(T());
      d.push([o.id, ".material-design-icon[data-v-0dd60e55]{display:flex;align-self:center;justify-self:center;align-items:center;justify-content:center}.datetime-picker-inline-icon[data-v-0dd60e55]{opacity:.3;border:none;background-color:rgba(0,0,0,0);border-radius:0;padding:6px !important}.datetime-picker-inline-icon--highlighted[data-v-0dd60e55]{opacity:.7}.datetime-picker-inline-icon[data-v-0dd60e55]:focus,.datetime-picker-inline-icon[data-v-0dd60e55]:hover{opacity:1}", "", { version: 3, sources: ["webpack://./src/assets/material-icons.css", "webpack://./src/components/NcDatetimePicker/NcDatetimePicker.vue"], names: [], mappings: "AAGA,uCACC,YAAA,CACA,iBAAA,CACA,mBAAA,CACA,kBAAA,CACA,sBAAA,CCND,8CACC,UAAA,CACA,WAAA,CACA,8BAAA,CACA,eAAA,CACA,sBAAA,CAEA,2DACC,UAAA,CAGD,wGAEC,SAAA", sourcesContent: [`/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon {
	display: flex;
	align-self: center;
	justify-self: center;
	align-items: center;
	justify-content: center;
}
`, `@use 'sass:math'; $scope_version:"3d66c94"; @import 'variables'; @import 'material-icons';

.datetime-picker-inline-icon {
	opacity: .3;
	border: none;
	background-color: transparent;
	border-radius: 0;
	padding: 6px !important;

	&--highlighted {
		opacity: .7;
	}

	&:focus,
	&:hover {
		opacity: 1;
	}
}
`], sourceRoot: "" }]);
      const A = d;
    }, 436: (o, l, a) => {
      a.d(l, { Z: () => A });
      var c = a(7537), T = a.n(c), u = a(3645), d = a.n(u)()(T());
      d.push([o.id, ".material-design-icon[data-v-3daafbe0]{display:flex;align-self:center;justify-self:center;align-items:center;justify-content:center}.name-parts[data-v-3daafbe0]{display:flex;max-width:100%;cursor:inherit}.name-parts__first[data-v-3daafbe0]{overflow:hidden;text-overflow:ellipsis}.name-parts__first[data-v-3daafbe0],.name-parts__last[data-v-3daafbe0]{white-space:pre;cursor:inherit}.name-parts__first strong[data-v-3daafbe0],.name-parts__last strong[data-v-3daafbe0]{font-weight:bold}", "", { version: 3, sources: ["webpack://./src/assets/material-icons.css", "webpack://./src/components/NcEllipsisedOption/NcEllipsisedOption.vue"], names: [], mappings: "AAGA,uCACC,YAAA,CACA,iBAAA,CACA,mBAAA,CACA,kBAAA,CACA,sBAAA,CCND,6BACC,YAAA,CACA,cAAA,CACA,cAAA,CACA,oCACC,eAAA,CACA,sBAAA,CAED,uEAGC,eAAA,CACA,cAAA,CACA,qFACC,gBAAA", sourcesContent: [`/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon {
	display: flex;
	align-self: center;
	justify-self: center;
	align-items: center;
	justify-content: center;
}
`, `@use 'sass:math'; $scope_version:"3d66c94"; @import 'variables'; @import 'material-icons';

.name-parts {
	display: flex;
	max-width: 100%;
	cursor: inherit;
	&__first {
		overflow: hidden;
		text-overflow: ellipsis;
	}
	&__first,
	&__last {
		// prevent whitespace from being trimmed
		white-space: pre;
		cursor: inherit;
		strong {
			font-weight: bold;
		}
	}
}
`], sourceRoot: "" }]);
      const A = d;
    }, 4180: (o, l, a) => {
      a.d(l, { Z: () => A });
      var c = a(7537), T = a.n(c), u = a(3645), d = a.n(u)()(T());
      d.push([o.id, ".material-design-icon[data-v-1b2ab2dd]{display:flex;align-self:center;justify-self:center;align-items:center;justify-content:center}.icon-vue[data-v-1b2ab2dd]{display:flex;justify-content:center;align-items:center;width:44px;height:44px;opacity:1}.icon-vue[data-v-1b2ab2dd] svg{fill:currentColor;max-width:20px;max-height:20px}", "", { version: 3, sources: ["webpack://./src/assets/material-icons.css", "webpack://./src/components/NcIconSvgWrapper/NcIconSvgWrapper.vue"], names: [], mappings: "AAGA,uCACC,YAAA,CACA,iBAAA,CACA,mBAAA,CACA,kBAAA,CACA,sBAAA,CCND,2BACC,YAAA,CACA,sBAAA,CACA,kBAAA,CACA,UAAA,CACA,WAAA,CACA,SAAA,CAEA,+BACC,iBAAA,CACA,cAAA,CACA,eAAA", sourcesContent: [`/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon {
	display: flex;
	align-self: center;
	justify-self: center;
	align-items: center;
	justify-content: center;
}
`, `@use 'sass:math'; $scope_version:"3d66c94"; @import 'variables'; @import 'material-icons';

.icon-vue {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 44px;
	height: 44px;
	opacity: 1;

	&:deep(svg) {
		fill: currentColor;
		max-width: 20px;
		max-height: 20px;
	}
}
`], sourceRoot: "" }]);
      const A = d;
    }, 808: (o, l, a) => {
      a.d(l, { Z: () => A });
      var c = a(7537), T = a.n(c), u = a(3645), d = a.n(u)()(T());
      d.push([o.id, ".material-design-icon[data-v-4f3daf70]{display:flex;align-self:center;justify-self:center;align-items:center;justify-content:center}.option[data-v-4f3daf70]{display:flex;align-items:center;width:100%;height:var(--height);cursor:inherit}.option__avatar[data-v-4f3daf70]{margin-right:var(--margin)}.option__details[data-v-4f3daf70]{display:flex;flex:1 1;flex-direction:column;justify-content:center;min-width:0}.option__lineone[data-v-4f3daf70]{color:var(--color-main-text)}.option__linetwo[data-v-4f3daf70]{color:var(--color-text-maxcontrast)}.option__lineone[data-v-4f3daf70],.option__linetwo[data-v-4f3daf70]{overflow:hidden;white-space:nowrap;text-overflow:ellipsis;line-height:1.1em}.option__lineone strong[data-v-4f3daf70],.option__linetwo strong[data-v-4f3daf70]{font-weight:bold}.option__icon[data-v-4f3daf70]{width:44px;height:44px;color:var(--color-text-maxcontrast)}.option__icon.icon[data-v-4f3daf70]{flex:0 0 44px;opacity:.7;background-position:center;background-size:16px}.option__details[data-v-4f3daf70],.option__lineone[data-v-4f3daf70],.option__linetwo[data-v-4f3daf70],.option__icon[data-v-4f3daf70]{cursor:inherit}", "", { version: 3, sources: ["webpack://./src/assets/material-icons.css", "webpack://./src/components/NcListItemIcon/NcListItemIcon.vue", "webpack://./src/assets/variables.scss"], names: [], mappings: "AAGA,uCACC,YAAA,CACA,iBAAA,CACA,mBAAA,CACA,kBAAA,CACA,sBAAA,CCND,yBACC,YAAA,CACA,kBAAA,CACA,UAAA,CACA,oBAAA,CACA,cAAA,CAEA,iCACC,0BAAA,CAGD,kCACC,YAAA,CACA,QAAA,CACA,qBAAA,CACA,sBAAA,CACA,WAAA,CAGD,kCACC,4BAAA,CAGD,kCACC,mCAAA,CAGD,oEAEC,eAAA,CACA,kBAAA,CACA,sBAAA,CACA,iBAAA,CACA,kFACC,gBAAA,CAIF,+BACC,UChBe,CDiBf,WCjBe,CDkBf,mCAAA,CACA,oCACC,aAAA,CACA,UCHc,CDId,0BAAA,CACA,oBAAA,CAIF,qIAIC,cAAA", sourcesContent: [`/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon {
	display: flex;
	align-self: center;
	justify-self: center;
	align-items: center;
	justify-content: center;
}
`, `@use 'sass:math'; $scope_version:"3d66c94"; @import 'variables'; @import 'material-icons';

.option {
	display: flex;
	align-items: center;
	width: 100%;
	height: var(--height);
	cursor: inherit;

	&__avatar {
		margin-right: var(--margin);
	}

	&__details {
		display: flex;
		flex: 1 1;
		flex-direction: column;
		justify-content: center;
		min-width: 0;
	}

	&__lineone {
		color: var(--color-main-text);
	}

	&__linetwo {
		color: var(--color-text-maxcontrast);
	}

	&__lineone,
	&__linetwo {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		line-height: 1.1em;
		strong {
			font-weight: bold;
		}
	}

	&__icon {
		width: $clickable-area;
		height: $clickable-area;
		color: var(--color-text-maxcontrast);
		&.icon {
			flex: 0 0 $clickable-area;
			opacity: $opacity_normal;
			background-position: center;
			background-size: 16px;
		}
	}

	&__details,
	&__lineone,
	&__linetwo,
	&__icon {
		cursor: inherit;
	}
}
`, `/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */

// https://uxplanet.org/7-rules-for-mobile-ui-button-design-e9cf2ea54556
// recommended is 48px
// 44px is what we choose and have very good visual-to-usability ratio
$clickable-area: 44px;

// background icon size
// also used for the scss icon font
$icon-size: 16px;

// icon padding for a $clickable-area width and a $icon-size icon
// ( 44px - 16px ) / 2
$icon-margin: math.div($clickable-area - $icon-size, 2);

// transparency background for icons
$icon-focus-bg: rgba(127, 127, 127, .25);

// popovermenu arrow width from the triangle center
$arrow-width: 9px;

// opacities
$opacity_disabled: .5;
$opacity_normal: .7;
$opacity_full: 1;

// menu round background hover feedback
// good looking on dark AND white bg
$action-background-hover: rgba(127, 127, 127, .25);

// various structure data used in the 
// \`AppNavigation\` component
$header-height: 50px;
$navigation-width: 300px;

// mobile breakpoint
$breakpoint-mobile: 1024px;

// top-bar spacing
$topbar-margin: 4px;

// navigation spacing
$app-navigation-settings-margin: 3px;
`], sourceRoot: "" }]);
      const A = d;
    }, 5030: (o, l, a) => {
      a.d(l, { Z: () => A });
      var c = a(7537), T = a.n(c), u = a(3645), d = a.n(u)()(T());
      d.push([o.id, ".material-design-icon[data-v-c4a9cada]{display:flex;align-self:center;justify-self:center;align-items:center;justify-content:center}.loading-icon svg[data-v-c4a9cada]{animation:rotate var(--animation-duration, 0.8s) linear infinite}", "", { version: 3, sources: ["webpack://./src/assets/material-icons.css", "webpack://./src/components/NcLoadingIcon/NcLoadingIcon.vue"], names: [], mappings: "AAGA,uCACC,YAAA,CACA,iBAAA,CACA,mBAAA,CACA,kBAAA,CACA,sBAAA,CCND,mCACC,gEAAA", sourcesContent: [`/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon {
	display: flex;
	align-self: center;
	justify-self: center;
	align-items: center;
	justify-content: center;
}
`, `@use 'sass:math'; $scope_version:"3d66c94"; @import 'variables'; @import 'material-icons';

.loading-icon svg{
	animation: rotate var(--animation-duration, 0.8s) linear infinite;
}
`], sourceRoot: "" }]);
      const A = d;
    }, 978: (o, l, a) => {
      a.d(l, { Z: () => A });
      var c = a(7537), T = a.n(c), u = a(3645), d = a.n(u)()(T());
      d.push([o.id, ".material-design-icon{display:flex;align-self:center;justify-self:center;align-items:center;justify-content:center}.resize-observer{position:absolute;top:0;left:0;z-index:-1;width:100%;height:100%;border:none;background-color:rgba(0,0,0,0);pointer-events:none;display:block;overflow:hidden;opacity:0}.resize-observer object{display:block;position:absolute;top:0;left:0;height:100%;width:100%;overflow:hidden;pointer-events:none;z-index:-1}.v-popper--theme-dropdown.v-popper__popper{z-index:100000;top:0;left:0;display:block !important;filter:drop-shadow(0 1px 10px var(--color-box-shadow))}.v-popper--theme-dropdown.v-popper__popper .v-popper__inner{padding:0;color:var(--color-main-text);border-radius:var(--border-radius);overflow:hidden;background:var(--color-main-background)}.v-popper--theme-dropdown.v-popper__popper .v-popper__arrow-container{position:absolute;z-index:1;width:0;height:0;border-style:solid;border-color:rgba(0,0,0,0);border-width:10px}.v-popper--theme-dropdown.v-popper__popper[data-popper-placement^=top] .v-popper__arrow-container{bottom:-10px;border-bottom-width:0;border-top-color:var(--color-main-background)}.v-popper--theme-dropdown.v-popper__popper[data-popper-placement^=bottom] .v-popper__arrow-container{top:-10px;border-top-width:0;border-bottom-color:var(--color-main-background)}.v-popper--theme-dropdown.v-popper__popper[data-popper-placement^=right] .v-popper__arrow-container{left:-10px;border-left-width:0;border-right-color:var(--color-main-background)}.v-popper--theme-dropdown.v-popper__popper[data-popper-placement^=left] .v-popper__arrow-container{right:-10px;border-right-width:0;border-left-color:var(--color-main-background)}.v-popper--theme-dropdown.v-popper__popper[aria-hidden=true]{visibility:hidden;transition:opacity var(--animation-quick),visibility var(--animation-quick);opacity:0}.v-popper--theme-dropdown.v-popper__popper[aria-hidden=false]{visibility:visible;transition:opacity var(--animation-quick);opacity:1}", "", { version: 3, sources: ["webpack://./src/assets/material-icons.css", "webpack://./src/components/NcPopover/NcPopover.vue"], names: [], mappings: "AAGA,sBACC,YAAA,CACA,iBAAA,CACA,mBAAA,CACA,kBAAA,CACA,sBAAA,CCLD,iBACC,iBAAA,CACA,KAAA,CACA,MAAA,CACA,UAAA,CACA,UAAA,CACA,WAAA,CACA,WAAA,CACA,8BAAA,CACA,mBAAA,CACA,aAAA,CACA,eAAA,CACA,SAAA,CAGD,wBACC,aAAA,CACA,iBAAA,CACA,KAAA,CACA,MAAA,CACA,WAAA,CACA,UAAA,CACA,eAAA,CACA,mBAAA,CACA,UAAA,CAMA,2CACC,cAAA,CACA,KAAA,CACA,MAAA,CACA,wBAAA,CAEA,sDAAA,CAEA,4DACC,SAAA,CACA,4BAAA,CACA,kCAAA,CACA,eAAA,CACA,uCAAA,CAGD,sEACC,iBAAA,CACA,SAAA,CACA,OAAA,CACA,QAAA,CACA,kBAAA,CACA,0BAAA,CACA,iBA1BW,CA6BZ,kGACC,YAAA,CACA,qBAAA,CACA,6CAAA,CAGD,qGACC,SAAA,CACA,kBAAA,CACA,gDAAA,CAGD,oGACC,UAAA,CACA,mBAAA,CACA,+CAAA,CAGD,mGACC,WAAA,CACA,oBAAA,CACA,8CAAA,CAGD,6DACC,iBAAA,CACA,2EAAA,CACA,SAAA,CAGD,8DACC,kBAAA,CACA,yCAAA,CACA,SAAA", sourcesContent: [`/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon {
	display: flex;
	align-self: center;
	justify-self: center;
	align-items: center;
	justify-content: center;
}
`, `@use 'sass:math'; $scope_version:"3d66c94"; @import 'variables'; @import 'material-icons';


.resize-observer {
	position:absolute;
	top:0;
	left:0;
	z-index:-1;
	width:100%;
	height:100%;
	border:none;
	background-color:transparent;
	pointer-events:none;
	display:block;
	overflow:hidden;
	opacity:0
}

.resize-observer object {
	display:block;
	position:absolute;
	top:0;
	left:0;
	height:100%;
	width:100%;
	overflow:hidden;
	pointer-events:none;
	z-index:-1
}

$arrow-width: 10px;

.v-popper--theme-dropdown {
	&.v-popper__popper {
		z-index: 100000;
		top: 0;
		left: 0;
		display: block !important;

		filter: drop-shadow(0 1px 10px var(--color-box-shadow));

		.v-popper__inner {
			padding: 0;
			color: var(--color-main-text);
			border-radius: var(--border-radius);
			overflow: hidden;
			background: var(--color-main-background);
		}

		.v-popper__arrow-container {
			position: absolute;
			z-index: 1;
			width: 0;
			height: 0;
			border-style: solid;
			border-color: transparent;
			border-width: $arrow-width;
		}

		&[data-popper-placement^='top'] .v-popper__arrow-container {
			bottom: -$arrow-width;
			border-bottom-width: 0;
			border-top-color: var(--color-main-background);
		}

		&[data-popper-placement^='bottom'] .v-popper__arrow-container {
			top: -$arrow-width;
			border-top-width: 0;
			border-bottom-color: var(--color-main-background);
		}

		&[data-popper-placement^='right'] .v-popper__arrow-container {
			left: -$arrow-width;
			border-left-width: 0;
			border-right-color: var(--color-main-background);
		}

		&[data-popper-placement^='left'] .v-popper__arrow-container {
			right: -$arrow-width;
			border-right-width: 0;
			border-left-color: var(--color-main-background);
		}

		&[aria-hidden='true'] {
			visibility: hidden;
			transition: opacity var(--animation-quick), visibility var(--animation-quick);
			opacity: 0;
		}

		&[aria-hidden='false'] {
			visibility: visible;
			transition: opacity var(--animation-quick);
			opacity: 1;
		}
	}
}

`], sourceRoot: "" }]);
      const A = d;
    }, 2: (o, l, a) => {
      a.d(l, { Z: () => A });
      var c = a(7537), T = a.n(c), u = a(3645), d = a.n(u)()(T());
      d.push([o.id, ".material-design-icon[data-v-31ffd2d4]{display:flex;align-self:center;justify-self:center;align-items:center;justify-content:center}ul[data-v-31ffd2d4]{display:flex;flex-direction:column;gap:4px}", "", { version: 3, sources: ["webpack://./src/assets/material-icons.css", "webpack://./src/components/NcPopoverMenu/NcPopoverMenu.vue"], names: [], mappings: "AAGA,uCACC,YAAA,CACA,iBAAA,CACA,mBAAA,CACA,kBAAA,CACA,sBAAA,CCND,oBACC,YAAA,CACA,qBAAA,CACA,OAAA", sourcesContent: [`/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon {
	display: flex;
	align-self: center;
	justify-self: center;
	align-items: center;
	justify-content: center;
}
`, `@use 'sass:math'; $scope_version:"3d66c94"; @import 'variables'; @import 'material-icons';

ul {
	display: flex;
	flex-direction: column;
	gap: 4px;
}
`], sourceRoot: "" }]);
      const A = d;
    }, 5772: (o, l, a) => {
      a.d(l, { Z: () => A });
      var c = a(7537), T = a.n(c), u = a(3645), d = a.n(u)()(T());
      d.push([o.id, '.material-design-icon[data-v-0ce1cbf1]{display:flex;align-self:center;justify-self:center;align-items:center;justify-content:center}li[data-v-0ce1cbf1]{display:flex;flex:0 0 auto}li.hidden[data-v-0ce1cbf1]{display:none}li>button[data-v-0ce1cbf1],li>a[data-v-0ce1cbf1],li>.menuitem[data-v-0ce1cbf1]{cursor:pointer;line-height:44px;border:0;background-color:rgba(0,0,0,0);display:flex;align-items:flex-start;height:auto;margin:0;padding:0;font-weight:normal;box-shadow:none;width:100%;color:var(--color-main-text);white-space:nowrap;opacity:.7}li>button span[class^=icon-][data-v-0ce1cbf1],li>button span[class*=" icon-"][data-v-0ce1cbf1],li>button[class^=icon-][data-v-0ce1cbf1],li>button[class*=" icon-"][data-v-0ce1cbf1],li>a span[class^=icon-][data-v-0ce1cbf1],li>a span[class*=" icon-"][data-v-0ce1cbf1],li>a[class^=icon-][data-v-0ce1cbf1],li>a[class*=" icon-"][data-v-0ce1cbf1],li>.menuitem span[class^=icon-][data-v-0ce1cbf1],li>.menuitem span[class*=" icon-"][data-v-0ce1cbf1],li>.menuitem[class^=icon-][data-v-0ce1cbf1],li>.menuitem[class*=" icon-"][data-v-0ce1cbf1]{min-width:0;min-height:0;background-position:14px center;background-size:16px}li>button span[class^=icon-][data-v-0ce1cbf1],li>button span[class*=" icon-"][data-v-0ce1cbf1],li>a span[class^=icon-][data-v-0ce1cbf1],li>a span[class*=" icon-"][data-v-0ce1cbf1],li>.menuitem span[class^=icon-][data-v-0ce1cbf1],li>.menuitem span[class*=" icon-"][data-v-0ce1cbf1]{padding:22px 0 22px 44px}li>button:not([class^=icon-]):not([class*=icon-])>span[data-v-0ce1cbf1]:not([class^=icon-]):not([class*=icon-]):first-child,li>button:not([class^=icon-]):not([class*=icon-])>input[data-v-0ce1cbf1]:not([class^=icon-]):not([class*=icon-]):first-child,li>button:not([class^=icon-]):not([class*=icon-])>form[data-v-0ce1cbf1]:not([class^=icon-]):not([class*=icon-]):first-child,li>a:not([class^=icon-]):not([class*=icon-])>span[data-v-0ce1cbf1]:not([class^=icon-]):not([class*=icon-]):first-child,li>a:not([class^=icon-]):not([class*=icon-])>input[data-v-0ce1cbf1]:not([class^=icon-]):not([class*=icon-]):first-child,li>a:not([class^=icon-]):not([class*=icon-])>form[data-v-0ce1cbf1]:not([class^=icon-]):not([class*=icon-]):first-child,li>.menuitem:not([class^=icon-]):not([class*=icon-])>span[data-v-0ce1cbf1]:not([class^=icon-]):not([class*=icon-]):first-child,li>.menuitem:not([class^=icon-]):not([class*=icon-])>input[data-v-0ce1cbf1]:not([class^=icon-]):not([class*=icon-]):first-child,li>.menuitem:not([class^=icon-]):not([class*=icon-])>form[data-v-0ce1cbf1]:not([class^=icon-]):not([class*=icon-]):first-child{margin-left:44px}li>button[class^=icon-][data-v-0ce1cbf1],li>button[class*=" icon-"][data-v-0ce1cbf1],li>a[class^=icon-][data-v-0ce1cbf1],li>a[class*=" icon-"][data-v-0ce1cbf1],li>.menuitem[class^=icon-][data-v-0ce1cbf1],li>.menuitem[class*=" icon-"][data-v-0ce1cbf1]{padding:0 14px 0 44px}li>button[data-v-0ce1cbf1]:not(:disabled):hover,li>button[data-v-0ce1cbf1]:not(:disabled):focus,li>button:not(:disabled).active[data-v-0ce1cbf1],li>a[data-v-0ce1cbf1]:not(:disabled):hover,li>a[data-v-0ce1cbf1]:not(:disabled):focus,li>a:not(:disabled).active[data-v-0ce1cbf1],li>.menuitem[data-v-0ce1cbf1]:not(:disabled):hover,li>.menuitem[data-v-0ce1cbf1]:not(:disabled):focus,li>.menuitem:not(:disabled).active[data-v-0ce1cbf1]{opacity:1 !important}li>button.action[data-v-0ce1cbf1],li>a.action[data-v-0ce1cbf1],li>.menuitem.action[data-v-0ce1cbf1]{padding:inherit !important}li>button>span[data-v-0ce1cbf1],li>a>span[data-v-0ce1cbf1],li>.menuitem>span[data-v-0ce1cbf1]{cursor:pointer;white-space:nowrap}li>button>p[data-v-0ce1cbf1],li>a>p[data-v-0ce1cbf1],li>.menuitem>p[data-v-0ce1cbf1]{width:150px;line-height:1.6em;padding:8px 0;white-space:normal;overflow:hidden;text-overflow:ellipsis}li>button>select[data-v-0ce1cbf1],li>a>select[data-v-0ce1cbf1],li>.menuitem>select[data-v-0ce1cbf1]{margin:0;margin-left:6px}li>button[data-v-0ce1cbf1]:not(:empty),li>a[data-v-0ce1cbf1]:not(:empty),li>.menuitem[data-v-0ce1cbf1]:not(:empty){padding-right:14px !important}li>button>img[data-v-0ce1cbf1],li>a>img[data-v-0ce1cbf1],li>.menuitem>img[data-v-0ce1cbf1]{width:16px;height:16px;margin:14px}li>button>input.radio+label[data-v-0ce1cbf1],li>button>input.checkbox+label[data-v-0ce1cbf1],li>a>input.radio+label[data-v-0ce1cbf1],li>a>input.checkbox+label[data-v-0ce1cbf1],li>.menuitem>input.radio+label[data-v-0ce1cbf1],li>.menuitem>input.checkbox+label[data-v-0ce1cbf1]{padding:0 !important;width:100%}li>button>input.checkbox+label[data-v-0ce1cbf1]::before,li>a>input.checkbox+label[data-v-0ce1cbf1]::before,li>.menuitem>input.checkbox+label[data-v-0ce1cbf1]::before{margin:-2px 13px 0}li>button>input.radio+label[data-v-0ce1cbf1]::before,li>a>input.radio+label[data-v-0ce1cbf1]::before,li>.menuitem>input.radio+label[data-v-0ce1cbf1]::before{margin:-2px 12px 0}li>button>input[data-v-0ce1cbf1]:not([type=radio]):not([type=checkbox]):not([type=image]),li>a>input[data-v-0ce1cbf1]:not([type=radio]):not([type=checkbox]):not([type=image]),li>.menuitem>input[data-v-0ce1cbf1]:not([type=radio]):not([type=checkbox]):not([type=image]){width:150px}li>button form[data-v-0ce1cbf1],li>a form[data-v-0ce1cbf1],li>.menuitem form[data-v-0ce1cbf1]{display:flex;flex:1 1 auto}li>button form[data-v-0ce1cbf1]:not(:first-child),li>a form[data-v-0ce1cbf1]:not(:first-child),li>.menuitem form[data-v-0ce1cbf1]:not(:first-child){margin-left:5px}li>button>span.hidden+form[data-v-0ce1cbf1],li>button>span[style*="display:none"]+form[data-v-0ce1cbf1],li>a>span.hidden+form[data-v-0ce1cbf1],li>a>span[style*="display:none"]+form[data-v-0ce1cbf1],li>.menuitem>span.hidden+form[data-v-0ce1cbf1],li>.menuitem>span[style*="display:none"]+form[data-v-0ce1cbf1]{margin-left:0}li>button input[data-v-0ce1cbf1],li>a input[data-v-0ce1cbf1],li>.menuitem input[data-v-0ce1cbf1]{min-width:44px;max-height:40px;margin:2px 0;flex:1 1 auto}li>button input[data-v-0ce1cbf1]:not(:first-child),li>a input[data-v-0ce1cbf1]:not(:first-child),li>.menuitem input[data-v-0ce1cbf1]:not(:first-child){margin-left:5px}li:not(.hidden):not([style*="display:none"]):first-of-type>button>form[data-v-0ce1cbf1],li:not(.hidden):not([style*="display:none"]):first-of-type>button>input[data-v-0ce1cbf1],li:not(.hidden):not([style*="display:none"]):first-of-type>a>form[data-v-0ce1cbf1],li:not(.hidden):not([style*="display:none"]):first-of-type>a>input[data-v-0ce1cbf1],li:not(.hidden):not([style*="display:none"]):first-of-type>.menuitem>form[data-v-0ce1cbf1],li:not(.hidden):not([style*="display:none"]):first-of-type>.menuitem>input[data-v-0ce1cbf1]{margin-top:12px}li:not(.hidden):not([style*="display:none"]):last-of-type>button>form[data-v-0ce1cbf1],li:not(.hidden):not([style*="display:none"]):last-of-type>button>input[data-v-0ce1cbf1],li:not(.hidden):not([style*="display:none"]):last-of-type>a>form[data-v-0ce1cbf1],li:not(.hidden):not([style*="display:none"]):last-of-type>a>input[data-v-0ce1cbf1],li:not(.hidden):not([style*="display:none"]):last-of-type>.menuitem>form[data-v-0ce1cbf1],li:not(.hidden):not([style*="display:none"]):last-of-type>.menuitem>input[data-v-0ce1cbf1]{margin-bottom:12px}li>button[data-v-0ce1cbf1]{padding:0}li>button span[data-v-0ce1cbf1]{opacity:1}', "", { version: 3, sources: ["webpack://./src/assets/material-icons.css", "webpack://./src/components/NcPopoverMenu/NcPopoverMenuItem.vue", "webpack://./src/assets/variables.scss"], names: [], mappings: "AAGA,uCACC,YAAA,CACA,iBAAA,CACA,mBAAA,CACA,kBAAA,CACA,sBAAA,CCND,oBACC,YAAA,CACA,aAAA,CAEA,2BACC,YAAA,CAGD,+EAGC,cAAA,CACA,gBCWe,CDVf,QAAA,CACA,8BAAA,CACA,YAAA,CACA,sBAAA,CACA,WAAA,CACA,QAAA,CACA,SAAA,CACA,kBAAA,CACA,eAAA,CACA,UAAA,CACA,4BAAA,CACA,kBAAA,CACA,UCgBe,CDbf,ohBAIC,WAAA,CACA,YAAA,CACA,+BAAA,CACA,oBCRS,CDWV,yRAIC,wBAAA,CAQC,ylCACC,gBC5BY,CDiCf,2PAEC,qBAAA,CAGD,6aAGC,oBAAA,CAID,oGACC,0BAAA,CAGD,8FACC,cAAA,CACA,kBAAA,CAID,qFACC,WAAA,CACA,iBAAA,CACA,aAAA,CACA,kBAAA,CAGA,eAAA,CACA,sBAAA,CAID,oGACC,QAAA,CACA,eAAA,CAID,mHACC,6BAAA,CAKD,2FACC,UC5ES,CD6ET,WC7ES,CD8ET,WC1EW,CD8EZ,mRAEC,oBAAA,CACA,UAAA,CAED,sKACC,kBAAA,CAED,6JACC,kBAAA,CAED,4QACC,WAAA,CAID,8FACC,YAAA,CACA,aAAA,CAGA,oJACC,eAAA,CAIF,oTAEC,aAAA,CAGD,iGACC,cCtHc,CDuHd,eAAA,CACA,YAAA,CACA,aAAA,CAEA,uJACC,eAAA,CAUA,+gBACC,eAAA,CAMD,ygBACC,kBAAA,CAKJ,2BACC,SAAA,CACA,gCACC,SCnIY", sourcesContent: [`/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon {
	display: flex;
	align-self: center;
	justify-self: center;
	align-items: center;
	justify-content: center;
}
`, `@use 'sass:math'; $scope_version:"3d66c94"; @import 'variables'; @import 'material-icons';

li {
	display: flex;
	flex: 0 0 auto;

	&.hidden {
		display: none;
	}

	> button,
	> a,
	> .menuitem {
		cursor: pointer;
		line-height: $clickable-area;
		border: 0;
		background-color: transparent;
		display: flex;
		align-items: flex-start;
		height: auto;
		margin: 0;
		padding: 0;
		font-weight: normal;
		box-shadow: none;
		width: 100%;
		color: var(--color-main-text);
		white-space: nowrap;
		opacity: $opacity_normal;

		// TODO split into individual components for readability
		span[class^='icon-'],
		span[class*=' icon-'],
		&[class^='icon-'],
		&[class*=' icon-'] {
			min-width: 0; /* Overwrite icons*/
			min-height: 0;
			background-position: #{$icon-margin} center;
			background-size: $icon-size;
		}

		span[class^='icon-'],
		span[class*=' icon-'] {
			/* Keep padding to define the width to
				assure correct position of a possible text */
			padding: #{math.div($clickable-area, 2)} 0 #{math.div($clickable-area, 2)} $clickable-area;
		}

		// If no icons set, force left margin to align
		&:not([class^='icon-']):not([class*='icon-']) {
			> span,
			> input,
			> form {
				&:not([class^='icon-']):not([class*='icon-']):first-child {
					margin-left: $clickable-area;
				}
			}
		}

		&[class^='icon-'],
		&[class*=' icon-'] {
			padding: 0 $icon-margin 0 $clickable-area;
		}

		&:not(:disabled):hover,
		&:not(:disabled):focus,
		&:not(:disabled).active {
			opacity: $opacity_full !important;
		}

		/* prevent .action class to break the design */
		&.action {
			padding: inherit !important;
		}

		> span {
			cursor: pointer;
			white-space: nowrap;
		}

		// long text area
		> p {
			width: 150px;
			line-height: 1.6em;
			padding: 8px 0;
			white-space: normal;

			// in case there are no spaces like long email addresses
			overflow: hidden;
			text-overflow: ellipsis;
		}

		// TODO: do we really supports it?
		> select {
			margin: 0;
			margin-left: 6px;
		}

		/* Add padding if contains icon+text */
		&:not(:empty) {
			padding-right: $icon-margin !important;
		}

		/* DEPRECATED! old img in popover fallback
			* TODO: to remove */
		> img {
			width: $icon-size;
			height: $icon-size;
			margin: $icon-margin;
		}

		/* checkbox/radio fixes */
		> input.radio + label,
		> input.checkbox + label {
			padding: 0 !important;
			width: 100%;
		}
		> input.checkbox + label::before {
			margin: -2px 13px 0;
		}
		> input.radio + label::before {
			margin: -2px 12px 0;
		}
		> input:not([type=radio]):not([type=checkbox]):not([type=image]) {
			width: 150px;
		}

		// Forms & text inputs
		form {
			display: flex;
			flex: 1 1 auto;
			/* put a small space between text and form
				if there is an element before */
			&:not(:first-child)  {
				margin-left: 5px;
			}
		}
		/* no margin if hidden span before */
		> span.hidden + form,
		> span[style*='display:none'] + form {
			margin-left: 0;
		}
		/* Inputs inside popover supports text, submit & reset */
		input {
			min-width: $clickable-area;
			max-height: #{$clickable-area - 4px}; /* twice the element margin-y */
			margin: 2px 0;
			flex: 1 1 auto;
			// space between inline inputs
			&:not(:first-child) {
				margin-left: 5px;
			}
		}
	}

	// TODO: do that in js, should be cleaner
	/* css hack, only first not hidden */
	&:not(.hidden):not([style*='display:none']) {
		&:first-of-type {
			> button, > a, > .menuitem {
				> form, > input {
					margin-top: $icon-margin - 2px; // minus the input margin
				}
			}
		}
		&:last-of-type {
			> button, > a, > .menuitem {
				> form, > input {
					margin-bottom: $icon-margin - 2px; // minus the input margin
				}
			}
		}
	}
	> button {
		padding: 0;
		span {
			opacity: $opacity_full;
		}
	}
}
`, `/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */

// https://uxplanet.org/7-rules-for-mobile-ui-button-design-e9cf2ea54556
// recommended is 48px
// 44px is what we choose and have very good visual-to-usability ratio
$clickable-area: 44px;

// background icon size
// also used for the scss icon font
$icon-size: 16px;

// icon padding for a $clickable-area width and a $icon-size icon
// ( 44px - 16px ) / 2
$icon-margin: math.div($clickable-area - $icon-size, 2);

// transparency background for icons
$icon-focus-bg: rgba(127, 127, 127, .25);

// popovermenu arrow width from the triangle center
$arrow-width: 9px;

// opacities
$opacity_disabled: .5;
$opacity_normal: .7;
$opacity_full: 1;

// menu round background hover feedback
// good looking on dark AND white bg
$action-background-hover: rgba(127, 127, 127, .25);

// various structure data used in the 
// \`AppNavigation\` component
$header-height: 50px;
$navigation-width: 300px;

// mobile breakpoint
$breakpoint-mobile: 1024px;

// top-bar spacing
$topbar-margin: 4px;

// navigation spacing
$app-navigation-settings-margin: 3px;
`], sourceRoot: "" }]);
      const A = d;
    }, 4477: (o, l, a) => {
      a.d(l, { Z: () => A });
      var c = a(7537), T = a.n(c), u = a(3645), d = a.n(u)()(T());
      d.push([o.id, ".material-design-icon[data-v-32fccbe9]{display:flex;align-self:center;justify-self:center;align-items:center;justify-content:center}.mention-bubble--primary .mention-bubble__content[data-v-32fccbe9]{color:var(--color-primary-text);background-color:var(--color-primary-element)}.mention-bubble__wrapper[data-v-32fccbe9]{max-width:150px;height:18px;vertical-align:text-bottom;display:inline-flex;align-items:center}.mention-bubble__content[data-v-32fccbe9]{display:inline-flex;overflow:hidden;align-items:center;max-width:100%;height:20px;-webkit-user-select:none;user-select:none;padding-right:6px;padding-left:2px;border-radius:10px;background-color:var(--color-background-dark)}.mention-bubble__icon[data-v-32fccbe9]{position:relative;width:16px;height:16px;border-radius:8px;background-color:var(--color-background-darker);background-repeat:no-repeat;background-position:center;background-size:12px}.mention-bubble__icon--with-avatar[data-v-32fccbe9]{color:inherit;background-size:cover}.mention-bubble__title[data-v-32fccbe9]{overflow:hidden;margin-left:2px;white-space:nowrap;text-overflow:ellipsis}.mention-bubble__title[data-v-32fccbe9]::before{content:attr(title)}.mention-bubble__select[data-v-32fccbe9]{position:absolute;z-index:-1;left:-1000px}", "", { version: 3, sources: ["webpack://./src/assets/material-icons.css", "webpack://./src/components/NcRichContenteditable/NcMentionBubble.vue"], names: [], mappings: "AAGA,uCACC,YAAA,CACA,iBAAA,CACA,mBAAA,CACA,kBAAA,CACA,sBAAA,CAAA,mECCC,+BAAA,CACA,6CAAA,CAGD,0CACC,eAXiB,CAajB,WAAA,CACA,0BAAA,CACA,mBAAA,CACA,kBAAA,CAGD,0CACC,mBAAA,CACA,eAAA,CACA,kBAAA,CACA,cAAA,CACA,WAzBc,CA0Bd,wBAAA,CACA,gBAAA,CACA,iBAAA,CACA,gBA3Be,CA4Bf,kBAAA,CACA,6CAAA,CAGD,uCACC,iBAAA,CACA,UAjCmB,CAkCnB,WAlCmB,CAmCnB,iBAAA,CACA,+CAAA,CACA,2BAAA,CACA,0BAAA,CACA,oBAAA,CAEA,oDACC,aAAA,CACA,qBAAA,CAIF,wCACC,eAAA,CACA,eAlDe,CAmDf,kBAAA,CACA,sBAAA,CAEA,gDACC,mBAAA,CAKF,yCACC,iBAAA,CACA,UAAA,CACA,YAAA", sourcesContent: [`/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon {
	display: flex;
	align-self: center;
	justify-self: center;
	align-items: center;
	justify-content: center;
}
`, `@use 'sass:math'; $scope_version:"3d66c94"; @import 'variables'; @import 'material-icons';

$bubble-height: 20px;
$bubble-max-width: 150px;
$bubble-padding: 2px;
$bubble-avatar-size: $bubble-height - 2 * $bubble-padding;

.mention-bubble {
	&--primary &__content {
		color: var(--color-primary-text);
		background-color: var(--color-primary-element);
	}

	&__wrapper {
		max-width: $bubble-max-width;
		// Align with text
		height: $bubble-height - $bubble-padding;
		vertical-align: text-bottom;
		display: inline-flex;
		align-items: center;
	}

	&__content {
		display: inline-flex;
		overflow: hidden;
		align-items: center;
		max-width: 100%;
		height: $bubble-height ;
		-webkit-user-select: none;
		user-select: none;
		padding-right: $bubble-padding * 3;
		padding-left: $bubble-padding;
		border-radius: math.div($bubble-height, 2);
		background-color: var(--color-background-dark);
	}

	&__icon {
		position: relative;
		width: $bubble-avatar-size;
		height: $bubble-avatar-size;
		border-radius: math.div($bubble-avatar-size, 2);
		background-color: var(--color-background-darker);
		background-repeat: no-repeat;
		background-position: center;
		background-size: $bubble-avatar-size - 2 * $bubble-padding;

		&--with-avatar {
			color: inherit;
			background-size: cover;
		}
	}

	&__title {
		overflow: hidden;
		margin-left: $bubble-padding;
		white-space: nowrap;
		text-overflow: ellipsis;
		// Put label in ::before so it is not selectable
		&::before {
			content: attr(title);
		}
	}

	// Hide the mention id so it is selectable
	&__select {
		position: absolute;
		z-index: -1;
		left: -1000px;
	}
}

`], sourceRoot: "" }]);
      const A = d;
    }, 7887: (o, l, a) => {
      a.d(l, { Z: () => A });
      var c = a(7537), T = a.n(c), u = a(3645), d = a.n(u)()(T());
      d.push([o.id, ".material-design-icon[data-v-3992c512]{display:flex;align-self:center;justify-self:center;align-items:center;justify-content:center}[data-v-3992c512] .multiselect__tags{border:none !important}", "", { version: 3, sources: ["webpack://./src/assets/material-icons.css", "webpack://./src/components/NcTimezonePicker/NcTimezonePicker.vue"], names: [], mappings: "AAGA,uCACC,YAAA,CACA,iBAAA,CACA,mBAAA,CACA,kBAAA,CACA,sBAAA,CCND,qCACC,sBAAA", sourcesContent: [`/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon {
	display: flex;
	align-self: center;
	justify-self: center;
	align-items: center;
	justify-content: center;
}
`, `@use 'sass:math'; $scope_version:"3d66c94"; @import 'variables'; @import 'material-icons';

:deep(.multiselect__tags) {
	border: none !important; // Remove the Multiselect border
}
`], sourceRoot: "" }]);
      const A = d;
    }, 5578: (o, l, a) => {
      a.d(l, { Z: () => A });
      var c = a(7537), T = a.n(c), u = a(3645), d = a.n(u)()(T());
      d.push([o.id, `
button.menuitem[data-v-0ce1cbf1] {
	border-radius: var(--border-radius-large) !important;
	text-align: left;
}
button.menuitem *[data-v-0ce1cbf1] {
	cursor: pointer;
}
button.menuitem[data-v-0ce1cbf1]:disabled {
	opacity: 0.5 !important;
	cursor: default;
}
button.menuitem:disabled *[data-v-0ce1cbf1] {
	cursor: default;
}
.menuitem.active[data-v-0ce1cbf1] {
	border-left: 4px solid var(--color-primary);
	border-radius: 0 var(--border-radius-large) var(--border-radius-large) 0 !important;
}
`, "", { version: 3, sources: ["webpack://./src/components/NcPopoverMenu/NcPopoverMenuItem.vue"], names: [], mappings: ";AAgYA;CACA,oDAAA;CACA,gBAAA;AACA;AAEA;CACA,eAAA;AACA;AAEA;CACA,uBAAA;CACA,eAAA;AACA;AAEA;CACA,eAAA;AACA;AAEA;CACA,2CAAA;CACA,mFAAA;AACA", sourcesContent: [`<!--
  - @copyright Copyright (c) 2018 John Molakvoæ <skjnldsv@protonmail.com>
  -
  - @author John Molakvoæ <skjnldsv@protonmail.com>
  -
  - @license GNU AGPL version 3 or any later version
  -
  - This program is free software: you can redistribute it and/or modify
  - it under the terms of the GNU Affero General Public License as
  - published by the Free Software Foundation, either version 3 of the
  - License, or (at your option) any later version.
  -
  - This program is distributed in the hope that it will be useful,
  - but WITHOUT ANY WARRANTY; without even the implied warranty of
  - MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
  - GNU Affero General Public License for more details.
  -
  - You should have received a copy of the GNU Affero General Public License
  - along with this program. If not, see <http://www.gnu.org/licenses/>.
  -
  -->

<template>
	<li class="popover__menuitem">
		<!-- If item.href is set, a link will be directly used -->
		<a v-if="item.href"
			:href="(item.href) ? item.href : '#' "
			:target="(item.target) ? item.target : '' "
			:download="item.download"
			class="focusable"
			rel="nofollow noreferrer noopener"
			@click="action">
			<span v-if="!iconIsUrl" :class="item.icon" />
			<img v-else :src="item.icon">
			<p v-if="item.text && item.longtext">
				<strong class="menuitem-text">
					{{ item.text }}
				</strong><br>
				<span class="menuitem-text-detail">
					{{ item.longtext }}
				</span>
			</p>
			<span v-else-if="item.text">
				{{ item.text }}
			</span>
			<p v-else-if="item.longtext">
				{{ item.longtext }}
			</p>
		</a>

		<!-- If item.input is set instead, an put will be used -->
		<span v-else-if="item.input" class="menuitem" :class="{active: item.active}">
			<!-- does not show if input is checkbox -->
			<span v-if="item.input !== 'checkbox'" :class="item.icon" />

			<!-- only shows if input is text -->
			<form v-if="item.input === 'text'"
				:class="item.input"
				@submit.prevent="item.action">
				<input :type="item.input"
					:value="item.value"
					:placeholder="item.text"
					required>
				<input type="submit" value="" class="icon-confirm">
			</form>

			<!-- checkbox -->
			<template v-else>
				<!-- eslint-disable-next-line -->
				<input :id="key" v-model="item.model"
					:type="item.input"
					:class="item.input"
					@change="item.action">
				<label :for="key" @click.stop.prevent="item.action">
					{{ item.text }}
				</label>
			</template>
		</span>

		<!-- If item.action is set instead, a button will be used -->
		<button v-else-if="item.action"
			class="menuitem focusable"
			:class="{active: item.active}"
			:disabled="item.disabled"
			type="button"
			@click.stop.prevent="item.action">
			<span :class="item.icon" />
			<p v-if="item.text && item.longtext">
				<strong class="menuitem-text">
					{{ item.text }}
				</strong><br>
				<span class="menuitem-text-detail">
					{{ item.longtext }}
				</span>
			</p>
			<span v-else-if="item.text">
				{{ item.text }}
			</span>
			<p v-else-if="item.longtext">
				{{ item.longtext }}
			</p>
		</button>

		<!-- If item.longtext is set AND the item does not have an action -->
		<span v-else class="menuitem" :class="{active: item.active}">
			<span :class="item.icon" />
			<p v-if="item.text && item.longtext">
				<strong class="menuitem-text">
					{{ item.text }}
				</strong><br>
				<span class="menuitem-text-detail">
					{{ item.longtext }}
				</span>
			</p>
			<span v-else-if="item.text">
				{{ item.text }}
			</span>
			<p v-else-if="item.longtext">
				{{ item.longtext }}
			</p>
		</span>
	</li>
</template>

<script>
export default {
	name: 'NcPopoverMenuItem',
	props: {
		item: {
			type: Object,
			required: true,
			default: () => {
				return {
					key: 'nextcloud-link',
					href: 'https://nextcloud.com',
					icon: 'icon-links',
					text: 'Nextcloud',
				}
			},
			// check the input types
			// TODO: add more validation of types
			validator: item => {
				// TODO: support radio
				if (item.input) {
					return ['text', 'checkbox'].indexOf(item.input) !== -1
				}
				return true
			},
		},
	},
	computed: {
		// random key for inputs binding if not provided
		key() {
			return this.item.key
				? this.item.key
				: Math.round(Math.random() * 16 * 1000000).toString(16)
		},
		iconIsUrl() {
			try {
				// eslint-disable-next-line no-new
				new URL(this.item.icon)
				return true
			} catch (_) {
				return false
			}
		},
	},
	methods: {
		// allow us to use both link and an action on \`a\`
		// we still need to make sure item.action exists
		action(event) {
			if (this.item.action) {
				this.item.action(event)
			}
		},
	},
}
<\/script>

<style scoped>
	button.menuitem {
		border-radius: var(--border-radius-large) !important;
		text-align: left;
	}

	button.menuitem * {
		cursor: pointer;
	}

	button.menuitem:disabled {
		opacity: 0.5 !important;
		cursor: default;
	}

	button.menuitem:disabled * {
		cursor: default;
	}

	.menuitem.active {
		border-left: 4px solid var(--color-primary);
		border-radius: 0 var(--border-radius-large) var(--border-radius-large) 0 !important;
	}
</style>

<style lang="scss" scoped>
li {
	display: flex;
	flex: 0 0 auto;

	&.hidden {
		display: none;
	}

	> button,
	> a,
	> .menuitem {
		cursor: pointer;
		line-height: $clickable-area;
		border: 0;
		background-color: transparent;
		display: flex;
		align-items: flex-start;
		height: auto;
		margin: 0;
		padding: 0;
		font-weight: normal;
		box-shadow: none;
		width: 100%;
		color: var(--color-main-text);
		white-space: nowrap;
		opacity: $opacity_normal;

		// TODO split into individual components for readability
		span[class^='icon-'],
		span[class*=' icon-'],
		&[class^='icon-'],
		&[class*=' icon-'] {
			min-width: 0; /* Overwrite icons*/
			min-height: 0;
			background-position: #{$icon-margin} center;
			background-size: $icon-size;
		}

		span[class^='icon-'],
		span[class*=' icon-'] {
			/* Keep padding to define the width to
				assure correct position of a possible text */
			padding: #{math.div($clickable-area, 2)} 0 #{math.div($clickable-area, 2)} $clickable-area;
		}

		// If no icons set, force left margin to align
		&:not([class^='icon-']):not([class*='icon-']) {
			> span,
			> input,
			> form {
				&:not([class^='icon-']):not([class*='icon-']):first-child {
					margin-left: $clickable-area;
				}
			}
		}

		&[class^='icon-'],
		&[class*=' icon-'] {
			padding: 0 $icon-margin 0 $clickable-area;
		}

		&:not(:disabled):hover,
		&:not(:disabled):focus,
		&:not(:disabled).active {
			opacity: $opacity_full !important;
		}

		/* prevent .action class to break the design */
		&.action {
			padding: inherit !important;
		}

		> span {
			cursor: pointer;
			white-space: nowrap;
		}

		// long text area
		> p {
			width: 150px;
			line-height: 1.6em;
			padding: 8px 0;
			white-space: normal;

			// in case there are no spaces like long email addresses
			overflow: hidden;
			text-overflow: ellipsis;
		}

		// TODO: do we really supports it?
		> select {
			margin: 0;
			margin-left: 6px;
		}

		/* Add padding if contains icon+text */
		&:not(:empty) {
			padding-right: $icon-margin !important;
		}

		/* DEPRECATED! old img in popover fallback
			* TODO: to remove */
		> img {
			width: $icon-size;
			height: $icon-size;
			margin: $icon-margin;
		}

		/* checkbox/radio fixes */
		> input.radio + label,
		> input.checkbox + label {
			padding: 0 !important;
			width: 100%;
		}
		> input.checkbox + label::before {
			margin: -2px 13px 0;
		}
		> input.radio + label::before {
			margin: -2px 12px 0;
		}
		> input:not([type=radio]):not([type=checkbox]):not([type=image]) {
			width: 150px;
		}

		// Forms & text inputs
		form {
			display: flex;
			flex: 1 1 auto;
			/* put a small space between text and form
				if there is an element before */
			&:not(:first-child)  {
				margin-left: 5px;
			}
		}
		/* no margin if hidden span before */
		> span.hidden + form,
		> span[style*='display:none'] + form {
			margin-left: 0;
		}
		/* Inputs inside popover supports text, submit & reset */
		input {
			min-width: $clickable-area;
			max-height: #{$clickable-area - 4px}; /* twice the element margin-y */
			margin: 2px 0;
			flex: 1 1 auto;
			// space between inline inputs
			&:not(:first-child) {
				margin-left: 5px;
			}
		}
	}

	// TODO: do that in js, should be cleaner
	/* css hack, only first not hidden */
	&:not(.hidden):not([style*='display:none']) {
		&:first-of-type {
			> button, > a, > .menuitem {
				> form, > input {
					margin-top: $icon-margin - 2px; // minus the input margin
				}
			}
		}
		&:last-of-type {
			> button, > a, > .menuitem {
				> form, > input {
					margin-bottom: $icon-margin - 2px; // minus the input margin
				}
			}
		}
	}
	> button {
		padding: 0;
		span {
			opacity: $opacity_full;
		}
	}
}
</style>
`], sourceRoot: "" }]);
      const A = d;
    }, 3645: (o) => {
      o.exports = function(l) {
        var a = [];
        return a.toString = function() {
          return this.map(function(c) {
            var T = "", u = c[5] !== void 0;
            return c[4] && (T += "@supports (".concat(c[4], ") {")), c[2] && (T += "@media ".concat(c[2], " {")), u && (T += "@layer".concat(c[5].length > 0 ? " ".concat(c[5]) : "", " {")), T += l(c), u && (T += "}"), c[2] && (T += "}"), c[4] && (T += "}"), T;
          }).join("");
        }, a.i = function(c, T, u, d, A) {
          typeof c == "string" && (c = [[null, c, void 0]]);
          var f = {};
          if (u)
            for (var h = 0; h < this.length; h++) {
              var S = this[h][0];
              S != null && (f[S] = !0);
            }
          for (var p = 0; p < c.length; p++) {
            var m = [].concat(c[p]);
            u && f[m[0]] || (A !== void 0 && (m[5] === void 0 || (m[1] = "@layer".concat(m[5].length > 0 ? " ".concat(m[5]) : "", " {").concat(m[1], "}")), m[5] = A), T && (m[2] && (m[1] = "@media ".concat(m[2], " {").concat(m[1], "}")), m[2] = T), d && (m[4] ? (m[1] = "@supports (".concat(m[4], ") {").concat(m[1], "}"), m[4] = d) : m[4] = "".concat(d)), a.push(m));
          }
        }, a;
      };
    }, 1667: (o) => {
      o.exports = function(l, a) {
        return a || (a = {}), l && (l = String(l.__esModule ? l.default : l), /^['"].*['"]$/.test(l) && (l = l.slice(1, -1)), a.hash && (l += a.hash), /["'() \t\n]|(%20)/.test(l) || a.needQuotes ? '"'.concat(l.replace(/"/g, '\\"').replace(/\n/g, "\\n"), '"') : l);
      };
    }, 7537: (o) => {
      o.exports = function(l) {
        var a = l[1], c = l[3];
        if (!c)
          return a;
        if (typeof btoa == "function") {
          var T = btoa(unescape(encodeURIComponent(JSON.stringify(c)))), u = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(T), d = "/*# ".concat(u, " */");
          return [a].concat([d]).join(`
`);
        }
        return [a].join(`
`);
      };
    }, 3379: (o) => {
      var l = [];
      function a(u) {
        for (var d = -1, A = 0; A < l.length; A++)
          if (l[A].identifier === u) {
            d = A;
            break;
          }
        return d;
      }
      function c(u, d) {
        for (var A = {}, f = [], h = 0; h < u.length; h++) {
          var S = u[h], p = d.base ? S[0] + d.base : S[0], m = A[p] || 0, g = "".concat(p, " ").concat(m);
          A[p] = m + 1;
          var N = a(g), R = { css: S[1], media: S[2], sourceMap: S[3], supports: S[4], layer: S[5] };
          if (N !== -1)
            l[N].references++, l[N].updater(R);
          else {
            var D = T(R, d);
            d.byIndex = h, l.splice(h, 0, { identifier: g, updater: D, references: 1 });
          }
          f.push(g);
        }
        return f;
      }
      function T(u, d) {
        var A = d.domAPI(d);
        return A.update(u), function(f) {
          if (f) {
            if (f.css === u.css && f.media === u.media && f.sourceMap === u.sourceMap && f.supports === u.supports && f.layer === u.layer)
              return;
            A.update(u = f);
          } else
            A.remove();
        };
      }
      o.exports = function(u, d) {
        var A = c(u = u || [], d = d || {});
        return function(f) {
          f = f || [];
          for (var h = 0; h < A.length; h++) {
            var S = a(A[h]);
            l[S].references--;
          }
          for (var p = c(f, d), m = 0; m < A.length; m++) {
            var g = a(A[m]);
            l[g].references === 0 && (l[g].updater(), l.splice(g, 1));
          }
          A = p;
        };
      };
    }, 569: (o) => {
      var l = {};
      o.exports = function(a, c) {
        var T = function(u) {
          if (l[u] === void 0) {
            var d = document.querySelector(u);
            if (window.HTMLIFrameElement && d instanceof window.HTMLIFrameElement)
              try {
                d = d.contentDocument.head;
              } catch {
                d = null;
              }
            l[u] = d;
          }
          return l[u];
        }(a);
        if (!T)
          throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
        T.appendChild(c);
      };
    }, 9216: (o) => {
      o.exports = function(l) {
        var a = document.createElement("style");
        return l.setAttributes(a, l.attributes), l.insert(a, l.options), a;
      };
    }, 3565: (o, l, a) => {
      o.exports = function(c) {
        var T = a.nc;
        T && c.setAttribute("nonce", T);
      };
    }, 7795: (o) => {
      o.exports = function(l) {
        var a = l.insertStyleElement(l);
        return { update: function(c) {
          (function(T, u, d) {
            var A = "";
            d.supports && (A += "@supports (".concat(d.supports, ") {")), d.media && (A += "@media ".concat(d.media, " {"));
            var f = d.layer !== void 0;
            f && (A += "@layer".concat(d.layer.length > 0 ? " ".concat(d.layer) : "", " {")), A += d.css, f && (A += "}"), d.media && (A += "}"), d.supports && (A += "}");
            var h = d.sourceMap;
            h && typeof btoa < "u" && (A += `
/*# sourceMappingURL=data:application/json;base64,`.concat(btoa(unescape(encodeURIComponent(JSON.stringify(h)))), " */")), u.styleTagTransform(A, T, u.options);
          })(a, l, c);
        }, remove: function() {
          (function(c) {
            if (c.parentNode === null)
              return !1;
            c.parentNode.removeChild(c);
          })(a);
        } };
      };
    }, 4589: (o) => {
      o.exports = function(l, a) {
        if (a.styleSheet)
          a.styleSheet.cssText = l;
        else {
          for (; a.firstChild; )
            a.removeChild(a.firstChild);
          a.appendChild(document.createTextNode(l));
        }
      };
    }, 2298: (o, l, a) => {
      a.d(l, { Z: () => y });
      var c = a(4262);
      const T = { name: "NcMentionBubble", props: { id: { type: String, required: !0 }, label: { type: String, required: !0 }, icon: { type: String, required: !0 }, source: { type: String, required: !0 }, primary: { type: Boolean, default: !1 } }, computed: { avatarUrl: function() {
        return this.id && this.source === "users" ? this.getAvatarUrl(this.id, 44) : null;
      }, mentionText: function() {
        return this.id.indexOf(" ") === -1 ? "@".concat(this.id) : '@"'.concat(this.id, '"');
      } }, methods: { getAvatarUrl: function(Z, F) {
        return (0, c.generateUrl)("/avatar/{user}/{size}", { user: Z, size: F });
      } } };
      var u = a(3379), d = a.n(u), A = a(7795), f = a.n(A), h = a(569), S = a.n(h), p = a(3565), m = a.n(p), g = a(9216), N = a.n(g), R = a(4589), D = a.n(R), v = a(4477), O = {};
      O.styleTagTransform = D(), O.setAttributes = m(), O.insert = S().bind(null, "head"), O.domAPI = f(), O.insertStyleElement = N(), d()(v.Z, O), v.Z && v.Z.locals && v.Z.locals;
      const y = (0, a(1900).Z)(T, function() {
        var Z = this, F = Z._self._c;
        return F("span", { staticClass: "mention-bubble", class: { "mention-bubble--primary": Z.primary }, attrs: { contenteditable: "false" } }, [F("span", { staticClass: "mention-bubble__wrapper" }, [F("span", { staticClass: "mention-bubble__content" }, [F("span", { staticClass: "mention-bubble__icon", class: [Z.icon, "mention-bubble__icon--".concat(Z.avatarUrl ? "with-avatar" : "")], style: Z.avatarUrl ? { backgroundImage: "url(".concat(Z.avatarUrl, ")") } : null }), Z._v(" "), F("span", { staticClass: "mention-bubble__title", attrs: { role: "heading", title: Z.label } })]), Z._v(" "), F("span", { staticClass: "mention-bubble__select", attrs: { role: "none" } }, [Z._v(Z._s(Z.mentionText))])])]);
      }, [], !1, null, "32fccbe9", null).exports;
    }, 3051: () => {
    }, 8538: () => {
    }, 6274: () => {
    }, 1287: () => {
    }, 8488: () => {
    }, 9280: () => {
    }, 6049: () => {
    }, 2405: () => {
    }, 1174: () => {
    }, 189: () => {
    }, 1900: (o, l, a) => {
      function c(T, u, d, A, f, h, S, p) {
        var m, g = typeof T == "function" ? T.options : T;
        if (u && (g.render = u, g.staticRenderFns = d, g._compiled = !0), A && (g.functional = !0), h && (g._scopeId = "data-v-" + h), S ? (m = function(D) {
          (D = D || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) || typeof __VUE_SSR_CONTEXT__ > "u" || (D = __VUE_SSR_CONTEXT__), f && f.call(this, D), D && D._registeredComponents && D._registeredComponents.add(S);
        }, g._ssrRegister = m) : f && (m = p ? function() {
          f.call(this, (g.functional ? this.parent : this).$root.$options.shadowRoot);
        } : f), m)
          if (g.functional) {
            g._injectStyles = m;
            var N = g.render;
            g.render = function(D, v) {
              return m.call(v), N(D, v);
            };
          } else {
            var R = g.beforeCreate;
            g.beforeCreate = R ? [].concat(R, m) : [m];
          }
        return { exports: T, options: g };
      }
      a.d(l, { Z: () => c });
    }, 7127: (o) => {
      o.exports = "data:image/svg+xml;base64,PCEtLSBUaGlzIGljb24gaXMgcGFydCBvZiBNYXRlcmlhbCBVSSBJY29ucy4gQ29weXJpZ2h0IDIwMjAgR29vZ2xlIEluYy4sIEFwYWNoZS0yLjAgTGljZW5zZSAtLT4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiI+PHBhdGggZmlsbD0ibm9uZSIgZD0iTS00LTRoMjR2MjRILTR6Ii8+PHBhdGggZD0iTTYuOS4xQzMgLjYtLjEgNC0uMSA4YzAgNC40IDMuNiA4IDggOCA0IDAgNy40LTMgOC02LjktMS4yIDEuMy0yLjkgMi4xLTQuNyAyLjEtMy41IDAtNi40LTIuOS02LjQtNi40IDAtMS45LjgtMy42IDIuMS00Ljd6IiBmaWxsPSIjZjRhMzMxIi8+PC9zdmc+Cg==";
    }, 2605: (o) => {
      o.exports = "data:image/svg+xml;base64,PCEtLSBUaGlzIGljb24gaXMgcGFydCBvZiBNYXRlcmlhbCBVSSBJY29ucy4gQ29weXJpZ2h0IDIwMjAgR29vZ2xlIEluYy4sIEFwYWNoZS0yLjAgTGljZW5zZSAtLT4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiI+PHBhdGggZD0iTS00LTRoMjR2MjRILTRWLTR6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTggMEMzLjYgMCAwIDMuNiAwIDhzMy42IDggOCA4IDgtMy42IDgtOC0zLjYtOC04LTh6IiBmaWxsPSIjZWQ0ODRjIi8+PHBhdGggZD0iTTUgNi41aDZjLjggMCAxLjUuNyAxLjUgMS41cy0uNyAxLjUtMS41IDEuNUg1Yy0uOCAwLTEuNS0uNy0xLjUtMS41UzQuMiA2LjUgNSA2LjV6IiBmaWxsPSIjZmRmZmZmIi8+PC9zdmc+Cg==";
    }, 3423: (o) => {
      o.exports = "data:image/svg+xml;base64,PCEtLSBUaGlzIGljb24gaXMgcGFydCBvZiBNYXRlcmlhbCBVSSBJY29ucy4gQ29weXJpZ2h0IDIwMjAgR29vZ2xlIEluYy4sIEFwYWNoZS0yLjAgTGljZW5zZSAtLT4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiI+PHBhdGggZD0iTTQuOCAxMS4yaDYuNFY0LjhINC44djYuNHpNOCAwQzMuNiAwIDAgMy42IDAgOHMzLjYgOCA4IDggOC0zLjYgOC04LTMuNi04LTgtOHoiIGZpbGw9IiM0OWIzODIiLz48L3N2Zz4K";
    }, 7425: (o) => {
      o.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0iI2QyZDJkMiI+PHBhdGggZD0iTTE4LjQgNy40TDE3IDZsLTYgNiA2IDYgMS40LTEuNC00LjYtNC42IDQuNi00LjZtLTYgMEwxMSA2bC02IDYgNiA2IDEuNC0xLjRMNy44IDEybDQuNi00LjZ6Ii8+PC9zdmc+";
    }, 6417: (o) => {
      o.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0iIzIyMiI+PHBhdGggZD0iTTE4LjQgNy40TDE3IDZsLTYgNiA2IDYgMS40LTEuNC00LjYtNC42IDQuNi00LjZtLTYgMEwxMSA2bC02IDYgNiA2IDEuNC0xLjRMNy44IDEybDQuNi00LjZ6Ii8+PC9zdmc+";
    }, 5322: (o) => {
      o.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0iI2QyZDJkMiI+PHBhdGggZD0iTTUuNiA3LjRMNyA2bDYgNi02IDYtMS40LTEuNCA0LjYtNC42LTQuNi00LjZtNiAwTDEzIDZsNiA2LTYgNi0xLjQtMS40IDQuNi00LjYtNC42LTQuNnoiLz48L3N2Zz4=";
    }, 5415: (o) => {
      o.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0iIzIyMiI+PHBhdGggZD0iTTUuNiA3LjRMNyA2bDYgNi02IDYtMS40LTEuNCA0LjYtNC42LTQuNi00LjZtNiAwTDEzIDZsNiA2LTYgNi0xLjQtMS40IDQuNi00LjYtNC42LTQuNnoiLz48L3N2Zz4=";
    }, 9039: (o) => {
      o.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0iI2QyZDJkMiI+PHBhdGggZD0iTTE1LjQgMTYuNkwxMC44IDEybDQuNi00LjZMMTQgNmwtNiA2IDYgNiAxLjQtMS40eiIvPjwvc3ZnPg==";
    }, 817: (o) => {
      o.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0iIzIyMiI+PHBhdGggZD0iTTE1LjQgMTYuNkwxMC44IDEybDQuNi00LjZMMTQgNmwtNiA2IDYgNiAxLjQtMS40eiIvPjwvc3ZnPg==";
    }, 4259: (o) => {
      o.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0iI2QyZDJkMiI+PHBhdGggZD0iTTguNiAxNi42bDQuNi00LjYtNC42LTQuNkwxMCA2bDYgNi02IDYtMS40LTEuNHoiLz48L3N2Zz4=";
    }, 3787: (o) => {
      o.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0iIzIyMiI+PHBhdGggZD0iTTguNiAxNi42bDQuNi00LjYtNC42LTQuNkwxMCA2bDYgNi02IDYtMS40LTEuNHoiLz48L3N2Zz4=";
    }, 3607: (o) => {
      o.exports = Vu();
    }, 768: (o) => {
      o.exports = iD();
    }, 7672: (o) => {
      o.exports = uD();
    }, 542: (o) => {
      o.exports = am();
    }, 754: (o) => {
      o.exports = RD();
    }, 4262: (o) => {
      o.exports = Rm();
    }, 9084: (o) => {
      o.exports = xl;
    }, 9454: (o) => {
      o.exports = dR;
    }, 4505: (o) => {
      o.exports = LR;
    }, 6464: (o) => {
      o.exports = xl;
    }, 453: (o) => {
      o.exports = PR();
    }, 2734: (o) => {
      o.exports = Jp;
    }, 1441: (o) => {
      o.exports = VR;
    } }, n = {};
    function i(o) {
      var l = n[o];
      if (l !== void 0)
        return l.exports;
      var a = n[o] = { id: o, exports: {} };
      return t[o](a, a.exports, i), a.exports;
    }
    i.m = t, i.n = (o) => {
      var l = o && o.__esModule ? () => o.default : () => o;
      return i.d(l, { a: l }), l;
    }, i.d = (o, l) => {
      for (var a in l)
        i.o(l, a) && !i.o(o, a) && Object.defineProperty(o, a, { enumerable: !0, get: l[a] });
    }, i.g = function() {
      if (typeof globalThis == "object")
        return globalThis;
      try {
        return this || new Function("return this")();
      } catch {
        if (typeof window == "object")
          return window;
      }
    }(), i.o = (o, l) => Object.prototype.hasOwnProperty.call(o, l), i.r = (o) => {
      typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(o, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(o, "__esModule", { value: !0 });
    }, i.b = document.baseURI || self.location.href, i.nc = void 0;
    var s = {};
    return (() => {
      i.r(s), i.d(s, { default: () => P });
      var o = i(3379), l = i.n(o), a = i(7795), c = i.n(a), T = i(569), u = i.n(T), d = i(3565), A = i.n(d), f = i(9216), h = i.n(f), S = i(4589), p = i.n(S), m = i(9934), g = {};
      g.styleTagTransform = p(), g.setAttributes = A(), g.insert = u().bind(null, "head"), g.domAPI = c(), g.insertStyleElement = h(), l()(m.Z, g), m.Z && m.Z.locals && m.Z.locals;
      var N = i(1651), R = i(2963), D = i(3648);
      const v = gm(), O = kF;
      var y = i.n(O), Z = i(5108), F = { date: "YYYY-MM-DD", datetime: "YYYY-MM-DD H:mm:ss", year: "YYYY", month: "YYYY-MM", time: "H:mm:ss", week: "w" };
      const b = { name: "NcDatetimePicker", components: { DatePicker: y(), NcPopover: R.default, NcTimezonePicker: N.default }, mixins: [D.Z], inheritAttrs: !1, props: { clearable: { type: Boolean, default: !1 }, minuteStep: { type: Number, default: 10 }, type: { type: String, default: "date" }, format: { type: String, default: null }, formatter: { type: Object, default: null }, value: { default: function() {
        return new Date();
      } }, timezoneId: { type: String, default: "UTC" }, showTimezoneSelect: { type: Boolean, default: !1 }, highlightTimezone: { type: Boolean, default: !1 }, appendToBody: { type: Boolean, default: !1 }, showWeekNumber: { type: Boolean, default: !1 }, placeholder: { type: String, default: null } }, emits: ["update:value", "update:timezone-id"], data: function() {
        return { showTimezonePopover: !1, tzVal: this.timezoneId };
      }, computed: { lang: function() {
        return { formatLocale: { months: (0, v.getMonthNames)(), monthsShort: (0, v.getMonthNamesShort)(), weekdays: (0, v.getDayNames)(), weekdaysShort: (0, v.getDayNamesShort)(), weekdaysMin: (0, v.getDayNamesMin)(), firstDayOfWeek: (0, v.getFirstDay)() }, monthFormat: "MMM" };
      }, defaultPlaceholder: function() {
        return this.type === "time" ? this.t("Pick a time") : this.type === "month" ? this.t("Pick a month") : this.type === "year" ? this.t("Pick a year") : this.type === "week" ? this.t("Pick a week") : this.type === "date" ? this.t("Pick a date") : this.t("Pick a date and a time");
      }, formatTypeMap: function() {
        var M;
        return (M = F[this.type]) !== null && M !== void 0 ? M : F.date;
      } }, methods: { handleSelectYear: function(M) {
        var Q = this.$refs.datepicker.currentValue;
        if (Q)
          try {
            var H = new Date(new Date(Q).setFullYear(M));
            this.$refs.datepicker.selectDate(H);
          } catch {
            Z.error("Invalid value", Q, M);
          }
      }, handleSelectMonth: function(M) {
        var Q = this.$refs.datepicker.currentValue;
        if (Q)
          try {
            var H = new Date(new Date(Q).setMonth(M));
            this.$refs.datepicker.selectDate(H);
          } catch {
            Z.error("Invalid value", Q, M);
          }
      }, toggleTimezonePopover: function() {
        this.showTimezoneSelect && (this.showTimezonePopover = !this.showTimezonePopover);
      } } };
      var Y = i(5308), I = {};
      I.styleTagTransform = p(), I.setAttributes = A(), I.insert = u().bind(null, "head"), I.domAPI = c(), I.insertStyleElement = h(), l()(Y.Z, I), Y.Z && Y.Z.locals && Y.Z.locals;
      var q = i(1900), _ = i(8538), z = i.n(_), E = (0, q.Z)(b, function() {
        var M = this, Q = M._self._c;
        return Q("DatePicker", M._g(M._b({ ref: "datepicker", attrs: { "append-to-body": M.appendToBody, clearable: M.clearable, format: M.format ? M.format : M.formatTypeMap, formatter: M.formatter, lang: M.lang, "minute-step": M.minuteStep, placeholder: M.placeholder ? M.placeholder : M.defaultPlaceholder, "popup-class": { "show-week-number": M.showWeekNumber }, "show-week-number": M.showWeekNumber, type: M.type, value: M.value }, on: { "select-year": M.handleSelectYear, "select-month": M.handleSelectMonth, "update:value": function(H) {
          return M.$emit("update:value", M.value);
        } }, scopedSlots: M._u([M.showTimezoneSelect ? { key: "icon-calendar", fn: function() {
          return [Q("NcPopover", { attrs: { open: M.showTimezonePopover, "open-class": "timezone-popover-wrapper" }, on: { "update:open": function(H) {
            M.showTimezonePopover = H;
          } }, scopedSlots: M._u([{ key: "trigger", fn: function() {
            return [Q("button", { staticClass: "datetime-picker-inline-icon icon-timezone icon", class: { "datetime-picker-inline-icon--highlighted": M.highlightTimezone }, on: { mousedown: function(H) {
              return H.stopPropagation(), H.preventDefault(), function() {
              }.apply(null, arguments);
            } } })];
          }, proxy: !0 }], null, !1, 3706780037) }, [M._v(" "), Q("div", { staticClass: "timezone-popover-wrapper__title" }, [Q("strong", [M._v(`
					` + M._s(M.t("Please select a time zone:")) + `
				`)])]), M._v(" "), Q("NcTimezonePicker", { staticClass: "timezone-popover-wrapper__timezone-select", on: { input: function(H) {
            return M.$emit("update:timezone-id", arguments[0]);
          } }, model: { value: M.tzVal, callback: function(H) {
            M.tzVal = H;
          }, expression: "tzVal" } })], 1)];
        }, proxy: !0 } : null, M._l(M.$scopedSlots, function(H, re) {
          return { key: re, fn: function(U) {
            return [M._t(re, null, null, U)];
          } };
        })], null, !0) }, "DatePicker", M.$attrs, !1), M.$listeners));
      }, [], !1, null, "0dd60e55", null);
      typeof z() == "function" && z()(E);
      const C = E.exports;
      (0, i(7645).Z)(C);
      const P = C;
    })(), s;
  })());
})(RE);
const PF = /* @__PURE__ */ gE(wl);
Rm();
/*! @license DOMPurify 2.4.3 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.4.3/LICENSE */
function vr(r) {
  return vr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, vr(r);
}
function cu(r, e) {
  return cu = Object.setPrototypeOf || function(n, i) {
    return n.__proto__ = i, n;
  }, cu(r, e);
}
function GF() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Li(r, e, t) {
  return GF() ? Li = Reflect.construct : Li = function(i, s, o) {
    var l = [null];
    l.push.apply(l, s);
    var a = Function.bind.apply(i, l), c = new a();
    return o && cu(c, o.prototype), c;
  }, Li.apply(null, arguments);
}
function wt(r) {
  return UF(r) || HF(r) || jF(r) || zF();
}
function UF(r) {
  if (Array.isArray(r))
    return Tu(r);
}
function HF(r) {
  if (typeof Symbol < "u" && r[Symbol.iterator] != null || r["@@iterator"] != null)
    return Array.from(r);
}
function jF(r, e) {
  if (r) {
    if (typeof r == "string")
      return Tu(r, e);
    var t = Object.prototype.toString.call(r).slice(8, -1);
    if (t === "Object" && r.constructor && (t = r.constructor.name), t === "Map" || t === "Set")
      return Array.from(r);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return Tu(r, e);
  }
}
function Tu(r, e) {
  (e == null || e > r.length) && (e = r.length);
  for (var t = 0, n = new Array(e); t < e; t++)
    n[t] = r[t];
  return n;
}
function zF() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var $F = Object.hasOwnProperty, jp = Object.setPrototypeOf, VF = Object.isFrozen, qF = Object.getPrototypeOf, WF = Object.getOwnPropertyDescriptor, Et = Object.freeze, kt = Object.seal, QF = Object.create, pE = typeof Reflect < "u" && Reflect, Ra = pE.apply, du = pE.construct;
Ra || (Ra = function(e, t, n) {
  return e.apply(t, n);
});
Et || (Et = function(e) {
  return e;
});
kt || (kt = function(e) {
  return e;
});
du || (du = function(e, t) {
  return Li(e, wt(t));
});
var KF = Mt(Array.prototype.forEach), zp = Mt(Array.prototype.pop), wn = Mt(Array.prototype.push), ki = Mt(String.prototype.toLowerCase), _l = Mt(String.prototype.toString), JF = Mt(String.prototype.match), Zt = Mt(String.prototype.replace), XF = Mt(String.prototype.indexOf), eO = Mt(String.prototype.trim), dt = Mt(RegExp.prototype.test), Ml = tO(TypeError);
function Mt(r) {
  return function(e) {
    for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
      n[i - 1] = arguments[i];
    return Ra(r, e, n);
  };
}
function tO(r) {
  return function() {
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
      t[n] = arguments[n];
    return du(r, t);
  };
}
function Me(r, e, t) {
  t = t || ki, jp && jp(r, null);
  for (var n = e.length; n--; ) {
    var i = e[n];
    if (typeof i == "string") {
      var s = t(i);
      s !== i && (VF(e) || (e[n] = s), i = s);
    }
    r[i] = !0;
  }
  return r;
}
function Zr(r) {
  var e = QF(null), t;
  for (t in r)
    Ra($F, r, [t]) === !0 && (e[t] = r[t]);
  return e;
}
function _i(r, e) {
  for (; r !== null; ) {
    var t = WF(r, e);
    if (t) {
      if (t.get)
        return Mt(t.get);
      if (typeof t.value == "function")
        return Mt(t.value);
    }
    r = qF(r);
  }
  function n(i) {
    return console.warn("fallback value for", i), null;
  }
  return n;
}
var $p = Et(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), Yl = Et(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), Il = Et(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), rO = Et(["animate", "color-profile", "cursor", "discard", "fedropshadow", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), Bl = Et(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover"]), nO = Et(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), Vp = Et(["#text"]), qp = Et(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "xmlns", "slot"]), Zl = Et(["accent-height", "accumulate", "additive", "alignment-baseline", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), Wp = Et(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), Mi = Et(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), iO = kt(/\{\{[\w\W]*|[\w\W]*\}\}/gm), aO = kt(/<%[\w\W]*|[\w\W]*%>/gm), oO = kt(/\${[\w\W]*}/gm), sO = kt(/^data-[\-\w.\u00B7-\uFFFF]/), lO = kt(/^aria-[\-\w]+$/), uO = kt(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), cO = kt(/^(?:\w+script|data):/i), TO = kt(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), dO = kt(/^html$/i), AO = function() {
  return typeof window > "u" ? null : window;
}, fO = function(e, t) {
  if (vr(e) !== "object" || typeof e.createPolicy != "function")
    return null;
  var n = null, i = "data-tt-policy-suffix";
  t.currentScript && t.currentScript.hasAttribute(i) && (n = t.currentScript.getAttribute(i));
  var s = "dompurify" + (n ? "#" + n : "");
  try {
    return e.createPolicy(s, {
      createHTML: function(l) {
        return l;
      },
      createScriptURL: function(l) {
        return l;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + s + " could not be created."), null;
  }
};
function hE() {
  var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : AO(), e = function(x) {
    return hE(x);
  };
  if (e.version = "2.4.3", e.removed = [], !r || !r.document || r.document.nodeType !== 9)
    return e.isSupported = !1, e;
  var t = r.document, n = r.document, i = r.DocumentFragment, s = r.HTMLTemplateElement, o = r.Node, l = r.Element, a = r.NodeFilter, c = r.NamedNodeMap, T = c === void 0 ? r.NamedNodeMap || r.MozNamedAttrMap : c, u = r.HTMLFormElement, d = r.DOMParser, A = r.trustedTypes, f = l.prototype, h = _i(f, "cloneNode"), S = _i(f, "nextSibling"), p = _i(f, "childNodes"), m = _i(f, "parentNode");
  if (typeof s == "function") {
    var g = n.createElement("template");
    g.content && g.content.ownerDocument && (n = g.content.ownerDocument);
  }
  var N = fO(A, t), R = N ? N.createHTML("") : "", D = n, v = D.implementation, O = D.createNodeIterator, y = D.createDocumentFragment, Z = D.getElementsByTagName, F = t.importNode, b = {};
  try {
    b = Zr(n).documentMode ? n.documentMode : {};
  } catch {
  }
  var Y = {};
  e.isSupported = typeof m == "function" && v && typeof v.createHTMLDocument < "u" && b !== 9;
  var I = iO, q = aO, _ = oO, z = sO, E = lO, C = cO, P = TO, M = uO, Q = null, H = Me({}, [].concat(wt($p), wt(Yl), wt(Il), wt(Bl), wt(Vp))), re = null, U = Me({}, [].concat(wt(qp), wt(Zl), wt(Wp), wt(Mi))), w = Object.seal(Object.create(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), W = null, se = null, ie = !0, Fe = !0, V = !1, $ = !1, J = !1, ae = !1, X = !1, pe = !1, L = !1, ee = !1, Ae = !0, Ne = !1, ye = "user-content-", be = !0, Ge = !1, Ze = {}, _e = null, oe = Me({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]), te = null, K = Me({}, ["audio", "video", "img", "source", "image", "track"]), k = null, B = Me({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), j = "http://www.w3.org/1998/Math/MathML", le = "http://www.w3.org/2000/svg", ce = "http://www.w3.org/1999/xhtml", De = ce, Ye = !1, Ue = null, G = Me({}, [j, le, ce], _l), ne, Ee = ["application/xhtml+xml", "text/html"], Ie = "text/html", He, ut = null, fr = n.createElement("form"), Cn = function(x) {
    return x instanceof RegExp || x instanceof Function;
  }, Te = function(x) {
    ut && ut === x || ((!x || vr(x) !== "object") && (x = {}), x = Zr(x), ne = // eslint-disable-next-line unicorn/prefer-includes
    Ee.indexOf(x.PARSER_MEDIA_TYPE) === -1 ? ne = Ie : ne = x.PARSER_MEDIA_TYPE, He = ne === "application/xhtml+xml" ? _l : ki, Q = "ALLOWED_TAGS" in x ? Me({}, x.ALLOWED_TAGS, He) : H, re = "ALLOWED_ATTR" in x ? Me({}, x.ALLOWED_ATTR, He) : U, Ue = "ALLOWED_NAMESPACES" in x ? Me({}, x.ALLOWED_NAMESPACES, _l) : G, k = "ADD_URI_SAFE_ATTR" in x ? Me(
      Zr(B),
      // eslint-disable-line indent
      x.ADD_URI_SAFE_ATTR,
      // eslint-disable-line indent
      He
      // eslint-disable-line indent
    ) : B, te = "ADD_DATA_URI_TAGS" in x ? Me(
      Zr(K),
      // eslint-disable-line indent
      x.ADD_DATA_URI_TAGS,
      // eslint-disable-line indent
      He
      // eslint-disable-line indent
    ) : K, _e = "FORBID_CONTENTS" in x ? Me({}, x.FORBID_CONTENTS, He) : oe, W = "FORBID_TAGS" in x ? Me({}, x.FORBID_TAGS, He) : {}, se = "FORBID_ATTR" in x ? Me({}, x.FORBID_ATTR, He) : {}, Ze = "USE_PROFILES" in x ? x.USE_PROFILES : !1, ie = x.ALLOW_ARIA_ATTR !== !1, Fe = x.ALLOW_DATA_ATTR !== !1, V = x.ALLOW_UNKNOWN_PROTOCOLS || !1, $ = x.SAFE_FOR_TEMPLATES || !1, J = x.WHOLE_DOCUMENT || !1, pe = x.RETURN_DOM || !1, L = x.RETURN_DOM_FRAGMENT || !1, ee = x.RETURN_TRUSTED_TYPE || !1, X = x.FORCE_BODY || !1, Ae = x.SANITIZE_DOM !== !1, Ne = x.SANITIZE_NAMED_PROPS || !1, be = x.KEEP_CONTENT !== !1, Ge = x.IN_PLACE || !1, M = x.ALLOWED_URI_REGEXP || M, De = x.NAMESPACE || ce, x.CUSTOM_ELEMENT_HANDLING && Cn(x.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (w.tagNameCheck = x.CUSTOM_ELEMENT_HANDLING.tagNameCheck), x.CUSTOM_ELEMENT_HANDLING && Cn(x.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (w.attributeNameCheck = x.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), x.CUSTOM_ELEMENT_HANDLING && typeof x.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (w.allowCustomizedBuiltInElements = x.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), $ && (Fe = !1), L && (pe = !0), Ze && (Q = Me({}, wt(Vp)), re = [], Ze.html === !0 && (Me(Q, $p), Me(re, qp)), Ze.svg === !0 && (Me(Q, Yl), Me(re, Zl), Me(re, Mi)), Ze.svgFilters === !0 && (Me(Q, Il), Me(re, Zl), Me(re, Mi)), Ze.mathMl === !0 && (Me(Q, Bl), Me(re, Wp), Me(re, Mi))), x.ADD_TAGS && (Q === H && (Q = Zr(Q)), Me(Q, x.ADD_TAGS, He)), x.ADD_ATTR && (re === U && (re = Zr(re)), Me(re, x.ADD_ATTR, He)), x.ADD_URI_SAFE_ATTR && Me(k, x.ADD_URI_SAFE_ATTR, He), x.FORBID_CONTENTS && (_e === oe && (_e = Zr(_e)), Me(_e, x.FORBID_CONTENTS, He)), be && (Q["#text"] = !0), J && Me(Q, ["html", "head", "body"]), Q.table && (Me(Q, ["tbody"]), delete W.tbody), Et && Et(x), ut = x);
  }, ue = Me({}, ["mi", "mo", "mn", "ms", "mtext"]), he = Me({}, ["foreignobject", "desc", "title", "annotation-xml"]), Ce = Me({}, ["title", "style", "font", "a", "script"]), Se = Me({}, Yl);
  Me(Se, Il), Me(Se, rO);
  var ke = Me({}, Bl);
  Me(ke, nO);
  var Qe = function(x) {
    var de = m(x);
    (!de || !de.tagName) && (de = {
      namespaceURI: De,
      tagName: "template"
    });
    var me = ki(x.tagName), Pe = ki(de.tagName);
    return Ue[x.namespaceURI] ? x.namespaceURI === le ? de.namespaceURI === ce ? me === "svg" : de.namespaceURI === j ? me === "svg" && (Pe === "annotation-xml" || ue[Pe]) : Boolean(Se[me]) : x.namespaceURI === j ? de.namespaceURI === ce ? me === "math" : de.namespaceURI === le ? me === "math" && he[Pe] : Boolean(ke[me]) : x.namespaceURI === ce ? de.namespaceURI === le && !he[Pe] || de.namespaceURI === j && !ue[Pe] ? !1 : !ke[me] && (Ce[me] || !Se[me]) : !!(ne === "application/xhtml+xml" && Ue[x.namespaceURI]) : !1;
  }, We = function(x) {
    wn(e.removed, {
      element: x
    });
    try {
      x.parentNode.removeChild(x);
    } catch {
      try {
        x.outerHTML = R;
      } catch {
        x.remove();
      }
    }
  }, tt = function(x, de) {
    try {
      wn(e.removed, {
        attribute: de.getAttributeNode(x),
        from: de
      });
    } catch {
      wn(e.removed, {
        attribute: null,
        from: de
      });
    }
    if (de.removeAttribute(x), x === "is" && !re[x])
      if (pe || L)
        try {
          We(de);
        } catch {
        }
      else
        try {
          de.setAttribute(x, "");
        } catch {
        }
  }, Jt = function(x) {
    var de, me;
    if (X)
      x = "<remove></remove>" + x;
    else {
      var Pe = JF(x, /^[\r\n\t ]+/);
      me = Pe && Pe[0];
    }
    ne === "application/xhtml+xml" && De === ce && (x = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + x + "</body></html>");
    var Dt = N ? N.createHTML(x) : x;
    if (De === ce)
      try {
        de = new d().parseFromString(Dt, ne);
      } catch {
      }
    if (!de || !de.documentElement) {
      de = v.createDocument(De, "template", null);
      try {
        de.documentElement.innerHTML = Ye ? R : Dt;
      } catch {
      }
    }
    var ct = de.body || de.documentElement;
    return x && me && ct.insertBefore(n.createTextNode(me), ct.childNodes[0] || null), De === ce ? Z.call(de, J ? "html" : "body")[0] : J ? de.documentElement : ct;
  }, pr = function(x) {
    return O.call(
      x.ownerDocument || x,
      x,
      // eslint-disable-next-line no-bitwise
      a.SHOW_ELEMENT | a.SHOW_COMMENT | a.SHOW_TEXT,
      null,
      !1
    );
  }, Xt = function(x) {
    return x instanceof u && (typeof x.nodeName != "string" || typeof x.textContent != "string" || typeof x.removeChild != "function" || !(x.attributes instanceof T) || typeof x.removeAttribute != "function" || typeof x.setAttribute != "function" || typeof x.namespaceURI != "string" || typeof x.insertBefore != "function" || typeof x.hasChildNodes != "function");
  }, _n = function(x) {
    return vr(o) === "object" ? x instanceof o : x && vr(x) === "object" && typeof x.nodeType == "number" && typeof x.nodeName == "string";
  }, er = function(x, de, me) {
    Y[x] && KF(Y[x], function(Pe) {
      Pe.call(e, de, me, ut);
    });
  }, Tc = function(x) {
    var de;
    if (er("beforeSanitizeElements", x, null), Xt(x) || dt(/[\u0080-\uFFFF]/, x.nodeName))
      return We(x), !0;
    var me = He(x.nodeName);
    if (er("uponSanitizeElement", x, {
      tagName: me,
      allowedTags: Q
    }), x.hasChildNodes() && !_n(x.firstElementChild) && (!_n(x.content) || !_n(x.content.firstElementChild)) && dt(/<[/\w]/g, x.innerHTML) && dt(/<[/\w]/g, x.textContent) || me === "select" && dt(/<template/i, x.innerHTML))
      return We(x), !0;
    if (!Q[me] || W[me]) {
      if (!W[me] && Ac(me) && (w.tagNameCheck instanceof RegExp && dt(w.tagNameCheck, me) || w.tagNameCheck instanceof Function && w.tagNameCheck(me)))
        return !1;
      if (be && !_e[me]) {
        var Pe = m(x) || x.parentNode, Dt = p(x) || x.childNodes;
        if (Dt && Pe)
          for (var ct = Dt.length, rt = ct - 1; rt >= 0; --rt)
            Pe.insertBefore(h(Dt[rt], !0), S(x));
      }
      return We(x), !0;
    }
    return x instanceof l && !Qe(x) || (me === "noscript" || me === "noembed") && dt(/<\/no(script|embed)/i, x.innerHTML) ? (We(x), !0) : ($ && x.nodeType === 3 && (de = x.textContent, de = Zt(de, I, " "), de = Zt(de, q, " "), de = Zt(de, _, " "), x.textContent !== de && (wn(e.removed, {
      element: x.cloneNode()
    }), x.textContent = de)), er("afterSanitizeElements", x, null), !1);
  }, dc = function(x, de, me) {
    if (Ae && (de === "id" || de === "name") && (me in n || me in fr))
      return !1;
    if (!(Fe && !se[de] && dt(z, de))) {
      if (!(ie && dt(E, de))) {
        if (!re[de] || se[de]) {
          if (
            // First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            !(Ac(x) && (w.tagNameCheck instanceof RegExp && dt(w.tagNameCheck, x) || w.tagNameCheck instanceof Function && w.tagNameCheck(x)) && (w.attributeNameCheck instanceof RegExp && dt(w.attributeNameCheck, de) || w.attributeNameCheck instanceof Function && w.attributeNameCheck(de)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            de === "is" && w.allowCustomizedBuiltInElements && (w.tagNameCheck instanceof RegExp && dt(w.tagNameCheck, me) || w.tagNameCheck instanceof Function && w.tagNameCheck(me)))
          )
            return !1;
        } else if (!k[de]) {
          if (!dt(M, Zt(me, P, ""))) {
            if (!((de === "src" || de === "xlink:href" || de === "href") && x !== "script" && XF(me, "data:") === 0 && te[x])) {
              if (!(V && !dt(C, Zt(me, P, "")))) {
                if (me)
                  return !1;
              }
            }
          }
        }
      }
    }
    return !0;
  }, Ac = function(x) {
    return x.indexOf("-") > 0;
  }, fc = function(x) {
    var de, me, Pe, Dt;
    er("beforeSanitizeAttributes", x, null);
    var ct = x.attributes;
    if (ct) {
      var rt = {
        attrName: "",
        attrValue: "",
        keepAttr: !0,
        allowedAttributes: re
      };
      for (Dt = ct.length; Dt--; ) {
        de = ct[Dt];
        var mi = de, Xe = mi.name, Xa = mi.namespaceURI;
        if (me = Xe === "value" ? de.value : eO(de.value), Pe = He(Xe), rt.attrName = Pe, rt.attrValue = me, rt.keepAttr = !0, rt.forceKeepAttr = void 0, er("uponSanitizeAttribute", x, rt), me = rt.attrValue, !rt.forceKeepAttr && (tt(Xe, x), !!rt.keepAttr)) {
          if (dt(/\/>/i, me)) {
            tt(Xe, x);
            continue;
          }
          $ && (me = Zt(me, I, " "), me = Zt(me, q, " "), me = Zt(me, _, " "));
          var pc = He(x.nodeName);
          if (dc(pc, Pe, me)) {
            if (Ne && (Pe === "id" || Pe === "name") && (tt(Xe, x), me = ye + me), N && vr(A) === "object" && typeof A.getAttributeType == "function" && !Xa)
              switch (A.getAttributeType(pc, Pe)) {
                case "TrustedHTML":
                  me = N.createHTML(me);
                  break;
                case "TrustedScriptURL":
                  me = N.createScriptURL(me);
                  break;
              }
            try {
              Xa ? x.setAttributeNS(Xa, Xe, me) : x.setAttribute(Xe, me), zp(e.removed);
            } catch {
            }
          }
        }
      }
      er("afterSanitizeAttributes", x, null);
    }
  }, DE = function Re(x) {
    var de, me = pr(x);
    for (er("beforeSanitizeShadowDOM", x, null); de = me.nextNode(); )
      er("uponSanitizeShadowNode", de, null), !Tc(de) && (de.content instanceof i && Re(de.content), fc(de));
    er("afterSanitizeShadowDOM", x, null);
  };
  return e.sanitize = function(Re) {
    var x = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, de, me, Pe, Dt, ct;
    if (Ye = !Re, Ye && (Re = "<!-->"), typeof Re != "string" && !_n(Re)) {
      if (typeof Re.toString != "function")
        throw Ml("toString is not a function");
      if (Re = Re.toString(), typeof Re != "string")
        throw Ml("dirty is not a string, aborting");
    }
    if (!e.isSupported) {
      if (vr(r.toStaticHTML) === "object" || typeof r.toStaticHTML == "function") {
        if (typeof Re == "string")
          return r.toStaticHTML(Re);
        if (_n(Re))
          return r.toStaticHTML(Re.outerHTML);
      }
      return Re;
    }
    if (ae || Te(x), e.removed = [], typeof Re == "string" && (Ge = !1), Ge) {
      if (Re.nodeName) {
        var rt = He(Re.nodeName);
        if (!Q[rt] || W[rt])
          throw Ml("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (Re instanceof o)
      de = Jt("<!---->"), me = de.ownerDocument.importNode(Re, !0), me.nodeType === 1 && me.nodeName === "BODY" || me.nodeName === "HTML" ? de = me : de.appendChild(me);
    else {
      if (!pe && !$ && !J && // eslint-disable-next-line unicorn/prefer-includes
      Re.indexOf("<") === -1)
        return N && ee ? N.createHTML(Re) : Re;
      if (de = Jt(Re), !de)
        return pe ? null : ee ? R : "";
    }
    de && X && We(de.firstChild);
    for (var mi = pr(Ge ? Re : de); Pe = mi.nextNode(); )
      Pe.nodeType === 3 && Pe === Dt || Tc(Pe) || (Pe.content instanceof i && DE(Pe.content), fc(Pe), Dt = Pe);
    if (Dt = null, Ge)
      return Re;
    if (pe) {
      if (L)
        for (ct = y.call(de.ownerDocument); de.firstChild; )
          ct.appendChild(de.firstChild);
      else
        ct = de;
      return re.shadowroot && (ct = F.call(t, ct, !0)), ct;
    }
    var Xe = J ? de.outerHTML : de.innerHTML;
    return J && Q["!doctype"] && de.ownerDocument && de.ownerDocument.doctype && de.ownerDocument.doctype.name && dt(dO, de.ownerDocument.doctype.name) && (Xe = "<!DOCTYPE " + de.ownerDocument.doctype.name + `>
` + Xe), $ && (Xe = Zt(Xe, I, " "), Xe = Zt(Xe, q, " "), Xe = Zt(Xe, _, " ")), N && ee ? N.createHTML(Xe) : Xe;
  }, e.setConfig = function(Re) {
    Te(Re), ae = !0;
  }, e.clearConfig = function() {
    ut = null, ae = !1;
  }, e.isValidAttribute = function(Re, x, de) {
    ut || Te({});
    var me = He(Re), Pe = He(x);
    return dc(me, Pe, de);
  }, e.addHook = function(Re, x) {
    typeof x == "function" && (Y[Re] = Y[Re] || [], wn(Y[Re], x));
  }, e.removeHook = function(Re) {
    if (Y[Re])
      return zp(Y[Re]);
  }, e.removeHooks = function(Re) {
    Y[Re] && (Y[Re] = []);
  }, e.removeAllHooks = function() {
    Y = {};
  }, e;
}
hE();
function pO() {
  return typeof window.firstDay > "u" ? (console.warn("No firstDay found"), 1) : window.firstDay;
}
const hO = {
  name: "CalendarAvailability",
  components: {
    NcDatetimePicker: PF
  },
  props: {
    slots: {
      type: Object,
      required: !0
    },
    loading: {
      type: Boolean,
      default: !1
    },
    l10nTo: {
      type: String,
      required: !0
    },
    l10nDeleteSlot: {
      type: String,
      required: !0
    },
    l10nEmptyDay: {
      type: String,
      required: !0
    },
    l10nAddSlot: {
      type: String,
      required: !0
    },
    l10nMonday: {
      type: String,
      required: !0
    },
    l10nTuesday: {
      type: String,
      required: !0
    },
    l10nWednesday: {
      type: String,
      required: !0
    },
    l10nThursday: {
      type: String,
      required: !0
    },
    l10nFriday: {
      type: String,
      required: !0
    },
    l10nSaturday: {
      type: String,
      required: !0
    },
    l10nSunday: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      internalSlots: this.slotsToInternalData(this.slots)
    };
  },
  watch: {
    slots() {
      this.internalSlots = this.slotsToInternalData(this.slots);
    }
  },
  methods: {
    timeStampSlotsToDateObjectSlots(r) {
      return r.map((e) => ({
        start: new Date(e.start * 1e3),
        end: new Date(e.end * 1e3)
      }));
    },
    slotsToInternalData() {
      const r = [
        {
          id: "MO",
          displayName: this.l10nMonday,
          slots: this.timeStampSlotsToDateObjectSlots(this.slots.MO)
        },
        {
          id: "TU",
          displayName: this.l10nTuesday,
          slots: this.timeStampSlotsToDateObjectSlots(this.slots.TU)
        },
        {
          id: "WE",
          displayName: this.l10nWednesday,
          slots: this.timeStampSlotsToDateObjectSlots(this.slots.WE)
        },
        {
          id: "TH",
          displayName: this.l10nThursday,
          slots: this.timeStampSlotsToDateObjectSlots(this.slots.TH)
        },
        {
          id: "FR",
          displayName: this.l10nFriday,
          slots: this.timeStampSlotsToDateObjectSlots(this.slots.FR)
        },
        {
          id: "SA",
          displayName: this.l10nSaturday,
          slots: this.timeStampSlotsToDateObjectSlots(this.slots.SA)
        }
      ], e = {
        id: "SU",
        displayName: this.l10nSunday,
        slots: this.timeStampSlotsToDateObjectSlots(this.slots.SU)
      };
      return pO() === 1 ? [...r, e] : [e, ...r];
    },
    internalDataToSlots() {
      const r = {};
      return this.internalSlots.forEach(({ id: e, slots: t }) => {
        r[e] = t.map((n) => ({
          start: Math.round(n.start.getTime() / 1e3),
          end: Math.round(n.end.getTime() / 1e3)
        }));
      }), r;
    },
    addSlot(r) {
      const e = new Date();
      e.setHours(9, 0, 0, 0);
      const t = new Date();
      t.setHours(17, 0, 0, 0), r.slots.push({
        start: e,
        end: t
      }), this.onChangeSlots();
    },
    removeSlot(r, e) {
      r.slots.splice(e, 1), this.onChangeSlots();
    },
    onChangeSlots() {
      this.$emit("update:slots", this.internalDataToSlots());
    }
  }
};
var mO = function() {
  var e = this, t = e._self._c;
  return t("div", { staticClass: "grid-table" }, [e._l(e.internalSlots, function(n) {
    return [t("div", { key: `day-label-${n.id}`, staticClass: "label-weekday" }, [e._v(" " + e._s(n.displayName) + " ")]), t("div", { key: `day-slots-${n.id}`, staticClass: "availability-slots" }, [t("div", { staticClass: "availability-slot-group" }, [e._l(n.slots, function(i, s) {
      return [t("div", { key: `slot-${n.id}-${s}`, staticClass: "availability-slot" }, [t("NcDatetimePicker", { staticClass: "start-date", attrs: { type: "time", format: "H:mm" }, on: { change: e.onChangeSlots }, model: { value: i.start, callback: function(o) {
        e.$set(i, "start", o);
      }, expression: "slot.start" } }), t("span", { staticClass: "to-text" }, [e._v(" " + e._s(e.l10nTo) + " ")]), t("NcDatetimePicker", { staticClass: "end-date", attrs: { type: "time", format: "H:mm" }, on: { change: e.onChangeSlots }, model: { value: i.end, callback: function(o) {
        e.$set(i, "end", o);
      }, expression: "slot.end" } }), t("button", { key: `slot-${n.id}-${s}-btn`, staticClass: "icon-delete delete-slot button", attrs: { title: e.l10nDeleteSlot }, on: { click: function(o) {
        return e.removeSlot(n, s);
      } } })], 1)];
    })], 2), n.slots.length === 0 ? t("span", { staticClass: "empty-content" }, [e._v(" " + e._s(e.l10nEmptyDay) + " ")]) : e._e()]), t("button", { key: `add-slot-${n.id}`, staticClass: "icon-add add-another button", attrs: { disabled: e.loading, title: e.l10nAddSlot }, on: { click: function(i) {
      return e.addSlot(n);
    } } })];
  })], 2);
}, EO = [], SO = /* @__PURE__ */ Xm(
  hO,
  mO,
  EO,
  !1,
  null,
  "d596f077",
  null,
  null
);
const MO = SO.exports;
var ii = {}, En = {};
Object.defineProperty(En, "__esModule", { value: !0 });
En.zonesMap = En.defaultStart = void 0;
En.defaultStart = "19700101T000000";
En.zonesMap = /* @__PURE__ */ new Map([
  [
    "Africa/Abidjan",
    {
      s: {
        f: "+0000",
        n: "GMT"
      }
    }
  ],
  [
    "Africa/Accra",
    {
      s: {
        f: "+0000",
        n: "GMT"
      }
    }
  ],
  [
    "Africa/Addis_Ababa",
    {
      s: {
        f: "+0300",
        n: "EAT"
      }
    }
  ],
  [
    "Africa/Algiers",
    {
      s: {
        f: "+0100",
        n: "CET"
      }
    }
  ],
  [
    "Africa/Asmara",
    {
      s: {
        f: "+0300",
        n: "EAT"
      }
    }
  ],
  [
    "Africa/Bamako",
    {
      s: {
        f: "+0000",
        n: "GMT"
      }
    }
  ],
  [
    "Africa/Bangui",
    {
      s: {
        f: "+0100",
        n: "WAT"
      }
    }
  ],
  [
    "Africa/Banjul",
    {
      s: {
        f: "+0000",
        n: "GMT"
      }
    }
  ],
  [
    "Africa/Bissau",
    {
      s: {
        f: "+0000",
        n: "GMT"
      }
    }
  ],
  [
    "Africa/Blantyre",
    {
      s: {
        f: "+0200",
        n: "CAT"
      }
    }
  ],
  [
    "Africa/Brazzaville",
    {
      s: {
        f: "+0100",
        n: "WAT"
      }
    }
  ],
  [
    "Africa/Bujumbura",
    {
      s: {
        f: "+0200",
        n: "CAT"
      }
    }
  ],
  [
    "Africa/Cairo",
    {
      s: {
        f: "+0200",
        n: "EET"
      }
    }
  ],
  [
    "Africa/Casablanca",
    {
      s: {
        f: "+0100",
        n: "+01"
      }
    }
  ],
  [
    "Africa/Ceuta",
    {
      s: {
        f: "+0200",
        t: "+0100",
        n: "CET",
        s: "19701025T030000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0100",
        t: "+0200",
        n: "CEST",
        s: "19700329T020000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Africa/Conakry",
    {
      s: {
        f: "+0000",
        n: "GMT"
      }
    }
  ],
  [
    "Africa/Dakar",
    {
      s: {
        f: "+0000",
        n: "GMT"
      }
    }
  ],
  [
    "Africa/Dar_es_Salaam",
    {
      s: {
        f: "+0300",
        n: "EAT"
      }
    }
  ],
  [
    "Africa/Djibouti",
    {
      s: {
        f: "+0300",
        n: "EAT"
      }
    }
  ],
  [
    "Africa/Douala",
    {
      s: {
        f: "+0100",
        n: "WAT"
      }
    }
  ],
  [
    "Africa/El_Aaiun",
    {
      s: {
        f: "+0100",
        n: "+01"
      }
    }
  ],
  [
    "Africa/Freetown",
    {
      s: {
        f: "+0000",
        n: "GMT"
      }
    }
  ],
  [
    "Africa/Gaborone",
    {
      s: {
        f: "+0200",
        n: "CAT"
      }
    }
  ],
  [
    "Africa/Harare",
    {
      s: {
        f: "+0200",
        n: "CAT"
      }
    }
  ],
  [
    "Africa/Johannesburg",
    {
      s: {
        f: "+0200",
        n: "SAST"
      }
    }
  ],
  [
    "Africa/Juba",
    {
      s: {
        f: "+0300",
        n: "EAT"
      }
    }
  ],
  [
    "Africa/Kampala",
    {
      s: {
        f: "+0300",
        n: "EAT"
      }
    }
  ],
  [
    "Africa/Khartoum",
    {
      s: {
        f: "+0200",
        n: "CAT"
      }
    }
  ],
  [
    "Africa/Kigali",
    {
      s: {
        f: "+0200",
        n: "CAT"
      }
    }
  ],
  [
    "Africa/Kinshasa",
    {
      s: {
        f: "+0100",
        n: "WAT"
      }
    }
  ],
  [
    "Africa/Lagos",
    {
      s: {
        f: "+0100",
        n: "WAT"
      }
    }
  ],
  [
    "Africa/Libreville",
    {
      s: {
        f: "+0100",
        n: "WAT"
      }
    }
  ],
  [
    "Africa/Lome",
    {
      s: {
        f: "+0000",
        n: "GMT"
      }
    }
  ],
  [
    "Africa/Luanda",
    {
      s: {
        f: "+0100",
        n: "WAT"
      }
    }
  ],
  [
    "Africa/Lubumbashi",
    {
      s: {
        f: "+0200",
        n: "CAT"
      }
    }
  ],
  [
    "Africa/Lusaka",
    {
      s: {
        f: "+0200",
        n: "CAT"
      }
    }
  ],
  [
    "Africa/Malabo",
    {
      s: {
        f: "+0100",
        n: "WAT"
      }
    }
  ],
  [
    "Africa/Maputo",
    {
      s: {
        f: "+0200",
        n: "CAT"
      }
    }
  ],
  [
    "Africa/Maseru",
    {
      s: {
        f: "+0200",
        n: "SAST"
      }
    }
  ],
  [
    "Africa/Mbabane",
    {
      s: {
        f: "+0200",
        n: "SAST"
      }
    }
  ],
  [
    "Africa/Mogadishu",
    {
      s: {
        f: "+0300",
        n: "EAT"
      }
    }
  ],
  [
    "Africa/Monrovia",
    {
      s: {
        f: "+0000",
        n: "GMT"
      }
    }
  ],
  [
    "Africa/Nairobi",
    {
      s: {
        f: "+0300",
        n: "EAT"
      }
    }
  ],
  [
    "Africa/Ndjamena",
    {
      s: {
        f: "+0100",
        n: "WAT"
      }
    }
  ],
  [
    "Africa/Niamey",
    {
      s: {
        f: "+0100",
        n: "WAT"
      }
    }
  ],
  [
    "Africa/Nouakchott",
    {
      s: {
        f: "+0000",
        n: "GMT"
      }
    }
  ],
  [
    "Africa/Ouagadougou",
    {
      s: {
        f: "+0000",
        n: "GMT"
      }
    }
  ],
  [
    "Africa/Porto-Novo",
    {
      s: {
        f: "+0100",
        n: "WAT"
      }
    }
  ],
  [
    "Africa/Sao_Tome",
    {
      s: {
        f: "+0100",
        n: "WAT"
      }
    }
  ],
  [
    "Africa/Tripoli",
    {
      s: {
        f: "+0200",
        n: "EET"
      }
    }
  ],
  [
    "Africa/Tunis",
    {
      s: {
        f: "+0100",
        n: "CET"
      }
    }
  ],
  [
    "Africa/Windhoek",
    {
      s: {
        f: "+0200",
        n: "CAT"
      }
    }
  ],
  [
    "America/Adak",
    {
      s: {
        f: "-0900",
        t: "-1000",
        n: "HST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-1000",
        t: "-0900",
        n: "HDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Anchorage",
    {
      s: {
        f: "-0800",
        t: "-0900",
        n: "AKST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0900",
        t: "-0800",
        n: "AKDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Anguilla",
    {
      s: {
        f: "-0400",
        n: "AST"
      }
    }
  ],
  [
    "America/Antigua",
    {
      s: {
        f: "-0400",
        n: "AST"
      }
    }
  ],
  [
    "America/Araguaina",
    {
      s: {
        f: "-0300",
        n: "-03"
      }
    }
  ],
  [
    "America/Argentina/Buenos_Aires",
    {
      s: {
        f: "-0300",
        n: "-03"
      }
    }
  ],
  [
    "America/Argentina/Catamarca",
    {
      s: {
        f: "-0300",
        n: "-03"
      }
    }
  ],
  [
    "America/Argentina/Cordoba",
    {
      s: {
        f: "-0300",
        n: "-03"
      }
    }
  ],
  [
    "America/Argentina/Jujuy",
    {
      s: {
        f: "-0300",
        n: "-03"
      }
    }
  ],
  [
    "America/Argentina/La_Rioja",
    {
      s: {
        f: "-0300",
        n: "-03"
      }
    }
  ],
  [
    "America/Argentina/Mendoza",
    {
      s: {
        f: "-0300",
        n: "-03"
      }
    }
  ],
  [
    "America/Argentina/Rio_Gallegos",
    {
      s: {
        f: "-0300",
        n: "-03"
      }
    }
  ],
  [
    "America/Argentina/Salta",
    {
      s: {
        f: "-0300",
        n: "-03"
      }
    }
  ],
  [
    "America/Argentina/San_Juan",
    {
      s: {
        f: "-0300",
        n: "-03"
      }
    }
  ],
  [
    "America/Argentina/San_Luis",
    {
      s: {
        f: "-0300",
        n: "-03"
      }
    }
  ],
  [
    "America/Argentina/Tucuman",
    {
      s: {
        f: "-0300",
        n: "-03"
      }
    }
  ],
  [
    "America/Argentina/Ushuaia",
    {
      s: {
        f: "-0300",
        n: "-03"
      }
    }
  ],
  [
    "America/Aruba",
    {
      s: {
        f: "-0400",
        n: "AST"
      }
    }
  ],
  [
    "America/Asuncion",
    {
      s: {
        f: "-0300",
        t: "-0400",
        n: "-04",
        s: "19700322T000000",
        r: {
          m: 3,
          d: "4SU"
        }
      },
      d: {
        f: "-0400",
        t: "-0300",
        n: "-03",
        s: "19701004T000000",
        r: {
          m: 10,
          d: "1SU"
        }
      }
    }
  ],
  [
    "America/Atikokan",
    {
      s: {
        f: "-0500",
        n: "EST"
      }
    }
  ],
  [
    "America/Bahia_Banderas",
    {
      s: {
        f: "-0500",
        t: "-0600",
        n: "CST",
        s: "19701025T020000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "-0600",
        t: "-0500",
        n: "CDT",
        s: "19700405T020000",
        r: {
          m: 4,
          d: "1SU"
        }
      }
    }
  ],
  [
    "America/Bahia",
    {
      s: {
        f: "-0300",
        n: "-03"
      }
    }
  ],
  [
    "America/Barbados",
    {
      s: {
        f: "-0400",
        n: "AST"
      }
    }
  ],
  [
    "America/Belem",
    {
      s: {
        f: "-0300",
        n: "-03"
      }
    }
  ],
  [
    "America/Belize",
    {
      s: {
        f: "-0600",
        n: "CST"
      }
    }
  ],
  [
    "America/Blanc-Sablon",
    {
      s: {
        f: "-0400",
        n: "AST"
      }
    }
  ],
  [
    "America/Boa_Vista",
    {
      s: {
        f: "-0400",
        n: "-04"
      }
    }
  ],
  [
    "America/Bogota",
    {
      s: {
        f: "-0500",
        n: "-05"
      }
    }
  ],
  [
    "America/Boise",
    {
      s: {
        f: "-0600",
        t: "-0700",
        n: "MST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0700",
        t: "-0600",
        n: "MDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Cambridge_Bay",
    {
      s: {
        f: "-0600",
        t: "-0700",
        n: "MST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0700",
        t: "-0600",
        n: "MDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Campo_Grande",
    {
      s: {
        f: "-0400",
        n: "-04",
        s: "19700215T000000",
        r: {
          m: 2,
          d: "3SU"
        }
      },
      d: {
        f: "-0400",
        t: "-0300",
        n: "-03",
        s: "19701101T000000",
        r: {
          m: 11,
          d: "1SU"
        }
      }
    }
  ],
  [
    "America/Cancun",
    {
      s: {
        f: "-0500",
        n: "EST"
      }
    }
  ],
  [
    "America/Caracas",
    {
      s: {
        f: "-0400",
        n: "-04"
      }
    }
  ],
  [
    "America/Cayenne",
    {
      s: {
        f: "-0300",
        n: "-03"
      }
    }
  ],
  [
    "America/Cayman",
    {
      s: {
        f: "-0500",
        n: "EST"
      }
    }
  ],
  [
    "America/Chicago",
    {
      s: {
        f: "-0500",
        t: "-0600",
        n: "CST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0600",
        t: "-0500",
        n: "CDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Chihuahua",
    {
      s: {
        f: "-0600",
        t: "-0700",
        n: "MST",
        s: "19701025T020000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "-0700",
        t: "-0600",
        n: "MDT",
        s: "19700405T020000",
        r: {
          m: 4,
          d: "1SU"
        }
      }
    }
  ],
  [
    "America/Costa_Rica",
    {
      s: {
        f: "-0600",
        n: "CST"
      }
    }
  ],
  [
    "America/Creston",
    {
      s: {
        f: "-0700",
        n: "MST"
      }
    }
  ],
  [
    "America/Cuiaba",
    {
      s: {
        f: "-0400",
        n: "-04",
        s: "19700215T000000",
        r: {
          m: 2,
          d: "3SU"
        }
      },
      d: {
        f: "-0400",
        t: "-0300",
        n: "-03",
        s: "19701101T000000",
        r: {
          m: 11,
          d: "1SU"
        }
      }
    }
  ],
  [
    "America/Curacao",
    {
      s: {
        f: "-0400",
        n: "AST"
      }
    }
  ],
  [
    "America/Danmarkshavn",
    {
      s: {
        f: "+0000",
        n: "GMT"
      }
    }
  ],
  [
    "America/Dawson_Creek",
    {
      s: {
        f: "-0700",
        n: "MST"
      }
    }
  ],
  [
    "America/Dawson",
    {
      s: {
        f: "-0700",
        t: "-0800",
        n: "PST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0800",
        t: "-0700",
        n: "PDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Denver",
    {
      s: {
        f: "-0600",
        t: "-0700",
        n: "MST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0700",
        t: "-0600",
        n: "MDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Detroit",
    {
      s: {
        f: "-0400",
        t: "-0500",
        n: "EST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0500",
        t: "-0400",
        n: "EDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Dominica",
    {
      s: {
        f: "-0400",
        n: "AST"
      }
    }
  ],
  [
    "America/Edmonton",
    {
      s: {
        f: "-0600",
        t: "-0700",
        n: "MST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0700",
        t: "-0600",
        n: "MDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Eirunepe",
    {
      s: {
        f: "-0500",
        n: "-05"
      }
    }
  ],
  [
    "America/El_Salvador",
    {
      s: {
        f: "-0600",
        n: "CST"
      }
    }
  ],
  [
    "America/Fort_Nelson",
    {
      s: {
        f: "-0700",
        n: "MST"
      }
    }
  ],
  [
    "America/Fortaleza",
    {
      s: {
        f: "-0300",
        n: "-03"
      }
    }
  ],
  [
    "America/Glace_Bay",
    {
      s: {
        f: "-0300",
        t: "-0400",
        n: "AST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0400",
        t: "-0300",
        n: "ADT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Godthab",
    {
      s: {
        f: "-0200",
        t: "-0300",
        n: "-03",
        s: "19701024T230000",
        r: {
          m: 10,
          d: "-1SA"
        }
      },
      d: {
        f: "-0300",
        t: "-0200",
        n: "-02",
        s: "19700328T220000",
        r: {
          m: 3,
          d: "-1SA"
        }
      }
    }
  ],
  [
    "America/Goose_Bay",
    {
      s: {
        f: "-0300",
        t: "-0400",
        n: "AST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0400",
        t: "-0300",
        n: "ADT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Grand_Turk",
    {
      s: {
        f: "-0400",
        t: "-0500",
        n: "EST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0500",
        t: "-0400",
        n: "EDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Grenada",
    {
      s: {
        f: "-0400",
        n: "AST"
      }
    }
  ],
  [
    "America/Guadeloupe",
    {
      s: {
        f: "-0400",
        n: "AST"
      }
    }
  ],
  [
    "America/Guatemala",
    {
      s: {
        f: "-0600",
        n: "CST"
      }
    }
  ],
  [
    "America/Guayaquil",
    {
      s: {
        f: "-0500",
        n: "-05"
      }
    }
  ],
  [
    "America/Guyana",
    {
      s: {
        f: "-0400",
        n: "-04"
      }
    }
  ],
  [
    "America/Halifax",
    {
      s: {
        f: "-0300",
        t: "-0400",
        n: "AST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0400",
        t: "-0300",
        n: "ADT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Havana",
    {
      s: {
        f: "-0400",
        t: "-0500",
        n: "CST",
        s: "19701101T010000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0500",
        t: "-0400",
        n: "CDT",
        s: "19700308T000000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Hermosillo",
    {
      s: {
        f: "-0700",
        n: "MST"
      }
    }
  ],
  [
    "America/Indiana/Indianapolis",
    {
      s: {
        f: "-0400",
        t: "-0500",
        n: "EST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0500",
        t: "-0400",
        n: "EDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Indiana/Knox",
    {
      s: {
        f: "-0500",
        t: "-0600",
        n: "CST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0600",
        t: "-0500",
        n: "CDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Indiana/Marengo",
    {
      s: {
        f: "-0400",
        t: "-0500",
        n: "EST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0500",
        t: "-0400",
        n: "EDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Indiana/Petersburg",
    {
      s: {
        f: "-0400",
        t: "-0500",
        n: "EST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0500",
        t: "-0400",
        n: "EDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Indiana/Tell_City",
    {
      s: {
        f: "-0500",
        t: "-0600",
        n: "CST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0600",
        t: "-0500",
        n: "CDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Indiana/Vevay",
    {
      s: {
        f: "-0400",
        t: "-0500",
        n: "EST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0500",
        t: "-0400",
        n: "EDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Indiana/Vincennes",
    {
      s: {
        f: "-0400",
        t: "-0500",
        n: "EST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0500",
        t: "-0400",
        n: "EDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Indiana/Winamac",
    {
      s: {
        f: "-0400",
        t: "-0500",
        n: "EST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0500",
        t: "-0400",
        n: "EDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Inuvik",
    {
      s: {
        f: "-0600",
        t: "-0700",
        n: "MST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0700",
        t: "-0600",
        n: "MDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Iqaluit",
    {
      s: {
        f: "-0400",
        t: "-0500",
        n: "EST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0500",
        t: "-0400",
        n: "EDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Jamaica",
    {
      s: {
        f: "-0500",
        n: "EST"
      }
    }
  ],
  [
    "America/Juneau",
    {
      s: {
        f: "-0800",
        t: "-0900",
        n: "AKST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0900",
        t: "-0800",
        n: "AKDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Kentucky/Louisville",
    {
      s: {
        f: "-0400",
        t: "-0500",
        n: "EST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0500",
        t: "-0400",
        n: "EDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Kentucky/Monticello",
    {
      s: {
        f: "-0400",
        t: "-0500",
        n: "EST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0500",
        t: "-0400",
        n: "EDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Kralendijk",
    {
      s: {
        f: "-0400",
        n: "AST"
      }
    }
  ],
  [
    "America/La_Paz",
    {
      s: {
        f: "-0400",
        n: "-04"
      }
    }
  ],
  [
    "America/Lima",
    {
      s: {
        f: "-0500",
        n: "-05"
      }
    }
  ],
  [
    "America/Los_Angeles",
    {
      s: {
        f: "-0700",
        t: "-0800",
        n: "PST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0800",
        t: "-0700",
        n: "PDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Lower_Princes",
    {
      s: {
        f: "-0400",
        n: "AST"
      }
    }
  ],
  [
    "America/Maceio",
    {
      s: {
        f: "-0300",
        n: "-03"
      }
    }
  ],
  [
    "America/Managua",
    {
      s: {
        f: "-0600",
        n: "CST"
      }
    }
  ],
  [
    "America/Manaus",
    {
      s: {
        f: "-0400",
        n: "-04"
      }
    }
  ],
  [
    "America/Marigot",
    {
      s: {
        f: "-0400",
        n: "AST"
      }
    }
  ],
  [
    "America/Martinique",
    {
      s: {
        f: "-0400",
        n: "AST"
      }
    }
  ],
  [
    "America/Matamoros",
    {
      s: {
        f: "-0500",
        t: "-0600",
        n: "CST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0600",
        t: "-0500",
        n: "CDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Mazatlan",
    {
      s: {
        f: "-0600",
        t: "-0700",
        n: "MST",
        s: "19701025T020000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "-0700",
        t: "-0600",
        n: "MDT",
        s: "19700405T020000",
        r: {
          m: 4,
          d: "1SU"
        }
      }
    }
  ],
  [
    "America/Menominee",
    {
      s: {
        f: "-0500",
        t: "-0600",
        n: "CST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0600",
        t: "-0500",
        n: "CDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Merida",
    {
      s: {
        f: "-0500",
        t: "-0600",
        n: "CST",
        s: "19701025T020000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "-0600",
        t: "-0500",
        n: "CDT",
        s: "19700405T020000",
        r: {
          m: 4,
          d: "1SU"
        }
      }
    }
  ],
  [
    "America/Metlakatla",
    {
      s: {
        f: "-0800",
        t: "-0900",
        n: "AKST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0900",
        t: "-0800",
        n: "AKDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Mexico_City",
    {
      s: {
        f: "-0500",
        t: "-0600",
        n: "CST",
        s: "19701025T020000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "-0600",
        t: "-0500",
        n: "CDT",
        s: "19700405T020000",
        r: {
          m: 4,
          d: "1SU"
        }
      }
    }
  ],
  [
    "America/Miquelon",
    {
      s: {
        f: "-0200",
        t: "-0300",
        n: "-03",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0300",
        t: "-0200",
        n: "-02",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Moncton",
    {
      s: {
        f: "-0300",
        t: "-0400",
        n: "AST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0400",
        t: "-0300",
        n: "ADT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Monterrey",
    {
      s: {
        f: "-0500",
        t: "-0600",
        n: "CST",
        s: "19701025T020000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "-0600",
        t: "-0500",
        n: "CDT",
        s: "19700405T020000",
        r: {
          m: 4,
          d: "1SU"
        }
      }
    }
  ],
  [
    "America/Montevideo",
    {
      s: {
        f: "-0300",
        n: "-03"
      }
    }
  ],
  [
    "America/Montserrat",
    {
      s: {
        f: "-0400",
        n: "AST"
      }
    }
  ],
  [
    "America/Nassau",
    {
      s: {
        f: "-0400",
        t: "-0500",
        n: "EST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0500",
        t: "-0400",
        n: "EDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/New_York",
    {
      s: {
        f: "-0400",
        t: "-0500",
        n: "EST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0500",
        t: "-0400",
        n: "EDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Nipigon",
    {
      s: {
        f: "-0400",
        t: "-0500",
        n: "EST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0500",
        t: "-0400",
        n: "EDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Nome",
    {
      s: {
        f: "-0800",
        t: "-0900",
        n: "AKST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0900",
        t: "-0800",
        n: "AKDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Noronha",
    {
      s: {
        f: "-0200",
        n: "-02"
      }
    }
  ],
  [
    "America/North_Dakota/Beulah",
    {
      s: {
        f: "-0500",
        t: "-0600",
        n: "CST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0600",
        t: "-0500",
        n: "CDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/North_Dakota/Center",
    {
      s: {
        f: "-0500",
        t: "-0600",
        n: "CST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0600",
        t: "-0500",
        n: "CDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/North_Dakota/New_Salem",
    {
      s: {
        f: "-0500",
        t: "-0600",
        n: "CST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0600",
        t: "-0500",
        n: "CDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Ojinaga",
    {
      s: {
        f: "-0600",
        t: "-0700",
        n: "MST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0700",
        t: "-0600",
        n: "MDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Panama",
    {
      s: {
        f: "-0500",
        n: "EST"
      }
    }
  ],
  [
    "America/Pangnirtung",
    {
      s: {
        f: "-0400",
        t: "-0500",
        n: "EST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0500",
        t: "-0400",
        n: "EDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Paramaribo",
    {
      s: {
        f: "-0300",
        n: "-03"
      }
    }
  ],
  [
    "America/Phoenix",
    {
      s: {
        f: "-0700",
        n: "MST"
      }
    }
  ],
  [
    "America/Port_of_Spain",
    {
      s: {
        f: "-0400",
        n: "AST"
      }
    }
  ],
  [
    "America/Port-au-Prince",
    {
      s: {
        f: "-0400",
        t: "-0500",
        n: "EST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0500",
        t: "-0400",
        n: "EDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Porto_Velho",
    {
      s: {
        f: "-0400",
        n: "-04"
      }
    }
  ],
  [
    "America/Puerto_Rico",
    {
      s: {
        f: "-0400",
        n: "AST"
      }
    }
  ],
  [
    "America/Punta_Arenas",
    {
      s: {
        f: "-0300",
        n: "-03"
      }
    }
  ],
  [
    "America/Rainy_River",
    {
      s: {
        f: "-0500",
        t: "-0600",
        n: "CST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0600",
        t: "-0500",
        n: "CDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Rankin_Inlet",
    {
      s: {
        f: "-0500",
        t: "-0600",
        n: "CST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0600",
        t: "-0500",
        n: "CDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Recife",
    {
      s: {
        f: "-0300",
        n: "-03"
      }
    }
  ],
  [
    "America/Regina",
    {
      s: {
        f: "-0600",
        n: "CST"
      }
    }
  ],
  [
    "America/Resolute",
    {
      s: {
        f: "-0500",
        t: "-0600",
        n: "CST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0600",
        t: "-0500",
        n: "CDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Rio_Branco",
    {
      s: {
        f: "-0500",
        n: "-05"
      }
    }
  ],
  [
    "America/Santarem",
    {
      s: {
        f: "-0300",
        n: "-03"
      }
    }
  ],
  [
    "America/Santiago",
    {
      s: {
        f: "-0300",
        t: "-0400",
        n: "-04",
        s: "19700405T000000",
        r: {
          m: 4,
          d: "1SU"
        }
      },
      d: {
        f: "-0400",
        t: "-0300",
        n: "-03",
        s: "19700906T000000",
        r: {
          m: 9,
          d: "1SU"
        }
      }
    }
  ],
  [
    "America/Santo_Domingo",
    {
      s: {
        f: "-0400",
        n: "AST"
      }
    }
  ],
  [
    "America/Sao_Paulo",
    {
      s: {
        f: "-0300",
        n: "-03",
        s: "19700215T000000",
        r: {
          m: 2,
          d: "3SU"
        }
      },
      d: {
        f: "-0300",
        t: "-0200",
        n: "-02",
        s: "19701101T000000",
        r: {
          m: 11,
          d: "1SU"
        }
      }
    }
  ],
  [
    "America/Scoresbysund",
    {
      s: {
        f: "+0000",
        t: "-0100",
        n: "-01",
        s: "19701025T010000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "-0100",
        t: "+0000",
        n: "+00",
        s: "19700329T000000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "America/Sitka",
    {
      s: {
        f: "-0800",
        t: "-0900",
        n: "AKST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0900",
        t: "-0800",
        n: "AKDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/St_Barthelemy",
    {
      s: {
        f: "-0400",
        n: "AST"
      }
    }
  ],
  [
    "America/St_Johns",
    {
      s: {
        f: "-0230",
        t: "-0330",
        n: "NST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0330",
        t: "-0230",
        n: "NDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/St_Kitts",
    {
      s: {
        f: "-0400",
        n: "AST"
      }
    }
  ],
  [
    "America/St_Lucia",
    {
      s: {
        f: "-0400",
        n: "AST"
      }
    }
  ],
  [
    "America/St_Thomas",
    {
      s: {
        f: "-0400",
        n: "AST"
      }
    }
  ],
  [
    "America/St_Vincent",
    {
      s: {
        f: "-0400",
        n: "AST"
      }
    }
  ],
  [
    "America/Swift_Current",
    {
      s: {
        f: "-0600",
        n: "CST"
      }
    }
  ],
  [
    "America/Tegucigalpa",
    {
      s: {
        f: "-0600",
        n: "CST"
      }
    }
  ],
  [
    "America/Thule",
    {
      s: {
        f: "-0300",
        t: "-0400",
        n: "AST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0400",
        t: "-0300",
        n: "ADT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Thunder_Bay",
    {
      s: {
        f: "-0400",
        t: "-0500",
        n: "EST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0500",
        t: "-0400",
        n: "EDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Tijuana",
    {
      s: {
        f: "-0700",
        t: "-0800",
        n: "PST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0800",
        t: "-0700",
        n: "PDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Toronto",
    {
      s: {
        f: "-0400",
        t: "-0500",
        n: "EST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0500",
        t: "-0400",
        n: "EDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Tortola",
    {
      s: {
        f: "-0400",
        n: "AST"
      }
    }
  ],
  [
    "America/Vancouver",
    {
      s: {
        f: "-0700",
        t: "-0800",
        n: "PST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0800",
        t: "-0700",
        n: "PDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Whitehorse",
    {
      s: {
        f: "-0700",
        t: "-0800",
        n: "PST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0800",
        t: "-0700",
        n: "PDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Winnipeg",
    {
      s: {
        f: "-0500",
        t: "-0600",
        n: "CST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0600",
        t: "-0500",
        n: "CDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Yakutat",
    {
      s: {
        f: "-0800",
        t: "-0900",
        n: "AKST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0900",
        t: "-0800",
        n: "AKDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "America/Yellowknife",
    {
      s: {
        f: "-0600",
        t: "-0700",
        n: "MST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0700",
        t: "-0600",
        n: "MDT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "Antarctica/Casey",
    {
      s: {
        f: "+0800",
        n: "+08"
      }
    }
  ],
  [
    "Antarctica/Davis",
    {
      s: {
        f: "+0700",
        n: "+07"
      }
    }
  ],
  [
    "Antarctica/DumontDUrville",
    {
      s: {
        f: "+1000",
        n: "+10"
      }
    }
  ],
  [
    "Antarctica/Macquarie",
    {
      s: {
        f: "+1100",
        n: "+11"
      }
    }
  ],
  [
    "Antarctica/Mawson",
    {
      s: {
        f: "+0500",
        n: "+05"
      }
    }
  ],
  [
    "Antarctica/McMurdo",
    {
      s: {
        f: "+1300",
        t: "+1200",
        n: "NZST",
        s: "19700405T030000",
        r: {
          m: 4,
          d: "1SU"
        }
      },
      d: {
        f: "+1200",
        t: "+1300",
        n: "NZDT",
        s: "19700927T020000",
        r: {
          m: 9,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Antarctica/Palmer",
    {
      s: {
        f: "-0300",
        n: "-03"
      }
    }
  ],
  [
    "Antarctica/Rothera",
    {
      s: {
        f: "-0300",
        n: "-03"
      }
    }
  ],
  [
    "Antarctica/Syowa",
    {
      s: {
        f: "+0300",
        n: "+03"
      }
    }
  ],
  [
    "Antarctica/Troll",
    {
      s: {
        f: "+0200",
        t: "+0000",
        n: "+00",
        s: "19701025T030000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0000",
        t: "+0200",
        n: "+02",
        s: "19700329T010000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Antarctica/Vostok",
    {
      s: {
        f: "+0600",
        n: "+06"
      }
    }
  ],
  [
    "Arctic/Longyearbyen",
    {
      s: {
        f: "+0200",
        t: "+0100",
        n: "CET",
        s: "19701025T030000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0100",
        t: "+0200",
        n: "CEST",
        s: "19700329T020000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Asia/Aden",
    {
      s: {
        f: "+0300",
        n: "+03"
      }
    }
  ],
  [
    "Asia/Almaty",
    {
      s: {
        f: "+0600",
        n: "+06"
      }
    }
  ],
  [
    "Asia/Amman",
    {
      s: {
        f: "+0300",
        t: "+0200",
        n: "EET",
        s: "19701030T010000",
        r: {
          m: 10,
          d: "-1FR"
        }
      },
      d: {
        f: "+0200",
        t: "+0300",
        n: "EEST",
        s: "19700326T235959",
        r: {
          m: 3,
          d: "-1TH"
        }
      }
    }
  ],
  [
    "Asia/Anadyr",
    {
      s: {
        f: "+1200",
        n: "+12"
      }
    }
  ],
  [
    "Asia/Aqtau",
    {
      s: {
        f: "+0500",
        n: "+05"
      }
    }
  ],
  [
    "Asia/Aqtobe",
    {
      s: {
        f: "+0500",
        n: "+05"
      }
    }
  ],
  [
    "Asia/Ashgabat",
    {
      s: {
        f: "+0500",
        n: "+05"
      }
    }
  ],
  [
    "Asia/Atyrau",
    {
      s: {
        f: "+0500",
        n: "+05"
      }
    }
  ],
  [
    "Asia/Baghdad",
    {
      s: {
        f: "+0300",
        n: "+03"
      }
    }
  ],
  [
    "Asia/Bahrain",
    {
      s: {
        f: "+0300",
        n: "+03"
      }
    }
  ],
  [
    "Asia/Baku",
    {
      s: {
        f: "+0400",
        n: "+04"
      }
    }
  ],
  [
    "Asia/Bangkok",
    {
      s: {
        f: "+0700",
        n: "+07"
      }
    }
  ],
  [
    "Asia/Barnaul",
    {
      s: {
        f: "+0700",
        n: "+07"
      }
    }
  ],
  [
    "Asia/Beirut",
    {
      s: {
        f: "+0300",
        t: "+0200",
        n: "EET",
        s: "19701025T000000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0200",
        t: "+0300",
        n: "EEST",
        s: "19700329T000000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Asia/Bishkek",
    {
      s: {
        f: "+0600",
        n: "+06"
      }
    }
  ],
  [
    "Asia/Brunei",
    {
      s: {
        f: "+0800",
        n: "+08"
      }
    }
  ],
  [
    "Asia/Chita",
    {
      s: {
        f: "+0900",
        n: "+09"
      }
    }
  ],
  [
    "Asia/Choibalsan",
    {
      s: {
        f: "+0800",
        n: "+08"
      }
    }
  ],
  [
    "Asia/Colombo",
    {
      s: {
        f: "+0530",
        n: "+0530"
      }
    }
  ],
  [
    "Asia/Damascus",
    {
      s: {
        f: "+0300",
        t: "+0200",
        n: "EET",
        s: "19701030T000000",
        r: {
          m: 10,
          d: "-1FR"
        }
      },
      d: {
        f: "+0200",
        t: "+0300",
        n: "EEST",
        s: "19700327T000000",
        r: {
          m: 3,
          d: "-1FR"
        }
      }
    }
  ],
  [
    "Asia/Dhaka",
    {
      s: {
        f: "+0600",
        n: "+06"
      }
    }
  ],
  [
    "Asia/Dili",
    {
      s: {
        f: "+0900",
        n: "+09"
      }
    }
  ],
  [
    "Asia/Dubai",
    {
      s: {
        f: "+0400",
        n: "+04"
      }
    }
  ],
  [
    "Asia/Dushanbe",
    {
      s: {
        f: "+0500",
        n: "+05"
      }
    }
  ],
  [
    "Asia/Famagusta",
    {
      s: {
        f: "+0300",
        t: "+0200",
        n: "EET",
        s: "19701025T040000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0200",
        t: "+0300",
        n: "EEST",
        s: "19700329T030000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Asia/Gaza",
    {
      s: {
        f: "+0300",
        t: "+0200",
        n: "EET",
        s: "19701031T010000",
        r: {
          m: 10,
          d: "-1SA"
        }
      },
      d: {
        f: "+0200",
        t: "+0300",
        n: "EEST",
        s: "19700328T010000",
        r: {
          m: 3,
          d: "4SA"
        }
      }
    }
  ],
  [
    "Asia/Hebron",
    {
      s: {
        f: "+0300",
        t: "+0200",
        n: "EET",
        s: "19701031T010000",
        r: {
          m: 10,
          d: "-1SA"
        }
      },
      d: {
        f: "+0200",
        t: "+0300",
        n: "EEST",
        s: "19700328T010000",
        r: {
          m: 3,
          d: "4SA"
        }
      }
    }
  ],
  [
    "Asia/Ho_Chi_Minh",
    {
      s: {
        f: "+0700",
        n: "+07"
      }
    }
  ],
  [
    "Asia/Hong_Kong",
    {
      s: {
        f: "+0800",
        n: "HKT"
      }
    }
  ],
  [
    "Asia/Hovd",
    {
      s: {
        f: "+0700",
        n: "+07"
      }
    }
  ],
  [
    "Asia/Irkutsk",
    {
      s: {
        f: "+0800",
        n: "+08"
      }
    }
  ],
  [
    "Asia/Istanbul",
    {
      s: {
        f: "+0300",
        n: "+03"
      }
    }
  ],
  [
    "Asia/Jakarta",
    {
      s: {
        f: "+0700",
        n: "WIB"
      }
    }
  ],
  [
    "Asia/Jayapura",
    {
      s: {
        f: "+0900",
        n: "WIT"
      }
    }
  ],
  [
    "Asia/Jerusalem",
    {
      s: {
        f: "+0300",
        t: "+0200",
        n: "IST",
        s: "19701025T020000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0200",
        t: "+0300",
        n: "IDT",
        s: "19700327T020000",
        r: {
          m: 3,
          d: "-1FR"
        }
      }
    }
  ],
  [
    "Asia/Kabul",
    {
      s: {
        f: "+0430",
        n: "+0430"
      }
    }
  ],
  [
    "Asia/Kamchatka",
    {
      s: {
        f: "+1200",
        n: "+12"
      }
    }
  ],
  [
    "Asia/Karachi",
    {
      s: {
        f: "+0500",
        n: "PKT"
      }
    }
  ],
  [
    "Asia/Kathmandu",
    {
      s: {
        f: "+0545",
        n: "+0545"
      }
    }
  ],
  [
    "Asia/Khandyga",
    {
      s: {
        f: "+0900",
        n: "+09"
      }
    }
  ],
  [
    "Asia/Kolkata",
    {
      s: {
        f: "+0530",
        n: "IST"
      }
    }
  ],
  [
    "Asia/Krasnoyarsk",
    {
      s: {
        f: "+0700",
        n: "+07"
      }
    }
  ],
  [
    "Asia/Kuala_Lumpur",
    {
      s: {
        f: "+0800",
        n: "+08"
      }
    }
  ],
  [
    "Asia/Kuching",
    {
      s: {
        f: "+0800",
        n: "+08"
      }
    }
  ],
  [
    "Asia/Kuwait",
    {
      s: {
        f: "+0300",
        n: "+03"
      }
    }
  ],
  [
    "Asia/Macau",
    {
      s: {
        f: "+0800",
        n: "CST"
      }
    }
  ],
  [
    "Asia/Magadan",
    {
      s: {
        f: "+1100",
        n: "+11"
      }
    }
  ],
  [
    "Asia/Makassar",
    {
      s: {
        f: "+0800",
        n: "WITA"
      }
    }
  ],
  [
    "Asia/Manila",
    {
      s: {
        f: "+0800",
        n: "PST"
      }
    }
  ],
  [
    "Asia/Muscat",
    {
      s: {
        f: "+0400",
        n: "+04"
      }
    }
  ],
  [
    "Asia/Nicosia",
    {
      s: {
        f: "+0300",
        t: "+0200",
        n: "EET",
        s: "19701025T040000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0200",
        t: "+0300",
        n: "EEST",
        s: "19700329T030000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Asia/Novokuznetsk",
    {
      s: {
        f: "+0700",
        n: "+07"
      }
    }
  ],
  [
    "Asia/Novosibirsk",
    {
      s: {
        f: "+0700",
        n: "+07"
      }
    }
  ],
  [
    "Asia/Omsk",
    {
      s: {
        f: "+0600",
        n: "+06"
      }
    }
  ],
  [
    "Asia/Oral",
    {
      s: {
        f: "+0500",
        n: "+05"
      }
    }
  ],
  [
    "Asia/Phnom_Penh",
    {
      s: {
        f: "+0700",
        n: "+07"
      }
    }
  ],
  [
    "Asia/Pontianak",
    {
      s: {
        f: "+0700",
        n: "WIB"
      }
    }
  ],
  [
    "Asia/Pyongyang",
    {
      s: {
        f: "+0900",
        n: "KST"
      }
    }
  ],
  [
    "Asia/Qatar",
    {
      s: {
        f: "+0300",
        n: "+03"
      }
    }
  ],
  [
    "Asia/Qyzylorda",
    {
      s: {
        f: "+0600",
        n: "+06"
      }
    }
  ],
  [
    "Asia/Riyadh",
    {
      s: {
        f: "+0300",
        n: "+03"
      }
    }
  ],
  [
    "Asia/Sakhalin",
    {
      s: {
        f: "+1100",
        n: "+11"
      }
    }
  ],
  [
    "Asia/Samarkand",
    {
      s: {
        f: "+0500",
        n: "+05"
      }
    }
  ],
  [
    "Asia/Seoul",
    {
      s: {
        f: "+0900",
        n: "KST"
      }
    }
  ],
  [
    "Asia/Shanghai",
    {
      s: {
        f: "+0800",
        n: "CST"
      }
    }
  ],
  [
    "Asia/Singapore",
    {
      s: {
        f: "+0800",
        n: "+08"
      }
    }
  ],
  [
    "Asia/Srednekolymsk",
    {
      s: {
        f: "+1100",
        n: "+11"
      }
    }
  ],
  [
    "Asia/Taipei",
    {
      s: {
        f: "+0800",
        n: "CST"
      }
    }
  ],
  [
    "Asia/Tashkent",
    {
      s: {
        f: "+0500",
        n: "+05"
      }
    }
  ],
  [
    "Asia/Tbilisi",
    {
      s: {
        f: "+0400",
        n: "+04"
      }
    }
  ],
  [
    "Asia/Tehran",
    {
      s: {
        f: "+0430",
        t: "+0330",
        n: "+0330",
        s: "19700921T000000",
        r: {
          m: 9,
          d: "3SU"
        }
      },
      d: {
        f: "+0330",
        t: "+0430",
        n: "+0430",
        s: "19700321T000000",
        r: {
          m: 3,
          d: "3SU"
        }
      }
    }
  ],
  [
    "Asia/Thimphu",
    {
      s: {
        f: "+0600",
        n: "+06"
      }
    }
  ],
  [
    "Asia/Tokyo",
    {
      s: {
        f: "+0900",
        n: "JST"
      }
    }
  ],
  [
    "Asia/Tomsk",
    {
      s: {
        f: "+0700",
        n: "+07"
      }
    }
  ],
  [
    "Asia/Ulaanbaatar",
    {
      s: {
        f: "+0800",
        n: "+08"
      }
    }
  ],
  [
    "Asia/Urumqi",
    {
      s: {
        f: "+0600",
        n: "+06"
      }
    }
  ],
  [
    "Asia/Ust-Nera",
    {
      s: {
        f: "+1000",
        n: "+10"
      }
    }
  ],
  [
    "Asia/Vientiane",
    {
      s: {
        f: "+0700",
        n: "+07"
      }
    }
  ],
  [
    "Asia/Vladivostok",
    {
      s: {
        f: "+1000",
        n: "+10"
      }
    }
  ],
  [
    "Asia/Yakutsk",
    {
      s: {
        f: "+0900",
        n: "+09"
      }
    }
  ],
  [
    "Asia/Yangon",
    {
      s: {
        f: "+0630",
        n: "+0630"
      }
    }
  ],
  [
    "Asia/Yekaterinburg",
    {
      s: {
        f: "+0500",
        n: "+05"
      }
    }
  ],
  [
    "Asia/Yerevan",
    {
      s: {
        f: "+0400",
        n: "+04"
      }
    }
  ],
  [
    "Atlantic/Azores",
    {
      s: {
        f: "+0000",
        t: "-0100",
        n: "-01",
        s: "19701025T010000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "-0100",
        t: "+0000",
        n: "+00",
        s: "19700329T000000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Atlantic/Bermuda",
    {
      s: {
        f: "-0300",
        t: "-0400",
        n: "AST",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      },
      d: {
        f: "-0400",
        t: "-0300",
        n: "ADT",
        s: "19700308T020000",
        r: {
          m: 3,
          d: "2SU"
        }
      }
    }
  ],
  [
    "Atlantic/Canary",
    {
      s: {
        f: "+0100",
        t: "+0000",
        n: "WET",
        s: "19701025T020000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0000",
        t: "+0100",
        n: "WEST",
        s: "19700329T010000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Atlantic/Cape_Verde",
    {
      s: {
        f: "-0100",
        n: "-01"
      }
    }
  ],
  [
    "Atlantic/Faroe",
    {
      s: {
        f: "+0100",
        t: "+0000",
        n: "WET",
        s: "19701025T020000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0000",
        t: "+0100",
        n: "WEST",
        s: "19700329T010000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Atlantic/Madeira",
    {
      s: {
        f: "+0100",
        t: "+0000",
        n: "WET",
        s: "19701025T020000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0000",
        t: "+0100",
        n: "WEST",
        s: "19700329T010000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Atlantic/Reykjavik",
    {
      s: {
        f: "+0000",
        n: "GMT"
      }
    }
  ],
  [
    "Atlantic/South_Georgia",
    {
      s: {
        f: "-0200",
        n: "-02"
      }
    }
  ],
  [
    "Atlantic/St_Helena",
    {
      s: {
        f: "+0000",
        n: "GMT"
      }
    }
  ],
  [
    "Atlantic/Stanley",
    {
      s: {
        f: "-0300",
        n: "-03"
      }
    }
  ],
  [
    "Australia/Adelaide",
    {
      s: {
        f: "+1030",
        t: "+0930",
        n: "ACST",
        s: "19700405T030000",
        r: {
          m: 4,
          d: "1SU"
        }
      },
      d: {
        f: "+0930",
        t: "+1030",
        n: "ACDT",
        s: "19701004T020000",
        r: {
          m: 10,
          d: "1SU"
        }
      }
    }
  ],
  [
    "Australia/Brisbane",
    {
      s: {
        f: "+1000",
        n: "AEST"
      }
    }
  ],
  [
    "Australia/Broken_Hill",
    {
      s: {
        f: "+1030",
        t: "+0930",
        n: "ACST",
        s: "19700405T030000",
        r: {
          m: 4,
          d: "1SU"
        }
      },
      d: {
        f: "+0930",
        t: "+1030",
        n: "ACDT",
        s: "19701004T020000",
        r: {
          m: 10,
          d: "1SU"
        }
      }
    }
  ],
  [
    "Australia/Currie",
    {
      s: {
        f: "+1100",
        t: "+1000",
        n: "AEST",
        s: "19700405T030000",
        r: {
          m: 4,
          d: "1SU"
        }
      },
      d: {
        f: "+1000",
        t: "+1100",
        n: "AEDT",
        s: "19701004T020000",
        r: {
          m: 10,
          d: "1SU"
        }
      }
    }
  ],
  [
    "Australia/Darwin",
    {
      s: {
        f: "+0930",
        n: "ACST"
      }
    }
  ],
  [
    "Australia/Eucla",
    {
      s: {
        f: "+0845",
        n: "+0845"
      }
    }
  ],
  [
    "Australia/Hobart",
    {
      s: {
        f: "+1100",
        t: "+1000",
        n: "AEST",
        s: "19700405T030000",
        r: {
          m: 4,
          d: "1SU"
        }
      },
      d: {
        f: "+1000",
        t: "+1100",
        n: "AEDT",
        s: "19701004T020000",
        r: {
          m: 10,
          d: "1SU"
        }
      }
    }
  ],
  [
    "Australia/Lindeman",
    {
      s: {
        f: "+1000",
        n: "AEST"
      }
    }
  ],
  [
    "Australia/Lord_Howe",
    {
      s: {
        f: "+1100",
        t: "+1030",
        n: "+1030",
        s: "19700405T020000",
        r: {
          m: 4,
          d: "1SU"
        }
      },
      d: {
        f: "+1030",
        t: "+1100",
        n: "+11",
        s: "19701004T020000",
        r: {
          m: 10,
          d: "1SU"
        }
      }
    }
  ],
  [
    "Australia/Melbourne",
    {
      s: {
        f: "+1100",
        t: "+1000",
        n: "AEST",
        s: "19700405T030000",
        r: {
          m: 4,
          d: "1SU"
        }
      },
      d: {
        f: "+1000",
        t: "+1100",
        n: "AEDT",
        s: "19701004T020000",
        r: {
          m: 10,
          d: "1SU"
        }
      }
    }
  ],
  [
    "Australia/Perth",
    {
      s: {
        f: "+0800",
        n: "AWST"
      }
    }
  ],
  [
    "Australia/Sydney",
    {
      s: {
        f: "+1100",
        t: "+1000",
        n: "AEST",
        s: "19700405T030000",
        r: {
          m: 4,
          d: "1SU"
        }
      },
      d: {
        f: "+1000",
        t: "+1100",
        n: "AEDT",
        s: "19701004T020000",
        r: {
          m: 10,
          d: "1SU"
        }
      }
    }
  ],
  [
    "Etc/GMT-0",
    {
      s: {
        f: "+0000",
        n: "GMT"
      }
    }
  ],
  [
    "Etc/GMT-1",
    {
      s: {
        f: "-0100",
        n: "-01"
      }
    }
  ],
  [
    "Etc/GMT-10",
    {
      s: {
        f: "-1000",
        n: "-10"
      }
    }
  ],
  [
    "Etc/GMT-11",
    {
      s: {
        f: "-1100",
        n: "-11"
      }
    }
  ],
  [
    "Etc/GMT-12",
    {
      s: {
        f: "-1200",
        n: "-12"
      }
    }
  ],
  [
    "Etc/GMT-2",
    {
      s: {
        f: "-0200",
        n: "-02"
      }
    }
  ],
  [
    "Etc/GMT-3",
    {
      s: {
        f: "-0300",
        n: "-03"
      }
    }
  ],
  [
    "Etc/GMT-4",
    {
      s: {
        f: "-0400",
        n: "-04"
      }
    }
  ],
  [
    "Etc/GMT-5",
    {
      s: {
        f: "-0500",
        n: "-05"
      }
    }
  ],
  [
    "Etc/GMT-6",
    {
      s: {
        f: "-0600",
        n: "-06"
      }
    }
  ],
  [
    "Etc/GMT-7",
    {
      s: {
        f: "-0700",
        n: "-07"
      }
    }
  ],
  [
    "Etc/GMT-8",
    {
      s: {
        f: "-0800",
        n: "-08"
      }
    }
  ],
  [
    "Etc/GMT-9",
    {
      s: {
        f: "-0900",
        n: "-09"
      }
    }
  ],
  [
    "Etc/GMT",
    {
      s: {
        f: "+0000",
        n: "GMT"
      }
    }
  ],
  [
    "Etc/GMT+0",
    {
      s: {
        f: "+0000",
        n: "GMT"
      }
    }
  ],
  [
    "Etc/GMT+1",
    {
      s: {
        f: "+0100",
        n: "+01"
      }
    }
  ],
  [
    "Etc/GMT+10",
    {
      s: {
        f: "+1000",
        n: "+10"
      }
    }
  ],
  [
    "Etc/GMT+11",
    {
      s: {
        f: "+1100",
        n: "+11"
      }
    }
  ],
  [
    "Etc/GMT+12",
    {
      s: {
        f: "+1200",
        n: "+12"
      }
    }
  ],
  [
    "Etc/GMT+13",
    {
      s: {
        f: "+1300",
        n: "+13"
      }
    }
  ],
  [
    "Etc/GMT+14",
    {
      s: {
        f: "+1400",
        n: "+14"
      }
    }
  ],
  [
    "Etc/GMT+2",
    {
      s: {
        f: "+0200",
        n: "+02"
      }
    }
  ],
  [
    "Etc/GMT+3",
    {
      s: {
        f: "+0300",
        n: "+03"
      }
    }
  ],
  [
    "Etc/GMT+4",
    {
      s: {
        f: "+0400",
        n: "+04"
      }
    }
  ],
  [
    "Etc/GMT+5",
    {
      s: {
        f: "+0500",
        n: "+05"
      }
    }
  ],
  [
    "Etc/GMT+6",
    {
      s: {
        f: "+0600",
        n: "+06"
      }
    }
  ],
  [
    "Etc/GMT+7",
    {
      s: {
        f: "+0700",
        n: "+07"
      }
    }
  ],
  [
    "Etc/GMT+8",
    {
      s: {
        f: "+0800",
        n: "+08"
      }
    }
  ],
  [
    "Etc/GMT+9",
    {
      s: {
        f: "+0900",
        n: "+09"
      }
    }
  ],
  [
    "Etc/GMT0",
    {
      s: {
        f: "+0000",
        n: "GMT"
      }
    }
  ],
  [
    "Etc/Greenwich",
    {
      s: {
        f: "+0000",
        n: "GMT"
      }
    }
  ],
  [
    "Etc/UCT",
    {
      s: {
        f: "+0000",
        n: "UCT"
      }
    }
  ],
  [
    "Etc/Universal",
    {
      s: {
        f: "+0000",
        n: "UTC"
      }
    }
  ],
  [
    "Etc/UTC",
    {
      s: {
        f: "+0000",
        n: "UTC"
      }
    }
  ],
  [
    "Etc/Zulu",
    {
      s: {
        f: "+0000",
        n: "UTC"
      }
    }
  ],
  [
    "Europe/Amsterdam",
    {
      s: {
        f: "+0200",
        t: "+0100",
        n: "CET",
        s: "19701025T030000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0100",
        t: "+0200",
        n: "CEST",
        s: "19700329T020000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Europe/Andorra",
    {
      s: {
        f: "+0200",
        t: "+0100",
        n: "CET",
        s: "19701025T030000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0100",
        t: "+0200",
        n: "CEST",
        s: "19700329T020000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Europe/Astrakhan",
    {
      s: {
        f: "+0400",
        n: "+04"
      }
    }
  ],
  [
    "Europe/Athens",
    {
      s: {
        f: "+0300",
        t: "+0200",
        n: "EET",
        s: "19701025T040000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0200",
        t: "+0300",
        n: "EEST",
        s: "19700329T030000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Europe/Belgrade",
    {
      s: {
        f: "+0200",
        t: "+0100",
        n: "CET",
        s: "19701025T030000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0100",
        t: "+0200",
        n: "CEST",
        s: "19700329T020000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Europe/Berlin",
    {
      s: {
        f: "+0200",
        t: "+0100",
        n: "CET",
        s: "19701025T030000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0100",
        t: "+0200",
        n: "CEST",
        s: "19700329T020000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Europe/Bratislava",
    {
      s: {
        f: "+0200",
        t: "+0100",
        n: "CET",
        s: "19701025T030000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0100",
        t: "+0200",
        n: "CEST",
        s: "19700329T020000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Europe/Brussels",
    {
      s: {
        f: "+0200",
        t: "+0100",
        n: "CET",
        s: "19701025T030000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0100",
        t: "+0200",
        n: "CEST",
        s: "19700329T020000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Europe/Bucharest",
    {
      s: {
        f: "+0300",
        t: "+0200",
        n: "EET",
        s: "19701025T040000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0200",
        t: "+0300",
        n: "EEST",
        s: "19700329T030000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Europe/Budapest",
    {
      s: {
        f: "+0200",
        t: "+0100",
        n: "CET",
        s: "19701025T030000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0100",
        t: "+0200",
        n: "CEST",
        s: "19700329T020000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Europe/Busingen",
    {
      s: {
        f: "+0200",
        t: "+0100",
        n: "CET",
        s: "19701025T030000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0100",
        t: "+0200",
        n: "CEST",
        s: "19700329T020000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Europe/Chisinau",
    {
      s: {
        f: "+0300",
        t: "+0200",
        n: "EET",
        s: "19701025T030000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0200",
        t: "+0300",
        n: "EEST",
        s: "19700329T020000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Europe/Copenhagen",
    {
      s: {
        f: "+0200",
        t: "+0100",
        n: "CET",
        s: "19701025T030000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0100",
        t: "+0200",
        n: "CEST",
        s: "19700329T020000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Europe/Dublin",
    {
      s: {
        f: "+0100",
        t: "+0000",
        n: "GMT",
        s: "19701025T020000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0000",
        t: "+0100",
        n: "IST",
        s: "19700329T010000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Europe/Gibraltar",
    {
      s: {
        f: "+0200",
        t: "+0100",
        n: "CET",
        s: "19701025T030000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0100",
        t: "+0200",
        n: "CEST",
        s: "19700329T020000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Europe/Guernsey",
    {
      s: {
        f: "+0100",
        t: "+0000",
        n: "GMT",
        s: "19701025T020000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0000",
        t: "+0100",
        n: "BST",
        s: "19700329T010000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Europe/Helsinki",
    {
      s: {
        f: "+0300",
        t: "+0200",
        n: "EET",
        s: "19701025T040000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0200",
        t: "+0300",
        n: "EEST",
        s: "19700329T030000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Europe/Isle_of_Man",
    {
      s: {
        f: "+0100",
        t: "+0000",
        n: "GMT",
        s: "19701025T020000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0000",
        t: "+0100",
        n: "BST",
        s: "19700329T010000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Europe/Istanbul",
    {
      s: {
        f: "+0300",
        n: "+03"
      }
    }
  ],
  [
    "Europe/Jersey",
    {
      s: {
        f: "+0100",
        t: "+0000",
        n: "GMT",
        s: "19701025T020000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0000",
        t: "+0100",
        n: "BST",
        s: "19700329T010000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Europe/Kaliningrad",
    {
      s: {
        f: "+0200",
        n: "EET"
      }
    }
  ],
  [
    "Europe/Kiev",
    {
      s: {
        f: "+0300",
        t: "+0200",
        n: "EET",
        s: "19701025T040000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0200",
        t: "+0300",
        n: "EEST",
        s: "19700329T030000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Europe/Kirov",
    {
      s: {
        f: "+0300",
        n: "+03"
      }
    }
  ],
  [
    "Europe/Lisbon",
    {
      s: {
        f: "+0100",
        t: "+0000",
        n: "WET",
        s: "19701025T020000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0000",
        t: "+0100",
        n: "WEST",
        s: "19700329T010000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Europe/Ljubljana",
    {
      s: {
        f: "+0200",
        t: "+0100",
        n: "CET",
        s: "19701025T030000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0100",
        t: "+0200",
        n: "CEST",
        s: "19700329T020000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Europe/London",
    {
      s: {
        f: "+0100",
        t: "+0000",
        n: "GMT",
        s: "19701025T020000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0000",
        t: "+0100",
        n: "BST",
        s: "19700329T010000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Europe/Luxembourg",
    {
      s: {
        f: "+0200",
        t: "+0100",
        n: "CET",
        s: "19701025T030000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0100",
        t: "+0200",
        n: "CEST",
        s: "19700329T020000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Europe/Madrid",
    {
      s: {
        f: "+0200",
        t: "+0100",
        n: "CET",
        s: "19701025T030000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0100",
        t: "+0200",
        n: "CEST",
        s: "19700329T020000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Europe/Malta",
    {
      s: {
        f: "+0200",
        t: "+0100",
        n: "CET",
        s: "19701025T030000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0100",
        t: "+0200",
        n: "CEST",
        s: "19700329T020000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Europe/Mariehamn",
    {
      s: {
        f: "+0300",
        t: "+0200",
        n: "EET",
        s: "19701025T040000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0200",
        t: "+0300",
        n: "EEST",
        s: "19700329T030000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Europe/Minsk",
    {
      s: {
        f: "+0300",
        n: "+03"
      }
    }
  ],
  [
    "Europe/Monaco",
    {
      s: {
        f: "+0200",
        t: "+0100",
        n: "CET",
        s: "19701025T030000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0100",
        t: "+0200",
        n: "CEST",
        s: "19700329T020000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Europe/Moscow",
    {
      s: {
        f: "+0300",
        n: "MSK"
      }
    }
  ],
  [
    "Europe/Nicosia",
    {
      s: {
        f: "+0300",
        t: "+0200",
        n: "EET",
        s: "19701025T040000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0200",
        t: "+0300",
        n: "EEST",
        s: "19700329T030000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Europe/Oslo",
    {
      s: {
        f: "+0200",
        t: "+0100",
        n: "CET",
        s: "19701025T030000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0100",
        t: "+0200",
        n: "CEST",
        s: "19700329T020000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Europe/Paris",
    {
      s: {
        f: "+0200",
        t: "+0100",
        n: "CET",
        s: "19701025T030000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0100",
        t: "+0200",
        n: "CEST",
        s: "19700329T020000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Europe/Podgorica",
    {
      s: {
        f: "+0200",
        t: "+0100",
        n: "CET",
        s: "19701025T030000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0100",
        t: "+0200",
        n: "CEST",
        s: "19700329T020000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Europe/Prague",
    {
      s: {
        f: "+0200",
        t: "+0100",
        n: "CET",
        s: "19701025T030000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0100",
        t: "+0200",
        n: "CEST",
        s: "19700329T020000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Europe/Riga",
    {
      s: {
        f: "+0300",
        t: "+0200",
        n: "EET",
        s: "19701025T040000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0200",
        t: "+0300",
        n: "EEST",
        s: "19700329T030000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Europe/Rome",
    {
      s: {
        f: "+0200",
        t: "+0100",
        n: "CET",
        s: "19701025T030000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0100",
        t: "+0200",
        n: "CEST",
        s: "19700329T020000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Europe/Samara",
    {
      s: {
        f: "+0400",
        n: "+04"
      }
    }
  ],
  [
    "Europe/San_Marino",
    {
      s: {
        f: "+0200",
        t: "+0100",
        n: "CET",
        s: "19701025T030000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0100",
        t: "+0200",
        n: "CEST",
        s: "19700329T020000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Europe/Sarajevo",
    {
      s: {
        f: "+0200",
        t: "+0100",
        n: "CET",
        s: "19701025T030000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0100",
        t: "+0200",
        n: "CEST",
        s: "19700329T020000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Europe/Saratov",
    {
      s: {
        f: "+0400",
        n: "+04"
      }
    }
  ],
  [
    "Europe/Simferopol",
    {
      s: {
        f: "+0300",
        n: "MSK"
      }
    }
  ],
  [
    "Europe/Skopje",
    {
      s: {
        f: "+0200",
        t: "+0100",
        n: "CET",
        s: "19701025T030000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0100",
        t: "+0200",
        n: "CEST",
        s: "19700329T020000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Europe/Sofia",
    {
      s: {
        f: "+0300",
        t: "+0200",
        n: "EET",
        s: "19701025T040000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0200",
        t: "+0300",
        n: "EEST",
        s: "19700329T030000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Europe/Stockholm",
    {
      s: {
        f: "+0200",
        t: "+0100",
        n: "CET",
        s: "19701025T030000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0100",
        t: "+0200",
        n: "CEST",
        s: "19700329T020000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Europe/Tallinn",
    {
      s: {
        f: "+0300",
        t: "+0200",
        n: "EET",
        s: "19701025T040000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0200",
        t: "+0300",
        n: "EEST",
        s: "19700329T030000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Europe/Tirane",
    {
      s: {
        f: "+0200",
        t: "+0100",
        n: "CET",
        s: "19701025T030000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0100",
        t: "+0200",
        n: "CEST",
        s: "19700329T020000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Europe/Ulyanovsk",
    {
      s: {
        f: "+0400",
        n: "+04"
      }
    }
  ],
  [
    "Europe/Uzhgorod",
    {
      s: {
        f: "+0300",
        t: "+0200",
        n: "EET",
        s: "19701025T040000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0200",
        t: "+0300",
        n: "EEST",
        s: "19700329T030000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Europe/Vaduz",
    {
      s: {
        f: "+0200",
        t: "+0100",
        n: "CET",
        s: "19701025T030000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0100",
        t: "+0200",
        n: "CEST",
        s: "19700329T020000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Europe/Vatican",
    {
      s: {
        f: "+0200",
        t: "+0100",
        n: "CET",
        s: "19701025T030000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0100",
        t: "+0200",
        n: "CEST",
        s: "19700329T020000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Europe/Vienna",
    {
      s: {
        f: "+0200",
        t: "+0100",
        n: "CET",
        s: "19701025T030000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0100",
        t: "+0200",
        n: "CEST",
        s: "19700329T020000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Europe/Vilnius",
    {
      s: {
        f: "+0300",
        t: "+0200",
        n: "EET",
        s: "19701025T040000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0200",
        t: "+0300",
        n: "EEST",
        s: "19700329T030000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Europe/Volgograd",
    {
      s: {
        f: "+0400",
        n: "+04"
      }
    }
  ],
  [
    "Europe/Warsaw",
    {
      s: {
        f: "+0200",
        t: "+0100",
        n: "CET",
        s: "19701025T030000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0100",
        t: "+0200",
        n: "CEST",
        s: "19700329T020000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Europe/Zagreb",
    {
      s: {
        f: "+0200",
        t: "+0100",
        n: "CET",
        s: "19701025T030000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0100",
        t: "+0200",
        n: "CEST",
        s: "19700329T020000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Europe/Zaporozhye",
    {
      s: {
        f: "+0300",
        t: "+0200",
        n: "EET",
        s: "19701025T040000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0200",
        t: "+0300",
        n: "EEST",
        s: "19700329T030000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Europe/Zurich",
    {
      s: {
        f: "+0200",
        t: "+0100",
        n: "CET",
        s: "19701025T030000",
        r: {
          m: 10,
          d: "-1SU"
        }
      },
      d: {
        f: "+0100",
        t: "+0200",
        n: "CEST",
        s: "19700329T020000",
        r: {
          m: 3,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Indian/Antananarivo",
    {
      s: {
        f: "+0300",
        n: "EAT"
      }
    }
  ],
  [
    "Indian/Chagos",
    {
      s: {
        f: "+0600",
        n: "+06"
      }
    }
  ],
  [
    "Indian/Christmas",
    {
      s: {
        f: "+0700",
        n: "+07"
      }
    }
  ],
  [
    "Indian/Cocos",
    {
      s: {
        f: "+0630",
        n: "+0630"
      }
    }
  ],
  [
    "Indian/Comoro",
    {
      s: {
        f: "+0300",
        n: "EAT"
      }
    }
  ],
  [
    "Indian/Kerguelen",
    {
      s: {
        f: "+0500",
        n: "+05"
      }
    }
  ],
  [
    "Indian/Mahe",
    {
      s: {
        f: "+0400",
        n: "+04"
      }
    }
  ],
  [
    "Indian/Maldives",
    {
      s: {
        f: "+0500",
        n: "+05"
      }
    }
  ],
  [
    "Indian/Mauritius",
    {
      s: {
        f: "+0400",
        n: "+04"
      }
    }
  ],
  [
    "Indian/Mayotte",
    {
      s: {
        f: "+0300",
        n: "EAT"
      }
    }
  ],
  [
    "Indian/Reunion",
    {
      s: {
        f: "+0400",
        n: "+04"
      }
    }
  ],
  [
    "Pacific/Apia",
    {
      s: {
        f: "+1400",
        t: "+1300",
        n: "+13",
        s: "19700405T040000",
        r: {
          m: 4,
          d: "1SU"
        }
      },
      d: {
        f: "+1300",
        t: "+1400",
        n: "+14",
        s: "19700927T030000",
        r: {
          m: 9,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Pacific/Auckland",
    {
      s: {
        f: "+1300",
        t: "+1200",
        n: "NZST",
        s: "19700405T030000",
        r: {
          m: 4,
          d: "1SU"
        }
      },
      d: {
        f: "+1200",
        t: "+1300",
        n: "NZDT",
        s: "19700927T020000",
        r: {
          m: 9,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Pacific/Bougainville",
    {
      s: {
        f: "+1100",
        n: "+11"
      }
    }
  ],
  [
    "Pacific/Chatham",
    {
      s: {
        f: "+1345",
        t: "+1245",
        n: "+1245",
        s: "19700405T034500",
        r: {
          m: 4,
          d: "1SU"
        }
      },
      d: {
        f: "+1245",
        t: "+1345",
        n: "+1345",
        s: "19700927T024500",
        r: {
          m: 9,
          d: "-1SU"
        }
      }
    }
  ],
  [
    "Pacific/Chuuk",
    {
      s: {
        f: "+1000",
        n: "+10"
      }
    }
  ],
  [
    "Pacific/Easter",
    {
      s: {
        f: "-0500",
        t: "-0600",
        n: "-06",
        s: "19700404T220000",
        r: {
          m: 4,
          d: "1SA"
        }
      },
      d: {
        f: "-0600",
        t: "-0500",
        n: "-05",
        s: "19700905T220000",
        r: {
          m: 9,
          d: "1SA"
        }
      }
    }
  ],
  [
    "Pacific/Efate",
    {
      s: {
        f: "+1100",
        n: "+11"
      }
    }
  ],
  [
    "Pacific/Enderbury",
    {
      s: {
        f: "+1300",
        n: "+13"
      }
    }
  ],
  [
    "Pacific/Fakaofo",
    {
      s: {
        f: "+1300",
        n: "+13"
      }
    }
  ],
  [
    "Pacific/Fiji",
    {
      s: {
        f: "+1300",
        t: "+1200",
        n: "+12",
        s: "19700118T030000",
        r: {
          m: 1,
          d: "-2SU"
        }
      },
      d: {
        f: "+1200",
        t: "+1300",
        n: "+13",
        s: "19701101T020000",
        r: {
          m: 11,
          d: "1SU"
        }
      }
    }
  ],
  [
    "Pacific/Funafuti",
    {
      s: {
        f: "+1200",
        n: "+12"
      }
    }
  ],
  [
    "Pacific/Galapagos",
    {
      s: {
        f: "-0600",
        n: "-06"
      }
    }
  ],
  [
    "Pacific/Gambier",
    {
      s: {
        f: "-0900",
        n: "-09"
      }
    }
  ],
  [
    "Pacific/Guadalcanal",
    {
      s: {
        f: "+1100",
        n: "+11"
      }
    }
  ],
  [
    "Pacific/Guam",
    {
      s: {
        f: "+1000",
        n: "ChST"
      }
    }
  ],
  [
    "Pacific/Honolulu",
    {
      s: {
        f: "-1000",
        n: "HST"
      }
    }
  ],
  [
    "Pacific/Kiritimati",
    {
      s: {
        f: "+1400",
        n: "+14"
      }
    }
  ],
  [
    "Pacific/Kosrae",
    {
      s: {
        f: "+1100",
        n: "+11"
      }
    }
  ],
  [
    "Pacific/Kwajalein",
    {
      s: {
        f: "+1200",
        n: "+12"
      }
    }
  ],
  [
    "Pacific/Majuro",
    {
      s: {
        f: "+1200",
        n: "+12"
      }
    }
  ],
  [
    "Pacific/Marquesas",
    {
      s: {
        f: "-0930",
        n: "-0930"
      }
    }
  ],
  [
    "Pacific/Midway",
    {
      s: {
        f: "-1100",
        n: "SST"
      }
    }
  ],
  [
    "Pacific/Nauru",
    {
      s: {
        f: "+1200",
        n: "+12"
      }
    }
  ],
  [
    "Pacific/Niue",
    {
      s: {
        f: "-1100",
        n: "-11"
      }
    }
  ],
  [
    "Pacific/Norfolk",
    {
      s: {
        f: "+1100",
        n: "+11"
      }
    }
  ],
  [
    "Pacific/Noumea",
    {
      s: {
        f: "+1100",
        n: "+11"
      }
    }
  ],
  [
    "Pacific/Pago_Pago",
    {
      s: {
        f: "-1100",
        n: "SST"
      }
    }
  ],
  [
    "Pacific/Palau",
    {
      s: {
        f: "+0900",
        n: "+09"
      }
    }
  ],
  [
    "Pacific/Pitcairn",
    {
      s: {
        f: "-0800",
        n: "-08"
      }
    }
  ],
  [
    "Pacific/Pohnpei",
    {
      s: {
        f: "+1100",
        n: "+11"
      }
    }
  ],
  [
    "Pacific/Port_Moresby",
    {
      s: {
        f: "+1000",
        n: "+10"
      }
    }
  ],
  [
    "Pacific/Rarotonga",
    {
      s: {
        f: "-1000",
        n: "-10"
      }
    }
  ],
  [
    "Pacific/Saipan",
    {
      s: {
        f: "+1000",
        n: "ChST"
      }
    }
  ],
  [
    "Pacific/Tahiti",
    {
      s: {
        f: "-1000",
        n: "-10"
      }
    }
  ],
  [
    "Pacific/Tarawa",
    {
      s: {
        f: "+1200",
        n: "+12"
      }
    }
  ],
  [
    "Pacific/Tongatapu",
    {
      s: {
        f: "+1300",
        n: "+13"
      }
    }
  ],
  [
    "Pacific/Wake",
    {
      s: {
        f: "+1200",
        n: "+12"
      }
    }
  ],
  [
    "Pacific/Wallis",
    {
      s: {
        f: "+1200",
        n: "+12"
      }
    }
  ]
]);
Object.defineProperty(ii, "__esModule", { value: !0 });
var mE = ii.getZoneString = ii.getZoneLines = void 0;
const EE = En;
function Qp(r) {
  const { n: e, f: t, t: n, r: i, s } = r;
  return [
    `TZNAME:${e}`,
    `TZOFFSETFROM:${t}`,
    `TZOFFSETTO:${n || t}`,
    `DTSTART:${s || EE.defaultStart}`,
    ...i ? [`RRULE:FREQ=${i.f || "YEARLY"};BYMONTH=${i.m};BYDAY=${i.d}`] : []
  ];
}
function SE(r, e = !0) {
  const t = EE.zonesMap.get(r);
  if (t) {
    const { s: n, d: i } = t;
    return [
      ...e ? ["BEGIN:VTIMEZONE"] : [],
      `TZID:${r}`,
      // `X-LIC-LOCATION:${zoneName}`, // Who uses this?
      "BEGIN:STANDARD",
      ...Qp(n),
      "END:STANDARD",
      ...i ? [
        "BEGIN:DAYLIGHT",
        ...Qp(i),
        "END:DAYLIGHT"
      ] : [],
      ...e ? ["END:VTIMEZONE"] : []
    ];
  }
}
ii.getZoneLines = SE;
function DO(r, e = !0) {
  const t = SE(r, e);
  return t == null ? void 0 : t.join(`\r
`);
}
mE = ii.getZoneString = DO;
let Yi;
const gO = new Uint8Array(16);
function RO() {
  if (!Yi && (Yi = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !Yi))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return Yi(gO);
}
const at = [];
for (let r = 0; r < 256; ++r)
  at.push((r + 256).toString(16).slice(1));
function vO(r, e = 0) {
  return (at[r[e + 0]] + at[r[e + 1]] + at[r[e + 2]] + at[r[e + 3]] + "-" + at[r[e + 4]] + at[r[e + 5]] + "-" + at[r[e + 6]] + at[r[e + 7]] + "-" + at[r[e + 8]] + at[r[e + 9]] + "-" + at[r[e + 10]] + at[r[e + 11]] + at[r[e + 12]] + at[r[e + 13]] + at[r[e + 14]] + at[r[e + 15]]).toLowerCase();
}
const NO = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), Kp = {
  randomUUID: NO
};
function FO(r, e, t) {
  if (Kp.randomUUID && !e && !r)
    return Kp.randomUUID();
  r = r || {};
  const n = r.random || (r.rng || RO)();
  if (n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, e) {
    t = t || 0;
    for (let i = 0; i < 16; ++i)
      e[t + i] = n[i];
    return e;
  }
  return vO(n);
}
var OO = om();
/*
 * @copyright Copyright (c) 2022 Richard Steinmetz <richard@steinmetz.cloud>
 *
 * @author Richard Steinmetz <richard@steinmetz.cloud>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
const yO = OO.getLoggerBuilder().detectUser().setApp("@nextcloud/calendar-availability-vue").build();
function bO() {
  return {
    MO: [],
    TU: [],
    WE: [],
    TH: [],
    FR: [],
    SA: [],
    SU: []
  };
}
function YO(r) {
  const e = ge.parse(r), t = new ge.Component(e), n = t.getFirstSubcomponent("vavailability");
  let i;
  const s = t.getFirstSubcomponent("vtimezone");
  s && (i = s.getFirstProperty("tzid").getFirstValue());
  const o = n.getAllSubcomponents("available"), l = bO();
  return o.forEach((a) => {
    const c = a.getFirstProperty("dtstart").getFirstValue().toJSDate(), T = a.getFirstProperty("dtend").getFirstValue().toJSDate(), u = a.getFirstProperty("rrule");
    if (u.getFirstValue().freq !== "WEEKLY") {
      yO.warn("rrule not supported", {
        rrule: u.toICALString()
      });
      return;
    }
    u.getFirstValue().getComponent("BYDAY").forEach((d) => {
      l[d].push({
        start: c.getTime() / 1e3,
        end: T.getTime() / 1e3
      });
    });
  }), {
    slots: l,
    timezoneId: i
  };
}
function IO(r, e) {
  const t = new ICAL.Component("vcalendar");
  t.addPropertyWithValue("prodid", "Nextcloud DAV app");
  const n = mE(e);
  if (n) {
    const o = new ICAL.Component(ICAL.parse(n));
    t.addSubcomponent(o);
  } else {
    const o = new ICAL.Component("vtimezone");
    o.addPropertyWithValue("tzid", e), t.addSubcomponent(o);
  }
  const i = new ICAL.Component("vavailability"), s = r.reduce((o, l) => {
    var u;
    const a = new Date(l.start * 1e3), c = new Date(l.end * 1e3), T = [
      a.getHours(),
      a.getMinutes(),
      c.getHours(),
      c.getMinutes()
    ].join("-");
    return {
      ...o,
      [T]: [...(u = o[T]) != null ? u : [], l]
    };
  }, {});
  return Object.keys(s).map((o) => {
    const l = s[o], a = l[0].start, c = l[0].end, T = l.map((f) => f.day).filter((f, h, S) => S.indexOf(f) === h), u = new ICAL.Component("available");
    return u.addPropertyWithValue("dtstart", ICAL.Time.fromJSDate(new Date(a * 1e3), !1)).setParameter("tzid", e), u.addPropertyWithValue("dtend", ICAL.Time.fromJSDate(new Date(c * 1e3), !1)).setParameter("tzid", e), u.addPropertyWithValue("uid", FO()), u.addPropertyWithValue("rrule", {
      freq: "WEEKLY",
      byday: T
    }), u;
  }).map(i.addSubcomponent.bind(i)), t.addSubcomponent(i), t.toString();
}
export {
  MO as CalendarAvailability,
  bO as getEmptySlots,
  IO as slotsToVavailability,
  YO as vavailabilityToSlots
};
